webpackJsonp([1,15],[
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(276);


/***/ }),
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	/**
	 * 引导JS: redux + react 初始化 （connect是异步操作）
	 */
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); // TODO
	
	// import Form from '@redux/container/detail';
	// import Result from '@redux/container/detail';
	
	
	var _react = __webpack_require__(73);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(105);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _redux = __webpack_require__(245);
	
	var _reduxThunk = __webpack_require__(277);
	
	var _reduxThunk2 = _interopRequireDefault(_reduxThunk);
	
	var _reactRedux = __webpack_require__(265);
	
	var _detail = __webpack_require__(278);
	
	var _detail2 = _interopRequireDefault(_detail);
	
	var _detail3 = __webpack_require__(537);
	
	var _detail4 = _interopRequireDefault(_detail3);
	
	var _reactRouterDom = __webpack_require__(579);
	
	var _knb = __webpack_require__(282);
	
	var _knb2 = _interopRequireDefault(_knb);
	
	var _util = __webpack_require__(281);
	
	var _util2 = _interopRequireDefault(_util);
	
	var _rlu = __webpack_require__(615);
	
	var _rlu2 = _interopRequireDefault(_rlu);
	
	__webpack_require__(616);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	// TODO
	
	var store = (0, _redux.createStore)(_detail2.default, window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__(), (0, _redux.applyMiddleware)(_reduxThunk2.default));
	
	/**
	 * TODO: 
	 * detail、apply、save页使用SPA，无跳转刷新，状态连续变化由前端控制（注意点：router保证回退；apply -> save页必须jumpToScheme/replace）
	 * 与列表页通讯（状态变更），APP: publish+subscribe; M站: 页面跳转/回退强制刷新
	 */
	
	var BootStrap = function () {
	    function BootStrap(props) {
	        _classCallCheck(this, BootStrap);
	
	        _rlu2.default.init(375);
	    }
	
	    _createClass(BootStrap, [{
	        key: 'init',
	        value: function init() {
	            try {
	                // if (!Util.isApp('dpapp')) {
	                //     var metas = document.getElementsByTagName("meta");
	                //     for (var i=0; i<metas.length; i++) {
	                //         if (metas[i].getAttribute("name") && metas[i].getAttribute("name")==="lx:appnm") {
	                //             metas[i].setAttribute("content", Util.isApp('mtgroup') ? "group" : "dp_m");
	                //         }
	                //     }
	                // }
	                // LXAnalytics('pageView', null, null, 'c_r95jj7ne');
	                _util2.default.getCity().then(function (cityid) {
	                    LXAnalytics('pageView', { "custom": {
	                            "city_id": cityid || 1,
	                            "pageview": _util2.default.getUA() || {},
	                            "event_id": _util2.default.parseQuery('offlineActivityId')
	                        } }, null, 'c_r95jj7ne');
	                }, function (err) {
	                    LXAnalytics('pageView', { "custom": {
	                            "city_id": 1,
	                            "pageview": _util2.default.getUA() || {},
	                            "event_id": _util2.default.parseQuery('offlineActivityId')
	                        } }, null, 'c_r95jj7ne');
	                });
	            } catch (e) {
	                console.log('lx page view error');
	            }
	            if (_util2.default.isApp()) {
	                // 禁止反弹
	                _knb2.default.ready(function () {
	                    _knb2.default.setBouncesEnabled({
	                        enable: 0,
	                        success: function success() {}
	                    });
	                });
	            }
	
	            _reactDom2.default.render(_react2.default.createElement(
	                _reactRedux.Provider,
	                { store: store },
	                _react2.default.createElement(_detail4.default, null)
	            ), document.getElementById('app'));
	        }
	    }]);
	
	    return BootStrap;
	}();
	
	new BootStrap().init();

/***/ }),
/* 277 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	function createThunkMiddleware(extraArgument) {
	  return function (_ref) {
	    var dispatch = _ref.dispatch,
	        getState = _ref.getState;
	    return function (next) {
	      return function (action) {
	        if (typeof action === 'function') {
	          return action(dispatch, getState, extraArgument);
	        }
	
	        return next(action);
	      };
	    };
	  };
	}
	
	var thunk = createThunkMiddleware();
	thunk.withExtraArgument = createThunkMiddleware;
	
	exports['default'] = thunk;

/***/ }),
/* 278 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _redux = __webpack_require__(245);
	
	var _detail = __webpack_require__(279);
	
	var _detail2 = __webpack_require__(280);
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function DetailData() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _detail.defaultDetail;
	    var action = arguments[1];
	
	    switch (action.type) {
	        case _detail2.INIT_LOADING:
	            return _extends({}, state, {
	                loading: true
	            });
	        case _detail2.UPDATE_DETAIL_DATA:
	            return _extends({}, state, action.data, {
	                loading: false
	            });
	        case _detail2.FETCH_RES_ERR:
	            return _extends({}, state, {
	                loading: false,
	                isError: true
	            });
	        default:
	            return state;
	    }
	}
	
	function ResData() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _detail.defaultResponse;
	    var action = arguments[1];
	
	    switch (action.type) {
	        case _detail2.FETCH_RES_LOADING:
	            return _extends({}, state, {
	                loading: true
	            });
	        case _detail2.FETCH_RES_SUCC:
	            return _extends({}, state, {
	                loading: false,
	                page: action.data.curPage,
	                list: [].concat(_toConsumableArray(state.list), _toConsumableArray(action.data.records || [])),
	                isEnd: action.data.maxPage <= action.data.curPage
	            });
	        case _detail2.FETCH_RES_ERR:
	            return _extends({}, state, {
	                loading: false,
	                isError: true
	            });
	        case _detail2.ADD_RES_DATA:
	            return _extends({}, state, {
	                list: [].concat(_toConsumableArray(state.list), [action.data])
	            });
	        default:
	            return state;
	    }
	}
	
	function NavData() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _detail.defaultNav;
	    var action = arguments[1];
	
	    switch (action.type) {
	        case _detail2.UPDATE_NAV_DATA:
	            return _extends({}, state, action.data);
	        default:
	            return state;
	    }
	}
	
	function UserData() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _detail.defaultUser;
	    var action = arguments[1];
	
	    switch (action.type) {
	        case _detail2.FETCH_USER_LOADING:
	            return _extends({}, state, {
	                loading: true
	            });
	        case _detail2.FETCH_USER_SUCC:
	            return _extends({}, state, {
	                loading: false,
	                page: action.data.page,
	                list: [].concat(_toConsumableArray(state.list), _toConsumableArray(action.data.userNickNameList || [])),
	                isEnd: action.data.pageEnd
	            });
	        case _detail2.FETCH_RES_ERR:
	            return _extends({}, state, {
	                loading: false,
	                isError: true
	            });
	        default:
	            return state;
	    }
	}
	
	var reducerApp = (0, _redux.combineReducers)({
	    DetailData: DetailData,
	    NavData: NavData,
	    ResData: ResData,
	    UserData: UserData
	});
	
	exports.default = reducerApp;

/***/ }),
/* 279 */
/***/ (function(module, exports) {

	'use strict';
	
	// WIKI: https://wiki.sankuai.com/pages/viewpage.action?pageId=841284934
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var defaultDetail = exports.defaultDetail = {
	    loading: true, // TODO: 动画
	    isError: false, // TODO: 出错提示
	    msg: '出错啦'
	};
	
	var defaultNav = exports.defaultNav = {
	    staticData: [{
	        id: 'detail',
	        name: '活动详情'
	    }, {
	        id: 'res',
	        name: '活动回应'
	    }],
	    navCursor: 'detail' //defaultNav.staticData[0].id
	};
	
	var defaultResponse = exports.defaultResponse = {
	    list: [],
	    loading: false,
	    page: 0,
	    isEnd: false,
	    isError: false,
	    endMsg: '到底了',
	    errMsg: '出错了'
	};
	
	var defaultUser = exports.defaultUser = {
	    list: [],
	    loading: false,
	    page: 0,
	    isEnd: false,
	    isError: false,
	    endMsg: '到底了',
	    errMsg: '出错了'
	};

/***/ }),
/* 280 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.fetchUsersData = exports.updateNavData = exports.addResData = exports.fetchResData = exports.fetchDetailData = exports.FETCH_USER_ERR = exports.FETCH_USER_SUCC = exports.FETCH_USER_LOADING = exports.ADD_RES_DATA = exports.FETCH_RES_ERR = exports.FETCH_RES_SUCC = exports.FETCH_RES_LOADING = exports.UPDATE_NAV_DATA = exports.UPDATE_DETAIL_DATA = exports.INIT_ERR = exports.INIT_LOADING = undefined;
	
	var _util = __webpack_require__(281);
	
	var _util2 = _interopRequireDefault(_util);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var INIT_LOADING = exports.INIT_LOADING = 'INIT_LOADING';
	var INIT_ERR = exports.INIT_ERR = 'INIT_ERR';
	var UPDATE_DETAIL_DATA = exports.UPDATE_DETAIL_DATA = 'UPDATE_DETAIL_DATA';
	var UPDATE_NAV_DATA = exports.UPDATE_NAV_DATA = 'UPDATE_NAV_DATA';
	
	var FETCH_RES_LOADING = exports.FETCH_RES_LOADING = 'FETCH_RES_LOADING';
	var FETCH_RES_SUCC = exports.FETCH_RES_SUCC = 'FETCH_RES_SUCC';
	var FETCH_RES_ERR = exports.FETCH_RES_ERR = 'FETCH_RES_ERR';
	var ADD_RES_DATA = exports.ADD_RES_DATA = 'ADD_RES_DATA';
	
	var FETCH_USER_LOADING = exports.FETCH_USER_LOADING = 'FETCH_USER_LOADING';
	var FETCH_USER_SUCC = exports.FETCH_USER_SUCC = 'FETCH_USER_SUCC';
	var FETCH_USER_ERR = exports.FETCH_USER_ERR = 'FETCH_USER_ERR';
	
	var fetchDetailData = exports.fetchDetailData = function fetchDetailData(url) {
	    var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	    return function (dispatch) {
	        dispatch({ type: INIT_LOADING });
	
	        // 返回数据一级字段名mapping: [data, msg]; 二级字段名暂时不做处理，请在reducer内处理
	        return _util2.default.reqwest(url, data).then(function (r) {
	            if (r.code == 200) {
	                dispatch({
	                    type: UPDATE_DETAIL_DATA,
	                    data: r.data.detail
	                });
	                return Promise.resolve(r);
	            } else {
	                dispatch({ type: INIT_ERR, msg: r.errorMsg });
	                return Promise.reject(r);
	            }
	        }).catch(function (e) {
	            dispatch({ type: INIT_ERR });
	            return Promise.reject({
	                code: 204,
	                message: e && e.message || 'something error'
	            });
	        });
	    };
	};
	
	// `回应`分页加载
	var fetchResData = exports.fetchResData = function fetchResData(url) {
	    var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	    var method = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'GET';
	    var validFn = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : _resultValid;
	    return function (dispatch) {
	        dispatch({ type: FETCH_RES_LOADING });
	
	        // 返回数据一级字段名mapping: [data, msg]; 二级字段名暂时不做处理，请在reducer内处理
	        return _util2.default.reqwest(url, data).then(function (r) {
	            if (r.code == 200) {
	                if (typeof validFn == 'function' && validFn(r)) {
	                    dispatch({
	                        type: FETCH_RES_SUCC,
	                        data: r.data
	                    });
	                }
	                return Promise.resolve(r);
	            } else {
	                dispatch({ type: FETCH_RES_ERR, msg: r.errorMsg });
	                return Promise.reject(r);
	            }
	        }).catch(function (e) {
	            dispatch({ type: FETCH_RES_ERR });
	            return Promise.reject({
	                code: 204,
	                message: e && e.message || 'something error'
	            });
	        });
	    };
	};
	
	var addResData = exports.addResData = function addResData() {
	    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    return function (dispatch) {
	        dispatch({
	            type: ADD_RES_DATA,
	            data: data
	        });
	    };
	};
	
	var updateNavData = exports.updateNavData = function updateNavData() {
	    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    return function (dispatch) {
	        dispatch({
	            type: UPDATE_NAV_DATA,
	            data: data
	        });
	    };
	};
	
	var fetchUsersData = exports.fetchUsersData = function fetchUsersData(url) {
	    var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	    var method = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'GET';
	    var validFn = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : _resultValid;
	    return function (dispatch) {
	        dispatch({ type: FETCH_USER_LOADING });
	
	        return _util2.default.reqwest(url, data).then(function (r) {
	            if (r.code == 200) {
	                if (validFn(r)) {
	                    dispatch({
	                        type: FETCH_USER_SUCC,
	                        data: r.data
	                    });
	                }
	                return Promise.resolve(r);
	            } else {
	                dispatch({ type: FETCH_USER_ERR, msg: r.errorMsg });
	                return Promise.reject(r);
	            }
	        }).catch(function (e) {
	            dispatch({ type: FETCH_USER_ERR });
	            return Promise.reject({
	                code: 204,
	                message: e && e.message || 'something error'
	            });
	        });
	    };
	};
	
	function _resultValid() {
	    return true;
	}

/***/ }),
/* 281 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _knb = __webpack_require__(282);
	
	var _knb2 = _interopRequireDefault(_knb);
	
	var _utilMUa = __webpack_require__(472);
	
	var _utilMUa2 = _interopRequireDefault(_utilMUa);
	
	var _utilLogin = __webpack_require__(473);
	
	var _utilLogin2 = _interopRequireDefault(_utilLogin);
	
	var _reqwest2 = __webpack_require__(476);
	
	var _reqwest3 = _interopRequireDefault(_reqwest2);
	
	var _whereami = __webpack_require__(478);
	
	var _whereami2 = _interopRequireDefault(_whereami);
	
	var _cookie = __webpack_require__(536);
	
	var _cookie2 = _interopRequireDefault(_cookie);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// import 'url-search-params-polyfill';
	// import 'whatwg-fetch';
	
	module.exports = {
	    cache: {},
	    shareRedirect: function shareRedirect(justCheck) {
	        if (this.cache.urlSource === undefined) {
	            this.cache.urlSource = this.parseQuery('source') || '';
	        }
	        if (!this.isApp() && this.cache.urlSource === 'mShare') {
	            if (!justCheck) {
	                location.href = 'https://evt.dianping.com/synthesislink/15763.html?url=' + encodeURIComponent(location.href);
	            }
	            return false;
	        }
	        return true;
	    },
	    extend: function extend(to, from) {
	        to = to || {};
	        for (var key in from) {
	            from.hasOwnProperty(key) && (to[key] = from[key]);
	        }
	        return to;
	    },
	    isObjectEmpty: function isObjectEmpty(obj) {
	        for (var key in obj) {
	            if (obj.hasOwnProperty(key)) {
	                return false;
	            }
	        }
	        return true;
	    },
	    getTypeList: function getTypeList() {
	        return {
	            0: '全部',
	            1: '美食',
	            6: '玩乐',
	            2: '丽人',
	            3: '结婚',
	            4: '亲子',
	            5: '家装',
	            8: '培训',
	            9: '酒旅',
	            10: '生活',
	            99: '其它'
	        };
	    },
	    getFilterList: function getFilterList() {
	        return {
	            0: '无',
	            1: '只看未抢',
	            2: '可用pass卡',
	            3: 'vclub',
	            99: '到综'
	        };
	    },
	    getUA: function getUA() {
	        if (!this.cache.ua) {
	            this.cache.ua = (0, _utilMUa2.default)();
	        }
	        return this.cache.ua;
	    },
	    isIOS: function isIOS() {
	        // TODO: Version
	        return !!navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
	    },
	    isIPhoneX: function isIPhoneX() {
	        var ua = this.getUA();
	        if (ua.model === 'iPhoneX') return true;
	        var _winHeight = window.screen && window.screen.height || window.outerHeight || window.innerHeight;
	        var _winWidth = window.screen && window.screen.width || window.outerWidth || window.innerWidth;
	        // 请先判断之上的isIOS()
	        return _winHeight === 812 && _winWidth === 375;
	    },
	    isVersion10: function isVersion10() {
	        var ua = this.getUA();
	        return parseInt(ua.version) > 9;
	    },
	    isApp: function isApp(app) {
	        var ua = this.getUA();
	        if (app) {
	            return ua.type == app;
	        }
	        return (/^(dpapp|mtgroup)$/i.test(ua.type)
	        );
	    },
	
	    getCx: function getCx() {
	        var _this = this;
	
	        return new Promise(function (resolve, reject) {
	            if (_this.isApp()) {
	                if (_this.cache.cx) {
	                    resolve(_this.cache.cx);
	                } else {
	                    _knb2.default.getFingerprint({
	                        success: function success(ret) {
	                            var cx = ret.fingerprint;
	                            if (cx) {
	                                _this.cache.cx = cx;
	                                resolve(cx);
	                            } else {
	                                resolve('');
	                            }
	                        },
	                        fail: function fail(msg) {
	                            resolve('');
	                        }
	                    });
	                }
	            } else {
	                resolve('');
	            }
	        });
	    },
	    getToken: function getToken() {
	        var _this2 = this;
	
	        return new Promise(function (resolve, reject) {
	            if (_this2.isApp()) {
	                if (_this2.cache.token) {
	                    resolve(_this2.cache.token);
	                } else {
	                    // let self = this;
	                    _knb2.default.getUserInfo({
	                        success: function success(user) {
	                            var token = user.token;
	                            if (token) {
	                                _this2.cache.token = token;
	                                resolve(token);
	                            } else {
	                                reject('unlogin');
	                            }
	                        },
	                        fail: function fail(msg) {
	                            reject('unlogin');
	                        }
	                    });
	                }
	            } else {
	                resolve();
	                // if (this.cache.token) {
	                //     resolve()
	                // } else {
	                //     Login.check((r) => {
	                //         if (r.isLogin) {
	                //             this.cache.token = r.userInfo.token;
	                //             resolve();
	                //         } else {
	                //             reject('unlogin');
	                //         }
	                //     })
	                // }
	            }
	        });
	    },
	    getDomain: function getDomain(isStatic) {
	        var url = location.href,
	            prefix = isStatic ? 'h5' : 'm',
	            domain = void 0;
	        if (~url.indexOf('.dianping.com')) {
	            if (~url.indexOf('ppe.dianping.com')) {
	                domain = '//ppe.' + prefix + '.dianping.com';
	            } else {
	                domain = '//' + prefix + '.dianping.com';
	            }
	        } else if (~url.indexOf('.51ping.com') || ~url.indexOf('.dev.sankuai.com')) {
	            domain = '//' + prefix + '.51ping.com';
	        } else {
	            domain = '//' + prefix + '.dianping.com';
	        }
	        return location.protocol + domain;
	    },
	    reqwest: function reqwest(url) {
	        var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	        var _this3 = this;
	
	        var method = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'GET';
	        var withCredentials = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
	
	        return this.getToken().then(function (token) {
	            token && (data.token = token);
	            var source = _this3.parseQuery('source');
	            source && (data.source = source);
	        }, function () {}).then(function () {
	            return _this3._reqwest(url, data, method, withCredentials);
	        });
	    },
	    _reqwest: function _reqwest(url) {
	        var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	        var method = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'GET';
	        var withCredentials = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
	
	        return (0, _reqwest3.default)({
	            url: this.getDomain() + url,
	            method: method,
	            data: data,
	            crossOrigin: true,
	            type: 'json',
	            withCredentials: withCredentials
	        }).then(function (r) {
	            if (!!r) {
	                return Promise.resolve(r);
	            } else {
	                return Promise.reject('Illegal Result');
	            }
	        }).fail(function (e) {
	            return Promise.reject('Network response was not ok, resason: ' + JSON.stringify(e));
	        });
	    },
	    _reqwest_fetch: function _reqwest_fetch(url) {
	        var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	        var method = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'GET';
	        var withCredentials = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
	
	        // deprecate: polyfill problem
	        // TODO: Header
	        var options = {
	            method: method,
	            mode: 'cors'
	        },
	            bodyObj = void 0;
	
	        withCredentials && (options.credentials = 'include');
	
	        if (method == 'POST' && Object.prototype.toString.call(data) !== '[object FormData]') {
	            // 说明1：后端不支持FormData格式数据
	            // bodyObj = new FormData();
	            // for (let key in data) {
	            //     data.hasOwnProperty(key) && bodyObj.append(key, data[key]);
	            // }
	            // 说明2：OPTION对后端改动大
	            // options.headers = {
	            //     'Content-Type': 'application/json'
	            // }
	            // bodyObj = [];
	            // for (let key in data) {
	            //     data.hasOwnProperty(key) && data[key] && bodyObj.push(`${key}=${data[key]}`);
	            // }
	            // bodyObj = new URLSearchParams(bodyObj.join('&')) // TODO: polyfill
	            bodyObj = new URLSearchParams(data);
	        } else if (method == 'GET') {
	            bodyObj = [];
	            for (var key in data) {
	                data.hasOwnProperty(key) && data[key] && bodyObj.push(key + '=' + data[key]);
	            }
	            if (bodyObj.length) {
	                url += (~url.indexOf('?') ? '&' : '?') + bodyObj.join('&');
	            }
	        }
	        method == 'POST' && (options.body = bodyObj || data);
	
	        return fetch(this.getDomain() + url, options).then(function (response) {
	            if (response.ok) {
	                return response.json().then(function (r) {
	                    if (!!r) {
	                        return Promise.resolve(r);
	                    } else {
	                        return Promise.reject('Illegal Result');
	                    }
	                });
	            } else {
	                return Promise.reject('Network response was not ok, status: ' + response.status);
	            }
	        });
	    },
	    handleRedir: function handleRedir(url, callback) {
	        var _this4 = this;
	
	        if (!this.shareRedirect()) return;
	        // `token=!`是点评的书写规范
	        if (/token[=|%3D]!/.test(url)) {
	            this.getToken().then(function () {
	                if (typeof callback == 'function') {
	                    callback(url);
	                } else {
	                    location.href = url;
	                }
	            }, function () {
	                (0, _utilLogin2.default)(function () {
	                    _this4.handleRedir(url, callback);
	                }, function () {
	                    console.log('login fail');
	                });
	            }).catch(function () {});
	        } else {
	            if (typeof callback == 'function') {
	                callback(url);
	            } else {
	                location.href = url;
	            }
	        }
	    },
	
	    parseQuery: function parseQuery(attr) {
	        if (!attr) return;
	        var match = RegExp('[?&]' + attr + '=([^&]*)').exec(window.location.search);
	        return match && decodeURIComponent(match[1].replace(/\+/g, ' ')); // url中+号表示空格,要替换掉
	    },
	    getCity: function getCity() {
	        var _this5 = this;
	
	        return new Promise(function (resolve, reject) {
	            var result = void 0;
	            /**
	             * 1. url search
	             * 2. meituan APP 前端不解析
	             * 3. 页面内城市/点评APP默认种cookie cityid
	             * 4. 前端定位经纬度 -> city
	             */
	            if (result = _this5.parseQuery('cityid')) {
	                resolve(result);
	            } else if (_this5.isApp('mtgroup')) {
	                reject({
	                    message: 'business not support meituan cityid'
	                });
	            } else if (result = (0, _cookie2.default)('cityid')) {
	                resolve(result);
	            } else {
	                _whereami2.default.config({
	                    timeout: 3000,
	                    enables: ['x5'],
	                    wxAutoConfig: true,
	                    city: true,
	                    cityType: 'dianping',
	                    source: 'fMeal',
	                    sampling: 0.5
	                });
	                (0, _whereami2.default)(function (res) {
	                    resolve(res.city.cityid);
	                }, function (err) {
	                    reject(err);
	                });
	            }
	        });
	    }
	};

/***/ }),
/* 282 */
/***/ (function(module, exports, __webpack_require__) {

	// notice: must use compiled file for user agent may only support es5 feature.
	var isBrowser = typeof window !== 'undefined';
	var KNB = isBrowser ? __webpack_require__(283) : {load: function(){}, _ready: function(){}};
	if (isBrowser) window.KNB = KNB;
	
	var KNBExtend = (function () {
	  if (typeof window === 'undefined') return; // do not load KNB if not run in browser
	  var env = __webpack_require__(295);
	  switch (true) {
	    case env.isDPApp:
	      return __webpack_require__(296);
	    case env.isMTNB:
	      return __webpack_require__(357);
	    case env.isHBNB:
	      return __webpack_require__(358);
	    case env.isTitans:
	      return __webpack_require__(466);
	    case env.isWX:
	      if (typeof _KNB_IGNORE_WECHAT !== 'undefined') return; // 如果用户有配置这个变量，则跳过对微信的适配
	      return __webpack_require__(469);
	  }
	})();
	
	KNB.load(KNBExtend || {});
	KNB._ready();
	
	module.exports = KNB;


/***/ }),
/* 283 */
/***/ (function(module, exports, __webpack_require__) {

	var apis = __webpack_require__(284);
	var mixin = __webpack_require__(285);
	var version = __webpack_require__(286);
	var getUA = __webpack_require__(287);
	var promisify = __webpack_require__(291);
	
	var noop = function () {};
	var cacheFns = [];
	
	var KNB = {
	  __version__: version,
	
	  NOTIMPLEMENTED: function(apiName, opts) {
	    var this$1 = this;
	
	    var fail = opts.fail || noop;
	    if (this._isReady) return fail({error: -1, msg: 'API [' + apiName + '] is not implemented'});
	    this.cache = this.cache || [];
	    this.cache.push(function () { return this$1[apiName](opts); });
	  },
	  load: function(child) {
	    var this$1 = this;
	
	    mixin(this, child);
	
	    // assign an _add method for child
	    // so child can dynamically add methods
	    child._add = function (name, fn) {
	      this$1[name] = fn;
	    };
	  },
	  _ready:function() {
	    this._isReady = true;
	    var tasks = this.cache || [];
	    function afterReady() {
	      (function doTasks(arr) {
	        if (!arr.length) return;
	        var task = arr.shift();
	        if (typeof task === 'function') task();
	        doTasks(arr);
	      })(tasks);
	
	      cacheFns.forEach(function (fn) { return fn(); });
	    }
	    // 说明具体环境脚本已经重写了ready方法
	    // 此时，需要等待具体环境ready
	    if (this.ready && !this.ready.isFromLoader) return this.ready(afterReady);
	    afterReady();
	  },
	  ready: function(cb) {
	    if (this._isReady) return cb();
	    if (typeof cb === 'function') cacheFns.push(cb);
	  },
	  use: function(api, opts) {
	    var this$1 = this;
	
	    this.cache = this.cache || [];
	    this.cache.push(function () { return this$1.use(api, opts); });
	  }
	};
	KNB.ready.isFromLoader = true;
	apis.forEach(function(api) {
	  KNB[api] = function(opts) {
	    if ( opts === void 0 ) opts={};
	
	    KNB.NOTIMPLEMENTED(api, opts);
	  };
	});
	KNB.getUA = getUA; // override getUA
	KNB.env = __webpack_require__(295);
	KNB.uaInfo = getUA.internal;
	promisify(KNB);
	
	module.exports = KNB;


/***/ }),
/* 284 */
/***/ (function(module, exports) {

	// API set to implement
	module.exports = [
	    'config',
	
	    'isApiSupported',
	    'getApisVersion',
	    'getUA',
	    'Semver',
	    'checkAuthorization',
	
	    'getFingerprint',
	    'getUserInfo',
	    'getDeviceInfo',
	    'login',
	    'logout',
	    'sendSMS',
	    'getContactList',
	    'pickContact',
	
	    'getCity',
	    'getLocationCity',
	    'getLocation',
	    'getNetworkType',
	    'pickCity',
	
	    'share',
	    'configShare',
	
	    'openWebview',
	    'closeWebview',
	    'jumpWebview',
	
	    'setTitle',
	    'setImageTitle',
	    'setNavButtons',
	    'setNavigationBarHidden',
	    'setBackgroundColor',
	    'setBouncesEnabled',
	    'setStatusBarStyle',
	    'setPullDown',
	    'stopPullDown',
	    'setLLButton',
	    'setSearchBar',
	    'scanQRCode',
	    'showKeyboard',
	
	    'store',
	    'retrieve',
	
	    'alert',
	    'confirm',
	    'prompt',
	    'sendLog',
	
	    'chooseImage',
	    'previewImage',
	    'uploadImage',
	    'downloadImage',
	
	    'publish',
	    'subscribe',
	    'unsubscribe',
	
	    'setResult',
	    'getResult',
	  ];


/***/ }),
/* 285 */
/***/ (function(module, exports) {

	//extend simple implementation
	
	module.exports = function (a, b, c, d, e, f) {
	  var objs = [b, c, d, e, f].filter(Boolean);
	  var target = a || {};
	  objs.forEach(function (source) {
	    for (var key in source) {
	      if (source.hasOwnProperty(key)) {
	        target[key] = source[key];
	      }
	    }
	  });
	  return target;
	};

/***/ }),
/* 286 */
/***/ (function(module, exports) {

	module.exports = ("1.5.11");

/***/ }),
/* 287 */
/***/ (function(module, exports, __webpack_require__) {

	var QS = __webpack_require__(288);
	function getUAInfo() {
	  var lua = (navigator.userAgent + '').toLowerCase();
	  var VER_REG_STR = "([0-9][0-9.a-zA-Z_]+)";
	  var regexp = function (str) { return new RegExp(str, 'i'); };
	  var isstr  = function (str) { return typeof str === 'string'; };
	  var href = location.href;
	  var qs = QS.parse((location.search || '').slice(1));
	
	  var apps = {
	    dianping: [/com\.dianping\.ba.\w+/, /com\.dianping\.\w+/],
	    meituan: ['meituangroup', /com.meituan.imeituan-?\w+/],
	    maoyanpro: ['moviepro', 'moviepro/android'],
	    maoyan: ['movie'],
	    moma: ['moma'],
	    daxiang: ['xm'],
	
	    wechat: ['micromessenger'],
	    qq: ['qq'],
	
	    unknown: ['never_match_anything'],
	  };
	  var appName = function () {
	     var names = Object.keys(apps);
	     for (var i = 0; i < names.length; i++) {
	       var matchers = apps[names[i]];
	       for (var j = 0; j < matchers.length; j++) {
	         if (isstr(matchers[j]) ? regexp('\\W' + matchers[j] + '\\W').test(lua) : matchers[j].test(lua)) return names[i]; 
	       }
	     }
	     return "unknown";
	  }();
	  var appVersion = function () {
	    var matchers = apps[appName];
	    for (var i = 0; i < matchers.length; i++) {
	      var mstring = isstr(matchers[i]) ? matchers[i] : matchers[i].source;
	      var m = lua.match(regexp(mstring + ' ' + VER_REG_STR)) || lua.match(regexp(mstring + '/' + VER_REG_STR));
	      if (m) return m[1];
	    }
	    return "0";
	  }();
	  var osName = function () {
	    if (/android/.test(lua)) return 'android';
	    if (/ios|iphone|ipod|ipad/.test(lua)) return 'ios';
	    if (/macintosh/.test(lua)) return 'mac';
	    if (/windows/.test(lua)) return 'windows';
	    return "unknown";
	  }();
	  var osVersion = function () {
	    var m;
	    // https://developer.chrome.com/multidevice/user-agent
	    // order matters!
	    if (osName === 'android') m  =  lua.match(regexp('android '+ VER_REG_STR)) || lua.match(regexp('android/'+ VER_REG_STR));
	    if (osName === 'ios') m = lua.match(regexp(VER_REG_STR +' like Mac OS X')) || lua.match(regexp('iOS/' + VER_REG_STR));
	
	    // 通常而言mac/window的版本不重要，无视之
	    return (m ? m[1] : '0').replace(/_/g, '.');
	  }();
	
	  // internal version info
	  // MATCHED INDEX:     1  2              3      4             5       6
	  // EXAMPLE:         KNB/1.1.0         Android/5.1     MeituanGroup/7.3.1
	  var reg1 = regexp(("(KNB)/" + VER_REG_STR + " (\\w+)/" + VER_REG_STR + " (\\w+)/" + VER_REG_STR));
	  var reg2 = regexp(("(KNB)/" + VER_REG_STR + " (\\w+)/" + VER_REG_STR + " ([a-z1-9A-Z_.-]+/[a-z1-9A-Z_.-]+)/" + VER_REG_STR));
	  var m   = lua.match(reg1) || lua.match(reg2);
	  var _knbVersion = m && m[2];
	
	  // Try KNB Generic Mode
	  if (appName === 'unknown' && m) {
	    appName    = m[5];
	    appVersion = m[6];
	  }
	
	  // God knowns who you are
	  if (appName === 'unknown') {
	    // waimai app
	    if (href.indexOf('wm_ctype=') > -1) appName = "waimai";
	    // meituan like app < 7.0
	    if (/iphone|ipod|ipad|android/.test(href)) {
	      if ((qs.utm_campaign || '').indexOf('Agroup') > -1) appName = 'meituan';
	      appVersion = qs.version_name;
	    }
	  }
	
	  var matchTitansVerison = lua.match(regexp(("(TitansX|TitansNoX)/" + VER_REG_STR)));
	  var titansxVersion = matchTitansVerison && matchTitansVerison[2];
	
	  return {
	    appName: appName,
	    appVersion: appVersion,
	    osName: osName,
	    osVersion: osVersion,
	
	    titansxVersion: titansxVersion,
	    _knbVersion: _knbVersion
	  };
	}
	
	function getUA(ref) {
	  var success = ref.success;
	
	  success && success(getUAInfo());
	}
	
	// The actual method
	getUA.internal = getUAInfo;
	
	module.exports = getUA;


/***/ }),
/* 288 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.decode = exports.parse = __webpack_require__(289);
	exports.encode = exports.stringify = __webpack_require__(290);


/***/ }),
/* 289 */
/***/ (function(module, exports) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	'use strict';
	
	// If obj.hasOwnProperty has been overridden, then calling
	// obj.hasOwnProperty(prop) will break.
	// See: https://github.com/joyent/node/issues/1707
	function hasOwnProperty(obj, prop) {
	  return Object.prototype.hasOwnProperty.call(obj, prop);
	}
	
	module.exports = function(qs, sep, eq, options) {
	  sep = sep || '&';
	  eq = eq || '=';
	  var obj = {};
	
	  if (typeof qs !== 'string' || qs.length === 0) {
	    return obj;
	  }
	
	  var regexp = /\+/g;
	  qs = qs.split(sep);
	
	  var maxKeys = 1000;
	  if (options && typeof options.maxKeys === 'number') {
	    maxKeys = options.maxKeys;
	  }
	
	  var len = qs.length;
	  // maxKeys <= 0 means that we should not limit keys count
	  if (maxKeys > 0 && len > maxKeys) {
	    len = maxKeys;
	  }
	
	  for (var i = 0; i < len; ++i) {
	    var x = qs[i].replace(regexp, '%20'),
	        idx = x.indexOf(eq),
	        kstr, vstr, k, v;
	
	    if (idx >= 0) {
	      kstr = x.substr(0, idx);
	      vstr = x.substr(idx + 1);
	    } else {
	      kstr = x;
	      vstr = '';
	    }
	
	    k = decodeURIComponent(kstr);
	    v = decodeURIComponent(vstr);
	
	    if (!hasOwnProperty(obj, k)) {
	      obj[k] = v;
	    } else if (Array.isArray(obj[k])) {
	      obj[k].push(v);
	    } else {
	      obj[k] = [obj[k], v];
	    }
	  }
	
	  return obj;
	};


/***/ }),
/* 290 */
/***/ (function(module, exports) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	'use strict';
	
	var stringifyPrimitive = function(v) {
	  switch (typeof v) {
	    case 'string':
	      return v;
	
	    case 'boolean':
	      return v ? 'true' : 'false';
	
	    case 'number':
	      return isFinite(v) ? v : '';
	
	    default:
	      return '';
	  }
	};
	
	module.exports = function(obj, sep, eq, name) {
	  sep = sep || '&';
	  eq = eq || '=';
	  if (obj === null) {
	    obj = undefined;
	  }
	
	  if (typeof obj === 'object') {
	    return Object.keys(obj).map(function(k) {
	      var ks = encodeURIComponent(stringifyPrimitive(k)) + eq;
	      if (Array.isArray(obj[k])) {
	        return obj[k].map(function(v) {
	          return ks + encodeURIComponent(stringifyPrimitive(v));
	        }).join(sep);
	      } else {
	        return ks + encodeURIComponent(stringifyPrimitive(obj[k]));
	      }
	    }).join(sep);
	
	  }
	
	  if (!name) return '';
	  return encodeURIComponent(stringifyPrimitive(name)) + eq +
	         encodeURIComponent(stringifyPrimitive(obj));
	};


/***/ }),
/* 291 */
/***/ (function(module, exports, __webpack_require__) {

	var win = typeof window !== 'undefined' ? window : {};
	var mixin = __webpack_require__(285);
	var Promise = win.Promise || __webpack_require__(292);
	var apis = __webpack_require__(284);
	
	// get an empty object from obj's type
	function empty(obj) {
	  return Object.prototype.toString.call(obj) === '[object Array]' ? [] : {};
	}
	
	module.exports = function (KNB) {
	  if (KNB.getPromiseInstance) return;
	  KNB.getPromiseInstance = function () {
	    var KNBP = {};
	    apis.forEach(function (name) {
	      if (name === 'config') return;
	      KNBP[name] = function (config) {
	        return new Promise(function (resolve, reject) {
	          KNB[name](mixin(empty(config), config, { success: resolve, fail: reject }));
	        });
	      };
	    });
	    KNBP.use = function (name, config) {
	      return new Promise(function (resolve, reject) {
	        KNB.use(name, mixin(empty(config), config, { success: resolve, fail: reject }));
	      });
	    };
	    KNBP.all = function (args) { return Promise.all(args); };
	    return KNBP;
	  };
	}
	


/***/ }),
/* 292 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, setImmediate) {'use strict';
	
	var PENDING = 'pending';
	var SETTLED = 'settled';
	var FULFILLED = 'fulfilled';
	var REJECTED = 'rejected';
	var NOOP = function () {};
	var isNode = typeof global !== 'undefined' && typeof global.process !== 'undefined' && typeof global.process.emit === 'function';
	
	var asyncSetTimer = typeof setImmediate === 'undefined' ? setTimeout : setImmediate;
	var asyncQueue = [];
	var asyncTimer;
	
	function asyncFlush() {
		// run promise callbacks
		for (var i = 0; i < asyncQueue.length; i++) {
			asyncQueue[i][0](asyncQueue[i][1]);
		}
	
		// reset async asyncQueue
		asyncQueue = [];
		asyncTimer = false;
	}
	
	function asyncCall(callback, arg) {
		asyncQueue.push([callback, arg]);
	
		if (!asyncTimer) {
			asyncTimer = true;
			asyncSetTimer(asyncFlush, 0);
		}
	}
	
	function invokeResolver(resolver, promise) {
		function resolvePromise(value) {
			resolve(promise, value);
		}
	
		function rejectPromise(reason) {
			reject(promise, reason);
		}
	
		try {
			resolver(resolvePromise, rejectPromise);
		} catch (e) {
			rejectPromise(e);
		}
	}
	
	function invokeCallback(subscriber) {
		var owner = subscriber.owner;
		var settled = owner._state;
		var value = owner._data;
		var callback = subscriber[settled];
		var promise = subscriber.then;
	
		if (typeof callback === 'function') {
			settled = FULFILLED;
			try {
				value = callback(value);
			} catch (e) {
				reject(promise, e);
			}
		}
	
		if (!handleThenable(promise, value)) {
			if (settled === FULFILLED) {
				resolve(promise, value);
			}
	
			if (settled === REJECTED) {
				reject(promise, value);
			}
		}
	}
	
	function handleThenable(promise, value) {
		var resolved;
	
		try {
			if (promise === value) {
				throw new TypeError('A promises callback cannot return that same promise.');
			}
	
			if (value && (typeof value === 'function' || typeof value === 'object')) {
				// then should be retrieved only once
				var then = value.then;
	
				if (typeof then === 'function') {
					then.call(value, function (val) {
						if (!resolved) {
							resolved = true;
	
							if (value === val) {
								fulfill(promise, val);
							} else {
								resolve(promise, val);
							}
						}
					}, function (reason) {
						if (!resolved) {
							resolved = true;
	
							reject(promise, reason);
						}
					});
	
					return true;
				}
			}
		} catch (e) {
			if (!resolved) {
				reject(promise, e);
			}
	
			return true;
		}
	
		return false;
	}
	
	function resolve(promise, value) {
		if (promise === value || !handleThenable(promise, value)) {
			fulfill(promise, value);
		}
	}
	
	function fulfill(promise, value) {
		if (promise._state === PENDING) {
			promise._state = SETTLED;
			promise._data = value;
	
			asyncCall(publishFulfillment, promise);
		}
	}
	
	function reject(promise, reason) {
		if (promise._state === PENDING) {
			promise._state = SETTLED;
			promise._data = reason;
	
			asyncCall(publishRejection, promise);
		}
	}
	
	function publish(promise) {
		promise._then = promise._then.forEach(invokeCallback);
	}
	
	function publishFulfillment(promise) {
		promise._state = FULFILLED;
		publish(promise);
	}
	
	function publishRejection(promise) {
		promise._state = REJECTED;
		publish(promise);
		if (!promise._handled && isNode) {
			global.process.emit('unhandledRejection', promise._data, promise);
		}
	}
	
	function notifyRejectionHandled(promise) {
		global.process.emit('rejectionHandled', promise);
	}
	
	/**
	 * @class
	 */
	function Promise(resolver) {
		if (typeof resolver !== 'function') {
			throw new TypeError('Promise resolver ' + resolver + ' is not a function');
		}
	
		if (this instanceof Promise === false) {
			throw new TypeError('Failed to construct \'Promise\': Please use the \'new\' operator, this object constructor cannot be called as a function.');
		}
	
		this._then = [];
	
		invokeResolver(resolver, this);
	}
	
	Promise.prototype = {
		constructor: Promise,
	
		_state: PENDING,
		_then: null,
		_data: undefined,
		_handled: false,
	
		then: function (onFulfillment, onRejection) {
			var subscriber = {
				owner: this,
				then: new this.constructor(NOOP),
				fulfilled: onFulfillment,
				rejected: onRejection
			};
	
			if ((onRejection || onFulfillment) && !this._handled) {
				this._handled = true;
				if (this._state === REJECTED && isNode) {
					asyncCall(notifyRejectionHandled, this);
				}
			}
	
			if (this._state === FULFILLED || this._state === REJECTED) {
				// already resolved, call callback async
				asyncCall(invokeCallback, subscriber);
			} else {
				// subscribe
				this._then.push(subscriber);
			}
	
			return subscriber.then;
		},
	
		catch: function (onRejection) {
			return this.then(null, onRejection);
		}
	};
	
	Promise.all = function (promises) {
		if (!Array.isArray(promises)) {
			throw new TypeError('You must pass an array to Promise.all().');
		}
	
		return new Promise(function (resolve, reject) {
			var results = [];
			var remaining = 0;
	
			function resolver(index) {
				remaining++;
				return function (value) {
					results[index] = value;
					if (!--remaining) {
						resolve(results);
					}
				};
			}
	
			for (var i = 0, promise; i < promises.length; i++) {
				promise = promises[i];
	
				if (promise && typeof promise.then === 'function') {
					promise.then(resolver(i), reject);
				} else {
					results[i] = promise;
				}
			}
	
			if (!remaining) {
				resolve(results);
			}
		});
	};
	
	Promise.race = function (promises) {
		if (!Array.isArray(promises)) {
			throw new TypeError('You must pass an array to Promise.race().');
		}
	
		return new Promise(function (resolve, reject) {
			for (var i = 0, promise; i < promises.length; i++) {
				promise = promises[i];
	
				if (promise && typeof promise.then === 'function') {
					promise.then(resolve, reject);
				} else {
					resolve(promise);
				}
			}
		});
	};
	
	Promise.resolve = function (value) {
		if (value && typeof value === 'object' && value.constructor === Promise) {
			return value;
		}
	
		return new Promise(function (resolve) {
			resolve(value);
		});
	};
	
	Promise.reject = function (reason) {
		return new Promise(function (resolve, reject) {
			reject(reason);
		});
	};
	
	module.exports = Promise;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(293).setImmediate))

/***/ }),
/* 293 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {var scope = (typeof global !== "undefined" && global) ||
	            (typeof self !== "undefined" && self) ||
	            window;
	var apply = Function.prototype.apply;
	
	// DOM APIs, for completeness
	
	exports.setTimeout = function() {
	  return new Timeout(apply.call(setTimeout, scope, arguments), clearTimeout);
	};
	exports.setInterval = function() {
	  return new Timeout(apply.call(setInterval, scope, arguments), clearInterval);
	};
	exports.clearTimeout =
	exports.clearInterval = function(timeout) {
	  if (timeout) {
	    timeout.close();
	  }
	};
	
	function Timeout(id, clearFn) {
	  this._id = id;
	  this._clearFn = clearFn;
	}
	Timeout.prototype.unref = Timeout.prototype.ref = function() {};
	Timeout.prototype.close = function() {
	  this._clearFn.call(scope, this._id);
	};
	
	// Does not start the time, just sets up the members needed.
	exports.enroll = function(item, msecs) {
	  clearTimeout(item._idleTimeoutId);
	  item._idleTimeout = msecs;
	};
	
	exports.unenroll = function(item) {
	  clearTimeout(item._idleTimeoutId);
	  item._idleTimeout = -1;
	};
	
	exports._unrefActive = exports.active = function(item) {
	  clearTimeout(item._idleTimeoutId);
	
	  var msecs = item._idleTimeout;
	  if (msecs >= 0) {
	    item._idleTimeoutId = setTimeout(function onTimeout() {
	      if (item._onTimeout)
	        item._onTimeout();
	    }, msecs);
	  }
	};
	
	// setimmediate attaches itself to the global object
	__webpack_require__(294);
	// On some exotic environments, it's not clear which object `setimmediate` was
	// able to install onto.  Search each possibility in the same order as the
	// `setimmediate` library.
	exports.setImmediate = (typeof self !== "undefined" && self.setImmediate) ||
	                       (typeof global !== "undefined" && global.setImmediate) ||
	                       (this && this.setImmediate);
	exports.clearImmediate = (typeof self !== "undefined" && self.clearImmediate) ||
	                         (typeof global !== "undefined" && global.clearImmediate) ||
	                         (this && this.clearImmediate);
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 294 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
	    "use strict";
	
	    if (global.setImmediate) {
	        return;
	    }
	
	    var nextHandle = 1; // Spec says greater than zero
	    var tasksByHandle = {};
	    var currentlyRunningATask = false;
	    var doc = global.document;
	    var registerImmediate;
	
	    function setImmediate(callback) {
	      // Callback can either be a function or a string
	      if (typeof callback !== "function") {
	        callback = new Function("" + callback);
	      }
	      // Copy function arguments
	      var args = new Array(arguments.length - 1);
	      for (var i = 0; i < args.length; i++) {
	          args[i] = arguments[i + 1];
	      }
	      // Store and register the task
	      var task = { callback: callback, args: args };
	      tasksByHandle[nextHandle] = task;
	      registerImmediate(nextHandle);
	      return nextHandle++;
	    }
	
	    function clearImmediate(handle) {
	        delete tasksByHandle[handle];
	    }
	
	    function run(task) {
	        var callback = task.callback;
	        var args = task.args;
	        switch (args.length) {
	        case 0:
	            callback();
	            break;
	        case 1:
	            callback(args[0]);
	            break;
	        case 2:
	            callback(args[0], args[1]);
	            break;
	        case 3:
	            callback(args[0], args[1], args[2]);
	            break;
	        default:
	            callback.apply(undefined, args);
	            break;
	        }
	    }
	
	    function runIfPresent(handle) {
	        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
	        // So if we're currently running a task, we'll need to delay this invocation.
	        if (currentlyRunningATask) {
	            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
	            // "too much recursion" error.
	            setTimeout(runIfPresent, 0, handle);
	        } else {
	            var task = tasksByHandle[handle];
	            if (task) {
	                currentlyRunningATask = true;
	                try {
	                    run(task);
	                } finally {
	                    clearImmediate(handle);
	                    currentlyRunningATask = false;
	                }
	            }
	        }
	    }
	
	    function installNextTickImplementation() {
	        registerImmediate = function(handle) {
	            process.nextTick(function () { runIfPresent(handle); });
	        };
	    }
	
	    function canUsePostMessage() {
	        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
	        // where `global.postMessage` means something completely different and can't be used for this purpose.
	        if (global.postMessage && !global.importScripts) {
	            var postMessageIsAsynchronous = true;
	            var oldOnMessage = global.onmessage;
	            global.onmessage = function() {
	                postMessageIsAsynchronous = false;
	            };
	            global.postMessage("", "*");
	            global.onmessage = oldOnMessage;
	            return postMessageIsAsynchronous;
	        }
	    }
	
	    function installPostMessageImplementation() {
	        // Installs an event handler on `global` for the `message` event: see
	        // * https://developer.mozilla.org/en/DOM/window.postMessage
	        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages
	
	        var messagePrefix = "setImmediate$" + Math.random() + "$";
	        var onGlobalMessage = function(event) {
	            if (event.source === global &&
	                typeof event.data === "string" &&
	                event.data.indexOf(messagePrefix) === 0) {
	                runIfPresent(+event.data.slice(messagePrefix.length));
	            }
	        };
	
	        if (global.addEventListener) {
	            global.addEventListener("message", onGlobalMessage, false);
	        } else {
	            global.attachEvent("onmessage", onGlobalMessage);
	        }
	
	        registerImmediate = function(handle) {
	            global.postMessage(messagePrefix + handle, "*");
	        };
	    }
	
	    function installMessageChannelImplementation() {
	        var channel = new MessageChannel();
	        channel.port1.onmessage = function(event) {
	            var handle = event.data;
	            runIfPresent(handle);
	        };
	
	        registerImmediate = function(handle) {
	            channel.port2.postMessage(handle);
	        };
	    }
	
	    function installReadyStateChangeImplementation() {
	        var html = doc.documentElement;
	        registerImmediate = function(handle) {
	            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
	            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
	            var script = doc.createElement("script");
	            script.onreadystatechange = function () {
	                runIfPresent(handle);
	                script.onreadystatechange = null;
	                html.removeChild(script);
	                script = null;
	            };
	            html.appendChild(script);
	        };
	    }
	
	    function installSetTimeoutImplementation() {
	        registerImmediate = function(handle) {
	            setTimeout(runIfPresent, 0, handle);
	        };
	    }
	
	    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
	    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
	    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;
	
	    // Don't get fooled by e.g. browserify environments.
	    if ({}.toString.call(global.process) === "[object process]") {
	        // For Node.js before 0.9
	        installNextTickImplementation();
	
	    } else if (canUsePostMessage()) {
	        // For non-IE10 modern browsers
	        installPostMessageImplementation();
	
	    } else if (global.MessageChannel) {
	        // For web workers, where supported
	        installMessageChannelImplementation();
	
	    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
	        // For IE 6–8
	        installReadyStateChangeImplementation();
	
	    } else {
	        // For older browsers
	        installSetTimeoutImplementation();
	    }
	
	    attachTo.setImmediate = setImmediate;
	    attachTo.clearImmediate = clearImmediate;
	}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(188)))

/***/ }),
/* 295 */
/***/ (function(module, exports) {

	function getENV() {
	  // make sure the script not throwing error under nodejs.
	  var win  = typeof window !== 'undefined'    ? window              : {};
	  var href = typeof location !== 'undefined'  ? location.href       : '';
	  var ua   = typeof navigator !== 'undefined' ? navigator.userAgent : '';
	  var is_stupid_ios = /ios|iphone|ipad|ipod/i.test(ua); // iOS下UA非常不可靠
	
	  //优先加载自定义环境
	  if (!!win._KNB_CUSTOM_ENV) {
	    return {
	      isWX: !!win._KNB_WX,
	      isMTNB: !!win._KNB_MTNB,
	      isTitans: !!win._KNB_TITANS,
	      isHBNB: !!win._KNB_HBNB,
	      isDPApp: !!win._KNB_DPAPP
	    }
	  }
	
	  var regDP = win._KNB_REGDP || /dp\/com\.dianping\.[\w\.]+\/([\d\.]+)/i;
	  var regMT = win._KNB_REGMT || /moviepro|MTNB|Meituan|MOMA/i;
	  var regHB = win._KNB_REGHB || /iHotel|HBNB/i;
	  var regWX = win._KNB_REGWX || /micromessenger/i;
	  var regTitans = win._KNB_REGTITANS || /TitansX/i;
	
	  var isWX     = regWX.test(ua);
	  var isDPApp  = regDP.test(ua);
	  var isMTNB   = regMT.test(ua) || /f=(iphone|ipad|ipod|android)/.test(href);
	  var isHBNB   = regHB.test(ua) && !win._MTNB;
	  var isTitans = function() {
	    if (href.indexOf('knb_force_use_titans') > -1) return true;
	    if (is_stupid_ios) return !!win._TitansX;
	    return regTitans.test(ua);
	  }();
	
	  var isMiniProgramWebview = win.__wxjs_environment === 'miniprogram';
	
	  var isNative = isDPApp || isHBNB || isTitans || regMT.test(ua) || isMiniProgramWebview;
	  //TitansNoX和点评包名的优先级高于其他，修复点评下引入美团实现的bug
	  if (/titansnox/i.test(ua) && isDPApp) {
	    isTitans = isHBNB = isWX = isMTNB = false;
	  } 
	  // order matters
	  if (isWX)     { isTitans = isHBNB = isDPApp = isMTNB = false; }
	  if (isTitans) { isDPApp  = isWX   = isMTNB  = isHBNB = false; }
	  if (isHBNB)   { isTitans = isWX   = isDPApp = isMTNB = false; }
	  if (isMTNB)   { isTitans = isWX   = isDPApp = isHBNB = false; }
	  if (isDPApp)  { isTitans = isWX   = isMTNB  = isHBNB = false; }
	
	  return {
	    isWX: isWX,
	    isTitans: isTitans,
	    isHBNB: isHBNB,
	    isDPApp: isDPApp,
	    isMTNB: isMTNB,
	    isNative: isNative,
	    isMiniProgramWebview: isMiniProgramWebview,
	  };
	}
	
	module.exports = getENV();
	module.exports.getENV = getENV;  // make it testable


/***/ }),
/* 296 */
/***/ (function(module, exports, __webpack_require__) {

	/**********
	 * KNB for dianping webview
	 * version 1.0
	 *********/
	
	var DPApp = __webpack_require__(297);
	var apiDPApp = __webpack_require__(340);
	var shareConst = __webpack_require__(341);
	var logEvent = __webpack_require__(342);
	var promisify = __webpack_require__(291);
	var version = __webpack_require__(286);
	var Titans = __webpack_require__(344);
	var mixin = __webpack_require__(285);
	var isWebProtocol = __webpack_require__(352);
	var qs = __webpack_require__(288);
	var semver = __webpack_require__(354);
	var picConverter = __webpack_require__(353);
	
	var KNB = {
	  __version__: version,
	
	  ready: function(cb) {
	    DPApp.ready(cb);
	  },
	
	  config: function(opts) {
	    DPApp.config(opts);
	
	    //titan的任务不会被native主动释放，导致titans方法会延迟很多发送
	    //修改延迟时间为50ms
	    if (opts)  {
	      opts.delay = opts.delay || 50;
	    }
	    Titans.config(opts);
	  },
	
	  isApiSupported: function(opts) {
	    var isSupport;
	    if (this[opts.apiName] instanceof Function) {
	      isSupport = true;
	    }else{
	      isSupport = DPApp.isSupport(opts.apiName);
	    }
	    if (navigator.userAgent.indexOf('TitansX') > -1) return Titans.isApiSupported(opts);
	    opts.success(isSupport);
	  },
	
	  getUserInfo: function(opts) {
	    var success = opts.success;
	    opts.success = function(user) {
	      success({
	        type: 'dp',
	        userId: user.userId,
	        uuid: user.dpid,
	        token: user.token
	      });
	    };
	    DPApp.getUserInfo(opts);
	  },
	
	  login: function(opts) {
	    var success = opts.success;
	    opts.success = function(user) {
	      success({
	        type: 'dp',
	        userId: user.userId,
	        token: user.token
	      });
	    };
	    DPApp.login(opts);
	  },
	
	  getFingerprint: function(opts) {
	    var success = opts.success;
	    opts.success = function(ret) {
	      var fp = '';
	      try {
	        fp = JSON.parse(ret.fingerprint).fingerprint;
	      }catch (ex){
	        fp = ret.fingerprint;
	      }
	      success({
	        fingerprint: fp
	      });
	    };
	    DPApp.getCX(opts);
	  },
	
	  getCity: function(opts) {
	    var success = opts.success;
	    opts.success = function(city) {
	      success({
	        type: 'dp',
	        cityId: city.cityId
	      });
	    };
	    DPApp.getCity(opts);
	  },
	
	  getLocationCity: function(opts) {
	    var success = opts.success;
	    opts.success = function(city) {
	      success({
	        type: 'dp',
	        cityId: city.locCityId
	      });
	    };
	    DPApp.getCity(opts);
	  },
	
	  openWebview: function(opts) {
	    opts = mixin({}, opts);
	    if (isWebProtocol(opts.url)) opts.url = 'dianping://web?' + qs.stringify(mixin({url: opts.url}, opts.qs));
	    DPApp.openScheme(opts);
	  },
	
	  jumpWebview: function(opts) {
	    opts = mixin({}, opts);
	    if (isWebProtocol(opts.url)) opts.url = 'dianping://web?' + qs.stringify(mixin({url: opts.url}, opts.qs));
	    DPApp.jumpToScheme(opts);
	  },
	
	  closeWebview: function(opts) {
	    DPApp.closeWindow(opts);
	  },
	
	  share: function(opts) {
	    // TODO: parse channel
	
	    opts = mixin({}, opts);
	    opts.feed = opts.channel;
	    if (!(opts.feed instanceof Array)) {
	      opts.feed = [opts.feed];
	    }
	    if (opts.feed && opts.feed.length === 1) {
	      opts.shareType = opts.feed[0];
	    }
	
	    // get sharedTo
	    var originSuccess = opts.success;
	    opts.success = function(res) {
	      opts.sharedTo = {};
	      Object.keys(shareConst).forEach(function (ele, i) {
	        opts.sharedTo[ele] = (i === res.channel)
	      })
	      originSuccess(opts);
	    }
	    DPApp.share(opts);
	  },
	
	  configShare: function(opts) {
	    var self = this;
	    opts = mixin({}, opts);
	    DPApp.setRRButton({
	      icon: 'H5_Share',
	      handle: function() {
	        opts.handle && opts.handle();
	        self.share(opts);
	      }
	    });
	  },
	
	  setNavButtons: function(opts) {
	    if (!(opts instanceof Array)) {
	      opts = [opts];
	    }
	    opts.forEach(function(btnConfig) {
	      var method =  'set'+ btnConfig.position + 'Button';
	      delete btnConfig.position;
	      if (btnConfig.type === 'base64') {
	        try{
	          btnConfig.icon = btnConfig.icon.split('data:image/png;base64,')[1];
	        }catch(e){
	          console.log('get base64 icon failed');
	        }
	      }
	      DPApp[method](btnConfig);
	    });
	  },
	
	  setLLButton: function(opts) {
	    opts = mixin({}, opts);
	    if (/^data:image\/png;base64/.test(opts.icon)) {
	      try {
	        opts.icon = opts.icon.split('data:image/png;base64,')[1];
	      } catch (e) {
	        console.log('get base64 icon failed');
	      }
	    }
	
	    DPApp.setLLButton(opts);
	  },
	
	  uploadImage: function (opts) {
	    opts = mixin({}, opts);
	    var success = opts.success || function () {};
	    opts.success = function (ret) {
	      ret.photoInfos = (ret.photoInfos || []).map(function (photo) {
	        return mixin({}, photo, {picKey: picConverter(photo.picKey), originalKey: photo.picKey})
	      });
	      success(ret);
	    }
	    DPApp.uploadImage(opts)
	  },
	
	  getUA: __webpack_require__(287),
	
	  use: function(name, opts) {
	    if (DPApp[name] instanceof Function) {
	      return DPApp[name](opts);
	    }
	    return Titans.use(name, opts);
	  }
	};
	
	(function() {
	  for (var key in shareConst) {
	    KNB.share[key] = shareConst[key];
	  }
	})();
	
	(function commonFnMap(commonAPI) {
	  commonAPI.forEach(function(api) {
	    //没有单独实现的API统一生成
	    if (!KNB[api]) {
	      if (typeof(api) == 'string') {
	        KNB[api] = DPApp[api];
	      }else{
	        //API接口变更的处理
	        var key = Object.keys(api)[0];
	        KNB[key] = function() {
	          DPApp[api[key]](arguments[0]);
	        };
	      }
	    }
	  });
	})(apiDPApp);
	
	//新增api由Titans提供支持
	['subscribe', 'unsubscribe', 'publish',
	 'getNetworkType','remove', 'pureUse',
	 'checkAuthorization', 'pickContact',
	 'setResult', 'getApisVersion', 'scanQRCode',
	 'autoLock', 'toast', 'vibrate', 'actionSheet',
	 'setSearchBar', 'shark', 'shareImage', 'capture', 
	 'setImageTitle', 'getResult', 'getDeviceInfo',
	 'chooseMedia', 'playMedia', 'editMedia', 'uploadMedia'].forEach(function (api) {
	  KNB[api] = Titans[api].bind(Titans);
	});
	
	KNB.Semver = semver;
	
	var ua = KNB.getUA.internal();
	var appVersion = ua.appVersion;
	if (semver.gte(appVersion, '9.1.2')) KNB.lxlog = Titans.lxlog.bind(Titans);
	if (semver.gte(appVersion, '9.3.0')) KNB.shark = Titans.shark.bind(Titans);
	
	//被引用统计
	logEvent('dpapp', KNB.__version__);
	
	promisify(KNB);
	
	module.exports = KNB;


/***/ }),
/* 297 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	(function (Host) {
	  var core = __webpack_require__(298);
	  var util = __webpack_require__(317);
	  var apis = __webpack_require__(318);
	
	  __webpack_require__(319);
	  
	  var patchVersion = function(version, patch) {
	    if (core.Semver.gte(util.appVersion, version)) {
	        core.patchForType(util.appVersion, patch);
	    }
	  };
	
	  patchVersion('7.0.0', __webpack_require__(320));
	  patchVersion('7.1.0', __webpack_require__(321));
	  patchVersion('7.2.0', __webpack_require__(322));
	  patchVersion('7.5.0', __webpack_require__(323));
	  patchVersion('7.6.0', __webpack_require__(324));
	  patchVersion('7.8.0', __webpack_require__(325));
	  patchVersion('7.9.1', __webpack_require__(326));
	  patchVersion('7.9.2', __webpack_require__(328));
	  patchVersion('7.9.4', __webpack_require__(329));
	  patchVersion('7.9.6', __webpack_require__(330));
	  patchVersion('8.0.0', __webpack_require__(331));
	  patchVersion('8.0.4', __webpack_require__(332));
	  patchVersion('8.0.6', __webpack_require__(333));
	  patchVersion('8.1.0', __webpack_require__(334));
	  patchVersion('8.1.2', __webpack_require__(335));
	  patchVersion('8.1.4', __webpack_require__(336));
	  patchVersion('8.1.6', __webpack_require__(337));
	
	  core.apis = apis;
	  core.decorate();
	
	  apis.forEach(function (api) {
	    if (!core[api]) {
	      core[api] = core._notImplemented;
	    }
	  });
	
	  core.__version__ = __webpack_require__(338);
	  core.__type__ = __webpack_require__(339);
	  // Export DPApp object, if support AMD, CMD, CommonJS.
	  if (true) {
	    module.exports = core;
	  }
	  // Export DPApp object to Host
	  if (typeof Host !== 'undefined') {
	    if(Host.DPApp){
	      Host.DPApp = core.merge(Host.DPApp, core);
	    }else{
	      Host.DPApp = core;
	    }
	  }
	
	}(window));

/***/ }),
/* 298 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var Core = __webpack_require__(299);
	var mixin = __webpack_require__(316);
	var util = __webpack_require__(317);
	
	var NOOP = function(){};
	
	var core = module.exports = new Core({
	  hippoPrefix:'dpapp',
	  getTypeFromUA: util.getWebviewVersion,
	  apis: [],
	  allowBeforeReady: ['getRequestId'],
	  isOldVersion: function(){
	    return this.uaType() == '6.9.x';
	  },
	  cache: {},
	  Share: {
	    WECHAT_FRIENDS: 0,
	    WECHAT_TIMELINE: 1,
	    QQ: 2,
	    SMS: 3,
	    WEIBO: 4,
	    QZONE: 5,
	    EMAIL: 6,
	    COPY: 7
	  },
	  _tidyUrlParams: function(url){
	    var splited = url.split('?');
	    var qs = splited[1];
	    var reserved = [];
	    if(!qs){
	      return splited[0];
	    }else{
	      qs.split('&').forEach(function(q){
	        var k = q.split('=')[0];
	        if(!/^(newtoken|token|product)$/.test(k) ){
	          reserved.push(q);
	        }
	      });
	      return [splited[0], reserved.join('&')].join('?');
	    }
	  },
	  _getEnv : function(callback) {
	    var self = this;
	    this._doSendMessage('getEnv', {}, function(env){
	      self.cache['env'] = env;
	      callback.call(this, env);
	    });
	  },
	  _captal: function(str) {
	    return str.slice(0, 1).toUpperCase() + str.slice(1);
	  },
	  _getBizName: function(opt) {
	    var fail = opt.fail;
	    var bizname = this._cfg.bizname;
	    if (!bizname) {
	      fail && fail('use `DPApp.config({bizname:"<your-bizname>"})` first');
	      return false;
	    } else {
	      return bizname;
	    }
	  },
	  isStatusOK : NOOP,
	  did_handle_callback : NOOP, 
	  _doSendMessage: function (method, args, callback) {
	    var self = this;
	    var hasCallback = callback && typeof callback == 'function';
	    this.log('调用方法', method, args);
	
	    /**
	     * pass 0 as callbackId
	     * thus _callbacks[callbackId] is undefined
	     * nothing will happen
	     * @type {Number}
	     */
	    var callbackId = hasCallback ? this._generateCallbackId() : 0;
	    var callbackName = this._generateCallbackName(callbackId);
	    
	    if (hasCallback){
	      window[callbackName] = callback;
	    }
	
	    /**
	     * check type for args
	     */
	    if(!args || typeof args !== 'object'){
	      args = {};
	    }
	
	    // 某些版本app很任性的把callbackId参数放到args里了
	    args.callbackId = callbackId;
	    args = JSON.stringify(args);
	
	    var _DPApp = window._DPApp;
	
	    var bridgeUrl = 'js://_?method=' + method + '&args=' + encodeURIComponent(args) + '&callbackId=' + callbackId;
	    
	    this._sendMessage2Native(bridgeUrl); 
	  },
	  _sendByPrompt: function(message) {
	    this.log('[Prompt] message: ' +message);
	    window.prompt(message);
	  },
	  _sendByIframe: function(message) {
	    this.log('[Iframe] message: ' + message);
	    this._createIframe(message);
	  },
	  _sendMessage2Native: function(message) {
	    var SUPPORTVERSION = '8.0.6';
	    if (this.Semver.gte(util.appVersion, SUPPORTVERSION) && util.osName === 'android') {
	      this._sendByPrompt(message);
	    }else{
	      this._sendByIframe(message);
	    }
	  },
	  _send: function(method, args){
	    args = args || {};
	    var self = this;
	    var _success = args.success;
	    var _fail = args.fail;
	    var _handle = args.handle;
	
	    var fail = function(result){
	      self.log('调用失败 ' + method, result);
	      _fail && _fail.call(self, result);
	    }
	
	    var success = function(result){
	      self.log('调用成功 ' + method, result);
	      _success && _success.call(self, result);
	    }
	
	    var handle = function(result){
	      self.log('回调 ' + method, result);
	      _handle && _handle.call(self, result);
	    }
	
	    var callback = (_success || _fail || _handle) ? function(result){
	      var status = result.status;
	
	      if(result.result != "next"){
	        delete result.result;
	      }
	      if(status == "success"){
	        success && success(result);
	      }else if(status == "action"){
	        handle && handle(result);
	      }else{
	        fail && fail(result);
	      }
	    } : null;
	    this._sendMessage(method, args, callback);
	  },
	  callback: function(callbackId, retValue){
	    var win = window;
	    var callbackFuncName = this._generateCallbackName(callbackId);
	    var callback = window[callbackFuncName];
	
	    if(callback){
	      this.log("[Callback] Id: " + callbackId);
	      setTimeout(function(){
	        callback && callback.call(self,retValue);
	      });
	      if(retValue.result == "complete" || retValue.result == "error"){
	        win[callbackFuncName] = null;
	        delete win[callbackFuncName];
	      }
	    }
	  },
	  merge: function(core, newCore) {
	    if (core.__type__ === 'npm' || core.__type__ === 'cortex') {
	      console.warn('引入了多个DPApp,目前DPApp版本是',core.__version__,', 后续引入的DPApp无法生效');
	      return core;
	    }else{
	      console.warn('引入了多个DPApp,正在进行mixin形式的合并');
	      return mixin(core, newCore);
	    }
	  }
	});

/***/ }),
/* 299 */
/***/ (function(module, exports, __webpack_require__) {

	var Core = __webpack_require__(300);
	var NativeCore = __webpack_require__(313);
	var Network = __webpack_require__(315);
	var Promise = __webpack_require__(303);
	
	Core.prototype._mixin(Core.prototype, NativeCore);
	Core.prototype._mixin(Core.prototype, Network);
	Core.prototype.all = function(list){
		return Promise.all(list);
	};
	module.exports = Core;

/***/ }),
/* 300 */
/***/ (function(module, exports, __webpack_require__) {

	function mixin(to, from) {
	  for (var key in from) {
	    to[key] = from[key];
	  }
	  return to;
	}
	
	var Core = module.exports = function(options){
	  options = options || {};
	  var self = this;
	  for(var key in options){
	    this[key] = options[key];
	  }
	
	
	  var apis = options.apis || __webpack_require__(301);
	  (options.extraApis || []).forEach(function(name){
	    if(apis.indexOf(name) === -1){
	      apis.push(name);
	    }
	  });
	
	  this.apis = apis;
	  this.allowBeforeReady = this.allowBeforeReady || ["getRequestId"];
	
	
	  apis.forEach(function(name) {
	    if(!self[name]){
	      self[name] = function(options) {
	        self._send(name, options);
	      }
	    }
	  });
	
	  this.decorate();
	};
	
	Core.prototype = {
	  _cfg: {
	    debug: false
	  },
	  _isProduct: !!location.href.match(".dianping.com"),
	  _isReady: false,
	  config: function(config) {
	    for(var key in config){
	      this._cfg[key] = config[key];
	    }
	  },
	  /**
	   * 是否为古早版本
	   */
	  isOldVersion: function(){
	    return false;
	  },
	  getQuery: function (){
	    var query = location.search.slice(1);
	    var ret = {};
	    query.split("&").forEach(function(pair){
	      var splited = pair.split("=");
	      ret[splited[0]] = splited[1];
	    });
	    return ret;
	  },
	  patchForType: function(version, patch){
	    if(this.uaType() == version){
	      this.extend(patch);
	      this.decorate();
	    }
	  },
	  decorate: __webpack_require__(302),
	  Semver: {
	    eq: function(a, b) {
	      return a === b;
	    },
	    gt: function(a, b) {
	      var splitedA = a ? a.split(".") : [];
	      var splitedB = b ? b.split(".") : [];
	      [0,1,2].forEach(function(i){
	        splitedA[i] = splitedA[i] || 0;
	        splitedB[i] = splitedB[i] || 0;
	      });
	      if (+splitedA[0] !== +splitedB[0]) {
	        return +splitedA[0] > +splitedB[0];
	      } else {
	        if (+splitedA[1] !== +splitedB[1]) {
	          return +splitedA[1] > +splitedB[1];
	        } else {
	          return +splitedA[2] > +(splitedB[2] || 0);
	        }
	      }
	    },
	    lt: function(a, b) {
	      return !this.gte(a, b);
	    },
	    gte: function(a, b) {
	      return this.eq(a, b) || this.gt(a, b);
	    },
	    lte: function(a, b) {
	      return this.eq(a, b) || this.lt(a, b);
	    }
	  },
	  _parseUA: function(ua){
	    var osName, osVersion, versionMatch;
	    if (ua.match(/iPhone/)) {
	      osName = "iphone";
	      osVersion = ua.match(/iPhone\sOS\s([\d_]+)/i)[1].replace(/_/g, ".");
	    } else if (ua.match(/Android/)) {
	      osName = "android";
	      versionMatch = ua.match(/Android[\s|\/]([\w\.]+)/);
	      osVersion = versionMatch && versionMatch[1];
	    } else {
	      osName = null;
	      osVersion = null;
	    }
	    return {
	      name: osName,
	      version: osVersion
	    }
	  },
	  getTypeFromUA: function(userAgent){
	    return /dp\/com\.dianping\.(\w+)\//.test(userAgent)
	      ? userAgent.match(/dp\/com\.dianping\.(\w+)\//)[1]
	      : "web"
	  },
	  uaType: function(){
	    return this.getTypeFromUA(navigator.userAgent);
	  },
	  _trace: function(name, params){
	    if(!this.hippoPrefix){return;}
	    var logFact = (this._cfg && this._cfg.logFact) || 0.05;
	    params = params || {};
	    params = this._mixin(params, {
	      module: this.hippoPrefix + "_" + name
	    });
	    if(Math.random() < logFact){
	      console.log("_trace", name)
	      window._hip && _hip.push(['mv', params]);
	    }
	  },
	  log: function() {
	
	    var message = [];
	    for(var i=0; i < arguments.length; i++){
	      if(typeof arguments[i] == "string"){
	        message.push(arguments[i]);
	      }else if(arguments[i] != undefined){
	        message.push(JSON.stringify(arguments[i]));
	      }
	    }
	
	    message = message.join(" ");
	    if (this._cfg && this._cfg.debug) {
	      setTimeout(function(){
	        alert(message);
	      });
	    }else{
	      console.log(message);
	    }
	  },
	  _mixin: mixin,
	  extend: function(args) {
	    return this._mixin(this, args);
	  },
	  _notImplemented: function notImplemented(opt) {
	    opt && opt.fail && opt.fail({
	      errMsg:"ERR_NOT_IMPLEMENTED"
	    });
	  },
	  isSupport: function(funcName) {
	    var api = this[funcName];
	    return !!(api
	      && typeof api == "function"
	      && api != this._notImplemented
	      && api._notReady != true)
	  }
	};
	
	Core.prototype._osUA = Core.prototype._parseUA(navigator.userAgent);

/***/ }),
/* 301 */
/***/ (function(module, exports) {

	module.exports = [
	  "getVersion", "getNetworkType", "getContactList", "pickContact",
	  "getRequestId", "getDeviceInfo", "clearStorage", "store", "retrieve", "publish", "subscribe", "unsubscribe", "openScheme", "jumpToScheme", "closeWindow", "sendSMS",
	  "downloadImage", "setBackgroundColor", "setTitle", "setLLButton", "setLRButton", "setRLButton", "setRRButton", "isInstalledApp",
	  "alert", "prompt", "confirm", "actionSheet"
	];

/***/ }),
/* 302 */
/***/ (function(module, exports, __webpack_require__) {

	var Promise = __webpack_require__(303);
	
	module.exports = function (allowBeforeReady){
	  var target = this;
	  var apis = this.apis;
	  var allowBeforeReady = this.allowBeforeReady;
	
	  apis.forEach(function(name){
	    if(!target[name]){
	      target[name] = target._notImplemented;
	    }
	  });
	
	  apis.forEach(function(api){
	    var _origin = target[api];
	    if(target[api] && target[api]._decorated){
	      return;
	    }
	    target[api] = function(args){
	      var _args = target._mixin({}, args);
	      target._trace(api + "_call");
	      var _success = _args.success;
	      var _fail = _args.fail;
	      var _wrapped_fail = function(result){
	        if(!_fail){
	          if(target.onerror){
	            target.onerror({
	              api: api,
	              err: result
	            });
	          }else{
	            var errorMessage = result.errMsg ? result.errMsg : JSON.stringify(result);
	            var err = new Error(errorMessage);
	            err.name = "DPAppError";
	            console.warn("`DPApp." + api + "` call faild");
	            target._trace('throw');
	            console.warn(new Error(err));
	          }
	        }else{
	          _fail(result);
	        }
	      }
	      var zero = +new Date;
	      _args.success = function(result){
	        target._trace(api + "_success", {
	          time: +new Date - zero,
	        });
	        _success && _success(result);
	      };
	      _args.fail = function(result){
	        var note = {};
	        note.args = args;
	        note.result = result;
	        target._trace(api + "_fail", {
	          time: +new Date - zero,
	          note: JSON.stringify(note)
	        });
	        _wrapped_fail(result);
	      }
	
	      if(!this._isReady
	        && allowBeforeReady.indexOf(api) === -1
	        && !target._isProduct // 非正式环境
	        && target.isOldVersion() // 且非新版本，为了判断环境，必须wrap在DPApp.ready中
	      ){
	        _wrapped_fail("use `DPApp.ready(fn)` to wrap api calls");
	        return;
	      }
	
	      return new Promise(function(resolve, reject){
	        var origin_success = _args.success;
	        var origin_fail = _args.fail;
	        var success = function(result){
	          origin_success(result);
	          resolve(result);
	        }
	        var fail = function(result){
	          origin_fail(result);
	          if(!_fail){
	            reject(result);
	          }
	        }
	        _args.success = success;
	        _args.fail = fail;
	        _origin.call(target, _args);
	      });
	    }
	    target[api]._decorated = true;
	    target[api]._notReady = _origin == target._notImplemented;
	
	  });
	}

/***/ }),
/* 303 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(304)


/***/ }),
/* 304 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(305);
	__webpack_require__(307);
	__webpack_require__(308);
	__webpack_require__(309);
	__webpack_require__(310);
	__webpack_require__(312);


/***/ }),
/* 305 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var asap = __webpack_require__(306);
	
	function noop() {}
	
	// States:
	//
	// 0 - pending
	// 1 - fulfilled with _value
	// 2 - rejected with _value
	// 3 - adopted the state of another promise, _value
	//
	// once the state is no longer pending (0) it is immutable
	
	// All `_` prefixed properties will be reduced to `_{random number}`
	// at build time to obfuscate them and discourage their use.
	// We don't use symbols or Object.defineProperty to fully hide them
	// because the performance isn't good enough.
	
	
	// to avoid using try/catch inside critical functions, we
	// extract them to here.
	var LAST_ERROR = null;
	var IS_ERROR = {};
	function getThen(obj) {
	  try {
	    return obj.then;
	  } catch (ex) {
	    LAST_ERROR = ex;
	    return IS_ERROR;
	  }
	}
	
	function tryCallOne(fn, a) {
	  try {
	    return fn(a);
	  } catch (ex) {
	    LAST_ERROR = ex;
	    return IS_ERROR;
	  }
	}
	function tryCallTwo(fn, a, b) {
	  try {
	    fn(a, b);
	  } catch (ex) {
	    LAST_ERROR = ex;
	    return IS_ERROR;
	  }
	}
	
	module.exports = Promise;
	
	function Promise(fn) {
	  if (typeof this !== 'object') {
	    throw new TypeError('Promises must be constructed via new');
	  }
	  if (typeof fn !== 'function') {
	    throw new TypeError('Promise constructor\'s argument is not a function');
	  }
	  this._40 = 0;
	  this._65 = 0;
	  this._55 = null;
	  this._72 = null;
	  if (fn === noop) return;
	  doResolve(fn, this);
	}
	Promise._37 = null;
	Promise._87 = null;
	Promise._61 = noop;
	
	Promise.prototype.then = function(onFulfilled, onRejected) {
	  if (this.constructor !== Promise) {
	    return safeThen(this, onFulfilled, onRejected);
	  }
	  var res = new Promise(noop);
	  handle(this, new Handler(onFulfilled, onRejected, res));
	  return res;
	};
	
	function safeThen(self, onFulfilled, onRejected) {
	  return new self.constructor(function (resolve, reject) {
	    var res = new Promise(noop);
	    res.then(resolve, reject);
	    handle(self, new Handler(onFulfilled, onRejected, res));
	  });
	}
	function handle(self, deferred) {
	  while (self._65 === 3) {
	    self = self._55;
	  }
	  if (Promise._37) {
	    Promise._37(self);
	  }
	  if (self._65 === 0) {
	    if (self._40 === 0) {
	      self._40 = 1;
	      self._72 = deferred;
	      return;
	    }
	    if (self._40 === 1) {
	      self._40 = 2;
	      self._72 = [self._72, deferred];
	      return;
	    }
	    self._72.push(deferred);
	    return;
	  }
	  handleResolved(self, deferred);
	}
	
	function handleResolved(self, deferred) {
	  asap(function() {
	    var cb = self._65 === 1 ? deferred.onFulfilled : deferred.onRejected;
	    if (cb === null) {
	      if (self._65 === 1) {
	        resolve(deferred.promise, self._55);
	      } else {
	        reject(deferred.promise, self._55);
	      }
	      return;
	    }
	    var ret = tryCallOne(cb, self._55);
	    if (ret === IS_ERROR) {
	      reject(deferred.promise, LAST_ERROR);
	    } else {
	      resolve(deferred.promise, ret);
	    }
	  });
	}
	function resolve(self, newValue) {
	  // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
	  if (newValue === self) {
	    return reject(
	      self,
	      new TypeError('A promise cannot be resolved with itself.')
	    );
	  }
	  if (
	    newValue &&
	    (typeof newValue === 'object' || typeof newValue === 'function')
	  ) {
	    var then = getThen(newValue);
	    if (then === IS_ERROR) {
	      return reject(self, LAST_ERROR);
	    }
	    if (
	      then === self.then &&
	      newValue instanceof Promise
	    ) {
	      self._65 = 3;
	      self._55 = newValue;
	      finale(self);
	      return;
	    } else if (typeof then === 'function') {
	      doResolve(then.bind(newValue), self);
	      return;
	    }
	  }
	  self._65 = 1;
	  self._55 = newValue;
	  finale(self);
	}
	
	function reject(self, newValue) {
	  self._65 = 2;
	  self._55 = newValue;
	  if (Promise._87) {
	    Promise._87(self, newValue);
	  }
	  finale(self);
	}
	function finale(self) {
	  if (self._40 === 1) {
	    handle(self, self._72);
	    self._72 = null;
	  }
	  if (self._40 === 2) {
	    for (var i = 0; i < self._72.length; i++) {
	      handle(self, self._72[i]);
	    }
	    self._72 = null;
	  }
	}
	
	function Handler(onFulfilled, onRejected, promise){
	  this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
	  this.onRejected = typeof onRejected === 'function' ? onRejected : null;
	  this.promise = promise;
	}
	
	/**
	 * Take a potentially misbehaving resolver function and make sure
	 * onFulfilled and onRejected are only called once.
	 *
	 * Makes no guarantees about asynchrony.
	 */
	function doResolve(fn, promise) {
	  var done = false;
	  var res = tryCallTwo(fn, function (value) {
	    if (done) return;
	    done = true;
	    resolve(promise, value);
	  }, function (reason) {
	    if (done) return;
	    done = true;
	    reject(promise, reason);
	  });
	  if (!done && res === IS_ERROR) {
	    done = true;
	    reject(promise, LAST_ERROR);
	  }
	}


/***/ }),
/* 306 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {"use strict";
	
	// Use the fastest means possible to execute a task in its own turn, with
	// priority over other events including IO, animation, reflow, and redraw
	// events in browsers.
	//
	// An exception thrown by a task will permanently interrupt the processing of
	// subsequent tasks. The higher level `asap` function ensures that if an
	// exception is thrown by a task, that the task queue will continue flushing as
	// soon as possible, but if you use `rawAsap` directly, you are responsible to
	// either ensure that no exceptions are thrown from your task, or to manually
	// call `rawAsap.requestFlush` if an exception is thrown.
	module.exports = rawAsap;
	function rawAsap(task) {
	    if (!queue.length) {
	        requestFlush();
	        flushing = true;
	    }
	    // Equivalent to push, but avoids a function call.
	    queue[queue.length] = task;
	}
	
	var queue = [];
	// Once a flush has been requested, no further calls to `requestFlush` are
	// necessary until the next `flush` completes.
	var flushing = false;
	// `requestFlush` is an implementation-specific method that attempts to kick
	// off a `flush` event as quickly as possible. `flush` will attempt to exhaust
	// the event queue before yielding to the browser's own event loop.
	var requestFlush;
	// The position of the next task to execute in the task queue. This is
	// preserved between calls to `flush` so that it can be resumed if
	// a task throws an exception.
	var index = 0;
	// If a task schedules additional tasks recursively, the task queue can grow
	// unbounded. To prevent memory exhaustion, the task queue will periodically
	// truncate already-completed tasks.
	var capacity = 1024;
	
	// The flush function processes all tasks that have been scheduled with
	// `rawAsap` unless and until one of those tasks throws an exception.
	// If a task throws an exception, `flush` ensures that its state will remain
	// consistent and will resume where it left off when called again.
	// However, `flush` does not make any arrangements to be called again if an
	// exception is thrown.
	function flush() {
	    while (index < queue.length) {
	        var currentIndex = index;
	        // Advance the index before calling the task. This ensures that we will
	        // begin flushing on the next task the task throws an error.
	        index = index + 1;
	        queue[currentIndex].call();
	        // Prevent leaking memory for long chains of recursive calls to `asap`.
	        // If we call `asap` within tasks scheduled by `asap`, the queue will
	        // grow, but to avoid an O(n) walk for every task we execute, we don't
	        // shift tasks off the queue after they have been executed.
	        // Instead, we periodically shift 1024 tasks off the queue.
	        if (index > capacity) {
	            // Manually shift all values starting at the index back to the
	            // beginning of the queue.
	            for (var scan = 0, newLength = queue.length - index; scan < newLength; scan++) {
	                queue[scan] = queue[scan + index];
	            }
	            queue.length -= index;
	            index = 0;
	        }
	    }
	    queue.length = 0;
	    index = 0;
	    flushing = false;
	}
	
	// `requestFlush` is implemented using a strategy based on data collected from
	// every available SauceLabs Selenium web driver worker at time of writing.
	// https://docs.google.com/spreadsheets/d/1mG-5UYGup5qxGdEMWkhP6BWCz053NUb2E1QoUTU16uA/edit#gid=783724593
	
	// Safari 6 and 6.1 for desktop, iPad, and iPhone are the only browsers that
	// have WebKitMutationObserver but not un-prefixed MutationObserver.
	// Must use `global` or `self` instead of `window` to work in both frames and web
	// workers. `global` is a provision of Browserify, Mr, Mrs, or Mop.
	
	/* globals self */
	var scope = typeof global !== "undefined" ? global : self;
	var BrowserMutationObserver = scope.MutationObserver || scope.WebKitMutationObserver;
	
	// MutationObservers are desirable because they have high priority and work
	// reliably everywhere they are implemented.
	// They are implemented in all modern browsers.
	//
	// - Android 4-4.3
	// - Chrome 26-34
	// - Firefox 14-29
	// - Internet Explorer 11
	// - iPad Safari 6-7.1
	// - iPhone Safari 7-7.1
	// - Safari 6-7
	if (typeof BrowserMutationObserver === "function") {
	    requestFlush = makeRequestCallFromMutationObserver(flush);
	
	// MessageChannels are desirable because they give direct access to the HTML
	// task queue, are implemented in Internet Explorer 10, Safari 5.0-1, and Opera
	// 11-12, and in web workers in many engines.
	// Although message channels yield to any queued rendering and IO tasks, they
	// would be better than imposing the 4ms delay of timers.
	// However, they do not work reliably in Internet Explorer or Safari.
	
	// Internet Explorer 10 is the only browser that has setImmediate but does
	// not have MutationObservers.
	// Although setImmediate yields to the browser's renderer, it would be
	// preferrable to falling back to setTimeout since it does not have
	// the minimum 4ms penalty.
	// Unfortunately there appears to be a bug in Internet Explorer 10 Mobile (and
	// Desktop to a lesser extent) that renders both setImmediate and
	// MessageChannel useless for the purposes of ASAP.
	// https://github.com/kriskowal/q/issues/396
	
	// Timers are implemented universally.
	// We fall back to timers in workers in most engines, and in foreground
	// contexts in the following browsers.
	// However, note that even this simple case requires nuances to operate in a
	// broad spectrum of browsers.
	//
	// - Firefox 3-13
	// - Internet Explorer 6-9
	// - iPad Safari 4.3
	// - Lynx 2.8.7
	} else {
	    requestFlush = makeRequestCallFromTimer(flush);
	}
	
	// `requestFlush` requests that the high priority event queue be flushed as
	// soon as possible.
	// This is useful to prevent an error thrown in a task from stalling the event
	// queue if the exception handled by Node.js’s
	// `process.on("uncaughtException")` or by a domain.
	rawAsap.requestFlush = requestFlush;
	
	// To request a high priority event, we induce a mutation observer by toggling
	// the text of a text node between "1" and "-1".
	function makeRequestCallFromMutationObserver(callback) {
	    var toggle = 1;
	    var observer = new BrowserMutationObserver(callback);
	    var node = document.createTextNode("");
	    observer.observe(node, {characterData: true});
	    return function requestCall() {
	        toggle = -toggle;
	        node.data = toggle;
	    };
	}
	
	// The message channel technique was discovered by Malte Ubl and was the
	// original foundation for this library.
	// http://www.nonblocking.io/2011/06/windownexttick.html
	
	// Safari 6.0.5 (at least) intermittently fails to create message ports on a
	// page's first load. Thankfully, this version of Safari supports
	// MutationObservers, so we don't need to fall back in that case.
	
	// function makeRequestCallFromMessageChannel(callback) {
	//     var channel = new MessageChannel();
	//     channel.port1.onmessage = callback;
	//     return function requestCall() {
	//         channel.port2.postMessage(0);
	//     };
	// }
	
	// For reasons explained above, we are also unable to use `setImmediate`
	// under any circumstances.
	// Even if we were, there is another bug in Internet Explorer 10.
	// It is not sufficient to assign `setImmediate` to `requestFlush` because
	// `setImmediate` must be called *by name* and therefore must be wrapped in a
	// closure.
	// Never forget.
	
	// function makeRequestCallFromSetImmediate(callback) {
	//     return function requestCall() {
	//         setImmediate(callback);
	//     };
	// }
	
	// Safari 6.0 has a problem where timers will get lost while the user is
	// scrolling. This problem does not impact ASAP because Safari 6.0 supports
	// mutation observers, so that implementation is used instead.
	// However, if we ever elect to use timers in Safari, the prevalent work-around
	// is to add a scroll event listener that calls for a flush.
	
	// `setTimeout` does not call the passed callback if the delay is less than
	// approximately 7 in web workers in Firefox 8 through 18, and sometimes not
	// even then.
	
	function makeRequestCallFromTimer(callback) {
	    return function requestCall() {
	        // We dispatch a timeout with a specified delay of 0 for engines that
	        // can reliably accommodate that request. This will usually be snapped
	        // to a 4 milisecond delay, but once we're flushing, there's no delay
	        // between events.
	        var timeoutHandle = setTimeout(handleTimer, 0);
	        // However, since this timer gets frequently dropped in Firefox
	        // workers, we enlist an interval handle that will try to fire
	        // an event 20 times per second until it succeeds.
	        var intervalHandle = setInterval(handleTimer, 50);
	
	        function handleTimer() {
	            // Whichever timer succeeds will cancel both timers and
	            // execute the callback.
	            clearTimeout(timeoutHandle);
	            clearInterval(intervalHandle);
	            callback();
	        }
	    };
	}
	
	// This is for `asap.js` only.
	// Its name will be periodically randomized to break any code that depends on
	// its existence.
	rawAsap.makeRequestCallFromTimer = makeRequestCallFromTimer;
	
	// ASAP was originally a nextTick shim included in Q. This was factored out
	// into this ASAP package. It was later adapted to RSVP which made further
	// amendments. These decisions, particularly to marginalize MessageChannel and
	// to capture the MutationObserver implementation in a closure, were integrated
	// back into ASAP proper.
	// https://github.com/tildeio/rsvp.js/blob/cddf7232546a9cf858524b75cde6f9edf72620a7/lib/rsvp/asap.js
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 307 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var Promise = __webpack_require__(305);
	
	module.exports = Promise;
	Promise.prototype.done = function (onFulfilled, onRejected) {
	  var self = arguments.length ? this.then.apply(this, arguments) : this;
	  self.then(null, function (err) {
	    setTimeout(function () {
	      throw err;
	    }, 0);
	  });
	};


/***/ }),
/* 308 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var Promise = __webpack_require__(305);
	
	module.exports = Promise;
	Promise.prototype['finally'] = function (f) {
	  return this.then(function (value) {
	    return Promise.resolve(f()).then(function () {
	      return value;
	    });
	  }, function (err) {
	    return Promise.resolve(f()).then(function () {
	      throw err;
	    });
	  });
	};


/***/ }),
/* 309 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	//This file contains the ES6 extensions to the core Promises/A+ API
	
	var Promise = __webpack_require__(305);
	
	module.exports = Promise;
	
	/* Static Functions */
	
	var TRUE = valuePromise(true);
	var FALSE = valuePromise(false);
	var NULL = valuePromise(null);
	var UNDEFINED = valuePromise(undefined);
	var ZERO = valuePromise(0);
	var EMPTYSTRING = valuePromise('');
	
	function valuePromise(value) {
	  var p = new Promise(Promise._61);
	  p._65 = 1;
	  p._55 = value;
	  return p;
	}
	Promise.resolve = function (value) {
	  if (value instanceof Promise) return value;
	
	  if (value === null) return NULL;
	  if (value === undefined) return UNDEFINED;
	  if (value === true) return TRUE;
	  if (value === false) return FALSE;
	  if (value === 0) return ZERO;
	  if (value === '') return EMPTYSTRING;
	
	  if (typeof value === 'object' || typeof value === 'function') {
	    try {
	      var then = value.then;
	      if (typeof then === 'function') {
	        return new Promise(then.bind(value));
	      }
	    } catch (ex) {
	      return new Promise(function (resolve, reject) {
	        reject(ex);
	      });
	    }
	  }
	  return valuePromise(value);
	};
	
	Promise.all = function (arr) {
	  var args = Array.prototype.slice.call(arr);
	
	  return new Promise(function (resolve, reject) {
	    if (args.length === 0) return resolve([]);
	    var remaining = args.length;
	    function res(i, val) {
	      if (val && (typeof val === 'object' || typeof val === 'function')) {
	        if (val instanceof Promise && val.then === Promise.prototype.then) {
	          while (val._65 === 3) {
	            val = val._55;
	          }
	          if (val._65 === 1) return res(i, val._55);
	          if (val._65 === 2) reject(val._55);
	          val.then(function (val) {
	            res(i, val);
	          }, reject);
	          return;
	        } else {
	          var then = val.then;
	          if (typeof then === 'function') {
	            var p = new Promise(then.bind(val));
	            p.then(function (val) {
	              res(i, val);
	            }, reject);
	            return;
	          }
	        }
	      }
	      args[i] = val;
	      if (--remaining === 0) {
	        resolve(args);
	      }
	    }
	    for (var i = 0; i < args.length; i++) {
	      res(i, args[i]);
	    }
	  });
	};
	
	Promise.reject = function (value) {
	  return new Promise(function (resolve, reject) {
	    reject(value);
	  });
	};
	
	Promise.race = function (values) {
	  return new Promise(function (resolve, reject) {
	    values.forEach(function(value){
	      Promise.resolve(value).then(resolve, reject);
	    });
	  });
	};
	
	/* Prototype Methods */
	
	Promise.prototype['catch'] = function (onRejected) {
	  return this.then(null, onRejected);
	};


/***/ }),
/* 310 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	// This file contains then/promise specific extensions that are only useful
	// for node.js interop
	
	var Promise = __webpack_require__(305);
	var asap = __webpack_require__(311);
	
	module.exports = Promise;
	
	/* Static Functions */
	
	Promise.denodeify = function (fn, argumentCount) {
	  if (
	    typeof argumentCount === 'number' && argumentCount !== Infinity
	  ) {
	    return denodeifyWithCount(fn, argumentCount);
	  } else {
	    return denodeifyWithoutCount(fn);
	  }
	};
	
	var callbackFn = (
	  'function (err, res) {' +
	  'if (err) { rj(err); } else { rs(res); }' +
	  '}'
	);
	function denodeifyWithCount(fn, argumentCount) {
	  var args = [];
	  for (var i = 0; i < argumentCount; i++) {
	    args.push('a' + i);
	  }
	  var body = [
	    'return function (' + args.join(',') + ') {',
	    'var self = this;',
	    'return new Promise(function (rs, rj) {',
	    'var res = fn.call(',
	    ['self'].concat(args).concat([callbackFn]).join(','),
	    ');',
	    'if (res &&',
	    '(typeof res === "object" || typeof res === "function") &&',
	    'typeof res.then === "function"',
	    ') {rs(res);}',
	    '});',
	    '};'
	  ].join('');
	  return Function(['Promise', 'fn'], body)(Promise, fn);
	}
	function denodeifyWithoutCount(fn) {
	  var fnLength = Math.max(fn.length - 1, 3);
	  var args = [];
	  for (var i = 0; i < fnLength; i++) {
	    args.push('a' + i);
	  }
	  var body = [
	    'return function (' + args.join(',') + ') {',
	    'var self = this;',
	    'var args;',
	    'var argLength = arguments.length;',
	    'if (arguments.length > ' + fnLength + ') {',
	    'args = new Array(arguments.length + 1);',
	    'for (var i = 0; i < arguments.length; i++) {',
	    'args[i] = arguments[i];',
	    '}',
	    '}',
	    'return new Promise(function (rs, rj) {',
	    'var cb = ' + callbackFn + ';',
	    'var res;',
	    'switch (argLength) {',
	    args.concat(['extra']).map(function (_, index) {
	      return (
	        'case ' + (index) + ':' +
	        'res = fn.call(' + ['self'].concat(args.slice(0, index)).concat('cb').join(',') + ');' +
	        'break;'
	      );
	    }).join(''),
	    'default:',
	    'args[argLength] = cb;',
	    'res = fn.apply(self, args);',
	    '}',
	    
	    'if (res &&',
	    '(typeof res === "object" || typeof res === "function") &&',
	    'typeof res.then === "function"',
	    ') {rs(res);}',
	    '});',
	    '};'
	  ].join('');
	
	  return Function(
	    ['Promise', 'fn'],
	    body
	  )(Promise, fn);
	}
	
	Promise.nodeify = function (fn) {
	  return function () {
	    var args = Array.prototype.slice.call(arguments);
	    var callback =
	      typeof args[args.length - 1] === 'function' ? args.pop() : null;
	    var ctx = this;
	    try {
	      return fn.apply(this, arguments).nodeify(callback, ctx);
	    } catch (ex) {
	      if (callback === null || typeof callback == 'undefined') {
	        return new Promise(function (resolve, reject) {
	          reject(ex);
	        });
	      } else {
	        asap(function () {
	          callback.call(ctx, ex);
	        })
	      }
	    }
	  }
	};
	
	Promise.prototype.nodeify = function (callback, ctx) {
	  if (typeof callback != 'function') return this;
	
	  this.then(function (value) {
	    asap(function () {
	      callback.call(ctx, null, value);
	    });
	  }, function (err) {
	    asap(function () {
	      callback.call(ctx, err);
	    });
	  });
	};


/***/ }),
/* 311 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	// rawAsap provides everything we need except exception management.
	var rawAsap = __webpack_require__(306);
	// RawTasks are recycled to reduce GC churn.
	var freeTasks = [];
	// We queue errors to ensure they are thrown in right order (FIFO).
	// Array-as-queue is good enough here, since we are just dealing with exceptions.
	var pendingErrors = [];
	var requestErrorThrow = rawAsap.makeRequestCallFromTimer(throwFirstError);
	
	function throwFirstError() {
	    if (pendingErrors.length) {
	        throw pendingErrors.shift();
	    }
	}
	
	/**
	 * Calls a task as soon as possible after returning, in its own event, with priority
	 * over other events like animation, reflow, and repaint. An error thrown from an
	 * event will not interrupt, nor even substantially slow down the processing of
	 * other events, but will be rather postponed to a lower priority event.
	 * @param {{call}} task A callable object, typically a function that takes no
	 * arguments.
	 */
	module.exports = asap;
	function asap(task) {
	    var rawTask;
	    if (freeTasks.length) {
	        rawTask = freeTasks.pop();
	    } else {
	        rawTask = new RawTask();
	    }
	    rawTask.task = task;
	    rawAsap(rawTask);
	}
	
	// We wrap tasks with recyclable task objects.  A task object implements
	// `call`, just like a function.
	function RawTask() {
	    this.task = null;
	}
	
	// The sole purpose of wrapping the task is to catch the exception and recycle
	// the task object after its single use.
	RawTask.prototype.call = function () {
	    try {
	        this.task.call();
	    } catch (error) {
	        if (asap.onerror) {
	            // This hook exists purely for testing purposes.
	            // Its name will be periodically randomized to break any code that
	            // depends on its existence.
	            asap.onerror(error);
	        } else {
	            // In a web browser, exceptions are not fatal. However, to avoid
	            // slowing down the queue of pending tasks, we rethrow the error in a
	            // lower priority turn.
	            pendingErrors.push(error);
	            requestErrorThrow();
	        }
	    } finally {
	        this.task = null;
	        freeTasks[freeTasks.length] = this;
	    }
	};


/***/ }),
/* 312 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var Promise = __webpack_require__(305);
	
	module.exports = Promise;
	Promise.enableSynchronous = function () {
	  Promise.prototype.isPending = function() {
	    return this.getState() == 0;
	  };
	
	  Promise.prototype.isFulfilled = function() {
	    return this.getState() == 1;
	  };
	
	  Promise.prototype.isRejected = function() {
	    return this.getState() == 2;
	  };
	
	  Promise.prototype.getValue = function () {
	    if (this._65 === 3) {
	      return this._55.getValue();
	    }
	
	    if (!this.isFulfilled()) {
	      throw new Error('Cannot get a value of an unfulfilled promise.');
	    }
	
	    return this._55;
	  };
	
	  Promise.prototype.getReason = function () {
	    if (this._65 === 3) {
	      return this._55.getReason();
	    }
	
	    if (!this.isRejected()) {
	      throw new Error('Cannot get a rejection reason of a non-rejected promise.');
	    }
	
	    return this._55;
	  };
	
	  Promise.prototype.getState = function () {
	    if (this._65 === 3) {
	      return this._55.getState();
	    }
	    if (this._65 === -1 || this._65 === -2) {
	      return 0;
	    }
	
	    return this._65;
	  };
	};
	
	Promise.disableSynchronous = function() {
	  Promise.prototype.isPending = undefined;
	  Promise.prototype.isFulfilled = undefined;
	  Promise.prototype.isRejected = undefined;
	  Promise.prototype.getValue = undefined;
	  Promise.prototype.getReason = undefined;
	  Promise.prototype.getState = undefined;
	};


/***/ }),
/* 313 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * count from 1
	 * @type {Number}
	 */
	var _events = {};
	/**
	 * mapping for all callbacks
	 * @type {Object}
	 */
	var pageEvents = ["appear", "disappear"];
	var queue = __webpack_require__(314);
	var Core;
	var q = queue(function(data){
	  if (DPApp._doSendMessage) {
	    DPApp._doSendMessage(data.method, data.args, data.callback)
	  }else if(DPApp.doSendMessage){
	    //兼容titans
	    DPApp.doSendMessage(data.method, data.args, data.callback)
	  }
	})
	
	Core = {
		_dequeueTimeout: null,
	  _messageQueue: q,
	  dequeue: function(){
	    var self = this;
	    setTimeout(function(){
	      DPApp && DPApp.log && DPApp.log("Dequeue");
	      clearTimeout(this._dequeueTimeout);
	      self._dequeueTimeout = null;
	      q.dequeue();
	    }, 0);
	  },
	  ready: function(callback){
	    var self = this;
	    this._send("ready", {
	      success: function(){
	        self._isReady = true;
	        callback();
	      }
	    });
	  },
	  openScheme: function(opt){
	    var url = opt.url;
	    var extra = opt.extra;
	    if(extra){
	      url += "?" + this._convertUrlParams(extra);
	      delete opt.extra;
	      opt.url = url;
	    }
	    this._send('openScheme', opt);
	  },
	  _sendMessage: function(method, args, callback){
	    var self = this;
	    q.push({
	      method: method,
	      args: args,
	      callback: callback
	    })
	    this._dequeueTimeout = setTimeout(function(){
	      self.dequeue();
	    },1000);
	
	  },
	  // _generateCallbackId: function(){
	  //   var rand = Math.floor(Math.random() * 1000);
	  //   var timestamp = +new Date();
	  //   return +(timestamp + "" + rand);
	  // },
	  _generateCallbackId: function () {
	    var rand = Math.floor(Math.random() * 1000);
	    var timestampStr = +new Date() + '';
	    //在DPAPP老版本中callbackId为int型，故只选取8位
	    var timestamp = timestampStr.substr(timestampStr.length - 5, 5);
	    return +(timestamp + "" + rand);
	  },
	  _generateCallbackName: function(callbackId){
	    return "DPApp_callback_" + callbackId;
	  },
	  /**
	   * send message to native
	   * @param  {String}   method
	   * @param  {Object}   args
	   * @param  {Function} callback
	   */
	  _doSendMessage: function (method, args, callback) {
	      var hasCallback = callback && typeof callback == 'function';
	      this.log('调用方法', method, args);
	
	      /**
	       * pass 0 as callbackId
	       * thus _callbacks[callbackId] is undefined
	       * nothing will happen
	       * @type {Number}
	       */
	      var callbackId = hasCallback ? this._generateCallbackId() : 0;
	      
	      if (hasCallback){
	        window[this._generateCallbackName(callbackId)] = callback;
	      }
	
	      /**
	       * check type for args
	       */
	      if(!args || typeof args !== 'object'){
	        args = {};
	      }
	
	      // 某些版本app很任性的把callbackId参数放到args里了
	      args.callbackId = callbackId;
	      args = JSON.stringify(args);
	
	      var bridgeUrl = 'js://_?method=' + method + '&args=' + encodeURIComponent(args) + '&callbackId=' + callbackId;
	
	      this.log('创建iframe ' + method, "callbackId:" + callbackId);
	      this._createIframe(bridgeUrl);
	  },
	  _createNode: function(src, type){
	    /**
	     * create node
	     * and native will intercept and handle the process
	     */
	    var node = document.createElement(type);
	    node.style.display = 'none';
	
	    function removeNode(){
	      node.onload = node.onerror = null;
	      node.parentNode && node.parentNode.removeChild(node);
	    }
	    /**
	     * remove node after loaded
	     */
	    node.onload = node.onerror = removeNode;
	    setTimeout(removeNode, 5000);
	    node.src = src;
	    document.body.appendChild(node);
	  },
	  _createIframe: function(src){
	    this._createNode(src, "iframe");
	  },
	  _send: function(method, args){
	    args = args || {};
	    var self = this;
	    var _success = args.success;
	    var _fail = args.fail;
	    var _handle = args.handle;
	
	    var fail = function(result){
	      self.log('调用失败 ' + method, result);
	      _fail && _fail.call(self, result);
	    }
	
	    var success = function(result){
	      self.log('调用成功 ' + method, result);
	      _success && _success.call(self, result);
	    }
	
	    var handle = function(result){
	      self.log('回调 ' + method, result);
	      _handle && _handle.call(self, result);
	    }
	
	    var callback = (_success || _fail || _handle) ? function(result){
	      var status = result.status;
	      if(result.result != "next"){
	        delete result.result;
	      }
	      if(status == "success"){
	        success && success(result);
	      }else if(status == "action"){
	        handle && handle(result);
	      }else{
	        fail && fail(result);
	      }
	    } : null;
	
	    this._sendMessage(method, args, callback);
	
	  },
	
	  _convertUrlParams: function(params){
	    var result = [];
	    for(var i in params){
	      result.push(i + "=" + encodeURIComponent(params[i]));
	    }
	    return result.join("&");
	  },
	  _sanitizeAjaxOpts: function(args){
	    args.method = args.method || "get";
	    args.data = args.data || "";
	    var url = args.url;
	    var data = args.data;
	
	    if (args.method == "get") {
	      var params = [];
	      for (var p in data) {
	        if (data.hasOwnProperty(p) && (data[p] || data[p] === 0)) {  // allow `something=0' param
	          params.push(p + '=' + encodeURIComponent(data[p]));
	        }
	      }
	
	      if (params.length) {
	        url += url.indexOf('?') == -1 ? "?" : "&";
	        url += params.join('&');
	      }
	      args.url = url;
	      delete args.data;
	    }
	    return args;
	  },
	  _parseFeed: function(f){
	    var feed;
	    if (!f) {
	      return 0xff;
	    } else if (f.constructor.toString().indexOf("Array") >= 0) {
	      feed = [0, 0, 0, 0, 0, 0, 0, 0];
	      f.forEach(function(pos) {
	        feed[7 - pos] = 1;
	      });
	      return parseInt(feed.join(""), 2);
	    }
	  },
	  _transModel: function(keys, obj){
	    if(!keys){return obj;}
	    var keymap = {};
	
	    function getHash(str) {
	      var hashCode = function(str) {
	        var hash = 0,
	          i, chr, len;
	        if (str.length == 0) return hash;
	        for (i = 0, len = str.length; i < len; i++) {
	          chr = str.charCodeAt(i);
	          hash = ((hash << 5) - hash) + chr;
	          hash |= 0; // Convert to 32bit integer
	        }
	        return hash;
	      };
	
	      var i = hashCode(str);
	      return "0x" + ((0xFFFF & i) ^ (i >>> 16)).toString(16);
	    }
	
	    function generateKeys(keys) {
	      keys.forEach(function(key) {
	        keymap[getHash(key)] = key;
	      });
	    }
	
	    function isArray(val) {
	      return Object.prototype.toString.call(val) == "[object Array]";
	    }
	
	    function isObject(val) {
	      return Object.prototype.toString.call(val) == "[object Object]";
	    }
	
	    function translate(obj){
	      if (isObject(obj)) {
	        delete obj.__name;
	        for (var key in obj) {
	          var val;
	          if (keymap[key]) {
	            val = obj[keymap[key]] = obj[key];
	            translate(val);
	            delete obj[key];
	          }
	        }
	      } else if (isArray(obj)) {
	        obj.forEach(function(item) {
	          translate(item);
	        });
	      }
	      return obj;
	    }
	
	    keys.forEach(function(key) {
	      keymap[getHash(key)] = key;
	    });
	
	    return translate(obj);
	  },
	  _capital: function(str){
	    return str.slice(0,1).toUpperCase() + str.slice(1);
	  },
	  subscribe : function(opt) {
	    var self = this;
	    var name = opt.action;
	    var success = opt.success;
	    var handle = opt.handle;
	    var messageName;
	
	    function mainHandler(e){
	      _events[name] && _events[name].length && _events[name].forEach(function(func) {
	        func && func(e);
	      });
	    }
	
	    function registerPageEvents(){
	      if(messageName){
	        self[messageName] = mainHandler;
	        opt.success && opt.success();
	      }
	    }
	
	    if (_events[name]) {
	      opt.success && opt.success();
	      _events[name].push(handle);
	    } else {
	      if(pageEvents.indexOf(name) != -1){
	        messageName = "on" + self._capital(name);
	        if(name == 'scroll'){
	          // 仅scroll事件需要toggle开关
	          this._send(messageName, {
	            success: registerPageEvents
	          });
	        }else{
	          // 不然就直接注册上了
	          registerPageEvents();
	        }
	      }else{
	        this._send("subscribe", {
	          action: name,
	          success: opt.success,
	          handle: mainHandler
	        });
	      }
	
	      _events[name] = [handle];
	    }
	  },
	
	  unsubscribe : function(opt) {
	    var name = opt.action;
	    var success = opt.success;
	    var handle = opt.handle;
	    var self = this;
	
	    var index = _events[name] ? _events[name].indexOf(handle) : -1;
	
	    function unregisterPageEvents(){
	      self[callbackName] = NOOP;
	    }
	
	    if (index != -1) {
	      _events[name].splice(index, 1);
	      success && success();
	      if(!_events[name].length){
	        _events[name] = null;
	      }
	    }else if(!handle){
	      _events[name] = null;
	    }
	
	    if(!_events[name]){
	      // unregister
	      // if is page event
	      if(pageEvents.indexOf(name) != -1 && after7_6){
	        var messageName = "off" + self._capital(name);
	        var callbackName = "on" + self._capital(name);
	        // 与安卓确认
	        if(name == 'scroll'){
	          this._send(messageName, {
	            success: unregisterPageEvents
	          });
	        }else{
	          unregisterPageEvents();
	        }
	      }else{
	        this._send("unsubscribe", {
	          action: name,
	          success: success
	        });
	      }
	    }
	    // if not found, remove all;
	  },
	
	  getUA: function(){},
	  /**
	   * callback function to be invoked from native
	   * @param  {Number} callbackId
	   * @param  {Object} retValue
	   */
	  callback: function(callbackId, retValue){
	    var win = window;
	    var callbackFuncName = this._generateCallbackName(callbackId);
	    var callback = window[callbackFuncName];
	
	    if(callback){
	      this.log("触发回调 ", "callbackId:" + callbackId);
	      setTimeout(function(){
	        callback && callback.call(self,retValue);
	      });
	      if(retValue.result == "complete" || retValue.result == "error"){
	        win[callbackFuncName] = null;
	        delete win[callbackFuncName];
	      }
	    }
	  }
	};
	
	module.exports = Core

/***/ }),
/* 314 */
/***/ (function(module, exports) {

	var queue = module.exports = function(worker){
		var currentData = null;
		var currentCallback = null;
		var q = {
			timeout: null,
			running : false,
			tasks: [],
			push: function(data, cb){
				var callback = cb || function(data){}
				q.tasks.push({
					data: data,
					callback: callback
				});
				setTimeout(function(){
					q.process();
				}, 0);
			},
			dequeue: function(){
				if(currentCallback){
					currentCallback();
				}else{
					q.running = false;
				}
			},
			process: function(){
				if(q.tasks.length && !q.running){
					var task = q.tasks.shift();
					q.running = true;
					currentCallback = function(){
						q.running = false;
						task.callback(task.data);
						q.process();
					};
					currentData = task.data;
					worker(task.data, currentCallback);
				}
			}
		}
		return q;
	};

/***/ }),
/* 315 */
/***/ (function(module, exports) {

	module.exports = {
	  _iOSNetworkType: function (result) {
	    var networkType;
	    var types = {
	      kSCNetworkReachabilityFlagsTransientConnection: 1 << 0,
	      kSCNetworkReachabilityFlagsReachable: 1 << 1,
	      kSCNetworkReachabilityFlagsConnectionRequired: 1 << 2,
	      kSCNetworkReachabilityFlagsConnectionOnTraffic: 1 << 3,
	      kSCNetworkReachabilityFlagsInterventionRequired: 1 << 4,
	      kSCNetworkReachabilityFlagsConnectionOnDemand: 1 << 5,
	      kSCNetworkReachabilityFlagsIsLocalAddress: 1 << 16,
	      kSCNetworkReachabilityFlagsIsDirect: 1 << 17,
	      kSCNetworkReachabilityFlagsIsWWAN: 1 << 18
	    };
	    var type = +result.type;
	    var subType = result.subType;
	    var returnValue;
	    // 2g, 3g, 4g
	    function getMobileType(subType) {
	      switch (subType) {
	        case "CTRadioAccessTechnologyGPRS":
	        case "CTRadioAccessTechnologyEdge":
	        case "CTRadioAccessTechnologyCDMA1x":
	          return "2g";
	        case "CTRadioAccessTechnologyLTE":
	          return "4g";
	        case "CTRadioAccessTechnologyWCDMA":
	        case "CTRadioAccessTechnologyHSDPA":
	        case "CTRadioAccessTechnologyHSUPA":
	        case "CTRadioAccessTechnologyCDMA1x":
	        case "CTRadioAccessTechnologyCDMAEVDORev0":
	        case "CTRadioAccessTechnologyCDMAEVDORevA":
	        case "CTRadioAccessTechnologyCDMAEVDORevB":
	        case "CTRadioAccessTechnologyeHRPD":
	          return "3g";
	      }
	    }
	
	    if ((type & types.kSCNetworkReachabilityFlagsReachable) == 0) {
	      return "none";
	    }
	
	    if ((type & types.kSCNetworkReachabilityFlagsConnectionRequired) == 0) {
	      // if target host is reachable and no connection is required
	      //  then we'll assume (for now) that your on Wi-Fi
	      returnValue = "wifi";
	    }
	
	
	    if (
	      (type & types.kSCNetworkReachabilityFlagsConnectionOnDemand) != 0
	      ||
	      (type & types.kSCNetworkReachabilityFlagsConnectionOnTraffic) != 0
	    ) {
	      // ... and the connection is on-demand (or on-traffic) if the
	      //     calling application is using the CFSocketStream or higher APIs
	      if ((type & types.kSCNetworkReachabilityFlagsInterventionRequired) == 0) {
	        // ... and no [user] intervention is needed
	        returnValue = "wifi";
	      }
	    }
	
	    if ((type & types.kSCNetworkReachabilityFlagsIsWWAN) == types.kSCNetworkReachabilityFlagsIsWWAN) {
	      // ... but WWAN connections are OK if the calling application
	      //     is using the CFNetwork (CFSocketStream?) APIs.
	      returnValue = getMobileType(subType);
	    }
	
	    return returnValue;
	  },
	  _androidNetworkType: function (result) {
	    var type = result.type;
	    var subType = result.subType;
	
	    if (type == 0) {
	      switch (subType) {
	        case 1:
	        case 2:
	        case 4:
	        case 7:
	        case 11:
	          return "2g";
	        case 3:
	        case 5:
	        case 6:
	        case 8:
	        case 9:
	        case 10:
	        case 12:
	        case 14:
	        case 15:
	          return "3g";
	        case 13:
	          return "4g";
	      }
	    }
	
	    if (type == 1) {
	      return "wifi";
	    } else {
	      return "none";
	    }
	  },
	  getNetworkType : function(opt) {
	    var self = this;
	    var _success = opt.success;
	
	    this._send("getNetworkType", {
	      success: function(result) {
	        var ua = self._osUA;
	        var networkType;
	
	        switch (ua.name) {
	          case "iphone":
	            networkType = this._iOSNetworkType(result);
	            break;
	          case "android":
	            networkType = this._androidNetworkType(result);
	            break;
	        }
	
	        _success && _success({
	          networkType: networkType,
	          raw: {
	            type: result.type,
	            subType: result.subType
	          }
	        });
	      },
	      fail: opt.fail
	    });
	  }
	}

/***/ }),
/* 316 */
/***/ (function(module, exports) {

	module.exports = function mixin(to, from) {
	  for (var key in from) {
	    to[key] = from[key];
	  }
	  return to;
	};

/***/ }),
/* 317 */
/***/ (function(module, exports) {

	'use strict';
	
	var regexVer = /dp\/com\.dianping\.[\w\.]+\/([\d\.]+)/;
	
	var getAppVersion = function (ua) {
	  var version;
	  var regexMAPI = /MApi/;
	  var match  = ua.match(regexVer);
	  if (match) {
	    version = match[1];
	  }else if (regexMAPI.test(ua)) {
	    version = '7.0.0';
	  }else{
	    version = 'web';
	  }
	  return version;
	};
	var getOSName = function (ua) {
	  var regexAndroid = /android/i;
	  var regexIos = /ipad|iphone/i;
	  if (regexAndroid.test(ua)) {
	    return 'android';
	  }else if (regexIos.test(ua)) {
	    return 'ios';
	  }
	};
	
	var getAdapterVersion = function (ua) {
	  if (ua.match(regexVer)) {
	    var reg = /adapter\/([\d\.]+)/;
	    var match = ua.match(reg);
	    if (match) {
	      return match[1];
	    }
	  }
	};
	
	var getWebviewVersion = function(ua) {
	  return getAdapterVersion(ua) || getAppVersion(ua);
	};
	
	var appVersion = getAppVersion(navigator.userAgent);
	var osName = getOSName(navigator.userAgent);
	
	module.exports = {
	  appVersion: appVersion,
	  getAppVersion: getAppVersion,
	  osName: osName,
	  getOSName: getOSName,
	  getWebviewVersion: getWebviewVersion,
	  actionMapping: function (method) {
	    return function (opt) {
	      this._send(method, opt);
	    };
	  }
	};

/***/ }),
/* 318 */
/***/ (function(module, exports) {

	module.exports = [
	  /*
	  * Common
	  */
	  "getRequestId", 
	  "isInstalledApp",
	  /*
	  * DeviceInfo
	  */
	  "getNetworkType", 
	  "getVersion",
	  /*
	  * UserInfos
	  */
	  "getUserInfo", 
	  "login", 
	  "updateAccount", 
	  "logout",
	  "thirdLogin",
	  /*
	  * GeoInfos
	  */ 
	  "getCityId", 
	  "getLocation", 
	  "getCity",
	  /*
	  * Common business
	  */
	  "setPullDown", 
	  "stopPullDown", 
	  "openScheme", 
	  "jumpToScheme", 
	  "closeWindow", 
	  "getContactList", 
	  "sendSMS", 
	  "bindPhone",
	  "ajax", 
	  "setSpotlight",
	  "getHealthData",
	  "pickCity",
	  "analyticsTag",
	  /*
	  * Storage
	  */
	  "store", 
	  "retrieve",
	  /*
	  *  Picture
	  */
	  "downloadImage", 
	  "chooseImage", 
	  "previewImage",
	  "uploadImage",
	  /*
	  * Audio
	  */
	  "playVoice",
	  /*
	  * Share
	  */
	  "share",
	  /*
	  * Broadcast
	  */
	  "publish", 
	  "subscribe", 
	  "unsubscribe", 
	
	  /*
	  * System widget
	  */
	  "alert", 
	  "prompt", 
	  "confirm", 
	  "actionSheet", 
	  /*
	  * System UI
	  */
	  "setTitle", 
	  "setBackgroundColor", 
	  "setNavigationBarHidden", 
	  "setScrollEnabled",
	  "setLLButton", 
	  "setLRButton", 
	  "setRLButton", 
	  "setRRButton", 
	  "setBouncesEnabled",
	  "setStatusBarStyle",
	  /*
	    Other
	   */
	  "setBarrageEnabled",
	  /*
	  * Private
	  */
	  "getCX",
	  "pay"
	];

/***/ }),
/* 319 */
/***/ (function(module, exports) {

	'use strict';
	
	var _err = window.onerror;
	var url = location.protocol + '//catdot.dianping.com/broker-service/api/js';
	window.onerror = function(err, file, line, col, error){
	  var e = encodeURIComponent;
	  var time = Date.now();
	  (new window.Image).src = url
	    + '?error=' + e(err)
	    + '&v=1'
	    + '&data=' + e(error && error.stack ? error.stack : '')
	    + '&url=' + e(location.href)
	    + '&file=' + e(file)
	    + '&line=' + e(line)
	    + '&col=' + e(col)
	    + '&timestamp=' + time;
	  _err && _err(err, file, line, col, error);
	};

/***/ }),
/* 320 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var util = __webpack_require__(317);
	
	module.exports = {
	  appVersion: '7.0',
	  _parseFeed: function(f){
	    var feed;
	    if (!f) {
	      return 0xff;
	    } else if (f.constructor.toString().indexOf('Array') >= 0) {
	      feed = [0, 0, 0, 0, 0, 0, 0, 0];
	      f.forEach(function(pos) {
	        feed[pos] = 1;
	      });
	      return parseInt(feed.join(''), 2);
	    }
	  },
	  share : function(opts){
	    opts.feed = this._parseFeed(opts.feed);
	    opts.url = this._tidyUrlParams(opts.url);
	    this._sendMessage('share', opts);
	  },
	  initShare: function(opt){
	    var success = opt.success;
	    var fail = opt.fail;
	    var src = 'dpshare://_?content=';
	    src += encodeURIComponent(JSON.stringify({
	      title: opt.title,
	      desc: opt.desc,
	      image: opt.image,
	      feed: this._parseFeed(opt.feed),
	      url: opt.url
	    }));
	    this.shareCallback = function(result){
	      if(result.status == 'success'){
	        success && success(result);
	      }else{
	        fail && fail(result);
	      }
	    };
	    this._createIframe(src);
	  },
	  getUA: function(opt) {
	    var success = opt && opt.success;
	    var appVersion = navigator.userAgent.match(/MApi\s[\w\.]+\s\([\w\.\d]+\s([\d\.]+)/)[1];
	    var ua = {
	      platform: 'dpapp',
	      appName: 'dianping',
	      appVersion: appVersion,
	      osName: this._osUA.name,
	      osVersion: this._osUA.version
	    };
	    success && success(ua);
	    return ua;
	  },
	  ready: function(callback) {
	    this._isReady = true;
	    callback();
	  },
	  uploadImage: function(opts) {
	    var fail = opts.fail;
	    var handle = opts.handle;
	
	    this._sendMessage('uploadImage', opts, function(result) {
	      var status = result.status;
	      if (status == 'fail') {
	        fail && fail(result);
	        return;
	      } else {
	        handle && handle(result);
	      }
	    });
	  },
	  ajax: function(args) {
	    args = this._sanitizeAjaxOpts(args);
	    var _success = args.success;
	    args.success = function(e) {
	      var result = JSON.parse(e.mapiResult);
	      result = this._transModel(args.keys, result);
	      _success(result);
	    };
	
	    this._send('mapi', args);
	  },
	  getCX: util.actionMapping('getCX'),
	  getContactList: util.actionMapping('getContactList'),
	  getRequestId: util.actionMapping('getRequestId'),
	  closeWindow: util.actionMapping('close_web'),
	  getUserInfo: util.actionMapping('getUserInfo'),
	  getCity: util.actionMapping('getCityId'),
	  getCityId: util.actionMapping('getCityId'),
	  getLocation: util.actionMapping('getLocation')
	};

/***/ }),
/* 321 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var util = __webpack_require__(317);
	var core = __webpack_require__(298);
	var patch7  = __webpack_require__(320);
	
	//更新的API: share, initShare, closeWindow, _parseFeed
	//新增的API: setTitle等
	var newAPIs = [
	    'setLLButton', 
	    'setLRButton', 
	    'setRLButton', 
	    'setRRButton',
	    'setTitle',
	    'sendSMS',
	    'publish',
	    'closeWindow'
	  ];
	
	var _events = {};
	var pageEvents = ['appear', 'disappear', 'scroll'];
	function getPageMethodName(name) {
	  var result = 'on' + core._captal(name);
	  // fix for android 7.6.0
	  if (util.osName == 'android' && util.appVersion == '7.6.0' && /appear|disappear/.test(name)) {
	    result = name;
	  }
	  return result;
	}
	
	var getUA = (function() {
	  var uastr = navigator.userAgent;
	  var appVersionMatch = uastr.match(/dp\/[\w\.\d]+\/([\d\.]+)/);
	  var appVersion = appVersionMatch && appVersionMatch[1];
	  var matchPackageId = uastr.match(/dp\/(com\.dianping\.\w+)/);
	  var packageId = matchPackageId && matchPackageId[1];
	  var adapterMatch = uastr.match(/adapter\/([\d\.]+)/);
	  var adapterVersion = adapterMatch && adapterMatch[1];
	
	  return function(opt) {
	    var success = opt && opt.success;
	    var ua = {
	      platform: 'dpapp',
	      appName: 'dianping',
	      packageId: packageId,
	      appVersion: appVersion,
	      osName: core._osUA.name,
	      osVersion: core._osUA.version,
	      adapterVersion: adapterVersion
	    };
	    success && success(ua);
	    return ua;
	  };
	})();
	
	var Patch = module.exports = {
	  appVersion: '7.1.0',
	  pay: patch7.pay,
	  
	  uploadImage: patch7.uploadImage,
	  
	  getUA: getUA,
	
	  ready: function(callback) {
	    var self = this;
	    this._send('ready', {
	      success: function() {
	        self._isReady = true;
	        callback();
	      }
	    });
	  },
	
	  login: function(opt) {
	    var self = this;
	    var loginUser;
	
	    function getUser(callback) {
	      self.getUserInfo({
	        success: callback
	      });
	    }
	    getUser(function(result) {
	      if (result.token) {
	        opt.success && opt.success(result);
	      } else {
	        var loginEvent = 'loginSuccess';
	        var appearEvent = 'appear';
	
	        var loginSuccessHandler = function() {
	          getUser(function (user) {
	            loginUser = user;
	          });
	          self.unsubscribe({
	            action: loginEvent,
	            handle: loginSuccessHandler
	          });
	        };
	
	        self.subscribe({
	          action: loginEvent,
	          handle: loginSuccessHandler
	        });
	
	        var appearHandler = function () {
	          getUser(function (user) {
	            if (user && user.token) {
	              opt.success && opt.success(user);
	            }else{
	              opt.fail && opt.fail(user);
	            }
	            
	          });
	          self.unsubscribe({
	            action: appearEvent,
	            handle: appearHandler
	          });
	        };
	
	        self.subscribe({
	          action: appearEvent,
	          handle: appearHandler
	        }); 
	
	        self.openScheme({
	          url: 'dianping://login'
	        });
	      }
	    });
	  },
	  updateAccount: function(opt) {
	    opt = opt || {};
	    var self = this;
	    var dper = document.cookie.match(/dper=\w+/);
	    if (dper) {
	      dper = dper[0].split('=')[1];
	    }
	
	    if (opt.dper) {
	      dper = opt.dper;
	    }
	
	    if (!dper) {
	      return opt.fail && opt.fail('Missing dper');
	    }
	    var _loopGetUserInfo = function(success, fail) {
	      var retries = 0;
	      function loopGetUserInfo() {
	        self.getUserInfo({
	          success: function(info) {
	            if (info.token) {
	              success && success(info);
	            } else {
	              if (retries > 5) {
	                fail && fail();
	              } else {
	                retries++;
	                setTimeout(function() {
	                  loopGetUserInfo();
	                }, 100);
	              }
	            }
	          }
	        });
	      }
	      loopGetUserInfo();
	    };
	
	    var url
	    if (location.protocol === 'http') {
	      url = 'http://m.api.dianping.com/mlogin/convertdper.api'
	    }else{
	      url = 'https://mapi.dianping.com/mapi/mlogin/convertdper.api'
	    }
	
	    self.ajax({
	      url: url,
	      data: {
	        dper: dper
	      },
	      keys: ['Token', 'NewToken'],
	      success: function(result) {
	        var ua = self.getUA();
	        if (self.Semver.gte(ua.appVersion, '7.5.0')) {
	          self._send('updateAccount', {
	            token: result.Token,
	            newtoken: result.NewToken,
	            success: function() {
	              self.getUserInfo({
	                success: opt.success
	              });
	            },
	            fail: opt.fail
	          });
	        } else {
	          self._send('loginsuccess', {
	            token: result.Token,
	            newtoken: result.NewToken
	          });
	
	          _loopGetUserInfo(opt.success, opt.fail);
	        }
	      },
	      fail: opt.fail
	    });
	  },
	  _parseFeed: function(f){
	    var feed;
	    if (!f) {
	      return 0xff;
	    } else if (f.constructor.toString().indexOf('Array') >= 0) {
	      feed = [0, 0, 0, 0, 0, 0, 0, 0];
	      f.forEach(function(pos) {
	        feed[7 - pos] = 1;
	      });
	      return parseInt(feed.join(''), 2);
	    }
	  },
	  share: function(opt) {
	    opt.feed = this._parseFeed(opt.feed);
	    opt.url = this._tidyUrlParams(opt.url);
	    this._send('share', opt);
	  },
	  initShare: function(opt) {
	    var self = this;
	    this.setRRButton({
	      icon: 'H5_Share',
	      handle: function() {
	        opt.handle && opt.handle();
	        self.share({
	          title: opt.title,
	          desc: opt.desc,
	          content: opt.content,
	          image: opt.image,
	          feed: opt.feed,
	          url: opt.url,
	          success: opt.success,
	          fail: opt.fail
	        });
	      }
	    });
	  },
	  subscribe: function(opt) {
	    var name = opt.action;
	    var handle = opt.handle;
	
	    function mainHandler(e) {
	      _events[name] && _events[name].length && _events[name].forEach(function(func) {
	        func && func(e);
	      });
	    }
	
	    if (_events[name]) {
	      opt.success && opt.success();
	      _events[name].push(handle);
	    } else {
	      this._send('subscribe', {
	        action: name,
	        success: opt.success,
	        handle: mainHandler
	      });
	
	      _events[name] = [handle];
	    }
	  },
	
	  unsubscribe: function(opt) {
	    var name = opt.action;
	    var success = opt.success;
	    var handle = opt.handle;
	
	    var index = _events[name] ? _events[name].indexOf(handle) : -1;
	
	    if (index != -1) {
	      _events[name].splice(index, 1);
	      success && success();
	      if (!_events[name].length) {
	        _events[name] = null;
	      }
	    } else if (!handle) {
	      _events[name] = null;
	    }
	
	    if (!_events[name]) {
	      this._send('unsubscribe', {
	        action: name,
	        success: success
	      });
	    }
	  },
	
	  openScheme: function(opt) {
	    var url = opt.url;
	    var extra = opt.extra;
	    if (extra) {
	      url += '?' + this._convertUrlParams(extra);
	      delete opt.extra;
	      opt.url = url;
	    }
	    this._send('openScheme', opt);
	  }
	};
	
	newAPIs.forEach(function (api) {
	  Patch[api] = util.actionMapping(api);
	});
	
	pageEvents.forEach(function(name) {
	  Patch[getPageMethodName(name)] = function (){};
	});

/***/ }),
/* 322 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = {
	  appVersion: '7.2.0',
	
	  jumpToScheme: function(opt) {
	    var url = opt.url;
	    var extra = opt.extra;
	    if (extra) {
	      url += '?' + this._convertUrlParams(extra);
	      delete opt.extra;
	      opt.url = url;
	    }
	    opt.toHome = !!opt.toHome ? 1 : 0;
	    this._send('jumpToScheme', opt);
	  },
	  publish: function(opt) {
	    var bizname = this._getBizName(opt);
	    var CONSTS = ['phoneChanged', 'AccountBindChange'];
	    if (bizname) {
	      if (CONSTS.indexOf(opt.action) == -1) {
	        opt.action = bizname + ':' + opt.action;
	      }
	      this._send('publish', opt);
	    }
	  }
	};

/***/ }),
/* 323 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var util = __webpack_require__(317);
	
	module.exports = {
	  appVersion: '7.5.0',
	  
	  store: function(opt) {
	    var bizname = this._getBizName(opt);
	    if (bizname) {
	      opt.key = bizname + ':' + opt.key;
	      this._send('store', opt);
	    }
	  },
	  retrieve: function(opt) {
	    var bizname = this._getBizName(opt);
	    if (opt.key.indexOf(':') === -1) {
	      opt.key = bizname + ':' + opt.key;
	    }
	    this._send('retrieve', opt);
	  },
	  setBackgroundColor: util.actionMapping('setBackgroundColor')
	};

/***/ }),
/* 324 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var util = __webpack_require__(317);
	var core = __webpack_require__(298);
	
	var _events = {};
	var pageEvents = ['appear', 'disappear', 'scroll'];
	function getPageMethodName(name) {
	  var result = 'on' + core._captal(name);
	  // fix for android 7.6.0
	  if (util.osName == 'android' && util.appVersion == '7.6.0' && /appear|disappear/.test(name)) {
	    result = name;
	  }
	  return result;
	}
	
	module.exports = {
	  appVersion: '7.6.0',
	  
	  isInstalledApp: util.actionMapping('isInstalledApp'),
	
	  subscribe: function(opt) {
	    var self = this;
	    var name = opt.action;
	    var handle = opt.handle;
	    var messageName;
	
	    function mainHandler(e) {
	      _events[name] && _events[name].length && _events[name].forEach(function(func) {
	        func && func(e);
	      });
	    }
	
	    function registerPageEvents() {
	      if (messageName) {
	        window.DPApp && (window.DPApp[getPageMethodName(name)] = mainHandler);
	        opt.success && opt.success();
	      }
	    }
	
	    if (_events[name]) {
	      opt.success && opt.success();
	      _events[name].push(handle);
	    } else {
	      if (pageEvents.indexOf(name) !== -1) {
	        messageName = 'on' + self._captal(name);
	        if (name == 'scroll') {
	          // 仅scroll事件需要toggle开关
	          this._send(messageName, {
	            success: registerPageEvents
	          });
	        } else {
	          // 不然就直接注册上了
	          registerPageEvents();
	        }
	      } else {
	        this._send('subscribe', {
	          action: name,
	          success: opt.success,
	          handle: mainHandler
	        });
	      }
	
	      _events[name] = [handle];
	    }
	  },
	
	  unsubscribe: function(opt) {
	    var name = opt.action;
	    var success = opt.success;
	    var handle = opt.handle;
	    var self = this;
	
	    var index = _events[name] ? _events[name].indexOf(handle) : -1;
	
	    function unregisterPageEvents() {
	      self[callbackName] = function () {};
	    }
	
	    if (index != -1) {
	      _events[name].splice(index, 1);
	      success && success();
	      if (!_events[name].length) {
	        _events[name] = null;
	      }
	    } else if (!handle) {
	      _events[name] = null;
	    }
	
	    if (!_events[name]) {
	      // unregister
	      // if is page event
	      if (pageEvents.indexOf(name) !== -1) {
	        var messageName = 'off' + self._captal(name);
	        var callbackName = 'on' + self._captal(name);
	        // 与安卓确认
	        if (name == 'scroll') {
	          this._send(messageName, {
	            success: unregisterPageEvents
	          });
	        } else {
	          unregisterPageEvents();
	        }
	      } else {
	        this._send('unsubscribe', {
	          action: name,
	          success: success
	        });
	      }
	    }
	  },
	};

/***/ }),
/* 325 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var util = __webpack_require__(317);
	
	var apis = ['alert', 'confirm', 'actionSheet', 'prompt', 'setPullDown', 'stopPullDown', 'downloadImage'];
	var core = {
	    appVersion: '7.8.0'
	};
	
	apis.forEach(function(api) {
	    var fn = util.actionMapping(api);
	    core[api] = fn;
	});
	core.prompt = function(opt) {
	    if (!opt.placeholder) {
	        opt.placeholder = '';
	    }
	    if (util.osName === 'ios') {
	        // FIX: message参数有bug，暂时不加入filterList
	        var filterList = ['title', 'placeholder', 'okButton', 'cancelButton', 'success', 'fail'];
	        var optKeys = Object.keys(opt);
	        for (var i = 0; i < optKeys.length; i++) {
	            var key = optKeys[i];
	            if (!~filterList.indexOf(key)) {
	                delete opt[key];
	            }
	        }
	    }
	    this._send('prompt', opt);
	};
	
	module.exports = core;


/***/ }),
/* 326 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var util = __webpack_require__(317);
	var async = __webpack_require__(327);
	var core = __webpack_require__(298);
	
	module.exports = {
	  appVersion: '7.9.1',
	  
	  setNavigationBarHidden: util.actionMapping('setNavigationBarHidden'),
	
	  chooseImage: function(opt) {
	    opt = opt || {};
	    opt.count = (!opt.count || opt.count > 9 || opt.count < 1) ? 9 : opt.count;
	    this._send('chooseImage', opt);
	  },
	  uploadImage: function(opts) {
	    var success = opts.success;
	    var fail = opts.fail;
	    var handle = opts.handle;
	    var ua = this.getUA();
	    var self = this;
	    if (opts.localId || opts.localIds) {
	      if (core.Semver.gte(ua.adapterVersion || ua.appVersion, '7.9.1')) {
	        if (opts.localIds) {
	          (function(ids) {
	            var picKeys = {};
	            var photoInfos = [];
	            async.mapSeries(ids, function(id, done){
	              self._send('uploadPhoto', {
	                localId: id,
	                success: function(e){
	                  picKeys[id] = e.picKey;
	                  photoInfos.push({
	                    localId: id,
	                    picKey: e.picKey//FIX BUG, What 'picKey' mean?
	                  });
	                  done(null);
	                },
	                fail: function(e){
	                  done(e);
	                }
	              });
	            }, function(e){
	              if(e){
	                fail && fail(e);
	              }else{
	                success && success({
	                  picKeys: picKeys,
	                  photoInfos: photoInfos
	                });
	              }
	            });
	          })(opts.localIds);
	        } else {
	          this._send('uploadPhoto', opts);
	        }
	      } else {
	        fail({
	          errMsg: 'ERR_NOT_IMPLEMENTED'
	        });
	      }
	    } else {
	      this._sendMessage('uploadImage', opts, function(result) {
	        var status = result.status;
	        if (status == 'fail') {
	          fail && fail(result);
	          return;
	        } else {
	          handle && handle(result);
	        }
	      });
	    }
	  },
	};

/***/ }),
/* 327 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.mapSeries = function(items, process, callback) {
	    var count = items.length;
	    var current = 0;
	    var results = [];
	
	    function done(err, result) {
	        if (err) {
	            return callback(err);
	        }
	
	        current++;
	        results.push(result);
	        if(current !== count){
	            process(items[current], done);
	        }else{
	            callback(null, results);
	        }
	    }
	
	    process(items[current], done);
	};

/***/ }),
/* 328 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var util = __webpack_require__(317);
	
	module.exports = {
	  appVersion: '7.9.2',
	  
	  previewImage: util.actionMapping('previewImage')
	};

/***/ }),
/* 329 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var util = __webpack_require__(317);
	
	module.exports = {
	  appVersion: '7.9.4',
	  setSpotlight: function (opt) {
	    if (!opt.webpageURL) {
	      return;
	    }
	    if (!opt.scheme) {
	      opt.scheme = 'dianping://web?url=' + encodeURIComponent(opt.webpageURL);
	    }
	    this._send('setSpotlight', opt);
	  },
	  playVoice: util.actionMapping('playVoice')
	};

/***/ }),
/* 330 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = {
	  appVersion: '7.9.6',
	
	  logout: function (opt) {
	    var url;
	    if (opt.type === 1) {
	      url = 'dianping://me';
	    }else if (opt.type === 2) {
	      url = 'dianping://home';
	    }
	    if (url) {
	      opt.success = function () {
	        this.openScheme({
	          url: url
	        });
	      };      
	    }
	    this._send('logout', opt);
	  },
	  login: function (opt) {
	    var self = this;
	    function getUser(callback) {
	      self.getUserInfo({
	        success: callback
	      });
	    }
	    // 先强制退出登录
	    this.logout({
	      type: 0,
	      success: function() {
	        // 注册事件
	        var appearEvent = 'appear';
	        // FIXME: loginSuccess 然并卵: 取消登录、已登录情况下不会发此通知，正常登录回调方法处理结果比appear慢！
	        // var loginEvent = 'loginSuccess';
	        var appearHandler = function () {
	          getUser(function (user) {
	            if (user && user.token) {
	              console.log('login success');
	              opt.success && opt.success(user);
	            }else{
	              console.log('login fail');
	              opt.fail && opt.fail(user);
	            }
	          });
	          self.unsubscribe({
	            action: appearEvent,
	            handle: appearHandler
	          });
	        };
	
	        self.subscribe({
	          action: appearEvent,
	          handle: appearHandler
	        });
	
	        // 打开登录页
	        self.openScheme({
	          url: 'dianping://login'
	        });
	      }
	    });
	  }
	};

/***/ }),
/* 331 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var util = __webpack_require__(317);
	
	module.exports = {
	  appVersion: '8.0.0',
	
	  setScrollEnabled: util.actionMapping('setScrollEnabled'),
	  setBouncesEnabled: util.actionMapping('setBouncesEnabled'),
	
	  bindPhone: util.actionMapping('bindPhone'),
	  pay: util.actionMapping('pay')
	};

/***/ }),
/* 332 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var util = __webpack_require__(317);
	
	var core = {
	  appVersion: '8.0.4',
	  thirdLogin: function(opt) {
	    var type = opt.type;
	    var url;
	    switch (type){
	      case 1:
	        url = location.protocol + '//m.dianping.com/auth/app?ft=15&sso=true';
	        break;
	      case 2:
	        url = location.protocol + '//m.dianping.com/auth/app?ft=6&sso=true&redir=';
	        break;
	      case 3:
	        url = location.protocol + '//m.dianping.com/auth/app?ft=5&ssp=true&redir=';
	        break;
	      case 4:
	        url = location.protocol + '//m.dianping.com/auth/app?ft=2&source=1&sso=true&redir=';
	        break;
	    }
	    this.openScheme({
	      url: 'dianping://loginweb?url=' + encodeURIComponent(url) + '&isFromNative=true',
	    });
	  },
	  getCX: function(opt) {
	    var success = opt.success;
	    opt.success = function(res) {
	      if (res.fingerprint) {
	        res.cx = res.fingerprint;
	      }
	      success(res);
	    }
	    this._send('getCX', opt);
	  },
	  uploadImage: function(opts) {
	    var success = opts.success;
	    var fail = opts.fail;
	    var handle = opts.handle;
	
	    if (opts.localId || opts.localIds) {
	
	      //兼容业务对localId单图上传的支持
	      if (opts.localId) {
	        opts.localIds = [opts.localId];
	        delete opts.localId;
	      }
	      
	      opts.success = function(res) {
	        var obj = {};
	        var _localId;
	        if (res.ret) {
	          res.ret.forEach(function(picItem, index) {
	            picItem.localId = picItem.localId || opts.localIds[index];
	            
	            _localId = picItem.localId;
	            obj[_localId] = picItem.picKey;
	          });
	          res.photoInfos = res.ret;
	          delete res.ret;
	        }
	        res.picKeys = obj;
	        success(res);
	      };
	
	      this._send('uploadPhoto', opts); 
	
	    } else {
	      this._sendMessage('uploadImage', opts, function(result) {
	        var status = result.status;
	        if (status == 'fail') {
	          fail && fail(result);
	          return;
	        } else {
	          handle && handle(result);
	        }
	      });
	    }
	  }
	};
	if (util.osName === 'ios') {//getOSName()
	  core.setStatusBarStyle = function(opt) {
	    if (opt.style === undefined) {
	      opt.style = 0;
	    }
	    this._send('setStatusBarStyle', opt);
	  }
	}
	module.exports = core;

/***/ }),
/* 333 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var util = __webpack_require__(317);
	
	module.exports = {
	  appVersion: '8.0.6',
	
	  share: function(opts) {
	    //直接分享渠道计数从1开始
	    if (opts.shareType !== undefined) {
	      if (util.osName === 'android') {
	        //Android下兼容shareType从1开始计数
	        opts.shareType += 1;
	      }
	    }
	    opts.feed = this._parseFeed(opts.feed);
	    opts.url = this._tidyUrlParams(opts.url);
	    
	    this._send('share', opts);
	  }
	
	};

/***/ }),
/* 334 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var util = __webpack_require__(317);
	
	var core = {
	    appVersion: '8.1.0'
	};
	
	if (util.osName === 'ios') {
	    core.getHealthData = function(opts) {
	        if (!opts) return;
	        // 目前支持的类型
	        var typeList = [1];
	        var type = opts.quantityType;
	        var fail = opts.fail;
	        // valid
	        if (~typeList.indexOf(type)) {
	            _handleDate(opts) && this._send('getHealthData', opts);
	        } else {
	            typeof fail == 'function' && fail('type error');
	        }
	
	        function _handleDate(opts) {
	            var start = opts.startDate;
	            var end = opts.endDate || new Date();
	            var fail = opts.fail;
	
	            start = +new Date(start);
	            end = +new Date(end);
	            if (start < end) {
	                // 单位：秒
	                opts.startDate = Math.round(start / 1000);
	                opts.endDate = Math.round(end / 1000);
	                return true;
	            } else {
	                typeof fail == 'function' && fail('date error');
	            }
	        }
	    };
	    core.prompt = function(opt) {
	        if (!opt.placeholder) {
	            opt.placeholder = '';
	        }
	        this._send('prompt', opt);
	    };
	}
	
	module.exports = core;


/***/ }),
/* 335 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var util = __webpack_require__(317);
	
	module.exports = {
	  appVersion: '8.1.2',
	
	  share: function(opts) {
	    
	    opts.feed = this._parseFeed(opts.feed);
	    opts.url = this._tidyUrlParams(opts.url);
	    
	    this._send('share', opts);
	  },
	  setBarrageEnabled: function(opts) {
	    this._send('setBarrageEnabled',opts);
	  }
	
	};

/***/ }),
/* 336 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var util = __webpack_require__(317);
	var batchAPI = [
	    'setLLButton',
	    'setLRButton',
	    'setRLButton',
	    'setRRButton'
	];
	
	var Core = module.exports = {
	    appVersion: '8.1.4',
	    publish: function(opt) {
	        var bizname = this._getBizName(opt);
	        var CONSTS = ['phoneChanged', 'AccountBindChange'];
	        if (/2Native/i.test(opt.type) || ~CONSTS.indexOf(opt.action)) {
	            delete opt.type;
	            this._send('publish', opt);
	        } else if (bizname) {
	            opt.action = bizname + ':' + opt.action;
	            delete opt.type;
	            this._send('publish', opt);
	        }
	    }
	};
	
	batchAPI.forEach(function (api) {
	  Core[api] = _actionMapping(api);
	});
	
	function _actionMapping(method) {
	    return function (opt) {
	        if (opt && opt.icon) {
	            opt.icon = _convertIcon(opt.icon);
	        }
	        this._send(method, opt);
	    };
	}
	
	function _convertIcon(icon) {
	    var mapList = {
	        'H5_Favorite_On': 'ic_action_favorite_on_normal',
	        'H5_Favorite_Off': 'ic_action_favorite_off_normal'
	    };
	    if (/android/i.test(util.osName)) {
	        return mapList[icon] || icon;
	    }
	    return icon;
	}

/***/ }),
/* 337 */
/***/ (function(module, exports, __webpack_require__) {

	var util = __webpack_require__(317);
	
	var Patch = {
		appVersion: '8.1.6',
		pickCity: function(opts) {
			var type = opts && opts.type;
			if (type === undefined || type == 0 || type == 1) {
				this._send('pickCity', opts);
			} else {
				console.log('param error');
				typeof opts.fail == 'function' && opts.fail();
			}
		},
		analyticsTag: function(opts) {
			if (opts && opts.channel && opts.key && opts.value) {
				typeof opts.value == 'string' || (opts.value = JSON.stringify(opts.value));
				this._send('analyticsTag', opts);
			} else {
				console.log('param error');
				typeof opts.fail == 'function' && opts.fail();
			}
		}
	};
	
	if (util.osName === 'ios') {
		Patch.setPullDown = function(opts) {
			var callCount = 0;
			var success = opts.success;
			opts.success = function(res) {
				//解决8.1.6 ios下无法区分success和handle事件的BUG
				callCount++;
				if (callCount > 1) {
					opts.handle(res);
				}else{
					success(res);
				}
			}
			this._send('setPullDown',opts);
		};
		
		Patch.getNetworkType = function(opts) {
			var success = opts.success;
			opts.success = function(res) {
				res.networkType = res.type;
				delete res.type;
				success(res);
			};
			this._send('getNetworkType',opts);
		};
	}
	
	module.exports = Patch;

/***/ }),
/* 338 */
/***/ (function(module, exports) {

	module.exports = ("1.7.0");

/***/ }),
/* 339 */
/***/ (function(module, exports) {

	module.exports = ("npm");

/***/ }),
/* 340 */
/***/ (function(module, exports) {

	//API currently implemented by dpapp
	module.exports = [
	    'config',
	    'ajax',
	
	    'isApiSupported',
	
	    'getFingerprint',
	    'getNetworkType',
	
	    'getUserInfo',
	    'login',
	    'logout',
	
	    'getCity',
	    'getLocationCity',
	    'getLocation',
	
	    'share',
	    'configShare',
	
	    'openWebview',
	    'closeWebview',
	    'jumpWebview',
	
	    'setTitle',
	    'setNavButtons',
	
	    'store',
	    'retrieve',
	
	    'chooseImage',
	    'uploadImage',
	    'previewImage',
	    'downloadImage',
	
	    'publish',
	    'subscribe',
	    'unsubscribe',
	
	    'setNavigationBarHidden',
	    'setBackgroundColor',
	    'setBouncesEnabled',
	    'setStatusBarStyle',
	    'setLLButton',
	
	    'alert',
	    'confirm',
	    'prompt',
	
	    'sendSMS',
	    'getContactList',
	
	    'setPullDown',
	    'stopPullDown',
	
	    'pickCity'
	  ];


/***/ }),
/* 341 */
/***/ (function(module, exports) {

	module.exports = {
	  'WECHAT_FRIENDS':0,
	  'WECHAT_TIMELINE': 1,
	  'QQ': 2,
	  'SMS': 3,
	  'WEIBO': 4,
	  'QZONE': 5,
	  'EMAIL': 6,
	  'COPY': 7
	};

/***/ }),
/* 342 */
/***/ (function(module, exports, __webpack_require__) {

	var request = __webpack_require__(343);
	
	module.exports = function logEvent (type, version) {
	  if (Math.random() >= 0.1) return;
	  var host;
	  var hosts = [
	    'dianping.com',  
	    'meituan.com', 
	    'sankuai.com', 
	    'meituan.net', 
	    'maoyan.com',
	    'm-zl-st.cfcmu.cn',
	    'm-zl.mucfc.com'
	  ];
	  var hostsBeta = [
	    'localhost',
	    '51ping.com',
	    'alpha.dp'
	  ];
	  for (var i = 0; i < hosts.length; i++) {
	    if (location.href.indexOf(hosts[i]) !== -1) {
	      host = 'm.dianping.com';
	      break;
	    }
	  }
	  if (!host) {
	    for (var j = 0; j < hostsBeta.length; j++) {
	      if (location.href.indexOf(hostsBeta[j])!==-1) {
	        host = 'm.51ping.com';
	      }
	    }
	  }
	  if (host) {
	    request({
	        url: '//' + host + '/mtnb/api/statistics',
	        data: {
	            version: version,
	            type: type
	        }
	    });    
	  }
	};

/***/ }),
/* 343 */
/***/ (function(module, exports) {

	var globalCount = 0;
	
	var urlStringify = function (url, data) {
	    if (!data) {
	        return url;
	    }
	    var param = [];
	    for (var o in data) {
	        if (data.hasOwnProperty(o)) {
	            param.push(o + '=' + data[o]);
	        }
	    }
	    return ~url.indexOf('?') ? url + param.join('&') : url + '?' + param.join('&');
	};
	
	/**
	 * jsonp
	 * */
	module.exports = function (options) {
	
	    if (!options.url) {
	        throw new Error('url request!');
	    }
	    var data = options.data || {};
	    var cb = options.onSuc || function () {
	    };
	    var cbName = data.callback = 'KNB' + (++globalCount) + (+new Date());
	
	    var script = document.createElement('script');
	    script.src = urlStringify(options.url, data);
	
	    window[cbName] = function (res) {
	        delete window[cbName];
	        script.parentNode.removeChild(script);
	        cb(res);
	    };
	
	    document.getElementsByTagName('head')[0].appendChild(script);
	};

/***/ }),
/* 344 */
/***/ (function(module, exports, __webpack_require__) {

	var Bridge = __webpack_require__(345)
	var baseAPIs = __webpack_require__(347)
	var mixin = __webpack_require__(285)
	var Semver = __webpack_require__(354)
	var version = __webpack_require__(286)
	var getUA = __webpack_require__(287)
	var util = __webpack_require__(356)
	
	var UA = getUA.internal()
	var titansVersion = UA._knbVersion
	var titansxVersion = UA.titansxVersion;
	var noop = function () {}
	
	var Titans = {
	  __version__: version,
	  // 拓展的API实现
	  // _apiFn_: {},
	  // 当前支持的API列表
	  apiList: [],
	  // 存储注册事件的回调
	  _eventQueue: {},
	  // 存储注册事件的ID，方便unsubscribe
	  _subscriptionMap: {},
	  _cfg: {},
	  config: function (config) {
	    this._cfg = mixin(this._cfg, config)
	    Bridge.config(config)
	  },
	  setBridge: function (bridge) { return Bridge.setBridge(bridge); },
	  getBizName: function () {return this._cfg.bizname},
	  ready: function (callback) { return Bridge.ready(callback); },
	  log: Bridge.log.bind(Bridge),
	  loadAPIs: function (ref) {
	    var type = ref.type; if ( type === void 0 ) type = 'base';
	    var apis = ref.apis; if ( apis === void 0 ) apis = [];
	
	    var self = this
	
	    apis
	      .filter(Boolean)
	      .forEach(function (API) {
	        var name = API.name || API.message
	        if (!name) return console.warn('[LoadAPI] fail', JSON.stringify(API))
	
	        // 针对版本过滤API，如果是基础API，参考版本为titansVersion,其他参考APP版本.
	        if (type === 'base' && API.version && Semver.lt(titansVersion, API.version)) return
	        if (type !== 'base' && API.version && Semver.lt(UA.appVersion, API.version)) return
	
	        // 针对操作系统过滤API
	        if (API.os && API.os !== UA.osName) return
	
	        // 记录添加的API
	        self.apiList.push(name)
	
	        if (typeof self[name] === 'function') Bridge.log('[API] ', name, ' overwrite default implementation')
	
	        self[name] = function (opts) {
	          var mapper = API.mapper || (function (x) { return x; })
	          opts = mapper.call(self, opts || {})
	          if (!opts) return;
	          // 如果mapper没有返回值，则表示方法被JS处理，无须发送消息到客户端
	          // 如果有handler，则表示参数被handler处理，无须发送消息到客户端
	          if (API.handler) return API.handler.call(self, opts)
	          // if has fall back, check if exists
	          if (API.fallback) {
	            return self._isApiSupported(API.message, function (supported) {
	                if (supported) return Bridge.callNative(API.message, opts);
	                return API.fallback(opts);
	            });
	          }
	          return Bridge.callNative(API.message, opts)
	        }
	        // 记录原始message及fallback
	        self[name].$MESSAGE = API.message
	        self[name].$FALLBACK = API.fallback;
	        // 给statics赋上，如KNB.share.WEIBO, KNB.share.WECHAT
	        Object.keys(API.statics || {}).forEach(function (key) { return self[name][key] = API.statics[key]; })
	      })
	  },
	  // 检查一个nativeApi是否存在
	  _isApiSupported: function (nativeApiName, success) {
	    return this.checkVersion({
	      apis: [nativeApiName],
	      success: function (data) {
	        var infos = data['infos'] || data['data']['infos'] || {}; // 容错
	        success(String(infos[nativeApiName]) !== "0")
	      },
	      fail: function () { return success(false); }
	    });
	  },
	  // 检查一个KNB方法是否存在
	  isApiSupported: function (ref) {
	    var apiName = ref.apiName;
	    var success = ref.success; if ( success === void 0 ) success = noop;
	
	    if (typeof this[apiName] === 'function') {
	      var message = this[apiName].$MESSAGE
	      if (!message) return success(true)   // 没有映射到native的，直接true
	      if (this[apiName].$FALLBACK) return success(true);  // 有fallback的，直接true
	      // 有映射到native的，询问native这个message是否存在
	      return this._isApiSupported(message, success);
	    }
	    return this._isApiSupported(apiName, success);
	  },
	  use: function (api, opts) {
	    if ( opts === void 0 ) opts={};
	
	    if (typeof this[api] === 'function') return this[api](opts);
	    return Bridge.callNative(api, opts)
	  },
	  pureUse: function(api, opts) {
	    if ( opts === void 0 ) opts={};
	
	    return Bridge.callNative(api, opts)
	  }
	}
	
	
	// 载入基础API
	Titans.loadAPIs({
	  type: 'base',
	  apis: baseAPIs
	});
	
	// 默认设置android的桥方式为prompt
	if (UA.osName === 'android') {
	  if (Semver.gte(UA.osVersion, '4.2.0') && typeof window.KNBTitansX === 'object' && window.KNBTitansX.sendMessage 
	    && Semver.gte(titansxVersion, '11.1.0')) {
	    Titans.setBridge({
	      name: 'interface',
	      delay: 50
	    })
	  } else {
	    Titans.setBridge({
	      name: 'prompt',
	      delay: 200
	    })
	  }
	}
	
	Titans.util = util
	module.exports = Titans


/***/ }),
/* 345 */
/***/ (function(module, exports, __webpack_require__) {

	var queue = __webpack_require__(346)
	var mixin = __webpack_require__(285)
	var noop = function () {}
	
	var callbackUtil = {
	  getName: function (callbackId) {
	    return 'DPApp_callback_' + callbackId
	  },
	  getId: function () {
	    var rand = Math.floor(Math.random() * 1000)
	    var timestampStr = (+new Date()).toString()
	    // 在DPAPP老版本中callbackId为int型，故只选取8位
	    var timestamp = timestampStr.substr(timestampStr.length - 5, 5)
	    return +(timestamp + '' + rand)
	  }
	}
	
	var isForceDebug = function () {
	  return location.href.indexOf('knb_force_titans_debug=1') > -1
	}
	
	var mtnbCBID = 1
	var messageHandlers = {}
	function regHandler (fn) {
	  var id = 'cb_' + (mtnbCBID++) + '_' + new Date().getTime()
	  messageHandlers[id] = fn
	  return id
	}
	
	var DPApp = {
	  _delay: 1000,
	  _isDebug: false,
	  _dequeueTimeout: null,
	
	  //防止@dp/app重写Titans的DPApp
	  __type__: 'npm',
	  __name__: 'titansX',
	  queue: undefined,
	  readyQueue: [],
	  _isReadying: false,
	  config: function (config) {
	    this._isDebug = config.debug
	    this._isReady = config.ready
	    this._delay = config.delay || 1000;
	  },
	  setBridge: function (bridge) {
	    if (typeof bridge === 'function') {
	      this._bridge = bridge
	      this._delay = 0
	    } else {
	      this._bridge = bridge.name
	      this._delay = bridge.delay
	    }
	  },
	  log: function () {
	    var arguments$1 = arguments;
	
	    var message = []
	    for (var i = 0; i < arguments.length; i++) {
	      if (typeof arguments$1[i] == 'string') {
	        message.push(arguments$1[i])
	      } else if (arguments$1[i] != undefined) {
	        message.push(JSON.stringify(arguments$1[i]))
	      }
	    }
	
	    if (this._isDebug || isForceDebug()) return setTimeout(function () { return alert(message.join(' ')); })
	    if (window._KNB_LOG) return window._KNB_LOG(message.join(' '))
	  },
	  ready: function (callback) {
	    var self = this
	    if (self._isReady) {
	      return callback && callback()
	    }
	
	    if (self._isReadying) {
	      return self.readyQueue.push(callback)
	    }else{
	      self._isReadying = true
	    }
	
	    self.log('[Auth   ]: 正在进行鉴权')
	    this.callNative('ready', {
	      success: function () {
	        self._isReady = true
	        self._isReadying = false
	        self.log('鉴权成功')
	        self.readyQueue.forEach(function(cb) {
	          cb && cb()
	        })
	        self.readyQueue = []
	
	        //fix config ready Bug
	        callback && callback();
	      },
	      fail: function (err) {
	        self.log('鉴权失败', err)
	      }
	    })
	  },
	  callNative: function (method, args) {
	    if ( args === void 0 ) args = {};
	
	    this.log('[Call  ]', method)
	    var self = this
	
	    function wrap (name, fn) {
	      return function (result) {
	        self.log(("[" + name + " ] " + method), result)
	        fn && fn.call(self, result)
	      }
	    }
	
	    // Wrap with log info
	    var fail = wrap('Failed', args.fail)
	    var success = wrap('Success', args.success)
	    var handle = wrap('Trigger', args.handle)
	
	    // adapt for MTNB proxy
	    args = mixin({
	      handlerId: regHandler(handle)
	    }, args)
	
	    self.enqueue(method, args, function (result) {
	      var status = result.status
	      var data = result.__isFromMTNB ? result.data : result
	      if (status === 'success' || String(status) == '0') return success(data)
	      if (status === 'action') return handle(data)
	      return fail(result);
	    })
	  },
	  enqueue: function (method, args, callback) {
	    var self = this
	    this.queue = this.queue || queue(function (ref) {
	      var method = ref.method;
	      var args = ref.args;
	      var callback = ref.callback;
	
	      return self.doSendMessage(method, args, callback);
	    })
	    this.log('[Enqueue]', method)
	    this.queue.push({method: method, args: args, callback: callback})
	    // run task every 1000ms if queue is not empty
	    this._dequeueTimeout = setTimeout(function () { return self.dequeue('Auto'); }, self._delay * self.queue.tasks.length)
	  },
	  dequeue: function (source) {
	    source = source || 'Native'
	    var self = this
	    this.log('[Dequeue]', 'by' , source)
	    setTimeout(function () {
	      self._dequeueTimeout && clearTimeout(self._dequeueTimeout);
	      self._dequeueTimeout = null
	      self.queue && self.queue.dequeue && self.queue.dequeue();
	    }, 0)
	  },
	  doSendMessage: function (method, args , callback) {
	    if ( args === void 0 ) args = {};
	
	    var callbackId = this.createCallback(callback, !!args.handle);
	
	    args = JSON.stringify(args)
	
	    var message = 'js://_?method=' + method + '&args=' + encodeURIComponent(args) + '&callbackId=' + callbackId
	    this.log('[Send]', method, 'with callbackId:', callbackId, 'has params: ', args)
	
	    if (typeof this._bridge === 'function') return this._bridge(message)
	    if (this._bridge === 'prompt') return this.sendByPrompt(message)
	    if (this._bridge === 'interface') return this.sendByInterface(message)
	    this.sendByIframe(message)
	  },
	  sendByPrompt: function (message) {
	    this.log('[Send By Prompt]', message)
	    window.prompt(message)
	  },
	  sendByInterface: function (message){
	    this.log('[Send By Interface]', message)
	    window.KNBTitansX && window.KNBTitansX.sendMessage(message);
	  },
	  sendByIframe: function (message) {
	    this.log('[Send By iframe]', message)
	    var node = document.createElement('iframe')
	    node.style.display = 'none'
	
	    var removeNode = function () {
	      node.onload = node.onerror = null
	      node.parentNode && node.parentNode.removeChild(node)
	    }
	
	    /*
	      remove node after loaded or error
	      */
	    node.onload = node.onerror = removeNode
	    setTimeout(removeNode, 3000)
	    node.src = message;
	    (document.body || document.documentElement).appendChild(node)
	  },
	  createCallback: function (callback, isHandleExisted) {
	    var callbackId = 0, callbackName
	
	    if (typeof callback === 'function') {
	      callbackId = callbackUtil.getId()
	      callbackName = callbackUtil.getName(callbackId)
	      window[callbackName] = callback;
	
	      // 没有handle回调，可以安全清除
	      callback.isSafeDelete = !isHandleExisted;
	    }
	
	    return callbackId
	  },
	  //Titans的调用callback时,把callbackId绑定在了window上,然后native调用window[callbackId]
	  callback: function (callbackId, retValue, isFromMTNB) {
	    this.log('[Call Callback]', callbackId)
	    // handle message from native
	    var win = window;
	    var self = this;
	    var callbackName = callbackUtil.getName(callbackId)
	    var callback = window[callbackName]
	    if (!callback) return
	    if (retValue && isFromMTNB) retValue.__isFromMTNB = true
	    setTimeout(function () {
	      callback.call(self, retValue);
	      
	      // force gc
	      if (callback.isSafeDelete) {
	        win[callbackName] = null;
	        delete win[callbackName];
	      }
	    }, 0)
	  }
	}
	
	// Adapt for MTNB call from Native
	if (window.MTNB) {
	  console.log('you env has already register MTNB')
	} else {
	  // Declare the ability of dealing with MTNB callback
	  window.MTNB = {
	    _handleMessageFromApp: function _handleMessageFromApp(message) {
	      DPApp.log('[MTNB] ', 'get message:' , message)
	      if (message.callbackId) return DPApp.callback(message.callbackId, message.data, true)
	      return (messageHandlers[message.handlerId] || noop)(message.data)
	    }
	  }
	}
	
	//覆盖Hippo   Hippo须保证在1.2.27以上版本
	if (!window.DPApp || window.DPApp.__type__ === 'hippo') {
	  window.DPApp = DPApp
	  DPApp.ready() // init first
	}else if(window.DPApp.__name__ === 'titansX'){
	  //防止titansX的DPApp重复加载
	  DPApp = window.DPApp
	}else if(window.DPApp && window.DPApp.dequeue){
	  //titans DPApp非全局DPApp时，释放队列
	  var _origin = window.DPApp.dequeue
	  window.DPApp.dequeue = function(){
	    _origin.apply(window.DPApp, arguments)
	    DPApp.dequeue.apply(DPApp, arguments)
	  }
	}
	
	
	
	if (isForceDebug()) alert('[Titans UA] ' + navigator.userAgent)
	
	module.exports = DPApp


/***/ }),
/* 346 */
/***/ (function(module, exports) {

	//队列管理
	module.exports = function queue(worker){
	  var currentCallback = null;
	  return {
	    timeout: null,
	    running : false,
	    tasks: [],
	    push: function(data, cb){
	      var callback = cb || function(){};
	      var self = this;
	      this.tasks.push({
	        data: data,
	        callback: callback
	      });
	      //当任务被放入队列后马上调用process处理，在process中如果running:false就可以立马运行
	      setTimeout(function(){
	        self.process();
	      }, 0);
	    },
	    dequeue: function(){
	      if(currentCallback){
	        currentCallback();
	      }else{
	        this.running = false;
	      }
	    },
	    process: function(){
	      var self = this;
	      if(this.tasks.length && !this.running){
	        var task = self.tasks.shift();
	        self.running = true;
	        currentCallback = function(){
	          self.running = false;
	          task.callback(task.data);
	          self.process();
	        };
	        worker(task.data, currentCallback);
	      }
	    }
	  };
	};

/***/ }),
/* 347 */
/***/ (function(module, exports, __webpack_require__) {

	var subscribe = __webpack_require__(348)
	var unsubscribe = __webpack_require__(349)
	var getUA = __webpack_require__(287)
	var mixin = __webpack_require__(285)
	var noop = function () {}
	var getNetworkType = __webpack_require__(350)
	var share = __webpack_require__(351)
	var qs = __webpack_require__(288)
	var isWebProtocal = __webpack_require__(352)
	var picConverter = __webpack_require__(353);
	var semver = __webpack_require__(354);
	
	var qparams = __webpack_require__(355)(location.href);
	
	function prependBizName (key, fail) {
	  var bizName = this.getBizName()
		if (key.indexOf(':') > -1) return key
		if (bizName) return bizName + ':' + key
		this.log('bizname not configed')
		fail('bizname not config, please call KNB.confg({bizName: YOUR_BIZ_NAME})')
	}
	
	function getWebviewURI() {
	  return window.TITANS_WEB_VIEW_URI || 'dianping://web'
	}
	
	module.exports = [
	  {
	    message: 'checkVersion'
	  },{
	    message: 'getApisVersion',
	    handler: function(ref) {
	      var success = ref.success; if ( success === void 0 ) success = noop;
	      var apis = ref.apis; if ( apis === void 0 ) apis = [];
	      var fail = ref.fail; if ( fail === void 0 ) fail = noop;
	
	      this.checkVersion({
	        apis: apis,
	        success: function (data) {
	          var infos = data['infos'] || data['data']['infos'] || {}; // 容错
	          success(apis.map(function (api) {
	            return String(infos[api]);
	          }));
	        },
	        fail: fail
	      });
	    }
	  },{
	    message: 'actionSheet'
	  }, {
	    message: 'alert'
	  }, {
	    name: 'closeWebview',
	    message: 'closeWindow'
	  }, {
	    message: 'getContactList'
	  }, {
	    name: 'getUA',
	    handler: getUA
	  }, {
	    message: 'confirm'
	  }, {
	    message: 'getVersion'
	  }, {
	    message: 'isInstalledApp'
	  }, {
	    message: 'pickContact'
	  }, {
	    message: 'prompt'
	  }, {
	    message: 'publish',
	    mapper: function (ref) {
	      var type = ref.type;
	      var action = ref.action;
	      var success = ref.success; if ( success === void 0 ) success = noop;
	      var fail = ref.fail; if ( fail === void 0 ) fail = noop;
	      var data = ref.data;
	      var info = ref.info;
	
	      //fix mtnb 实现bug(for attribute data && info);
	      if (type === 'native') return {action: action, success: success, fail: fail, data: info || data}
	      var actionName = prependBizName.call(this, action, fail)
	      if (actionName) return {action: actionName, success: success, fail: fail, data: info || data}
	    }
	  }, {
	    message: 'remove',
	    mapper: function (ref) {
	      var type = ref.type;
	      var key = ref.key;
	      var success = ref.success; if ( success === void 0 ) success = noop;
	      var fail = ref.fail; if ( fail === void 0 ) fail = noop;
	
	      if (type === 'native') return {key: key, success: success, fail: fail}
	      var newkey = prependBizName.call(this, key, fail)
	      if (newkey) return {key: newkey, success: success, fail: fail}
	    }
	  }, {
	    message: 'retrieve',
	    mapper: function (ref) {
	      var type = ref.type;
	      var key = ref.key;
	      var success = ref.success; if ( success === void 0 ) success = noop;
	      var fail = ref.fail; if ( fail === void 0 ) fail = noop;
	
	      if (type === 'native') return {key: key, success: success, fail: fail}
	      var newkey = prependBizName.call(this, key, fail)
	      if (newkey) return {key: newkey, success: success, fail: fail}
	    }
	  }, {
	    message: 'store',
	    mapper: function (ref) {
	      var type = ref.type;
	      var key = ref.key;
	      var value = ref.value;
	      var success = ref.success; if ( success === void 0 ) success = noop;
	      var fail = ref.fail; if ( fail === void 0 ) fail = noop;
	
	      if (type === 'native') return {key: key, value: value, success: success, fail: fail}
	      var newkey = prependBizName.call(this, key, fail)
	      if (newkey) return {key: newkey, value: value, success: success, fail: fail}
	    }
	  }, {
	    message: 'setLLButton'
	  }, {
	    message: 'setLRButton'
	  }, {
	    message: 'setRLButton'
	  }, {
	    message: 'setRRButton'
	  }, {
	    message: 'setTitle'
	  }, {
	    message: 'sendSMS'
	  }, {
	    message: 'setBackgroundColor'
	  }, {
	    message: 'setNavigationBarHidden',
	    os: 'android'
	  }, {
	    message: 'setBouncesEnabled',
	    os: 'ios'
	  }, {
	    message: 'setScrollEnabled',
	    os: 'ios'
	  }, {
	    message: 'setStatusBarStyle',
	    os: 'ios',
	    mapper: function (_opts) {
	      var opts = mixin({}, _opts)
	      if (opts.style === undefined) opts.style = 0
	      return opts
	    }
	  },
	  {
	    name: 'setNavButtons',
	    handler: function (opts) {
	      var this$1 = this;
	
	      [].concat(opts).forEach(function (btnConfig) {
	        var nobj = mixin({}, btnConfig) // create a copy
	        delete nobj.position
	        nobj.icon = btnConfig.type === 'base64' ? (btnConfig.icon || '').split('data:image/png;base64,')[1] : nobj.icon
	        this$1['set' + btnConfig.position + 'Button'](nobj)
	      })
	    }
	  },
	  {
	    message: 'bind'
	  },
	  {
	    message: 'chooseImage',
	    mapper: function (opts) {
	      if (!opts.quality) {
	        opts.quality = 50;
	      }
	      return opts;
	    }
	  },
	  {
	    message: 'downloadImage'
	  },
	  {
	    name: 'getCity',
	    message: 'getCityInfo'
	  },
	  {
	    message: 'getUserInfo',
	    mapper: function (opt) {
	      return mixin({}, opt, {
	        success: function (result) { return opt.success(mixin(result, {
	          token: result.token || result.userToken,
	          uuid: result.uuid || qparams.uuid
	        })); }
	      });
	    }
	  },
	  {
	    message: 'getFingerprint'
	  },
	  {
	    message: 'getLocation',
	    mapper: function (opts) {
	      if (!opts.timeout) {
	        opts.timeout = 6000;
	      }
	      return opts;
	    }
	  }, {
	    // @deprecated
	    name: 'getLocationCity',
	    message: 'getCityInfo',
	    mapper: function (opt) {
	      return mixin({}, opt, {
	        success: function (cityInfo) { return opt.success(mixin(cityInfo, {cityId: cityInfo.locCityId})); }
	      });
	    }
	  }, {
	    // @dp
	    message: 'getFingerprint',
	    name: 'getCX'
	  }, {
	    message: 'analyticsTag',
	    version: '8.1.6'
	  },
	  {
	    name: 'jumpWebview',
	    message: 'jumpToScheme',
	    mapper: function (opts) {
	      if (isWebProtocal(opts.url)) {
	        return mixin({}, opts, {
	          url: getWebviewURI() + '?' + qs.stringify(mixin({url: opts.url}, opts.qs))
	        });
	      }
	
	      return opts;
	    }
	  },
	  {
	    name: 'openWebview',
	    message: 'openScheme',
	    mapper: function (opts) {
	      if (isWebProtocal(opts.url)) {
	        return mixin({}, opts, {
	          url: getWebviewURI() + '?' + qs.stringify(mixin({url: opts.url}, opts.qs))
	        });
	      }
	
	      return opts;
	    }
	  },
	  {
	    name: 'configShare',
	    handler: function (opts) {
	      var this$1 = this;
	
	      opts = mixin({}, opts)
	      var handle = opts.handle || noop
	      delete opts.handle
	      this.setRRButton({
	        icon: 'H5_Share',
	        handle: function () {
	          handle()
	          this$1.share(opts)
	        }
	      })
	    }
	  },
	  {
	    message: 'pickCity'
	  },
	  {
	    message: 'analyticsTag'
	  },
	  {
	    message: 'setBarrageEnabled'
	  },
	  {
	    message: 'getHealthData',
	    os: 'ios',
	    mapper: function (_opts) {
	      if (!_opts) return
	      var opts = mixin({}, _opts)
	      // 目前支持的类型
	      var typeList = [1]
	      var type = opts.quantityType
	      var fail = opts.fail || noop
	
	      var start = +new Date(opts.startDate)
	      var end = +new Date(opts.endDate || new Date())
	      if (start > end) { fail('date error'); return; }
	      if (typeList.indexOf(type) === -1) { fail('type error'); return; }
	      // 单位：秒
	      opts.startDate = Math.round(start / 1000)
	      opts.endDate = Math.round(end / 1000)
	      return opts
	    }
	  },
	  {
	    message: 'mapi',
	    name: 'ajax',
	    mapper: function (_opts) {
	      var opts = mixin({}, _opts)
	      var self = this;
	      opts = this.util.sanitizeAjaxOpts(opts)
	      var success = opts.success || noop;
	      opts.success = function (ret) {
	        var result = JSON.parse(ret.mapiResult)
	        result = self.util.transModel(opts.keys, result)
	        success(result)
	      };
	      return opts
	    }
	  },
	  {
	    message: 'login',
	    mapper: function (opts) {
	      var success = opts.success || noop
	      // 新版Titans增加type字段标识用户类型
	      return mixin({}, opts, {
	        success: function (res) {
	          success(mixin({}, res, res.dpid ? {type: 'dp'} : {}, {token: res.token || res.userToken}))
	        }
	      })
	    }
	  },
	  {
	    message: 'logout'
	  },
	  {
	    message: 'pay'
	  },
	  {
	    message: 'playVoice'
	  },
	  {
	    message: 'previewImage'
	  },
	  {
	    message: 'setPullDown'
	  },
	  {
	    message: 'stopPullDown'
	  },
	  {
	    message: 'setNavigationBarHidden',
	    os: 'ios'
	  },
	  {
	    message: 'uploadPhoto',
	    name: 'uploadImage',
	    mapper: function (_opts) {
	      var opts = mixin({}, _opts);
	      var success = opts.success || noop;
	
	      if (!opts.bucket) {
	        opts.bucket = opts.clientId = 'knb';
	      } else if (!opts.clientId) {
	        opts.clientId = opts.bucket;
	      }
	
	      opts.success = function (result) {
	        result.photoInfos = (result.photoInfos || result.ret || []).map(function (photo) {
	          var picKey = picConverter(photo.picKey);
	          var picUrl = picConverter(photo.picUrl);
	          return mixin({}, photo, {
	            picKey: picUrl,
	            originalKey: photo.picKey,
	
	            //对齐点评picKey和picUrl的语义
	            picUrl: picUrl || (/^https?:\/\//.test(picKey) ? picKey : null),
	            originalUrl: photo.picKey || photo.picUrl
	          })
	        });
	        success(result);
	      }
	
	      return opts;
	    }
	  },
	  {
	    message: 'vibrate'
	  },
	  {
	    message: 'toast'
	  },
	  {
	    message: 'autoLock'
	  },
	  {
	    message: 'lxlog'
	  },
	  {
	    message: 'Semver',
	    statics: semver
	  },
	  {
	    message: 'checkAuthorization'
	  },
	  {
	    message: 'capture'
	  },
	  {
	    message: 'shareImage',
	    statics: {
	      WECHAT_FRIENDS: 0,
	      WECHAT_TIMELINE: 1
	    }
	  },
	  {
	    message: 'setSearchBar'
	  },
	  {
	    message: 'scanQRCode'
	  },
	  {
	    message: 'setResult',
	    statics: {
	      "RESULT_OK": -1,
	      "RESULT_CANCELED": 0
	    }
	  },
	  {
	    //mt 8.5
	    message: 'getResult',
	    mapper: function(opts){
	      var originSuccess = opts.success || noop;
	      return mixin({}, opts, {
	        success: function (res) {
	          originSuccess(mixin({}, {
	            resultData: res.resp ? res.resp.resultData : res.resultData,
	            resultCode: res.resp ? res.resp.resultCode : res.resultCode
	          }));
	        }
	      }) 
	    }
	  },
	  { 
	    //mt 8.5
	    message: 'setImageTitle'
	  },
	  {
	    message: 'shark'
	  },
	  {
	    message: 'chooseMedia',
	  },
	  {
	    message: 'playMedia'
	  },
	  {
	    message: 'editMedia'
	  },
	  {
	    message: 'uploadMedia'
	  },
	  {
	    message: 'getDeviceInfo'
	  },
	  {
	    message: 'showKeyboard',
	    os: 'android'
	  },
	  {
	    message: 'sendLog',
	    mapper: function(opts){
	      return mixin({}, opts, {
	        time: +new Date(),
	        page: location.href
	      });
	    }
	  },
	  {
	    message: 'shareMiniProgram'
	  },
	  {
	    message: 'addRequestSignature',
	    mapper: function(ref){
	      var method = ref.method;
	      var url = ref.url;
	      var body = ref.body; if ( body === void 0 ) body = "";
	      var header = ref.header; if ( header === void 0 ) header = {};
	      var success = ref.success; if ( success === void 0 ) success = noop;
	      var fail = ref.fail; if ( fail === void 0 ) fail = noop;
	
	      var contentType = header.contentType; if ( contentType === void 0 ) contentType = "";
	      var contentEncoding = header.contentEncoding; if ( contentEncoding === void 0 ) contentEncoding = "";
	      var originSuccess = success;
	      var userAgent = navigator.userAgent || "";
	      return {
	        method: method, 
	        url: url, 
	        body: body, 
	        header:{contentType: contentType, userAgent: userAgent, contentEncoding: contentEncoding},
	        success: function (res) {
	          var url = res.url || '';
	          if(url.indexOf('://') === -1){
	            res.url = decodeURIComponent(url);
	          }
	          originSuccess(res);
	        }, 
	        fail: fail
	      };
	    }
	  },
	  {
	    message: 'stopLocating'
	  }
	
	].concat([subscribe, unsubscribe, getNetworkType, share])


/***/ }),
/* 348 */
/***/ (function(module, exports) {

	var pageEvents = ['appear', 'disappear'];
	var count = 0;
	var getRandomId = function () { return ('sub' + (++count)); }
	var noop = function() {}
	
	module.exports = {
	  message: 'subscribe',
	  mapper: function(ref) {
	    var action = ref.action;
	    var handle = ref.handle; if ( handle === void 0 ) handle = noop;
	    var success = ref.success; if ( success === void 0 ) success = noop;
	    var fail = ref.fail; if ( fail === void 0 ) fail = noop;
	
	
	    this._eventQueue = this._eventQueue || {};
	    this._subscriptionMap = this._subscriptionMap || {};
	    var subId = getRandomId();
	
	    this._subscriptionMap[subId] = {action: action, handle: handle};
	
	    var _events = this._eventQueue;
	    var eventName = action;
	
	    var eventHandler = function(e) {
	      (_events[eventName] || []).filter(Boolean).forEach(function (fn) { return fn(e); });
	    };
	
	    function registerPageEvents() {
	      if (!eventName) return;
	      var capital = function (str) { return str.slice(0,1).toUpperCase() + str.slice(1); };
	      if (window.DPApp) window.DPApp['on' + capital(eventName)] = eventHandler;
	      success({subId: subId});
	    }
	
	    if (_events[eventName]) {
	      //事件只需要向客户端注册一次，事件队列有JS段维护
	      success({subId: subId});
	      _events[eventName].push(handle);
	      return;
	    }
	
	    _events[eventName] = [handle];
	
	    //页面级别事件 appear/disappear 直接注册在DPApp全局对象下，事件触发时客户端会直接调用
	    if (pageEvents.indexOf(eventName) !== -1) return registerPageEvents()
	    return {
	      action: eventName,
	      success: function () { return success({subId: subId}); },
	      handle: eventHandler,
	      fail: fail
	    };
	  }
	};


/***/ }),
/* 349 */
/***/ (function(module, exports) {

	module.exports = {
	  message: 'unsubscribe',
	  mapper: function(opts) {
	    var _events = this._eventQueue;
	    this._subscriptionMap = this._subscriptionMap || {};
	
	    var handle = opts.handle;
	    var eventName = opts.action;
	    var success = opts.success || function(){};
	    var subId = opts.subId;
	
	    var subscription = this._subscriptionMap[subId];
	    if (subscription) {
	      eventName = subscription.action;
	      handle = subscription.handle;
	    }
	
	    if (_events[eventName]) {
	      _events[eventName] = (_events[eventName] || []).filter(function (h) { return h != handle; });
	      // 都不传，则直接取消所有
	      if (!handle && !subId) {
	        _events[eventName] = [];
	      }
	    }
	
	    success();
	
	    // 需要清理JS上注册的subscription吗？应该没什么必要。
	  }
	};


/***/ }),
/* 350 */
/***/ (function(module, exports, __webpack_require__) {

	var getUA = __webpack_require__(287).internal;
	var noop = function(){};
	
	var _iOSNetworkType = function(result) {
	  var types = {
	    kSCNetworkReachabilityFlagsTransientConnection: 1 << 0,
	    kSCNetworkReachabilityFlagsReachable: 1 << 1,
	    kSCNetworkReachabilityFlagsConnectionRequired: 1 << 2,
	    kSCNetworkReachabilityFlagsConnectionOnTraffic: 1 << 3,
	    kSCNetworkReachabilityFlagsInterventionRequired: 1 << 4,
	    kSCNetworkReachabilityFlagsConnectionOnDemand: 1 << 5,
	    kSCNetworkReachabilityFlagsIsLocalAddress: 1 << 16,
	    kSCNetworkReachabilityFlagsIsDirect: 1 << 17,
	    kSCNetworkReachabilityFlagsIsWWAN: 1 << 18
	  };
	  var type = +result.type;
	  var subType = result.subType;
	  var returnValue;
	  // 2g, 3g, 4g
	  function getMobileType(subType) {
	    switch (subType) {
	      case 'CTRadioAccessTechnologyGPRS':
	      case 'CTRadioAccessTechnologyEdge':
	      case 'CTRadioAccessTechnologyCDMA1x':
	        return '2g';
	      case 'CTRadioAccessTechnologyLTE':
	        return '4g';
	      case 'CTRadioAccessTechnologyWCDMA':
	      case 'CTRadioAccessTechnologyHSDPA':
	      case 'CTRadioAccessTechnologyHSUPA':
	      case 'CTRadioAccessTechnologyCDMAEVDORev0':
	      case 'CTRadioAccessTechnologyCDMAEVDORevA':
	      case 'CTRadioAccessTechnologyCDMAEVDORevB':
	      case 'CTRadioAccessTechnologyeHRPD':
	        return '3g';
	    }
	  }
	
	  if ((type & types.kSCNetworkReachabilityFlagsReachable) == 0) {
	    return 'none';
	  }
	
	  if ((type & types.kSCNetworkReachabilityFlagsConnectionRequired) == 0) {
	    // if target host is reachable and no connection is required
	    //  then we'll assume (for now) that your on Wi-Fi
	    returnValue = 'wifi';
	  }
	
	
	  if (
	    (type & types.kSCNetworkReachabilityFlagsConnectionOnDemand) != 0 ||
	    (type & types.kSCNetworkReachabilityFlagsConnectionOnTraffic) != 0
	  ) {
	    // ... and the connection is on-demand (or on-traffic) if the
	    //     calling application is using the CFSocketStream or higher APIs
	    if ((type & types.kSCNetworkReachabilityFlagsInterventionRequired) == 0) {
	      // ... and no [user] intervention is needed
	      returnValue = 'wifi';
	    }
	  }
	
	  if ((type & types.kSCNetworkReachabilityFlagsIsWWAN) == types.kSCNetworkReachabilityFlagsIsWWAN) {
	    // ... but WWAN connections are OK if the calling application
	    //     is using the CFNetwork (CFSocketStream?) APIs.
	    returnValue = getMobileType(subType);
	  }
	
	  return returnValue;
	};
	var _androidNetworkType = function(result) {
	  var type = result.type;
	  var subType = result.subType;
	
	  if (type == 0) {
	    switch (subType) {
	      case 1:
	      case 2:
	      case 4:
	      case 7:
	      case 11:
	        return '2g';
	      case 3:
	      case 5:
	      case 6:
	      case 8:
	      case 9:
	      case 10:
	      case 12:
	      case 14:
	      case 15:
	        return '3g';
	      case 13:
	        return '4g';
	    }
	  }
	
	  if (type == 1) {
	    return 'wifi';
	  } else {
	    return 'none';
	  }
	};
	var getNetwork = function(res) {
	  if (/wifi|2g|3g|4g/.test(res.type)) return res.type;
	  switch (getUA().osName) {
	    case 'ios': return _iOSNetworkType(res);
	    case 'android': return _androidNetworkType(res);
	  }
	  return 'unknown';
	};
	
	module.exports = {
	  message: 'getNetworkType',
	  mapper: function(ref) {
	    var success = ref.success; if ( success === void 0 ) success = noop;
	    var fail = ref.fail; if ( fail === void 0 ) fail = noop;
	
	    return {
	      success: function(result) {
	        success({
	          networkType: result.networkType || getNetwork(result)
	        });
	      },
	      fail: fail
	    };
	  }
	};


/***/ }),
/* 351 */
/***/ (function(module, exports, __webpack_require__) {

	
	var isAndroid =  (navigator.userAgent || '').match(/Android/i);
	var mixin = __webpack_require__(285);
	
	function noop() {}
	
	var channels = [
	  'WECHAT_FRIENDS',
	  'WECHAT_TIMELINE',
	  'QQ',
	  'SMS',
	  'WEIBO',
	  'QZONE',
	  'EMAIL',
	  'COPY'
	]
	
	/*
	 * MT 7.6 Android沿用MTNB渠道调用
	 * MT 7.6 iOS使用titans 渠道分享
	 * both of them are incorrect!!
	 * */
	function getChannel() {
	    if(isAndroid){
	        return {
	            'WECHAT_FRIENDS': 128,
	            'WECHAT_TIMELINE': 256,
	            'QQ': 512,
	            'SMS': 32,
	            'WEIBO': 1,
	            'QZONE': 2,
	            // not supported
	            'EMAIL': 0,
	            'COPY': 0
	        }
	    } else {
	        return {
	            'WECHAT_FRIENDS': 0,
	            'WECHAT_TIMELINE': 1,
	            'QQ': 2,
	            'SMS': 3,
	            'WEIBO': 4,
	            'QZONE': 5,
	            'EMAIL': 6,
	            'COPY': 7
	        }
	    }
	}
	
	function sum(array) {
	    if (!array) return 0;
	    var s = 0;
	    for (var i = 0; i < array.length; i++) {
	        s += array[i];
	    }
	    return s;
	}
	
	module.exports = {
	    message: 'share',
	    statics: getChannel(),
	    mapper: function (ref) {
	        var title = ref.title;
	        var desc = ref.desc;
	        var content = ref.content;
	        var image = ref.image;
	        var url = ref.url;
	        var channel = ref.channel;
	        var miniProgram = ref.miniProgram;
	        var success = ref.success; if ( success === void 0 ) success = noop;
	        var fail = ref.fail; if ( fail === void 0 ) fail = noop;
	
	        var feed = channel !== undefined ? [].concat(channel) : 0
	        // 如果只传入一个渠道，那么就直接分享出去
	        // 将渠道常量作为八位二进制
	        var feedBinary = this.util.parseFeed(feed);
	        url = this.util.tidyUrlParams(url);
	        var originalSuccess = success;
	        
	        var opt = {
	            title: title,
	            desc: desc,
	            content: content,
	            image: image,
	            success: function(res){
	              if(res.channel != undefined) {
	                res.sharedTo = {};
	                channels.forEach(function (ele, i) {res.sharedTo[ele] = (i === res.channel)});
	              }
	              originalSuccess(res);
	            },
	            shareType: isAndroid ? sum(feed) : feedBinary,
	            fail: fail,
	            url: this.util.tidyUrlParams(url)
	        }
	        if(!miniProgram) return opt;
	
	        if(isAndroid){
	            var miniProgramId = miniProgram.id;
	            var miniProgramPath = miniProgram.path;
	            var miniProgramImage = miniProgram.image;
	            return mixin(opt,{miniProgramId: miniProgramId, miniProgramPath: miniProgramPath, miniProgramImage: miniProgramImage});
	        } else {
	            return mixin(opt,{miniProgram: miniProgram});
	        }
	    }
	}


/***/ }),
/* 352 */
/***/ (function(module, exports) {

	/**
	 * @params string url
	 * @return boolean is Web Protocol
	 * can detect string starts with http, https, //
	 * */
	module.exports = function (url) {
	    return /^http:|^https:|^\/\//i.test(url);
	};


/***/ }),
/* 353 */
/***/ (function(module, exports) {

	/*
	* 将HTTP的美团Venus图片URL 转成HTTPS
	**/
	
	module.exports = function (httpUrl) {
	    if (!httpUrl) {
	        httpUrl = '';
	    }
	    return httpUrl.replace(/^http:\/\/(p0|p1|img)\.meituan\.net\//, 'https://img.meituan.net/');
	};


/***/ }),
/* 354 */
/***/ (function(module, exports) {

	//版本比较方法
	module.exports = {
	  eq: function(a, b) {
	    return a === b;
	  },
	  gt: function(a, b) {
	    var splitedA = a ? a.split('.') : [];
	    var splitedB = b ? b.split('.') : [];
	    [0,1,2].forEach(function(i){
	      splitedA[i] = splitedA[i] || 0;
	      splitedB[i] = splitedB[i] || 0;
	    });
	    if (+splitedA[0] !== +splitedB[0]) {
	      return +splitedA[0] > +splitedB[0];
	    } else {
	      if (+splitedA[1] !== +splitedB[1]) {
	        return +splitedA[1] > +splitedB[1];
	      } else {
	        return +splitedA[2] > +(splitedB[2] || 0);
	      }
	    }
	  },
	  lt: function(a, b) {
	    return !this.gte(a, b);
	  },
	  gte: function(a, b) {
	    return this.eq(a, b) || this.gt(a, b);
	  },
	  lte: function(a, b) {
	    return this.eq(a, b) || this.lt(a, b);
	  }
	};

/***/ }),
/* 355 */
/***/ (function(module, exports) {

	function getQueryObject(str) {
		var questionMark = str.indexOf('?');
		var sharpMark = str.indexOf('#');
	
		if (questionMark === -1) return {};
	
		var qs = sharpMark > -1 ? str.slice(questionMark + 1, sharpMark) : str.slice(questionMark + 1);
	
	  var qparams = {};
	  var q = qs.split('&');
	
	  for (var i = 0; i <  q.length; i++){
	    var pair = q[i].split('=');
	    qparams[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1]);
		}
		return qparams;
	}
	
	module.exports = getQueryObject;


/***/ }),
/* 356 */
/***/ (function(module, exports) {

	module.exports = {
	  tidyUrlParams: function(url){
	    //移除url中的登陆态信息，防止在分享时被泄露
	    var splited = url.split('?');
	    var qs = splited[1];
	    var reserved = [];
	    if (!qs) {
	      return splited[0];
	    } else {
	      qs.split('&').forEach(function(q){
	        var arr = q.split('=');
	        var key = arr[0];
	        var value = arr.length? arr[1]:undefined;
	        if(!/^(newtoken|token)$/.test(key) && !(key ==='product' && value === 'dpapp')){
	          reserved.push(q);
	        }
	      });
	      return [splited[0], reserved.join('&')].join('?');
	    }
	  },
	  sanitizeAjaxOpts: function(args) {
	    args.method = args.method || 'get';
	    args.data = args.data || '';
	    var url = args.url;
	    var data = args.data;
	
	    if (args.method == 'get') {
	      var params = [];
	      for (var p in data) {
	        if (data.hasOwnProperty(p) && (data[p] || data[p] === 0)) {
	          params.push(p + '=' + encodeURIComponent(data[p]));
	        }
	      }
	
	      if (params.length) {
	        url += url.indexOf('?') == -1 ? '?' : '&';
	        url += params.join('&');
	      }
	      args.url = url;
	      delete args.data;
	    }
	    return args;
	  },
	  parseFeed: function(f){
	    //分享渠道映射
	    var feed;
	    if (!f) {
	      return 0xff;
	    } else if (f.constructor.toString().indexOf('Array') >= 0) {
	      feed = [0, 0, 0, 0, 0, 0, 0, 0];
	      f.forEach(function(pos) {
	        feed[7 - pos] = 1;
	      });
	      return parseInt(feed.join(''), 2);
	    }
	  }, 
	  transModel: function(keys, obj){
	    //MAPI model转换
	    if(!keys){return obj;}
	    var keymap = {};
	
	    function getHash(str) {
	      var hashCode = function(str) {
	        var hash = 0,
	          i, chr, len;
	        if (str.length == 0) return hash;
	        for (i = 0, len = str.length; i < len; i++) {
	          chr = str.charCodeAt(i);
	          hash = ((hash << 5) - hash) + chr;
	          hash |= 0; // Convert to 32bit integer
	        }
	        return hash;
	      };
	
	      var i = hashCode(str);
	      return '0x' + ((0xFFFF & i) ^ (i >>> 16)).toString(16);
	    }
	
	    function isArray(val) {
	      return Object.prototype.toString.call(val) == '[object Array]';
	    }
	
	    function isObject(val) {
	      return Object.prototype.toString.call(val) == '[object Object]';
	    }
	
	    function translate(obj){
	      if (isObject(obj)) {
	        delete obj.__name;
	        for (var key in obj) {
	          var val;
	          if (keymap[key]) {
	            val = obj[keymap[key]] = obj[key];
	            translate(val);
	            delete obj[key];
	          }
	        }
	      } else if (isArray(obj)) {
	        obj.forEach(function(item) {
	          translate(item);
	        });
	      }
	      return obj;
	    }
	
	    keys.forEach(function(key) {
	      keymap[getHash(key)] = key;
	    });
	
	    return translate(obj);
	  },
	  capital: function(str){
	    return str.slice(0,1).toUpperCase() + str.slice(1);
	  }
	};

/***/ }),
/* 357 */
/***/ (function(module, exports, __webpack_require__) {

	(function() {
	  var mixin = __webpack_require__(285);
	  var promisify = __webpack_require__(291);
	  var win = typeof window !== 'undefined' ? window : {};
	  var Promise = win.Promise || __webpack_require__(292);
	  var isWebProtocol = __webpack_require__(352);
	  var picConverter = __webpack_require__(353);
	
	  function noop() {}
	
	  var mtaLog = {
	    env:{
	      token: '5788a4a2488076d81906aa66',
	      sdkVersion: '0.01'
	    },
	    logs: []
	  };
	  var isBrowser = typeof window !== 'undefined';
	  var MTNB;  // declare first
	
	  if (!isBrowser) return;  // if not in browser, return immediately
	  if (isBrowser && window.MTNB)  {
	    module.exports = window.MTNB;
	    return;
	  }
	
	  var sentinel = function () {
	    var pendingRegistrations = 0;
	    var resolverFn = noop;
	    var _promise = new Promise(function (resolve) { return resolverFn = resolve; });
	
	    function tryResolve() {
	        if (pendingRegistrations <= 0) setTimeout(function () { return resolverFn(true); }, 1);
	    }
	    return {
	      increase: function () {
	        pendingRegistrations++;
	      },
	      decrease: function () {
	        pendingRegistrations--;
	        if (pendingRegistrations < 0) pendingRegistrations = 0;
	        tryResolve();
	      },
	      tryResolve: tryResolve,
	      ready: function (fn) { return _promise.then(fn); }
	    };
	  }();
	
	  var debug = false;
	  var logEvent = __webpack_require__(342);
	  var version = __webpack_require__(286);
	
	  function isObject(obj) { return Object.prototype.toString.call(obj) === '[object Object]'; }
	  function isFunction(obj) { return Object.prototype.toString.call(obj) === '[object Function]'; }
	  function valueFn(obj) { return obj; }
	  function sum(array) {
	    if (!array) return 0;
	    var s = 0;
	    for (var i = 0; i < array.length; i++) {
	      s += array[i];
	    }
	    return s;
	  }
	  function parseName(name) {
	    var partials = name.split('.');
	    if (partials.length === 2) partials.unshift('basic'); // default to be basic
	    return {
	      businessName: partials[0],
	      moduleName: partials[1],
	      methodName: partials[2],
	    };
	  }
	
	  // send debug message
	  var log = window._MTNB_LOG || function (type, message) {
	    if (type == "error" && debug == true) {
	      alert("Error: " + message);
	    } else if (debug == true) {
	      alert("Notice: " + message);
	    }
	  };
	  var initCallback = window._MTNB_INIT_CALLBACK || noop;
	
	  var report = function (method, msg) {
	    try {
	      var element = document.createElement('script');
	      //http://docs.sankuai.com/doc/knb/mtnb_docs/api/#ua
	      var uaArray = navigator.userAgent.split(/\s+/);
	      var ualen = uaArray.length;
	
	      mtaLog.logs.push({
	          type: 'business',
	          tags: {
	            method: method,
	            nbType: 'mtnb-knb',
	            app: ((uaArray[ualen - 2] +  uaArray[ualen - 1]) || '').toLowerCase(),
	            path: location.protocol + '//' + location.hostname + location.pathname,
	            ua: navigator.userAgent,
	            msg: msg || ''
	          }
	      });
	
	      var elementSrc = 'https://frep.meituan.com/api/collect?token=5788a4a2488076d81906aa66&empty=true&data=' +
	          encodeURIComponent(JSON.stringify(mtaLog));
	      element.setAttribute('src', elementSrc);
	      document.body.appendChild(element);
	      mtaLog.logs.pop();
	    } catch (e) {
	      noop();  // do nothing
	    }
	  };
	  //采样率10%
	  var sendLog = Math.random() < 0.1 ? report: noop;
	
	  function getCookie (a) {
	    var b = document.cookie.match("(?:;|^)\\s*" + a + "\\s*=\\s*([^;]+)\\s*(?:;|$)");
	    return b && b[1];
	  }
	
	  var q = location.href.split('?')[1] || '';
	  var qparams = {};
	  q = q.split('&');
	  for (var i = 0; i < q.length; i++) {
	    var pair = q[i].split('=');
	    qparams[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1]);
	  }
	
	  function xhr (url, success) {
	    try {
	      var _xhr = new XMLHttpRequest();
	      _xhr.open("GET", url, true);
	      _xhr.onreadystatechange = function () {
	        if (_xhr.readyState == 4) {
	          _xhr.onreadystatechange = null;
	          var data = JSON.parse(_xhr.responseText);
	          if (data.status == 0) {
	            success(data.data);
	          }
	        }
	      };
	      _xhr.send();
	    } catch (e) {
	      console.error(e);
	    }
	  }
	
	 function getVersionInfo(name) {
	   try {
	     switch (name) {
	       case "imeituan":
	         return navigator.userAgent.match(/meituangroup\/?([^ ]+)/i)[1]; // android中间没/
	       case "KNB":
	         //修复android 7.7.0 多个KNB/x.x.x的bug :(
	         return navigator.userAgent.match(/KNB\/(\S+)/g).map(function (str) {
	              return str.match(/KNB\/([^ ]+)/i)[1];
	         });
	     }
	   } catch (e) {
	     noop(); // do nothing
	   }
	   return '0';
	 }
	
	  //////////// Fallback Method, with JavascriptWebviewBridge and imeituan schema
	  var isInited = false;
	  var biz = "default";
	  var isAndroid =  (navigator.userAgent || '').match(/Android/i);
	  var isIphone  =  (navigator.userAgent || '').match(/(iPhone|iPad|iPod)/i);
	  var isMeituanAPP = /meituan/i.test(navigator.userAgent);
	  var isMaoyan     = /movie/i.test(navigator.userAgent);
	
	  var imeituanversion = getVersionInfo('imeituan');
	  var mtnbNativeVersions = getVersionInfo('KNB');
	  var canDetectInternalAPI = (mtnbNativeVersions == '0' ? [] : mtnbNativeVersions).some(function (version) { return parseFloat(version) >= 1.1; });
	
	  function ready(callback) {
	      function init (bridge) {
	        if (isInited) return;
	        try {
	            bridge.init();
	            isInited = true;
	        } catch (e) {
	          console.log('init failed');
	        }
	      }
	      // 如果有WebViewJavascriptBridge这个全局变量，
	      // 则直接初始化它
	      if (window.WebViewJavascriptBridge) {
	          init(WebViewJavascriptBridge);
	          callback(WebViewJavascriptBridge);
	          return;
	      }
	
	      // 否则添加监听事件再初始化
	      document.addEventListener('WebViewJavascriptBridgeReady', function () {
	        init(WebViewJavascriptBridge);
	        callback(WebViewJavascriptBridge);
	      }, false);
	  }
	  ////////////////
	
	  var messageHandlers = {};
	  var responseCallbacks = {};
	  var uniqueId = 1;
	  var blockedJob = [];
	  var subHandleMap = {};
	  var subEventMap = {};
	  var uniqueSubId = 0;
	
	  var useMTNB = navigator.userAgent.indexOf('MTNB') > -1 || navigator.userAgent.indexOf('KNB') > -1;
	  var channelMap1 = {
	    WECHAT_FRIENDS: 1,
	    WECHAT_TIMELINE: 2,
	    QQ: 4,
	    SMS: 8,
	    WEIBO: 16,
	    QZONE: 32,
	    EMAIL: 64,
	    COPY: 128
	  };
	  var channelMap2 = {
	    WECHAT_FRIENDS: 128,
	    WECHAT_TIMELINE: 256,
	    QQ: 512,
	    SMS: 32,
	    WEIBO: 1,
	    QZONE: 2,
	    // not supported
	    EMAIL: 0,
	    COPY: 0
	  };
	
	  function getChannels() {
	    if (useMTNB && !isAndroid && !isMaoyan) {
	      return channelMap1;
	    }
	    return channelMap2;
	  }
	
	  function send(message, responseCallback) {
	    if (responseCallback) {
	      var callbackId = 'cb_'+(uniqueId++)+'_'+new Date().getTime();
	      responseCallbacks[callbackId] = responseCallback;
	      message.callbackId = callbackId;
	    }
	    message.fromKNB = true;  // add formKNB mark for usage tracking
	    var messageTxt = JSON.stringify(message);
	
	    if (isIphone) _MTNB._handleMessageFromJs(messageTxt);
	    if (isAndroid) window.prompt(messageTxt);
	    log("Notice", "sending:", message);
	  }
	
	  function _handleMessageFromApp(message) {
	    var responseCallback;
	
	    if (!message || !isObject(message)) return log('error', 'message is not defined or is not a valid object');
	    log("Notice", "get message:" , message); // do not stringify the message because of performance hit
	
	    // 同步回调
	    // 指的是一般性调用bridge
	    if (message.callbackId) responseCallback = responseCallbacks[message.callbackId];
	
	    // 异步回调
	    // 指的是注册按钮的回调函数
	    if (message.handlerId) {
	      responseCallback = messageHandlers[message.handlerId];
	      message.data = message.data || {status: 0};
	    }
	
	    // 每个模块的回调函数如果没有返回值，或返回值不为false，则出错，且向上给MTNB.onerror抛出错误
	    // 回调MTNB.onerror
	    var status = message.data && message.data.status;
	    var ret = isFunction(responseCallback) && responseCallback(message.data);
	    if (ret && (status !== 0) && isFunction(MTNB.onerror)) {
	      MTNB.onerror(0, 'test error message', null);
	    }
	  }
	
	  MTNB = {
	    _INITED: false,
	    callHandler: function callHandler(params, responseCallback, handlerMapper) {
	      // params.data就是用户调用时传的数据
	      // 如果是数组的话，就每个都format一遍
	      [].concat(params.data).filter(Boolean).forEach(function (obj) {
	        if (!isFunction(obj.handle)) return;
	        // 把用户传进来的handle函数，转化为handleId，并将函数注册到messageHandlers下
	        var handlerId = 'hd_' + (uniqueId++) + '_' + new Date().getTime();
	        messageHandlers[handlerId] = function (params) {
	          obj.handle((handlerMapper || valueFn)(params));
	        };
	        obj.handlerId = handlerId;
	      });
	      send( params, responseCallback);
	    },
	    apis: {},
	    _handleMessageFromApp: _handleMessageFromApp,
	    //注册一个协议, 其中obj的格式为：
	    // {
	    //   name: String
	    //   moduleName: String,
	    //   methodName: String,
	    //   // 为与KNB接口兼容，需要三个维度上的参数映射
	    //   mapper: Function,         // 对调用MTNB.call时参数的映射
	    //   handlerMapper: Function,  // 对Native传给handler的参数的映射
	    //   callbackMapper: Function, // 对Native传给callback参数的映射
	    //
	    //   handler: Function,        // 凡是定义了handler，表示可以不走NB协议
	    //   fallback: Function,       // 在不支持MTNB时的fallback方案
	    //
	    // }
	    reg: function (obj) {
	      var name = obj.name;
	      var statics = obj.statics;
	      obj.businessName = obj.businessName || 'basic';
	      MTNB[name] = function (params) {
	        MTNB.call(name, params);
	      };
	      Object.keys(statics || {}).forEach(function (key) {
	        MTNB[name][key] = obj.statics[key];
	      });
	      MTNB.apis[name] = obj;
	      if (this._add) this._add(name, MTNB[name]); // reg method
	    },
	    //使用协议
	    call: function (name, params) {
	      if (MTNB._INITED == false && useMTNB) return blockedJob.push([name, params]);
	
	      params = params || {};
	      var obj = MTNB.apis[name];
	      var par = ((obj && obj.mapper) || valueFn)(params);
	      var businessName = 'basic';
	
	      if (!name || typeof name !== 'string') return log('error', 'api name is invalid.');
	      if (!obj && name.indexOf('.') > -1) {
	        obj = parseName(name);
	        businessName = obj.businessName;
	      }
	      if (!obj)                     return log('error', 'api name [' + name + '] is not implemented.');
	      if (obj.handler)              return obj.handler(par);
	      if (!useMTNB && obj.fallback) return obj.fallback(par);
	      if (!useMTNB)                 return log('error', 'api [' + name + '] do not have a fallback.');
	
	      var contextData = {
	        "businessName": obj.businessName || businessName,
	        "moduleName": obj.moduleName,
	        "methodName": obj.methodName,
	        "data": par
	      };
	
	      try {
	        sendLog(businessName + '-' + obj.moduleName + '-' + obj.methodName);
	      } catch (e) {
	        // do nothing
	        noop();
	      }
	
	      // 有这个逻辑是因为ios的处理缺陷, 部分api不能有callback传入, 否则会sb
	      if ([
	          'basic.webview.open',
	          'basic.webview.close',
	          'basic.webview.setIcon',
	          'basic.webview.setTitle',
	          'basic.webview.setHtmlTitle',
	          'basic.account.login',
	          'basic.account.logout'
	        ].indexOf((businessName + "." + (obj.moduleName) + "." + (obj.methodName))) > -1) return MTNB.callHandler(contextData, null, obj.handlerMapper);
	
	      MTNB.callHandler(contextData, function (res) {
	        /**** [begin] please go to hell  ****/
	        // android版本对basic.core.checkVersion返回的数据格式有问题
	        if (
	          businessName === 'basic' &&
	          contextData.moduleName === 'core' &&
	          contextData.methodName === 'checkVersion' &&
	          typeof res.info === 'object'   // android return the wrong thing! wtf !
	          ) return (par.success || noop)((obj.callbackMapper || valueFn)(res));
	        /**** [end] please go to hell  ****/
	
	        if (res.status != 0) return (params.fail || noop)(res);
	        (par.success || noop)((obj.callbackMapper || valueFn)(res.data));
	      }, obj.handlerMapper);
	    }
	  };
	
	  MTNB.use = MTNB.call; // alias
	
	  promisify(MTNB);
	
	  /**
	   * 用于检查一个全名的API是否被native支持。
	   * 仅在MTNB大于1.1的版本适用.
	   * 小于1.1的版本将直接返回false.
	   */
	  function isInternalSupported(fullName) {
	    if (!canDetectInternalAPI) return Promise.resolve(false);
	    return new Promise(function (resolve) {
	      MTNB.checkVersion({
	        apis: [fullName],
	        success: function (data) {
	          resolve(data.info && data.info[fullName] != 0);
	        }
	      });
	    });
	  }
	
	  // register modules
	  [{
	    //config 配置KNB
	    name: "config",
	    handler: function (options) {
	      if(options.debug != undefined) debug = options.debug;
	      if(options.bizname != undefined) biz = options.bizname;
	    }
	  },
	  {
	    name: "ready",
	    handler: function(cb) {
	      if ( cb === void 0 ) cb=noop;
	
	      sentinel.ready(cb);
	    }
	  },
	  {
	    name: "isApiSupported",
	    handler: function (ref) {
	      var apiName = ref.apiName;
	      var success = ref.success; if ( success === void 0 ) success = noop;
	
	      sentinel.ready(function () {
	        var API = apiName.indexOf('.') > -1 ? parseName(apiName) : MTNB.apis[apiName];
	        if (!API) return success(false);
	        if (API.handler) return success(true);
	        if (API.fallback && !useMTNB) return success(true);
	        if (canDetectInternalAPI) return isInternalSupported(((API.businessName) + "." + (API.moduleName) + "." + (API.methodName))).then(success);
	        success(true);
	      });
	    }
	  },
	  {
	    name: 'getUA',
	    handler: __webpack_require__(287)
	  },
	  {
	    name: "share",
	    moduleName: "share",
	    methodName: "invoke",
	    mapper: function (params) {
	      return {
	        url: params.url,
	        title: params.title,
	        pic: params.image,
	        channel: sum(params.channel) || -1,
	        content: params.desc,
	        handle: params.success,
	      };
	    },
	    statics: getChannels(),
	    fallback: function (params) {
	      var shareLink = "imeituan://www.meituan.com/share"
	        + '?channel=' + (params.channel || -1)
	        + "&title=" + encodeURIComponent(params.title)
	        + "&imageURL=" + encodeURIComponent(params.pic)
	        + "&detailURL=" + encodeURIComponent(params.url)
	        + "&content_-1=" + encodeURIComponent(params.content)
	        + "&content_1=" + encodeURIComponent(params.weiboContent);
	      location.href = shareLink;
	    }
	  },
	  {
	    name: "openWebview",
	    moduleName: "webview",
	    methodName: "open",
	    fallback: function (ref) {
	      var url = ref.url; if ( url === void 0 ) url = '';
	
	      if (isWebProtocol(url)) url = "imeituan://www.meituan.com/web?url=" + encodeURIComponent(url) ;
	      location.href = url;
	    }
	  },
	  {
	    name: "closeWebview",
	    moduleName: "webview",
	    methodName: "close",
	    fallback: function () {
	      window.close();
	    }
	  },
	  {
	    name: "jumpWebview",
	    handler: function (ref) {
	      var url = ref.url; if ( url === void 0 ) url = "";
	
	      if (isWebProtocol(url)) url = "imeituan://www.meituan.com/web?url=" + encodeURIComponent(url);
	
	      if (isAndroid) {
	        location.href = url;
	        return MTNB.closeWebview();
	      }  // Android没有支持closeAndNavigate..
	      ready(function (bridge) {
	        bridge.callHandler('callNativeMethod', {
	          "moduleName" : "platform",
	          "methodName" : "closeAndNavigate",
	          "fromKNB"    : true,
	          data : { "url" : url}
	        }, noop);
	      });
	    }
	  },
	  {
	    name: "setTitle",
	    moduleName: "webview",
	    methodName: "setHtmlTitle",
	    fallback: function (params) {
	      document.title = params.title;
	    }
	  },
	  {
	    name: "getLocation",
	    moduleName: "geo",
	    methodName: "getLocation",
	    callbackMapper: function (param) {
	      return {
	        lat: param.latitude,
	        lng: param.longitude
	      };
	    },
	    fallback: function (params) {
	      navigator.geolocation.getCurrentPosition(function (geo) {
	        params.success && params.success({
	          lat: geo.coords.latitude,
	        lng: geo.coords.longitude
	        });
	      }, function (err) {
	        params.fail && params.fail(err);
	      }, {timeout: params.timeout, enableHighAccuracy: false});
	    }
	  },
	  {
	    name: "login",
	    moduleName: "account",
	    methodName: "login",
	    mapper: function (params) {
	      params.handle = function (res) {
	        var success = (params.success || noop);
	        var fail   = (params.fail || noop);
	        // handle会返回userId等字段
	        if (res.userId) {
	          return success({
	            type: 'mt',
	            name: res.userName,
	            userId: res.userId,
	            token: res.userToken
	          });
	        }
	        // 如果失败，会返回status字段不为0
	        if (String(res.status) !== "0") return fail(res);
	        // 否则，是callback风格的成功
	        success(res.data);
	      };
	      return params;
	    },
	    fallback: function () {
	      if (isMeituanAPP) {
	        location.href = "imeituan://www.meituan.com/signin?redirectURL=" + encodeURIComponent(location.href);
	        return;
	      }
	      // 如果不是meituan app，且没有mtnb，则跳转到i版页面
	      location.href = "//i.meituan.com/account/login?backurl=" + encodeURIComponent(location.href);
	    }
	  },
	  {
	    name: "logout",
	    moduleName: "account",
	    methodName: "logout"
	  },
	  {
	    name: "getCity",
	    handler: function (params) {
	      var cityId = parseInt(qparams.ci);
	      if (!cityId) {
	        cityId = parseInt(getCookie("cityid")) || 0;
	      }
	      params.success({
	        cityId: cityId,
	        type: 'mt'
	      });
	    }
	  },
	  {
	    name: "getLocationCity",
	    handler: function (params) {
	      MTNB.getLocation({
	        timeout: 1000,
	        success: function (loc) {
	            xhr("//i.meituan.com/locate/latlng/"+loc.lat+","+loc.lng+".json?ndr", function(data) {
	              params.success && params.success({
	              cityId: data.id,
	              type: 'mt'
	            });
	          });
	        },
	        fail: params.fail
	      });
	    }
	  },
	  {
	    name: "store",
	    handler: function (params) {
	      var key;
	      try {
	        if (params.key.indexOf(':') != -1) {
	          key = params.key;
	        } else {
	          key = biz + ":" + params.key;
	        }
	        localStorage[key] = params.value;
	        params.success && params.success();
	      } catch (e) {
	        params.fail && params.fail(e);
	      }
	    }
	  },
	  {
	    name: "retrieve",
	    handler: function (ref) {
	      var key = ref.key; if ( key === void 0 ) key = '';
	      var success = ref.success; if ( success === void 0 ) success = noop;
	      var fail = ref.fail; if ( fail === void 0 ) fail = noop;
	
	      var value;
	      try {
	        value = localStorage[key.indexOf(':') != -1 ? key : (biz + ":" + key)];
	      } catch (e) {
	        return fail(e);
	      }
	      success({value: value});
	    }
	  },
		{
			name: 'lxlog',
			businessName: 'mtalog',
			moduleName: 'stat',
			methodName: 'log'
		},
	  {
	    name: "getNetworkType",
	    handler: function (ref) {
	      var success = ref.success; if ( success === void 0 ) success = noop;
	
	      var network = getCookie('network');
	      success({
	        networkType: network
	      });
	    }
	  },
	  ].forEach(MTNB.reg.bind(MTNB));
	
	  // 从可以检测native API版本开始
	  if (canDetectInternalAPI) {
	    [{
	      name: "checkVersion",
	      moduleName: "core",
	      methodName: "checkVersion"
	    },
	    {
	      name: 'uploadImage',
	      moduleName: 'media',
	      methodName: 'uploadImage',
	      mapper: function (_opts) {
	        var opts = mixin({}, _opts);
	
	        if (!_opts.clientId) {
	          opts.clientId = opts.bucket;
	        }
	        return opts;
	      },
	      callbackMapper: function (ref){
	        var photoInfos = ref.photoInfos; if ( photoInfos === void 0 ) photoInfos = [];
	
	        return {
	          photoInfos: photoInfos.map(function (photo) {
	            var picKey = photo.picKey;
	            var httpsKey = picConverter(photo.picKey);
	            return mixin(photo, {picUrl: httpsKey, picKey:httpsKey, originalKey: picKey})
	          })
	        }
	      }
	    },
	    {
	      name: 'previewImage',
	      moduleName: 'media',
	      methodName: 'previewImage'
	    },
	    {
	      name: 'publish',
	      moduleName: 'message',
	      methodName: 'publish',
	      mapper: function (params) {
	        //mtnb 文档实现有误,导致native实现的时候用的info.而点评是传的data
	        params.info = params.info || params.data;
	        return params;
	      }
	    },
	    {
	      name: 'subscribe',
	      handler: function (ref) {
	        var action = ref.action;
	        var handle = ref.handle; if ( handle === void 0 ) handle = noop;
	        var success = ref.success; if ( success === void 0 ) success = noop;
	        var fail = ref.fail; if ( fail === void 0 ) fail = noop;
	
	        if (!action) return;
	        var eventName = action;
	        var eventQueue = subEventMap[eventName] || [];
	
	        var subId = 'sub_' + (++uniqueSubId);
	        subHandleMap[subId] = handle;
	
	        if (eventQueue.length) {
	          eventQueue.push(subId);
	          subEventMap[eventName] = eventQueue;
	          return success({subId: subId});
	        }
	
	        eventQueue.push(subId);
	        subEventMap[eventName] = eventQueue;
	        var handleQueue = function (e) {
	          (subEventMap[eventName] || []).forEach(function (subId) { return subHandleMap[subId](e); })
	        };
	
	        MTNB.use('basic.message.subscribe',{
	          action: eventName,
	          handle: handleQueue,
	          success: function () { return success({subId: subId}); },
	          fail: fail
	        });
	      }
	    },
	    {
	      name: 'unsubscribe',
	      handler: function (ref) {
	        var action = ref.action;
	        var subId = ref.subId;
	        var success = ref.success; if ( success === void 0 ) success = noop;
	
	        if (subId) {
	          subHandleMap[subId] = noop;
	        } else if (action) {
	          subEventMap[action] = [];
	        }
	        success();
	      }
	    },
	    {
	      name: 'setNavigationBarHidden',
	      moduleName: 'webview',
	      methodName: 'setNavigationBarHidden'
	    },
	    {
	      name: 'setBackgroundColor',
	      moduleName: 'webview',
	      methodName: 'setBackgroundColor'
	    },
	    {
	      name: 'setBouncesEnabled',
	      moduleName: 'webview',
	      methodName: 'setBouncesEnabled'
	    },
	    {
	      name: 'setStatusBarStyle',
	      moduleName: 'webview',
	      methodName: 'setStatusBarStyle'
	    },
	      //ios和android对确认和取消按钮的处理均存在错误
	      /*
	      {
	        name: 'alert',
	        moduleName: 'system',
	        methodName: 'alert'
	      },
	      {
	        name: 'confirm',
	        moduleName: 'system',
	        methodName: 'confirm'
	      },
	      {
	        name: 'prompt',
	        moduleName: 'system',
	        methodName: 'prompt'
	      },*/
	    {
	      name: 'sendSMS',
	      moduleName: 'system',
	      methodName: 'sendSMS'
	    },
	    {
	      name: 'getContactList',
	      moduleName: 'system',
	      methodName: 'getContactList'
	    },
	  /*{
	      name: 'downloadImage',
	      moduleName: 'media',
	      methodName: 'downloadImage'
	    },*/
	    {
	      name: "chooseImage",
	      moduleName: "media",
	      methodName: "chooseImage"
	    }].forEach(MTNB.reg.bind(MTNB));
	  }
	
	  // 为防止ios crash，从7.1开始支持.
	  if (imeituanversion !== '0' && imeituanversion.indexOf('7.0') === -1) {
	    MTNB.reg({
	      name: "chooseImage",
	      moduleName: "media",
	      methodName: "chooseImage"
	    });
	  }
	
	  // 因为设置按钮每一次都需要全量设置
	  // 所以需要缓存
	  var icons = {
	    l: null,
	    r: null
	  };
	  MTNB.reg({
	    name: "setNavButtons",
	    moduleName: "webview",
	    methodName: "setIcon",
	    mapper: function (params) {
	      params = [].concat(params).filter(Boolean);
	      for (var i = 0; i < params.length; i++) {
	        var icon = params[i];
	        if (icon.type == "base64") icon.url = icon.icon; // for android
	        // 只处理RL/RR，是因为MTNB不支持对LL/LR按钮的配置
	        if (icon.position == "RL") icons.l   = icon.disable ? null : icon;
	        if (icon.position == "RR") icons.r   = icon.disable ? null : icon;
	      }
	      return [icons.l, icons.r].filter(Boolean);
	    }
	  });
	
	  MTNB.reg({
	    name: "configShare",
	    handler: function (params) {
	      // KNB on Android
	      if (useMTNB && isAndroid) {
	        return MTNB.setNavButtons({
	          type: "base64",
	          position: "RR",
	          icon: window._MTNB_DEFAULT_SHARE_ICON || "data:image/png;base64,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",
	          handle: function () {
	            params.handle && params.handle();
	            MTNB.share(params);
	          }
	        });
	      }
	      // KNB on iOS
	      if (useMTNB && !isAndroid) {
	        return MTNB.setNavButtons({
	          type: 'share',
	          position: 'RR',
	          handle:function() {
	            params.handle && params.handle();
	            MTNB.share(params);
	          }
	        });
	      }
	
	      // waimai c端
	      ready(function (bridge) {
	        // 这个bridge方法是用来设置右上角button的。
	        bridge.callHandler('callNativeMethod', {
	          "moduleName": "platform",
	          "methodName": "shareCommon",
	          "fromKNB"    : true,
	          "data": {
	            "channel": sum(params.channel)+"", //外卖bug，channel必须是字符串
	            "content": params.content,
	            "content_-1": params.content,
	            "content_1": params.weiboContent || params.content,
	            "detailURL": params.url,
	            "imageURL": params.image,
	            "title": params.title
	          }
	        }, function (res) {
	          params.success && params.success(res);
	        });
	      });
	    }
	  });
	
	  var stopHandler = noop;
	
	  function jsbSetPullDownReg() {
	    if (imeituanversion == '0') return; // only register on metiuangroup app
	    MTNB.reg({
	      name: "setPullDown",
	      handler: function (params) {
	        ready(function(bridge) {
	          bridge.callHandler('callNativeMethod', {
	            moduleName : 'platform',
	            methodName : 'buildUpRefresh',
	            fromKNB: true,
	            data: { partial: true }
	          }, noop);
	          bridge.registerHandler("pullToRefresh", function (data, callback) {
	            stopHandler = callback;
	            params.handle();
	          });
	        });
	      }
	    });
	  }
	
	  function jsbStopPullDownReg() {
	    if (imeituanversion == '0') return;
	    MTNB.reg({
	      name: "stopPullDown",
	      // `stopHandler` is a variable, don't assign it directly here.
	      // it might change by time.
	      handler: function () { return stopHandler(); }
	    });
	  }
	
	  [{
	    name: 'setPullDown',
	    businessName: 'basic',
	    moduleName: 'webview',
	    methodName: 'setPullDown',
	    fallbackRegFn: jsbSetPullDownReg,
	  },{
	    name: 'stopPullDown',
	    businessName: 'basic',
	    moduleName: 'webview',
	    methodName: 'stopPullDown',
	    fallbackRegFn: jsbStopPullDownReg,
	  },{
	    name: 'setSearchBar',
	    businessName: 'meituan',
	    moduleName: 'webview',
	    methodName: 'setSearchBar',
	    fallbackRegFn: function () {
	      MTNB.reg({
	        name: 'setSearchBar',
	        handler: function (props) {
	            ready(function (bridge) {
	              bridge.callHandler('callNativeMethod', {
	                'moduleName' : 'platform',
	                'methodName' : 'search',
	                'fromKNB'    : true,
	                data : props  // isShowSearch / searchText / searchTextColor / searchCateId
	              }, noop);
	            })
	        }
	      });
	    },
	  },{
	    name: 'setLLButton',
	    businessName: 'basic',
	    moduleName: 'webview',
	    methodName: 'setLLButton',
	    fallbackRegFn: noop
	  },{
	    name: 'getUserInfo',
	    businessName: 'basic',
	    moduleName: 'account',
	    methodName: 'getUserInfo',
	    callbackMapper: function (ret) {
	      return mixin(ret,{
	        userId: +ret.userId || +ret.id,
	        token: ret.token || qparams['token'],
	        uuid: ret.uuid || qparams['uuid']
	      })
	    },
	    fallbackRegFn: function () {
	      MTNB.reg({
	        name: 'getUserInfo',
	        handler: function (ref) {
	            var success = ref.success; if ( success === void 0 ) success = noop;
	
	            success({
	              type: 'mt',
	              userId: qparams['userid'] ? parseInt(qparams['userid']) : null,
	              uuid: qparams['uuid'] ? qparams['uuid'] : null,
	              token: qparams['token'] ? qparams['token'] : null
	            });
	          }
	      })
	    }
	  }].forEach(function (ref) {
	    var name = ref.name;
	    var businessName = ref.businessName;
	    var moduleName = ref.moduleName;
	    var methodName = ref.methodName;
	    var fallbackRegFn = ref.fallbackRegFn;
	    var callbackMapper = ref.callbackMapper;
	
	    sentinel.increase();
	    isInternalSupported((businessName + "." + moduleName + "." + methodName)).then(function (supported) {
	      sentinel.decrease();
	      if (!supported) return fallbackRegFn();
	      MTNB.reg({name: name, businessName: businessName, moduleName: moduleName, methodName: methodName, callbackMapper: callbackMapper});
	    });
	  });
	
	  // 如果没有imeituanversion信息，则是6.x及以下版本
	  // Android没有实现MTNB版的fingerprint
	  // WHAT A PILE OF HOLY SHIT!!
	  MTNB.reg(function() {
	    if (useMTNB && imeituanversion !== '0' && !isAndroid) {
	      return {
	        name: "getFingerprint",
	        moduleName: "fingerprint",
	        methodName: "getFingerprint"
	      };
	    }
	    return {
	      name: "getFingerprint",
	      handler: function (params) {
	        ready(function (bridge) {
	          bridge.callHandler('conveyFingerPrintInfoHandler', {
	            "fromKNB": true
	          }, function (res) {
	            params.success && params.success(res);
	          });
	        });
	      }
	    };
	  }());
	
	  sentinel.tryResolve(); // try resolve first
	
	  MTNB.__version__ = version;
	
	  // 被引用统计
	  logEvent('mtnb', MTNB.__version__);
	
	  if (isBrowser) window.MTNB = MTNB;
	
	  module.exports = MTNB;
	
	  if (!useMTNB) return;
	
	  // init MTNB
	  window.dpMTNBInit = function(data) {
	    if (!data.nonceStr) return report('mtnb-init-failed', 'nonceStr not exist'); // avoid call native to prevent crash under iOS Group 6.5
	    MTNB.callHandler({
	      "businessName": "basic",
	      "moduleName": "core",
	      "methodName": "init",
	      "data": {
	        "nonceStr": data.nonceStr,
	        "ts": parseInt(data.ts) || 0,
	        "url": data.url,
	        "sign": data.sign
	      }
	    }, function (res) {
	      initCallback(res);
	      if (res && res.status !== 0) {
	        var resString = JSON.stringify(res);
	        report('mtnb-init-failed', resString);
	        log('error', resString);
	        return;
	      }
	
	      MTNB._INITED = true;
	      for (var i = 0; i < blockedJob.length; i++)  MTNB.call(blockedJob[i][0], blockedJob[i][1]);
	    });
	  };
	  var script = document.createElement('script');
	  script.setAttribute('type', 'text/javascript');
	  var url = location.protocol + '//m.dianping.com/mtnb/api/signature?callback=dpMTNBInit';
	  script.setAttribute('src', url);
	  document.getElementsByTagName('head')[0].appendChild(script);
	})();


/***/ }),
/* 358 */
/***/ (function(module, exports, __webpack_require__) {

	/*global Promise*/
	var hbnb = __webpack_require__(359);
	var version = __webpack_require__(286);
	var uncommenApis = __webpack_require__(465);
	
	if (typeof window !== 'undefined' && typeof window.Promise === 'undefined') {
	  window.Promise = __webpack_require__(292);
	}
	
	var debug = false;
	var bizname = null;
	
	var shareChannelMap = {
	  'WECHAT_FRIENDS': 'weixinfriends',
	  'WECHAT_TIMELINE': 'weixin',
	  'QQ': 'qqclient',
	  'SMS': 'sms',
	  'WEIBO': 'sinaweibo',
	  'QZONE': 'qzone',
	  'EMAIL': 'email',
	  // 'COPY': ''  // todo: not supported by hbnb
	};
	
	var currentButtons = {};
	
	var availableApis = {
	  'config': true,
	  'isApiSupported': true,
	  'use': true,
	  'getUA': true,
	  'getUserInfo': true,
	  'getFingerprint': true,
	  'getNetworkType': false,
	  'login': true,
	  'logout': false,
	  'getLocation': true,
	  'getCity': true,
	  'getLocationCity': true,
	  'openWebview': true,
	  'jumpWebview': false,
	  'closeWebview': true,
	  'share': true,
	  'configShare': true,
	  'setTitle': true,
	  'setNavButtons': true,
	  'store': true,
	  'retrieve': true,
	
	  'checkVersion': false,
	  'chooseImage': false,
	  'uploadImage': false,
	  'previewImage': false,
	  'downloadImage': false,
	  'publish': false,
	  'subscribe': false,
	  'unsubscribe': false,
	  'setNavigationBarHidden': false,
	  'setBackgroundColor': false,
	  'setStatusBarStyle': false,
	  'setBouncesEnabled': false,
	  'alert': true,
	  'confirm': true,
	  'prompt': false,
	  'sendSMS': false,
	  'getContactList': false,
	  'setPullDown': false,
	  'stopPullDown': false
	
	};
	
	function noop() {
	}
	
	function isFunction(fn) {
	  return typeof fn === 'function';
	}
	
	function escapeRegExp(str) {
	  return str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&");
	}
	
	function qs(key) {
	  key = encodeURIComponent(key);
	
	  var res = null;
	  var search = location.search;
	
	  var reg = new RegExp('(?:\\?|&)' + escapeRegExp(key) + '=([^&]*)(?:&|$)');
	  var match = search.match(reg);
	
	  if (match && match.length > 1) {
	    res = decodeURIComponent(match[1]);
	  }
	
	  return res;
	}
	
	
	function xhr(url, success) {
	  try {
	    var _xhr = new XMLHttpRequest();
	    _xhr.open("GET", url, true);
	    _xhr.onreadystatechange = function() {
	      if (_xhr.readyState == 4) {
	        _xhr.onreadystatechange = null;
	        var data = JSON.parse(_xhr.responseText);
	        if (data.status == 0) {
	          success(data.data);
	        }
	      }
	    };
	    _xhr.send();
	  } catch (e) {
	    console.error(e);
	  }
	}
	
	
	var KNB = {
	  __version__: version,
	
	  ready: function(cb) {
	    cb && cb();
	  },
	
	  config: function(opts) {
	    debug = Boolean(opts.debug);
	    bizname = opts.bizname;
	  },
	
	  isApiSupported: function(opts) {
	    opts.success(availableApis[opts.apiName] === true);
	  },
	
	  use: function(apiName, opts) {
	    apiName = apiName.replace(/^hb\./, '');
	    try {
	      var apiInfo = uncommenApis[apiName];
	      var args = apiInfo.params.map(function(paramName) {
	        return opts[paramName];
	      });
	
	      if (apiInfo.params.length === 1 && apiInfo.params[0] === 'opts') {
	        args = [opts];
	      }
	
	      var res = hbnb[apiInfo.memberof][apiInfo.name].apply(null, args);
	
	      if (apiInfo.return === 'Promise') {
	        res.then(opts.success || noop, opts.fail || noop);
	      } else {
	        return res;
	      }
	    } catch (ex) {
	      opts.fail && opts.fail();
	    }
	  },
	
	  getUserInfo: function(opts) {
	    Promise.all([
	      hbnb.account.getUser(),
	      // todo: there is no valid way to get uuid via hbnb
	      null
	    ]).then(function(values) {
	      var user = values[0];
	      var uuid = values[1];
	
	      opts.success({
	        type: 'mt',
	        userId: user.userId,
	        token: user.userToken,
	        uuid: uuid
	      });
	    }).catch(opts.fail || noop);
	  },
	
	  getFingerprint: function(opts) {
	    hbnb.pay.getFingerprint()
	      .then(function(fingerprint) {
	        opts.success({fingerprint: fingerprint});
	      }).catch(opts.fail || noop);
	  },
	
	  getNetworkType: function() {
	    if (debug) {
	      console.warn('KNB: API `getNetworkType` is not supported currently.');
	    }
	  },
	
	  login: function(opts) {
	    hbnb.account.login()
	      .then(function(user) {
	        opts.success({
	          type: 'mt',
	          userId: user.userId,
	          token: user.userToken
	        });
	      }).catch(opts.fail || noop);
	  },
	
	  logout: function() {
	    if (debug) {
	      console.warn('KNB: API `logout` is not supported currently.');
	    }
	  },
	
	  getLocation: function(opts) {
	    var lat = qs('lat');
	    var lng = qs('lng');
	
	    if (lat && lng) {
	      setTimeout(function() {
	        opts.success({
	          lat: lat,
	          lng: lng
	        });
	      }, 0);
	    } else {
	      setTimeout(opts.fail || noop, 0);
	    }
	  },
	
	  getCity: function(opts) {
	    if (!isFunction(opts.success)) {
	      return;
	    }
	
	    hbnb.position.getCity()
	      .then(function(city) {
	        opts.success({
	          type: 'mt',
	          cityId: city.cityId
	        });
	      }).catch(opts.fail || noop);
	  },
	
	  getLocationCity: function(opts) {
	    if (!isFunction(opts.success)) {
	      return;
	    }
	
	    KNB.getLocation({
	      success: function(loc) {
	        xhr("https://i.meituan.com/locate/latlng/" + loc.lat + "," + loc.lng + ".json?ndr", function(res) {
	          opts.success({
	            cityId: res.id,
	            type: 'mt'
	          });
	        });
	      },
	      fail: opts.fail
	    });
	  },
	
	  openWebview: function(opts) {
	    hbnb.webview.open(opts.url);
	  },
	
	  jumpWebview: function() {
	    if (debug) {
	      console.warn('KNB: API `jumpWebview` is not supported currently.');
	    }
	  },
	
	  closeWebview: function() {
	    hbnb.webview.close();
	  },
	
	  share: function(opts) {
	    // todo: `opts.success` is not supported by hbnb
	    if (!opts.channel || opts.channel.length === 0) {
	      opts.channel = ['all'];
	    }
	
	    hbnb.share.callLocal(opts.channel, {
	      title: opts.title,
	      content: opts.desc,
	      detailURL: opts.url,
	      imageURL: opts.image
	    });
	  },
	
	  configShare: function(opts) {
	    // todo: `opts.handle` and `opts.success` are not supported by hbnb
	    if (!opts.channel || opts.channel.length === 0) {
	      opts.channel = ['all'];
	    }
	
	    hbnb.share.activeNavButton(opts.channel, {
	      title: opts.title,
	      content: opts.desc,
	      detailURL: opts.url,
	      imageURL: opts.image
	    });
	  },
	
	  setTitle: function(opts) {
	    // todo: `opts.handle` is not supported by hbnb
	    hbnb.webview.setTitle(opts.title);
	  },
	
	  setNavButtons: function(buttons) {
	
	    var hbnbButtons = [];
	    buttons = [].concat(buttons);
	
	    // todo: `button.position` in ['LL', 'LR'] is not supported by hbnb
	    ['RR', 'RL'].forEach(function(position) {
	      var button = buttons.filter(function(btn) {
	        return position === btn.position;
	      });
	
	      if (button.length) {
	        currentButtons[position] = button[button.length - 1];
	      }
	      button = currentButtons[position];
	
	      if (!button || button.disable) return;
	
	      var res = {
	        callback: button.handle
	      };
	      switch (button.type) {
	        case 'base64':
	          res.type = 'icon';
	          res.icon = button.icon;
	          break;
	        case 'text':
	          res.type = 'text';
	          res.text = button.text;
	          res.color = button.color;
	          break;
	        default:
	        // do nothing
	      }
	      hbnbButtons.push(res);
	    });
	
	    hbnb.webview.setMenus(hbnbButtons);
	  },
	
	  setLLButton: function (ref) {
	    var handle = ref.handle; if ( handle === void 0 ) handle = noop;
	
	    hbnb.webview.setBackAction(handle);
	  },
	
	  store: function(opts) {
	    // todo: `opts.success` is not supported by hbnb
	    var key = bizname ? bizname + ':' + opts.key : opts.key;
	    hbnb.storage.setItem(key, JSON.stringify(opts.value));
	  },
	
	  retrieve: function(opts) {
	    var keys = opts.key.split(/:(.*)$/);
	    var biz = keys.length > 1 ? keys[0] : bizname;
	    var key = keys.length > 1 ? keys[1] : keys[0];
	    key = biz ? biz + ':' + key : key;
	    hbnb.storage.getItem(key)
	      .then(function(value) {
	        opts.success(JSON.parse(value));
	      }).catch(opts.fail || noop);
	  },
	
	  alert: function (ref) {
	    var message = ref.message;
	    var title = ref.title;
	    var handle = ref.handle; if ( handle === void 0 ) handle = noop;
	    var button = ref.button;
	
	    hbnb.ui.alert(message, title, [{
	      label: button,
	      callback: function () {
	        handle();
	      }
	    }]);
	  },
	
	  confirm: function (ref) {
	    var message = ref.message;
	    var title = ref.title;
	    var okButton = ref.okButton;
	    var cancelButton = ref.cancelButton;
	    var handle = ref.handle; if ( handle === void 0 ) handle = noop;
	
	    hbnb.ui.confirm(message, title, {
	      label: okButton,
	      callback: function () {handle({ret: true});}
	    },{
	      label: cancelButton,
	      callback: function () {handle({ret: false});}
	    });
	  }
	};
	
	for (var key in shareChannelMap) {
	  if (shareChannelMap.hasOwnProperty(key)) {
	    KNB.share[key] = shareChannelMap[key];
	  }
	}
	KNB.getUA = __webpack_require__(287);
	
	var logEvent = __webpack_require__(342);
	// 统计hbnb调用次数
	logEvent("hbnb", version);
	
	module.exports = KNB;


/***/ }),
/* 359 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports = module.exports = function() {
	    return exports;
	};
	
	if (false) {
	    exports._debug = require('debug');
	    // _debug.enable('hbnb:invoke:*');
	}
	
	// invoke
	exports._invoke = __webpack_require__(360);
	
	// hbnb
	exports.core = __webpack_require__(368);
	
	// basic
	exports.account = __webpack_require__(372);
	exports.log = __webpack_require__(377);
	exports.network = __webpack_require__(379);
	exports.pay = __webpack_require__(382);
	exports.position = __webpack_require__(385);
	exports.storage = __webpack_require__(387);
	exports.thirdApps = __webpack_require__(392);
	exports.ui = __webpack_require__(394);
	exports.webview = __webpack_require__(404);
	
	// tower
	exports.tower = __webpack_require__(415);
	
	//flight
	exports.flight = __webpack_require__(421);
	
	//train
	exports.train = __webpack_require__(430);
	exports.inject = __webpack_require__(443);
	
	//lvyou
	window.Bridge = __webpack_require__(451);
	exports.travel = __webpack_require__(453);
	
	//env
	exports.env = __webpack_require__(459);
	
	//share
	exports.share = __webpack_require__(461);
	


/***/ }),
/* 360 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(361);


/***/ }),
/* 361 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var debug;
	var assert;
	if (false) {
	    debug = require('debug')('hbnb:invoke:invoke');
	    assert = require('assert');
	}
	
	var env = __webpack_require__(362);
	var ready = __webpack_require__(365);
	var buildURI = __webpack_require__(366);
	var sendURI = __webpack_require__(367);
	
	var invoke = function(moduleName, methodName, parameters, protocol) {
	    if (false) {
	        //assert(env.HBNBReady);
	        debug('module = %s', moduleName);
	        debug('method = %s', methodName);
	        debug('parameters = %j', parameters);
	        debug('protocol = %s', protocol);
	    }
	
	    // return if not in meituan app
	    if (true) {
	        if (!env.isHBNBWebview) {
	            if (parameters && parameters.complete) {
	                var complete = parameters.complete;
	                if (typeof complete === 'function') {
	                    setTimeout(function() {
	                        complete({
	                            status: 200,
	                            message: 'not HBNB webview'
	                        });
	                    });
	                }
	                return;
	            }
	        }
	    }
	
	    // throw Error on development
	    if (false) {
	        assert(typeof moduleName === 'string' && moduleName);
	        assert(typeof methodName === 'string' && methodName);
	    }
	
	    parameters = parameters || {};
	    protocol = protocol || 'magpie:';
	    var uri = buildURI(protocol, moduleName, methodName, parameters);
	
	    if (false) {
	        debug('uri = %s', uri);
	    }
	
	    ready(function() {
	        sendURI(uri);
	    });
	};
	
	module.exports = invoke;


/***/ }),
/* 362 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var debug;
	if (false) {
	    debug = require('debug')('hbnb:invoke:env');
	}
	
	
	// default value
	exports.isHBNBWebview = false;
	exports.platform = 'h5';
	exports.appVersion = undefined;
	exports.supportPrompt = undefined; // android group 5.x not support alert
	exports.HBNBReady = false;
	
	var versionCompare = __webpack_require__(363);
	var initEvent = __webpack_require__(364);
	
	var initVersion = function() {
	    // user agent regexp
	    var RE_ANDROID = (/android/i);
	    var RE_IOS = (/iPhone|iPad/i);
	    var RE_HBNB = (/\biHotel\/(\d+(?:\.\d+)*)\b/i);
	    var TRIP_BIZ = (/mt_trip_biz/i);
	
	    // check user agent
	    var ua = navigator.userAgent || '';
	    var match = ua.match(RE_HBNB);
	    if (match) {
	        if (RE_IOS.test(ua)) {
	            exports.platform = 'ios';
	            exports.appVersion = match[1];
	            exports.isHBNBWebview = true;
	        } else if (RE_ANDROID.test(ua)) {
	            exports.platform = 'android';
	            exports.appVersion = match[1];
	            exports.isHBNBWebview = true;
	            exports.supportPrompt = TRIP_BIZ.test(ua) || Boolean(versionCompare(exports.appVersion, '6.0') >= 0);
	        }
	    }
	};
	
	var init = function() {
	    initVersion();
	    initEvent();
	};
	
	init();
	
	if (false) {
	    debug('env = %j', exports);
	}


/***/ }),
/* 363 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var debug;
	if (false) {
	    debug = require('debug')('hbnb:invoke:version-compare');
	}
	
	/**
	 * compare version number
	 *
	 * @private
	 * @param {String} a
	 * @param {String} b
	 * @return {Number} -1 is <, 0 is =, 1 is >
	 *
	 * @example
	 *  compare('6.0', '6.0.1'); // -1
	 *  compare('6.0', '5.9'); // 1
	 *  compare('5.9.2', '5.9.2'); // 0
	 */
	var compare = function(a, b) {
	    var pa = String(a).split('.');
	    var pb = String(b).split('.');
	    var len = Math.min(pa.length, pb.length) + 1;
	
	    if (false) {
	        debug('a is %j', pa);
	        debug('b is %j', pb);
	    }
	
	    for (var i = 0; i < len; ++i) {
	        var na = Number(pa[i]);
	        var nb = Number(pb[i]);
	        if (na > nb) {
	            return 1;
	        } else if (nb > na) {
	            return -1;
	        } else if (!isNaN(na) && isNaN(nb)) {
	            return 1;
	        } else if (isNaN(na) && !isNaN(nb)) {
	            return -1;
	        }
	    }
	    return 0;
	};
	
	module.exports = compare;


/***/ }),
/* 364 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * 1. 页面开启
	 * 2. 页面隐藏
	 * 3. 桥协议可用
	 */
	
	var debug;
	var assert;
	if (false) {
	    debug = require('debug')('hbnb:invoke:event');
	    assert = require('assert');
	}
	
	var env = __webpack_require__(362);
	
	
	var win = window;
	var doc = document;
	
	var dispatch = function(eventName) {
	    if (false) {
	        assert(eventName);
	        debug('dispatch event "%s"', eventName);
	    }
	
	    var ev = doc.createEvent('Events');
	    ev.initEvent(eventName);
	    doc.dispatchEvent(ev);
	};
	
	var addLifecycleEvent = function() {
	    if (false) {
	        debug('add lifecycle event');
	        assert(win.HBNB);
	    }
	
	    dispatch('HBNB:ready');
	    env.HBNBReady = true;
	
	    win.HBNB.onPageShow = function() {
	        dispatch('HBNB:pageshow');
	    };
	
	    win.HBNB.onPageHide = function() {
	        dispatch('HBNB:pagehide');
	    };
	};
	
	var checkHBNB = function() {
	    setTimeout(function check() {
	        if (win.HBNB) {
	            addLifecycleEvent();
	        } else {
	            setTimeout(check, 500);
	        }
	    });
	};
	
	var initEvent = function() {
	    if (false) {
	        if (env.platform === 'h5') {
	            win.HBNB = {};
	            addLifecycleEvent();
	        }
	    }
	
	    if (!env.isHBNBWebview) {
	        if (false) {
	            debug('not HBNB webview');
	        }
	        return;
	    }
	
	    if (env.platform === 'ios') {
	        if (win.HBNB) {
	            // ios 会添加 HBNB 对象，如果有该对象，说明桥协议可用
	            addLifecycleEvent();
	        } else if (env.HBNBVersion) {
	            // 带 HBNB 的版本，在可用时会触发 _HBNBReady 事件，表示桥协议可用了
	            doc.addEventListener('_HBNBReady', addLifecycleEvent);
	        } else {
	            // 旧版本只能定时检查
	            checkHBNB();
	        }
	    } else if (env.platform === 'android') {
	        if (env.supportPrompt) {
	            // 支持 prompt 的版本，是在页面加载前就可用了
	            win.HBNB = {};
	            addLifecycleEvent();
	        } else if (win.HBNB) {
	            // 旧版本使用 HBNB 传递数据，存在 HBNB 时可用
	            addLifecycleEvent();
	        } else {
	            // 就版本只能定时检查
	            checkHBNB();
	        }
	    }
	};
	
	module.exports = initEvent;


/***/ }),
/* 365 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var debug;
	if (false) {
	    debug = require('debug')('hbnb:invoke:ready');
	}
	
	var env = __webpack_require__(362);
	
	var fnQueue = [];
	
	document.addEventListener('HBNB:ready', function() {
	    if (false) {
	        debug('fnQueue length = %s', fnQueue.length);
	    }
	
	    for (var i = 0, ii = fnQueue.length; i < ii; ++i) {
	        fnQueue[i]();
	    }
	});
	
	var ready = function(fn) {
	    if (typeof fn !== 'function') {
	        return;
	    }
	
	    if (env.HBNBReady) {
	        fn();
	    } else {
	        if (false) {
	            debug('push fn to fnQueue');
	        }
	
	        fnQueue.push(fn);
	    }
	};
	
	module.exports = ready;


/***/ }),
/* 366 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var debug;
	if (false) {
	    debug = require('debug')('hbnb:invoke:build-uri');
	}
	
	var _id = 0;
	var _buildCallback = function(fn) {
	    var fnID = (new Date().getTime() + '_' + (++_id));
	    var callbackName = 'HBNB_CALLBACK_' + fnID;
	    window[callbackName] = (function(fn, callbackName) {
	        var innerFN = function() {
	            var r = fn.apply(null, arguments);
	            if (r !== false) {
	                delete window[callbackName];
	            }
	        };
	        return innerFN;
	    })(fn, callbackName);
	
	    if (false) {
	        //debug('window["%s"] call "%s"', callbackName, fn);
	    }
	
	    return callbackName;
	};
	
	var _processParameters = function(key, value) {
	    if (typeof value === 'function') {
	        return _buildCallback(value);
	    } else {
	        return value;
	    }
	};
	
	var buildURI = function(protocol, moduleName, methodName, parameters) {
	    if (false) {
	        debug('protocol = %s', protocol);
	        debug('module = %s', moduleName);
	        debug('method = %s', methodName);
	        debug('before process, parameters is %j', parameters);
	    }
	
	    var params = encodeURIComponent(JSON.stringify(parameters, _processParameters));
	    if (false) {
	        debug('after encode, parameters is %s', params);
	    }
	
	    var uri = protocol + '//' + moduleName + '/' + methodName + '?params=' + params;
	
	    if (false) {
	        debug('uri = %s', uri);
	    }
	
	    return uri;
	};
	
	module.exports = buildURI;
	module.exports.processParams = _processParameters; // for legency-lvyou


/***/ }),
/* 367 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var debug;
	if (false) {
	    debug = require('debug')('hbnb:invoke:send-uri');
	}
	
	var env = __webpack_require__(362);
	
	/*eslint-disable no-undef, block-scoped-var, no-alert */
	var strategy = {
	    'alert': function(uri) { window.alert(uri); },
	    'prompt': function(uri) { window.prompt(uri); },
	    'HBNB': {
	        'android': function(uri) { HBNB.sendBridgeMessage(uri); },
	        'ios': function(uri) { HBNB.postMessage(uri); }
	    }
	};
	/*eslint-enable no-undef, block-scoped-var, no-alert */
	
	var sendURI;
	if (env.platform === 'ios') {
	    sendURI = strategy['HBNB']['ios'];
	} else if (env.platform === 'android') {
	    if (env.supportPrompt) {
	        // android app >= 6.0 support window.prompt
	        sendURI = strategy['prompt'];
	    } else {
	        sendURI = strategy['HBNB']['android'];
	    }
	} else {
	    sendURI = strategy['alert'];
	}
	
	if (false) {
	    debug('sendURI = %s', sendURI);
	}
	
	module.exports = sendURI;


/***/ }),
/* 368 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * @name core
	 */
	
	exports.HBNBVersion = __webpack_require__(369);
	exports.supportApis = __webpack_require__(370);
	exports.OSVersion = __webpack_require__(371);


/***/ }),
/* 369 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var debug;
	if (false) {
	    debug = require('debug')('hbnb:module:core:HBNBVersion');
	}
	
	var _invoke = __webpack_require__(360);
	
	/**
	 * 获取桥协议版本
	 *
	 * 支持版本
	 * + iHotel/6.1+
	 * + HBNB/?
	 *
	 * @memberof core
	 * @static
	 * @name HBNBVersion
	 * @return {Promise<version>}
	 * @example
	 *  hbnb.core.HBNBVersion()
	 *      .then(function(version) {
	 *      });
	 */
	
	module.exports = function() {
	    if (false) {
	        debug('called');
	    }
	
	    var p = new Promise(function(resolve, reject) {
	        _invoke('core', 'hbnb_version', {
	            callback: function(version) {
	                if (false) {
	                    debug('version is %j', version);
	                }
	                if (version && version.version) {
	                    resolve(version.version);
	                } else {
	                    reject();
	                }
	            }
	        });
	    });
	    return p;
	};


/***/ }),
/* 370 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var debug;
	if (false) {
	    debug = require('debug')('hbnb:module:core:supportApis');
	}
	
	var _invoke = __webpack_require__(360);
	
	/**
	 * 获取桥协议版本
	 *
	 * 支持版本
	 * + iHotel/6.1+
	 * + HBNB/?
	 *
	 * @memberof core
	 * @static
	 * @name supportApis
	 * @return {Promise<Array>}
	 * @example
	 *  hbnb.core.supportApis([
	 *      'magpie://ui/alert',
	 *      'magpie://what/the_f**k'
	 *  ])
	 *      .then(function(status) {
	 *          status = [
	 *              true,
	 *              false
	 *          ]
	 *      });
	 */
	
	module.exports = function(apis) {
	    if (false) {
	        debug('apis is %j', apis);
	    }
	
	    var p = new Promise(function(resolve, reject) {
	        _invoke('core', 'support_apis', {
	            callback: function(status) {
	                if (false) {
	                    debug('status is %j', status);
	                }
	                resolve(status);
	            }
	        });
	    });
	    return p;
	};


/***/ }),
/* 371 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var debug;
	if (false) {
	    debug = require('debug')('hbnb:module:core:OSVersion');
	}
	
	var _invoke = __webpack_require__(360);
	
	/**
	 * 获取桥协议版本
	 *
	 * 支持版本
	 * + iHotel/6.1+
	 * + HBNB/?
	 *
	 * @memberof core
	 * @static
	 * @name OS
	 * @return {Promise<version>}
	 * @example
	 *  hbnb.core.OSVersion()
	 *      .then(function(version) {
	 *          version = {
	 *              os: 'ios',
	 *              version: '9.0'
	 *          }
	 *      });
	 */
	
	module.exports = function() {
	    if (false) {
	        debug('called');
	    }
	
	    var p = new Promise(function(resolve, reject) {
	        _invoke('core', 'os_version', {
	            callback: function(version) {
	                if (false) {
	                    debug('version is %j', version);
	                }
	                resolve(version);
	            }
	        });
	    });
	    return p;
	};


/***/ }),
/* 372 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * @name account
	 */
	
	exports.login = __webpack_require__(373);
	exports.getUser = __webpack_require__(374);
	exports.mobileLogin = __webpack_require__(375);
	exports.sendMobileLoginCode = __webpack_require__(376);


/***/ }),
/* 373 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var debug;
	if (false) {
	    debug = require('debug')('hbnb:module:account:login');
	}
	
	var _invoke = __webpack_require__(360);
	
	/**
	 * 打开客户端登录界面
	 *
	 * 1. 客户端不会判断是否已经登录。
	 * 需要业务方自己调用 `hbnb.account.getUser` 判断是否已经登录。
	 * 2. 用户没有登录直接返回时，客户端不会给出通知。
	 * 需要业务方自己监听 `HBNB:pageshow` 事件。
	 *
	 * 支持版本
	 * + iHotel/5.8
	 *
	 * @memberof account
	 * @static
	 * @name login
	 * @returns {Promise<user>} resolve if login success
	 * @example
	 *  hbnb.account.login()
	 *      .then(function(user) {
	 *          user = {
	 *              userId: 1234567,
	 *              userName: 'name is string',
	 *              userToken: 'token is string'
	 *          }
	 *      })
	 */
	
	module.exports = function() {
	    var p = new Promise(function(resolve, reject) {
	        _invoke('user', 'login', {
	            callback: function(user) {
	                if (false) {
	                    debug('success, user is %j', user, user);
	                }
	                resolve(user);
	            },
	            errback: reject
	        });
	    });
	    return p;
	};


/***/ }),
/* 374 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var debug;
	if (false) {
	    debug = require('debug')('hbnb:module:account:getUser');
	}
	
	var _invoke = __webpack_require__(360);
	
	/**
	 * 获取用户登录信息
	 *
	 * 用户已登录时 resolve，用户未登录 reject
	 *
	 * 支持版本
	 * + iHotel/5.8+
	 *
	 * @memberof account
	 * @static
	 * @name getUser
	 * @return {Promise<user | err>}
	 * @example
	 *  hbnb.account.getUser()
	 *      .then(function(user) {
	 *          user = {
	 *              userId: 1234567,
	 *              userName: 'name is string',
	 *              userToken: 'token is string'
	 *          }
	 *      })
	 *      .catch(function(err) {
	 *          err = {
	 *              message: "用户未登录美团",
	 *              status: -1
	 *          }
	 *      });
	 */
	
	module.exports = function(cb, eb) {
	    var p = new Promise(function(resolve, reject) {
	        _invoke('user', 'get_user', {
	            callback: function(user) {
	                if (false) {
	                    debug('user is %j', user, user);
	                }
	                resolve(user);
	            },
	            errback: reject
	        });
	    });
	    return p;
	};


/***/ }),
/* 375 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var debug;
	if (false) {
	    debug = require('debug')('hbnb:module:account:mobileLogin');
	}
	
	var _invoke = __webpack_require__(360);
	
	/**
	 * 打开客户端登录界面
	 *
	 * 客户端不会判断是否已经登录。
	 * 需要业务方自己调用 `hbnb.account.getUser` 判断是否已经登录。
	 *
	 * 支持版本
	 * + iHotel/6.2
	 *
	 * @memberof account
	 * @static
	 * @name mobileLogin
	 * @param mobile
	 * @param code
	 * @returns {Promise<user>} resolve if login success
	 * @example
	 *  hbnb.account.mobileLogin(19988887777, 123456)
	 *      .then(function(user) {
	 *          user = {
	 *              userId: 1234567,
	 *              userName: 'name is string',
	 *              userToken: 'token is string'
	 *          }
	 *      })
	 *      .catch(function(err) {
	 *      })
	 */
	
	module.exports = function(mobile, code) {
	    var p = new Promise(function(resolve, reject) {
	        _invoke('user', 'mobile_login', {
	            mobile: mobile,
	            code: code,
	            callback: function(user) {
	                if (false) {
	                    debug('success, user is %j', user, user);
	                }
	                resolve(user);
	            },
	            errback: reject
	        });
	    });
	    return p;
	};


/***/ }),
/* 376 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var debug;
	if (false) {
	    debug = require('debug')('hbnb:module:account:sendMobileLoginCode');
	}
	
	var _invoke = __webpack_require__(360);
	
	/**
	
	 *
	 * 支持版本
	 * + iHotel/6.2
	 *
	 * @memberof account
	 * @static
	 * @name sendMobileLoginCode
	 * @param {String} mobile 手机号
	 * @returns {Promise<user>} resolve if login success
	 * @example
	 *  hbnb.account.sendMobileLoginCode('19988887777')
	 *      .then(function() {
	 *      })
	 *      .catch(function() {
	 *      })
	 */
	
	module.exports = function(mobile) {
	    var p = new Promise(function(resolve, reject) {
	        _invoke('user', 'send_mobile_login_code', {
	            mobile: mobile,
	            callback: function() {
	                resolve();
	            },
	            errback: reject
	        });
	    });
	    return p;
	};


/***/ }),
/* 377 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * @name log
	 */
	exports.mge = __webpack_require__(378);


/***/ }),
/* 378 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var debug;
	if (false) {
	    debug = require('debug')('hbnb:module:log:mge');
	}
	
	var _invoke = __webpack_require__(360);
	
	/**
	 * 发送 mge 统计参数
	 *
	 * 支持版本
	 * + iHotel/5.8+
	 *
	 * @memberof log
	 * @static
	 * @name mge
	 * @param {String | Undefined} cid 页面名
	 * @param {String | Undefined} act 事件名
	 * @param {String | Undefined} val 页面属性
	 * @param {String | Undefined} lab 事件属性
	 * @return {Undefined}
	 * @example
	 *  hbnb.log.mge('页面A', '点击事件B');
	 *  hbnb.log.mge({
	 *      cid: '页面A‘，
	 *      act: '点击事件B'
	 *  });
	 */
	
	module.exports = function(cid, act, val, lab) {
	    if (false) {
	        debug('cid = %s', cid);
	        debug('act = %s', act);
	        debug('val = %s', val);
	        debug('lab = %s', lab);
	    }
	
	    if (typeof cid === 'object') {
	        var opt = cid;
	        cid = String(opt.cid || '');
	        act = String(opt.act || opt.action);
	        val = String(opt.val || opt.value);
	        lab = String(opt.lab || opt.label);
	    }
	
	    _invoke('log', 'mge', {
	        cid: cid || '',
	        action: act || '',
	        value: val || '',
	        label: lab || ''
	    });
	};


/***/ }),
/* 379 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * @name network
	 */
	
	exports.request = __webpack_require__(380);
	exports.sendSms = __webpack_require__(381);
	
	//exports.httpRequest = require('./http-request.js'); // not support POST, disabled


/***/ }),
/* 380 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var debug;
	var assert;
	if (false) {
	    debug = require('debug')('hbnb:module:network:request');
	    assert = require('assert');
	}
	
	var _invoke = __webpack_require__(360);
	
	
	/**
	 * 发起网络请求
	 *
	 * @memberof network
	 * @static
	 * @name request
	 * @param {Object} opts 请求参数，参考 [request](https://github.com/request/request#requestoptions-callback)
	 * @return {Promise<resp|err>}
	 * @example
	 *  hbnb.network.request({
	 *      url: 'https://www.google.com/',
	 *      method: 'GET',
	 *      headers: {
	 *          'X-Requested-With': 'XMLHttpRequest'
	 *      },
	 *      body: '',
	 *      followRedirect: true,
	 *      maxRedirects: 10,
	 *      timeout: 5000
	 *  }).then(function(resp) {
	 *      resp = {
	 *          statusCode: 404,
	 *          body: '',
	 *          headers: {
	 *              'content-encoding': ['gzip']
	 *          }
	 *      }
	 *  }).catch(function(err) {
	 *      err = {
	 *          message: "用户未登录美团",
	 *          status: -1
	 *      }
	 *  });
	 *
	 */
	
	module.exports = function(opts) {
	    if (false) {
	        debug('request opts is %j', opts);
	        assert(opts.url);
	        assert(typeof opts.method === 'undefined' || ['GET', 'POST', 'PUT', 'DELETE'].indexOf(opts.method.toUpperCase()) !== -1);
	        assert(typeof opts.headers === 'undefined' || typeof opts.headers === 'object');
	        assert(typeof opts.body === 'undefined' || typeof opts.body === 'string');
	        assert(typeof opts.followRedirect === 'undefined' || typeof opts.followRedirect === 'boolean');
	        assert(typeof opts.maxRedirects === 'undefined' || typeof opts.maxRedirects === 'number');
	        assert(typeof opts.timeout === 'undefined' || typeof opts.timeout === 'number');
	    }
	    if (opts.headers) {
	        var newHeaders = {};
	        var headers = opts.headers;
	        for (var key in headers) {
	            if (headers.hasOwnProperty(key)) {
	                newHeaders[key.toLowerCase()] = headers[key];
	            }
	        }
	        opts.headers = newHeaders;
	    }
	
	    var p = new Promise(function(resolve, reject) {
	        _invoke('network', 'request', {
	            url: opts.url,
	            method: opts.method ? opts.method.toUpperCase() : 'GET',
	            headers: opts.headers ? opts.headers : {},
	            body: opts.body ? opts.body : '',
	            followRedirect: !(opts.followRedirect === false),
	            maxRedirects: opts.maxRedirects ? opts.maxRedirects : 10,
	            timeout: opts.timeout ? opts.timeout : 5000,
	            insecure: opts.insecure ? opts.insecure : false,
	            responseEncoding: opts.responseEncoding ? opts.responseEncoding : '',
	            callback: function(response) {
	                if (false) {
	                    debug('request success, %j', response, response);
	                }
	                var newHeaders = {};
	                var headers = response.headers;
	                for (var i = 0, ii = headers.length; i < ii; i++) {
	                    var header = headers[i];
	                    var index = header.indexOf(';');
	                    if (index === -1) continue;
	                    var key = header.substr(0, key).trim().toLowerCase();
	                    var val = header.substr(index + 1).trim();
	                    newHeaders[key] = val;
	                }
	                response.headers = newHeaders;
	                resolve(response);
	            },
	            errback: function(msg) {
	                if (false) {
	                    debug('request fail, %j', msg);
	                }
	                reject(msg);
	            }
	        });
	    });
	
	    return p;
	};


/***/ }),
/* 381 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var debug;
	if (false) {
	    debug = require('debug')('hbnb:module:network:sendSms');
	}
	
	var _invoke = __webpack_require__(360);
	
	/**
	 * 发送预填充内容了的短信
	 *
	 * 支持版本
	 * + iHotel/6.6
	 *
	 * @memberof network
	 * @static
	 * @name sendSms
	 * @example
	 *  hbnb.network.sendSms({
	 *      "recipients": 110, // 电话号码，支持多个
	 *      "text": "help" // 发送到的文字内容
	 *  })
	 */
	
	module.exports = function(mobile, content) {
	    _invoke('device', 'send_sms', {
	        "recipients": mobile, // 电话号码，支持多个
	        "text": content // 发送到的文字内容
	    });
	};


/***/ }),
/* 382 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * @name pay
	 */
	
	exports.payment = __webpack_require__(383);
	exports.getFingerprint = __webpack_require__(384);


/***/ }),
/* 383 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var debug;
	if (false) {
	    debug = require('debug')('hbnb:module:pay:payment');
	}
	
	var _invoke = __webpack_require__(360);
	
	/**
	 * 调用客户端收银台
	 *
	 * 支持版本
	 * + iHotel/5.8+
	 *
	 * @memberof pay
	 * @static
	 * @name payment
	 * @param {Object} opts 收银台参数
	 * @returns {Promise<orderId | Undefined>}
	 * @example
	 *  hbnb.pay.payment({
	 *      tradeNo: '123',
	 *      payToken: '456',
	 *      orderId: '789',
	 *      returnURL: 'imeituan://...'
	 *  }).then(function(data) {
	 *      data = {
	 *          isPayed: true,
	 *          orderId: '789'
	 *      }
	 *  }).catch(function() {
	 *      ...
	 *  });
	 */
	
	module.exports = function(opts) {
	    if (false) {
	        debug('payment opts is %j', opts);
	    }
	    var p = new Promise(function(resolve, reject) {
	        var cb = opts.callback;
	        opts.callback = function(data) {
	            if (false) {
	                debug('payment return %j', data);
	            }
	
	            resolve(data);
	            if (typeof cb === 'function') {
	                cb(data);
	            }
	        };
	        opts.errback = function() {
	            reject();
	        };
	        _invoke('pay', 'cashier', opts);
	    });
	    return p;
	};


/***/ }),
/* 384 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var debug;
	if (false) {
	    debug = require('debug')('hbnb:module:pay:getFingerprint');
	}
	
	var _invoke = __webpack_require__(360);
	var env = __webpack_require__(362);
	var versionCompare = __webpack_require__(363);
	
	/**
	 * 调用客户端收银台
	 *
	 * 支持版本
	 * + iHotel/6.1+
	 *
	 * @memberof pay
	 * @static
	 * @name getFingerprint
	 * @returns {Promise<String>}
	 * @example
	 *  hbnb.pay.getFingerprint()
	 *      .then(function(fp) {
	 *          fp = 'xxxxxxx'
	 *      });
	 */
	
	module.exports = function() {
	    if (false) {
	        debug('called');
	    }
	    var p = new Promise(function(resolve, reject) {
	        if (versionCompare(env.appVersion, '6.1') >= 0) {
	            _invoke('pay', 'get_fingerprint', {
	                callback: function(fingerprint) {
	                    if (false) {
	                        debug('fingerprint return %j', fingerprint);
	                    }
	                    if (fingerprint && fingerprint.fingerprint) {
	                        resolve(fingerprint.fingerprint);
	                    } else {
	                        reject();
	                    }
	                }
	            });
	        } else {
	            reject();
	        }
	    });
	    return p;
	};


/***/ }),
/* 385 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * @name position
	 */
	
	exports.getCity = __webpack_require__(386);


/***/ }),
/* 386 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var debug;
	if (false) {
	    debug = require('debug')('hbnb:module:position:getCity');
	}
	
	var _invoke = __webpack_require__(360);
	
	/**
	 * 获取当前选择的城市
	 *
	 * 支持版本
	 * + iHotel/5.8+
	 *
	 * @memberof position
	 * @static
	 * @name getCity
	 * @return {Promise<city>}
	 * @example
	 *  hbnb.position.getCity()
	 *      .then(function(city) {
	 *          city = {
	 *              cityId: 1,
	 *              cityName: '北京'
	 *              cityPinyin: 'beijing'
	 *          }
	 *      });
	 */
	module.exports = function() {
	    if (false) {
	        debug('call get city');
	    }
	    var p = new Promise(function(resolve, reject) {
	        _invoke('position', 'get_city', {
	            callback: function(city) {
	                if (false) {
	                    debug('return city %j', city);
	                }
	                resolve(city);
	            }
	        });
	    });
	    return p;
	};


/***/ }),
/* 387 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * @name storage
	 */
	
	exports.getItem = __webpack_require__(388);
	exports.setItem = __webpack_require__(389);
	exports.removeItem = __webpack_require__(390);
	exports.setResult = __webpack_require__(391);


/***/ }),
/* 388 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var debug;
	if (false) {
	    debug = require('debug')('hbnb:module:storage:getItem');
	}
	
	var _invoke = __webpack_require__(360);
	
	/**
	 * 客户端存储／查
	 *
	 * 支持版本
	 * + iHotel/5.8+
	 *
	 * @memberof storage
	 * @static
	 * @name getItem
	 * @return {Promise<val>}
	 * @example
	 *  hbnb.storage.getItem('key')
	 *      .then(function(value) {
	 *          value = '' || null;
	 *      });
	 */
	module.exports = function(key) {
	    if (false) {
	        debug('key is %s', key);
	    }
	
	    var p = new Promise(function(resolve, reject) {
	        _invoke('storage', 'get_item', {
	            key: key,
	            callback: function(val) {
	                if (false) {
	                    debug('value is %j', val);
	                }
	
	                if (val && val.value) {
	                    resolve(val.value);
	                } else {
	                    resolve(null);
	                }
	            }
	        });
	    });
	
	    return p;
	};


/***/ }),
/* 389 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var debug;
	if (false) {
	    debug = require('debug')('hbnb:module:storage:setItem');
	}
	
	var _invoke = __webpack_require__(360);
	
	/**
	 * 客户端存储／增、改
	 *
	 * 客户端调用是异步的，不保证接下去调用 `hbnb.storage.getItem` 能立刻获取最新值
	 *
	 * 支持版本
	 * + iHotel/5.8+
	 *
	 * @memberof storage
	 * @static
	 * @name setItem
	 * @return {Undefined}
	 * @example
	 *  hbnb.storage.setItem('key', 'value');
	 */
	module.exports = function(key, val) {
	    if (false) {
	        debug('key is %s, value is %s', key, val.toString(), val);
	    }
	
	    _invoke('storage', 'set_item', {
	        key: key,
	        value: val.toString()
	    });
	};


/***/ }),
/* 390 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var debug;
	if (false) {
	    debug = require('debug')('hbnb:module:storage:removeItem');
	}
	
	var _invoke = __webpack_require__(360);
	
	/**
	 * 客户端存储／删
	 *
	 * 客户端调用是异步的，不保证接下去调用 `hbnb.storage.getItem` 能立刻获取最新值
	 *
	 * 支持版本
	 * + iHotel/5.8+
	 *
	 * @memberof storage
	 * @static
	 * @name removeItem
	 * @return {Undefined}
	 * @example
	 *  hbnb.storage.removeItem('key');
	 */
	module.exports = function(key) {
	    if (false) {
	        debug('key is %s', key);
	    }
	
	    _invoke('storage', 'remove_item', {
	        key: key
	    });
	};


/***/ }),
/* 391 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var debug;
	if (false) {
	    debug = require('debug')('hbnb:module:webview:closeAll');
	}
	
	var _invoke = __webpack_require__(360);
	var env = __webpack_require__(362);
	var versionCompare = __webpack_require__(363);
	
	/**
	 * 适用的场景是native打开H5的页面选择学校、城市
	 *
	 * 支持版本
	 * + Android
	 * + iHotel/6.9+
	 *
	 * @memberof storage
	 * @static
	 * @name setResult
	 * @param {Object} obj
	 * @return {Undefined}
	 * @example
	 *  hbnb.storage.setResult({id: "45", name: "广西"});
	 */
	module.exports = function(params) {
	    if (false) {
	        debug('url list %s', params);
	    }
	
	    if (env.platform === 'android' && versionCompare(env.appVersion, '6.9') >= 0) {
	        _invoke('inject', 'set_result', params);
	    } else {
	        // no op
	    }
	};


/***/ }),
/* 392 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * @name thirdApps
	 */
	
	exports.installed = __webpack_require__(393);


/***/ }),
/* 393 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var debug;
	var assert;
	if (false) {
	    debug = require('debug')('hbnb:module:thirdApps:installed');
	    assert = require('assert');
	}
	
	var _invoke = __webpack_require__(360);
	
	/**
	 * 检查第三方软件安装情况
	 *
	 * 目前支持支付宝（`alipay`）
	 *
	 * 支持版本
	 * + iHotel/5.8+
	 *
	 * @memberof thirdApps
	 * @static
	 * @name installed
	 * @param {String} appName 软件名
	 * @return {Promise<status>}
	 * @example
	 *  var hbnb = request('@hfe/hbnb');
	 *  hbnb.thirdApps.installed('alipay')
	 *      .then(function(status) {
	 *          status = true || false
	 *      });
	 */
	module.exports = function(appName) {
	    if (false) {
	        debug('app is %s', appName);
	        assert(['alipay'].indexOf(appName) >= 0);
	    }
	
	    var p = new Promise(function(resolve, reject) {
	        _invoke('third_apps', 'installed', {
	            appName: appName,
	            callback: function(status) {
	                if (false) {
	                    debug('status is %j', status);
	                }
	
	                if (status && status.installed) {
	                    resolve(true);
	                } else {
	                    resolve(false);
	                }
	            }
	        });
	    });
	
	    return p;
	};


/***/ }),
/* 394 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * @name ui
	 */
	
	exports.loadingStart = __webpack_require__(395);
	exports.loadingStop = __webpack_require__(396);
	
	exports.toast = __webpack_require__(397);
	exports.alert = __webpack_require__(398);
	exports.confirm = __webpack_require__(399);
	
	exports.options = __webpack_require__(400);
	exports.singleSelect = __webpack_require__(401);
	
	exports.selectDate = __webpack_require__(402);
	exports.autoLock = __webpack_require__(403);


/***/ }),
/* 395 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var debug;
	if (false) {
	    debug = require('debug')('hbnb:module:ui:loadingStart');
	}
	
	var _invoke = __webpack_require__(360);
	
	/**
	 * 开启加载动画
	 *
	 * 在关闭前多次调用存在 bug，需要业务方自己把握开启／关闭的配对关系
	 *
	 * 支持版本
	 * + iHotel/5.8+
	 *
	 * @memberof ui
	 * @static
	 * @name loadingStart
	 * @return {Undefined}
	 * @example
	 *  hbnb.ui.loadingStart();
	 */
	module.exports = function() {
	    if (false) {
	        debug('start');
	    }
	
	    _invoke('ui', 'loading_start');
	};


/***/ }),
/* 396 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var debug;
	if (false) {
	    debug = require('debug')('hbnb:module:ui:loadingStop');
	}
	
	var _invoke = __webpack_require__(360);
	
	/**
	 * 关闭加载动画
	 *
	 * 支持版本
	 * + iHotel/5.8+
	 *
	 * @memberof ui
	 * @static
	 * @name loadingStop
	 * @return {Undefined}
	 * @example
	 *  hbnb.ui.loadingStop();
	 */
	module.exports = function() {
	    if (false) {
	        debug('stop');
	    }
	
	    _invoke('ui', 'loading_stop');
	};


/***/ }),
/* 397 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var debug;
	if (false) {
	    debug = require('debug')('hbnb:module:ui:toast');
	}
	
	var _invoke = __webpack_require__(360);
	
	/**
	 * toast 弹窗
	 *
	 * 支持版本
	 * + iHotel/5.8+
	 *
	 * @memberof ui
	 * @static
	 * @name toast
	 * @param {String} message 弹窗信息
	 * @param {Number} [time] toast 持续时间，单位 `ms`，可选，默认 3000
	 * @return {Undefined}
	 * @example
	 *  hbnb.ui.toast('message', 1000);
	 */
	
	module.exports = function(message, time) {
	    if (false) {
	        debug('message is %s', message);
	        debug('time is %s', time);
	    }
	
	    time = time || 3000;
	
	    _invoke('ui', 'toast', {
	        message: message,
	        time: time
	    });
	};


/***/ }),
/* 398 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var debug;
	if (false) {
	    debug = require('debug')('hbnb:module:ui:alert');
	}
	
	var _invoke = __webpack_require__(360);
	
	/**
	 * 单按钮弹窗，类似 alert
	 *
	 * 支持版本
	 * + iHotel/5.8+
	 *
	 * @memberof ui
	 * @static
	 * @name alert
	 * @param {String} message 弹窗信息
	 * @param {String} [title] 弹窗标题，可选
	 * @param {Array} button 按钮
	 * @return {Undefined}
	 * @example
	 *  hbnb.ui.alert('message', ['title'], [{
	 *      label: '确定',
	 *      callback: function() {
	 *          console.log('clicked');
	 *      }
	 *  }]);
	 */
	module.exports = function(message, title, button) {
	    if (false) {
	        debug('message is %j', message);
	        debug('title is %j', title);
	        debug('button is %j', button);
	    }
	
	    if (!button) {
	        button = title;
	        title = '';
	    }
	
	    // fix: button should be an array
	    if (Object.prototype.toString.call(button) === "[object Object]") {
	        button = [button];
	    }
	
	    _invoke('ui', 'alert', {
	        message: message,
	        title: title,
	        buttons: button
	    });
	};


/***/ }),
/* 399 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var debug;
	if (false) {
	    debug = require('debug')('hbnb:module:ui:confirm');
	}
	
	var _invoke = __webpack_require__(360);
	
	/**
	 * 双按钮弹窗，类似 confirm
	 *
	 * 支持版本
	 * + iHotel/5.8+
	 *
	 * @memberof ui
	 * @static
	 * @name confirm
	 * @param {String} message 弹窗信息
	 * @param {String} [title] 弹窗标题，可选
	 * @param {Object} leftButton 左按钮
	 * @param {Object} rightButton 右按钮
	 * @return {Undefined}
	 * @example
	 *  hbnb.ui.confirm('message', 'title', {
	 *      label: '确定',
	 *      callback: function() {}
	 *  }, {
	 *      label: '取消',
	 *      callback: function() {}
	 *  });
	 */
	module.exports = function(message, title, leftButton, rightButton) {
	    if (false) {
	        debug('message is %j', message);
	        debug('title is %j', title);
	        debug('left button is %j', leftButton);
	        debug('right button is %j', rightButton);
	    }
	
	    if (!rightButton) {
	        rightButton = leftButton;
	        leftButton = title;
	        title = '';
	    }
	
	    _invoke('ui', 'alert', {
	        message: message,
	        title: title,
	        buttons: [leftButton, rightButton]
	    });
	};


/***/ }),
/* 400 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var debug;
	if (false) {
	    debug = require('debug')('hbnb:module:ui:options');
	}
	
	var _invoke = __webpack_require__(360);
	
	/**
	 * 选项弹窗
	 *
	 * 支持版本
	 * + iHotel/5.8+
	 *
	 * @memberof ui
	 * @static
	 * @name options
	 * @param {Array} menus 选项数组
	 * @param {Object} cancel 取消按钮
	 * @return {Undefined}
	 * @example
	 *  hbnb.ui.options([{
	 *      label: 'option1',
	 *      callback: function() {}
	 *  }, {
	 *      label: 'option2',
	 *      callback: function() {}
	 *  }], {
	 *      label: 'cancel',
	 *      callback: function() {}
	 *  });
	 */
	module.exports = function(menus, cancel) {
	    if (false) {
	        debug('menus is %j', menus);
	        debug('cancel is %j', cancel);
	    }
	
	    _invoke('ui', 'options', {
	        menus: menus,
	        cancel: cancel
	    });
	};


/***/ }),
/* 401 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var debug;
	if (false) {
	    debug = require('debug')('hbnb:module:ui:singleSelect');
	}
	
	var _invoke = __webpack_require__(360);
	
	/**
	 * 单选框
	 *
	 * 支持版本
	 * + iHotel/5.8+
	 *
	 * @memberof ui
	 * @static
	 * @name singleSelect
	 * @param {Array} menus 选项数组
	 * @return {Undefined}
	 * @example
	 *  hbnb.ui.singleSelect([{
	 *      label: 'all',
	 *      active: true,
	 *      callback: function() {},
	 *  }, {
	 *      label: 'option 1',
	 *      active: false,
	 *      callback: function() {},
	 *  }, {
	 *      label: 'option 2',
	 *      active: false,
	 *      callback: function() {},
	 *  }]);
	 */
	module.exports = function(menus) {
	    if (false) {
	        debug('menus is %j', menus);
	    }
	
	    _invoke('ui', 'single_select', {
	        menus: menus
	    });
	};


/***/ }),
/* 402 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var debug;
	if (false) {
	    debug = require('debug')('hbnb:module:ui:singleDate');
	}
	
	var _invoke = __webpack_require__(360);
	
	/**
	 * 日期选择
	 *
	 * TODO: 补全示例
	 *
	 * 支持版本
	 * + iHotel/5.9.2+
	 *
	 * @memberof ui
	 * @static
	 * @name selectDate
	 * @param {String} current 当前日期
	 * @param {String} maxDate 最大可选日期
	 * @param {String} minDate 最小可选日期
	 * @return {Promise<date | err>}
	 * @example
	 *  hbnb.ui.selectDate('');
	 */
	module.exports = function(current, maxDate, minDate) {
	    if (false) {
	        debug('current is %s', current);
	        debug('maxDate is %s', maxDate);
	        debug('minDate is %s', minDate);
	    }
	
	    var p = new Promise(function(resolve, reject) {
	        _invoke('ui', 'select_date', {
	            original: current || '',
	            maxDate: maxDate,
	            minDate: minDate,
	            callback: function(data) {
	                resolve(data);
	            },
	            errback: function(err) {
	                reject(err);
	            }
	        });
	    });
	
	    return p;
	};


/***/ }),
/* 403 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var debug;
	if (false) {
	    debug = require('debug')('hbnb:module:ui:autoLock');
	}
	
	var _invoke = __webpack_require__(360);
	var env = __webpack_require__(362);
	var versionCompare = __webpack_require__(363);
	
	/**
	 * 不允许自动锁屏
	 *
	 * 支持版本
	 * + iHotel/6.5+
	 *
	 * @memberof ui
	 * @static
	 * @name autoLock
	 * @param {Boolean} enable true表示禁止自动锁屏
	 * @return {Undefined}
	 * @example
	 *  hbnb.ui.autoLock();
	 */
	module.exports = function(enable) {
	    if (false) {
	        debug('enable', enable);
	    }
	
	    if (versionCompare(env.appVersion, '6.5') >= 0) {
	        _invoke('ui', 'auto_lock', {
	            enable: enable
	        });
	    }
	};


/***/ }),
/* 404 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * @name webview
	 */
	
	exports.open = __webpack_require__(405);
	exports.back = __webpack_require__(406);
	exports.close = __webpack_require__(407);
	exports.closeAll = __webpack_require__(408);
	
	exports.modal = __webpack_require__(409);
	exports.dismiss = __webpack_require__(410);
	
	exports.setTitle = __webpack_require__(411);
	exports.setMenus = __webpack_require__(412);
	exports.setComplexTitle = __webpack_require__(413);
	
	exports.setBackAction = __webpack_require__(414);


/***/ }),
/* 405 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var debug;
	if (false) {
	    debug = require('debug')('hbnb:module:webview:open');
	}
	
	var _invoke = __webpack_require__(360);
	
	/**
	 * 打开新页面
	 *
	 * 与 `hbnb.webivew.close` 配合使用
	 *
	 * 支持版本
	 * + iHotel/5.8+
	 *
	 * @memberof webview
	 * @static
	 * @name open
	 * @param {String} url 页面地址
	 * @return {Undefined}
	 * @example
	 *  hbnb.webview.open('http://i.meituan.com');
	 */
	module.exports = function(url) {
	    if (false) {
	        debug('url is %s', url);
	    }
	
	    _invoke('webview', 'open', {
	        url: url
	    });
	};


/***/ }),
/* 406 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var debug;
	if (false) {
	    debug = require('debug')('hbnb:module:webview:back');
	}
	
	var _invoke = __webpack_require__(360);
	
	/**
	 * 后退
	 *
	 * TODO: ANDROID 旧版实现有问题
	 *
	 * 支持版本
	 * + iHotel/?
	 *
	 * @memberof webview
	 * @static
	 * @name back
	 * @return {Undefined}
	 * @example
	 *  hbnb.webview.back();
	 */
	module.exports = function() {
	    if (false) {
	        debug('called');
	    }
	
	    _invoke('webview', 'back');
	};


/***/ }),
/* 407 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var debug;
	if (false) {
	    debug = require('debug')('hbnb:module:webview:close');
	}
	
	var _invoke = __webpack_require__(360);
	
	/**
	 * 关闭当前 webview
	 *
	 * 与 `hbnb.webivew.open` 配合使用
	 *
	 * TODO: ANDROID 旧版实现有问题
	 *
	 * 支持版本
	 * + iHotel/?
	 *
	 * @memberof webview
	 * @static
	 * @name close
	 * @return {Undefined}
	 * @example
	 *  hbnb.webview.close();
	 */
	module.exports = function() {
	    if (false) {
	        debug('called');
	    }
	
	    _invoke('webview', 'close');
	};


/***/ }),
/* 408 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var debug;
	if (false) {
	    debug = require('debug')('hbnb:module:webview:closeAll');
	}
	
	var _invoke = __webpack_require__(360);
	var env = __webpack_require__(362);
	var versionCompare = __webpack_require__(363);
	
	/**
	 * 适用的场景是抢票任务编辑，从任务列表不想回表单.
	 * ABCBC，在C页面closeAll([B, C])就退到页面A
	 *
	 * 与 `hbnb.webview.open` 配合使用
	 *
	 * 支持版本
	 * + Android
	 * + iHotel/6.5+
	 *
	 * @memberof webview
	 * @static
	 * @name closeAll
	 * @param {Array} urls 连续关闭的URL
	 * @return {Undefined}
	 * @example
	 *  hbnb.webview.closeAll([
	 *      '/qiangpiao/add/',
	 *      '/qiangpiao/list/'
	 *  ]);
	 */
	module.exports = function(urls) {
	    if (false) {
	        debug('url list %s', urls);
	    }
	
	    if (env.platform === 'android' && versionCompare(env.appVersion, '6.5') >= 0) {
	        _invoke('webview', 'close_all', {
	            urls: urls
	        });
	    } else {
	        _invoke('webview', 'close');
	    }
	};


/***/ }),
/* 409 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var debug;
	if (false) {
	    debug = require('debug')('hbnb:module:webview:modal');
	}
	
	var _invoke = __webpack_require__(360);
	
	/**
	 * 打开 modal 弹窗
	 *
	 * 1. 与 `hbnb.webivew.dismiss` 配合使用
	 * 2. `modal` 弹窗内部不能继续调用 `modal` 弹窗，可以调用 `open`
	 * 3. `dimiss` 时会关闭弹窗，且 modal 的操作不会纪录到后退路径中
	 *
	 * 支持版本
	 * + iHotel/5.8+
	 *
	 * @memberof webview
	 * @static
	 * @name modal
	 * @param {String} url 页面地址
	 * @return {Undefined}
	 * @example
	 *  hbnb.webview.modal('http://i.meituan.com');
	 */
	module.exports = function(url) {
	    if (false) {
	        debug('url is %s', url);
	    }
	
	    _invoke('webview', 'modal', {
	        url: url
	    });
	};


/***/ }),
/* 410 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var debug;
	if (false) {
	    debug = require('debug')('hbnb:module:webview:dismiss');
	}
	
	var _invoke = __webpack_require__(360);
	
	/**
	 * 关闭当前 modal
	 *
	 * 与 `hbnb.webivew.modal` 配合使用
	 *
	 * 支持版本
	 * + iHotel/5.8+
	 *
	 * @memberof webview
	 * @static
	 * @name dismiss
	 * @example
	 *  hbnb.webview.dismiss();
	 */
	module.exports = function() {
	    if (false) {
	        debug('called');
	    }
	
	    _invoke('webview', 'dismiss');
	};


/***/ }),
/* 411 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var debug;
	if (false) {
	    debug = require('debug')('hbnb:module:webview:setTitle');
	}
	
	var _invoke = __webpack_require__(360);
	
	/**
	 * 修改标题
	 *
	 * 支持版本
	 * + iHotel/5.8+
	 *
	 * @memberof webview
	 * @static
	 * @name setTitle
	 * @param {String} title 标题
	 * @return {Undefined}
	 * @example
	 *  hbnb.webview.setTitle('new title');
	 */
	module.exports = function(title) {
	    if (false) {
	        debug('title is %s', title);
	    }
	
	    _invoke('webview', 'set_title', {
	        title: title
	    });
	};


/***/ }),
/* 412 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var debug;
	if (false) {
	    debug = require('debug')('hbnb:module:webview:setMenus');
	}
	
	var _invoke = __webpack_require__(360);
	
	/**
	 * 设置导航栏右侧按钮
	 *
	 * 目前支持 `icon`/`text` 两种类型的按钮
	 *
	 * 支持版本
	 * + iHotel/5.8+
	 *
	 * @memberof webview
	 * @static
	 * @name setMenus
	 * @param {Array} menus 按钮设置
	 * @return {Undefined}
	 * @example
	 *  hbnb.webview.setMenus([{
	 *      type: 'text',
	 *      text: '确定',
	 *      color: '#cccccc',
	 *      callback: function() {console.log('clicked'); return false;}
	 *  }, {
	 *      type: 'icon',
	 *      icon: 'url',
	 *      callback: function() {console.log('clicked'); return false;}
	 *  ]);
	 */
	module.exports = function(menus) {
	    if (false) {
	        debug('menus is %j', menus);
	    }
	
	    _invoke('webview', 'set_navbar_menus', {
	        menus: menus
	    });
	};


/***/ }),
/* 413 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var debug;
	var assert;
	if (false) {
	    debug = require('debug')('hbnb:module:webview:setComplexTitle');
	    assert = require('assert');
	}
	
	var _invoke = __webpack_require__(360);
	
	/**
	 * 设置复杂标题
	 *
	 * 根据传入的 `type` 判断使用那种展示形式。
	 * 如果当前版本不支持 `type`，会回退到普通形式，只展示 `title`。
	 *
	 * 目前只支持上下双栏的主副标题 `type='two-row'`
	 *
	 * 支持版本
	 * + iHotel/5.9.2+
	 *
	 * @memberof webview
	 * @static
	 * @name setComplexTitle
	 * @param {Object} opts 标题设置
	 * @return {Undefined}
	 * @example
	 *  hbnb.webview.setComplexTitle({
	 *      type: 'two-row',
	 *      title: 'title',
	 *      subTitle: 'subTitle'
	 *  });
	 */
	module.exports = function(opts) {
	    if (false) {
	        debug('opts is %j', opts);
	        assert(opts.title);
	    }
	
	    _invoke('webview', 'set_complex_title', opts);
	};


/***/ }),
/* 414 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var debug;
	if (false) {
	    debug = require('debug')('hbnb:module:webview:setBackAction');
	}
	
	var _invoke = __webpack_require__(360);
	
	/**
	 * 修改后退操作
	 *
	 * 一旦设置该函数，用户点击后退时只会调用该函数而不会直接后退。
	 * 可在函数内调用 `hbnb.webview.back` 方法进行后退
	 *
	 * TODO: 支持版本
	 *
	 * 支持版本
	 * + iHotel/??
	 *
	 * @memberof webview
	 * @static
	 * @name setBackAction
	 * @param {Function} cb 点击后退按钮时执行的函数
	 * @return {Undefined}
	 * @example
	 *  hbnb.webview.setBackAction(function() {
	 *      // do something
	 *  });
	 */
	module.exports = function(cb) {
	    if (false) {
	        debug('callback is %s', cb);
	    }
	
	    _invoke('webview', 'set_navbar_back', {
	        callback: function() {
	            cb();
	            return false;
	        }
	    });
	};


/***/ }),
/* 415 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * @name Tower
	 */
	
	exports.getUuid = __webpack_require__(416);
	exports.commentCallback= __webpack_require__(417);
	exports.comment = __webpack_require__(418);
	exports.shareConfig = __webpack_require__(419);
	exports.checkNickname = __webpack_require__(420);
	


/***/ }),
/* 416 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var debug;
	if (false) {
	    debug = require('debug')('hbnb:module:tower:getUuid');
	}
	
	var _invoke = __webpack_require__(360);
	
	/**
	 * 获取用户设备信息
	 *
	 * 目前主要用来获得UUID
	 *
	 * 支持版本
	 * + iTower/0.4+
	 *
	 * @memberof tower
	 * @static
	 * @name getUuid
	 * @return {Promise<string | err>}
	 * @example
	 *  hbnb.tower.getUuid()
	 *      .then(function(uuid) {
	 *          uuid = {
	 *              UUID: "xxxxxxxxx"
	 *          };
	 *      })
	 *      .catch(function(err) {
	 *          err = {
	 *              status: -1
	 *          };
	 *      });
	 */
	
	module.exports = function(cb, eb) {
	    return new Promise(function(resolve, reject) {
	        _invoke('tower', 'get_uuid', {
	            callback: function(result) {
	                if (false) {
	                    debug('uuid is %j', result, result);
	                }
	                resolve(result.UUID);
	            },
	            errback: reject
	        });
	    });
	};


/***/ }),
/* 417 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var debug;
	if (false) {
	    debug = require('debug')('hbnb:module:tower:commentCallback');
	}
	
	var _invoke = __webpack_require__(360);
	
	/**
	 * 专题评论成功通知
	 *
	 * 专题评论成功后，通知客户端，无返回数据
	 *
	 * 支持版本
	 * + iTower/0.4+
	 *
	 * @memberof tower
	 * @static
	 * @name sendTopicCommentSuccess
	 * @return {Promise<string | err>}
	 * @example
	 *  hbnb.tower.commentCallback();
	 */
	
	module.exports = function(cb, eb) {
	    return new Promise(function(resolve, reject) {
	        _invoke('tower', 'sendTopicCommentSuccess', {
	            callback: function(result) {
	                if (false) {
	                    debug('comment callback result is %j', result, result);
	                }
	                resolve(result);
	            },
	            errback: reject
	        });
	    });
	};


/***/ }),
/* 418 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var debug;
	if (false) {
	    debug = require('debug')('hbnb:module:tower:comment');
	}
	
	var _invoke = __webpack_require__(360);
	
	/**
	 * 打开native评论输入界面
	 *
	 * 支持版本
	 * + MtLvxing/1.3+
	 *
	 * @memberof tower
	 * @static
	 * @name comment
	 * @param {Object} opts
	 * @return {Promise<object | err>}
	 * @example
	 *  hbnb.tower.comment({
	 *          type: 'simple',
	 *          placeholder: '请在此输入',
	 *          content: '评论内容',
	 *          limit: 350,
	 *          buttonText: '发送',
	 *      })
	 *      .then(function(result) {
	 *          result = {
	 *              status: 0,
	 *              content: '用户输入的内容',
	 *          }
	 *      })
	 *      .catch(function(err) {
	 *          err = {
	 *              message: "fail",
	 *              status: -1
	 *          }
	 *      });
	 */
	
	module.exports = function(data) {
	    var p = new Promise(function(resolve, reject) {
	        _invoke('tower', 'comment', {
	            type: data.type || 'simple',
	            placeholder: data.placeholder || '',
	            content: data.content || '',
	            limit: data.limit || null,
	            buttonText: data.buttonText,
	
	            callback: function(result) {
	                if (false) {
	                    debug('comment result is %j', result);
	                }
	                resolve(result);
	            },
	            errback: reject
	        });
	    });
	    return p;
	};


/***/ }),
/* 419 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var debug;
	if (false) {
	    debug = require('debug')('hbnb:module:tower:shareConfig');
	}
	
	var _invoke = __webpack_require__(360);
	
	/**
	 * Webview 页面分享功能
	 *
	 * 在App中将页面分享到微信、朋友圈、微博
	 *
	 * 支持版本
	 * + iTower/1.3+
	 *
	 * @memberof tower
	 * @static
	 * @name shareConfig
	 * @param {String} name
	 * @param {Object} opts
	 * @return {Promise<string | err>}
	 * @example
	 *  hbnb.tower.shareConfig('weixin', {
	 *      title: '页面名称',
	 *      desc: '内容',
	 *      imgUrl: 'http://xxx.jpg',
	 *      link: 'http://www.com',
	 *  }).then().catch();
	 */
	
	module.exports = function(name, data) {
	    return new Promise(function(resolve, reject) {
	        _invoke('tower', 'share_config_' + name, {
	            title: data.title,
	            desc: data.desc,
	            imgUrl: data.imgUrl,
	            link: data.link,
	            callback: function(result) {
	                if (false) {
	                    debug('share_config result is %j', result);
	                }
	                resolve(result);
	            },
	            errback: reject
	        });
	    });
	};
	


/***/ }),
/* 420 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var debug;
	if (false) {
	    debug = require('debug')('hbnb:module:tower:userCheckNickname');
	}
	
	var _invoke = __webpack_require__(360);
	
	/**
	 *
	 * 检查设置用户昵称
	 *
	 * http://wiki.sankuai.com/pages/viewpage.action?pageId=500753388
	 *
	 * 支持版本
	 * + iTower/1.3+
	 *
	 * @memberof tower
	 * @static
	 * @name checkNickname
	 * @return {Promise<string | err>}
	 * @example
	 *  hbnb.tower.checkNickname();
	 */
	
	module.exports = function() {
	    return new Promise(function(resolve, reject) {
	        _invoke('tower', 'user_check_nickname', {
	            callback: function(result) {
	                if (false) {
	                    debug('check nickname callback result is %j', result);
	                }
	                resolve(result);
	            },
	            errback: reject
	        });
	    });
	};


/***/ }),
/* 421 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * @name flight
	 */
	
	exports.gotoAppHomepage = __webpack_require__(422);
	
	//exports.getUser = require('./get-user.js');
	//exports.login = require('./login.js');
	
	exports.getFilter = __webpack_require__(423);
	exports.getLinkman = __webpack_require__(424);
	exports.getExpress = __webpack_require__(425);
	exports.selectCity = __webpack_require__(426);
	exports.selectDate = __webpack_require__(427);
	exports.selectRoundDate = __webpack_require__(428);
	
	//exports.alipay = require('./alipay.js');
	
	exports.gotoOrderDetail = __webpack_require__(429);


/***/ }),
/* 422 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var debug;
	if (false) {
	    debug = require('debug')('hbnb:module:flight:gotoAppHomepage');
	}
	
	var _invoke = __webpack_require__(360);
	
	/**
	 * 返回 app 首页
	 *
	 * @memberof flight
	 * @static
	 * @name gotoAppHomepage
	 * @return {Undefined}
	 * @example
	 *  hbnb.flight.gotoAppHomepage();
	 */
	module.exports = function() {
	    if (false) {
	        debug('called');
	    }
	
	    _invoke('flight', 'goto_app_homepage');
	};


/***/ }),
/* 423 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var debug;
	if (false) {
	    debug = require('debug')('hbnb:module:flight:getFilter');
	}
	
	var _invoke = __webpack_require__(360);
	
	/**
	 * 机票筛选
	 *
	 * TODO：补全参数
	 *
	 * @memberof flight
	 * @static
	 * @name getFilter
	 * @param {Object} opts
	 * @return {Promise}
	 * @example
	 *  hbnb.flight.getFilters([
	 *  ]).then(function(data) {
	 *  });
	 */
	module.exports = function(opts) {
	    if (false) {
	        debug('opts is %j', opts);
	    }
	
	    var p = new Promise(function(resolve, reject) {
	        _invoke('flight', 'get_filter', {
	            options: opts,
	            callback: function(data) {
	                resolve(data);
	            }
	        });
	    });
	    return p;
	};


/***/ }),
/* 424 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var debug;
	if (false) {
	    debug = require('debug')('hbnb:module:flight:getLinkman');
	}
	
	var _invoke = __webpack_require__(360);
	
	/**
	 * 获取联系人
	 *
	 * @memberof flight
	 * @static
	 * @name getLinkman
	 * @param {int} id 默认为 '', 
	 * @return {Promise}
	 * @example
	 * hbnb.flight.getLinkman('').then(function(data) {
	 *     data = {
	           id: 'id is number',
	 *         name: 'name is string',
	 *         mobile: 'mobile is string',
	 *         email: 'mobile is string',
	 *     }
	 * });
	 */
	module.exports = function(id) {
	    var p = new Promise(function(resolve, reject) {
	        _invoke('flight', 'get_linkman', {
	            id: id,
	            is_international: is_international,
	            callback: function(date) {
	                resolve(date);
	            }
	        });
	    });
	    return p;
	};
	


/***/ }),
/* 425 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var debug;
	if (false) {
	    debug = require('debug')('hbnb:module:flight:getExpress');
	}
	
	var _invoke = __webpack_require__(360);
	
	/**
	 * 获取邮寄地址
	 *
	 * @memberof flight
	 * @static
	 * @name getExpress
	 * @param {siteId} siteId,
	 * @param {int} id 默认为 '',
	 * @return {Promise}
	 * @example
	 hbnb.flight.getExpress(1, '').then(function(data) {
	     data = {
	         id: 'id is number',
	         name: 'name is string',
	         mobile: 'mobile is string',
	         province: 'province is string',
	         city: 'city is string',
	         district: 'district is string',
	         address: 'address is string',
	         postCode: 'postCode is string',
	         expressAmount: 'expressAmount is string'
	     }
	 });
	 */
	module.exports = function(siteId, id) {
	    var p = new Promise(function(resolve, reject) {
	        _invoke('flight', 'get_express', {
	            siteId: siteId,
	            id: id,
	            callback: function(date) {
	                resolve(date);
	            }
	        });
	    });
	    return p;
	};


/***/ }),
/* 426 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var debug;
	if (false) {
	    debug = require('debug')('hbnb:module:flight:selectCity');
	}
	
	var _invoke = __webpack_require__(360);
	
	/**
	 * 选择城市
	 *
	 * @memberof flight
	 * @static
	 * @name selectCity
	 * @param {String} city
	 * @return {Promise}
	 * @example
	 *  hbnb.flight.selectCity('city')
	 *      .then(function(city) {
	 *          city = {
	 *              cityName: '',
	 *              cityPinyin: ''
	 *          }
	 *      });
	 */
	module.exports = function(city) {
	    if (false) {
	        debug('city is %s', city);
	    }
	    city = city || '';
	
	    var p = new Promise(function(resolve, reject) {
	        _invoke('flight', 'select_city', {
	            original: city,
	            callback: function(city) {
	                resolve(city);
	            }
	        });
	    });
	    return p;
	};


/***/ }),
/* 427 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var debug;
	if (false) {
	    debug = require('debug')('hbnb:module:flight:selectDate');
	}
	
	var _invoke = __webpack_require__(360);
	
	/**
	 * 选择日期
	 *
	 * @memberof flight
	 * @static
	 * @name selectDate
	 * @param {String} fromCity
	 * @param {String} toCity
	 * @param {String} months
	 * @param {String} original
	 * @return {Promise}
	 * @example
	 *  hbnb.flight.selectDate(
	 *      fromCity,
	 *      toCity,
	 *      months,
	 *      original
	 *  ).then(function(data) {
	 *      console.log(data);
	 *  });
	 */
	module.exports = function(fromCity, toCity, months, original) {
	    if (false) {
	        debug('original is %s', original);
	        debug('from city %s', fromCity);
	        debug('to city %s', toCity);
	        debug('mounths is %s', months);
	    }
	    original = original || '';
	
	    var p = new Promise(function(resolve, reject) {
	        _invoke('flight', 'select_date', {
	            original: original,
	            months: months,
	            fromCity: fromCity,
	            toCity: toCity,
	            callback: function(date) {
	                resolve(date);
	            }
	        });
	    });
	    return p;
	};


/***/ }),
/* 428 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var debug;
	if (false) {
	    debug = require('debug')('hbnb:module:flight:selectRoundDate');
	}
	
	var _invoke = __webpack_require__(360);
	
	/**
	 * 选择日期
	 *
	 * @memberof flight
	 * @static
	 * @name selectRoundDate
	 * @return {Promise}
	 * @example
	 *  hbnb.flight.selectRoundDate().then(function(data) {
	 *      console.log(data);
	 *  });
	 */
	module.exports = function() {
	    var p = new Promise(function(resolve, reject) {
	        _invoke('flight', 'select_roundDate', {
	            callback: function(date) {
	                resolve(date);
	            }
	        });
	    });
	    return p;
	};


/***/ }),
/* 429 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var debug;
	if (false) {
	    debug = require('debug')('hbnb:module:flight:gotoOrderDetail');
	}
	
	var _invoke = __webpack_require__(360);
	
	/**
	 * 进入机票订单详情页面
	 *
	 * 点击后退时会返回订单列表页面，再后退会返回我的页面
	 *
	 * @memberof flight
	 * @static
	 * @name gotoOrderDetail
	 * @param {String} url 订单页面地址
	 * @param {String} orderListUrl 订单列表页面地址
	 * @return {Undefined}
	 * @example
	 *  hbnb.flight.gotoOrderDetail(
	 *      'url'
	 *      'orderListUrl'
	 *  );
	 */
	module.exports = function(url, orderListUrl) {
	    if (false) {
	        debug('url is %s', url);
	        debug('orderListUrl is %s', orderListUrl);
	    }
	
	    _invoke('flight', 'goto_order_detail', {
	        url: url,
	        orderListUrl: orderListUrl
	    });
	};


/***/ }),
/* 430 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * @name train
	 */
	
	exports.gotoOrderDetail = __webpack_require__(431);
	exports.selectDate = __webpack_require__(432);
	exports.selectStation = __webpack_require__(433);
	exports.timeTable = __webpack_require__(434);
	
	exports.selectDateStudent = __webpack_require__(435);
	exports.selectDateRush = __webpack_require__(436);
	exports.timeRange = __webpack_require__(437);
	exports.gotoOrderList = __webpack_require__(438);
	exports.multiSelect = __webpack_require__(439);
	exports.selectTrains = __webpack_require__(440);
	exports.ringtone = __webpack_require__(441);
	exports.vibrate = __webpack_require__(442);


/***/ }),
/* 431 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var debug;
	if (false) {
	    debug = require('debug')('hbnb:module:train:gotoOrderDetail');
	}
	
	var _invoke = __webpack_require__(360);
	
	/**
	 * 进入火车票订单详情页面
	 *
	 * 点击后退时会返回订单列表页面，再后退会返回我的页面
	 *
	 * 支持版本
	 * + iHotel/5.8+
	 *
	 * @memberof train
	 * @static
	 * @name gotoOrderDetail
	 * @param {String} url 订单页面地址
	 * @param {String} orderListUrl 订单列表页面地址
	 * @return {Undefined}
	 * @example
	 *  hbnb.train.gotoOrderDetail(
	 *      'url'
	 *      'orderListUrl'
	 *  );
	 */
	module.exports = function(url, orderListUrl) {
	    if (false) {
	        debug('url is %s', url);
	        debug('orderListUrl is %s', orderListUrl);
	    }
	
	    _invoke('train', 'goto_order_detail', {
	        url: url,
	        orderListUrl: orderListUrl
	    });
	};


/***/ }),
/* 432 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var debug;
	if (false) {
	    debug = require('debug')('hbnb:module:train:selectDate');
	}
	
	var _invoke = __webpack_require__(360);
	
	/**
	 * 选择出行日期
	 *
	 * TODO: 补全参数和返回值
	 *
	 * 支持版本
	 * + iHotel/5.8+
	 *
	 * @memberof train
	 * @static
	 * @name selectDate
	 * @param {String} date 当前日期
	 * @param {Number} days 日期 6.2
	 * @param {String} tips 底部提示 6.2
	 * @return {Promise<date>}
	 * @example
	 *  hbnb.train.selectDate('date', '60', '预售期为60天，60天外不可购买')
	 *      .then(function(date) {
	 *          date = '2015-02-02'
	 *      });
	 */
	module.exports = function(date, days, tips) {
	    if (false) {
	        debug('date is %s', date);
	        debug('days is %s', days);
	        debug('tips is %s', tips);
	    }
	
	    if (days === undefined) days = 60;
	    if (tips === undefined) tips = '预售期为60天，60天外不可购买';
	
	    var p = new Promise(function(resolve, reject) {
	        _invoke('train', 'select_date', {
	            date: date,
	            days: days,
	            tips: tips,
	            callback: function(date) {
	                resolve(date.date);
	            }
	        });
	    });
	    return p;
	};


/***/ }),
/* 433 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var debug;
	if (false) {
	    debug = require('debug')('hbnb:module:train:selectStation');
	}
	
	var _invoke = __webpack_require__(360);
	
	/**
	 * 选择火车站
	 *
	 * TODO: 补全参数和返回值
	 *
	 * 支持版本
	 * + iHotel/5.8+
	 *
	 * @memberof train
	 * @static
	 * @name selectStation
	 * @param {String} stationCode 当前火车站
	 * @param {String} stationType 类型
	 * @return {Promise<station>}
	 * @example
	 *  hbnb.train.selectStation('code', 'type')
	 *      .then(function(station) {
	 *      });
	 */
	module.exports = function(stationCode, stationType) {
	    if (false) {
	        debug('station code is %s', stationCode);
	        debug('station type is %s', stationType);
	    }
	
	    var p = new Promise(function(resolve, reject) {
	        _invoke('train', 'select_station', {
	            stationCode: stationCode,
	            stationType: stationType,
	            callback: function(station) {
	                resolve(station);
	            }
	        });
	    });
	    return p;
	};


/***/ }),
/* 434 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var debug;
	if (false) {
	    debug = require('debug')('hbnb:module:train:timeTable');
	}
	
	var _invoke = __webpack_require__(360);
	
	/**
	 * 展示列车时刻表
	 *
	 * 支持版本
	 * + iHotel/5.8+
	 *
	 * @memberof train
	 * @static
	 * @name timeTable
	 * @param {Object} stations
	 * @return {Undefined}
	 * @example
	 *  hbnb.train.timeTable([{
	 *      type: 'inside/outside/from/to',
	 *      value: [
	 *          'station_no',
	 *          'station_name',
	 *          'arrive_time',
	 *          'start_time'
	 *          'stopover_time'
	 *      ]
	 *  }]);
	 */
	module.exports = function(stations) {
	    if (false) {
	        debug('stations is %j', stations);
	    }
	
	    _invoke('train', 'time_table', {
	        title: '列车时刻表',
	        header: ['', '车站', '到达', '发车', '停留'],
	        rows: stations
	    });
	};


/***/ }),
/* 435 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var debug;
	if (false) {
	    debug = require('debug')('hbnb:module:train:selectDateStudent');
	}
	
	var _invoke = __webpack_require__(360);
	
	/**
	 * 选择出行日期
	 *
	 *
	 * 支持版本
	 * + iHotel/5.8+
	 *
	 * @memberof train
	 * @static
	 * @name selectDateStudent
	 * @param {Object} opts 选项
	 * @return {Promise<date>}
	 * @example
	 *  hbnb.train.selectDateStudent({
	 *      date: '2015-10-19',
	 *      days: 60,
	 *      range: [{
	 *          start: '2015-10-20',
	 *          finish: '2015-12-30'
	 *      }],
	 *      tips: '预售期为60天，60天外不可购买'
	 *  })
	 *      .then(function(date) {
	 *          date = '2015-12-13'
	 *      });
	 */
	module.exports = function(opts) {
	    if (false) {
	        debug('opts is %j', opts);
	    }
	
	    var p = new Promise(function(resolve, reject) {
	        opts.callback = function(date) {
	            resolve(date.date);
	        };
	        _invoke('train', 'select_date_student', opts);
	    });
	    return p;
	};
	


/***/ }),
/* 436 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var debug;
	if (false) {
	    debug = require('debug')('hbnb:module:train:selectDateRush');
	}
	
	var _invoke = __webpack_require__(360);
	
	/**
	 * 选择出行日期
	 *
	 *
	 * 支持版本
	 * + iHotel/5.8+
	 *
	 * @memberof train
	 * @static
	 * @name selectDateRush
	 * @param {Object} opts 选项
	 * @return {Promise<date>}
	 * @example
	 *  hbnb.train.selectDateRush({
	 *      date: '2015-10-19',
	 *      days: 60,
	 *      buyRange: [{
	 *          start: '2015-11-11',
	 *          finish: '2015-12-11'
	 *      }],
	 *      reserveRange: [{
	 *          start: '2015-12-12',
	 *          finish: '2015-12-31'
	 *      }]
	 *  })
	 *      .then(function(date) {
	 *          date = '2015-12-13'
	 *      });
	 */
	module.exports = function(opts) {
	    if (false) {
	        debug('opts is %j', opts);
	    }
	
	    var p = new Promise(function(resolve, reject) {
	        opts.callback = function(date) {
	            resolve(date.date);
	        };
	        _invoke('train', 'select_date_rush', opts);
	    });
	    return p;
	};
	


/***/ }),
/* 437 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var debug;
	if (false) {
	    debug = require('debug')('hbnb:module:train:timeRange');
	}
	
	var _invoke = __webpack_require__(360);
	
	/**
	 * 选择出行日期
	 *
	 *
	 * @memberof train
	 * @static
	 * @name timeRange
	 * @param {Number} start 开始时间
	 * @param {Number} end 结束时间
	 * @return {Promise<date>}
	 * @example
	 *  hbnb.train.timeRange(12, 15)
	 *      .then(function(range) {
	 *          range = {
	 *              start: 0,
	 *              end: 24
	 *          }
	 *      });
	 */
	module.exports = function(start, end) {
	    if (false) {
	        debug('start is %s', start);
	        debug('end is %s', end);
	    }
	
	    if (start === undefined) {
	        start = 0;
	        end = 24;
	    }
	
	    var p = new Promise(function(resolve, reject) {
	        _invoke('train', 'time_range', {
	            start: start,
	            end: end,
	            callback: function(range) {
	                resolve(range);
	            }
	        });
	    });
	    return p;
	};


/***/ }),
/* 438 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var debug;
	if (false) {
	    debug = require('debug')('hbnb:module:train:gotoOrderList');
	}
	
	var _invoke = __webpack_require__(360);
	
	/**
	 *
	 * @memberof train
	 * @static
	 * @name gotoOrderList
	 * @param {String} url 订单列表地址
	 * @return {Undefined}
	 * @example
	 *  hbnb.train.gotoOrderList('url');
	 */
	module.exports = function(url) {
	    if (false) {
	        debug('url is %s', url);
	    }
	
	    _invoke('train', 'goto_order_list', {
	        url: url
	    });
	};


/***/ }),
/* 439 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var debug;
	if (false) {
	    debug = require('debug')('hbnb:module:train:multiSelect');
	}
	
	var _invoke = __webpack_require__(360);
	
	/**
	 *
	 * @memberof train
	 * @static
	 * @name multiSelect
	 * @param {Array} menus 菜单
	 * @return {Promise}
	 * @example
	 *  hbnb.train.multiSelect([{
	 *      label: '',
	 *      value: '',
	 *      active: false
	 *  }])
	 *      .then(function(menus) {
	 *          menus = [{
	 *              label: '',
	 *              value: '',
	 *              active: false
	 *          }]
	 *      });
	 */
	module.exports = function(menus) {
	    if (false) {
	        debug('menus is %j', menus);
	    }
	
	    var p = new Promise(function(resolve, reject) {
	        _invoke('train', 'multi_select', {
	            menus: menus,
	            callback: function(menus) {
	                resolve(menus);
	            }
	        });
	    });
	
	    return p;
	};


/***/ }),
/* 440 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var debug;
	if (false) {
	    debug = require('debug')('hbnb:module:train:selectTrains');
	}
	
	var _invoke = __webpack_require__(360);
	
	/**
	 *
	 * @memberof train
	 * @static
	 * @name selectTrains
	 * @param {Array} menus 菜单
	 * @return {Promise}
	 * @example
	 *  hbnb.train.selectTrains([{
	 *      label: '',
	 *      subLabel: '',
	 *      description: ''
	 *      value: '',
	 *      active: false
	 *  }])
	 *      .then(function(menus) {
	 *          menus = [{
	 *              label: '',
	 *              value: '',
	 *              active: false
	 *          }]
	 *      });
	 */
	module.exports = function(menus) {
	    if (false) {
	        debug('menus is %j', menus);
	    }
	
	    var p = new Promise(function(resolve, reject) {
	        _invoke('train', 'select_trains', {
	            menus: menus,
	            callback: function(menus) {
	                resolve(menus);
	            }
	        });
	    });
	
	    return p;
	};


/***/ }),
/* 441 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var debug;
	if (false) {
	    debug = require('debug')('hbnb:module:train:ringtone');
	}
	
	var _invoke = __webpack_require__(360);
	
	/**
	 *
	 * @memberof train
	 * @static
	 * @name ringtone
	 * @param {Number} loop 时长
	 * @return {Promise}
	 * @example
	 *  hbnb.train.ringtone()
	 *      .then(function() {});
	 */
	module.exports = function(duration) {
	    if (false) {
	        debug('duration is %s', duration);
	    }
	
	    var p = new Promise(function(resolve, reject) {
	        _invoke('train', 'ringtone', {
	            duration: duration,
	            callback: function() {
	                resolve();
	            },
	            errback: function() {
	                reject();
	            }
	        });
	    });
	
	    return p;
	};


/***/ }),
/* 442 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var debug;
	if (false) {
	    debug = require('debug')('hbnb:module:train:vibrate');
	}
	
	var _invoke = __webpack_require__(360);
	
	/**
	 *
	 * @memberof train
	 * @static
	 * @name vibrate
	 * @param {Number} duration 震动时长
	 * @return {Promise}
	 * @example
	 *  hbnb.train.vibrate(1000)
	 *      .then(function() {});
	 */
	module.exports = function(duration) {
	    if (false) {
	        debug('duration is %s', duration);
	    }
	
	    var p = new Promise(function(resolve, reject) {
	        _invoke('train', 'vibrate', {
	            duration: duration,
	            callback: function() {
	                resolve();
	            },
	            errback: function() {
	                reject();
	            }
	        });
	    });
	
	    return p;
	};


/***/ }),
/* 443 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * @name inject
	 */
	
	exports.load = __webpack_require__(444);
	exports.loadHTML = __webpack_require__(445);
	exports.close = __webpack_require__(446);
	exports.show = __webpack_require__(447);
	exports.runScript = __webpack_require__(448);
	
	
	exports.addStopUrl = __webpack_require__(449);
	
	exports.callback = __webpack_require__(450);


/***/ }),
/* 444 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var debug;
	if (false) {
	    debug = require('debug')('hbnb:module:inject:load');
	}
	
	var _invoke = __webpack_require__(360);
	
	/**
	 * 打开一个隐藏 webview
	 *
	 * 如果指定的 `name` 还不存在，会创建一个新的 webview。
	 * 如果指定的 `name` 存在，会在该 webview 上加载新的 url。
	 * 在加载页面所有静态资源请求都完成时，Promise resolve。
	 * 但是不保证页面已经可用，业务方可自己进行 domready 等检测。
	 *
	 * 支持版本
	 * + iHotel/5.8+
	 *
	 * @memberof inject
	 * @static
	 * @name load
	 * @param {String} name 隐藏 webview 名
	 * @param {String} url 需要加载的页面地址
	 * @return {Promise}
	 * @example
	 *  hbnb.inject.load(
	 *      'name',
	 *      'https://kyfw.12306.cn/otn/leftTicket/init'
	 *  ).then(function() {
	 *      console.log('loaded');
	 *  });
	 */
	module.exports = function(name, url) {
	    if (false) {
	        debug('name is %s', name);
	        debug('url is %s', url);
	    }
	
	    var p = new Promise(function(resolve, reject) {
	        _invoke('inject', 'load', {
	            name: name,
	            url: url,
	            callback: function() {
	                resolve();
	            }
	        });
	    });
	    return p;
	};


/***/ }),
/* 445 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var debug;
	if (false) {
	    debug = require('debug')('hbnb:module:inject:loadHTML');
	}
	
	var _invoke = __webpack_require__(360);
	
	/**
	 * 打开一个隐藏 webview
	 *
	 * 如果指定的 `name` 还不存在，会创建一个新的 webview。
	 * 在指定的 webview 中加载给定的 `html` 片段
	 * 在加载页面所有静态资源请求都完成时，Promise resolve。
	 * 但是不保证页面已经可用，业务方可自己进行 domready 等检测。
	 *
	 * 支持版本
	 * + iHotel/6.1+
	 *
	 * @memberof inject
	 * @static
	 * @name loadHTML
	 * @param {String} name 隐藏 webview 名
	 * @param {String} url 需要加载的页面地址
	 * @param {String} html 需要加载的 html 片段
	 * @return {Promise}
	 * @example
	 *  hbnb.inject.loadHTML(
	 *      'name',
	 *      'https://kyfw.12306.cn/otn/',
	 *      '<!DOCTYPE html><html><head><meta charset="utf-8" /></head><body></body></html>'
	 *  ).then(function() {
	 *      console.log('loaded');
	 *  });
	 */
	module.exports = function(name, url, html) {
	    if (false) {
	        debug('name is %s', name);
	        debug('url is %s', url);
	        debug('html is %s', html);
	    }
	
	    var p = new Promise(function(resolve, reject) {
	        _invoke('inject', 'load_html', {
	            name: name,
	            baseUrl: url,
	            html: html,
	            callback: function() {
	                resolve();
	            }
	        });
	    });
	    return p;
	};


/***/ }),
/* 446 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var debug;
	if (false) {
	    debug = require('debug')('hbnb:module:inject:close');
	}
	
	var _invoke = __webpack_require__(360);
	
	/**
	 * 关闭隐藏 webview
	 *
	 * 主要为了减小内存占用
	 *
	 * 支持版本
	 * + iHotel/5.8+
	 *
	 * @memberof inject
	 * @static
	 * @name close
	 * @param {String} name 隐藏 webview 名
	 * @return {Promise}
	 * @example
	 *  hbnb.inject.close('name')
	 */
	module.exports = function(name) {
	    if (false) {
	        debug('name is %s', name);
	    }
	
	    var p = new Promise(function(resolve, reject) {
	        _invoke('inject', 'close', {
	            name: name,
	            callback: function() {
	                resolve();
	            }
	        });
	    });
	    return p;
	};


/***/ }),
/* 447 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var debug;
	if (false) {
	    debug = require('debug')('hbnb:module:inject:show');
	}
	
	var _invoke = __webpack_require__(360);
	
	/**
	 * 将隐藏 webview 放到前台
	 *
	 * TODO: 验证下返回值
	 *
	 * 支持版本
	 * + iHotel/5.8+
	 *
	 * @memberof inject
	 * @static
	 * @name show
	 * @param {String} name 隐藏 webview 名
	 * @return {Promise}
	 * @example
	 *  hbnb.inject.show('name');
	 */
	module.exports = function(name) {
	    if (false) {
	        debug('name is %s', name);
	    }
	
	    var p = new Promise(function(resolve, reject) {
	        _invoke('inject', 'show', {
	            name: name
	        });
	    });
	    return p;
	};


/***/ }),
/* 448 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var debug;
	if (false) {
	    debug = require('debug')('hbnb:module:inject:runScript');
	}
	
	var _invoke = __webpack_require__(360);
	
	/**
	 * 向隐藏 webview 注入脚本
	 *
	 * 支持版本
	 * + iHotel/5.8+
	 *
	 * @memberof inject
	 * @static
	 * @name runScript
	 * @param {String} name 隐藏 webview 名
	 * @param {String} script 注入的脚本，必须为可执行函数
	 * @param {String} param script 的参数，即 `hbnb.inject.callback` 的 `funcName`
	 * @return {Promise}
	 * @example
	 *  hbnb.inject.runScript(
	 *      'name',
	 *      'script',
	 *      'param'
	 *  ).then(function() {
	 *      console.log('loaded');
	 *  });
	 */
	module.exports = function(name, script, param) {
	    if (false) {
	        debug('name is %s', name);
	        debug('script is %s', script);
	        debug('param is %s', param);
	    }
	
	    script = script.toString();
	    var p = new Promise(function(resolve, reject) {
	        _invoke('inject', 'run_script', {
	            name: name,
	            script: script,
	            param: param,
	            callback: function() {
	                resolve();
	            }
	        });
	    });
	
	    return p;
	};


/***/ }),
/* 449 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var debug;
	if (false) {
	    debug = require('debug')('hbnb:module:inject:addStopUrl');
	}
	
	var _invoke = __webpack_require__(360);
	
	/**
	 * 匹配隐藏 webview 页面的 url
	 *
	 * 符合时，停止页面加载并执行脚本
	 * 只匹配一次？
	 *
	 * TODO: 支持版本
	 *
	 * 支持版本
	 * + iHotel/5.9?
	 *
	 * @memberof inject
	 * @static
	 * @name addStopUrl
	 * @param {String} name 隐藏 webview 名
	 * @param {String} pattern 用于匹配 url 的正则
	 * @param {String} script 匹配后执行的命令
	 * @return {Promise}
	 * @example
	 *  hbnb.inject.addStopUrl('name', 'pattern', 'script')
	 *      .then(function() {
	 *          console.log('loaded');
	 *      });
	 */
	module.exports = function(name, pattern, script) {
	    if (false) {
	        debug('name is %s', name);
	        debug('pattern is %s', pattern);
	        debug('script is %s', script);
	    }
	
	    var p = new Promise(function(resolve, reject) {
	        _invoke('inject', 'add_stop_url', {
	            name: name,
	            pattern: pattern,
	            script: script,
	            callback: function() {
	                resolve();
	            }
	        });
	    });
	    return p;
	};


/***/ }),
/* 450 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var debug;
	if (false) {
	    debug = require('debug')('hbnb:module:inject:callback');
	}
	
	var _invoke = __webpack_require__(360);
	
	/**
	 * 隐藏 webview 中使用该方法返回数据
	 *
	 * 支持版本
	 * + iHotel/5.8+
	 *
	 * @memberof inject
	 * @static
	 * @name callback
	 * @param {String} fnName 回调函数名
	 * @param {String} data 返回的数据
	 * @return {Undefined}
	 * @example
	 *  hbnb.inject.callback('funcName', 'data')
	 */
	module.exports = function(fnName, data) {
	    if (false) {
	        debug('fnName is %s', fnName);
	        debug('data is %s', data);
	    }
	
	    _invoke('inject', 'callback', {
	        callback: fnName,
	        param: data
	    });
	};


/***/ }),
/* 451 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function Bridge() {}
	
	var pushBack = __webpack_require__(452);
	Bridge.prototype.pushBack = Bridge.pushBack = pushBack;
	Bridge.prototype.setTitle = Bridge.setTitle = function(title, subtitle) {
	    pushBack('bridge:', 'set_webview_title', {
	        title: title,
	        subtitle: subtitle
	    });
	};
	
	module.exports = Bridge;


/***/ }),
/* 452 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var env = __webpack_require__(362);
	var buildURI = __webpack_require__(366);
	
	var messageQueue = [];
	var messageQueueFetch = function() {
	    var response = messageQueue.length ? JSON.stringify(messageQueue) : '';
	    messageQueue = [];
	    if (response) return response;
	};
	window.messageQueueFetch = messageQueueFetch;
	
	var pushBack = function(protocol, name, params) {
	    params = params || {};
	    var uri = protocol + '//' + name + '?params=' + encodeURIComponent(JSON.stringify(params, buildURI.processParams));
	    if (env.platform === 'android') {
	        if (env.supportPrompt) {
	            window.prompt(uri); // eslint-disable-line no-alert
	        } else {
	            try {
	                window['MeituanHotelWebviewBridge']['sendBridgeMessage'](uri);
	            } catch (e) {}
	        }
	    } else if (env.platform === 'ios') {
	        messageQueue.push(uri);
	    } else {
	        // for debug
	        alert(uri); // eslint-disable-line no-alert
	    }
	};
	
	module.exports = pushBack;


/***/ }),
/* 453 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * @name travel
	 */
	
	// 选择城市
	exports.selectCity = __webpack_require__(454);
	
	// 设置客户端大G埋点
	exports.setGdata = __webpack_require__(455);
	
	// 获取pos机id
	exports.getPosDeviceId = __webpack_require__(456);
	
	// 获取pos机打印状态
	exports.printerState = __webpack_require__(457);
	
	// 打印
	exports.print = __webpack_require__(458);

/***/ }),
/* 454 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var debug;
	if (false) {
	    debug = require('debug')('hbnb:module:travel:selectCity');
	}
	
	var _invoke = __webpack_require__(360);
	
	/**
	 * 选择城市
	 *
	 *
	 * 支持版本
	 * + iTrip/6.9+
	 *
	 *
	 * @memberof travel
	 * @static
	 * @name selectCity
	 * @param {String} city
	 * @return {Promise}
	 * @example
	 *  hbnb.travel.selectCity('city')
	 *      .then(function(city) {
	 *          city = {
	 *              cityName: '',
	 *              cityID: ''
	 *          }
	 *      });
	 */
	module.exports = function(city) {
	    if (false) {
	        debug('city is %s', city);
	    }
	    city = city || '';
	
	    var p = new Promise(function(resolve, reject) {
	        _invoke('travel', 'select_city', {
	            original: city,
	            callback: function(city) {
	                resolve(city);
	            }
	        });
	    });
	    return p;
	};


/***/ }),
/* 455 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var debug;
	if (false) {
	    debug = require('debug')('hbnb:module:travel:setGdata');
	}
	
	var _invoke = __webpack_require__(360);
	
	/**
	 * 设置客户端大G埋点
	 *
	 *
	 * 支持版本
	 * + iTrip/6.9+
	 *
	 *
	 * @memberof travel
	 * @static
	 * @name setGdata
	 * @param {String} bigG
	 * @return {Promise}
	 * @example
	 *  hbnb.travel.setGdata('bigG')
	 *      .then(function(bigG) {
	 *          bigG = {
	 *              status: 1          //0: 失败；1:成功
	 *          }
	 *      });
	 */
	module.exports = function(bigG) {
	    if (false) {
	        debug('bigG is %s', bigG);
	    }
	    bigG = bigG || '';
	
	    var p = new Promise(function(resolve, reject) {
	        _invoke('travel', 'set_g_data', {
	            gdata: bigG,
	            callback: function(bigG) {
	                resolve(bigG);
	            }
	        });
	    });
	    return p;
	};


/***/ }),
/* 456 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var debug;
	if (false) {
	    debug = require('debug')('hbnb:module:travelmerchant:get_pos_deviceid');
	}
	
	var _invoke = __webpack_require__(360);
	
	/**
	 * 获取pos 设备id
	 *
	 * @memberof travel
	 * @static
	 * @name getPosDeviceId
	 * @return {Promise}
	 * @example
	 *  hbnb.travel.getPosDeviceId()
	 *      .then(function(resp) {
	 *          resp = {
	 *              deviceid: "xxxxx"//如果返回deviceid为空，则表示不是pos机
	 *          }
	 *      });
	 */
	module.exports = function() {
	    if (false) {
	        debug('getDeviceId  %s');
	    }
	    var p = new Promise(function(resolve, reject) {
	        _invoke('travelmerchant', 'get_pos_deviceid', {
	            callback: function(resp) {
	                resolve(resp);
	            },
	            complete: function (resp) {
	                reject(resp);
	            }
	        });
	    });
	    return p;
	};


/***/ }),
/* 457 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var debug;
	if (false) {
	    debug = require('debug')('hbnb:module:travelmerchant:check_printer_state');
	}
	
	var _invoke = __webpack_require__(360);
	
	/**
	 * 打印状态
	 *
	 * @memberof travel
	 * @static
	 * @name check_printer_state
	 * @return {Promise}
	 * @example
	 *  hbnb.travel.printerState()
	 *      .then(function(resp) {
	 *          resp = {
	 *              status:""//一共五种状态：OK,NO_PAPER（缺纸）,HIGH_TEMP（过热）,ERROR(过热且缺纸),UNKNOW(未知)
	 *          }
	 *      });
	 */
	module.exports = function() {
	    if (false) {
	        //debug('city is %s');
	    }
	
	    var p = new Promise(function(resolve, reject) {
	        _invoke('travelmerchant', 'check_printer_state', {
	            callback: function(resp) {
	                resolve(resp);
	            },
	            complete: function (resp) {
	                reject(resp);
	            }
	        });
	    });
	    return p;
	};


/***/ }),
/* 458 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var debug;
	if (false) {
	    debug = require('debug')('hbnb:module:travelmerchant:print');
	}
	
	var _invoke = __webpack_require__(360);
	
	/**
	 * 获取pos 设备id
	 *
	 * @memberof travel
	 * @static
	 * @name print
	 * @param {Array} content
	 * @return {Promise}
	 * @example
	 *  hbnb.travel.print([
	 *    {
	        "content":"xxx",
	        "gravity":"left", //对齐 left/right/center
	        "textsize":"small" //字体大小  small/medium/large
	      }
	 *  ])
	 *      .then(function(resp) {
	 *          resp = {
	 *              status: 0,
	 *              message: '成功'
	 *          }
	 *      });
	 */
	module.exports = function(content) {
	    if (false) {
	        debug('content is %s', content);
	    }
	    content = content || [];
	    var p = new Promise(function(resolve, reject) {
	        _invoke('travelmerchant', 'print', {
	            content: content,
	            callback: function(resp) {
	                resolve(resp);
	            },
	            complete: function (resp) {
	                reject(resp);
	            }
	        });
	    });
	    return p;
	};


/***/ }),
/* 459 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * @name env
	 */
	
	exports.getPageEnv = __webpack_require__(460);


/***/ }),
/* 460 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var debug;
	if (false) {
	    debug = require('debug')('hbnb:module:env:getPageEnv');
	}
	
	var _invoke = __webpack_require__(360);
	
	/**
	 * 获取当前页面变量
	 *
	 * 支持版本
	 * + iHotel/6.3
	 *
	 * @memberof env
	 * @static
	 * @name getPageEnv
	 * @return {Promise<version>}
	 * @example
	 *  hbnb.env.getPageEnv()
	 *      .then(function(env) {
	 *      });
	 */
	
	module.exports = function() {
	    if (false) {
	        debug('called');
	    }
	
	    var p = new Promise(function(resolve, reject) {
	        _invoke('env', 'get_page_env', {
	            callback: function(env) {
	                resolve(env);
	            },
	            errback: function(err) {
	                reject(err);
	            }
	        });
	    });
	    return p;
	};


/***/ }),
/* 461 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * @name share
	 */
	
	// 激活导航栏分享按钮
	exports.activeNavButton = __webpack_require__(462);
	
	// 禁用导航栏分享按钮
	exports.disableNavButton = __webpack_require__(463);
	
	// 调用本地分享
	exports.callLocal = __webpack_require__(464);
	
	
	
	


/***/ }),
/* 462 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var debug;
	if (false) {
	    debug = require('debug')('hbnb:module:share:activeNavButton');
	}
	
	var _invoke = __webpack_require__(360);
	
	/**
	 * share.activeNavButton 激活导航栏分享按钮
	 *
	 * 支持版本
	 * + iHotel/7.0+
	  * 此版本不支持successCallback,failCallback 客户端说排期比较紧张，7.1版本实现, ios失败没有回调通知
	 * @memberof share
	 * @static
	 * @name activeNavButton
	 * @param {Array} channel 渠道
	 * @param {Object} conf 配置信息
	 * @return {Undefined}
	 * @example
	 *  hbnb.share.activeNavButton(['weixin','weibo','sinaWeibo'], {
	        content: '分享内容',
	        detailURL: 'http://i.meituan.com/',
	        imageURL: 'http://p1.meituan.net/codeman/799087624091d1d43768b7da396d4a122532.png',
	        title: '分享标题'
	    });
	 */
	
	module.exports = function(channelParam, configParam, successCallback, failCallback) {
	    if (false) {
	        debug('param channelParam is %j', channelParam);
	        debug('param configParam is %j', configParam);
	    }
	    var p = new Promise(function(resolve, reject) {
	        var data = {
	            'sinaweibo': 1,
	            'qzone': 2,
	            'qqweibo': 4,
	            'renren': 8,
	            'kaixin': 16,
	            'sms': 32,
	            'email': 64,
	            'weixin': 128,
	            'weixinfriends': 256,
	            'qqclient': 512,
	            'all':-1
	        };
	        var params = {};
	        var channel = channelParam || [];
	        var config = configParam || {};
	        var channelNumber = 0;
	        var i;
	        var num;
	        var d;
	        if(channel && Object.prototype.toString.call(channel) == "[object Array]"){
	            for (var i = 0, len = channel.length; i < len; i++){
	                d = channel[i];
	                num = data[d.toLowerCase()];
	                channelNumber += num;
	                if(config['content_' + d]){
	                    params['content_' + num] = config['content_' + d];
	                }
	            }
	            if (config.cid) {
	                params.cid = config.cid;
	            }
	            params.channel = channelNumber;
	            params.content =  config.content;
	            params.detailURL = config.detailURL;
	            params.imageURL =  config.imageURL;
	            params.title = config.title;
	            params.callback = function (returnData) {
	                if (returnData && returnData.status === 'COMPLETE') {
	                    if (typeof successCallback === 'function') {
	                        successCallback(returnData)
	                    }
	                } else {
	                    if (typeof failCallback === 'function') {
	                        failCallback(returnData)
	                    }
	                }
	                resolve(returnData);
	                return false;
	            };
	            _invoke('share', 'enable_nav_share_button', params);
	        }
	
	    });
	    return p;
	};


/***/ }),
/* 463 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var debug;
	if (false) {
	    debug = require('debug')('hbnb:module:share:disableNavButton');
	}
	
	var _invoke = __webpack_require__(360);
	
	/**
	 * share.disableNavButton 禁用导航栏分享按钮
	 *
	 * 支持版本
	 * + iHotel/7.0+
	 *
	 * @memberof share
	 * @static
	 * @name disableNavButton
	 * @return {Undefined}
	 * @example
	 *  hbnb.share.disableNavButton();
	 */
	
	module.exports = function() {
		if (false) {
	        debug('called');
	    }
	    var p = new Promise(function(resolve, reject) {
	    	_invoke('share', 'disable_nav_share_button', {});
	    });
	    return p;
	};


/***/ }),
/* 464 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var debug;
	if (false) {
	    debug = require('debug')('hbnb:module:share:callLocal');
	}
	
	var _invoke = __webpack_require__(360);
	
	/**
	 * share.callLocal 激活导航栏分享按钮
	 *
	 * 支持版本
	 * + iHotel/7.0+
	  * 此版本不支持successCallback,failCallback 客户端说排期比较紧张，7.1版本实现
	 * @memberof share
	 * @static
	 * @name callLocal
	 * @param {Array} channel 渠道
	 * @param {Object} conf 配置信息
	 * @return {Undefined}
	 * @example
	 *  hbnb.share.callLocal(['weixin','weibo','sinaWeibo'], {
	        content: '分享内容',
	        detailURL: 'http://i.meituan.com/',
	        imageURL: 'http://p1.meituan.net/codeman/799087624091d1d43768b7da396d4a122532.png',
	        title: '分享标题'
	    });
	 */
	
	module.exports = function(channelParam, configParam, successCallback, failCallback) {
	    if (false) {
	        debug('param channelParam is %j', channelParam);
	        debug('param configParam is %j', configParam);
	    }
	    var p = new Promise(function(resolve, reject) {
	        var data = {
	            'sinaweibo': 1,
	            'qzone': 2,
	            'qqweibo': 4,
	            'renren': 8,
	            'kaixin': 16,
	            'sms': 32,
	            'email': 64,
	            'weixin': 128,
	            'weixinfriends': 256,
	            'qqclient': 512,
	            'all':-1
	        };
	        var params = {};
	        var channel = channelParam || [];
	        var config = configParam || {};
	        var channelNumber = 0;
	        var i;
	        var num;
	        var d;
	
	        if(channel && Object.prototype.toString.call(channel) == "[object Array]"){
	            for (var i = 0, len = channel.length; i < len; i++){
	                d = channel[i];
	                num = data[d.toLowerCase()];
	                channelNumber += num;
	                if(config['content_' + d]){
	                    params['content_' + num] = config['content_' + d];
	                }
	            }
	            if (config.cid) {
	                params.cid = config.cid;
	            }
	            params.channel = channelNumber;
	            params.content =  config.content;
	            params.detailURL = config.detailURL;
	            params.imageURL =  config.imageURL;
	            params.title = config.title;
	            params.callback = function (returnData) {
	                if (returnData && returnData.status === 'COMPLETE') {
	                    if (typeof successCallback === 'function') {
	                        successCallback(returnData)
	                    }
	                } else {
	                    if (typeof failCallback === 'function') {
	                        failCallback(returnData)
	                    }
	                }
	                resolve(returnData);
	                return false;
	            };
	            _invoke('share', 'common_share', params);
	        }
	    });
	    return p;
	};


/***/ }),
/* 465 */
/***/ (function(module, exports) {

	module.exports = {
	  "core.HBNBVersion": {
	    "params": [],
	    "memberof": "core",
	    "name": "HBNBVersion",
	    "return": "Promise"
	  },
	  "core.OS": {
	    "params": [],
	    "memberof": "core",
	    "name": "OS",
	    "return": "Promise"
	  },
	  "core.supportApis": {
	    "params": [],
	    "memberof": "core",
	    "name": "supportApis",
	    "return": "Promise"
	  },
	  "account.getUser": {
	    "params": [],
	    "memberof": "account",
	    "name": "getUser",
	    "return": "Promise"
	  },
	  "account.login": {
	    "params": [],
	    "memberof": "account",
	    "name": "login",
	    "return": "Promise"
	  },
	  "account.mobileLogin": {
	    "params": [
	      "mobile",
	      "code"
	    ],
	    "memberof": "account",
	    "name": "mobileLogin",
	    "return": "Promise"
	  },
	  "account.sendMobileLoginCode": {
	    "params": [
	      "mobile"
	    ],
	    "memberof": "account",
	    "name": "sendMobileLoginCode",
	    "return": "Promise"
	  },
	  "log.mge": {
	    "params": [
	      "cid",
	      "act",
	      "val",
	      "lab"
	    ],
	    "memberof": "log",
	    "name": "mge",
	    "return": "Undefined"
	  },
	  "network.request": {
	    "params": [
	      "opts"
	    ],
	    "memberof": "network",
	    "name": "request",
	    "return": "Promise"
	  },
	  "network.sendSms": {
	    "params": [],
	    "memberof": "network",
	    "name": "sendSms"
	  },
	  "pay.getFingerprint": {
	    "params": [],
	    "memberof": "pay",
	    "name": "getFingerprint",
	    "return": "Promise"
	  },
	  "pay.payment": {
	    "params": [
	      "opts"
	    ],
	    "memberof": "pay",
	    "name": "payment",
	    "return": "Promise"
	  },
	  "position.getCity": {
	    "params": [],
	    "memberof": "position",
	    "name": "getCity",
	    "return": "Promise"
	  },
	  "storage.getItem": {
	    "params": [],
	    "memberof": "storage",
	    "name": "getItem",
	    "return": "Promise"
	  },
	  "storage.removeItem": {
	    "params": [],
	    "memberof": "storage",
	    "name": "removeItem",
	    "return": "Undefined"
	  },
	  "storage.setItem": {
	    "params": [],
	    "memberof": "storage",
	    "name": "setItem",
	    "return": "Undefined"
	  },
	  "storage.setResult": {
	    "params": [
	      "obj"
	    ],
	    "memberof": "storage",
	    "name": "setResult",
	    "return": "Undefined"
	  },
	  "thirdApps.installed": {
	    "params": [
	      "appName"
	    ],
	    "memberof": "thirdApps",
	    "name": "installed",
	    "return": "Promise"
	  },
	  "ui.alert": {
	    "params": [
	      "message",
	      "title",
	      "button"
	    ],
	    "memberof": "ui",
	    "name": "alert",
	    "return": "Undefined"
	  },
	  "ui.autoLock": {
	    "params": [
	      "enable"
	    ],
	    "memberof": "ui",
	    "name": "autoLock",
	    "return": "Undefined"
	  },
	  "ui.confirm": {
	    "params": [
	      "message",
	      "title",
	      "leftButton",
	      "rightButton"
	    ],
	    "memberof": "ui",
	    "name": "confirm",
	    "return": "Undefined"
	  },
	  "ui.loadingStart": {
	    "params": [],
	    "memberof": "ui",
	    "name": "loadingStart",
	    "return": "Undefined"
	  },
	  "ui.loadingStop": {
	    "params": [],
	    "memberof": "ui",
	    "name": "loadingStop",
	    "return": "Undefined"
	  },
	  "ui.options": {
	    "params": [
	      "menus",
	      "cancel"
	    ],
	    "memberof": "ui",
	    "name": "options",
	    "return": "Undefined"
	  },
	  "ui.selectDate": {
	    "params": [
	      "current",
	      "maxDate",
	      "minDate"
	    ],
	    "memberof": "ui",
	    "name": "selectDate",
	    "return": "Promise"
	  },
	  "ui.singleSelect": {
	    "params": [
	      "menus"
	    ],
	    "memberof": "ui",
	    "name": "singleSelect",
	    "return": "Undefined"
	  },
	  "ui.toast": {
	    "params": [
	      "message",
	      "time"
	    ],
	    "memberof": "ui",
	    "name": "toast",
	    "return": "Undefined"
	  },
	  "webview.back": {
	    "params": [],
	    "memberof": "webview",
	    "name": "back",
	    "return": "Undefined"
	  },
	  "webview.closeAll": {
	    "params": [
	      "urls"
	    ],
	    "memberof": "webview",
	    "name": "closeAll",
	    "return": "Undefined"
	  },
	  "webview.close": {
	    "params": [],
	    "memberof": "webview",
	    "name": "close",
	    "return": "Undefined"
	  },
	  "webview.dismiss": {
	    "params": [],
	    "memberof": "webview",
	    "name": "dismiss"
	  },
	  "webview.modal": {
	    "params": [
	      "url"
	    ],
	    "memberof": "webview",
	    "name": "modal",
	    "return": "Undefined"
	  },
	  "webview.open": {
	    "params": [
	      "url"
	    ],
	    "memberof": "webview",
	    "name": "open",
	    "return": "Undefined"
	  },
	  "webview.setBackAction": {
	    "params": [
	      "cb"
	    ],
	    "memberof": "webview",
	    "name": "setBackAction",
	    "return": "Undefined"
	  },
	  "webview.setComplexTitle": {
	    "params": [
	      "opts"
	    ],
	    "memberof": "webview",
	    "name": "setComplexTitle",
	    "return": "Undefined"
	  },
	  "webview.setMenus": {
	    "params": [
	      "menus"
	    ],
	    "memberof": "webview",
	    "name": "setMenus",
	    "return": "Undefined"
	  },
	  "webview.setTitle": {
	    "params": [
	      "title"
	    ],
	    "memberof": "webview",
	    "name": "setTitle",
	    "return": "Undefined"
	  },
	  "tower.sendTopicCommentSuccess": {
	    "params": [],
	    "memberof": "tower",
	    "name": "sendTopicCommentSuccess",
	    "return": "Promise"
	  },
	  "tower.comment": {
	    "params": [
	      "opts"
	    ],
	    "memberof": "tower",
	    "name": "comment",
	    "return": "Promise"
	  },
	  "tower.getUuid": {
	    "params": [],
	    "memberof": "tower",
	    "name": "getUuid",
	    "return": "Promise"
	  },
	  "tower.shareConfig": {
	    "params": [
	      "name",
	      "opts"
	    ],
	    "memberof": "tower",
	    "name": "shareConfig",
	    "return": "Promise"
	  },
	  "tower.checkNickname": {
	    "params": [],
	    "memberof": "tower",
	    "name": "checkNickname",
	    "return": "Promise"
	  },
	  "flight.alipay": {
	    "params": [
	      "orderId",
	      "payURL",
	      "returnURL"
	    ],
	    "memberof": "flight",
	    "name": "alipay",
	    "return": "Promise"
	  },
	  "flight.getExpress": {
	    "params": [
	      "siteId",
	      "id"
	    ],
	    "memberof": "flight",
	    "name": "getExpress",
	    "return": "Promise"
	  },
	  "flight.getFilter": {
	    "params": [
	      "opts"
	    ],
	    "memberof": "flight",
	    "name": "getFilter",
	    "return": "Promise"
	  },
	  "flight.getLinkman": {
	    "params": [
	      "id"
	    ],
	    "memberof": "flight",
	    "name": "getLinkman",
	    "return": "Promise"
	  },
	  "flight.getUser": {
	    "params": [],
	    "memberof": "flight",
	    "name": "getUser",
	    "return": "Promise"
	  },
	  "flight.gotoAppHomepage": {
	    "params": [],
	    "memberof": "flight",
	    "name": "gotoAppHomepage",
	    "return": "Undefined"
	  },
	  "flight.gotoOrderDetail": {
	    "params": [
	      "url",
	      "orderListUrl"
	    ],
	    "memberof": "flight",
	    "name": "gotoOrderDetail",
	    "return": "Undefined"
	  },
	  "flight.login": {
	    "params": [],
	    "memberof": "flight",
	    "name": "login",
	    "return": "Promise"
	  },
	  "flight.selectCity": {
	    "params": [
	      "city"
	    ],
	    "memberof": "flight",
	    "name": "selectCity",
	    "return": "Promise"
	  },
	  "flight.selectDate": {
	    "params": [
	      "fromCity",
	      "toCity",
	      "months",
	      "original"
	    ],
	    "memberof": "flight",
	    "name": "selectDate",
	    "return": "Promise"
	  },
	  "flight.selectRoundDate": {
	    "params": [],
	    "memberof": "flight",
	    "name": "selectRoundDate",
	    "return": "Promise"
	  },
	  "train.gotoOrderDetail": {
	    "params": [
	      "url",
	      "orderListUrl"
	    ],
	    "memberof": "train",
	    "name": "gotoOrderDetail",
	    "return": "Undefined"
	  },
	  "train.gotoOrderList": {
	    "params": [
	      "url"
	    ],
	    "memberof": "train",
	    "name": "gotoOrderList",
	    "return": "Undefined"
	  },
	  "train.multiSelect": {
	    "params": [
	      "menus"
	    ],
	    "memberof": "train",
	    "name": "multiSelect",
	    "return": "Promise"
	  },
	  "train.ringtone": {
	    "params": [
	      "loop"
	    ],
	    "memberof": "train",
	    "name": "ringtone",
	    "return": "Promise"
	  },
	  "train.selectDateRush": {
	    "params": [
	      "opts"
	    ],
	    "memberof": "train",
	    "name": "selectDateRush",
	    "return": "Promise"
	  },
	  "train.selectDateStudent": {
	    "params": [
	      "opts"
	    ],
	    "memberof": "train",
	    "name": "selectDateStudent",
	    "return": "Promise"
	  },
	  "train.selectDate": {
	    "params": [
	      "date",
	      "days",
	      "tips"
	    ],
	    "memberof": "train",
	    "name": "selectDate",
	    "return": "Promise"
	  },
	  "train.selectStation": {
	    "params": [
	      "stationCode",
	      "stationType"
	    ],
	    "memberof": "train",
	    "name": "selectStation",
	    "return": "Promise"
	  },
	  "train.selectTrains": {
	    "params": [
	      "menus"
	    ],
	    "memberof": "train",
	    "name": "selectTrains",
	    "return": "Promise"
	  },
	  "train.timeRange": {
	    "params": [
	      "start",
	      "end"
	    ],
	    "memberof": "train",
	    "name": "timeRange",
	    "return": "Promise"
	  },
	  "train.timeTable": {
	    "params": [
	      "stations"
	    ],
	    "memberof": "train",
	    "name": "timeTable",
	    "return": "Undefined"
	  },
	  "train.vibrate": {
	    "params": [
	      "duration"
	    ],
	    "memberof": "train",
	    "name": "vibrate",
	    "return": "Promise"
	  },
	  "inject.addStopUrl": {
	    "params": [
	      "name",
	      "pattern",
	      "script"
	    ],
	    "memberof": "inject",
	    "name": "addStopUrl",
	    "return": "Promise"
	  },
	  "inject.callback": {
	    "params": [
	      "fnName",
	      "data"
	    ],
	    "memberof": "inject",
	    "name": "callback",
	    "return": "Undefined"
	  },
	  "inject.close": {
	    "params": [
	      "name"
	    ],
	    "memberof": "inject",
	    "name": "close",
	    "return": "Promise"
	  },
	  "inject.loadHTML": {
	    "params": [
	      "name",
	      "url",
	      "html"
	    ],
	    "memberof": "inject",
	    "name": "loadHTML",
	    "return": "Promise"
	  },
	  "inject.load": {
	    "params": [
	      "name",
	      "url"
	    ],
	    "memberof": "inject",
	    "name": "load",
	    "return": "Promise"
	  },
	  "inject.runScript": {
	    "params": [
	      "name",
	      "script",
	      "param"
	    ],
	    "memberof": "inject",
	    "name": "runScript",
	    "return": "Promise"
	  },
	  "inject.show": {
	    "params": [
	      "name"
	    ],
	    "memberof": "inject",
	    "name": "show",
	    "return": "Promise"
	  },
	  "travel.getPosDeviceId": {
	    "params": [],
	    "memberof": "travel",
	    "name": "getPosDeviceId",
	    "return": "Promise"
	  },
	  "travel.print": {
	    "params": [
	      "content"
	    ],
	    "memberof": "travel",
	    "name": "print",
	    "return": "Promise"
	  },
	  "travel.check_printer_state": {
	    "params": [],
	    "memberof": "travel",
	    "name": "check_printer_state",
	    "return": "Promise"
	  },
	  "travel.selectCity": {
	    "params": [
	      "city"
	    ],
	    "memberof": "travel",
	    "name": "selectCity",
	    "return": "Promise"
	  },
	  "travel.setGdata": {
	    "params": [
	      "bigG"
	    ],
	    "memberof": "travel",
	    "name": "setGdata",
	    "return": "Promise"
	  },
	  "env.getPageEnv": {
	    "params": [],
	    "memberof": "env",
	    "name": "getPageEnv",
	    "return": "Promise"
	  },
	  "share.activeNavButton": {
	    "params": [
	      "channel",
	      "conf"
	    ],
	    "memberof": "share",
	    "name": "activeNavButton",
	    "return": "Undefined"
	  },
	  "share.callLocal": {
	    "params": [
	      "channel",
	      "conf"
	    ],
	    "memberof": "share",
	    "name": "callLocal",
	    "return": "Undefined"
	  },
	  "share.disableNavButton": {
	    "params": [],
	    "memberof": "share",
	    "name": "disableNavButton",
	    "return": "Undefined"
	  }
	};

/***/ }),
/* 466 */
/***/ (function(module, exports, __webpack_require__) {

	var Titans = __webpack_require__(344);
	
	var getUA = __webpack_require__(287).internal;
	
	if ('dianping' === getUA().appName){
	  Titans.loadAPIs({
	    type: 'dp',
	    apis: __webpack_require__(467)
	  })
	}
	
	// promisify
	(function(){
	  var promisify = __webpack_require__(291);
	  promisify(Titans);
	})();
	
	(function(){
	  var logStat = __webpack_require__(342)
	  var version = __webpack_require__(286)
	  // 统计Titans调用次数
	  logStat("titans", version);
	})();
	
	module.exports = Titans;


/***/ }),
/* 467 */
/***/ (function(module, exports, __webpack_require__) {

	var _920 = __webpack_require__(468);
	
	module.exports = [].concat(_920);

/***/ }),
/* 468 */
/***/ (function(module, exports, __webpack_require__) {

	var mixin = __webpack_require__(285);
	var util = __webpack_require__(356);
	var getUA = __webpack_require__(287).internal;
	
	var ua = getUA();
	
	function noop() {}
	
	var batchAPI = [
	    'setLLButton',
	    'setLRButton',
	    'setRLButton',
	    'setRRButton'
	];
	
	function _convertIcon(icon) {
	    var mapList = {
	        'H5_Favorite_On': 'ic_action_favorite_on_normal',
	        'H5_Favorite_Off': 'ic_action_favorite_off_normal'
	    };
	
	    if (/android/i.test(ua.osName)) {
	        return mapList[icon] || icon;
	    }
	    return icon;
	}
	
	
	var mappedAPI = batchAPI.map(function (api) {
	  return {
	    message: api,
	    version: '9.2.0',
	    mapper: function(opts){
	      if (opts && opts.icon){
	        opts.icon = _convertIcon(opts.icon);
	      }
	
	      return opts;
	    }
	  }
	});
	
	module.exports = [
	  {
	    version: '9.2.0',
	    message: 'login',
	    mapper: function (opts) {
	      var self = this;
	      var success = opts.success || noop
	      return mixin({}, opts, {
	        success: function () {
	          self.getUserInfo({
	            success: function (ret) {
	              success(mixin({}, ret, {
	                type: 'dp',
	                token: ret.token || ret.userToken,
	                uuid: ret.uuid
	              }));
	            }
	          })
	        }
	      });
	    }
	  },
	  {
	    version: '9.2.0',
	    message: 'share',
	    statics: {
	      WECHAT_FRIENDS: 0,
	      WECHAT_TIMELINE: 1,
	      QQ: 2,
	      SMS: 3,
	      WEIBO: 4,
	      QZONE: 5,
	      EMAIL: 6,
	      COPY: 7
	    },
	    mapper: function (opts) {
	      opts = mixin({}, opts);
	      opts.feed = opts.channel;
	      if (!(opts.feed instanceof Array)) {
	        opts.feed = [opts.feed];
	      }
	      if (opts.feed && opts.feed.length === 1) {
	        opts.shareType = opts.feed[0];
	      }
	
	      if (opts.miniProgram && (/android/i.test(ua.osName))) {
	        var miniProgram = opts.miniProgram;
	        delete opts.miniProgram;
	        return mixin(opts, {
	          feed: util.parseFeed(opts.feed),
	          url: util.tidyUrlParams(opts.url),
	          miniProgramId: miniProgram.id,
	          miniProgramPath: miniProgram.path,
	          miniProgramImage: miniProgram.image
	        })
	      } else {
	        return mixin(opts, {
	          feed: util.parseFeed(opts.feed),
	          url: util.tidyUrlParams(opts.url)
	        });
	      }
	    }
	  },
	  {
	    version: '9.2.0',
	    message: 'thirdLogin',
	    handler: function(opts){
	      var type = opts.type;
	      var url;
	      switch (type){
	        case 1:
	          url = location.protocol + '//m.dianping.com/auth/app?ft=15&sso=true';
	          break;
	        case 2:
	          url = location.protocol + '//m.dianping.com/auth/app?ft=6&sso=true&redir=';
	          break;
	        case 3:
	          url = location.protocol + '//m.dianping.com/auth/app?ft=5&ssp=true&redir=';
	          break;
	        case 4:
	          url = location.protocol + '//m.dianping.com/auth/app?ft=2&source=1&sso=true&redir=';
	          break;
	      }
	      this.openWebview({
	        url: 'dianping://loginweb?url=' + encodeURIComponent(url) + '&isFromNative=true',
	      });
	    }
	  },
	  {
	    version: '9.2.0',
	    message: 'setSpotlight',
	    mapper: function(opts){
	      if (!opts.webpageURL) {
	        return;
	      }
	      if (!opts.scheme) {
	        opts.scheme = 'dianping://web?url=' + encodeURIComponent(opts.webpageURL);
	      } 
	      return opts;
	    }
	  },
	  {
	    version: '9.2.0',
	    message: 'publish',
	    mapper: function(opts){
	      var bizname = this.getBizName();
	      var CONSTS = ['phoneChanged', 'AccountBindChange'];
	      if (/2Native/i.test(opts.type) || ~CONSTS.indexOf(opts.action)) {
	        delete opts.type;
	        return opts;
	      } else if (bizname) {
	        opts.action = bizname + ':' + opts.action;
	        delete opts.type;
	        return opts;
	      }else if(!bizname){
	        opts.fail && opts.fail('bizname not config, please call KNB.confg({bizName: YOUR_BIZ_NAME})')
	      }
	    }
	  }
	].concat(mappedAPI);


/***/ }),
/* 469 */
/***/ (function(module, exports, __webpack_require__) {

	var loader = !window._KNB_WX_LOADER ? __webpack_require__(470) : {use: function (cb) { return cb(window.wx); }};
	var miniProgramApis = __webpack_require__(471);
	var mixin = __webpack_require__(285)
	var noop = function () {}
	var win = typeof window !== 'undefined' ? window : {}
	var Promise = win.Promise || __webpack_require__(292)
	var wx = function () {
	  return window.wx || ( function (ref) {
	    var fail = ref.fail; if ( fail === void 0 ) fail = noop;
	
	    return fail({error: -1, msg: 'wx sdk is not loaded'});
	  } )
	}
	
	var isMiniProgramH5 = win.__wxjs_environment === 'miniprogram';
	var qparams = __webpack_require__(355);
	
	/**
	 * 微信官方文档
	 * https://mp.weixin.qq.com/wiki
	 * **/
	
	/** constants **/
	var WECHAT_FRIENDS = 'WCF'
	var WECHAT_TIMELINE = 'WCT'
	var QQ = 'QQ'
	var QZONE = 'QZONE'
	/** constants **/
	
	function uploadImages (localIds) {
	  var ids = localIds.concat()
	  var photos = []
	  return new Promise(function (resolve, reject) {
	    function uploadSingleImage () {
	      var localId = ids.shift()
	      if (!localId) resolve(photos)
	      wx().uploadImage({
	        localId: localId,
	        success: function (photo) {
	          photos.push(photo)
	          uploadSingleImage()
	        },
	        fail: reject
	      })
	    }
	    uploadSingleImage()
	  })
	}
	
	var KNB = {
	  use: function (name, options) {
	    if (KNB[name] && !KNB[name].NOTIMPLEMENTED) return KNB[name](options)
	    if (wx()[name]) wx()[name](options)
	  },
	
	  getUA: __webpack_require__(287),
	
	  isApiSupported: function (ref) {
	    var apiName = ref.apiName;
	    var success = ref.success; if ( success === void 0 ) success = noop;
	
	    return success(!!(KNB[apiName] && !KNB[apiName].NOTIMPLEMENTED))
	  },
	  previewImage: function (config) { return wx().previewImage(config); },
	  // 建议只用count
	  chooseImage: function (ref) {
	    var count = ref.count;
	    var success = ref.success; if ( success === void 0 ) success = noop;
	    var fail = ref.fail; if ( fail === void 0 ) fail = noop;
	
	    wx().chooseImage({
	      count: count,
	      success: function (res) {
	        success({
	          photoInfos: res.localIds.map(function (id) { return ({localId: id}); })
	        })
	      },
	    fail: fail})
	  },
	  uploadImage: function (config) {
	    var localIds = config.localIds; if ( localIds === void 0 ) localIds = [];
	    var success = config.success; if ( success === void 0 ) success = noop;
	    var fail = config.fail; if ( fail === void 0 ) fail = noop;
	
	    uploadImages(localIds)
	      .then(function (photos) {
	        success({
	          photoInfos: photos.map(function (photo) { return mixin(photo, {picUrl: photo.serverId, picKey: photo.serverId}); }
	          )
	        })
	      })
	      .catch(fail)
	  },
	  downloadImage: function (config) { return wx().downloadImage(config); },
	  scanQRCode: function (config) {
	    var success = config.success; if ( success === void 0 ) success = noop;
	    var fail = config.fail; if ( fail === void 0 ) fail = noop;
	    delete config.success;
	    delete config.fail;
	    wx().scanQRCode(mixin(config, {
	      success: function (res) {
	        success({ scanResult: res.resultStr });
	      },
	      fail: function (res) { return fail(res); }
	    }))
	  },
	
	  getNetworkType: function (config) { return wx().getNetworkType(config); },
	  closeWindow: function (config) { return wx().closeWindow(config); },
	
	  // constants
	  share: {
	    WECHAT_FRIENDS: WECHAT_FRIENDS,
	    WECHAT_TIMELINE: WECHAT_TIMELINE,
	    QQ: QQ,
	  QZONE: QZONE},
	
	  // share
	  // mapping from
	  // [knb api]
	  //   title:"分享标题",
	  //   desc:"分享描述",
	  //   image:"http://www.dpfile.com/toevent/img/16d05c85a71b135edc39d197273746d6.png",
	  //   url:"http://m.dianping.com",
	  //   channel: [KNB.share.WECHAT_FRIENDS,KNB.share.WECHAT_TIMELINE],
	  // to
	  // [wx api]
	  //   title: '', // 分享标题
	  //   desc: '', //分享描述
	  //   link: '', // 分享链接
	  //   imgUrl: '', // 分享图标
	  configShare: function (ref) {
	    var title = ref.title;
	    var desc = ref.desc; if ( desc === void 0 ) desc = '';
	    var image = ref.image; if ( image === void 0 ) image = '';
	    var url = ref.url; if ( url === void 0 ) url = '';
	    var content = ref.content; if ( content === void 0 ) content = '【' + title +  '】' +desc;
	    var channel = ref.channel; if ( channel === void 0 ) channel = [WECHAT_FRIENDS, WECHAT_TIMELINE, QQ, QZONE];
	    var success = ref.success; if ( success === void 0 ) success = noop;
	    var fail = ref.fail; if ( fail === void 0 ) fail = noop;
	
	    channel
	      .map(function (c) {
	        switch (c) {
	          case KNB.share.WECHAT_FRIENDS:
	            return function (x) { return wx().onMenuShareAppMessage(x); }
	          case KNB.share.QQ:
	            return function (x) { return wx().onMenuShareQQ(x); }
	          case KNB.share.QZONE:
	            return function (x) { return wx().onMenuShareQZone(x); }
	          case KNB.share.WECHAT_TIMELINE:
	            return function (x) { return wx().onMenuShareTimeline(mixin(x, {title: content})); } 
	        }
	      })
	      .filter(Boolean)
	      .forEach(function (configure) {
	        configure({
	          title: title,
	          desc: desc,
	          link: url,
	          imgUrl: image,
	          success: success,
	        fail: fail})
	      })
	  },
	
	  getLocation: function (ref) {
	    var fail = ref.fail; if ( fail === void 0 ) fail = noop;
	    var success = ref.success; if ( success === void 0 ) success = noop;
	
	    wx().getLocation({
	      fail: fail,
	      success: function (res) {
	        success({
	          lat: res.latitude,
	          lng: res.longitude
	        })
	      }
	    })
	  }
	}
	
	// 所有API调用，自动放入ready里。
	// 如果用户没有主动调KNB.ready，这里会自动调起鉴权。
	var apis = __webpack_require__(284)
	apis
	  .concat('use')
	  .forEach(function (name) {
	    if (name === 'config') return
	    var isImplemented = KNB[name]
	    var notImplementedMethod = function (ref) {
	      var fail = ref.fail; if ( fail === void 0 ) fail = noop;
	
	      return fail({error: -2, msg: ("API [" + name + "] is not implemented")});
	    };
	    var method = KNB[name] || notImplementedMethod; 
	    if (typeof method !== 'function') return
	    KNB[name] = function (a, b, c) {
	      KNB.ready(function () { return method(a, b, c); });
	    }
	
	    if (isMiniProgramH5 && miniProgramApis.indexOf(name) === -1) {
	      KNB[name] = notImplementedMethod;
	      isImplemented = false;
	    }
	
	    if (!isImplemented) KNB[name].NOTIMPLEMENTED = true
	    KNB[name].getSourceCode = function () { return method.toString(); } // for debug reason
	  })
	
	if (isMiniProgramH5) {
	  KNB.getUserInfo = function (ref) {
	    var success = ref.success;
	    var fail = ref.fail; if ( fail === void 0 ) fail = noop;
	
	    var qs = qparams(location.href);
	    if (!qs.token) {
	      return fail({
	        errorCode: -500, 
	        errorMessage: 'get userinfo failed!'
	      });
	    }
	
	    success({
	      type: 'wx-miniprogram',
	      uuid: qs.uuid,
	      token: qs.token,
	      userId: qs.userid,
	    });
	  } ;
	  //KNB > 1.5.9
	  KNB.openWebview = function (ref) {
	    var url = ref.url;
	    var fail = ref.fail; if ( fail === void 0 ) fail = noop;
	
	    if (/^knbwxmini:\/\//i.test(url)){
	      var navigatePath = decodeURIComponent(qparams(url).path);
	      if(!navigatePath) {
	        return fail({
	          errorCode: -400,
	          errorMessage: 'get miniProgram url failed'
	        });
	      }
	      wx().miniProgram.navigateTo({url: navigatePath});
	    } else {
	      location.href = url;
	    }
	  }
	}
	
	if (typeof window !== 'undefined') {
	  var version = __webpack_require__(286);
	  var logEvent = __webpack_require__(342);
	  // 统计wx调用次数
	  logEvent("wx", version);
	}
	
	KNB.ready = function (cb) {
	  if ( cb === void 0 ) cb = noop;
	
	  loader.use(function (wx) {
	    wx && wx.ready && wx.ready(cb);
	  })
	}; // 增加ready函数
	
	module.exports = KNB


/***/ }),
/* 470 */
/***/ (function(module, exports) {

	'use strict';
	
	
	var defaults = {
	    url: '//res.wx.qq.com/open/js/jweixin-1.3.1.js', //微信JSSDK的URL
	    configHostnameMap: [ //配置wx的js与域名的映射关系
	        {
	            pattern: /dianping.com$/,
	            host: 'cps.dianping.com'
	        },
	        {
	            pattern: /51ping.com$/,
	            host: 'tcps.51ping.com'
	        },
	        {
	            pattern: /(.meituan.(com|net))|(maoyan.com)$/,
	            host: 'i.meituan.com/firework/api'
	        }
	    ],
	    config: { //默认配置
	        debug: false
	    },
	    onError: function (msg) {
	        console && console.error && console.error(msg);
	    }
	};
	
	var states = ['not-auth', 'being-auth', 'auth-success', 'auth-fail']
	
	if (!window._MTDPAuth_) {
	    window._MTDPAuth_ = {
	        state: states[0],
	        callbackQueue: []
	    }
	}
	
	var queue = window._MTDPAuth_.callbackQueue
	
	var loadScript = function (src, onload) {
	    var script = document.createElement('script');
	    script.src = src;
	    script.onload = onload;
	    document.getElementsByTagName("head")[0].appendChild(script);
	};
	
	
	exports.use = function (callback, opts) {
	    opts = opts || {}
	
	    var options = defaults;
	    if (/[\?&]debug:wx($|&)/.test(window.location.search)) {
	        options.config.debug = true;
	    }
	
	    //成功失败都回调
	    if (window._MTDPAuth_.state === states[2] || window._MTDPAuth_.state === states[3]) {
	        return callback(window.wx);
	    }
	
	    queue.push(callback);
	
	    if (window._MTDPAuth_.state === states[1]) {
	        return;
	    }
	
	    window._MTDPAuth_.state = states[1]
	
	    var configHostname = options.configHostnameMap[0].host;
	    options.configHostnameMap.forEach(function (item) {
	        if (item.pattern.test(location.hostname))
	            configHostname = item.host;
	    });
	
	    var apis = 'checkJsApi,onMenuShareTimeline,onMenuShareAppMessage,onMenuShareQQ,onMenuShareWeibo,onMenuShareQZone,startRecord,stopRecord,onVoiceRecordEnd,playVoice,pauseVoice,stopVoice,onVoicePlayEnd,uploadVoice,downloadVoice,chooseImage,previewImage,uploadImage,downloadImage,getLocalImgData,translateVoice,getNetworkType,openLocation,getLocation,hideOptionMenu,showOptionMenu,hideMenuItems,showMenuItems,hideAllNonBaseMenuItem,showAllNonBaseMenuItem,closeWindow,scanQRCode,chooseWXPay,openAddress,openProductSpecificView,addCard,chooseCard,openCard,startSearchBeacons,stopSearchBeacons,onSearchBeacons,launchMiniProgram,miniProgram';
	    var configSearch = '?apis=' + apis;
	    Object.keys(options.config).forEach(function (name) {
	        configSearch += '&';
	        configSearch += encodeURIComponent(name);
	        configSearch += '=';
	        configSearch += encodeURIComponent(options.config[name]);
	    });
	
	    var doTask = function () {
	        var doCallback = function () {
	
	            window._MTDPAuth_.state = states[2]
	
	            while (queue && queue.length) {
	                var cb = queue.shift()
	                cb && cb(window.wx)
	            }
	        };
	
	        if (configHostname.indexOf('i.meituan.com') !== -1) {
	            window.jsonpWXLoader = function (res) {
	                var config = {
	                    debug: options.config.debug,
	                    appId: 'wxc72f01f43da0083b',
	                    timestamp: res.data.timestamp,
	                    signature: res.data.signature,
	                    nonceStr: res.data.nonceStr,
	                    jsApiList: apis.split(',')
	                };
	                wx.config(config);
	                doCallback();
	            }
	            loadScript('//' + configHostname + '/weixin/config.json?url=' + encodeURIComponent(location.href) + '&callback=jsonpWXLoader');
	        } else {
	            loadScript('//' + configHostname + '/weixin/config.js' + configSearch, function () {
	                doCallback();
	            });
	        }
	    }
	
	    if (opts.noSDK) {
	        doTask()
	    } else {
	        loadScript(options.url, function () {
	            doTask()
	        });
	    }
	};

/***/ }),
/* 471 */
/***/ (function(module, exports) {

	module.exports = [
	  'chooseImage',
	  'previewImage',
	  'uploadImage',
	  'downloadImage',
	  'getNetworkType',
	  'getLocation',
	  'scanQRCode',
	  'getUA',
	  'isApiSupported',
	  'use',
	  'openWebview'
	]

/***/ }),
/* 472 */
/***/ (function(module, exports) {

	var getUA = function(ua, url, host) {
	    var UA = ua || navigator.userAgent || navigator.vendor || window.opera;
	    var URL = url || window.location.href;
	    var HOST = host || window.location.host;
	    var result = {};
	    var type;
	    var version;
	    var os;
	    var osVersion;
	    var kernal;
	    var source;
	    var env
	
	    function match(reg) {
	        if (reg) {
	            if (UA.match(reg) && UA.match(reg).length) {
	                return UA.match(reg)[1];
	            }
	        }
	    }
	
	    function matchTypeVersion(reg) {
	        if (reg) {
	            if (UA.match(reg) && UA.match(reg).length >= 2) {
	                return UA.match(reg);
	            } else {
	                return ['', '0.0.0'];
	            }
	        }
	    }
	
	    function isMobile() {
	        var check = false;
	        if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(UA) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(UA.substr(0, 4))) check = true 
	        return check;
	    }
	    
	
	    try {
	        //mobile detect
	        result.isMobile = isMobile();
	
	        //os detect
	        if (UA.match(/android/i)) {
	            result.os = 'android';
	
	            result.osVersion = match(/Android\/([\d\.]+)/i) || match(/Android ([\d\.]+)/);
	
	            result.kernal = match(/AppleWebKit\/([\d\.]+)/i);
	
	            result.browserVersion = match(/Chrome\/([\d\.]+)/i);
	        } else if (UA.match(/(ipad|iphone|ipod).*os\s([\d_]+)/i)) {
	            result.os = 'ios';
	
	            result.osVersion = match(/iOS\/([\d\.]+)/) || match(/OS ([\d\_]+)/).split('_').join('.');
	
	            result.kernal = match(/AppleWebKit\/([\d\.]+)/i);
	
	            result.browserVersion = match(/Safari\/([\d\.]+)/i);
	        }
	
	        //environment & version detect
	        if (/dp\/com\.dianping/.test(UA)) {
	            var arr = matchTypeVersion(/dp\/com\.dianping\.([\w\.]+)\/([\d\.]+)/);
	            var typeKey = arr[1];
	            version = arr[2];
	            if (typeKey.indexOf('dpscope') !== -1) {
	                type = 'dpapp';
	            } else if (typeKey.indexOf('v1') !== -1) {
	                type = 'dpapp'
	                if (/adapter\/([\d\.]+)/.test(UA)) {
	                    version = match(/adapter\/([\d\.]+)/);
	                }
	            } else if (typeKey.indexOf('merchant')) {
	                type = 'dpmerchant';
	            } else if (typeKey.indexOf('wed')) {
	                type = 'dpwed';
	            } else {
	                type = 'dp';
	            }
	
	        } else if (/MeituanGroup/i.test(UA)) {
	            type = 'mtgroup';
	
	            var arr = matchTypeVersion(/(MeituanGroup)\/([\d\.]+)/i);
	            version = arr[2];
	
	        } else if (/(f=android)|(f=iphone)|(f=ipad)|(f=ios)/g.test(URL)) {
	            if (/(utm_campaign=Agroup)/.test(URL)) {
	                type = 'mtgroup';
	            } else {
	                type = 'mt'
	            }
	            var param = {};
	            try {
	                var query = URL.split('?')[1].split('&');
	                if (query && query.length) {
	                    query.map(function(str) {
	                        var arr = str.split('=');
	                        param[arr[0]] = arr[1];
	                    })
	                }
	            } catch (e) {
	                console.log('parse param failed');
	            }
	            version = param.version_name;
	        } else if (/MicroMessenger/.test(UA)) {
	            type = 'weixin';
	            version = match(/MicroMessenger\/([\d\.]+)/i);
	
	        } else if (/QZONE/.test(UA)) {
	            type = 'qqzone';
	            version = match(/QZONEJSSDK\/([\d\.]+)/);
	
	        } else if (/QQ\/([\d\.]+)/.test(UA)) {
	            type = 'qq';
	            version = match(/QQ\/([\d\.]+)/i);
	
	        } else if (/UCWEB/i.test(UA)) {
	            type = 'ucweb';
	            version = match(/UCWEB([\d\.]+)/i);
	
	        } else {
	            type = 'browser';
	        }
	
	        //区分业务：点评OR美团
	        if (/\.(dianping|dpfile)\.com/i.test(HOST)) {
	            source = 'dianping';
	            env = 'product';
	        }else if (/\.51ping\.com/i.test(HOST)) {
	            source = 'dianping';
	            env = 'beta';
	        }else if (/test(.+)\.meituan\.(com|net)/i.test(HOST)) {
	            source = 'meituan';
	            env = 'beta';
	        }else if (/\.meituan\.(com|net)/i.test(HOST)) {
	            source = 'meituan';
	            env = 'product';
	        }
	
	        result.type = type;
	        result.version = version;
	        result.source = source;
	        result.env = env;
	
	        return result;
	    } catch (e) {
	        console.log(e);
	        result.type = type;
	        result.version = version;
	
	        return result;
	    }
	};
	module.exports = getUA;

/***/ }),
/* 473 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 *
	 * Basic login component union
	 * adapt to Meituan and DianPing, both main APP and M website
	 */
	
	var GetUA = __webpack_require__(474);
	
	var DPAPP = 'dpapp';
	var MTAPP = 'mtgroup';
	var DPMW = 'dianping';
	var MTMW = 'meituan';
	
	var ua = GetUA()
	
	/**
	 *
	 * @param succ login成功回调
	 * @param fail login失败回调
	 * @param customUA 自定义UA信息
	 */
	var login = function (succ, fail, customUA) {
		ua = customUA || ua
		_envSwitch(
			//KNB action
			function () {
				KNB.login({
					success: function (user) {
						typeof succ == "function" && succ(user);
					},
					fail: function () {
						typeof fail == "function" && fail();
					}
				});
			},
			//web action
			function () {
				location.href = _getUrl();
			}
		);
	};
	
	login.check = function (cb, customUA) {
		ua = customUA || ua
		_envSwitch(
			//KNB action
			function () {
				KNB.getUserInfo({
					success: function (user) {
						_checkLoginAjax(function (isLogin) {
							var checkResult = { isLogin: isLogin };
							isLogin ? checkResult.userInfo = user : checkResult.userInfo = {};
							cb(checkResult);
						}, user.token);
					},
					fail: function () {
						typeof cb == "function" && cb({ isLogin: false, userInfo: {} });
					}
				})
			},
			//web action
			function () {
				_checkLoginAjax(
					function (isLogin) {
						cb({ isLogin: isLogin, userInfo: {} });
					}
				);
			}
		);
	}
	
	/**
	 * @param afterCheck cb
	 * @param token if KNB，post token to Backend
	 */
	function _checkLoginAjax(afterCheck, token) {
		var checkUrl = "https:" + (ua.env == "product" ? "//m.dianping.com" : "//m.51ping.com") + "/account/ajax/checkLogin";
		var ajaxData = token ? { token: token } : {};
		if (window.$ && window.$.ajax) {
			window.$.ajax({
				url: checkUrl,
				type: 'POST',
				timeout: 5000,
				xhrFields: {
					withCredentials: true
				},
				data: ajaxData,
				success: function (res) {
					console.log('checkLogin ajax succ' + JSON.stringify(res));
					typeof afterCheck == "function" && afterCheck(Boolean(res.login));
				},
				error: function (e) {
					console.error('checkLogin ajax failed!');
					typeof afterCheck == "function" && afterCheck(false);
				}
			})
		} else {
			!/* require.ensure */(function () {
				var reqwest = __webpack_require__(476);
				reqwest({
					url: checkUrl,
					type: 'json',
					method: 'post',
					contentType: 'application/x-www-form-urlencoded',
					withCredentials: true,
					headers: {},
					data: ajaxData,
					error: function (err) {
						console.error('checkLogin ajax failed');
						typeof afterCheck == "function" && afterCheck(false);
					},
					success: function (resp) {
						console.log('checkLogin ajax succ' + JSON.stringify(resp));
						typeof afterCheck == "function" && afterCheck(Boolean(resp.login));
					}
				})
			}(__webpack_require__));
		}
	}
	
	function _envSwitch(knbAction, webAction) {
		if (ua.type === DPAPP || ua.type === MTAPP) {
			if (!window.KNB) {
				!/* require.ensure */(function () {
					var KNB = __webpack_require__(282);
					KNB.ready(function () {
						typeof knbAction == "function" && knbAction();
					});
				}(__webpack_require__));
			} else {
				window.KNB.ready(function () {
					typeof knbAction == "function" && knbAction();
				});
			}
		} else {
			typeof webAction == "function" && webAction();
		}
	}
	
	function _getUrl() {
		var PROTOCOL = location.protocol;
		var REDIRECT = location.href;
		var source = ua.source;
		var env = ua.env;
		var domain;
		var path;
		switch (source) {
			case DPMW:
				if (env === 'product') {
					domain = '//m.dianping.com';
				} else {
					domain = '//m.51ping.com';
				}
				path = '/login?redir=' + encodeURIComponent(REDIRECT);
				break;
			case MTMW:
				if (env === 'product') {
					domain = '//i.meituan.com';
				} else {
					domain = '//i.wpt.test.sankuai.com';
				}
				path = '/account/login?backurl=' + encodeURIComponent(REDIRECT);
				break;
			default:
				domain = '//m.dianping.com';
				path = '/login?redir=' + encodeURIComponent(REDIRECT);
				break;
		}
		return PROTOCOL + domain + (path || '');
	}
	
	module.exports = login;

/***/ }),
/* 474 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {var parse = __webpack_require__(475);
	
	module.exports = function(config) {
	    config = config || {};
	    var UA = config.ua;
	    var HOST = config.host;
	
	    var isNode;
	    try{
	        isNode = Object.prototype.toString.call(global.process) === '[object process]';
	    }catch(e){
	        isNode = false
	    }
	    if (isNode) {
	        UA = UA || this.req.headers['user-agent']
	        HOST = HOST || this.req.headers['host'];
	    }else{
	        UA = UA || window.navigator.userAgent || window.navigator.vendor || window.opera;
	        HOST = HOST || window.location.host
	    }
	
	    return parse(UA, HOST)
	};
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 475 */
/***/ (function(module, exports) {

	var caches = []
	var MAX_CACHE = 10
	
	module.exports = function parseUA(UA, HOST) {
	    for (var index = 0; index < caches.length; index++) {
	        var cache = caches[index];
	        if (cache && cache.ua === UA && cache.host === HOST && cache.result instanceof Object) {
	            cache.result.isCache = true
	            return cache.result
	        }
	    }
	
	    var result = {
	        isCache: false
	    };
	    var type;
	    var version;
	    var os;
	    var osVersion;
	    var kernal;
	    var source;
	    var env;
	    var model;
	
	    function match(reg) {
	        if (reg) {
	            if (UA.match(reg) && UA.match(reg).length) {
	                return UA.match(reg)[1];
	            }
	        }
	    }
	
	    function matchTypeVersion(reg) {
	        if (reg) {
	            if (UA.match(reg) && UA.match(reg).length >= 2) {
	                return UA.match(reg);
	            } else {
	                return ['', '0.0.0'];
	            }
	        }
	    }
	
	    function isMobile() {
	        var check = false;
	        if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(UA) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(UA.substr(0, 4))) check = true
	        return check;
	    }
	
	
	    try {
	        if (!UA) return
	        //mobile detect
	        result.isMobile = isMobile();
	
	        //os detect
	        if (UA.match(/android/i)) {
	            result.os = 'android';
	
	            result.osVersion = match(/Android\/([\d\.]+)/i) || match(/Android ([\d\.]+)/);
	
	            result.kernal = match(/AppleWebKit\/([\d\.]+)/i);
	
	            result.browserVersion = match(/Chrome\/([\d\.]+)/i);
	        } else if (UA.match(/(ipad|iphone|ipod).*os\s([\d_]+)/i)) {
	            result.os = 'ios';
	
	            result.osVersion = match(/iOS\/([\d\.]+)/) || match(/OS ([\d\_]+)/).split('_').join('.');
	
	            result.kernal = match(/AppleWebKit\/([\d\.]+)/i);
	
	            result.browserVersion = match(/Safari\/([\d\.]+)/i);
	        }
	
	        //environment & version detect
	        if (/dp\/com\.dianping/.test(UA)) {
	            var arr = matchTypeVersion(/dp\/com\.dianping\.([\w\.]+)\/([\d\.]+)/);
	            var typeKey = arr[1];
	            version = arr[2];
	            if (typeKey.indexOf('dpscope') !== -1) {
	                type = 'dpapp';
	            } else if (typeKey.indexOf('v1') !== -1) {
	                type = 'dpapp'
	                if (/adapter\/([\d\.]+)/.test(UA)) {
	                    version = match(/adapter\/([\d\.]+)/);
	                }
	            } else if (typeKey.indexOf('wedmerchant') !== -1) {
	                type = 'dpwedmerchant'
	            } else if (typeKey.indexOf('merchant') !== -1 || typeKey === 'mp.mobile') {
	                type = 'dpmerchant';
	            } else if (typeKey.indexOf('wed') !== -1) {
	                type = 'dpwed';
	            } else {
	                type = 'dp';
	            }
	
	        } else if (/MeituanGroup/i.test(UA)) {
	            type = 'mtgroup';
	
	            var arr = matchTypeVersion(/(MeituanGroup)\/([\d\.]+)/i);
	            version = arr[2];
	
	        } else if (/MicroMessenger/.test(UA)) {
	            type = 'weixin';
	            version = match(/MicroMessenger\/([\d\.]+)/i);
	
	        } else if (/QZONE/.test(UA)) {
	            type = 'qqzone';
	            version = match(/QZONEJSSDK\/([\d\.]+)/);
	
	        } else if (/QQ\/([\d\.]+)/.test(UA)) {
	            type = 'qq';
	            version = match(/QQ\/([\d\.]+)/i);
	
	        } else if (/UCWEB/i.test(UA)) {
	            type = 'ucweb';
	            version = match(/UCWEB([\d\.]+)/i);
	
	        } else {
	            type = 'browser';
	        }
	
	        //区分业务：点评OR美团
	        if (/\.(dianping|dpfile)\.com/i.test(HOST)) {
	            source = 'dianping';
	            env = 'product';
	        } else if (/\.51ping\.com/i.test(HOST)) {
	            source = 'dianping';
	            env = 'beta';
	        } else if (/test(.+)\.meituan\.(com|net)/i.test(HOST)) {
	            source = 'meituan';
	            env = 'beta';
	        } else if (/\.meituan\.(com|net)/i.test(HOST)) {
	            source = 'meituan';
	            env = 'product';
	        }
	
	        if (/iPhone\/iPhoneX/.test(UA)) {
	            model = 'iPhoneX'
	        } else {
	            model = ''
	        }
	
	        result.type = type;
	        result.version = version;
	        result.source = source;
	        result.env = env;
	        result.model = model;
	
	    } catch (e) {
	        console.log(e);
	        result.type = type;
	        result.version = version;
	    }
	
	    var newCache = {
	        ua: UA,
	        host: HOST,
	        result: result
	    }
	    if (caches.length < MAX_CACHE) {
	        caches.push(newCache)
	    } else {
	        caches.shift()
	        caches.push(newCache)
	    }
	
	    return result
	};

/***/ }),
/* 476 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	  * Reqwest! A general purpose XHR connection manager
	  * license MIT (c) Dustin Diaz 2015
	  * https://github.com/ded/reqwest
	  */
	
	!function (name, context, definition) {
	  if (typeof module != 'undefined' && module.exports) module.exports = definition()
	  else if (true) !(__WEBPACK_AMD_DEFINE_FACTORY__ = (definition), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
	  else context[name] = definition()
	}('reqwest', this, function () {
	
	  var context = this
	
	  if ('window' in context) {
	    var doc = document
	      , byTag = 'getElementsByTagName'
	      , head = doc[byTag]('head')[0]
	  } else {
	    var XHR2
	    try {
	      XHR2 = __webpack_require__(477)
	    } catch (ex) {
	      throw new Error('Peer dependency `xhr2` required! Please npm install xhr2')
	    }
	  }
	
	
	  var httpsRe = /^http/
	    , protocolRe = /(^\w+):\/\//
	    , twoHundo = /^(20\d|1223)$/ //http://stackoverflow.com/questions/10046972/msie-returns-status-code-of-1223-for-ajax-request
	    , readyState = 'readyState'
	    , contentType = 'Content-Type'
	    , requestedWith = 'X-Requested-With'
	    , uniqid = 0
	    , callbackPrefix = 'reqwest_' + (+new Date())
	    , lastValue // data stored by the most recent JSONP callback
	    , xmlHttpRequest = 'XMLHttpRequest'
	    , xDomainRequest = 'XDomainRequest'
	    , noop = function () {}
	
	    , isArray = typeof Array.isArray == 'function'
	        ? Array.isArray
	        : function (a) {
	            return a instanceof Array
	          }
	
	    , defaultHeaders = {
	          'contentType': 'application/x-www-form-urlencoded'
	        , 'requestedWith': xmlHttpRequest
	        , 'accept': {
	              '*':  'text/javascript, text/html, application/xml, text/xml, */*'
	            , 'xml':  'application/xml, text/xml'
	            , 'html': 'text/html'
	            , 'text': 'text/plain'
	            , 'json': 'application/json, text/javascript'
	            , 'js':   'application/javascript, text/javascript'
	          }
	      }
	
	    , xhr = function(o) {
	        // is it x-domain
	        if (o['crossOrigin'] === true) {
	          var xhr = context[xmlHttpRequest] ? new XMLHttpRequest() : null
	          if (xhr && 'withCredentials' in xhr) {
	            return xhr
	          } else if (context[xDomainRequest]) {
	            return new XDomainRequest()
	          } else {
	            throw new Error('Browser does not support cross-origin requests')
	          }
	        } else if (context[xmlHttpRequest]) {
	          return new XMLHttpRequest()
	        } else if (XHR2) {
	          return new XHR2()
	        } else {
	          return new ActiveXObject('Microsoft.XMLHTTP')
	        }
	      }
	    , globalSetupOptions = {
	        dataFilter: function (data) {
	          return data
	        }
	      }
	
	  function succeed(r) {
	    var protocol = protocolRe.exec(r.url)
	    protocol = (protocol && protocol[1]) || context.location.protocol
	    return httpsRe.test(protocol) ? twoHundo.test(r.request.status) : !!r.request.response
	  }
	
	  function handleReadyState(r, success, error) {
	    return function () {
	      // use _aborted to mitigate against IE err c00c023f
	      // (can't read props on aborted request objects)
	      if (r._aborted) return error(r.request)
	      if (r._timedOut) return error(r.request, 'Request is aborted: timeout')
	      if (r.request && r.request[readyState] == 4) {
	        r.request.onreadystatechange = noop
	        if (succeed(r)) success(r.request)
	        else
	          error(r.request)
	      }
	    }
	  }
	
	  function setHeaders(http, o) {
	    var headers = o['headers'] || {}
	      , h
	
	    headers['Accept'] = headers['Accept']
	      || defaultHeaders['accept'][o['type']]
	      || defaultHeaders['accept']['*']
	
	    var isAFormData = typeof FormData !== 'undefined' && (o['data'] instanceof FormData);
	    // breaks cross-origin requests with legacy browsers
	    if (!o['crossOrigin'] && !headers[requestedWith]) headers[requestedWith] = defaultHeaders['requestedWith']
	    if (!headers[contentType] && !isAFormData) headers[contentType] = o['contentType'] || defaultHeaders['contentType']
	    for (h in headers)
	      headers.hasOwnProperty(h) && 'setRequestHeader' in http && http.setRequestHeader(h, headers[h])
	  }
	
	  function setCredentials(http, o) {
	    if (typeof o['withCredentials'] !== 'undefined' && typeof http.withCredentials !== 'undefined') {
	      http.withCredentials = !!o['withCredentials']
	    }
	  }
	
	  function generalCallback(data) {
	    lastValue = data
	  }
	
	  function urlappend (url, s) {
	    return url + (/\?/.test(url) ? '&' : '?') + s
	  }
	
	  function handleJsonp(o, fn, err, url) {
	    var reqId = uniqid++
	      , cbkey = o['jsonpCallback'] || 'callback' // the 'callback' key
	      , cbval = o['jsonpCallbackName'] || reqwest.getcallbackPrefix(reqId)
	      , cbreg = new RegExp('((^|\\?|&)' + cbkey + ')=([^&]+)')
	      , match = url.match(cbreg)
	      , script = doc.createElement('script')
	      , loaded = 0
	      , isIE10 = navigator.userAgent.indexOf('MSIE 10.0') !== -1
	
	    if (match) {
	      if (match[3] === '?') {
	        url = url.replace(cbreg, '$1=' + cbval) // wildcard callback func name
	      } else {
	        cbval = match[3] // provided callback func name
	      }
	    } else {
	      url = urlappend(url, cbkey + '=' + cbval) // no callback details, add 'em
	    }
	
	    context[cbval] = generalCallback
	
	    script.type = 'text/javascript'
	    script.src = url
	    script.async = true
	    if (typeof script.onreadystatechange !== 'undefined' && !isIE10) {
	      // need this for IE due to out-of-order onreadystatechange(), binding script
	      // execution to an event listener gives us control over when the script
	      // is executed. See http://jaubourg.net/2010/07/loading-script-as-onclick-handler-of.html
	      script.htmlFor = script.id = '_reqwest_' + reqId
	    }
	
	    script.onload = script.onreadystatechange = function () {
	      if ((script[readyState] && script[readyState] !== 'complete' && script[readyState] !== 'loaded') || loaded) {
	        return false
	      }
	      script.onload = script.onreadystatechange = null
	      script.onclick && script.onclick()
	      // Call the user callback with the last value stored and clean up values and scripts.
	      fn(lastValue)
	      lastValue = undefined
	      head.removeChild(script)
	      loaded = 1
	    }
	
	    // Add the script to the DOM head
	    head.appendChild(script)
	
	    // Enable JSONP timeout
	    return {
	      abort: function () {
	        script.onload = script.onreadystatechange = null
	        err({}, 'Request is aborted: timeout', {})
	        lastValue = undefined
	        head.removeChild(script)
	        loaded = 1
	      }
	    }
	  }
	
	  function getRequest(fn, err) {
	    var o = this.o
	      , method = (o['method'] || 'GET').toUpperCase()
	      , url = typeof o === 'string' ? o : o['url']
	      // convert non-string objects to query-string form unless o['processData'] is false
	      , data = (o['processData'] !== false && o['data'] && typeof o['data'] !== 'string')
	        ? reqwest.toQueryString(o['data'])
	        : (o['data'] || null)
	      , http
	      , sendWait = false
	
	    // if we're working on a GET request and we have data then we should append
	    // query string to end of URL and not post data
	    if ((o['type'] == 'jsonp' || method == 'GET') && data) {
	      url = urlappend(url, data)
	      data = null
	    }
	
	    if (o['type'] == 'jsonp') return handleJsonp(o, fn, err, url)
	
	    // get the xhr from the factory if passed
	    // if the factory returns null, fall-back to ours
	    http = (o.xhr && o.xhr(o)) || xhr(o)
	
	    http.open(method, url, o['async'] === false ? false : true)
	    setHeaders(http, o)
	    setCredentials(http, o)
	    if (context[xDomainRequest] && http instanceof context[xDomainRequest]) {
	        http.onload = fn
	        http.onerror = err
	        // NOTE: see
	        // http://social.msdn.microsoft.com/Forums/en-US/iewebdevelopment/thread/30ef3add-767c-4436-b8a9-f1ca19b4812e
	        http.onprogress = function() {}
	        sendWait = true
	    } else {
	      http.onreadystatechange = handleReadyState(this, fn, err)
	    }
	    o['before'] && o['before'](http)
	    if (sendWait) {
	      setTimeout(function () {
	        http.send(data)
	      }, 200)
	    } else {
	      http.send(data)
	    }
	    return http
	  }
	
	  function Reqwest(o, fn) {
	    this.o = o
	    this.fn = fn
	
	    init.apply(this, arguments)
	  }
	
	  function setType(header) {
	    // json, javascript, text/plain, text/html, xml
	    if (header === null) return undefined; //In case of no content-type.
	    if (header.match('json')) return 'json'
	    if (header.match('javascript')) return 'js'
	    if (header.match('text')) return 'html'
	    if (header.match('xml')) return 'xml'
	  }
	
	  function init(o, fn) {
	
	    this.url = typeof o == 'string' ? o : o['url']
	    this.timeout = null
	
	    // whether request has been fulfilled for purpose
	    // of tracking the Promises
	    this._fulfilled = false
	    // success handlers
	    this._successHandler = function(){}
	    this._fulfillmentHandlers = []
	    // error handlers
	    this._errorHandlers = []
	    // complete (both success and fail) handlers
	    this._completeHandlers = []
	    this._erred = false
	    this._responseArgs = {}
	
	    var self = this
	
	    fn = fn || function () {}
	
	    if (o['timeout']) {
	      this.timeout = setTimeout(function () {
	        timedOut()
	      }, o['timeout'])
	    }
	
	    if (o['success']) {
	      this._successHandler = function () {
	        o['success'].apply(o, arguments)
	      }
	    }
	
	    if (o['error']) {
	      this._errorHandlers.push(function () {
	        o['error'].apply(o, arguments)
	      })
	    }
	
	    if (o['complete']) {
	      this._completeHandlers.push(function () {
	        o['complete'].apply(o, arguments)
	      })
	    }
	
	    function complete (resp) {
	      o['timeout'] && clearTimeout(self.timeout)
	      self.timeout = null
	      while (self._completeHandlers.length > 0) {
	        self._completeHandlers.shift()(resp)
	      }
	    }
	
	    function success (resp) {
	      var type = o['type'] || resp && setType(resp.getResponseHeader('Content-Type')) // resp can be undefined in IE
	      resp = (type !== 'jsonp') ? self.request : resp
	      // use global data filter on response text
	      var filteredResponse = globalSetupOptions.dataFilter(resp.responseText, type)
	        , r = filteredResponse
	      try {
	        resp.responseText = r
	      } catch (e) {
	        // can't assign this in IE<=8, just ignore
	      }
	      if (r) {
	        switch (type) {
	        case 'json':
	          try {
	            resp = context.JSON ? context.JSON.parse(r) : eval('(' + r + ')')
	          } catch (err) {
	            return error(resp, 'Could not parse JSON in response', err)
	          }
	          break
	        case 'js':
	          resp = eval(r)
	          break
	        case 'html':
	          resp = r
	          break
	        case 'xml':
	          resp = resp.responseXML
	              && resp.responseXML.parseError // IE trololo
	              && resp.responseXML.parseError.errorCode
	              && resp.responseXML.parseError.reason
	            ? null
	            : resp.responseXML
	          break
	        }
	      }
	
	      self._responseArgs.resp = resp
	      self._fulfilled = true
	      fn(resp)
	      self._successHandler(resp)
	      while (self._fulfillmentHandlers.length > 0) {
	        resp = self._fulfillmentHandlers.shift()(resp)
	      }
	
	      complete(resp)
	    }
	
	    function timedOut() {
	      self._timedOut = true
	      self.request.abort()
	    }
	
	    function error(resp, msg, t) {
	      resp = self.request
	      self._responseArgs.resp = resp
	      self._responseArgs.msg = msg
	      self._responseArgs.t = t
	      self._erred = true
	      while (self._errorHandlers.length > 0) {
	        self._errorHandlers.shift()(resp, msg, t)
	      }
	      complete(resp)
	    }
	
	    this.request = getRequest.call(this, success, error)
	  }
	
	  Reqwest.prototype = {
	    abort: function () {
	      this._aborted = true
	      this.request.abort()
	    }
	
	  , retry: function () {
	      init.call(this, this.o, this.fn)
	    }
	
	    /**
	     * Small deviation from the Promises A CommonJs specification
	     * http://wiki.commonjs.org/wiki/Promises/A
	     */
	
	    /**
	     * `then` will execute upon successful requests
	     */
	  , then: function (success, fail) {
	      success = success || function () {}
	      fail = fail || function () {}
	      if (this._fulfilled) {
	        this._responseArgs.resp = success(this._responseArgs.resp)
	      } else if (this._erred) {
	        fail(this._responseArgs.resp, this._responseArgs.msg, this._responseArgs.t)
	      } else {
	        this._fulfillmentHandlers.push(success)
	        this._errorHandlers.push(fail)
	      }
	      return this
	    }
	
	    /**
	     * `always` will execute whether the request succeeds or fails
	     */
	  , always: function (fn) {
	      if (this._fulfilled || this._erred) {
	        fn(this._responseArgs.resp)
	      } else {
	        this._completeHandlers.push(fn)
	      }
	      return this
	    }
	
	    /**
	     * `fail` will execute when the request fails
	     */
	  , fail: function (fn) {
	      if (this._erred) {
	        fn(this._responseArgs.resp, this._responseArgs.msg, this._responseArgs.t)
	      } else {
	        this._errorHandlers.push(fn)
	      }
	      return this
	    }
	  , 'catch': function (fn) {
	      return this.fail(fn)
	    }
	  }
	
	  function reqwest(o, fn) {
	    return new Reqwest(o, fn)
	  }
	
	  // normalize newline variants according to spec -> CRLF
	  function normalize(s) {
	    return s ? s.replace(/\r?\n/g, '\r\n') : ''
	  }
	
	  function serial(el, cb) {
	    var n = el.name
	      , t = el.tagName.toLowerCase()
	      , optCb = function (o) {
	          // IE gives value="" even where there is no value attribute
	          // 'specified' ref: http://www.w3.org/TR/DOM-Level-3-Core/core.html#ID-862529273
	          if (o && !o['disabled'])
	            cb(n, normalize(o['attributes']['value'] && o['attributes']['value']['specified'] ? o['value'] : o['text']))
	        }
	      , ch, ra, val, i
	
	    // don't serialize elements that are disabled or without a name
	    if (el.disabled || !n) return
	
	    switch (t) {
	    case 'input':
	      if (!/reset|button|image|file/i.test(el.type)) {
	        ch = /checkbox/i.test(el.type)
	        ra = /radio/i.test(el.type)
	        val = el.value
	        // WebKit gives us "" instead of "on" if a checkbox has no value, so correct it here
	        ;(!(ch || ra) || el.checked) && cb(n, normalize(ch && val === '' ? 'on' : val))
	      }
	      break
	    case 'textarea':
	      cb(n, normalize(el.value))
	      break
	    case 'select':
	      if (el.type.toLowerCase() === 'select-one') {
	        optCb(el.selectedIndex >= 0 ? el.options[el.selectedIndex] : null)
	      } else {
	        for (i = 0; el.length && i < el.length; i++) {
	          el.options[i].selected && optCb(el.options[i])
	        }
	      }
	      break
	    }
	  }
	
	  // collect up all form elements found from the passed argument elements all
	  // the way down to child elements; pass a '<form>' or form fields.
	  // called with 'this'=callback to use for serial() on each element
	  function eachFormElement() {
	    var cb = this
	      , e, i
	      , serializeSubtags = function (e, tags) {
	          var i, j, fa
	          for (i = 0; i < tags.length; i++) {
	            fa = e[byTag](tags[i])
	            for (j = 0; j < fa.length; j++) serial(fa[j], cb)
	          }
	        }
	
	    for (i = 0; i < arguments.length; i++) {
	      e = arguments[i]
	      if (/input|select|textarea/i.test(e.tagName)) serial(e, cb)
	      serializeSubtags(e, [ 'input', 'select', 'textarea' ])
	    }
	  }
	
	  // standard query string style serialization
	  function serializeQueryString() {
	    return reqwest.toQueryString(reqwest.serializeArray.apply(null, arguments))
	  }
	
	  // { 'name': 'value', ... } style serialization
	  function serializeHash() {
	    var hash = {}
	    eachFormElement.apply(function (name, value) {
	      if (name in hash) {
	        hash[name] && !isArray(hash[name]) && (hash[name] = [hash[name]])
	        hash[name].push(value)
	      } else hash[name] = value
	    }, arguments)
	    return hash
	  }
	
	  // [ { name: 'name', value: 'value' }, ... ] style serialization
	  reqwest.serializeArray = function () {
	    var arr = []
	    eachFormElement.apply(function (name, value) {
	      arr.push({name: name, value: value})
	    }, arguments)
	    return arr
	  }
	
	  reqwest.serialize = function () {
	    if (arguments.length === 0) return ''
	    var opt, fn
	      , args = Array.prototype.slice.call(arguments, 0)
	
	    opt = args.pop()
	    opt && opt.nodeType && args.push(opt) && (opt = null)
	    opt && (opt = opt.type)
	
	    if (opt == 'map') fn = serializeHash
	    else if (opt == 'array') fn = reqwest.serializeArray
	    else fn = serializeQueryString
	
	    return fn.apply(null, args)
	  }
	
	  reqwest.toQueryString = function (o, trad) {
	    var prefix, i
	      , traditional = trad || false
	      , s = []
	      , enc = encodeURIComponent
	      , add = function (key, value) {
	          // If value is a function, invoke it and return its value
	          value = ('function' === typeof value) ? value() : (value == null ? '' : value)
	          s[s.length] = enc(key) + '=' + enc(value)
	        }
	    // If an array was passed in, assume that it is an array of form elements.
	    if (isArray(o)) {
	      for (i = 0; o && i < o.length; i++) add(o[i]['name'], o[i]['value'])
	    } else {
	      // If traditional, encode the "old" way (the way 1.3.2 or older
	      // did it), otherwise encode params recursively.
	      for (prefix in o) {
	        if (o.hasOwnProperty(prefix)) buildParams(prefix, o[prefix], traditional, add)
	      }
	    }
	
	    // spaces should be + according to spec
	    return s.join('&').replace(/%20/g, '+')
	  }
	
	  function buildParams(prefix, obj, traditional, add) {
	    var name, i, v
	      , rbracket = /\[\]$/
	
	    if (isArray(obj)) {
	      // Serialize array item.
	      for (i = 0; obj && i < obj.length; i++) {
	        v = obj[i]
	        if (traditional || rbracket.test(prefix)) {
	          // Treat each array item as a scalar.
	          add(prefix, v)
	        } else {
	          buildParams(prefix + '[' + (typeof v === 'object' ? i : '') + ']', v, traditional, add)
	        }
	      }
	    } else if (obj && obj.toString() === '[object Object]') {
	      // Serialize object item.
	      for (name in obj) {
	        buildParams(prefix + '[' + name + ']', obj[name], traditional, add)
	      }
	
	    } else {
	      // Serialize scalar item.
	      add(prefix, obj)
	    }
	  }
	
	  reqwest.getcallbackPrefix = function () {
	    return callbackPrefix
	  }
	
	  // jQuery and Zepto compatibility, differences can be remapped here so you can call
	  // .ajax.compat(options, callback)
	  reqwest.compat = function (o, fn) {
	    if (o) {
	      o['type'] && (o['method'] = o['type']) && delete o['type']
	      o['dataType'] && (o['type'] = o['dataType'])
	      o['jsonpCallback'] && (o['jsonpCallbackName'] = o['jsonpCallback']) && delete o['jsonpCallback']
	      o['jsonp'] && (o['jsonpCallback'] = o['jsonp'])
	    }
	    return new Reqwest(o, fn)
	  }
	
	  reqwest.ajaxSetup = function (options) {
	    options = options || {}
	    for (var k in options) {
	      globalSetupOptions[k] = options[k]
	    }
	  }
	
	  return reqwest
	});


/***/ }),
/* 477 */
/***/ (function(module, exports) {

	/* (ignored) */

/***/ }),
/* 478 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _config = __webpack_require__(479);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _url = __webpack_require__(480);
	
	var _url2 = _interopRequireDefault(_url);
	
	var _cache = __webpack_require__(481);
	
	var _cache2 = _interopRequireDefault(_cache);
	
	var _dp = __webpack_require__(483);
	
	var _dp2 = _interopRequireDefault(_dp);
	
	var _mt = __webpack_require__(494);
	
	var _mt2 = _interopRequireDefault(_mt);
	
	var _log = __webpack_require__(495);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Promise = window.Promise || __webpack_require__(486);
	
	var GEOS = [_url2.default, _cache2.default, __webpack_require__(527), __webpack_require__(529), __webpack_require__(531), __webpack_require__(533), // （TBS）补位API
	__webpack_require__(534), // 1.浏览器 2.安卓微信&QQ补位API
	__webpack_require__(535) // 兜底
	];
	var DIANPING = 'dianping';
	var MEITUAN = 'meituan';
	
	var Whereami = function () {
	    function Whereami() {
	        _classCallCheck(this, Whereami);
	
	        this.isLocating = false;
	        this.sucCallbackQueue = [];
	        this.errorCallBackQueue = [];
	    }
	
	    _createClass(Whereami, [{
	        key: 'initData',
	        value: function initData() {
	            // config
	            this.timeout = _config2.default.get('timeout') || 10000;
	            this.disables = _config2.default.get('disables') || [];
	            this.needCity = _config2.default.get('city');
	            this.cityType = _config2.default.get('cityType');
	            this.allowCache = !~this.disables.indexOf('cache'); // 说明：默认使用内存，只有`disables`能完全屏蔽`cache`API
	            this.debug = /debug:whereami/i.test(location.href) || _config2.default.get('debug');
	
	            this.apiTimeout = this.timeout; // 说明：目前统一设置为业务允许的最大值，灵活可控，组件内保留缓存策略
	
	            // once
	            this.isTimeout = false;
	            this.timer = undefined;
	            this.current = -1;
	            this.onceStartTime = Date.now(); // 一次调用的开始时间
	            (0, _log.LogClean)(); // 根据采样率重置上报开关
	        }
	    }, {
	        key: 'action',
	        value: function action(onSucc, onFail) {
	            var _this = this;
	
	            // 预处理
	            onSucc = typeof onSucc == 'function' ? onSucc : this.noop;
	            onFail = typeof onFail == 'function' ? onFail : this.noop;
	            // 过滤爬虫
	            if (this.isSpider()) return onFail();
	
	            // 回调队列
	            this.sucCallbackQueue.push(onSucc);
	            this.errorCallBackQueue.push(onFail);
	
	            // 检查状态: 业务并发调用控制阀
	            if (this.isLocating) return;
	            this.isLocating = true;
	            // 初始化数据
	            this.initData();
	            // 计时器
	            this.timer = setTimeout(function () {
	                _this.isTimeout = true;
	                // GEO总体上报: 一次定位结束[3]
	                (0, _log.Log)(_this.onceStartTime, 408); // 若全量使用缓存策略，统计数据GEO满足`408=201+409+416`等式
	                // 业务回调
	                _this.execute(_this.errorCallBackQueue, {
	                    code: 202,
	                    message: 'Timeout: ' + _this.timeout + 'ms'
	                });
	            }, this.timeout);
	
	            // 开始定位
	            this.next();
	        }
	
	        /**
	         * 定位流程处理策略
	         * 1.已超时，允许缓存: 业务方返回失败结果，组件内部继续定位（补位API逆袭; 阶段二城市信息）
	         * 2.已超时，禁止缓存: API定位结束（结果无增益）
	         * 3.未超时，GEO API依次调用（正常流程）
	         */
	
	    }, {
	        key: 'processOn',
	        value: function processOn() {
	            return !this.isTimeout || this.allowCache;
	        }
	
	        /**
	         * 调用场景：
	         * 1. 显式调用: 开始定位、禁用、环境不支持(匹配UA)或业务不支持(`enables`选项且未显式声明)
	         * 2. 隐式调用: API异常、`enables`定位失败、超时 [新增]
	         * 3. 隐式调用: 定位结果无效 [新增]
	         */
	
	    }, {
	        key: 'next',
	        value: function next() {
	            var _this2 = this;
	
	            // API队列计数器
	            this.current++;
	            // 队列结束
	            if (!GEOS[this.current]) {
	                // GEO总体上报: 一次定位结束[4]
	                (0, _log.Log)(this.onceStartTime, this.isTimeout ? 416 : 417);
	                // 超时
	                if (this.isTimeout) return;
	                clearTimeout(this.timer);
	                // 业务回调
	                return this.execute(this.errorCallBackQueue, {
	                    code: '204',
	                    message: 'No Geo Support'
	                });
	            }
	
	            // 流程策略检查
	            if (!this.processOn()) return;
	
	            // API调用描述信息（闭包）
	            var geoMethodType = GEOS[this.current].type;
	            var startTime = Date.now();
	            // API禁用（高优先级）
	            if (~this.disables.indexOf(geoMethodType)) {
	                return this.next();
	            }
	            // Debug
	            this.debug && alert('start geos: ' + geoMethodType);
	            // console.log('WhereAmI Geo Channel:', geoMethodType);
	
	            GEOS[this.current](function (ret, token) {
	                _this2.geoSuccHandle(ret, {
	                    customToken: token,
	                    originToken: startTime,
	                    geoMethodType: geoMethodType, // 备选
	                    startTime: startTime
	                });
	            }, function (err, token) {
	                _this2.geoErrorHandle(err, {
	                    customToken: token,
	                    originToken: startTime,
	                    geoMethodType: geoMethodType, // 备选
	                    startTime: startTime
	                });
	            }, this.next.bind(this), {
	                token: startTime, // 分发Token
	                timeout: this.apiTimeout // API超时时长
	            });
	        }
	
	        /**
	         * API 回调时效性校验，确保回调(succ、fail)有且仅有一次生效
	         * @param custom API当前Token(分发至API，各自`keeper`实例管理，只读一次、超时销毁)
	         * @param origin 原始Token
	         */
	
	    }, {
	        key: 'validToken',
	        value: function validToken(custom, origin, geoMethodType) {
	            try {
	                if (!origin || !custom) return false;
	                return new Date(origin).toString() == new Date(custom).toString();
	            } catch (e) {
	                return false;
	            }
	        }
	
	        /**
	         * API定位结果校验
	         * @param ret 
	         */
	
	    }, {
	        key: 'validGeoRet',
	        value: function validGeoRet(ret) {
	            return !!(ret && parseFloat(ret.lat) && parseFloat(ret.lng));
	        }
	
	        /**
	         * API定位成功（未校验）: Token校验、数据校验、API上报、[GEO上报, 补位API调用]，不涉及业务回调
	         * @param ret 
	         * @param param1 
	         */
	
	    }, {
	        key: 'geoSuccHandle',
	        value: function geoSuccHandle(ret, _ref) {
	            var customToken = _ref.customToken,
	                originToken = _ref.originToken,
	                geoMethodType = _ref.geoMethodType,
	                startTime = _ref.startTime;
	
	            // 校验token
	            if (!this.validToken(customToken, originToken, geoMethodType)) {
	                this.allowCache && _cache2.default.set(ret); // 说明: API超时时长以业务为准，允许组件写入缓存；其他情况不追加结果
	                return;
	            }
	            // API信息
	            var geoType = ret.type || geoMethodType;
	            // 校验数据
	            var validRet = this.validGeoRet(ret);
	            // API定位上报
	            (0, _log.Log)(startTime, validRet || 206, geoType);
	            if (!validRet) {
	                return this.next(); // 补位API继续定位，提升总体成功率（代价是平均时延增大）
	            }
	            // GEO总体上报: 一次定位结束[1]
	            (0, _log.Log)(this.onceStartTime, !this.isTimeout || 201);
	            (0, _log.LogService)(this.onceStartTime, ret);
	            // 组件业务逻辑处理
	            this.getPositionSuccess(ret, geoType);
	        }
	
	        /**
	         * API定位失败、异常、超时: Token校验、API上报、[GEO上报, 补位策略]，不涉及业务回调
	         * @param err 
	         * @param param1
	         */
	
	    }, {
	        key: 'geoErrorHandle',
	        value: function geoErrorHandle() {
	            var err = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	            var _ref2 = arguments[1];
	            var customToken = _ref2.customToken,
	                originToken = _ref2.originToken,
	                geoMethodType = _ref2.geoMethodType,
	                startTime = _ref2.startTime;
	
	            // 校验token
	            if (!this.validToken(customToken, originToken, geoMethodType)) return;
	            // API信息
	            var geoType = err.type || geoMethodType;
	            // API定位上报
	            (0, _log.Log)(startTime, err.code, geoType);
	            if (~[400, 404, 407, 408, 412].indexOf(err.code)) {
	                if (err.code == 400) {
	                    // 异常详情上报
	                    (0, _log.LogError)(err, geoType, err.title || geoType + '-exception');
	                } else if (err.code == 404) {
	                    // `enables`API定位失败详情上报
	                    (0, _log.LogError)(err, geoType);
	                }
	                // 407: 设备未授权
	                // 408: API超时
	                // 412: 未命中
	                return this.next(); // 使用补位API继续定位
	            }
	            // 401: `用户未授权`进入结束状态 -> 1) 用户不友好 2) 反馈至业务方（主要是html渠道）
	            // GEO总体上报: 一次定位结束[2]
	            (0, _log.Log)(this.onceStartTime, this.isTimeout && 409);
	            // 错误详情上报
	            (0, _log.LogError)(err, geoType);
	
	            // 组件业务逻辑处理
	            this.getPositionError(err);
	        }
	
	        /**
	         * 定位成功后的业务流程: 数据处理、缓存、城市、超时处理、回调队列
	         * @param ret 
	         * @param geoMethodType 
	         */
	
	    }, {
	        key: 'getPositionSuccess',
	        value: function getPositionSuccess(ret, geoMethodType) {
	            var _this3 = this;
	
	            // 策略检查 (阶段1)
	            if (!this.processOn()) return;
	
	            // 数据处理
	            ret.geoType || (ret.geoType = 'wgs84'); // 坐标系类型
	            ret.type || (ret.type = geoMethodType); // 定位API类型
	            // 缓存1: 经纬度
	            this.allowCache && _cache2.default.set(ret);
	
	            // 城市接口
	            this.needCity = this.needCity && (!ret.city || ret.city.cityType !== this.cityType);
	            var _cityStartTime = Date.now();
	            Promise.resolve(this.needCity && this.getCity(ret)).then(function (city) {
	                // 城市接口统计，与业务超时无关
	                city && (0, _log.Log)(_cityStartTime, true, null, 'city-' + _this3.cityType);
	                // 策略检查 (阶段2, 可能是异步)
	                if (!_this3.processOn()) return;
	                // 计时清零
	                clearTimeout(_this3.timer);
	                // 城市数据处理、缓存、上报
	                if (city) {
	                    try {
	                        ret.city = typeof city == 'string' && JSON.parse(city) || city;
	                        // 缓存2
	                        _this3.allowCache && _cache2.default.set(ret);
	                    } catch (e) {}
	                }
	                // 消费回调队列
	                _this3.isTimeout || _this3.execute(_this3.sucCallbackQueue, ret);
	            }).catch(function () {
	                var err = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	                // 计时清零
	                clearTimeout(_this3.timer);
	                // 城市接口成功率统计
	                (0, _log.Log)(_cityStartTime, err.code, null, 'city-' + _this3.cityType);
	                // 消费回调队列: 包装code、message传给调用方
	                _this3.isTimeout || _this3.execute(_this3.errorCallBackQueue, {
	                    code: 207,
	                    message: err.message
	                });
	            });
	
	            // debug
	            this.debug && alert(JSON.stringify(ret));
	            console.log('succ channel:' + geoMethodType);
	        }
	
	        /**
	         * 定位失败后的业务处理流程: 超时处理、回调队列
	         * @param err 
	         * @param geoMethodType 
	         */
	
	    }, {
	        key: 'getPositionError',
	        value: function getPositionError() {
	            var err = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	            var geoMethodType = arguments[1];
	
	            // 超时
	            if (this.isTimeout) return;
	            // 计时清零
	            clearTimeout(this.timer);
	            // 业务回调
	            this.execute(this.errorCallBackQueue, _extends(err, {
	                code: '205' // 默认状态码
	            }));
	        }
	
	        /**
	         * 根据`cityType`选取城市接口
	         * @param ret 定位结果
	         */
	
	    }, {
	        key: 'getCity',
	        value: function getCity(ret) {
	            var useMeituan = void 0;
	            if (this.cityType == DIANPING) {
	                useMeituan = false; // 显式设置优先于默认设置
	            } else if (this.cityType == MEITUAN || /.meituan.(com|net)$/.test(location.hostname)) {
	                this.cityType = MEITUAN;
	                useMeituan = true;
	            } else {
	                this.cityType = DIANPING; // 默认用`点评`
	            }
	            var method = useMeituan ? _mt2.default : _dp2.default;
	            return method(ret, {
	                token: Date.now(), // 暂时不做校验
	                timeout: this.apiTimeout
	            });
	        }
	
	        /**
	         * 消费回调队列 -> 收尾
	         * @param queue 
	         * @param args 
	         */
	
	    }, {
	        key: 'execute',
	        value: function execute(queue) {
	            for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	                args[_key - 1] = arguments[_key];
	            }
	
	            for (var i = 0, l = queue.length; i < l; i++) {
	                try {
	                    queue.shift().apply(null, args);
	                } catch (e) {}
	            }
	            this.endHandle();
	        }
	
	        /**
	         * 一次(批)调用最后一步: 清空回调队列，打开组件定位开关
	         */
	
	    }, {
	        key: 'endHandle',
	        value: function endHandle() {
	            this.isLocating = false;
	            this.sucCallbackQueue = [];
	            this.errorCallBackQueue = [];
	        }
	    }, {
	        key: 'isSpider',
	        value: function isSpider() {
	            return !!navigator.userAgent.match(/spider/i);
	        }
	    }, {
	        key: 'noop',
	        value: function noop() {}
	    }]);
	
	    return Whereami;
	}();
	
	var instance = new Whereami();
	
	module.exports = instance.action.bind(instance);
	module.exports.cache = _cache2.default.syncAPI;
	module.exports.url = _url2.default.syncAPI;
	module.exports.config = _config2.default.config;

/***/ }),
/* 479 */
/***/ (function(module, exports) {

	"use strict";
	
	var config = {
	    timeout: 10000,
	    disables: [],
	    enables: ["x5"],
	    urlParamNames: [], // custom
	    cacheType: "cookie",
	    cookieNames: ["locallat", "locallng"],
	    storageName: "whereami",
	    wxAutoConfig: false,
	    city: false,
	    source: "",
	    sampling: 0.5, // 自定义采样率，与source配合使用
	    debug: false
	};
	
	exports.get = function (key) {
	    return config[key];
	};
	
	exports.set = function (key, value) {
	    config[key] = value;
	};
	
	exports.config = function (obj) {
	    Object.keys(obj).forEach(function (key) {
	        config[key] = obj[key];
	    });
	};

/***/ }),
/* 480 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _config = __webpack_require__(479);
	
	var _config2 = _interopRequireDefault(_config);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var BASEURLPARAMGROUP = [["latitude", "longitude", "geotype"], // dp
	["lat", "lng", "geotype"] // mt
	];
	
	var URL = function () {
	    function URL() {
	        _classCallCheck(this, URL);
	
	        this.type = 'url';
	        this.keeper = undefined;
	        this.allowdCoordtype = ['wgs84', 'gcj02'];
	    }
	
	    _createClass(URL, [{
	        key: 'initData',
	        value: function initData() {
	            this.query = location.search;
	            this.urlParamGroup = [_config2.default.get('urlParamNames')].concat(BASEURLPARAMGROUP); // 自定义参数优先级高
	        }
	    }, {
	        key: 'syncProcess',
	        value: function syncProcess() {
	            this.initData();
	            return this.match(this.query, this.urlParamGroup);
	        }
	    }, {
	        key: 'process',
	        value: function process(succ, fail, next) {
	            var opt = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
	
	            // 预处理
	            typeof succ == 'function' || (succ = this.noop);
	            typeof fail == 'function' || (fail = this.noop);
	            typeof next == 'function' || (next = this.noop);
	
	            try {
	                this.initData();
	                var position = this.match(this.query, this.urlParamGroup);
	                if (!position) return next(); // 不匹配
	                succ(_extends({ type: this.type }, position), opt.token);
	            } catch (e) {
	                fail({
	                    code: 400,
	                    message: e && e.message || JSON.stringify(e),
	                    type: this.type
	                }, opt.token);
	            }
	        }
	    }, {
	        key: 'match',
	        value: function match(query, matchGroup) {
	            var result = void 0;
	            if (!query || !matchGroup) return result;
	            for (var i = 0; i < matchGroup.length; i++) {
	                if (!matchGroup[i].length) continue;
	                if (!matchGroup[i][0] || !matchGroup[i][1]) continue;
	                var latReg = new RegExp('[?&]' + matchGroup[i][0] + '=([^$&]+)'),
	                    lngReg = new RegExp('[?&]' + matchGroup[i][1] + '=([^$&]+)'),
	                    coordtypeReg = new RegExp('[?&]' + (matchGroup[i][2] || 'geotype') + '=([^$&]+)');
	                var latMatch = query.match(latReg),
	                    lngMatch = query.match(lngReg),
	                    coordtypeMatch = query.match(coordtypeReg);
	                if (latMatch && lngMatch && !isNaN(latMatch[1]) && !isNaN(lngMatch[1])) {
	                    result = {
	                        lat: latMatch[1],
	                        lng: lngMatch[1]
	                    };
	                    if (coordtypeMatch && ~this.allowdCoordtype.indexOf(coordtypeMatch[1])) {
	                        // url自定义经纬度、坐标系
	                        result.geoType = coordtypeMatch[1];
	                    } else if (/(dp\/com\.dianping)|(meituan)/.test(navigator.userAgent)) {
	                        // app 注入经纬度，默认坐标系
	                        result.geoType = /meituan/.test(navigator.userAgent) ? 'gcj02' : 'wgs84';
	                    }
	                    break;
	                }
	            }
	            return result;
	        }
	    }, {
	        key: 'noop',
	        value: function noop() {}
	    }]);
	
	    return URL;
	}();
	
	var instance = new URL();
	module.exports = instance.process.bind(instance);
	module.exports.syncAPI = instance.syncProcess.bind(instance);
	module.exports.type = instance.type;

/***/ }),
/* 481 */
/***/ (function(module, exports, __webpack_require__) {

	// 缓存策略(读/写): 内存 > cookie / localStorage
	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _cookie = __webpack_require__(482);
	
	var _cookie2 = _interopRequireDefault(_cookie);
	
	var _config = __webpack_require__(479);
	
	var _config2 = _interopRequireDefault(_config);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var COOKIE = 'cookie';
	var STORAGE = 'storage';
	var GEOTYPEKEY = 'geoType';
	
	var Cache = function () {
	    function Cache() {
	        _classCallCheck(this, Cache);
	
	        this.type = 'cache';
	        this.cacheDuration = 15 * 60 * 1000;
	        this.isSupportLS = this.supportLocalStorage();
	        this.positionMemory = {};
	    }
	
	    _createClass(Cache, [{
	        key: 'initData',
	        value: function initData() {
	            this.cacheType = _config2.default.get('cacheType');
	            this.disabled = !!~_config2.default.get('disables').indexOf('cache');
	            this.storageKey = _config2.default.get('storageName');
	            this.cookieKey = _config2.default.get('cookieNames');
	            this.isSupportCity = _config2.default.get('city');
	        }
	    }, {
	        key: 'process',
	        value: function process(succ, fail, next) {
	            var opt = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
	
	            // 预处理
	            typeof succ == 'function' || (succ = this.noop);
	            typeof fail == 'function' || (fail = this.noop);
	            typeof next == 'function' || (next = this.noop);
	
	            // API禁用逻辑在外层，此处不做冗余判断
	            // 数据初始化
	            this.initData();
	
	            // 组件：默认使用内存
	            var result = this.getFromMemory();
	            if (result) return succ(_extends(result, { type: this.type }), opt.token);
	
	            // 业务：指定缓存类型
	            if (this.cacheType == COOKIE) {
	                result = this.getFromCookie();
	            } else if (this.cacheType == STORAGE) {
	                result = this.getFromStorage();
	            } else {
	                return next(); // 不匹配
	            }
	            if (result) return succ(_extends(result, { type: this.type }), opt.token);
	            fail({
	                code: 412, // 未命中
	                type: this.type
	            }, opt.token);
	        }
	    }, {
	        key: 'syncProcess',
	        value: function syncProcess() {
	            this.initData();
	            if (this.disabled) return;
	            if (this.cacheType === COOKIE) {
	                return this.getFromCookie();
	            } else if (this.cacheType === STORAGE) {
	                return this.getFromStorage();
	            }
	        }
	    }, {
	        key: 'store',
	        value: function store() {
	            var position = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	            // 数据初始化
	            this.cacheType === undefined && this.initData();
	            if (this.disabled) return;
	
	            // 默认使用内存
	            _extends(this.positionMemory, position);
	            this.positionMemory.startTime = this.positionMemory.startTime || Date.now(); // 设置过期时间
	
	            // 来自Cache的数据不再存储
	            if (position.type == this.type) return;
	
	            // 校验
	            if (!this.validate(position)) return;
	
	            if (this.cacheType === COOKIE) {
	                this.storeCookie(position);
	            } else if (this.cacheType === STORAGE) {
	                this.storeLocalStorage(position);
	            }
	        }
	    }, {
	        key: 'getFromMemory',
	        value: function getFromMemory() {
	            // 校验
	            if (new Date() - (this.positionMemory.startTime || new Date()) < this.cacheDuration && this.validate(this.positionMemory)) {
	                return this.positionMemory;
	            }
	            return false;
	        }
	    }, {
	        key: 'getFromStorage',
	        value: function getFromStorage() {
	            if (!this.isSupportLS) return false;
	            var ret = localStorage.getItem(this.storageKey);
	            if (!ret) return false;
	            try {
	                ret = JSON.parse(ret);
	                typeof ret.city == 'string' && (ret.city = JSON.parse(ret.city));
	                if (new Date() - (ret.startTime || new Date()) < this.cacheDuration && this.validate(ret)) {
	                    return ret;
	                }
	                localStorage.removeItem(this.storageKey);
	                return false;
	            } catch (e) {
	                return false;
	            }
	        }
	    }, {
	        key: 'getFromCookie',
	        value: function getFromCookie() {
	            if (Object.prototype.toString.call(this.cookieKey) !== '[object Array]') return false;
	            var ret = {
	                lat: (0, _cookie2.default)(this.cookieKey[0]),
	                lng: (0, _cookie2.default)(this.cookieKey[1]),
	                geoType: (0, _cookie2.default)(GEOTYPEKEY) // 说明
	            };
	            if (!this.validate(ret)) return false;
	            var backup = this.isSupportCity && this.getFromStorage();
	            if (backup && backup.lat == ret.lat && backup.lng == ret.lng) {
	                return backup;
	            } else {
	                return ret;
	            }
	        }
	    }, {
	        key: 'validate',
	        value: function validate() {
	            var position = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	            if (parseFloat(position.lat) && parseFloat(position.lng)) {
	                return true;
	            }
	            return false;
	        }
	    }, {
	        key: 'storeCookie',
	        value: function storeCookie() {
	            var position = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	            position = _extends({}, position); // FIXME: 引用参数
	            if (Object.prototype.toString.call(this.cookieKey) !== '[object Array]') return;
	
	            var setting = {
	                expires: this.cacheDuration / 1000 / 3600 / 24,
	                path: '/',
	                domain: this.getCookieDomain()
	            };
	            (0, _cookie2.default)(this.cookieKey[0], position.lat, setting);
	            (0, _cookie2.default)(this.cookieKey[1], position.lng, setting);
	            (0, _cookie2.default)(GEOTYPEKEY, position.geoType, setting);
	
	            if (this.isSupportCity && position.city) {
	                /**
	                 * cookie不直接存储city信息 -> 1.非通用 2.数据重
	                 * 暂时用localStorage存储, key一致 -> 两种方式是互斥的, 不冲突
	                 */
	                position.city = JSON.stringify(position.city); // FIXME: 嵌套对象单独处理, 线上转义: 未知原因(xss?)
	                this.isSupportLS && localStorage.setItem(this.storageKey, JSON.stringify(position)); // 不再设置过期时间
	            }
	        }
	    }, {
	        key: 'storeLocalStorage',
	        value: function storeLocalStorage() {
	            var position = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	            if (!this.isSupportLS) return;
	
	            var ret = _extends({}, position);
	            ret.startTime = +new Date();
	            localStorage.setItem(this.storageKey, JSON.stringify(ret));
	        }
	    }, {
	        key: 'supportLocalStorage',
	        value: function supportLocalStorage() {
	            // iphone safari 无痕模式下设置localStorage时候会抛异常
	            var testKey = 'local_test';
	            try {
	                localStorage.setItem(testKey, 1);
	                localStorage.removeItem(testKey);
	            } catch (e) {
	                return false;
	            }
	            return true;
	        }
	    }, {
	        key: 'getCookieDomain',
	        value: function getCookieDomain() {
	            // TODO: .meituan.com .meituan.net域名
	            var hostname = location.hostname;
	            if (/.*\.51ping\.com$/.test(hostname)) {
	                return '.51ping.com';
	            } else if (/.*\.dianping\.com$/.test(hostname)) {
	                return '.dianping.com';
	            } else {
	                return hostname;
	            }
	        }
	    }, {
	        key: 'noop',
	        value: function noop() {}
	    }]);
	
	    return Cache;
	}();
	
	var instance = new Cache();
	
	module.exports = instance.process.bind(instance);
	module.exports.set = instance.store.bind(instance);
	module.exports.syncAPI = instance.syncProcess.bind(instance);
	module.exports.type = instance.type;

/***/ }),
/* 482 */
/***/ (function(module, exports) {

	'use strict';
	
	/*!
	 * refer  jquery.cookie
	 * https://github.com/carhartl/jquery-cookie
	 *
	 */
	var isFunction = function isFunction(obj) {
	    return Object.prototype.toString.call(obj) == '[object Function]';
	};
	var extend = function extend(obj) {
	    Array.prototype.slice.call(arguments, 1).forEach(function (source) {
	        if (source) {
	            for (var prop in source) {
	                obj[prop] = source[prop];
	            }
	        }
	    });
	    return obj;
	};
	
	var pluses = /\+/g;
	
	function encode(s) {
	    return config.raw ? s : encodeURIComponent(s);
	}
	
	function decode(s) {
	    return config.raw ? s : decodeURIComponent(s);
	}
	
	function stringifyCookieValue(value) {
	    return encode(config.json ? JSON.stringify(value) : String(value));
	}
	
	function parseCookieValue(s) {
	    if (s.indexOf('"') === 0) {
	        // This is a quoted cookie as according to RFC2068, unescape...
	        s = s.slice(1, -1).replace(/\\"/g, '"').replace(/\\\\/g, '\\');
	    }
	
	    try {
	        // Replace server-side written pluses with spaces.
	        // If we can't decode the cookie, ignore it, it's unusable.
	        // If we can't parse the cookie, ignore it, it's unusable.
	        s = decodeURIComponent(s.replace(pluses, ' '));
	        return config.json ? JSON.parse(s) : s;
	    } catch (e) {}
	}
	
	function read(s, converter) {
	    var value = config.raw ? s : parseCookieValue(s);
	    return isFunction(converter) ? converter(value) : value;
	}
	
	var cookie, config, removeCookie;
	
	config = cookie = function cookie(key, value, options) {
	
	    // Write
	
	    if (value !== undefined && !isFunction(value)) {
	        options = extend({}, config.defaults, options);
	
	        if (typeof options.expires === 'number') {
	            var days = options.expires,
	                t = options.expires = new Date();
	            t.setTime(+t + days * 864e+5);
	        }
	
	        return document.cookie = [encode(key), '=', stringifyCookieValue(value), options.expires ? '; expires=' + options.expires.toUTCString() : '', // use expires attribute, max-age is not supported by IE
	        options.path ? '; path=' + options.path : '', options.domain ? '; domain=' + options.domain : '', options.secure ? '; secure' : ''].join('');
	    }
	
	    // Read
	
	    var result = key ? undefined : {};
	
	    // To prevent the for loop in the first place assign an empty array
	    // in case there are no cookies at all. Also prevents odd result when
	    // calling $.cookie().
	    var cookies = document.cookie ? document.cookie.split('; ') : [];
	
	    for (var i = 0, l = cookies.length; i < l; i++) {
	        var parts = cookies[i].split('=');
	        var name = decode(parts.shift());
	        var cookie = parts.join('=');
	
	        if (key && key === name) {
	            // If second argument (value) is a function it's a converter...
	            result = read(cookie, value);
	            break;
	        }
	
	        // Prevent storing a cookie that we couldn't decode.
	        if (!key && (cookie = read(cookie)) !== undefined) {
	            result[name] = cookie;
	        }
	    }
	
	    return result;
	};
	
	config.defaults = {};
	
	removeCookie = function removeCookie(key, options) {
	    if (cookie(key) === undefined) {
	        return false;
	    }
	
	    // Must not alter options, thus extending a fresh object...
	    cookie(key, '', extend({}, options, { expires: -1 }));
	    return !cookie(key);
	};
	cookie.remove = removeCookie;
	module.exports = cookie;

/***/ }),
/* 483 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _request = __webpack_require__(484);
	
	var _request2 = _interopRequireDefault(_request);
	
	var _keeper = __webpack_require__(485);
	
	var _keeper2 = _interopRequireDefault(_keeper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Promise = window.Promise || __webpack_require__(486);
	
	var DPcity = function () {
	    function DPcity() {
	        _classCallCheck(this, DPcity);
	
	        this.cityType = 'dianping';
	        this.GEOTYPE = ['wgs84', 'gcj02']; // map coordType: 1, 2
	        this.keeper = undefined;
	    }
	
	    _createClass(DPcity, [{
	        key: 'process',
	        value: function process() {
	            var _this = this;
	
	            var position = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	            var opt = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	            // TODO: 城市超时缓存，目前被`promise`直接丢弃了
	            return new Promise(function (resolve, reject) {
	                // 说明：若超时未开启，最差情况：无thenable对象返回，不影响业务整体超时失败，只丢掉一次城市API失败上报
	                opt.trigger = function (token) {
	                    reject({
	                        // code: 408,
	                        message: _this.cityType + ' city API Timeout: ' + opt.timeout + 'ms',
	                        type: _this.type
	                    });
	                };
	                _this.keeper = new _keeper2.default(opt);
	
	                (0, _request2.default)({
	                    url: "//mapi.dianping.com/getlocalcityid",
	                    data: {
	                        lat: position.lat,
	                        lng: position.lng,
	                        coordType: _this.GEOTYPE.indexOf(position.geoType.toLowerCase()) + 1 || 1
	                    },
	                    onSuc: function onSuc() {
	                        var res = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	                        if (res.code == 200 && res.message) {
	                            res.message.cityType = _this.cityType;
	                            resolve(res.message);
	                        } else {
	                            reject({
	                                message: _this.cityType + ' city API: fail'
	                            });
	                        }
	                    }
	                });
	            });
	        }
	    }]);
	
	    return DPcity;
	}();
	
	var instance = new DPcity();
	module.exports = instance.process.bind(instance);

/***/ }),
/* 484 */
/***/ (function(module, exports) {

	"use strict";
	
	var globalCount = 0;
	
	var urlStringify = function urlStringify(url, data) {
	    if (!data) {
	        return url;
	    }
	    var param = [];
	    for (var o in data) {
	        if (data.hasOwnProperty(o)) {
	            param.push(o + "=" + data[o]);
	        }
	    }
	    return ~url.indexOf("?") ? url + '&' + param.join("&") : url + "?" + param.join("&");
	};
	
	/**
	 * jsonp
	 * */
	module.exports = function (options) {
	
	    if (!options.url) {
	        throw new Error("url request!");
	    }
	    var data = options.data || {};
	    var cb = options.onSuc || function () {};
	    var cbName = data.callback = "WhereAmI" + ++globalCount + +new Date();
	
	    var script = document.createElement("script");
	    script.src = urlStringify(options.url, data);
	
	    window[cbName] = function (res) {
	        delete window[cbName];
	        script.parentNode.removeChild(script);
	        cb(res);
	    };
	
	    document.getElementsByTagName("head")[0].appendChild(script);
	};

/***/ }),
/* 485 */
/***/ (function(module, exports) {

	'use strict';
	/**
	 * API 调用过程中的 Token Keeper:
	 * token: 某次调用的timestamp, token 阅后即焚 -> 保证不重复调用
	 * timeout: API超时 -> token 失效
	 * trigger: 超时回调
	 */
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Keeper = function () {
	    function Keeper() {
	        var _this = this;
	
	        var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : opt,
	            type = _ref.type,
	            token = _ref.token,
	            timeout = _ref.timeout,
	            trigger = _ref.trigger;
	
	        _classCallCheck(this, Keeper);
	
	        this.token = token;
	        if (token && parseInt(timeout)) {
	            this._timeout = setTimeout(function () {
	                typeof trigger == 'function' && trigger(_this.token);
	                _this.token = null;
	            }, timeout);
	        }
	    }
	
	    _createClass(Keeper, [{
	        key: 'getToken',
	        value: function getToken() {
	            var ret = this.token;
	            if (!ret) return ret; // 计时器结束/token被读过了
	            clearTimeout(this._timeout); // 结束计时
	            this.token = null; // 销毁
	            return ret;
	        }
	    }]);
	
	    return Keeper;
	}();
	
	exports.default = Keeper;

/***/ }),
/* 486 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(487)


/***/ }),
/* 487 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(488);
	__webpack_require__(489);
	__webpack_require__(490);
	__webpack_require__(491);
	__webpack_require__(492);
	__webpack_require__(493);


/***/ }),
/* 488 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var asap = __webpack_require__(306);
	
	function noop() {}
	
	// States:
	//
	// 0 - pending
	// 1 - fulfilled with _value
	// 2 - rejected with _value
	// 3 - adopted the state of another promise, _value
	//
	// once the state is no longer pending (0) it is immutable
	
	// All `_` prefixed properties will be reduced to `_{random number}`
	// at build time to obfuscate them and discourage their use.
	// We don't use symbols or Object.defineProperty to fully hide them
	// because the performance isn't good enough.
	
	
	// to avoid using try/catch inside critical functions, we
	// extract them to here.
	var LAST_ERROR = null;
	var IS_ERROR = {};
	function getThen(obj) {
	  try {
	    return obj.then;
	  } catch (ex) {
	    LAST_ERROR = ex;
	    return IS_ERROR;
	  }
	}
	
	function tryCallOne(fn, a) {
	  try {
	    return fn(a);
	  } catch (ex) {
	    LAST_ERROR = ex;
	    return IS_ERROR;
	  }
	}
	function tryCallTwo(fn, a, b) {
	  try {
	    fn(a, b);
	  } catch (ex) {
	    LAST_ERROR = ex;
	    return IS_ERROR;
	  }
	}
	
	module.exports = Promise;
	
	function Promise(fn) {
	  if (typeof this !== 'object') {
	    throw new TypeError('Promises must be constructed via new');
	  }
	  if (typeof fn !== 'function') {
	    throw new TypeError('Promise constructor\'s argument is not a function');
	  }
	  this._75 = 0;
	  this._83 = 0;
	  this._18 = null;
	  this._38 = null;
	  if (fn === noop) return;
	  doResolve(fn, this);
	}
	Promise._47 = null;
	Promise._71 = null;
	Promise._44 = noop;
	
	Promise.prototype.then = function(onFulfilled, onRejected) {
	  if (this.constructor !== Promise) {
	    return safeThen(this, onFulfilled, onRejected);
	  }
	  var res = new Promise(noop);
	  handle(this, new Handler(onFulfilled, onRejected, res));
	  return res;
	};
	
	function safeThen(self, onFulfilled, onRejected) {
	  return new self.constructor(function (resolve, reject) {
	    var res = new Promise(noop);
	    res.then(resolve, reject);
	    handle(self, new Handler(onFulfilled, onRejected, res));
	  });
	}
	function handle(self, deferred) {
	  while (self._83 === 3) {
	    self = self._18;
	  }
	  if (Promise._47) {
	    Promise._47(self);
	  }
	  if (self._83 === 0) {
	    if (self._75 === 0) {
	      self._75 = 1;
	      self._38 = deferred;
	      return;
	    }
	    if (self._75 === 1) {
	      self._75 = 2;
	      self._38 = [self._38, deferred];
	      return;
	    }
	    self._38.push(deferred);
	    return;
	  }
	  handleResolved(self, deferred);
	}
	
	function handleResolved(self, deferred) {
	  asap(function() {
	    var cb = self._83 === 1 ? deferred.onFulfilled : deferred.onRejected;
	    if (cb === null) {
	      if (self._83 === 1) {
	        resolve(deferred.promise, self._18);
	      } else {
	        reject(deferred.promise, self._18);
	      }
	      return;
	    }
	    var ret = tryCallOne(cb, self._18);
	    if (ret === IS_ERROR) {
	      reject(deferred.promise, LAST_ERROR);
	    } else {
	      resolve(deferred.promise, ret);
	    }
	  });
	}
	function resolve(self, newValue) {
	  // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
	  if (newValue === self) {
	    return reject(
	      self,
	      new TypeError('A promise cannot be resolved with itself.')
	    );
	  }
	  if (
	    newValue &&
	    (typeof newValue === 'object' || typeof newValue === 'function')
	  ) {
	    var then = getThen(newValue);
	    if (then === IS_ERROR) {
	      return reject(self, LAST_ERROR);
	    }
	    if (
	      then === self.then &&
	      newValue instanceof Promise
	    ) {
	      self._83 = 3;
	      self._18 = newValue;
	      finale(self);
	      return;
	    } else if (typeof then === 'function') {
	      doResolve(then.bind(newValue), self);
	      return;
	    }
	  }
	  self._83 = 1;
	  self._18 = newValue;
	  finale(self);
	}
	
	function reject(self, newValue) {
	  self._83 = 2;
	  self._18 = newValue;
	  if (Promise._71) {
	    Promise._71(self, newValue);
	  }
	  finale(self);
	}
	function finale(self) {
	  if (self._75 === 1) {
	    handle(self, self._38);
	    self._38 = null;
	  }
	  if (self._75 === 2) {
	    for (var i = 0; i < self._38.length; i++) {
	      handle(self, self._38[i]);
	    }
	    self._38 = null;
	  }
	}
	
	function Handler(onFulfilled, onRejected, promise){
	  this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
	  this.onRejected = typeof onRejected === 'function' ? onRejected : null;
	  this.promise = promise;
	}
	
	/**
	 * Take a potentially misbehaving resolver function and make sure
	 * onFulfilled and onRejected are only called once.
	 *
	 * Makes no guarantees about asynchrony.
	 */
	function doResolve(fn, promise) {
	  var done = false;
	  var res = tryCallTwo(fn, function (value) {
	    if (done) return;
	    done = true;
	    resolve(promise, value);
	  }, function (reason) {
	    if (done) return;
	    done = true;
	    reject(promise, reason);
	  });
	  if (!done && res === IS_ERROR) {
	    done = true;
	    reject(promise, LAST_ERROR);
	  }
	}


/***/ }),
/* 489 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var Promise = __webpack_require__(488);
	
	module.exports = Promise;
	Promise.prototype.done = function (onFulfilled, onRejected) {
	  var self = arguments.length ? this.then.apply(this, arguments) : this;
	  self.then(null, function (err) {
	    setTimeout(function () {
	      throw err;
	    }, 0);
	  });
	};


/***/ }),
/* 490 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var Promise = __webpack_require__(488);
	
	module.exports = Promise;
	Promise.prototype['finally'] = function (f) {
	  return this.then(function (value) {
	    return Promise.resolve(f()).then(function () {
	      return value;
	    });
	  }, function (err) {
	    return Promise.resolve(f()).then(function () {
	      throw err;
	    });
	  });
	};


/***/ }),
/* 491 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	//This file contains the ES6 extensions to the core Promises/A+ API
	
	var Promise = __webpack_require__(488);
	
	module.exports = Promise;
	
	/* Static Functions */
	
	var TRUE = valuePromise(true);
	var FALSE = valuePromise(false);
	var NULL = valuePromise(null);
	var UNDEFINED = valuePromise(undefined);
	var ZERO = valuePromise(0);
	var EMPTYSTRING = valuePromise('');
	
	function valuePromise(value) {
	  var p = new Promise(Promise._44);
	  p._83 = 1;
	  p._18 = value;
	  return p;
	}
	Promise.resolve = function (value) {
	  if (value instanceof Promise) return value;
	
	  if (value === null) return NULL;
	  if (value === undefined) return UNDEFINED;
	  if (value === true) return TRUE;
	  if (value === false) return FALSE;
	  if (value === 0) return ZERO;
	  if (value === '') return EMPTYSTRING;
	
	  if (typeof value === 'object' || typeof value === 'function') {
	    try {
	      var then = value.then;
	      if (typeof then === 'function') {
	        return new Promise(then.bind(value));
	      }
	    } catch (ex) {
	      return new Promise(function (resolve, reject) {
	        reject(ex);
	      });
	    }
	  }
	  return valuePromise(value);
	};
	
	Promise.all = function (arr) {
	  var args = Array.prototype.slice.call(arr);
	
	  return new Promise(function (resolve, reject) {
	    if (args.length === 0) return resolve([]);
	    var remaining = args.length;
	    function res(i, val) {
	      if (val && (typeof val === 'object' || typeof val === 'function')) {
	        if (val instanceof Promise && val.then === Promise.prototype.then) {
	          while (val._83 === 3) {
	            val = val._18;
	          }
	          if (val._83 === 1) return res(i, val._18);
	          if (val._83 === 2) reject(val._18);
	          val.then(function (val) {
	            res(i, val);
	          }, reject);
	          return;
	        } else {
	          var then = val.then;
	          if (typeof then === 'function') {
	            var p = new Promise(then.bind(val));
	            p.then(function (val) {
	              res(i, val);
	            }, reject);
	            return;
	          }
	        }
	      }
	      args[i] = val;
	      if (--remaining === 0) {
	        resolve(args);
	      }
	    }
	    for (var i = 0; i < args.length; i++) {
	      res(i, args[i]);
	    }
	  });
	};
	
	Promise.reject = function (value) {
	  return new Promise(function (resolve, reject) {
	    reject(value);
	  });
	};
	
	Promise.race = function (values) {
	  return new Promise(function (resolve, reject) {
	    values.forEach(function(value){
	      Promise.resolve(value).then(resolve, reject);
	    });
	  });
	};
	
	/* Prototype Methods */
	
	Promise.prototype['catch'] = function (onRejected) {
	  return this.then(null, onRejected);
	};


/***/ }),
/* 492 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	// This file contains then/promise specific extensions that are only useful
	// for node.js interop
	
	var Promise = __webpack_require__(488);
	var asap = __webpack_require__(311);
	
	module.exports = Promise;
	
	/* Static Functions */
	
	Promise.denodeify = function (fn, argumentCount) {
	  if (
	    typeof argumentCount === 'number' && argumentCount !== Infinity
	  ) {
	    return denodeifyWithCount(fn, argumentCount);
	  } else {
	    return denodeifyWithoutCount(fn);
	  }
	};
	
	var callbackFn = (
	  'function (err, res) {' +
	  'if (err) { rj(err); } else { rs(res); }' +
	  '}'
	);
	function denodeifyWithCount(fn, argumentCount) {
	  var args = [];
	  for (var i = 0; i < argumentCount; i++) {
	    args.push('a' + i);
	  }
	  var body = [
	    'return function (' + args.join(',') + ') {',
	    'var self = this;',
	    'return new Promise(function (rs, rj) {',
	    'var res = fn.call(',
	    ['self'].concat(args).concat([callbackFn]).join(','),
	    ');',
	    'if (res &&',
	    '(typeof res === "object" || typeof res === "function") &&',
	    'typeof res.then === "function"',
	    ') {rs(res);}',
	    '});',
	    '};'
	  ].join('');
	  return Function(['Promise', 'fn'], body)(Promise, fn);
	}
	function denodeifyWithoutCount(fn) {
	  var fnLength = Math.max(fn.length - 1, 3);
	  var args = [];
	  for (var i = 0; i < fnLength; i++) {
	    args.push('a' + i);
	  }
	  var body = [
	    'return function (' + args.join(',') + ') {',
	    'var self = this;',
	    'var args;',
	    'var argLength = arguments.length;',
	    'if (arguments.length > ' + fnLength + ') {',
	    'args = new Array(arguments.length + 1);',
	    'for (var i = 0; i < arguments.length; i++) {',
	    'args[i] = arguments[i];',
	    '}',
	    '}',
	    'return new Promise(function (rs, rj) {',
	    'var cb = ' + callbackFn + ';',
	    'var res;',
	    'switch (argLength) {',
	    args.concat(['extra']).map(function (_, index) {
	      return (
	        'case ' + (index) + ':' +
	        'res = fn.call(' + ['self'].concat(args.slice(0, index)).concat('cb').join(',') + ');' +
	        'break;'
	      );
	    }).join(''),
	    'default:',
	    'args[argLength] = cb;',
	    'res = fn.apply(self, args);',
	    '}',
	    
	    'if (res &&',
	    '(typeof res === "object" || typeof res === "function") &&',
	    'typeof res.then === "function"',
	    ') {rs(res);}',
	    '});',
	    '};'
	  ].join('');
	
	  return Function(
	    ['Promise', 'fn'],
	    body
	  )(Promise, fn);
	}
	
	Promise.nodeify = function (fn) {
	  return function () {
	    var args = Array.prototype.slice.call(arguments);
	    var callback =
	      typeof args[args.length - 1] === 'function' ? args.pop() : null;
	    var ctx = this;
	    try {
	      return fn.apply(this, arguments).nodeify(callback, ctx);
	    } catch (ex) {
	      if (callback === null || typeof callback == 'undefined') {
	        return new Promise(function (resolve, reject) {
	          reject(ex);
	        });
	      } else {
	        asap(function () {
	          callback.call(ctx, ex);
	        })
	      }
	    }
	  }
	};
	
	Promise.prototype.nodeify = function (callback, ctx) {
	  if (typeof callback != 'function') return this;
	
	  this.then(function (value) {
	    asap(function () {
	      callback.call(ctx, null, value);
	    });
	  }, function (err) {
	    asap(function () {
	      callback.call(ctx, err);
	    });
	  });
	};


/***/ }),
/* 493 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var Promise = __webpack_require__(488);
	
	module.exports = Promise;
	Promise.enableSynchronous = function () {
	  Promise.prototype.isPending = function() {
	    return this.getState() == 0;
	  };
	
	  Promise.prototype.isFulfilled = function() {
	    return this.getState() == 1;
	  };
	
	  Promise.prototype.isRejected = function() {
	    return this.getState() == 2;
	  };
	
	  Promise.prototype.getValue = function () {
	    if (this._83 === 3) {
	      return this._18.getValue();
	    }
	
	    if (!this.isFulfilled()) {
	      throw new Error('Cannot get a value of an unfulfilled promise.');
	    }
	
	    return this._18;
	  };
	
	  Promise.prototype.getReason = function () {
	    if (this._83 === 3) {
	      return this._18.getReason();
	    }
	
	    if (!this.isRejected()) {
	      throw new Error('Cannot get a rejection reason of a non-rejected promise.');
	    }
	
	    return this._18;
	  };
	
	  Promise.prototype.getState = function () {
	    if (this._83 === 3) {
	      return this._18.getState();
	    }
	    if (this._83 === -1 || this._83 === -2) {
	      return 0;
	    }
	
	    return this._83;
	  };
	};
	
	Promise.disableSynchronous = function() {
	  Promise.prototype.isPending = undefined;
	  Promise.prototype.isFulfilled = undefined;
	  Promise.prototype.isRejected = undefined;
	  Promise.prototype.getValue = undefined;
	  Promise.prototype.getReason = undefined;
	  Promise.prototype.getState = undefined;
	};


/***/ }),
/* 494 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _request = __webpack_require__(484);
	
	var _request2 = _interopRequireDefault(_request);
	
	var _keeper = __webpack_require__(485);
	
	var _keeper2 = _interopRequireDefault(_keeper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Promise = window.Promise || __webpack_require__(486);
	
	var MTcity = function () {
	    function MTcity() {
	        _classCallCheck(this, MTcity);
	
	        this.cityType = 'meituan';
	        this.GEOTYPE = ['wgs84', 'gcj02'];
	        this.keeper = undefined;
	    }
	
	    _createClass(MTcity, [{
	        key: 'process',
	        value: function process() {
	            var _this = this;
	
	            var position = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	            var opt = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	            var coordType = this.GEOTYPE.indexOf(position.geoType.toLowerCase());
	            var url = location.protocol == 'https:' ? '//apimobile.meituan.com/group/v1/city/latlng/' : '//api.mobile.meituan.com/group/v1/city/latlng/';
	
	            return new Promise(function (resolve, reject) {
	                opt.trigger = function (token) {
	                    reject({
	                        // code: 408,
	                        message: _this.cityType + ' city API Timeout: ' + opt.timeout + 'ms',
	                        type: _this.type
	                    });
	                };
	                _this.keeper = new _keeper2.default(opt);
	
	                (0, _request2.default)({
	                    url: url + position.lat + ',' + position.lng,
	                    data: {
	                        tag: ~coordType ? coordType : 0
	                    },
	                    onSuc: function onSuc() {
	                        var res = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	                        if (res.data) {
	                            var city = {
	                                cityType: 'meituan',
	                                cityid: res.data.id,
	                                cityname: res.data.city
	                            };
	                            resolve(city);
	                        } else {
	                            reject({
	                                message: _this.cityType + ' city API: fail'
	                            });
	                        }
	                    }
	                });
	            });
	        }
	    }]);
	
	    return MTcity;
	}();
	
	var instance = new MTcity();
	module.exports = instance.process.bind(instance);

/***/ }),
/* 495 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _config = __webpack_require__(479);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _cookie = __webpack_require__(482);
	
	var _cookie2 = _interopRequireDefault(_cookie);
	
	var _xhr = __webpack_require__(496);
	
	var _xhr2 = _interopRequireDefault(_xhr);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var PROJECTNAME = 'whereami';
	var BASESAMPLE = 0.5; // 组件内置的日志上报率
	var FILTERCODE = [201, 409, 416]; // 需要过滤的code
	
	var Log = function () {
	    function Log() {
	        _classCallCheck(this, Log);
	
	        this.stack = []; // 初始化Log栈队列(异步模式下暂存日志对象)
	        this.initSDK();
	        this.debug = /debug/i.test(location.search);
	
	        /**
	         * 组件级tag, `清洗`脏数据
	         * `new`: v2.0.5 - v2.0.7
	         * `stage`: v2.0.8 - latest
	         */
	        this.defaultTag = 'stage';
	
	        this.normalPrefix = 'whereami-type-' + (this.debug ? 'debug-' : '');
	        this.errorPrefix = 'whereami-fail-' + (this.debug ? 'debug-' : '');
	    }
	
	    _createClass(Log, [{
	        key: 'initSDK',
	        value: function initSDK() {
	            var _this = this;
	
	            var Owl = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window.Owl;
	
	            if (!Owl) {
	                // 异步加载npm版本owl
	                return __webpack_require__.e/* nsure */(2, function () {
	                    _this.debug && console.log('load owl async');
	                    Owl = __webpack_require__(497);
	                    _this.initSDK(Owl);
	                    _this.dispatch();
	                });
	            }
	            this.owl = new Owl.OWL({
	                devMode: /51ping.com/i.test(location.hostname),
	                project: PROJECTNAME,
	                resource: {
	                    sampleApi: 1 // 说明：实际采样率由`this.sampleValid`控制
	                }
	            });
	        }
	    }, {
	        key: 'initData',
	        value: function initData() {
	            var opt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	            this.stack = [];
	            this.source = _config2.default.get('source').trim();
	            this.sample = _config2.default.get('sampling');
	            opt.normalPrefix && (this.normalPrefix = opt.normalPrefix);
	            opt.errorPrefix && (this.errorPrefix = opt.errorPrefix);
	            // 上报率控制阀：针对一次完整调用
	            this.random = Math.random();
	            this.sampleValid = this.randomSample(BASESAMPLE); // 组件级开关，上报率内置
	            this.customSampleValid = !!this.source && this.randomSample(this.sample); // 自定义业务开关
	        }
	    }, {
	        key: 'dispatch',
	        value: function dispatch() {
	            var _this2 = this;
	
	            this.stack.map(function (log) {
	                if (log.type == 'err') {
	                    _this2.logError.apply(_this2, log.params);
	                } else {
	                    _this2.log.apply(_this2, log.params);
	                }
	            });
	        }
	        /**
	         * API上报: 渠道成功率
	         * @param {*} startTime 
	         * @param {*} isSuccess 
	         * @param {*} type 
	         * @param {*} name 
	         * @param {*} endTime 
	         */
	
	    }, {
	        key: 'log',
	        value: function log() {
	            var startTime = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new Date();
	            var code = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 500;
	            var type = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'all';
	            var name = arguments[3];
	            var endTime = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : Date.now();
	
	            if (!!~FILTERCODE.indexOf(code) || !(this.sampleValid || this.customSampleValid)) return;
	            name = name || this.normalPrefix + type; // 默认用渠道名, 接受自定义(某些特殊的地方，组件级)
	            if (!this.owl) {
	                // stack
	                return this.stack.push({
	                    params: [startTime, code, type, name, endTime] // 手动填充: 新增endTime，并向前兼容
	                });
	            }
	            code = code == true ? 200 : code == false ? 500 : code; // 状态码：向前兼容
	            // 组件统计
	            this.sampleValid && this.owl.addApi({
	                name: this.withTag(name, this.defaultTag),
	                statusCode: code,
	                responseTime: endTime - startTime // 时间
	            });
	            // 业务统计
	            this.customSampleValid && this.owl.addApi({
	                name: this.withTag(name, this.source),
	                statusCode: code,
	                responseTime: endTime - startTime
	            });
	        }
	        /**
	         * 错误详情上报
	         * @param {*} err 
	         * @param {*} type 
	         * @param {*} name 
	         */
	
	    }, {
	        key: 'logError',
	        value: function logError() {
	            var err = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	            var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'all';
	            var name = arguments[2];
	
	            if (!this.sampleValid && !this.customSampleValid) return; // v2.1 开始与`log`同比采样
	            name = name || this.errorPrefix + type;
	            if (!this.owl) {
	                // stack
	                return this.stack.push({
	                    type: 'err',
	                    params: arguments
	                });
	            }
	            // 组件统计
	            this.sampleValid && this.owl.addError({
	                name: this.withTag(name, this.defaultTag),
	                msg: err.message
	            });
	            // TEST: 业务统计
	            // this.customSampleValid && this.owl.addError({
	            //     name: this.withTag(this.errorPrefix + type, this.source),
	            //     msg: err.message
	            // })
	        }
	        /**
	         * 定位成功结果上报（统计服务）: 与SDK无关
	         * @param {*} startTime 
	         * @param {*} position 
	         */
	
	    }, {
	        key: 'logService',
	        value: function logService() {
	            var startTime = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new Date();
	            var position = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	            var data = {
	                model: 'h5',
	                reqid: 1, // 请求的ID
	                lastloc: {
	                    accu: -1, // 误差半径
	                    age: new Date() - startTime,
	                    lat: position.lat,
	                    lon: position.lng,
	                    coordtype: /wgs84/i.test(position.geoType) ? 0 : 1
	                },
	                version: '2.1.0', // 固定值
	                address_language: '',
	                appname: 'whereami',
	                request_address: true,
	                auth_key: 'GY7A10rxJfxi066yuEppbAJBSruNp6xt', // 授权码
	                osver: '', // 系统版本号
	                nettype: 'Mobile',
	                deviceid: (0, _cookie2.default)('_hc.v')
	            };
	            (0, _xhr2.default)('//apimobile.meituan.com/locate/v2/sdk/loc?ci=whereami', [{
	                name: 'Content-Type',
	                value: 'application/json'
	            }], data, function (e) {});
	        }
	    }, {
	        key: 'randomSample',
	        value: function randomSample(threshold) {
	            if ((this.random || Math.random()) < threshold) {
	                return true;
	            }
	            return false;
	        }
	    }, {
	        key: 'withTag',
	        value: function withTag(origin, tag) {
	            var split = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '-';
	
	            if (!tag) return origin;
	            if (!origin) return;
	            return origin + split + tag;
	        }
	    }]);
	
	    return Log;
	}();
	
	var instance = new Log();
	
	module.exports.Log = instance.log.bind(instance);
	module.exports.LogError = instance.logError.bind(instance);
	module.exports.LogClean = instance.initData.bind(instance);
	
	module.exports.LogService = instance.logService.bind(instance);

/***/ }),
/* 496 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = function (url) {
	    var header = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
	    var data = arguments[2];
	    var callback = arguments[3];
	
	    if (!url) return;
	    typeof callback == 'function' || (callback = noop);
	
	    var xhr = new XMLHttpRequest();
	
	    xhr.open('POST', url);
	    if (typeof xhr.setRequestHeader == 'function' && header.length) {
	        header.map(function (item) {
	            xhr.setRequestHeader(item.name, item.value);
	        });
	    } else {}
	    xhr.send(JSON.stringify(data));
	    _addListener(xhr, 'loadend', callback); // FIXME: 结果由业务处理，组件只保证触发回调
	};
	
	function noop() {}
	
	function _addListener(target, event, callback) {
	    if (target && event) {
	        if (addEventListener) {
	            target.addEventListener(event, function (e) {
	                typeof callback == 'function' && callback(e);
	            });
	        } else if (attachEvent) {
	            // 兼容IE
	            target.attachEvent('on' + event, function (e) {
	                typeof callback == 'function' && callback(e);
	            });
	        } else {}
	    }
	}

/***/ }),
/* 497 */,
/* 498 */,
/* 499 */,
/* 500 */,
/* 501 */,
/* 502 */,
/* 503 */,
/* 504 */,
/* 505 */,
/* 506 */,
/* 507 */,
/* 508 */,
/* 509 */,
/* 510 */,
/* 511 */,
/* 512 */,
/* 513 */,
/* 514 */,
/* 515 */,
/* 516 */,
/* 517 */,
/* 518 */,
/* 519 */,
/* 520 */,
/* 521 */,
/* 522 */,
/* 523 */,
/* 524 */,
/* 525 */,
/* 526 */,
/* 527 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _keeper = __webpack_require__(485);
	
	var _keeper2 = _interopRequireDefault(_keeper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Promise = window.Promise || __webpack_require__(486);
	var KNB = window.KNB;
	
	var App = function () {
	    function App() {
	        _classCallCheck(this, App);
	
	        this.type = 'app'; // 收归`dianping`、`meituan`，CAT中请用容器区分
	        this.GEOTYPE = ['wgs84', 'gcj02'];
	        this.keeper = undefined;
	    }
	
	    _createClass(App, [{
	        key: 'process',
	        value: function process(succ, fail, next) {
	            var _this = this;
	
	            var opt = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
	
	            // 预处理
	            typeof succ == 'function' || (succ = this.noop);
	            typeof fail == 'function' || (fail = this.noop);
	            typeof next == 'function' || (next = this.noop);
	
	            if (!this.supportGeo()) return next();
	            opt.trigger = function (token) {
	                fail({
	                    // code: 408, // 说明：定位超时放弃兜底方案，与API超时结果处理一致
	                    message: _this.type + ' API Timeout:' + opt.timeout + 'ms',
	                    type: _this.type
	                }, token);
	            };
	            this.keeper = new _keeper2.default(opt);
	
	            Promise.resolve(KNB || this.initSDK()).then(function () {
	                KNB.ready(function () {
	                    var KNBP = KNB.getPromiseInstance();
	                    KNBP.isApiSupported({
	                        apiName: 'getLocation'
	                    }).then(function (isSupported) {
	                        if (isSupported) {
	                            return KNBP.getLocation({
	                                timeout: opt.timeout / 1000,
	                                cache: false
	                            });
	                        } else {
	                            fail({
	                                code: 412, // API不支持走兜底方案
	                                type: _this.type
	                            }, _this.keeper.getToken());
	                        }
	                    }, function () {
	                        fail({
	                            code: 412, // API不支持走兜底方案
	                            type: _this.type
	                        }, _this.keeper.getToken());
	                    }).then(function (ret) {
	                        ret && succ({
	                            lat: ret.lat,
	                            lng: ret.lng,
	                            geoType: _this._parseGeoType(ret.type),
	                            type: _this.type
	                        }, _this.keeper.getToken());
	                    }, function () {
	                        var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	                        /**
	                         * JSB API结果：未授权(-100)、API超时(-101)、定位错误
	                         * SDK策略覆盖GPS WIFI 基站等（不包含IP），成功率高于补位API，后者可能会有奇怪的授权弹框
	                         */
	                        fail({
	                            message: e.errorMsg || 'app geo error',
	                            type: _this.type
	                        }, _this.keeper.getToken());
	                    }).catch(function (e) {
	                        // 异常
	                        fail({
	                            code: 400,
	                            message: e && e.message || JSON.stringify(e),
	                            type: _this.type
	                        }, _this.keeper.getToken());
	                    });
	                });
	            });
	        }
	    }, {
	        key: 'initSDK',
	        value: function initSDK() {
	            return new Promise(function (resolve) {
	                __webpack_require__.e/* nsure */(3, function () {
	                    KNB = __webpack_require__(528);
	                    resolve();
	                });
	            });
	        }
	    }, {
	        key: 'supportGeo',
	        value: function supportGeo() {
	            return this._inDPAPP() || this._inMTAPP();
	        }
	    }, {
	        key: '_inDPAPP',
	        value: function _inDPAPP() {
	            return (/dp\/com\.dianping/.test(navigator.userAgent)
	            );
	        }
	    }, {
	        key: '_inMTAPP',
	        value: function _inMTAPP() {
	            return (/meituan/.test(navigator.userAgent)
	            );
	        }
	    }, {
	        key: '_parseGeoType',
	        value: function _parseGeoType(type) {
	            if (type && isNaN(type) && ~this.GEOTYPE.indexOf(type.toLowerCase())) {
	                // string
	                return type.toLowerCase();
	            } else if (parseInt(type) || parseInt(type) === 0) {
	                // number
	                return this.GEOTYPE[parseInt(type)];
	            }
	            // default
	            return this.GEOTYPE[this._inMTAPP() ? 1 : 0];
	        }
	    }]);
	
	    return App;
	}();
	
	var instance = new App();
	module.exports = instance.process.bind(instance);
	module.exports.type = instance.type;

/***/ }),
/* 528 */,
/* 529 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _keeper = __webpack_require__(485);
	
	var _keeper2 = _interopRequireDefault(_keeper);
	
	var _config = __webpack_require__(479);
	
	var _config2 = _interopRequireDefault(_config);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Weixin = function () {
	    function Weixin() {
	        _classCallCheck(this, Weixin);
	
	        this.type = 'weixin';
	        this.keeper = undefined;
	    }
	
	    _createClass(Weixin, [{
	        key: 'process',
	        value: function process(succ, _fail, next) {
	            var _this = this;
	
	            var opt = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
	
	            // 预处理
	            typeof succ == 'function' || (succ = this.noop);
	            typeof _fail == 'function' || (_fail = this.noop);
	            typeof next == 'function' || (next = this.noop);
	
	            if (!this.supportGeo()) return next();
	            opt.trigger = function (token) {
	                // API超时、用户拒绝授权
	                _fail({
	                    code: 408,
	                    message: _this.type + ' API Timeout:' + opt.timeout,
	                    type: _this.type
	                }, token);
	            };
	            this.keeper = new _keeper2.default(opt);
	
	            this.initSDK(function () {
	                try {
	                    // 说明: `回调未执行`先用超时来统计，包含两部分 -> checkJsApi & getLocation
	                    wx.ready(function () {
	                        wx.checkJsApi({
	                            jsApiList: ['getLocation'],
	                            success: function success(res) {
	                                if (res.checkResult && res.checkResult.getLocation) {
	                                    wx.getLocation({
	                                        type: 'wgs84',
	                                        success: function success(res) {
	                                            succ({
	                                                lat: res.latitude,
	                                                lng: res.longitude,
	                                                type: _this.type
	                                            }, _this.keeper.getToken());
	                                        },
	                                        fail: function fail() {
	                                            var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	                                            // TODO: 用户授权失败标识
	                                            _fail({
	                                                message: e.message || e.errMsg || JSON.stringify(e),
	                                                type: _this.type
	                                            }, _this.keeper.getToken());
	                                        }
	                                    });
	                                } else {
	                                    // 说明：config中未匹配的域名、jsApiList没有指定`getLocation`都进入此分支
	                                    _fail({
	                                        code: 400,
	                                        message: 'wx checkJsApi error',
	                                        title: 'weixin-checkJsApi',
	                                        type: _this.type
	                                    }, _this.keeper.getToken());
	                                }
	                            },
	                            fail: function fail() {
	                                var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	                                _fail({
	                                    code: 400,
	                                    message: e.message || e.errMsg || 'wx checkJsApi fail',
	                                    title: 'weixin-checkJsApi',
	                                    type: _this.type
	                                }, _this.keeper.getToken());
	                            }
	                        });
	                    });
	                    // TODO: 可能有误操作，beta
	                    wx.error(function () {
	                        var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	                        console.log('wx config error');
	                        _fail({
	                            code: 400,
	                            message: e.message || e.errMsg || 'wx config error',
	                            title: 'weixin-config',
	                            type: _this.type
	                        }, _this.keeper.getToken());
	                    });
	                } catch (e) {
	                    console.log('wx exception');
	                    _fail({
	                        code: 400,
	                        message: 'wx init error',
	                        type: _this.type
	                    }, _this.keeper.getToken());
	                }
	            });
	        }
	    }, {
	        key: 'initSDK',
	        value: function initSDK(action) {
	            if (_config2.default.get('wxAutoConfig') && typeof wx === 'undefined') {
	                // 说明：同一个url仅需验证一次
	                __webpack_require__.e/* nsure */(4, function () {
	                    var loader = __webpack_require__(530);
	                    loader.use(action);
	                });
	            } else {
	                action();
	            }
	        }
	    }, {
	        key: 'supportGeo',
	        value: function supportGeo() {
	            return (/MicroMessenger/.test(navigator.userAgent)
	            );
	        }
	    }]);
	
	    return Weixin;
	}();
	
	var instance = new Weixin();
	module.exports = instance.process.bind(instance);
	module.exports.type = instance.type;

/***/ }),
/* 530 */,
/* 531 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _keeper = __webpack_require__(485);
	
	var _keeper2 = _interopRequireDefault(_keeper);
	
	var _util = __webpack_require__(532);
	
	var _util2 = _interopRequireDefault(_util);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * 手Q官方文档：http://open.mobile.qq.com/api/common/index
	 */
	var MobileQQ = function () {
	    function MobileQQ() {
	        _classCallCheck(this, MobileQQ);
	
	        this.type = 'mobileqq';
	        this.keeper = undefined;
	    }
	
	    _createClass(MobileQQ, [{
	        key: 'supportGeo',
	        value: function supportGeo() {
	            return (/(.*?(iPad|iPhone|iPod).*?QQ\/([\d\.]+).*?)|(.*?\bV1_AND_SQI?_([\d\.]+)(.*?QQ\/([\d\.]+))?.*?)/i.test(navigator.userAgent)
	            );
	        }
	    }, {
	        key: 'process',
	        value: function process(succ, fail, next) {
	            var _this = this;
	
	            var opt = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
	
	            // 预处理
	            typeof succ == 'function' || (succ = this.noop);
	            typeof fail == 'function' || (fail = this.noop);
	            typeof next == 'function' || (next = this.noop);
	
	            if (!this.supportGeo()) return next();
	            opt.trigger = function (token) {
	                // API超时
	                fail({
	                    code: 408,
	                    message: _this.type + ' API Timeout:' + opt.timeout,
	                    type: _this.type
	                }, token);
	            };
	            this.keeper = new _keeper2.default(opt);
	
	            _util2.default.loadScript('//open.mobile.qq.com/sdk/qqapi.js?_bid=152', function () {
	                try {
	                    if (!mqq.support('mqq.sensor.getLocation')) return fail({
	                        code: 412, // API不支持归类为`未命中`
	                        type: _this.type
	                    }, _this.keeper.getToken());
	                    mqq.sensor.getLocation({
	                        allowCacheTime: 60 // 设置缓存时间（秒）
	                    }, function (retCode, latitude, longitude, status) {
	                        if (retCode == 0 && latitude && longitude) {
	                            succ({
	                                lat: latitude,
	                                lng: longitude,
	                                geoType: 'gcj02',
	                                type: _this.type
	                            }, _this.keeper.getToken());
	                        } else {
	                            var msg = ['retCode:' + retCode];
	                            if (status) {
	                                // FIXME: >= IOS 4.7
	                                msg.push('authroized:' + status.authroized);
	                                msg.push('sensor:' + status.enabled);
	                            }
	                            fail({
	                                // code: status && !status.authroized ? 401 : 500, // TODO: authroized为Number类型，与文档不符合
	                                code: status && !status.enabled && 407,
	                                message: msg.join(' '),
	                                type: _this.type
	                            }, _this.keeper.getToken());
	                        }
	                    });
	                } catch (e) {
	                    fail({
	                        code: 400,
	                        message: e && e.message || JSON.stringify(e),
	                        type: _this.type
	                    }, _this.keeper.getToken());
	                }
	            });
	        }
	    }]);
	
	    return MobileQQ;
	}();
	
	var instance = new MobileQQ();
	module.exports = instance.process.bind(instance);
	module.exports.type = instance.type;

/***/ }),
/* 532 */
/***/ (function(module, exports) {

	"use strict";
	
	var cached = [];
	
	exports.loadScript = function (src, cb) {
	    if (~cached.indexOf(src)) {
	        cb();
	        return;
	    }
	
	    var script = document.createElement("script");
	    script.src = src;
	    script.onload = function () {
	        cached.push(src);
	        cb();
	    };
	    document.getElementsByTagName("head")[0].appendChild(script);
	};

/***/ }),
/* 533 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _util = __webpack_require__(532);
	
	var _util2 = _interopRequireDefault(_util);
	
	var _config = __webpack_require__(479);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _log = __webpack_require__(495);
	
	var _keeper = __webpack_require__(485);
	
	var _keeper2 = _interopRequireDefault(_keeper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var LBS = function () {
	    function LBS() {
	        _classCallCheck(this, LBS);
	
	        this.type = 'x5';
	        this.keeper = undefined;
	    }
	
	    _createClass(LBS, [{
	        key: 'supportGeo',
	        value: function supportGeo() {
	            return (/TBS/i.test(navigator.userAgent) && ~_config2.default.get('enables').indexOf('x5')
	            ); // 组件策略：目前只对X5内核开放
	        }
	    }, {
	        key: 'process',
	        value: function process(succ, fail, next) {
	            var _this = this;
	
	            var opt = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
	
	            // 预处理
	            typeof succ == 'function' || (succ = this.noop);
	            typeof fail == 'function' || (fail = this.noop);
	            typeof next == 'function' || (next = this.noop);
	
	            if (!this.supportGeo()) return next();
	            opt.trigger = function (token) {
	                // API超时
	                fail({
	                    code: 408,
	                    message: _this.type + ' API Timeout:' + opt.timeout,
	                    type: _this.type
	                }, token);
	            };
	            this.keeper = new _keeper2.default(opt);
	
	            _util2.default.loadScript('//apis.map.qq.com/tools/geolocation/min?key=6ULBZ-4X3C3-QEK3S-3ZRI6-6D7RE-WQFRQ&referer=大众点评M站', function () {
	                try {
	                    var x5Geo = new qq.maps.Geolocation('6ULBZ-4X3C3-QEK3S-3ZRI6-6D7RE-WQFRQ', '大众点评M站');
	                    x5Geo.getLocation(function (location) {
	                        succ({
	                            lat: location.lat,
	                            lng: location.lng,
	                            geoType: 'gcj02', // 坐标系类型
	                            type: _this.type
	                        }, _this.keeper.getToken());
	                    }, function () {
	                        var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	                        fail({
	                            code: 404, // 可选的定位方式，特殊状态码
	                            message: e.message || JSON.stringify(e),
	                            type: _this.type
	                        }, _this.keeper.getToken());
	                    }, {
	                        timeout: opt.timeout
	                    });
	                } catch (e) {
	                    // 同步异常
	                    fail({
	                        code: 400,
	                        message: e && e.message || JSON.stringify(e),
	                        type: _this.type
	                    }, _this.keeper.getToken());
	                }
	            });
	        }
	    }, {
	        key: 'noop',
	        value: function noop() {}
	    }]);
	
	    return LBS;
	}();
	
	var instance = new LBS();
	module.exports = instance.process.bind(instance);
	module.exports.type = instance.type;

/***/ }),
/* 534 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _keeper = __webpack_require__(485);
	
	var _keeper2 = _interopRequireDefault(_keeper);
	
	var _util = __webpack_require__(532);
	
	var _util2 = _interopRequireDefault(_util);
	
	var _log = __webpack_require__(495);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var QQBrowser = function () {
	    function QQBrowser() {
	        _classCallCheck(this, QQBrowser);
	
	        this.type = 'qqbrowser';
	        this.keeper = undefined;
	    }
	
	    _createClass(QQBrowser, [{
	        key: 'supportGeo',
	        value: function supportGeo() {
	            return (/MQQBrowser(?!(.*TBS))/.test(navigator.userAgent)
	            ); // x5内核微信、QQ客户端关闭该补位方式，出错率95%+
	        }
	    }, {
	        key: 'process',
	        value: function process(succ, fail, next) {
	            var _this = this;
	
	            var opt = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
	
	            // 预处理
	            typeof succ == 'function' || (succ = this.noop);
	            typeof fail == 'function' || (fail = this.noop);
	            typeof next == 'function' || (next = this.noop);
	
	            if (!this.supportGeo()) return next();
	            opt.trigger = function (token) {
	                // API超时
	                fail({
	                    code: 408,
	                    message: _this.type + ' API Timeout:' + opt.timeout,
	                    type: _this.type
	                }, token);
	            };
	            this.keeper = new _keeper2.default(opt);
	
	            _util2.default.loadScript('//jsapi.qq.com/get?api=app.getGeoLocation', function () {
	                try {
	                    browser.app.getGeoLocation(function (res) {
	                        if (res && res.ret === 'true') {
	                            succ({
	                                lat: res.latitude,
	                                lng: res.longitude,
	                                type: _this.type
	                            }, _this.keeper.getToken());
	                        } else {
	                            fail({
	                                message: 'qqbrowser geo error',
	                                type: _this.type
	                            }, _this.keeper.getToken());
	                        }
	                    }, function () {
	                        fail({
	                            message: 'qqbrowser geo fail',
	                            type: _this.type
	                        }, _this.keeper.getToken());
	                    });
	                } catch (e) {
	                    fail({
	                        code: 400,
	                        message: e && e.message || JSON.stringify(e),
	                        type: _this.type
	                    }, _this.keeper.getToken());
	                }
	            });
	        }
	    }]);
	
	    return QQBrowser;
	}();
	
	var instance = new QQBrowser();
	module.exports = instance.process.bind(instance);
	module.exports.type = instance.type;

/***/ }),
/* 535 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _config = __webpack_require__(479);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _keeper = __webpack_require__(485);
	
	var _keeper2 = _interopRequireDefault(_keeper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var H5 = function () {
	    function H5() {
	        _classCallCheck(this, H5);
	
	        this.type = 'html';
	        this.keeper = undefined;
	    }
	
	    _createClass(H5, [{
	        key: 'process',
	        value: function process(succ, fail, next) {
	            var _this = this;
	
	            var opt = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
	
	            // 预处理
	            typeof succ == 'function' || (succ = this.noop);
	            typeof fail == 'function' || (fail = this.noop);
	            typeof next == 'function' || (next = this.noop);
	
	            if (!this.supportGeo()) return next();
	            opt.trigger = function (token) {
	                fail({
	                    code: 408,
	                    message: _this.type + ' API Timeout:' + opt.timeout,
	                    type: _this.type
	                }, token);
	            };
	            this.keeper = new _keeper2.default(opt);
	
	            try {
	                navigator.geolocation.getCurrentPosition(function (crd) {
	                    succ({
	                        lat: crd.coords.latitude,
	                        lng: crd.coords.longitude,
	                        type: _this.type
	                    }, _this.keeper.getToken());
	                }, function () {
	                    var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	                    fail({
	                        code: e.code == 1 && /https/.test(location.protocol) && 401, // http协议问题走错误日志查看
	                        message: (e.code || 'UNKOWN') + ': ' + (e.message || 'h5 get location error'),
	                        type: _this.type
	                    }, _this.keeper.getToken());
	                }, {
	                    enableHighAccuracy: true,
	                    maximumAge: 30000, // 组件设置的默认缓存时间：30s
	                    timeout: _config2.default.get('timeout') || 10000
	                });
	            } catch (e) {
	                fail({
	                    code: 400,
	                    message: e && e.message || JSON.stringify(e),
	                    type: this.type
	                }, this.keeper.getToken());
	            }
	        }
	    }, {
	        key: 'supportGeo',
	        value: function supportGeo() {
	            return !!navigator.geolocation;
	        }
	    }]);
	
	    return H5;
	}();
	
	var instance = new H5();
	module.exports = instance.process.bind(instance);
	module.exports.type = instance.type;

/***/ }),
/* 536 */
/***/ (function(module, exports) {

	var isFunction = function(obj){
	    return Object.prototype.toString.call(obj) == '[object Function]';
	};
	var extend = function(obj){
	    Array.prototype.slice.call(arguments, 1).forEach(function(source){
	        if (source) {
	            for (var prop in source) {
	                obj[prop] = source[prop];
	            }
	        }
	    });
	    return obj;
	};
	
	
	var pluses = /\+/g;
	
	function encode(s) {
	    return config.raw ? s : encodeURIComponent(s);
	}
	
	function decode(s) {
	    return config.raw ? s : decodeURIComponent(s);
	}
	
	function stringifyCookieValue(value) {
	    return encode(config.json ? JSON.stringify(value) : String(value));
	}
	
	function parseCookieValue(s) {
	    if (s.indexOf('"') === 0) {
	        // This is a quoted cookie as according to RFC2068, unescape...
	        s = s.slice(1, -1).replace(/\\"/g, '"').replace(/\\\\/g, '\\');
	    }
	
	    try {
	        // Replace server-side written pluses with spaces.
	        // If we can't decode the cookie, ignore it, it's unusable.
	        // If we can't parse the cookie, ignore it, it's unusable.
	        s = decodeURIComponent(s.replace(pluses, ' '));
	        return config.json ? JSON.parse(s) : s;
	    } catch(e) {}
	}
	
	function read(s, converter) {
	    var value = config.raw ? s : parseCookieValue(s);
	    return isFunction(converter) ? converter(value) : value;
	}
	
	var cookie,config,removeCookie;
	
	config = cookie = function (key, value, options) {
	
	    // Write
	
	    if (value !== undefined && !isFunction(value)) {
	        options = extend({}, config.defaults, options);
	
	        if (typeof options.expires === 'number') {
	            var days = options.expires, t = options.expires = new Date();
	            t.setTime(+t + days * 864e+5);
	        }
	
	        return (document.cookie = [
	                encode(key), '=', stringifyCookieValue(value),
	                options.expires ? '; expires=' + options.expires.toUTCString() : '', // use expires attribute, max-age is not supported by IE
	                options.path    ? '; path=' + options.path : '',
	                options.domain  ? '; domain=' + options.domain : '',
	                options.secure  ? '; secure' : ''
	        ].join(''));
	    }
	
	    // Read
	
	    var result = key ? undefined : {};
	
	    // To prevent the for loop in the first place assign an empty array
	    // in case there are no cookies at all. Also prevents odd result when
	    // calling $.cookie().
	    var cookies = document.cookie ? document.cookie.split('; ') : [];
	
	    for (var i = 0, l = cookies.length; i < l; i++) {
	        var parts = cookies[i].split('=');
	        var name = decode(parts.shift());
	        var cookie = parts.join('=');
	
	        if (key && key === name) {
	            // If second argument (value) is a function it's a converter...
	            result = read(cookie, value);
	            break;
	        }
	
	        // Prevent storing a cookie that we couldn't decode.
	        if (!key && (cookie = read(cookie)) !== undefined) {
	            result[name] = cookie;
	        }
	    }
	
	    return result;
	};
	
	config.defaults = {};
	
	removeCookie = function (key, options) {
	    if (cookie(key) === undefined) {
	        return false;
	    }
	
	    // Must not alter options, thus extending a fresh object...
	    cookie(key, '', extend({}, options, { expires: -1 }));
	    return !cookie(key);
	};
	cookie.remove = removeCookie;
	
	module.exports = cookie;

/***/ }),
/* 537 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(73);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(105);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _reactRedux = __webpack_require__(265);
	
	var _reselect = __webpack_require__(538);
	
	var _detail = __webpack_require__(280);
	
	var Action = _interopRequireWildcard(_detail);
	
	var _reactLazyload = __webpack_require__(539);
	
	var _reactLazyload2 = _interopRequireDefault(_reactLazyload);
	
	var _lodash = __webpack_require__(545);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _sticky = __webpack_require__(546);
	
	var _notice = __webpack_require__(547);
	
	var _notice2 = _interopRequireDefault(_notice);
	
	var _reactSwipe = __webpack_require__(549);
	
	var _reactSwipe2 = _interopRequireDefault(_reactSwipe);
	
	var _classnames = __webpack_require__(552);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _knb = __webpack_require__(282);
	
	var _knb2 = _interopRequireDefault(_knb);
	
	var _utilMShare = __webpack_require__(553);
	
	var _utilMShare2 = _interopRequireDefault(_utilMShare);
	
	var _weppModuleToast = __webpack_require__(572);
	
	var _weppModuleToast2 = _interopRequireDefault(_weppModuleToast);
	
	var _utilLogin = __webpack_require__(473);
	
	var _utilLogin2 = _interopRequireDefault(_utilLogin);
	
	var _util = __webpack_require__(281);
	
	var _util2 = _interopRequireDefault(_util);
	
	var _date_format = __webpack_require__(575);
	
	var _share_cb = __webpack_require__(576);
	
	var _detailLess = __webpack_require__(577);
	
	var _detailLess2 = _interopRequireDefault(_detailLess);
	
	__webpack_require__(578);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MAXPRELOADHEIGHT = 50;
	
	var Header = function (_React$Component) {
	    _inherits(Header, _React$Component);
	
	    function Header(props) {
	        _classCallCheck(this, Header);
	
	        var _this = _possibleConstructorReturn(this, (Header.__proto__ || Object.getPrototypeOf(Header)).call(this, props));
	
	        _this.state = {
	            cursor: 0
	        };
	        return _this;
	    }
	
	    _createClass(Header, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            var swipeImgInit = document.getElementsByClassName('swipe-img-init')[0];
	            // dpapp在IOS环境中图片上有translateZ属性，图片显示会有问题
	            if (swipeImgInit) {
	                var url = swipeImgInit.getAttribute('data-url');
	                if (!url) return;
	                swipeImgInit.setAttribute('src', url);
	                swipeImgInit.removeAttribute('data-url');
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this,
	                _classNames2;
	
	            var HeadData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
	
	            return _react2.default.createElement(
	                'header',
	                null,
	                HeadData.headImgList && _react2.default.createElement(
	                    'div',
	                    { className: _detailLess2.default["img_wrap"] },
	                    _react2.default.createElement(
	                        _reactSwipe2.default,
	                        { swipeOptions: {
	                                continuous: false,
	                                callback: function callback(index, elem) {
	                                    var url = elem.getAttribute('data-url');
	                                    _this2.setState({
	                                        cursor: index
	                                    });
	                                    if (!url) return;
	                                    elem.setAttribute('src', url);
	                                    elem.removeAttribute('data-url');
	                                }
	                            }, style: {
	                                container: { position: 'relative', height: '28.1rem', overflow: 'hidden' },
	                                wrapper: { position: 'relative', height: '100%' },
	                                child: { float: 'left', position: 'relative', width: '100%', height: '100%' }
	                            } },
	                        HeadData.headImgList.map(function (item, index) {
	                            return index ? _react2.default.createElement('img', { 'data-url': item, src: 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7', key: index }) : _react2.default.createElement('img', { className: 'swipe-img-init', 'data-url': item, src: 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7', key: index });
	                        })
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: _detailLess2.default["img_count"] },
	                        HeadData.headImgList.length > 1 && HeadData.headImgList.map(function (item, index) {
	                            var _classNames;
	
	                            return _react2.default.createElement('i', { className: (0, _classnames2.default)((_classNames = {}, _defineProperty(_classNames, _detailLess2.default["count_dot"], true), _defineProperty(_classNames, _detailLess2.default["count_dot_on"], _this2.state.cursor == index), _classNames)), key: index });
	                        })
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: _detailLess2.default["desc_wrap"] },
	                    _react2.default.createElement(
	                        'p',
	                        { className: _detailLess2.default["desc_hd"] },
	                        HeadData.title
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: _detailLess2.default["desc_info"] },
	                        HeadData.mode == 11 ? _react2.default.createElement(
	                            'p',
	                            null,
	                            '\u8D77\u62CD\u4EF7',
	                            _react2.default.createElement(
	                                'span',
	                                { className: _detailLess2.default["highlight"] },
	                                HeadData.startPrice,
	                                'D\u5E01'
	                            )
	                        ) : _react2.default.createElement(
	                            'p',
	                            null,
	                            _react2.default.createElement(
	                                'span',
	                                { className: _detailLess2.default["highlight"] },
	                                '\uFFE5'
	                            ),
	                            _react2.default.createElement(
	                                'span',
	                                { className: _detailLess2.default["cur_price"] },
	                                '0'
	                            ),
	                            _react2.default.createElement(
	                                'span',
	                                { className: _detailLess2.default["origin_price"] },
	                                '\uFFE5',
	                                _react2.default.createElement(
	                                    'del',
	                                    null,
	                                    HeadData.cost
	                                )
	                            )
	                        ),
	                        HeadData.mode == 11 ? _react2.default.createElement(
	                            'p',
	                            { className: _detailLess2.default["statistics"] },
	                            _react2.default.createElement(
	                                'span',
	                                { className: _detailLess2.default["statistics_item"] },
	                                (0, _date_format.formatDate)(HeadData.applyEndTime, 'MM月dd日 HH:mm'),
	                                '\u622A\u6B62'
	                            )
	                        ) : HeadData.mode == 13 ? _react2.default.createElement(
	                            'p',
	                            { className: _detailLess2.default["statistics"] },
	                            _react2.default.createElement(
	                                'span',
	                                { className: _detailLess2.default["statistics_item"] },
	                                '\u540D\u989D',
	                                _react2.default.createElement(
	                                    'el',
	                                    { className: _detailLess2.default["highlight"] },
	                                    HeadData.joinCount || '不受限制'
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'span',
	                                { className: _detailLess2.default["statistics_item"] },
	                                HeadData.applyCount,
	                                '\u4EBA\u6B21\u62BD'
	                            ),
	                            _react2.default.createElement(
	                                'span',
	                                { className: _detailLess2.default["statistics_item"] },
	                                HeadData.userWinCount,
	                                '\u4EBA\u5DF2\u4E2D'
	                            )
	                        ) : _react2.default.createElement(
	                            'p',
	                            { className: _detailLess2.default["statistics"] },
	                            _react2.default.createElement(
	                                'span',
	                                { className: _detailLess2.default["statistics_item"] },
	                                '\u540D\u989D',
	                                _react2.default.createElement(
	                                    'el',
	                                    { className: _detailLess2.default["highlight"] },
	                                    HeadData.joinCount || '不受限制'
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'span',
	                                { className: _detailLess2.default["statistics_item"] },
	                                HeadData.applyCount,
	                                '\u4EBA\u62A5\u540D'
	                            )
	                        )
	                    ),
	                    HeadData.passCount > 0 ? _react2.default.createElement(
	                        'p',
	                        { className: (0, _classnames2.default)((_classNames2 = {}, _defineProperty(_classNames2, _detailLess2.default["passcard"], true), _defineProperty(_classNames2, _detailLess2.default["passcard_disabled"], !HeadData.leftPassCount), _classNames2)) },
	                        HeadData.leftPassCount ? '支持使用Pass卡，' : 'Pass卡名额已用完，',
	                        _react2.default.createElement(
	                            'a',
	                            { className: 'passcard_link', href: _util2.default.getDomain() + "/mobile/event/passCardQA" },
	                            '\u4EC0\u4E48\u662FPass\u5361'
	                        )
	                    ) : null
	                ),
	                HeadData.mode == 11 ? _react2.default.createElement(Record, { list: HeadData.recordVOs || [], offlineActivityId: HeadData.offlineActivityId }) : HeadData.mode == 13 ? _react2.default.createElement(
	                    'p',
	                    { className: _detailLess2.default["desc_tips"] },
	                    '\u7ED3\u679C\u7ACB\u523B\u63ED\u6653\uFF0C\u62BD\u4E0D\u4E2D\u8FD8\u6709\u9738\u6C14\u503C\u9001\u54E6'
	                ) : null
	            );
	        }
	    }]);
	
	    return Header;
	}(_react2.default.Component);
	
	var Record = function (_React$Component2) {
	    _inherits(Record, _React$Component2);
	
	    function Record(props) {
	        _classCallCheck(this, Record);
	
	        return _possibleConstructorReturn(this, (Record.__proto__ || Object.getPrototypeOf(Record)).call(this, props));
	    }
	
	    _createClass(Record, [{
	        key: 'render',
	        value: function render() {
	            var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props,
	                list = _ref.list,
	                offlineActivityId = _ref.offlineActivityId;
	
	            return list.length ? _react2.default.createElement(
	                'div',
	                { className: _detailLess2.default["record_wrap"] },
	                _react2.default.createElement(
	                    'a',
	                    { className: _detailLess2.default["record_title"], href: 'javascript:;',
	                        onClick: function onClick() {
	                            location.href = _util2.default.getDomain() + '/mobile/event/' + offlineActivityId + '/auctionRecord?token=*';
	                        }
	                    },
	                    '\u62CD\u5356\u7EAA\u5F55',
	                    _react2.default.createElement('span', { className: _detailLess2.default["icon_arrow"] })
	                ),
	                _react2.default.createElement(
	                    'ul',
	                    { className: _detailLess2.default["record_list"] },
	                    list.map(function (item, index) {
	                        var _classNames3;
	
	                        return _react2.default.createElement(
	                            'li',
	                            { className: (0, _classnames2.default)((_classNames3 = {}, _defineProperty(_classNames3, _detailLess2.default["record_item"], true), _defineProperty(_classNames3, _detailLess2.default["record_disable_item"], item.out), _classNames3)), key: index },
	                            _react2.default.createElement(
	                                'label',
	                                { className: _detailLess2.default["label_status"] },
	                                item.des
	                            ),
	                            _react2.default.createElement(
	                                'span',
	                                { className: _detailLess2.default["record_username"] },
	                                item.nickName
	                            ),
	                            _react2.default.createElement(
	                                'span',
	                                { className: _detailLess2.default["record_time"] },
	                                (0, _date_format.formatDate)(item.time, 'MM.dd HH:mm', '.')
	                            ),
	                            _react2.default.createElement(
	                                'span',
	                                { className: _detailLess2.default["record_price"] },
	                                item.price
	                            )
	                        );
	                    })
	                )
	            ) : null;
	        }
	    }]);
	
	    return Record;
	}(_react2.default.Component);
	
	var Shop = function (_React$Component3) {
	    _inherits(Shop, _React$Component3);
	
	    function Shop(props) {
	        _classCallCheck(this, Shop);
	
	        var _this4 = _possibleConstructorReturn(this, (Shop.__proto__ || Object.getPrototypeOf(Shop)).call(this, props));
	
	        _this4.state = {
	            cursor: 0 // 记录列表展示索引
	        };
	        _this4.switchShop = _this4.switchShop.bind(_this4);
	        return _this4;
	    }
	
	    _createClass(Shop, [{
	        key: 'render',
	        value: function render() {
	            var _classNames4;
	
	            var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props,
	                _ref2$list = _ref2.list,
	                list = _ref2$list === undefined ? [] : _ref2$list;
	
	            var item = list[this.state.cursor];
	            return _react2.default.createElement(
	                'div',
	                { className: _detailLess2.default["shop_wrap"] },
	                _react2.default.createElement(
	                    'p',
	                    { className: _detailLess2.default["shop_title"] },
	                    '\u9002\u7528\u5546\u6237',
	                    list.length > 1 && '(' + list.length + ')',
	                    list.length > 1 && _react2.default.createElement(
	                        'span',
	                        { className: _detailLess2.default["shop_change"], onClick: this.switchShop },
	                        '\u6362\u4E00\u6362'
	                    )
	                ),
	                item ? _react2.default.createElement(
	                    'div',
	                    { className: _detailLess2.default["shop_content"] },
	                    _react2.default.createElement(
	                        'a',
	                        { className: _detailLess2.default["shop_detail"], href: 'javascript:;', onClick: function onClick() {
	                                LXAnalytics('moduleClick', 'b_y718vrmf');
	                                if (!_util2.default.shareRedirect()) return;
	                                location.href = item.shopJumpUrl;
	                            } },
	                        _react2.default.createElement(
	                            'p',
	                            { className: _detailLess2.default["shop_brand"] },
	                            item.shopFullName
	                        ),
	                        _react2.default.createElement(
	                            'p',
	                            { className: _detailLess2.default["shop_info"] },
	                            _react2.default.createElement('i', { className: (0, _classnames2.default)((_classNames4 = {}, _defineProperty(_classNames4, _detailLess2.default["start_level"], true), _defineProperty(_classNames4, _detailLess2.default['start_' + item.shopPower], true), _classNames4)) }),
	                            _react2.default.createElement(
	                                'span',
	                                { className: _detailLess2.default["distance"] },
	                                item.distanceInfo
	                            )
	                        )
	                    ),
	                    item.phoneNo && (_util2.default.shareRedirect(true) ? _react2.default.createElement('a', { className: _detailLess2.default["shop_phone"], href: 'tel:' + item.phoneNo }) : _react2.default.createElement('a', { className: _detailLess2.default["shop_phone"], href: 'javascript:;', onClick: function onClick() {
	                            if (!_util2.default.shareRedirect()) return;
	                        } }))
	                ) : '',
	                item ? _react2.default.createElement(
	                    'p',
	                    { className: _detailLess2.default["shop_loc"], onClick: function onClick() {
	                            LXAnalytics('moduleClick', 'b_y718vrmf');
	                            if (!_util2.default.shareRedirect()) return;
	                            location.href = item.shopJumpUrl;
	                        } },
	                    item.shopAddress
	                ) : ''
	            );
	        }
	    }, {
	        key: 'switchShop',
	        value: function switchShop() {
	            var length = this.props.list.length;
	
	            if (!length) return;
	            if (!_util2.default.shareRedirect()) return;
	            this.setState({
	                cursor: (this.state.cursor + 1) % length
	            });
	        }
	    }]);
	
	    return Shop;
	}(_react2.default.Component);
	
	var Nav = function (_React$Component4) {
	    _inherits(Nav, _React$Component4);
	
	    function Nav(props) {
	        _classCallCheck(this, Nav);
	
	        return _possibleConstructorReturn(this, (Nav.__proto__ || Object.getPrototypeOf(Nav)).call(this, props));
	    }
	
	    _createClass(Nav, [{
	        key: 'render',
	        value: function render() {
	            var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props,
	                NavData = _ref3.NavData,
	                navHandle = _ref3.navHandle;
	
	            var _NavData$staticData = NavData.staticData,
	                staticData = _NavData$staticData === undefined ? [] : _NavData$staticData,
	                cursor = NavData.navCursor;
	
	            return _react2.default.createElement(
	                'nav',
	                { className: _detailLess2.default["tab_wrap"] },
	                staticData.map(function (item) {
	                    var _classNames5;
	
	                    return _react2.default.createElement(
	                        'span',
	                        { key: item.id, className: (0, _classnames2.default)((_classNames5 = {}, _defineProperty(_classNames5, _detailLess2.default["tab_item"], true), _defineProperty(_classNames5, _detailLess2.default["tab_item_on"], cursor == item.id), _classNames5)), onClick: navHandle, 'data-id': item.id },
	                        item.name
	                    );
	                })
	            );
	        }
	    }]);
	
	    return Nav;
	}(_react2.default.Component);
	
	var Detail = function (_React$Component5) {
	    _inherits(Detail, _React$Component5);
	
	    function Detail(props) {
	        _classCallCheck(this, Detail);
	
	        var _this6 = _possibleConstructorReturn(this, (Detail.__proto__ || Object.getPrototypeOf(Detail)).call(this, props));
	
	        _this6.StickyFooter = (0, _sticky.StickyDecorator)(Footer);
	        _this6.state = {
	            unfold: false // 展开
	        };
	        _this6.toggleMechtModule = _this6.toggleMechtModule.bind(_this6);
	        return _this6;
	    }
	
	    _createClass(Detail, [{
	        key: 'render',
	        value: function render() {
	            var _classNames6, _classNames7, _classNames8, _classNames9, _classNames10, _classNames11;
	
	            var _ref4 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props,
	                DetailData = _ref4.DetailData,
	                UserData = _ref4.UserData,
	                isHidden = _ref4.isHidden,
	                fetchUserData = _ref4.fetchUserData;
	
	            return _react2.default.createElement(
	                'section',
	                { className: (0, _classnames2.default)((_classNames6 = {}, _defineProperty(_classNames6, _detailLess2.default["detail_container"], true), _defineProperty(_classNames6, _detailLess2.default["hide"], isHidden), _classNames6)) },
	                _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement(
	                        'p',
	                        { className: _detailLess2.default["detail_title"] },
	                        '\u6D3B\u52A8\u8BE6\u60C5'
	                    ),
	                    !DetailData.newActivity && DetailData.body ? _react2.default.createElement('div', { className: _detailLess2.default["detail_content"], dangerouslySetInnerHTML: { __html: DetailData.body } }) : _react2.default.createElement(
	                        'ul',
	                        { className: _detailLess2.default["detail_content"] },
	                        DetailData.activityContent.map(function (tip, index) {
	                            return _react2.default.createElement(
	                                'li',
	                                { key: index },
	                                tip
	                            );
	                        })
	                    )
	                ),
	                _react2.default.createElement(
	                    'a',
	                    { className: _detailLess2.default["more_entry"],
	                        href: 'javascript:;',
	                        onClick: function onClick() {
	                            LXAnalytics('moduleClick', 'b_cog4xrfy');
	                            if (!_util2.default.shareRedirect()) return;
	                            location.href = _util2.default.getDomain() + '/mobile/event/detailWithPic/' + DetailData.offlineActivityId;
	                        }
	                    },
	                    '\u66F4\u591A\u56FE\u6587\u8BE6\u60C5'
	                ),
	                DetailData.scenicSpotIntroduction ? _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement(
	                        'p',
	                        { className: _detailLess2.default["detail_title"] },
	                        '\u666F\u533A\u4ECB\u7ECD'
	                    ),
	                    _react2.default.createElement('div', { className: _detailLess2.default["detail_content"], dangerouslySetInnerHTML: { __html: DetailData.scenicSpotIntroduction } })
	                ) : '',
	                _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement(
	                        'p',
	                        { className: _detailLess2.default["detail_title"] },
	                        '\u6D3B\u52A8\u53EF\u7528\u65F6\u95F4'
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: _detailLess2.default["detail_content"] },
	                        (0, _date_format.formatDate)(DetailData.beginTime, 'yyyy年MM月dd日 HH:mm'),
	                        ' - ',
	                        (0, _date_format.formatDate)(DetailData.endTime, 'yyyy年MM月dd日 HH:mm')
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement(
	                        'p',
	                        { className: _detailLess2.default["detail_title"] },
	                        '\u6D3B\u52A8\u8BF4\u660E'
	                    ),
	                    _react2.default.createElement(
	                        'ul',
	                        { className: _detailLess2.default["detail_content"] },
	                        DetailData.activityExplain.map(function (tip, index) {
	                            return _react2.default.createElement(
	                                'li',
	                                { key: index },
	                                tip
	                            );
	                        })
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement(
	                        'p',
	                        { className: _detailLess2.default["detail_title"] },
	                        '\u9884\u7EA6\u4FE1\u606F'
	                    ),
	                    DetailData.appointmentFlag ? _react2.default.createElement(
	                        'div',
	                        { className: _detailLess2.default["detail_content"] },
	                        '1.\u9700\u63D0\u524D',
	                        DetailData.earlierDays,
	                        '\u5929\u9884\u7EA6',
	                        _react2.default.createElement('br', null),
	                        '2.\u9884\u7EA6\u7535\u8BDD\uFF1A',
	                        DetailData.appointmentPhone
	                    ) : _react2.default.createElement(
	                        'div',
	                        { className: _detailLess2.default["detail_content"] },
	                        '\u4E0D\u9700\u8981\u9884\u7EA6'
	                    )
	                ),
	                DetailData.kindTips ? _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement(
	                        'p',
	                        { className: _detailLess2.default["detail_title"] },
	                        '\u6E29\u99A8\u63D0\u793A'
	                    ),
	                    _react2.default.createElement(
	                        'ul',
	                        { className: _detailLess2.default["detail_content"] },
	                        DetailData.kindTips.map(function (tip, index) {
	                            return _react2.default.createElement(
	                                'li',
	                                { key: index },
	                                tip
	                            );
	                        })
	                    )
	                ) : null,
	                DetailData.mode != 11 && _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement(
	                        'p',
	                        { className: _detailLess2.default["detail_title"] },
	                        '\u4E2D\u5956\u5C0F\u7A8D\u95E8'
	                    ),
	                    _react2.default.createElement(
	                        'ul',
	                        { className: _detailLess2.default["detail_content"] },
	                        DetailData.winTips.map(function (tip, index) {
	                            return _react2.default.createElement(
	                                'li',
	                                { key: index },
	                                tip
	                            );
	                        })
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement(
	                        'p',
	                        { className: _detailLess2.default["detail_title"] },
	                        '\u6D3B\u52A8Tips'
	                    ),
	                    !DetailData.newActivity && DetailData.desc ? _react2.default.createElement('div', { className: _detailLess2.default["detail_content"], dangerouslySetInnerHTML: { __html: DetailData.desc } }) // 说明：老版本使用富文本编辑器，自带DOM结构
	                    : _react2.default.createElement(
	                        'ul',
	                        { className: _detailLess2.default["detail_content"] },
	                        DetailData.activityTips.map(function (tip, index) {
	                            return _react2.default.createElement(
	                                'li',
	                                { key: index },
	                                tip
	                            );
	                        })
	                    )
	                ),
	                !!DetailData.releasedUsersCount && !!UserData.list.length && _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement(
	                        'p',
	                        { className: _detailLess2.default["detail_title"] },
	                        '\u4E2D\u5956\u540D\u5355'
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: (0, _classnames2.default)((_classNames7 = {}, _defineProperty(_classNames7, _detailLess2.default["detail_content"], true), _defineProperty(_classNames7, _detailLess2.default["red_txt"], true), _classNames7)) },
	                        UserData.list.join(', '),
	                        !UserData.isEnd && !UserData.isError && _react2.default.createElement(
	                            'p',
	                            { className: _detailLess2.default["more_user"], onClick: fetchUserData },
	                            '\u66F4\u591A'
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: _detailLess2.default["merchant_wrap"] },
	                    _react2.default.createElement(
	                        'p',
	                        { className: _detailLess2.default["merchant_title"], onClick: this.toggleMechtModule },
	                        '\u6211\u662F\u5546\u5BB6\uFF0C\u4E09\u6B65\u8BA9\u95E8\u5E97\u4EBA\u6C14\u66B4\u589E',
	                        _react2.default.createElement(
	                            'label',
	                            { className: _detailLess2.default["merchant_label"] },
	                            '\u5546\u5BB6'
	                        ),
	                        _react2.default.createElement('i', { className: (0, _classnames2.default)((_classNames8 = {}, _defineProperty(_classNames8, _detailLess2.default["icon_arrow_down"], !this.state.unfold), _defineProperty(_classNames8, _detailLess2.default["icon_arrow_up"], this.state.unfold), _classNames8)) })
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: (0, _classnames2.default)((_classNames9 = {}, _defineProperty(_classNames9, _detailLess2.default["merchant_content"], true), _defineProperty(_classNames9, _detailLess2.default["hide"], !this.state.unfold), _classNames9)) },
	                        _react2.default.createElement(
	                            'ul',
	                            { className: _detailLess2.default["merchant_list"] },
	                            _react2.default.createElement(
	                                'li',
	                                { className: _detailLess2.default["merchant_item"] },
	                                _react2.default.createElement(
	                                    'p',
	                                    { className: _detailLess2.default["merchant_item_title"] },
	                                    '\u5173\u6CE8'
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: _detailLess2.default["merchant_item_desc"] },
	                                    '\u66DD\u5149\u589E\u52A0',
	                                    _react2.default.createElement(
	                                        'p',
	                                        { className: _detailLess2.default["merchant_item_desc_highlight"] },
	                                        '500%'
	                                    )
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'li',
	                                { className: _detailLess2.default["merchant_item"] },
	                                _react2.default.createElement(
	                                    'p',
	                                    { className: _detailLess2.default["merchant_item_title"] },
	                                    '\u5230\u5E97'
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: _detailLess2.default["merchant_item_desc"] },
	                                    '\u5BA2\u6D41\u63D0\u5347',
	                                    _react2.default.createElement(
	                                        'p',
	                                        { className: _detailLess2.default["merchant_item_desc_highlight"] },
	                                        '50%'
	                                    )
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'li',
	                                { className: _detailLess2.default["merchant_item"] },
	                                _react2.default.createElement(
	                                    'p',
	                                    { className: _detailLess2.default["merchant_item_title"] },
	                                    '\u53E3\u7891'
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: _detailLess2.default["merchant_item_desc"] },
	                                    '\u4F18\u8D28\u8BC4\u4EF7',
	                                    _react2.default.createElement(
	                                        'p',
	                                        { className: _detailLess2.default["merchant_item_desc_highlight"] },
	                                        '150%'
	                                    )
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'p',
	                            { className: _detailLess2.default["merchant_tips"] },
	                            '\u4E0B\u8F7D\u70B9\u8BC4\u7BA1\u5BB6APP\uFF0C1\u5206\u949F\u5B8C\u6210\u5165\u9A7B'
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: _detailLess2.default["btn_wrap"] },
	                            _react2.default.createElement(
	                                'a',
	                                { href: _util2.default.getDomain(true) + "/platform/record/index.html", className: (0, _classnames2.default)((_classNames10 = {}, _defineProperty(_classNames10, _detailLess2.default["btn"], true), _defineProperty(_classNames10, _detailLess2.default["btn_plain"], true), _classNames10)) },
	                                '\u4E86\u89E3\u66F4\u591A'
	                            ),
	                            _react2.default.createElement(
	                                'a',
	                                { href: '//e.dianping.com/mobile/viewDpgj', className: (0, _classnames2.default)((_classNames11 = {}, _defineProperty(_classNames11, _detailLess2.default["btn"], true), _defineProperty(_classNames11, _detailLess2.default["btn_primary"], true), _classNames11)) },
	                                '\u7ACB\u5373\u5165\u9A7B'
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }, {
	        key: 'toggleMechtModule',
	        value: function toggleMechtModule() {
	            var _this7 = this;
	
	            if (!_util2.default.shareRedirect()) return;
	            this.setState({
	                unfold: !this.state.unfold
	            });
	            // 说明：强行将父容器滚动上去(已知父容器可滚动(⊙﹏⊙)b)
	            if (!this.state.unfold) {
	                setTimeout(function () {
	                    // 降低优先级
	                    var parentNode = _reactDom2.default.findDOMNode(_this7).parentNode;
	                    parentNode.scrollTop = parentNode.scrollHeight;
	                }, 0);
	            }
	        }
	    }]);
	
	    return Detail;
	}(_react2.default.Component);
	
	var Response = function (_React$Component6) {
	    _inherits(Response, _React$Component6);
	
	    function Response(props) {
	        _classCallCheck(this, Response);
	
	        var _this8 = _possibleConstructorReturn(this, (Response.__proto__ || Object.getPrototypeOf(Response)).call(this, props));
	
	        _this8.StickyFooter = (0, _sticky.StickyDecorator)(Footer);
	        return _this8;
	    }
	
	    _createClass(Response, [{
	        key: 'render',
	        value: function render() {
	            var _classNames12;
	
	            var _ref5 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props,
	                ResData = _ref5.ResData,
	                isHidden = _ref5.isHidden,
	                _ref5$inputHidden = _ref5.inputHidden,
	                inputHidden = _ref5$inputHidden === undefined ? true : _ref5$inputHidden,
	                resAction = _ref5.resAction;
	
	            var _ResData$list = ResData.list,
	                list = _ResData$list === undefined ? [] : _ResData$list,
	                loading = ResData.loading,
	                isEnd = ResData.isEnd,
	                isError = ResData.isError,
	                page = ResData.page,
	                errMsg = ResData.errMsg,
	                endMsg = ResData.endMsg;
	
	            return _react2.default.createElement(
	                'ul',
	                { className: (0, _classnames2.default)((_classNames12 = {}, _defineProperty(_classNames12, _detailLess2.default["response_container"], true), _defineProperty(_classNames12, _detailLess2.default["hide"], isHidden), _classNames12)) },
	                list.map(function (item, index) {
	                    return _react2.default.createElement(
	                        'li',
	                        { className: _detailLess2.default["res_item"], key: index },
	                        _react2.default.createElement(
	                            'div',
	                            { className: _detailLess2.default["avatar_wrap"] },
	                            _react2.default.createElement(
	                                _reactLazyload2.default,
	                                { once: true, height: "4rem", offset: 50 },
	                                _react2.default.createElement('img', { className: _detailLess2.default["avatar"], src: item.userFace })
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: _detailLess2.default["res_info"] },
	                            _react2.default.createElement(
	                                'p',
	                                { className: _detailLess2.default["user_date"] },
	                                _react2.default.createElement(
	                                    'span',
	                                    { className: _detailLess2.default["username"] },
	                                    item.userNickName
	                                ),
	                                _react2.default.createElement(
	                                    'span',
	                                    { className: _detailLess2.default["timestamp"] },
	                                    item.addDate
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'p',
	                                { className: _detailLess2.default["content"] },
	                                item.noteBody
	                            )
	                        )
	                    );
	                }),
	                loading && _react2.default.createElement(
	                    'div',
	                    { className: _detailLess2.default["load_wrap"] },
	                    _react2.default.createElement('i', { className: _detailLess2.default["icon_loading"] })
	                ),
	                (isError || isEnd) && _react2.default.createElement(
	                    'p',
	                    { className: _detailLess2.default["list_tips"] },
	                    isError ? errMsg : endMsg
	                )
	            );
	        }
	    }]);
	
	    return Response;
	}(_react2.default.Component);
	
	var Footer = function (_React$Component7) {
	    _inherits(Footer, _React$Component7);
	
	    function Footer(props) {
	        _classCallCheck(this, Footer);
	
	        return _possibleConstructorReturn(this, (Footer.__proto__ || Object.getPrototypeOf(Footer)).call(this, props));
	    }
	
	    _createClass(Footer, [{
	        key: 'render',
	        value: function render() {
	            var _classNames13, _classNames14;
	
	            var _ref6 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props,
	                positionStyle = _ref6.positionStyle,
	                btnOpt = _ref6.btnOpt;
	
	            return _react2.default.createElement(
	                'footer',
	                { className: (0, _classnames2.default)((_classNames13 = {}, _defineProperty(_classNames13, _detailLess2.default["footer_wrap"], true), _defineProperty(_classNames13, _detailLess2.default["btn_wrap"], true), _classNames13)), style: positionStyle },
	                _react2.default.createElement(
	                    'a',
	                    { className: (0, _classnames2.default)((_classNames14 = {}, _defineProperty(_classNames14, _detailLess2.default["btn"], true), _defineProperty(_classNames14, _detailLess2.default["btn_primary"], true), _classNames14)), href: 'javascript:;', onClick: btnOpt.handle },
	                    btnOpt.text
	                )
	            );
	        }
	    }]);
	
	    return Footer;
	}(_react2.default.Component);
	
	var Input = function (_React$Component8) {
	    _inherits(Input, _React$Component8);
	
	    function Input(props) {
	        _classCallCheck(this, Input);
	
	        var _this10 = _possibleConstructorReturn(this, (Input.__proto__ || Object.getPrototypeOf(Input)).call(this, props));
	
	        console.log('input init');
	        return _this10;
	    }
	
	    _createClass(Input, [{
	        key: 'render',
	        value: function render() {
	            var _classNames15, _classNames16;
	
	            var _ref7 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props,
	                focusEvt = _ref7.focusEvt,
	                blurEvt = _ref7.blurEvt,
	                getInputRef = _ref7.getInputRef,
	                resSubmit = _ref7.resSubmit,
	                isHidden = _ref7.isHidden;
	
	            return _react2.default.createElement(
	                'form',
	                { className: (0, _classnames2.default)((_classNames15 = {}, _defineProperty(_classNames15, _detailLess2.default["input_wrap"], true), _defineProperty(_classNames15, _detailLess2.default["Hide"], isHidden), _classNames15)), onSubmit: resSubmit },
	                _react2.default.createElement('input', { className: _detailLess2.default["input_el"], onFocus: focusEvt, onBlur: blurEvt, ref: getInputRef }),
	                _react2.default.createElement(
	                    'button',
	                    { className: (0, _classnames2.default)((_classNames16 = {}, _defineProperty(_classNames16, _detailLess2.default["btn"], true), _defineProperty(_classNames16, _detailLess2.default["btn_plain"], true), _defineProperty(_classNames16, _detailLess2.default["btn_res_submit"], true), _classNames16)), type: 'submit' },
	                    '\u63D0\u4EA4'
	                )
	            );
	        }
	    }]);
	
	    return Input;
	}(_react2.default.Component);
	
	var Index = function (_React$Component9) {
	    _inherits(Index, _React$Component9);
	
	    function Index(props) {
	        _classCallCheck(this, Index);
	
	        var _this11 = _possibleConstructorReturn(this, (Index.__proto__ || Object.getPrototypeOf(Index)).call(this, props));
	
	        _this11.state = {
	            inputHidden: true // 保存`input`状态
	        };
	        _this11.offlineActivityId = _util2.default.parseQuery('offlineActivityId'); // TODO: url query !!!
	        _this11.btnText = ['我要报名', '已报名,看看其他活动', '已结束,看看其他活动', '已中奖,看看其他活动', '立即拍', '立即抽', '明天再来，看看其它活动', '继续抽奖', '邀请好友'];
	        _this11.initData();
	        _this11.stickyNotice = (0, _sticky.StickyDecorator)(_notice2.default);
	        _this11.StickyFooter = (0, _sticky.StickyDecorator)(Footer);
	        _this11.navHandle = _this11.navHandle.bind(_this11);
	        _this11.fetchResponseData = _this11.fetchResponseData.bind(_this11);
	        _this11.scrollLoadHandle = _this11.scrollLoadHandle.bind(_this11);
	        _this11.btnClickHandle = _this11.btnClickHandle.bind(_this11);
	        _this11.inputStatusToggle = _this11.inputStatusToggle.bind(_this11);
	        _this11.inputFocusEvt = _this11.inputFocusEvt.bind(_this11);
	        _this11.inputBlurEvt = _this11.inputBlurEvt.bind(_this11);
	        _this11.inputSubmitHandle = _this11.inputSubmitHandle.bind(_this11);
	        _this11.fetchUserData = _this11.fetchUserData.bind(_this11);
	        _this11.clientHeight = document.documentElement.clientHeight || document.body.clientHeight;
	        return _this11;
	    }
	
	    _createClass(Index, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.scrollContainer && this.scrollContainer.addEventListener('scroll', this._scrollLoadHandler = (0, _lodash2.default)(this.scrollLoadHandle, 50));
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextprops) {
	            if (!this._scrollLoadHandler) {
	                this._scrollLoadHandler && this.scrollContainer.addEventListener('scroll', this._scrollLoadHandler = (0, _lodash2.default)(this.scrollLoadHandle, 50));
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this12 = this;
	
	            var _ref8 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props,
	                NavData = _ref8.NavData,
	                DetailData = _ref8.DetailData,
	                ResData = _ref8.ResData,
	                UserData = _ref8.UserData;
	
	            var isVersion10 = _util2.default.isVersion10();
	            return DetailData.loading ? _react2.default.createElement('div', { className: isVersion10 ? "page_loading_v10" : "page_loading" }) : _react2.default.createElement(
	                'div',
	                { className: _detailLess2.default["detail_layout"], style: { height: this.clientHeight + 'px' } },
	                !this.state.destoryNotice && DetailData.noticeInfoVO && DetailData.noticeInfoVO.noticeText && DetailData.noticeInfoVO.noticeText.trim() && _react2.default.createElement(this.stickyNotice, { opt: {
	                        LSKEY: DetailData.noticeInfoVO.noticeId,
	                        defaultLS: true, // 默认存储LocalStorage
	                        frequency: 1 // 1天
	                    }, content: DetailData.noticeInfoVO.noticeText, clickHandle: function clickHandle(e) {
	                        e.preventDefault();
	                        _util2.default.handleRedir(DetailData.noticeInfoVO.noticeUrl || 'javascript:;');
	                    }, closeHandle: function closeHandle(e) {
	                        if (!_util2.default.shareRedirect()) return;
	                        _this12.setState({
	                            destoryNotice: true
	                        });
	                    }, topOffset: 0, setSticky: true }),
	                _react2.default.createElement(
	                    'section',
	                    { className: _detailLess2.default["detail_main"], ref: function ref(container) {
	                            return _this12.scrollContainer = _reactDom2.default.findDOMNode(container);
	                        } },
	                    _react2.default.createElement(Header, DetailData),
	                    _react2.default.createElement(Shop, { list: DetailData.activityShopInfoList || [] }),
	                    _react2.default.createElement(Nav, { NavData: NavData, navHandle: this.navHandle }),
	                    _react2.default.createElement(Detail, {
	                        DetailData: DetailData,
	                        UserData: UserData,
	                        isHidden: NavData.navCursor != NavData.staticData[0].id,
	                        fetchUserData: this.fetchUserData }),
	                    _react2.default.createElement(Response, {
	                        ResData: ResData,
	                        isHidden: NavData.navCursor != NavData.staticData[1].id,
	                        inputHidden: this.state.inputHidden,
	                        resAction: this.inputStatusToggle })
	                ),
	                NavData.navCursor == NavData.staticData[0].id && _react2.default.createElement(this.StickyFooter, { btnOpt: {
	                        text: DetailData.mode == 11 && this.btnText[4] || DetailData.mode == 13 && !DetailData.userApplyStatus && this.btnText[5] || DetailData.mode == 13 && DetailData.userApplyStatus == 1 && this.btnText[6] || DetailData.mode == 13 && DetailData.userApplyStatus == 4 && this.btnText[7] || DetailData.mode == 13 && DetailData.userApplyStatus == 5 && this.btnText[8] || this.btnText[DetailData.userApplyStatus],
	                        handle: this.btnClickHandle
	                    }, bottomOffset: 0, setSticky: true }),
	                NavData.navCursor == NavData.staticData[1].id && this.state.inputHidden && _react2.default.createElement(this.StickyFooter, { btnOpt: {
	                        text: '我要回应',
	                        handle: this.inputStatusToggle
	                    }, bottomOffset: 0, setSticky: true }),
	                _react2.default.createElement(Input, {
	                    resSubmit: this.inputSubmitHandle,
	                    getInputRef: function getInputRef(el) {
	                        return _this12.inputRef = _reactDom2.default.findDOMNode(el);
	                    },
	                    focusEvt: this.inputFocusEvt,
	                    blurEvt: this.inputBlurEvt,
	                    isHidden: this.state.inputHidden })
	            );
	        }
	    }, {
	        key: 'initData',
	        value: function initData() {
	            var _this13 = this;
	
	            var fetchDetailData = this.props.fetchDetailData;
	            // 详情
	
	            fetchDetailData('/activity/static/detail', {
	                offlineActivityId: this.offlineActivityId
	            }).then(function (r) {
	                if (window.performance) {
	                    try {
	                        timeing = window.performance.timing.navigationStart;
	
	                        Owl.addPoint({
	                            position: 1,
	                            duration: new Date() - timeing
	                        });
	                        Owl.sendPoints();
	                    } catch (e) {
	                        console.error(e);
	                    }
	                }
	                // 重置标题
	                _this13.resetTitle(r.data.detail.title);
	                // 获取用户名单
	                !!r.data.detail.releasedUsersCount && _this13.fetchUserData();
	                var shareInfo = r.data.detail.shareInfo;
	                shareInfo && new _utilMShare2.default({
	                    title: shareInfo.shareTitle,
	                    desc: shareInfo.shareDesc,
	                    url: shareInfo.shareUrl,
	                    image: shareInfo.sharePic,
	                    content: shareInfo.shareDesc,
	                    channelDPApp: [_utilMShare2.default.CHANNEL.WECHAT_FRIENDS, _utilMShare2.default.CHANNEL.WECHAT_TIMELINE],
	                    channelWX: [_utilMShare2.default.CHANNEL.WECHAT_FRIENDS, _utilMShare2.default.CHANNEL.WECHAT_TIMELINE],
	                    success: function success() {
	                        (0, _share_cb.shareSuccHandler)().then(function (r) {
	                            var addScore = r.msg.score;
	                            parseInt(addScore) && (0, _weppModuleToast2.default)('\u5206\u4EAB\u6210\u529F\uFF0C\u53C8\u589E\u52A0\u4E86' + addScore + '\u9738\u6C14\u503C');
	                        }).catch(function (e) {
	                            console.log('Exception', e);
	                        });
	                    }
	                });
	            }).catch(function (e) {
	                console.log('Exception', e);
	            });
	        }
	    }, {
	        key: 'resetTitle',
	        value: function resetTitle(title) {
	            if (!title) return;
	            if (_util2.default.isApp()) {
	                _knb2.default.setTitle({
	                    title: title //标题
	                });
	            } else {
	                document.title = title;
	            }
	        }
	    }, {
	        key: 'navHandle',
	        value: function navHandle(e) {
	            e.preventDefault();
	            var cursor = e.target.dataset.id;
	            if (!cursor) return;
	            if (!_util2.default.shareRedirect()) return;
	            var _props = this.props,
	                ResData = _props.ResData,
	                updateNavData = _props.updateNavData;
	
	            updateNavData({
	                navCursor: cursor
	            });
	            if (cursor == 'res' && !ResData.list.length && !ResData.isEnd) {
	                // 拉`回复`的初始数据
	                this.fetchResponseData();
	                // 打点
	                LXAnalytics('moduleClick', 'b_zsa2izig');
	            } else if (cursor == 'detail' && !this.state.inputHidden) {
	                // 收起`input`
	                this.inputStatusToggle();
	            }
	        }
	    }, {
	        key: 'scrollLoadHandle',
	        value: function scrollLoadHandle(e) {
	            var _this14 = this;
	
	            e.preventDefault();
	            // 说明：两个tab内容的滚动容器相同，`硬编码`判断当前内容是否可见
	            if (this.props.NavData.navCursor != 'res') return;
	            var _props$ResData = this.props.ResData,
	                isError = _props$ResData.isError,
	                isEnd = _props$ResData.isEnd,
	                loading = _props$ResData.loading;
	            // conditions
	
	            if (loading) {
	                return;
	            } else if (isEnd || isError) {
	                this.scrollContainer.removeEventListener('scroll', this._scrollLoadHandler);
	                // this._scrollLoadHandler = undefined; // 说明：`reset`可以用于重新初始化`scroll`事件
	                return;
	            }
	            setTimeout(function () {
	                var _scrollContainer = _this14.scrollContainer,
	                    scrollHeight = _scrollContainer.scrollHeight,
	                    scrollTop = _scrollContainer.scrollTop,
	                    clientHeight = _scrollContainer.clientHeight;
	
	                if (scrollTop) {
	                    // 可滚动容器
	                    if (scrollHeight - scrollTop - clientHeight <= MAXPRELOADHEIGHT) {
	                        // console.log('scrollHeight/scrollTop/clientHeight', scrollHeight, scrollTop, clientHeight)
	                        _this14.fetchResponseData();
	                    }
	                } else {
	                    // 不可滚动容器以视窗为准
	                    // const { bottom } = this.scrollContainer.getBoundingClientRect();
	                    // const distanceFromBottom = bottom - this._getViewPort().height;
	                    // if (-1 <= distanceFromBottom && distanceFromBottom < MAXPRELOADHEIGHT) { // HACK: 部分机器拉到底部可能会出现负数
	                    //     this.fetchResponseData();
	                    // }
	                }
	            }, 0);
	        }
	    }, {
	        key: 'fetchResponseData',
	        value: function fetchResponseData() {
	            var _props2 = this.props,
	                ResData = _props2.ResData,
	                fetchResData = _props2.fetchResData;
	
	            var page = parseInt(ResData.page) || 0;
	            fetchResData('/mobile/event/ajax/statics/activity/followList', {
	                offlineActivityId: this.offlineActivityId,
	                page: page + 1
	            }, 'GET', function (r) {
	                return r.data.curPage == page + 1;
	            }).then(function (r) {}).catch(function (e) {
	                console.log('Exceptioon', e);
	            });
	        }
	    }, {
	        key: 'fetchUserData',
	        value: function fetchUserData() {
	            var _props3 = this.props,
	                UserData = _props3.UserData,
	                fetchUsersData = _props3.fetchUsersData;
	            var page = UserData.page,
	                isEnd = UserData.isEnd,
	                isError = UserData.isError,
	                loading = UserData.loading;
	
	            if (isEnd || isError || loading) return;
	            if (page >= 1 && !_util2.default.shareRedirect()) return;
	            fetchUsersData('/activity/static/detail/releasedUsers', {
	                offlineActivityId: this.offlineActivityId,
	                page: page + 1
	            }, 'POST', function (r) {
	                return r.data.page == page + 1;
	            }).then(function (r) {}).catch(function (e) {
	                console.log('Exception', e);
	            });
	        }
	    }, {
	        key: 'btnClickHandle',
	        value: function btnClickHandle(e) {
	            if (!_util2.default.shareRedirect()) return;
	            var _props$DetailData = this.props.DetailData,
	                mode = _props$DetailData.mode,
	                userApplyStatus = _props$DetailData.userApplyStatus,
	                loginStatus = _props$DetailData.loginStatus,
	                moreActivityUrl = _props$DetailData.moreActivityUrl,
	                applyURL = _props$DetailData.applyURL;
	            // 暂时统一在当前webview打开
	
	            if (userApplyStatus && mode != 11) {
	                // 说明：DB竞拍可以一直拍
	                // 已报名/结束/中奖
	                LXAnalytics('moduleClick', 'b_y5o23cfa');
	                if (mode == 13 && userApplyStatus == 5) {
	                    //天天抽邀请好友
	                    location.href = applyURL.replace('apply/', 'success/') + '&fromdetail=1';
	                } else if (mode == 13 && userApplyStatus == 4) {
	                    location.href = applyURL;
	                } else {
	                    location.href = moreActivityUrl;
	                }
	            } else if (loginStatus) {
	                // 未报名
	                location.href = applyURL;
	            } else {
	                // 未登录
	                if (_util2.default.isApp()) {
	                    _util2.default.getToken().then(function () {
	                        // 说明：APP中登录成功后，需要手动获取登录态，因为页面无刷新
	                        location.href = applyURL;
	                    }, function () {
	                        (0, _utilLogin2.default)(function () {
	                            location.href = applyURL;
	                        });
	                    }).catch(function (e) {
	                        console.log('Exception', e);
	                    });
	                } else {
	                    (0, _utilLogin2.default)();
	                }
	            }
	        }
	    }, {
	        key: 'inputStatusToggle',
	        value: function inputStatusToggle() {
	            var _this15 = this;
	
	            if (!this.props.DetailData.loginStatus && _util2.default.isApp()) {
	                // APP中需要手动拿登录态
	                return _util2.default.getToken().then(function () {
	                    _this15.setState({
	                        inputHidden: !_this15.state.inputHidden
	                    });
	                    setTimeout(function () {
	                        _this15.state.inputHidden || _this15.inputRef.focus();
	                    }, 0);
	                }, function () {
	                    (0, _utilLogin2.default)(function () {
	                        _this15.inputStatusToggle();
	                    });
	                });
	            } else if (!this.props.DetailData.loginStatus) {
	                // M站
	                return (0, _utilLogin2.default)();
	            }
	            this.setState({
	                inputHidden: !this.state.inputHidden
	            });
	            setTimeout(function () {
	                _this15.state.inputHidden || _this15.inputRef.focus();
	            }, 0);
	        }
	    }, {
	        key: 'inputFocusEvt',
	        value: function inputFocusEvt(e) {
	            e.preventDefault();
	            this.originScrollTop = document.body.scrollTop; // 失焦重置scrollTop
	            // document.body.scrollTop = document.body.scrollHeight;
	            this.interval = setInterval(function () {
	                // FIXME: 键盘切换
	                document.body.scrollTop = document.body.scrollHeight;
	            }, 100);
	        }
	    }, {
	        key: 'inputBlurEvt',
	        value: function inputBlurEvt(e) {
	            e.preventDefault();
	            document.body.scrollTop = this.originScrollTop;
	            clearInterval(this.interval);
	        }
	    }, {
	        key: 'inputSubmitHandle',
	        value: function inputSubmitHandle(e) {
	            var _this16 = this;
	
	            e.preventDefault();
	            var content = this.inputRef.value.trim();
	            if (!content || this.isSubmitting) return;
	            this.isSubmitting = true; // 仅用来表示提交状态，与UI无关
	            _util2.default.reqwest('/activity/static/follow/add', {
	                offlineActivityId: this.offlineActivityId,
	                noteBody: content
	            }, 'POST').then(function (r) {
	                // TODO: 新增`回应`展示逻辑
	                if (r.code != 200 || !r.data) {
	                    return (0, _weppModuleToast2.default)('出错了');
	                }
	                var addResData = _this16.props.addResData;
	
	                addResData({
	                    noteBody: r.data.noteBody || content,
	                    userNickName: r.data.userNickName || '点评用户',
	                    userFace: r.data.userFace,
	                    addDate: (0, _date_format.formatDate)(r.data.addTime, 'MM-dd HH:mm', '-')
	                });
	                _this16.inputStatusToggle(); // 关闭`input`
	                _this16.inputRef.value = ''; // 提交成功，清空`input`
	                _this16.isSubmitting = false; // reset 状态
	            }).catch(function (e) {
	                console.log('Exception', e);
	            });
	        }
	    }]);
	
	    return Index;
	}(_react2.default.Component);
	
	var formatDetailData = (0, _reselect.createSelector)([function (state) {
	    return state.DetailData;
	}], function (detailData) {
	    var fields = ['activityTips', 'winTips', 'activityContent', 'activityExplain', 'kindTips'];
	    fields.map(function (field) {
	        typeof detailData[field] == 'string' && (detailData[field] = detailData[field].split('\r\n'));
	    });
	    return detailData;
	});
	
	exports.default = (0, _reactRedux.connect)(function (state) {
	    return {
	        DetailData: formatDetailData(state),
	        NavData: state.NavData,
	        ResData: state.ResData,
	        UserData: state.UserData
	    };
	}, _extends({}, Action))(Index);

/***/ }),
/* 538 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.defaultMemoize = defaultMemoize;
	exports.createSelectorCreator = createSelectorCreator;
	exports.createStructuredSelector = createStructuredSelector;
	function defaultEqualityCheck(a, b) {
	  return a === b;
	}
	
	function areArgumentsShallowlyEqual(equalityCheck, prev, next) {
	  if (prev === null || next === null || prev.length !== next.length) {
	    return false;
	  }
	
	  // Do this in a for loop (and not a `forEach` or an `every`) so we can determine equality as fast as possible.
	  var length = prev.length;
	  for (var i = 0; i < length; i++) {
	    if (!equalityCheck(prev[i], next[i])) {
	      return false;
	    }
	  }
	
	  return true;
	}
	
	function defaultMemoize(func) {
	  var equalityCheck = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultEqualityCheck;
	
	  var lastArgs = null;
	  var lastResult = null;
	  // we reference arguments instead of spreading them for performance reasons
	  return function () {
	    if (!areArgumentsShallowlyEqual(equalityCheck, lastArgs, arguments)) {
	      // apply arguments instead of spreading for performance.
	      lastResult = func.apply(null, arguments);
	    }
	
	    lastArgs = arguments;
	    return lastResult;
	  };
	}
	
	function getDependencies(funcs) {
	  var dependencies = Array.isArray(funcs[0]) ? funcs[0] : funcs;
	
	  if (!dependencies.every(function (dep) {
	    return typeof dep === 'function';
	  })) {
	    var dependencyTypes = dependencies.map(function (dep) {
	      return typeof dep;
	    }).join(', ');
	    throw new Error('Selector creators expect all input-selectors to be functions, ' + ('instead received the following types: [' + dependencyTypes + ']'));
	  }
	
	  return dependencies;
	}
	
	function createSelectorCreator(memoize) {
	  for (var _len = arguments.length, memoizeOptions = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	    memoizeOptions[_key - 1] = arguments[_key];
	  }
	
	  return function () {
	    for (var _len2 = arguments.length, funcs = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	      funcs[_key2] = arguments[_key2];
	    }
	
	    var recomputations = 0;
	    var resultFunc = funcs.pop();
	    var dependencies = getDependencies(funcs);
	
	    var memoizedResultFunc = memoize.apply(undefined, [function () {
	      recomputations++;
	      // apply arguments instead of spreading for performance.
	      return resultFunc.apply(null, arguments);
	    }].concat(memoizeOptions));
	
	    // If a selector is called with the exact same arguments we don't need to traverse our dependencies again.
	    var selector = defaultMemoize(function () {
	      var params = [];
	      var length = dependencies.length;
	
	      for (var i = 0; i < length; i++) {
	        // apply arguments instead of spreading and mutate a local list of params for performance.
	        params.push(dependencies[i].apply(null, arguments));
	      }
	
	      // apply arguments instead of spreading for performance.
	      return memoizedResultFunc.apply(null, params);
	    });
	
	    selector.resultFunc = resultFunc;
	    selector.recomputations = function () {
	      return recomputations;
	    };
	    selector.resetRecomputations = function () {
	      return recomputations = 0;
	    };
	    return selector;
	  };
	}
	
	var createSelector = exports.createSelector = createSelectorCreator(defaultMemoize);
	
	function createStructuredSelector(selectors) {
	  var selectorCreator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : createSelector;
	
	  if (typeof selectors !== 'object') {
	    throw new Error('createStructuredSelector expects first argument to be an object ' + ('where each property is a selector, instead received a ' + typeof selectors));
	  }
	  var objectKeys = Object.keys(selectors);
	  return selectorCreator(objectKeys.map(function (key) {
	    return selectors[key];
	  }), function () {
	    for (var _len3 = arguments.length, values = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
	      values[_key3] = arguments[_key3];
	    }
	
	    return values.reduce(function (composition, value, index) {
	      composition[objectKeys[index]] = value;
	      return composition;
	    }, {});
	  });
	}

/***/ }),
/* 539 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.forceCheck = exports.lazyload = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(73);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(105);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _propTypes = __webpack_require__(267);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _event = __webpack_require__(540);
	
	var _scrollParent = __webpack_require__(541);
	
	var _scrollParent2 = _interopRequireDefault(_scrollParent);
	
	var _debounce = __webpack_require__(542);
	
	var _debounce2 = _interopRequireDefault(_debounce);
	
	var _throttle = __webpack_require__(543);
	
	var _throttle2 = _interopRequireDefault(_throttle);
	
	var _decorator = __webpack_require__(544);
	
	var _decorator2 = _interopRequireDefault(_decorator);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * react-lazyload
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	
	var defaultBoundingClientRect = { top: 0, right: 0, bottom: 0, left: 0, width: 0, height: 0 };
	var LISTEN_FLAG = 'data-lazyload-listened';
	var listeners = [];
	var pending = [];
	
	// try to handle passive events
	var passiveEventSupported = false;
	try {
	  var opts = Object.defineProperty({}, 'passive', {
	    get: function get() {
	      passiveEventSupported = true;
	    }
	  });
	  window.addEventListener('test', null, opts);
	} catch (e) {}
	// if they are supported, setup the optional params
	// IMPORTANT: FALSE doubles as the default CAPTURE value!
	var passiveEvent = passiveEventSupported ? { capture: false, passive: true } : false;
	
	/**
	 * Check if `component` is visible in overflow container `parent`
	 * @param  {node} component React component
	 * @param  {node} parent    component's scroll parent
	 * @return {bool}
	 */
	var checkOverflowVisible = function checkOverflowVisible(component, parent) {
	  var node = _reactDom2.default.findDOMNode(component);
	
	  var parentTop = void 0;
	  var parentHeight = void 0;
	
	  try {
	    var _parent$getBoundingCl = parent.getBoundingClientRect();
	
	    parentTop = _parent$getBoundingCl.top;
	    parentHeight = _parent$getBoundingCl.height;
	  } catch (e) {
	    parentTop = defaultBoundingClientRect.top;
	    parentHeight = defaultBoundingClientRect.height;
	  }
	
	  var windowInnerHeight = window.innerHeight || document.documentElement.clientHeight;
	
	  // calculate top and height of the intersection of the element's scrollParent and viewport
	  var intersectionTop = Math.max(parentTop, 0); // intersection's top relative to viewport
	  var intersectionHeight = Math.min(windowInnerHeight, parentTop + parentHeight) - intersectionTop; // height
	
	  // check whether the element is visible in the intersection
	  var top = void 0;
	  var height = void 0;
	
	  try {
	    var _node$getBoundingClie = node.getBoundingClientRect();
	
	    top = _node$getBoundingClie.top;
	    height = _node$getBoundingClie.height;
	  } catch (e) {
	    top = defaultBoundingClientRect.top;
	    height = defaultBoundingClientRect.height;
	  }
	
	  var offsetTop = top - intersectionTop; // element's top relative to intersection
	
	  var offsets = Array.isArray(component.props.offset) ? component.props.offset : [component.props.offset, component.props.offset]; // Be compatible with previous API
	
	  return offsetTop - offsets[0] <= intersectionHeight && offsetTop + height + offsets[1] >= 0;
	};
	
	/**
	 * Check if `component` is visible in document
	 * @param  {node} component React component
	 * @return {bool}
	 */
	var checkNormalVisible = function checkNormalVisible(component) {
	  var node = _reactDom2.default.findDOMNode(component);
	
	  // If this element is hidden by css rules somehow, it's definitely invisible
	  if (!(node.offsetWidth || node.offsetHeight || node.getClientRects().length)) return false;
	
	  var top = void 0;
	  var elementHeight = void 0;
	
	  try {
	    var _node$getBoundingClie2 = node.getBoundingClientRect();
	
	    top = _node$getBoundingClie2.top;
	    elementHeight = _node$getBoundingClie2.height;
	  } catch (e) {
	    top = defaultBoundingClientRect.top;
	    elementHeight = defaultBoundingClientRect.height;
	  }
	
	  var windowInnerHeight = window.innerHeight || document.documentElement.clientHeight;
	
	  var offsets = Array.isArray(component.props.offset) ? component.props.offset : [component.props.offset, component.props.offset]; // Be compatible with previous API
	
	  return top - offsets[0] <= windowInnerHeight && top + elementHeight + offsets[1] >= 0;
	};
	
	/**
	 * Detect if element is visible in viewport, if so, set `visible` state to true.
	 * If `once` prop is provided true, remove component as listener after checkVisible
	 *
	 * @param  {React} component   React component that respond to scroll and resize
	 */
	var checkVisible = function checkVisible(component) {
	  var node = _reactDom2.default.findDOMNode(component);
	  if (!node) {
	    return;
	  }
	
	  var parent = (0, _scrollParent2.default)(node);
	  var isOverflow = component.props.overflow && parent !== node.ownerDocument && parent !== document && parent !== document.documentElement;
	  var visible = isOverflow ? checkOverflowVisible(component, parent) : checkNormalVisible(component);
	  if (visible) {
	    // Avoid extra render if previously is visible
	    if (!component.visible) {
	      if (component.props.once) {
	        pending.push(component);
	      }
	
	      component.visible = true;
	      component.forceUpdate();
	    }
	  } else if (!(component.props.once && component.visible)) {
	    component.visible = false;
	    if (component.props.unmountIfInvisible) {
	      component.forceUpdate();
	    }
	  }
	};
	
	var purgePending = function purgePending() {
	  pending.forEach(function (component) {
	    var index = listeners.indexOf(component);
	    if (index !== -1) {
	      listeners.splice(index, 1);
	    }
	  });
	
	  pending = [];
	};
	
	var lazyLoadHandler = function lazyLoadHandler() {
	  for (var i = 0; i < listeners.length; ++i) {
	    var listener = listeners[i];
	    checkVisible(listener);
	  }
	  // Remove `once` component in listeners
	  purgePending();
	};
	
	// Depending on component's props
	var delayType = void 0;
	var finalLazyLoadHandler = null;
	
	var LazyLoad = function (_Component) {
	  _inherits(LazyLoad, _Component);
	
	  function LazyLoad(props) {
	    _classCallCheck(this, LazyLoad);
	
	    var _this = _possibleConstructorReturn(this, (LazyLoad.__proto__ || Object.getPrototypeOf(LazyLoad)).call(this, props));
	
	    _this.visible = false;
	    return _this;
	  }
	
	  _createClass(LazyLoad, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      if (typeof process !== 'undefined' && ("production") !== 'production') {
	        if (_react2.default.Children.count(this.props.children) > 1) {
	          console.warn('[react-lazyload] Only one child is allowed to be passed to `LazyLoad`.');
	        }
	
	        if (this.props.wheel) {
	          // eslint-disable-line
	          console.warn('[react-lazyload] Props `wheel` is not supported anymore, try set `overflow` for lazy loading in overflow containers.');
	        }
	
	        // Warn the user if placeholder and height is not specified and the rendered height is 0
	        if (!this.props.placeholder && this.props.height === undefined && _reactDom2.default.findDOMNode(this).offsetHeight === 0) {
	          console.warn('[react-lazyload] Please add `height` props to <LazyLoad> for better performance.');
	        }
	      }
	
	      // It's unlikely to change delay type on the fly, this is mainly
	      // designed for tests
	      var needResetFinalLazyLoadHandler = false;
	      if (this.props.debounce !== undefined && delayType === 'throttle') {
	        console.warn('[react-lazyload] Previous delay function is `throttle`, now switching to `debounce`, try setting them unanimously');
	        needResetFinalLazyLoadHandler = true;
	      } else if (delayType === 'debounce' && this.props.debounce === undefined) {
	        console.warn('[react-lazyload] Previous delay function is `debounce`, now switching to `throttle`, try setting them unanimously');
	        needResetFinalLazyLoadHandler = true;
	      }
	
	      if (needResetFinalLazyLoadHandler) {
	        (0, _event.off)(window, 'scroll', finalLazyLoadHandler, passiveEvent);
	        (0, _event.off)(window, 'resize', finalLazyLoadHandler, passiveEvent);
	        finalLazyLoadHandler = null;
	      }
	
	      if (!finalLazyLoadHandler) {
	        if (this.props.debounce !== undefined) {
	          finalLazyLoadHandler = (0, _debounce2.default)(lazyLoadHandler, typeof this.props.debounce === 'number' ? this.props.debounce : 300);
	          delayType = 'debounce';
	        } else if (this.props.throttle !== undefined) {
	          finalLazyLoadHandler = (0, _throttle2.default)(lazyLoadHandler, typeof this.props.throttle === 'number' ? this.props.throttle : 300);
	          delayType = 'throttle';
	        } else {
	          finalLazyLoadHandler = lazyLoadHandler;
	        }
	      }
	
	      if (this.props.overflow) {
	        var parent = (0, _scrollParent2.default)(_reactDom2.default.findDOMNode(this));
	        if (parent && typeof parent.getAttribute === 'function') {
	          var listenerCount = 1 + +parent.getAttribute(LISTEN_FLAG);
	          if (listenerCount === 1) {
	            parent.addEventListener('scroll', finalLazyLoadHandler, passiveEvent);
	          }
	          parent.setAttribute(LISTEN_FLAG, listenerCount);
	        }
	      } else if (listeners.length === 0 || needResetFinalLazyLoadHandler) {
	        var _props = this.props,
	            scroll = _props.scroll,
	            resize = _props.resize;
	
	
	        if (scroll) {
	          (0, _event.on)(window, 'scroll', finalLazyLoadHandler, passiveEvent);
	        }
	
	        if (resize) {
	          (0, _event.on)(window, 'resize', finalLazyLoadHandler, passiveEvent);
	        }
	      }
	
	      listeners.push(this);
	      checkVisible(this);
	    }
	  }, {
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate() {
	      return this.visible;
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      if (this.props.overflow) {
	        var parent = (0, _scrollParent2.default)(_reactDom2.default.findDOMNode(this));
	        if (parent && typeof parent.getAttribute === 'function') {
	          var listenerCount = +parent.getAttribute(LISTEN_FLAG) - 1;
	          if (listenerCount === 0) {
	            parent.removeEventListener('scroll', finalLazyLoadHandler, passiveEvent);
	            parent.removeAttribute(LISTEN_FLAG);
	          } else {
	            parent.setAttribute(LISTEN_FLAG, listenerCount);
	          }
	        }
	      }
	
	      var index = listeners.indexOf(this);
	      if (index !== -1) {
	        listeners.splice(index, 1);
	      }
	
	      if (listeners.length === 0) {
	        (0, _event.off)(window, 'resize', finalLazyLoadHandler, passiveEvent);
	        (0, _event.off)(window, 'scroll', finalLazyLoadHandler, passiveEvent);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return this.visible ? this.props.children : this.props.placeholder ? this.props.placeholder : _react2.default.createElement('div', { style: { height: this.props.height }, className: 'lazyload-placeholder' });
	    }
	  }]);
	
	  return LazyLoad;
	}(_react.Component);
	
	LazyLoad.propTypes = {
	  once: _propTypes2.default.bool,
	  height: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	  offset: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.arrayOf(_propTypes2.default.number)]),
	  overflow: _propTypes2.default.bool,
	  resize: _propTypes2.default.bool,
	  scroll: _propTypes2.default.bool,
	  children: _propTypes2.default.node,
	  throttle: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.bool]),
	  debounce: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.bool]),
	  placeholder: _propTypes2.default.node,
	  unmountIfInvisible: _propTypes2.default.bool
	};
	
	LazyLoad.defaultProps = {
	  once: false,
	  offset: 0,
	  overflow: false,
	  resize: false,
	  scroll: true,
	  unmountIfInvisible: false
	};
	
	var lazyload = exports.lazyload = _decorator2.default;
	exports.default = LazyLoad;
	exports.forceCheck = lazyLoadHandler;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(188)))

/***/ }),
/* 540 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.on = on;
	exports.off = off;
	function on(el, eventName, callback, opts) {
	  opts = opts || false;
	  if (el.addEventListener) {
	    el.addEventListener(eventName, callback, opts);
	  } else if (el.attachEvent) {
	    el.attachEvent("on" + eventName, function (e) {
	      callback.call(el, e || window.event);
	    });
	  }
	}
	
	function off(el, eventName, callback, opts) {
	  opts = opts || false;
	  if (el.removeEventListener) {
	    el.removeEventListener(eventName, callback, opts);
	  } else if (el.detachEvent) {
	    el.detachEvent("on" + eventName, callback);
	  }
	}

/***/ }),
/* 541 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	/**
	 * @fileOverview Find scroll parent
	 */
	
	exports.default = function (node) {
	  if (!node) {
	    return document.documentElement;
	  }
	
	  var excludeStaticParent = node.style.position === 'absolute';
	  var overflowRegex = /(scroll|auto)/;
	  var parent = node;
	
	  while (parent) {
	    if (!parent.parentNode) {
	      return node.ownerDocument || document.documentElement;
	    }
	
	    var style = window.getComputedStyle(parent);
	    var position = style.position;
	    var overflow = style.overflow;
	    var overflowX = style['overflow-x'];
	    var overflowY = style['overflow-y'];
	
	    if (position === 'static' && excludeStaticParent) {
	      parent = parent.parentNode;
	      continue;
	    }
	
	    if (overflowRegex.test(overflow) && overflowRegex.test(overflowX) && overflowRegex.test(overflowY)) {
	      return parent;
	    }
	
	    parent = parent.parentNode;
	  }
	
	  return node.ownerDocument || node.documentElement || document.documentElement;
	};

/***/ }),
/* 542 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = debounce;
	function debounce(func, wait, immediate) {
	  var timeout = void 0;
	  var args = void 0;
	  var context = void 0;
	  var timestamp = void 0;
	  var result = void 0;
	
	  var later = function later() {
	    var last = +new Date() - timestamp;
	
	    if (last < wait && last >= 0) {
	      timeout = setTimeout(later, wait - last);
	    } else {
	      timeout = null;
	      if (!immediate) {
	        result = func.apply(context, args);
	        if (!timeout) {
	          context = null;
	          args = null;
	        }
	      }
	    }
	  };
	
	  return function debounced() {
	    context = this;
	    args = arguments;
	    timestamp = +new Date();
	
	    var callNow = immediate && !timeout;
	    if (!timeout) {
	      timeout = setTimeout(later, wait);
	    }
	
	    if (callNow) {
	      result = func.apply(context, args);
	      context = null;
	      args = null;
	    }
	
	    return result;
	  };
	}

/***/ }),
/* 543 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = throttle;
	/*eslint-disable */
	function throttle(fn, threshhold, scope) {
	  threshhold || (threshhold = 250);
	  var last, deferTimer;
	  return function () {
	    var context = scope || this;
	
	    var now = +new Date(),
	        args = arguments;
	    if (last && now < last + threshhold) {
	      // hold on to it
	      clearTimeout(deferTimer);
	      deferTimer = setTimeout(function () {
	        last = now;
	        fn.apply(context, args);
	      }, threshhold);
	    } else {
	      last = now;
	      fn.apply(context, args);
	    }
	  };
	}

/***/ }),
/* 544 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(73);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _index = __webpack_require__(539);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var getDisplayName = function getDisplayName(WrappedComponent) {
	  return WrappedComponent.displayName || WrappedComponent.name || 'Component';
	};
	
	exports.default = function () {
	  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  return function lazyload(WrappedComponent) {
	    return function (_Component) {
	      _inherits(LazyLoadDecorated, _Component);
	
	      function LazyLoadDecorated() {
	        _classCallCheck(this, LazyLoadDecorated);
	
	        var _this = _possibleConstructorReturn(this, (LazyLoadDecorated.__proto__ || Object.getPrototypeOf(LazyLoadDecorated)).call(this));
	
	        _this.displayName = 'LazyLoad' + getDisplayName(WrappedComponent);
	        return _this;
	      }
	
	      _createClass(LazyLoadDecorated, [{
	        key: 'render',
	        value: function render() {
	          return _react2.default.createElement(
	            _index2.default,
	            options,
	            _react2.default.createElement(WrappedComponent, this.props)
	          );
	        }
	      }]);
	
	      return LazyLoadDecorated;
	    }(_react.Component);
	  };
	};

/***/ }),
/* 545 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * lodash (Custom Build) <https://lodash.com/>
	 * Build: `lodash modularize exports="npm" -o ./`
	 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	
	/** Used as the `TypeError` message for "Functions" methods. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/** Used as references for various `Number` constants. */
	var NAN = 0 / 0;
	
	/** `Object#toString` result references. */
	var symbolTag = '[object Symbol]';
	
	/** Used to match leading and trailing whitespace. */
	var reTrim = /^\s+|\s+$/g;
	
	/** Used to detect bad signed hexadecimal string values. */
	var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
	
	/** Used to detect binary string values. */
	var reIsBinary = /^0b[01]+$/i;
	
	/** Used to detect octal string values. */
	var reIsOctal = /^0o[0-7]+$/i;
	
	/** Built-in method references without a dependency on `root`. */
	var freeParseInt = parseInt;
	
	/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max,
	    nativeMin = Math.min;
	
	/**
	 * Gets the timestamp of the number of milliseconds that have elapsed since
	 * the Unix epoch (1 January 1970 00:00:00 UTC).
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Date
	 * @returns {number} Returns the timestamp.
	 * @example
	 *
	 * _.defer(function(stamp) {
	 *   console.log(_.now() - stamp);
	 * }, _.now());
	 * // => Logs the number of milliseconds it took for the deferred invocation.
	 */
	var now = function() {
	  return root.Date.now();
	};
	
	/**
	 * Creates a debounced function that delays invoking `func` until after `wait`
	 * milliseconds have elapsed since the last time the debounced function was
	 * invoked. The debounced function comes with a `cancel` method to cancel
	 * delayed `func` invocations and a `flush` method to immediately invoke them.
	 * Provide `options` to indicate whether `func` should be invoked on the
	 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
	 * with the last arguments provided to the debounced function. Subsequent
	 * calls to the debounced function return the result of the last `func`
	 * invocation.
	 *
	 * **Note:** If `leading` and `trailing` options are `true`, `func` is
	 * invoked on the trailing edge of the timeout only if the debounced function
	 * is invoked more than once during the `wait` timeout.
	 *
	 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	 *
	 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	 * for details over the differences between `_.debounce` and `_.throttle`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to debounce.
	 * @param {number} [wait=0] The number of milliseconds to delay.
	 * @param {Object} [options={}] The options object.
	 * @param {boolean} [options.leading=false]
	 *  Specify invoking on the leading edge of the timeout.
	 * @param {number} [options.maxWait]
	 *  The maximum time `func` is allowed to be delayed before it's invoked.
	 * @param {boolean} [options.trailing=true]
	 *  Specify invoking on the trailing edge of the timeout.
	 * @returns {Function} Returns the new debounced function.
	 * @example
	 *
	 * // Avoid costly calculations while the window size is in flux.
	 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
	 *
	 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
	 * jQuery(element).on('click', _.debounce(sendMail, 300, {
	 *   'leading': true,
	 *   'trailing': false
	 * }));
	 *
	 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
	 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
	 * var source = new EventSource('/stream');
	 * jQuery(source).on('message', debounced);
	 *
	 * // Cancel the trailing debounced invocation.
	 * jQuery(window).on('popstate', debounced.cancel);
	 */
	function debounce(func, wait, options) {
	  var lastArgs,
	      lastThis,
	      maxWait,
	      result,
	      timerId,
	      lastCallTime,
	      lastInvokeTime = 0,
	      leading = false,
	      maxing = false,
	      trailing = true;
	
	  if (typeof func != 'function') {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  wait = toNumber(wait) || 0;
	  if (isObject(options)) {
	    leading = !!options.leading;
	    maxing = 'maxWait' in options;
	    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
	    trailing = 'trailing' in options ? !!options.trailing : trailing;
	  }
	
	  function invokeFunc(time) {
	    var args = lastArgs,
	        thisArg = lastThis;
	
	    lastArgs = lastThis = undefined;
	    lastInvokeTime = time;
	    result = func.apply(thisArg, args);
	    return result;
	  }
	
	  function leadingEdge(time) {
	    // Reset any `maxWait` timer.
	    lastInvokeTime = time;
	    // Start the timer for the trailing edge.
	    timerId = setTimeout(timerExpired, wait);
	    // Invoke the leading edge.
	    return leading ? invokeFunc(time) : result;
	  }
	
	  function remainingWait(time) {
	    var timeSinceLastCall = time - lastCallTime,
	        timeSinceLastInvoke = time - lastInvokeTime,
	        result = wait - timeSinceLastCall;
	
	    return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
	  }
	
	  function shouldInvoke(time) {
	    var timeSinceLastCall = time - lastCallTime,
	        timeSinceLastInvoke = time - lastInvokeTime;
	
	    // Either this is the first call, activity has stopped and we're at the
	    // trailing edge, the system time has gone backwards and we're treating
	    // it as the trailing edge, or we've hit the `maxWait` limit.
	    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
	      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
	  }
	
	  function timerExpired() {
	    var time = now();
	    if (shouldInvoke(time)) {
	      return trailingEdge(time);
	    }
	    // Restart the timer.
	    timerId = setTimeout(timerExpired, remainingWait(time));
	  }
	
	  function trailingEdge(time) {
	    timerId = undefined;
	
	    // Only invoke if we have `lastArgs` which means `func` has been
	    // debounced at least once.
	    if (trailing && lastArgs) {
	      return invokeFunc(time);
	    }
	    lastArgs = lastThis = undefined;
	    return result;
	  }
	
	  function cancel() {
	    if (timerId !== undefined) {
	      clearTimeout(timerId);
	    }
	    lastInvokeTime = 0;
	    lastArgs = lastCallTime = lastThis = timerId = undefined;
	  }
	
	  function flush() {
	    return timerId === undefined ? result : trailingEdge(now());
	  }
	
	  function debounced() {
	    var time = now(),
	        isInvoking = shouldInvoke(time);
	
	    lastArgs = arguments;
	    lastThis = this;
	    lastCallTime = time;
	
	    if (isInvoking) {
	      if (timerId === undefined) {
	        return leadingEdge(lastCallTime);
	      }
	      if (maxing) {
	        // Handle invocations in a tight loop.
	        timerId = setTimeout(timerExpired, wait);
	        return invokeFunc(lastCallTime);
	      }
	    }
	    if (timerId === undefined) {
	      timerId = setTimeout(timerExpired, wait);
	    }
	    return result;
	  }
	  debounced.cancel = cancel;
	  debounced.flush = flush;
	  return debounced;
	}
	
	/**
	 * Creates a throttled function that only invokes `func` at most once per
	 * every `wait` milliseconds. The throttled function comes with a `cancel`
	 * method to cancel delayed `func` invocations and a `flush` method to
	 * immediately invoke them. Provide `options` to indicate whether `func`
	 * should be invoked on the leading and/or trailing edge of the `wait`
	 * timeout. The `func` is invoked with the last arguments provided to the
	 * throttled function. Subsequent calls to the throttled function return the
	 * result of the last `func` invocation.
	 *
	 * **Note:** If `leading` and `trailing` options are `true`, `func` is
	 * invoked on the trailing edge of the timeout only if the throttled function
	 * is invoked more than once during the `wait` timeout.
	 *
	 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	 *
	 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	 * for details over the differences between `_.throttle` and `_.debounce`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to throttle.
	 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
	 * @param {Object} [options={}] The options object.
	 * @param {boolean} [options.leading=true]
	 *  Specify invoking on the leading edge of the timeout.
	 * @param {boolean} [options.trailing=true]
	 *  Specify invoking on the trailing edge of the timeout.
	 * @returns {Function} Returns the new throttled function.
	 * @example
	 *
	 * // Avoid excessively updating the position while scrolling.
	 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
	 *
	 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
	 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
	 * jQuery(element).on('click', throttled);
	 *
	 * // Cancel the trailing throttled invocation.
	 * jQuery(window).on('popstate', throttled.cancel);
	 */
	function throttle(func, wait, options) {
	  var leading = true,
	      trailing = true;
	
	  if (typeof func != 'function') {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  if (isObject(options)) {
	    leading = 'leading' in options ? !!options.leading : leading;
	    trailing = 'trailing' in options ? !!options.trailing : trailing;
	  }
	  return debounce(func, wait, {
	    'leading': leading,
	    'maxWait': wait,
	    'trailing': trailing
	  });
	}
	
	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}
	
	/**
	 * Checks if `value` is classified as a `Symbol` primitive or object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	 * @example
	 *
	 * _.isSymbol(Symbol.iterator);
	 * // => true
	 *
	 * _.isSymbol('abc');
	 * // => false
	 */
	function isSymbol(value) {
	  return typeof value == 'symbol' ||
	    (isObjectLike(value) && objectToString.call(value) == symbolTag);
	}
	
	/**
	 * Converts `value` to a number.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to process.
	 * @returns {number} Returns the number.
	 * @example
	 *
	 * _.toNumber(3.2);
	 * // => 3.2
	 *
	 * _.toNumber(Number.MIN_VALUE);
	 * // => 5e-324
	 *
	 * _.toNumber(Infinity);
	 * // => Infinity
	 *
	 * _.toNumber('3.2');
	 * // => 3.2
	 */
	function toNumber(value) {
	  if (typeof value == 'number') {
	    return value;
	  }
	  if (isSymbol(value)) {
	    return NAN;
	  }
	  if (isObject(value)) {
	    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
	    value = isObject(other) ? (other + '') : other;
	  }
	  if (typeof value != 'string') {
	    return value === 0 ? value : +value;
	  }
	  value = value.replace(reTrim, '');
	  var isBinary = reIsBinary.test(value);
	  return (isBinary || reIsOctal.test(value))
	    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
	    : (reIsBadHex.test(value) ? NAN : +value);
	}
	
	module.exports = throttle;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 546 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.StickyDecorator = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(73);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(105);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _lodash = __webpack_require__(545);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * 高阶组件，提供`sticky`功能
	 * 针对浏览器端和安卓设备上scroll事件连续触发:
	 *  lodash.throttle(func, 50) // https://lodash.com/docs#throttle
	 *  setTimeout(func, 0) // 计算元素的layout属性将引起reflow, 异步处理
	 *  window.requestAnimationFrame(func) // 平滑性更好
	 * @param {*} WrappedComponent 
	 */
	
	/**
	 * TODO: 
	 * iOS sticky css优化（不支持callback）
	 * 指定父容器
	 * 滚动吸底
	 */
	
	var StickyDecorator = exports.StickyDecorator = function StickyDecorator(WrappedComponent) {
	    return function (_React$Component) {
	        _inherits(_class, _React$Component);
	
	        function _class(props) {
	            _classCallCheck(this, _class);
	
	            var _this = _possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).call(this, props));
	
	            _this.state = {};
	            // 默认吸顶
	            if (props.bottomOffset !== undefined) {
	                _this.bottomSticky = true;
	            } else {
	                _this.topSticky = true;
	            }
	            return _this;
	        }
	
	        _createClass(_class, [{
	            key: 'componentWillMount',
	            value: function componentWillMount() {
	                // 默认监听容器`window`
	                var _props = this.props,
	                    _props$scrollContaine = _props.scrollContainer,
	                    scrollContainer = _props$scrollContaine === undefined ? window : _props$scrollContaine,
	                    setSticky = _props.setSticky;
	
	                scrollContainer.addEventListener('touchmove', this._scrollHandler = (0, _lodash2.default)(this.scrollHandle.bind(this), 50));
	                this.scrollContainer = scrollContainer;
	                setSticky && this._triggerHandler(setSticky);
	            }
	        }, {
	            key: 'componentDidMount',
	            value: function componentDidMount() {
	                var _this2 = this;
	
	                setTimeout(function () {
	                    if (!_this2.content) return;
	
	                    var _content$getBoundingC = _this2.content.getBoundingClientRect(),
	                        left = _content$getBoundingC.left,
	                        right = _content$getBoundingC.right,
	                        width = _content$getBoundingC.width,
	                        height = _content$getBoundingC.height;
	
	                    _this2.setState({
	                        originWidth: width,
	                        originHeight: height,
	                        originFromLeft: left,
	                        originFromRight: right
	                    });
	                }, 0);
	            }
	        }, {
	            key: 'componentDidUpdate',
	            value: function componentDidUpdate() {
	                this.placeholder.style.paddingBottom = (this.state.isSticky ? this.state.originHeight : 0) + 'px';
	            }
	        }, {
	            key: 'componentWillReceiveProps',
	            value: function componentWillReceiveProps(nextProps) {
	                var setSticky = nextProps.setSticky;
	
	                if (setSticky === undefined || setSticky === this.state.isSticky) return;
	                if (!this.state.originHeight) {
	                    // 说明：初始化时不可见
	                    var _content$getBoundingC2 = this.content.getBoundingClientRect(),
	                        left = _content$getBoundingC2.left,
	                        right = _content$getBoundingC2.right,
	                        width = _content$getBoundingC2.width,
	                        height = _content$getBoundingC2.height;
	
	                    this.setState({
	                        originWidth: width,
	                        originHeight: height,
	                        originFromLeft: left,
	                        originFromRight: right
	                    });
	                }
	                this._triggerHandler(setSticky);
	            }
	        }, {
	            key: 'componentWillUnmount',
	            value: function componentWillUnmount() {
	                this.scrollContainer.removeEventListener('touchmove', this._scrollHandler);
	            }
	        }, {
	            key: 'scrollHandle',
	            value: function scrollHandle() {
	                setTimeout(function () {
	                    var _props2 = this.props,
	                        _props2$topOffset = _props2.topOffset,
	                        topOffset = _props2$topOffset === undefined ? 0 : _props2$topOffset,
	                        _props2$bottomOffset = _props2.bottomOffset,
	                        bottomOffset = _props2$bottomOffset === undefined ? 0 : _props2$bottomOffset;
	                    var _scrollContainer = this.scrollContainer,
	                        scrollHeight = _scrollContainer.scrollHeight,
	                        scrollTop = _scrollContainer.scrollTop,
	                        clientHeight = _scrollContainer.clientHeight;
	
	
	                    var isSticky = void 0;
	
	                    if (scrollTop) {
	                        // TODO
	                        // 可滚动容器
	                        if (this.topSticky) {
	                            var _content$getBoundingC3 = this.content.getBoundingClientRect(),
	                                curFromTop = _content$getBoundingC3.top,
	                                curFromBottom = _content$getBoundingC3.bottom;
	
	                            if (this.topSticky) {
	                                isSticky = scrollTop > topOffset;
	                                // scrollHeight - scrollTop - clientHeight < topOffset
	                            } else {}
	                        } else {}
	                    } else {
	                        var selfHeight = this.content.clientHeight;
	
	                        var _placeholder$getBound = this.placeholder.getBoundingClientRect(),
	                            originFromTop = _placeholder$getBound.top,
	                            originFromBottom = _placeholder$getBound.bottom,
	                            originFromLeft = _placeholder$getBound.left,
	                            originWidth = _placeholder$getBound.width;
	
	                        if (this.topSticky) {
	                            isSticky = originFromTop < (topOffset > 0 ? topOffset + selfHeight : topOffset); // 临界条件：0，不要带`=`
	                        } else {
	                            isSticky = originFromBottom - (document.documentElement.clientHeight || document.body.clientHeight) > bottomOffset;
	                        }
	                    }
	                    // console.log('topSticky:' + !!this.topSticky, 'bottomSticky:' + !!this.bottomSticky)
	                    // console.log('offset', this.topSticky ? topOffset : bottomOffset)
	                    this._triggerHandler(isSticky);
	                }.bind(this), 100);
	            }
	        }, {
	            key: '_triggerHandler',
	            value: function _triggerHandler(isSticky) {
	                var wasSticky = !!this.state.isSticky;
	                if (isSticky === wasSticky) return;
	
	                var distance2Right = (document.documentElement.clientWidth || document.body.clientWidth) - this.state.originFromRight;
	
	                var style = !isSticky ? {} : {
	                    position: 'fixed', // 理论上是相对body固定定位
	                    zIndex: 101,
	                    left: this.state.originFromLeft,
	                    right: distance2Right >= 0 ? distance2Right : 0
	                    //width: originWidth // 依赖于`box-sizing: border-box`
	                };
	
	                if (isSticky && this.topSticky) {
	                    style.top = this.props.topOffset;
	                } else if (isSticky) {
	                    style.bottom = this.props.bottomOffset;
	                }
	
	                this.setState({
	                    isSticky: isSticky,
	                    style: style
	                });
	
	                console.log('isSticky:' + isSticky);
	
	                var fixedHandler = this.props.fixedHandler;
	
	                isSticky !== wasSticky && typeof fixedHandler == 'function' && fixedHandler(isSticky);
	            }
	        }, {
	            key: 'render',
	            value: function render() {
	                var _this3 = this;
	
	                /**
	                 * TODO: sticky无法触发其他事件，默认滚动触发，可选的sticky
	                 * WrappedComponent 必须显式使用`style`属性
	                 */
	                return _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement(WrappedComponent, _extends({}, this.props, { ref: function ref(content) {
	                            return _this3.content = _reactDom2.default.findDOMNode(content);
	                        },
	                        positionStyle: this.state.style,
	                        isSticky: this.state.isSticky })),
	                    _react2.default.createElement('div', { ref: function ref(placeholder) {
	                            return _this3.placeholder = placeholder;
	                        } })
	                );
	            }
	        }, {
	            key: 'noop',
	            value: function noop() {}
	        }]);
	
	        return _class;
	    }(_react2.default.Component);
	};

/***/ }),
/* 547 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(73);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(105);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _indexLess = __webpack_require__(548);
	
	var _indexLess2 = _interopRequireDefault(_indexLess);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Notice = function (_Component) {
	    _inherits(Notice, _Component);
	
	    function Notice(props) {
	        _classCallCheck(this, Notice);
	
	        var _this = _possibleConstructorReturn(this, (Notice.__proto__ || Object.getPrototypeOf(Notice)).call(this, props));
	
	        _this.setting = {
	            LSKEY: 'dp_speaker',
	            defaultLS: true, // 默认存储LS
	            frequency: 1 // 关闭后重新出现的频率，单位为天
	        };
	        _extends(_this.setting, _this.props.opt || {});
	        _this.state = {
	            isShowNotice: _this.validate()
	        };
	        _this.closeHandle = _this.closeHandle.bind(_this);
	        return _this;
	    }
	
	    _createClass(Notice, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            var succHandle = this.props.succHandle;
	
	            if (this.state.isShowNotice && typeof succHandle == 'function') {
	                succHandle();
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props,
	                content = _ref.content,
	                clickHandle = _ref.clickHandle,
	                positionStyle = _ref.positionStyle;
	
	            return this.state.isShowNotice ? _react2.default.createElement(
	                'div',
	                { className: _indexLess2.default["notice_wrap"], style: positionStyle },
	                _react2.default.createElement('i', { className: _indexLess2.default["icon_notice"] }),
	                _react2.default.createElement(
	                    'p',
	                    { className: _indexLess2.default["notice_content"], onClick: clickHandle },
	                    content
	                ),
	                _react2.default.createElement('i', { className: _indexLess2.default["icon_close"], onClick: this.closeHandle })
	            ) : _react2.default.createElement('div', null);
	        }
	    }, {
	        key: 'validate',
	        value: function validate() {
	            // 校验LS的时间戳是否已失效
	            try {
	                if (!this.setting.defaultLS || !supportLocalStorage()) {
	                    // 不支持LocalStorage，默认展示
	                    return true;
	                }
	                var _setting = this.setting,
	                    LSKEY = _setting.LSKEY,
	                    frequency = _setting.frequency;
	
	                var storedNotice = JSON.parse(localStorage.getItem(LSKEY));
	                if (!storedNotice || Date.now() - storedNotice.timestamp > frequency * 24 * 60 * 60 * 1000) {
	                    return true; // 未存储该KEY值（未进行关闭操作）或已过`有效期`
	                }
	                return false;
	            } catch (e) {
	                return false;
	            }
	        }
	    }, {
	        key: 'closeHandle',
	        value: function closeHandle(e) {
	            e.preventDefault();
	            var closeHandle = this.props.closeHandle;
	
	            if (this.setting.defaultLS && supportLocalStorage()) {
	                // 业务支持、技术支持LocalStorage
	                var LSKEY = this.setting.LSKEY;
	                // 进入`静默期`（倒计时）
	
	                localStorage.setItem(LSKEY, JSON.stringify({
	                    timestamp: Date.now(),
	                    source: 'activity-web'
	                }));
	            }
	            this.setState({
	                isShowNotice: false
	            });
	            typeof closeHandle == 'function' && closeHandle();
	        }
	    }]);
	
	    return Notice;
	}(_react.Component);
	
	exports.default = Notice;
	
	
	function noop() {}
	
	function supportLocalStorage() {
	    var support = false;
	    var testKey = 'local_test';
	    try {
	        support = !!window.localStorage && window.localStorage != null;
	        localStorage.setItem(testKey, 1);
	        localStorage.removeItem(testKey);
	    } catch (e) {
	        return false;
	    }
	    return support;
	};

/***/ }),
/* 548 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"notice_wrap":"notice_wrap___3a7O0","icon_notice":"icon_notice___1KyJB","icon_close":"icon_close___33F9d","notice_content":"notice_content___YWC1X"};

/***/ }),
/* 549 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _propTypes = __webpack_require__(267);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(73);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _swipeJsIso = __webpack_require__(550);
	
	var _swipeJsIso2 = _interopRequireDefault(_swipeJsIso);
	
	var _objectAssign = __webpack_require__(551);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ReactSwipe = function (_Component) {
	  _inherits(ReactSwipe, _Component);
	
	  function ReactSwipe() {
	    _classCallCheck(this, ReactSwipe);
	
	    return _possibleConstructorReturn(this, (ReactSwipe.__proto__ || Object.getPrototypeOf(ReactSwipe)).apply(this, arguments));
	  }
	
	  _createClass(ReactSwipe, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var swipeOptions = this.props.swipeOptions;
	
	
	      this.swipe = (0, _swipeJsIso2.default)(this.container, swipeOptions);
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps) {
	      var _props = this.props,
	          childCount = _props.childCount,
	          swipeOptions = _props.swipeOptions;
	
	
	      if (prevProps.childCount !== childCount) {
	        this.swipe.kill();
	        this.swipe = (0, _swipeJsIso2.default)(this.container, swipeOptions);
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.swipe.kill();
	      this.swipe = void 0;
	    }
	  }, {
	    key: 'next',
	    value: function next() {
	      this.swipe.next();
	    }
	  }, {
	    key: 'prev',
	    value: function prev() {
	      this.swipe.prev();
	    }
	  }, {
	    key: 'slide',
	    value: function slide() {
	      var _swipe;
	
	      (_swipe = this.swipe).slide.apply(_swipe, arguments);
	    }
	  }, {
	    key: 'getPos',
	    value: function getPos() {
	      return this.swipe.getPos();
	    }
	  }, {
	    key: 'getNumSlides',
	    value: function getNumSlides() {
	      return this.swipe.getNumSlides();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props2 = this.props,
	          id = _props2.id,
	          className = _props2.className,
	          style = _props2.style,
	          children = _props2.children;
	
	
	      return _react2.default.createElement(
	        'div',
	        { ref: function ref(container) {
	            return _this2.container = container;
	          }, id: id, className: 'react-swipe-container ' + className, style: style.container },
	        _react2.default.createElement(
	          'div',
	          { style: style.wrapper },
	          _react2.default.Children.map(children, function (child) {
	            if (!child) {
	              return null;
	            }
	
	            var childStyle = child.props.style ? (0, _objectAssign2.default)({}, style.child, child.props.style) : style.child;
	
	            return _react2.default.cloneElement(child, { style: childStyle });
	          })
	        )
	      );
	    }
	  }]);
	
	  return ReactSwipe;
	}(_react.Component);
	
	ReactSwipe.propTypes = {
	  swipeOptions: _propTypes2.default.shape({
	    startSlide: _propTypes2.default.number,
	    speed: _propTypes2.default.number,
	    auto: _propTypes2.default.number,
	    continuous: _propTypes2.default.bool,
	    disableScroll: _propTypes2.default.bool,
	    stopPropagation: _propTypes2.default.bool,
	    swiping: _propTypes2.default.func,
	    callback: _propTypes2.default.func,
	    transitionEnd: _propTypes2.default.func
	  }),
	  style: _propTypes2.default.shape({
	    container: _propTypes2.default.object,
	    wrapper: _propTypes2.default.object,
	    child: _propTypes2.default.object
	  }),
	  id: _propTypes2.default.string,
	  className: _propTypes2.default.string,
	  childCount: _propTypes2.default.number
	};
	ReactSwipe.defaultProps = {
	  swipeOptions: {},
	  style: {
	    container: {
	      overflow: 'hidden',
	      visibility: 'hidden',
	      position: 'relative'
	    },
	
	    wrapper: {
	      overflow: 'hidden',
	      position: 'relative'
	    },
	
	    child: {
	      float: 'left',
	      width: '100%',
	      position: 'relative',
	      transitionProperty: 'transform'
	    }
	  },
	  className: '',
	  childCount: 0
	};
	exports.default = ReactSwipe;
	module.exports = exports['default'];


/***/ }),
/* 550 */
/***/ (function(module, exports) {

	/*
	 * Swipe 2.0.0
	 * Brad Birdsall
	 * https://github.com/thebird/Swipe
	 * Copyright 2013-2015, MIT License
	 *
	*/
	
	(function (root, factory) {
	    if (typeof module !== 'undefined' && module.exports) {
	        module.exports = factory();
	    } else {
	        root.Swipe = factory();
	    }
	}(this, function () {
	  'use strict';
	
	  return function Swipe (container, options) {
	    // utilities
	    var noop = function() {}; // simple no operation function
	    var offloadFn = function(fn) { setTimeout(fn || noop, 0); }; // offload a functions execution
	
	    // check browser capabilities
	    var browser = {
	      addEventListener: !!window.addEventListener,
	      touch: ('ontouchstart' in window) || window.DocumentTouch && document instanceof window.DocumentTouch,
	      transitions: (function(temp) {
	        var props = ['transitionProperty', 'WebkitTransition', 'MozTransition', 'OTransition', 'msTransition'];
	        for ( var i in props ) if (temp.style[ props[i] ] !== undefined) return true;
	        return false;
	      })(document.createElement('swipe'))
	    };
	
	    // quit if no root element
	    if (!container) return;
	    var element = container.children[0];
	    var slides, slidePos, width, length;
	    options = options || {};
	    var index = parseInt(options.startSlide, 10) || 0;
	    var speed = options.speed || 300;
	    var continuous = options.continuous = options.continuous !== undefined ? options.continuous : true;
	
	    function setup() {
	
	      // cache slides
	      slides = element.children;
	      length = slides.length;
	
	      // set continuous to false if only one slide
	      continuous = slides.length < 2 ? false : options.continuous;
	
	      //special case if two slides
	      if (browser.transitions && continuous && slides.length < 3) {
	        element.appendChild(slides[0].cloneNode(true));
	        element.appendChild(element.children[1].cloneNode(true));
	        slides = element.children;
	      }
	
	      // create an array to store current positions of each slide
	      slidePos = new Array(slides.length);
	
	      // determine width of each slide
	      width = Math.round(container.getBoundingClientRect().width || container.offsetWidth);
	
	      element.style.width = (slides.length * width) + 'px';
	
	      // stack elements
	      var pos = slides.length;
	      while(pos--) {
	
	        var slide = slides[pos];
	
	        slide.style.width = width + 'px';
	        slide.setAttribute('data-index', pos);
	
	        if (browser.transitions) {
	          slide.style.left = (pos * -width) + 'px';
	          move(pos, index > pos ? -width : (index < pos ? width : 0), 0);
	        }
	
	      }
	
	      // reposition elements before and after index
	      if (continuous && browser.transitions) {
	        move(circle(index-1), -width, 0);
	        move(circle(index+1), width, 0);
	      }
	
	      if (!browser.transitions) element.style.left = (index * -width) + 'px';
	
	      container.style.visibility = 'visible';
	
	    }
	
	    function prev() {
	
	      if (continuous) slide(index-1);
	      else if (index) slide(index-1);
	
	    }
	
	    function next() {
	
	      if (continuous) slide(index+1);
	      else if (index < slides.length - 1) slide(index+1);
	
	    }
	
	    function circle(index) {
	
	      // a simple positive modulo using slides.length
	      return (slides.length + (index % slides.length)) % slides.length;
	
	    }
	
	    function slide(to, slideSpeed) {
	
	      // do nothing if already on requested slide
	      if (index == to) return;
	
	      if (browser.transitions) {
	
	        var direction = Math.abs(index-to) / (index-to); // 1: backward, -1: forward
	
	        // get the actual position of the slide
	        if (continuous) {
	          var natural_direction = direction;
	          direction = -slidePos[circle(to)] / width;
	
	          // if going forward but to < index, use to = slides.length + to
	          // if going backward but to > index, use to = -slides.length + to
	          if (direction !== natural_direction) to =  -direction * slides.length + to;
	
	        }
	
	        var diff = Math.abs(index-to) - 1;
	
	        // move all the slides between index and to in the right direction
	        while (diff--) move( circle((to > index ? to : index) - diff - 1), width * direction, 0);
	
	        to = circle(to);
	
	        move(index, width * direction, slideSpeed || speed);
	        move(to, 0, slideSpeed || speed);
	
	        if (continuous) move(circle(to - direction), -(width * direction), 0); // we need to get the next in place
	
	      } else {
	
	        to = circle(to);
	        animate(index * -width, to * -width, slideSpeed || speed);
	        //no fallback for a circular continuous if the browser does not accept transitions
	      }
	
	      index = to;
	      offloadFn(options.callback && options.callback(index, slides[index]));
	    }
	
	    function move(index, dist, speed) {
	
	      translate(index, dist, speed);
	      slidePos[index] = dist;
	
	    }
	
	    function translate(index, dist, speed) {
	
	      var slide = slides[index];
	      var style = slide && slide.style;
	
	      if (!style) return;
	
	      style.webkitTransitionDuration =
	      style.MozTransitionDuration =
	      style.msTransitionDuration =
	      style.OTransitionDuration =
	      style.transitionDuration = speed + 'ms';
	
	      style.webkitTransform = 'translate(' + dist + 'px,0)' + 'translateZ(0)';
	      style.msTransform =
	      style.MozTransform =
	      style.OTransform = 'translateX(' + dist + 'px)';
	
	    }
	
	    function animate(from, to, speed) {
	
	      // if not an animation, just reposition
	      if (!speed) {
	
	        element.style.left = to + 'px';
	        return;
	
	      }
	
	      var start = +new Date();
	
	      var timer = setInterval(function() {
	
	        var timeElap = +new Date() - start;
	
	        if (timeElap > speed) {
	
	          element.style.left = to + 'px';
	
	          if (delay) begin();
	
	          options.transitionEnd && options.transitionEnd.call(event, index, slides[index]);
	
	          clearInterval(timer);
	          return;
	
	        }
	
	        element.style.left = (( (to - from) * (Math.floor((timeElap / speed) * 100) / 100) ) + from) + 'px';
	
	      }, 4);
	
	    }
	
	    // setup auto slideshow
	    var delay = options.auto || 0;
	    var interval;
	
	    function begin() {
	      clearTimeout(interval);
	      interval = setTimeout(next, delay);
	
	    }
	
	    function stop() {
	
	      delay = 0;
	      clearTimeout(interval);
	
	    }
	
	
	    // setup initial vars
	    var start = {};
	    var delta = {};
	    var isScrolling;
	
	    // setup event capturing
	    var events = {
	
	      handleEvent: function(event) {
	
	        switch (event.type) {
	          case 'touchstart': this.start(event); break;
	          case 'touchmove': this.move(event); break;
	          case 'touchend': offloadFn(this.end(event)); break;
	          case 'webkitTransitionEnd':
	          case 'msTransitionEnd':
	          case 'oTransitionEnd':
	          case 'otransitionend':
	          case 'transitionend': offloadFn(this.transitionEnd(event)); break;
	          case 'resize': offloadFn(setup); break;
	        }
	
	        if (options.stopPropagation) event.stopPropagation();
	
	      },
	      start: function(event) {
	
	        var touches = event.touches[0];
	
	        // measure start values
	        start = {
	
	          // get initial touch coords
	          x: touches.pageX,
	          y: touches.pageY,
	
	          // store time to determine touch duration
	          time: +new Date()
	
	        };
	
	        // used for testing first move event
	        isScrolling = undefined;
	
	        // reset delta and end measurements
	        delta = {};
	
	        // attach touchmove and touchend listeners
	        element.addEventListener('touchmove', this, false);
	        element.addEventListener('touchend', this, false);
	
	      },
	      move: function(event) {
	
	        // ensure swiping with one touch and not pinching
	        if ( event.touches.length > 1 || event.scale && event.scale !== 1) return;
	
	        if (options.disableScroll) return;
	
	        var touches = event.touches[0];
	
	        // measure change in x and y
	        delta = {
	          x: touches.pageX - start.x,
	          y: touches.pageY - start.y
	        };
	
	        // determine if scrolling test has run - one time test
	        if ( typeof isScrolling == 'undefined') {
	          isScrolling = !!( isScrolling || Math.abs(delta.x) < Math.abs(delta.y) );
	        }
	
	        // if user is not trying to scroll vertically
	        if (!isScrolling) {
	
	          // prevent native scrolling
	          event.preventDefault();
	
	          // stop slideshow
	          stop();
	
	          // increase resistance if first or last slide
	          if (continuous) { // we don't add resistance at the end
	
	            translate(circle(index-1), delta.x + slidePos[circle(index-1)], 0);
	            translate(index, delta.x + slidePos[index], 0);
	            translate(circle(index+1), delta.x + slidePos[circle(index+1)], 0);
	
	          } else {
	
	            delta.x =
	              delta.x /
	                ( (!index && delta.x > 0 ||         // if first slide and sliding left
	                  index == slides.length - 1 &&     // or if last slide and sliding right
	                  delta.x < 0                       // and if sliding at all
	                ) ?
	                ( Math.abs(delta.x) / width + 1 )      // determine resistance level
	                : 1 );                                 // no resistance if false
	
	            // translate 1:1
	            translate(index-1, delta.x + slidePos[index-1], 0);
	            translate(index, delta.x + slidePos[index], 0);
	            translate(index+1, delta.x + slidePos[index+1], 0);
	          }
	          options.swiping && options.swiping(-delta.x / width);
	
	        }
	
	      },
	      end: function(event) {
	
	        // measure duration
	        var duration = +new Date() - start.time;
	
	        // determine if slide attempt triggers next/prev slide
	        var isValidSlide =
	              Number(duration) < 250 &&         // if slide duration is less than 250ms
	              Math.abs(delta.x) > 20 ||         // and if slide amt is greater than 20px
	              Math.abs(delta.x) > width/2;      // or if slide amt is greater than half the width
	
	        // determine if slide attempt is past start and end
	        var isPastBounds =
	              !index && delta.x > 0 ||                      // if first slide and slide amt is greater than 0
	              index == slides.length - 1 && delta.x < 0;    // or if last slide and slide amt is less than 0
	
	        if (continuous) isPastBounds = false;
	
	        // determine direction of swipe (true:right, false:left)
	        var direction = delta.x < 0;
	
	        // if not scrolling vertically
	        if (!isScrolling) {
	
	          if (isValidSlide && !isPastBounds) {
	
	            if (direction) {
	
	              if (continuous) { // we need to get the next in this direction in place
	
	                move(circle(index-1), -width, 0);
	                move(circle(index+2), width, 0);
	
	              } else {
	                move(index-1, -width, 0);
	              }
	
	              move(index, slidePos[index]-width, speed);
	              move(circle(index+1), slidePos[circle(index+1)]-width, speed);
	              index = circle(index+1);
	
	            } else {
	              if (continuous) { // we need to get the next in this direction in place
	
	                move(circle(index+1), width, 0);
	                move(circle(index-2), -width, 0);
	
	              } else {
	                move(index+1, width, 0);
	              }
	
	              move(index, slidePos[index]+width, speed);
	              move(circle(index-1), slidePos[circle(index-1)]+width, speed);
	              index = circle(index-1);
	
	            }
	
	            options.callback && options.callback(index, slides[index]);
	
	          } else {
	
	            if (continuous) {
	
	              move(circle(index-1), -width, speed);
	              move(index, 0, speed);
	              move(circle(index+1), width, speed);
	
	            } else {
	
	              move(index-1, -width, speed);
	              move(index, 0, speed);
	              move(index+1, width, speed);
	            }
	
	          }
	
	        }
	
	        // kill touchmove and touchend event listeners until touchstart called again
	        element.removeEventListener('touchmove', events, false);
	        element.removeEventListener('touchend', events, false);
	        element.removeEventListener('touchforcechange', function() {}, false);
	
	      },
	      transitionEnd: function(event) {
	
	        if (parseInt(event.target.getAttribute('data-index'), 10) == index) {
	
	          if (delay) begin();
	
	          options.transitionEnd && options.transitionEnd.call(event, index, slides[index]);
	
	        }
	
	      }
	
	    };
	
	    // trigger setup
	    setup();
	
	    // start auto slideshow if applicable
	    if (delay) begin();
	
	
	    // add event listeners
	    if (browser.addEventListener) {
	
	      // set touchstart event on element
	      if (browser.touch) {
	        element.addEventListener('touchstart', events, false);
	        element.addEventListener('touchforcechange', function() {}, false);
	      }
	
	      if (browser.transitions) {
	        element.addEventListener('webkitTransitionEnd', events, false);
	        element.addEventListener('msTransitionEnd', events, false);
	        element.addEventListener('oTransitionEnd', events, false);
	        element.addEventListener('otransitionend', events, false);
	        element.addEventListener('transitionend', events, false);
	      }
	
	      // set resize event on window
	      window.addEventListener('resize', events, false);
	
	    } else {
	
	      window.onresize = function () { setup(); }; // to play nice with old IE
	
	    }
	
	    // expose the Swipe API
	    return {
	      setup: function() {
	
	        setup();
	
	      },
	      slide: function(to, speed) {
	
	        // cancel slideshow
	        stop();
	
	        slide(to, speed);
	
	      },
	      prev: function() {
	
	        // cancel slideshow
	        stop();
	
	        prev();
	
	      },
	      next: function() {
	
	        // cancel slideshow
	        stop();
	
	        next();
	
	      },
	      stop: function() {
	
	        // cancel slideshow
	        stop();
	
	      },
	      getPos: function() {
	
	        // return current index position
	        return index;
	
	      },
	      getNumSlides: function() {
	
	        // return total number of slides
	        return length;
	      },
	      kill: function() {
	
	        // cancel slideshow
	        stop();
	
	        // reset element
	        element.style.width = '';
	        element.style.left = '';
	
	        // reset slides
	        var pos = slides.length;
	        while(pos--) {
	
	          var slide = slides[pos];
	          slide.style.width = '';
	          slide.style.left = '';
	
	          if (browser.transitions) translate(pos, 0, 0);
	        }
	
	        // removed event listeners
	        if (browser.addEventListener) {
	
	          // remove current event listeners
	          element.removeEventListener('touchstart', events, false);
	          element.removeEventListener('webkitTransitionEnd', events, false);
	          element.removeEventListener('msTransitionEnd', events, false);
	          element.removeEventListener('oTransitionEnd', events, false);
	          element.removeEventListener('otransitionend', events, false);
	          element.removeEventListener('transitionend', events, false);
	          window.removeEventListener('resize', events, false);
	
	        } else {
	          window.onresize = null;
	        }
	      }
	    };
	  };
	}));


/***/ }),
/* 551 */
/***/ (function(module, exports) {

	/*
	object-assign
	(c) Sindre Sorhus
	@license MIT
	*/
	
	'use strict';
	/* eslint-disable no-unused-vars */
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	var propIsEnumerable = Object.prototype.propertyIsEnumerable;
	
	function toObject(val) {
		if (val === null || val === undefined) {
			throw new TypeError('Object.assign cannot be called with null or undefined');
		}
	
		return Object(val);
	}
	
	function shouldUseNative() {
		try {
			if (!Object.assign) {
				return false;
			}
	
			// Detect buggy property enumeration order in older V8 versions.
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=4118
			var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
			test1[5] = 'de';
			if (Object.getOwnPropertyNames(test1)[0] === '5') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test2 = {};
			for (var i = 0; i < 10; i++) {
				test2['_' + String.fromCharCode(i)] = i;
			}
			var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
				return test2[n];
			});
			if (order2.join('') !== '0123456789') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test3 = {};
			'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
				test3[letter] = letter;
			});
			if (Object.keys(Object.assign({}, test3)).join('') !==
					'abcdefghijklmnopqrst') {
				return false;
			}
	
			return true;
		} catch (err) {
			// We don't expect any of the above to throw, but better to be safe.
			return false;
		}
	}
	
	module.exports = shouldUseNative() ? Object.assign : function (target, source) {
		var from;
		var to = toObject(target);
		var symbols;
	
		for (var s = 1; s < arguments.length; s++) {
			from = Object(arguments[s]);
	
			for (var key in from) {
				if (hasOwnProperty.call(from, key)) {
					to[key] = from[key];
				}
			}
	
			if (getOwnPropertySymbols) {
				symbols = getOwnPropertySymbols(from);
				for (var i = 0; i < symbols.length; i++) {
					if (propIsEnumerable.call(from, symbols[i])) {
						to[symbols[i]] = from[symbols[i]];
					}
				}
			}
		}
	
		return to;
	};


/***/ }),
/* 552 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	  Copyright (c) 2016 Jed Watson.
	  Licensed under the MIT License (MIT), see
	  http://jedwatson.github.io/classnames
	*/
	/* global define */
	
	(function () {
		'use strict';
	
		var hasOwn = {}.hasOwnProperty;
	
		function classNames () {
			var classes = [];
	
			for (var i = 0; i < arguments.length; i++) {
				var arg = arguments[i];
				if (!arg) continue;
	
				var argType = typeof arg;
	
				if (argType === 'string' || argType === 'number') {
					classes.push(arg);
				} else if (Array.isArray(arg)) {
					classes.push(classNames.apply(null, arg));
				} else if (argType === 'object') {
					for (var key in arg) {
						if (hasOwn.call(arg, key) && arg[key]) {
							classes.push(key);
						}
					}
				}
			}
	
			return classes.join(' ');
		}
	
		if (typeof module !== 'undefined' && module.exports) {
			module.exports = classNames;
		} else if (true) {
			// register as 'classnames', consistent with npm package name
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return classNames;
			}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
			window.classNames = classNames;
		}
	}());


/***/ }),
/* 553 */
/***/ (function(module, exports, __webpack_require__) {

	var UA = __webpack_require__(472)();
	var SocialRecord = __webpack_require__(554).default;
	var extend = __webpack_require__(559);
	
	__webpack_require__(560);
	
	var _setting = {
	  enableSocialRecord: false,
	  wxAutoConfig: true,
	  wxLoadScript: true,
	  hide: false, //隐藏分享
	  envir: '' //分享环境
	};
	
	var instance;
	var isInit = false;
	var isLoading = false;
	var cbQueue = [];
	var ShareClass;
	var dep;
	var sRecord;
	
	var patchShare4Type = function(envir, cb) {
	  if (cb) {
	    cbQueue.push(cb);
	  }
	  if (isLoading) {
	    return;
	  }else{
	    isLoading = true;
	  }
	  envir = envir || UA.type;
	  
	  cb = function(shareConstructor, shareDep) {
	    ShareClass = shareConstructor;
	    dep = shareDep;
	    isInit = true;
	    cbQueue.forEach(function(callback) {
	      callback(ShareClass, dep);
	    });
	    cbQueue = [];
	  };
	  
	  //异步加载模块解析规则问题，导致需要把异步模块都加载进来
	  if (envir === 'dpapp') {
	    
	    var _doTask = function(KNB) {
	      __webpack_require__.e/* nsure */(5, function(require) {
	        var DPAppShare = __webpack_require__(561);
	        KNB.ready(function() {
	          cb(DPAppShare, {KNB: KNB});
	        });
	      }); 
	    };
	    
	    if (window.KNB) {
	      _doTask(window.KNB);
	    }else{
	      __webpack_require__.e/* nsure */(3/* duplicate */, function(require) {
	        var KNB = __webpack_require__(528);
	        _doTask(KNB);
	      });  
	    }
	  }else if (envir === 'weixin') {
	    // require.ensure([], function() {
	      var loader = __webpack_require__(470);
	      loader.use(function(wx) {
	          try {
	            wx.miniProgram.getEnv(function(res) {
	              if(res.miniprogram) {
	                __webpack_require__.e/* nsure */(6, function() {
	                  var WXMinaShare = __webpack_require__(562);
	                  cb(WXMinaShare, {loader: loader});
	                });
	              } else {
	                __webpack_require__.e/* nsure */(7, function() {
	                  var WXShare = __webpack_require__(563);
	                  cb(WXShare, {loader: loader});
	                });
	              }
	            });
	          } catch(e) {
	            console.warn('wx API exception');
	          }
	      });
	      
	    // }, 'wx-loader');
	  }else if (envir === 'qq') {
	    __webpack_require__.e/* nsure */(8, function(require) {
	      var QQShare = __webpack_require__(564);
	
	      cb(QQShare,{});
	    });
	  }else if (envir === 'qqzone') {
	    __webpack_require__.e/* nsure */(9, function(require) {
	      var QQZoneShare = __webpack_require__(566);
	
	      cb(QQZoneShare, {});
	
	    });
	  }else if(envir === 'mtgroup'){
	    var isMTNB = false;
	    if (UA.version < '7.6.0') {
	      isMTNB = true;
	    }
	
	    var doTask = function() {
	      var KNB = window.KNB;
	      __webpack_require__.e/* nsure */(10, function(require) {
	        var MTShare = __webpack_require__(568);
	        KNB.ready(function() {
	          cb(MTShare, {KNB: KNB, isMTNB: isMTNB});
	        });
	      }); 
	    };
	    if (window.KNB) {
	      doTask();
	    }else{
	      __webpack_require__.e/* nsure */(3/* duplicate */, function(require) {
	        window.KNB = __webpack_require__(528);
	        doTask();
	      });    
	    }
	  }else if(envir === 'browser' || envir === 'ucweb'){
	    __webpack_require__.e/* nsure */(11, function(require) {
	      
	      var BrowserShare = __webpack_require__(569);
	      var $ = __webpack_require__(570);
	
	      cb(BrowserShare, {$: $});
	
	    });
	  }
	};
	
	patchShare4Type();
	
	var parseConfig = function(config, setting){
	  if(!config) return config;
	  if (config.image && config.image.indexOf('//') === 0) {
	      config.image = window.location.protocol + config.image;
	  }
	
	  if(config.url && config.url.indexOf('//')===0){
	    config.url = window.location.protocol + config.url;
	  }
	
	  if (!config.content) {
	    config.content = '【'+config.title+'】' + config.desc;
	  }
	
	  if(setting && setting.enableSocialRecord){
	    config.url = sRecord.changeUrl(config.url);  
	  }
	
	  return config;
	};
	
	var createShare = function(config, setting){
	  setting = extend(_setting, setting, true);
	
	  if(setting.enableSocialRecord){
	    sRecord = new SocialRecord();
	    sRecord.init();
	  }
	  config = parseConfig(config, setting);
	
	  this.config = config;
	  this.setting = setting;
	
	  if (isInit) {
	    instance = new ShareClass(config, setting, dep);
	  }else{
	    this._init();
	  }
	};
	
	createShare.prototype = {
	  _init: function(cb) {
	    if (isInit) {
	      cb && cb(instance);
	    }else{
	      var self = this;
	      patchShare4Type(self.setting.env, function(ShareClass, dep) {
	        instance = new ShareClass(self.config, self.setting, dep);
	        cb && cb(instance);
	      });      
	    }
	
	  },
	  //由于分享模块是异步加载的，所以只能返回createShare的实例，并不能直接返回instance实例
	  updateConfig: function(config) {
	    var setting = this.setting;
	    this._init(function() {
	      instance.updateConfig(parseConfig(config, setting));
	    });
	  },
	  trigger: function(config) {
	    var setting = this.setting;
	    this._init(function() {
	      instance.trigger(parseConfig(config, setting));
	    });
	  },
	  hide: function() {
	    this._init(function() {
	      instance.hide();
	    });
	  },
	  remove: function() {
	    this._init(function() {
	      instance.remove();
	    });
	  }
	};
	
	createShare.CHANNEL = {
	  WECHAT_FRIENDS: 0,
	  WECHAT_TIMELINE: 1,
	  QQ: 2,
	  SMS: 3,
	  WEIBO: 4,
	  QZONE: 5,
	  EMAIL: 6,
	  COPY: 7,
	  WEIBO_TECENT: 8
	};
	
	module.exports = createShare;

/***/ }),
/* 554 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * @author yongsheng.zhang
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * 测试分享回流
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * 2017.03.31
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      */
	
	
	var _utilGetUrl = __webpack_require__(555);
	
	var _utilGetUrl2 = _interopRequireDefault(_utilGetUrl);
	
	var _utilMUa = __webpack_require__(556);
	
	var _utilMUa2 = _interopRequireDefault(_utilMUa);
	
	__webpack_require__(558);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * @_social_u {string} 用户信息
	 * @_social_e {string} 来源信息
	 * @_login {boolean} 用户是否登录
	 * @from {string} 来源
	 * @secondShare {string} 是否二次分享
	 */
	var param = {
	    _social_u: (0, _utilGetUrl2.default)('_social_u') || '',
	    _social_e: '',
	    from: (0, _utilGetUrl2.default)('from') || '',
	    _login: document.cookie.indexOf('dper') != -1 ? true : false,
	    secondShare: (0, _utilGetUrl2.default)('second_s') || ''
	};
	
	var ua = (0, _utilMUa2.default)();
	
	var SocialRecord = function () {
	    function SocialRecord() {
	        _classCallCheck(this, SocialRecord);
	    }
	
	    _createClass(SocialRecord, [{
	        key: 'changeUrl',
	        value: function changeUrl(url) {
	            //在非APP环境下二次分享，则加上二次分享参数，不再记录请求
	            if (!param.secondShare.trim() && ua.type != 'dpapp') {
	                if (url.indexOf('?') != -1) {
	                    return url + '&second_s=true';
	                } else {
	                    return url + '?second_s=true';
	                }
	            } else {
	                return url;
	            }
	        }
	    }, {
	        key: 'init',
	        value: function init() {
	            //没有登录或者在APP里面则不做任何事,或者在app分享时未登录,二次分享
	            if (!param._login || ua.type == 'dpapp' || !param._social_u.trim() || param.secondShare == 'true') return;
	            if (ua.type == 'qq') {
	                //QQ环境
	                param._social_e = 'qq';
	            } else {
	                //微信环境
	                if (param.from == 'timeline') {
	                    //朋友圈
	                    param._social_e = 'wx_friend';
	                } else if (param.from == 'singlemessage' || param.from == 'groupmessage') {
	                    //微信对话框
	                    param._social_e = 'wx_message';
	                }
	            }
	            var domain = void 0;
	            if (location.href.indexOf('51ping') != -1) {
	                domain = '//m.51ping.com';
	            } else {
	                domain = '//m.dianping.com';
	            }
	            fetch('' + location.protocol + domain + '/friend/potentialFriend?_social_u=' + param._social_u + '&_social_e=' + param._social_e, {
	                method: 'GET',
	                mode: 'cors',
	                credentials: 'include'
	            }).then(function (response) {
	                return response.json();
	            }).then(function (result) {
	                console.log('add ptFriend success');
	            }).catch(function (err) {
	                console.log('add ptFriend fail');
	            });
	        }
	    }]);
	
	    return SocialRecord;
	}();
	
	exports.default = SocialRecord;

/***/ }),
/* 555 */
/***/ (function(module, exports) {

	var urldata;
	function getUrl() {
	    var vars = {};
	    var parts = window.location.href.replace(/[?&]+([^=&]+)=([^#&]*)/gi, function(m,key,value) {
	        vars[key] = value;
	    });
	    return vars;
	};
	
	var getUrlVars = function(urlData){
	    urlData = urlData || '';
	    urldata = getUrl()[urlData]==undefined?"":getUrl()[urlData];
	    return urldata;
	}
	module.exports = getUrlVars;


/***/ }),
/* 556 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {var parse = __webpack_require__(557);
	
	module.exports = function(config) {
	    config = config || {};
	    var UA = config.ua;
	    var HOST = config.host;
	
	    var isNode;
	    try{
	        isNode = Object.prototype.toString.call(global.process) === '[object process]';
	    }catch(e){
	        isNode = false
	    }
	    if (isNode) {
	        UA = UA || this.req.headers['user-agent']
	        HOST = HOST || this.req.headers['host'];
	    }else{
	        UA = UA || window.navigator.userAgent || window.navigator.vendor || window.opera;
	        HOST = HOST || window.location.host
	    }
	
	    return parse(UA, HOST)
	};
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 557 */
/***/ (function(module, exports) {

	var caches = []
	var MAX_CACHE = 10
	
	module.exports = function parseUA(UA, HOST) {
	    for (var index = 0; index < caches.length; index++) {
	        var cache = caches[index];
	        if (cache && cache.ua === UA && cache.host === HOST && cache.result instanceof Object) {
	            cache.result.isCache = true
	            return cache.result
	        }
	    }
	
	    var result = {
	        isCache: false
	    };
	    var type;
	    var version;
	    var os;
	    var osVersion;
	    var kernal;
	    var source;
	    var env;
	    var model;
	
	    function match(reg) {
	        if (reg) {
	            if (UA.match(reg) && UA.match(reg).length) {
	                return UA.match(reg)[1];
	            }
	        }
	    }
	
	    function matchTypeVersion(reg) {
	        if (reg) {
	            if (UA.match(reg) && UA.match(reg).length >= 2) {
	                return UA.match(reg);
	            } else {
	                return ['', '0.0.0'];
	            }
	        }
	    }
	
	    function isMobile() {
	        var check = false;
	        if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(UA) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(UA.substr(0, 4))) check = true
	        return check;
	    }
	
	
	    try {
	        if (!UA) return
	        //mobile detect
	        result.isMobile = isMobile();
	
	        //os detect
	        if (UA.match(/android/i)) {
	            result.os = 'android';
	
	            result.osVersion = match(/Android\/([\d\.]+)/i) || match(/Android ([\d\.]+)/);
	
	            result.kernal = match(/AppleWebKit\/([\d\.]+)/i);
	
	            result.browserVersion = match(/Chrome\/([\d\.]+)/i);
	        } else if (UA.match(/(ipad|iphone|ipod).*os\s([\d_]+)/i)) {
	            result.os = 'ios';
	
	            result.osVersion = match(/iOS\/([\d\.]+)/) || match(/OS ([\d\_]+)/).split('_').join('.');
	
	            result.kernal = match(/AppleWebKit\/([\d\.]+)/i);
	
	            result.browserVersion = match(/Safari\/([\d\.]+)/i);
	        }
	
	        //environment & version detect
	        if (/dp\/com\.dianping/.test(UA)) {
	            var arr = matchTypeVersion(/dp\/com\.dianping\.([\w\.]+)\/([\d\.]+)/);
	            var typeKey = arr[1];
	            version = arr[2];
	            if (typeKey.indexOf('dpscope') !== -1) {
	                type = 'dpapp';
	            } else if (typeKey.indexOf('v1') !== -1) {
	                type = 'dpapp'
	                if (/adapter\/([\d\.]+)/.test(UA)) {
	                    version = match(/adapter\/([\d\.]+)/);
	                }
	            } else if (typeKey.indexOf('wedmerchant') !== -1) {
	                type = 'dpwedmerchant'
	            } else if (typeKey.indexOf('merchant') !== -1 || typeKey === 'mp.mobile') {
	                type = 'dpmerchant';
	            } else if (typeKey.indexOf('wed') !== -1) {
	                type = 'dpwed';
	            } else {
	                type = 'dp';
	            }
	
	        } else if (/MeituanGroup/i.test(UA)) {
	            type = 'mtgroup';
	
	            var arr = matchTypeVersion(/(MeituanGroup)\/([\d\.]+)/i);
	            version = arr[2];
	
	        } else if (/MicroMessenger/.test(UA)) {
	            type = 'weixin';
	            version = match(/MicroMessenger\/([\d\.]+)/i);
	
	        } else if (/QZONE/.test(UA)) {
	            type = 'qqzone';
	            version = match(/QZONEJSSDK\/([\d\.]+)/);
	
	        } else if (/QQ\/([\d\.]+)/.test(UA)) {
	            type = 'qq';
	            version = match(/QQ\/([\d\.]+)/i);
	
	        } else if (/UCWEB/i.test(UA)) {
	            type = 'ucweb';
	            version = match(/UCWEB([\d\.]+)/i);
	
	        } else {
	            type = 'browser';
	        }
	
	        //区分业务：点评OR美团
	        if (/\.(dianping|dpfile)\.com/i.test(HOST)) {
	            source = 'dianping';
	            env = 'product';
	        } else if (/\.51ping\.com/i.test(HOST)) {
	            source = 'dianping';
	            env = 'beta';
	        } else if (/test(.+)\.meituan\.(com|net)/i.test(HOST)) {
	            source = 'meituan';
	            env = 'beta';
	        } else if (/\.meituan\.(com|net)/i.test(HOST)) {
	            source = 'meituan';
	            env = 'product';
	        }
	
	        if (/iPhone\/iPhoneX/.test(UA)) {
	            model = 'iPhoneX'
	        } else {
	            model = ''
	        }
	
	        result.type = type;
	        result.version = version;
	        result.source = source;
	        result.env = env;
	        result.model = model;
	
	    } catch (e) {
	        console.log(e);
	        result.type = type;
	        result.version = version;
	    }
	
	    var newCache = {
	        ua: UA,
	        host: HOST,
	        result: result
	    }
	    if (caches.length < MAX_CACHE) {
	        caches.push(newCache)
	    } else {
	        caches.shift()
	        caches.push(newCache)
	    }
	
	    return result
	};

/***/ }),
/* 558 */
/***/ (function(module, exports) {

	(function(self) {
	  'use strict';
	
	  if (self.fetch) {
	    return
	  }
	
	  var support = {
	    searchParams: 'URLSearchParams' in self,
	    iterable: 'Symbol' in self && 'iterator' in Symbol,
	    blob: 'FileReader' in self && 'Blob' in self && (function() {
	      try {
	        new Blob()
	        return true
	      } catch(e) {
	        return false
	      }
	    })(),
	    formData: 'FormData' in self,
	    arrayBuffer: 'ArrayBuffer' in self
	  }
	
	  if (support.arrayBuffer) {
	    var viewClasses = [
	      '[object Int8Array]',
	      '[object Uint8Array]',
	      '[object Uint8ClampedArray]',
	      '[object Int16Array]',
	      '[object Uint16Array]',
	      '[object Int32Array]',
	      '[object Uint32Array]',
	      '[object Float32Array]',
	      '[object Float64Array]'
	    ]
	
	    var isDataView = function(obj) {
	      return obj && DataView.prototype.isPrototypeOf(obj)
	    }
	
	    var isArrayBufferView = ArrayBuffer.isView || function(obj) {
	      return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
	    }
	  }
	
	  function normalizeName(name) {
	    if (typeof name !== 'string') {
	      name = String(name)
	    }
	    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
	      throw new TypeError('Invalid character in header field name')
	    }
	    return name.toLowerCase()
	  }
	
	  function normalizeValue(value) {
	    if (typeof value !== 'string') {
	      value = String(value)
	    }
	    return value
	  }
	
	  // Build a destructive iterator for the value list
	  function iteratorFor(items) {
	    var iterator = {
	      next: function() {
	        var value = items.shift()
	        return {done: value === undefined, value: value}
	      }
	    }
	
	    if (support.iterable) {
	      iterator[Symbol.iterator] = function() {
	        return iterator
	      }
	    }
	
	    return iterator
	  }
	
	  function Headers(headers) {
	    this.map = {}
	
	    if (headers instanceof Headers) {
	      headers.forEach(function(value, name) {
	        this.append(name, value)
	      }, this)
	    } else if (Array.isArray(headers)) {
	      headers.forEach(function(header) {
	        this.append(header[0], header[1])
	      }, this)
	    } else if (headers) {
	      Object.getOwnPropertyNames(headers).forEach(function(name) {
	        this.append(name, headers[name])
	      }, this)
	    }
	  }
	
	  Headers.prototype.append = function(name, value) {
	    name = normalizeName(name)
	    value = normalizeValue(value)
	    var oldValue = this.map[name]
	    this.map[name] = oldValue ? oldValue+','+value : value
	  }
	
	  Headers.prototype['delete'] = function(name) {
	    delete this.map[normalizeName(name)]
	  }
	
	  Headers.prototype.get = function(name) {
	    name = normalizeName(name)
	    return this.has(name) ? this.map[name] : null
	  }
	
	  Headers.prototype.has = function(name) {
	    return this.map.hasOwnProperty(normalizeName(name))
	  }
	
	  Headers.prototype.set = function(name, value) {
	    this.map[normalizeName(name)] = normalizeValue(value)
	  }
	
	  Headers.prototype.forEach = function(callback, thisArg) {
	    for (var name in this.map) {
	      if (this.map.hasOwnProperty(name)) {
	        callback.call(thisArg, this.map[name], name, this)
	      }
	    }
	  }
	
	  Headers.prototype.keys = function() {
	    var items = []
	    this.forEach(function(value, name) { items.push(name) })
	    return iteratorFor(items)
	  }
	
	  Headers.prototype.values = function() {
	    var items = []
	    this.forEach(function(value) { items.push(value) })
	    return iteratorFor(items)
	  }
	
	  Headers.prototype.entries = function() {
	    var items = []
	    this.forEach(function(value, name) { items.push([name, value]) })
	    return iteratorFor(items)
	  }
	
	  if (support.iterable) {
	    Headers.prototype[Symbol.iterator] = Headers.prototype.entries
	  }
	
	  function consumed(body) {
	    if (body.bodyUsed) {
	      return Promise.reject(new TypeError('Already read'))
	    }
	    body.bodyUsed = true
	  }
	
	  function fileReaderReady(reader) {
	    return new Promise(function(resolve, reject) {
	      reader.onload = function() {
	        resolve(reader.result)
	      }
	      reader.onerror = function() {
	        reject(reader.error)
	      }
	    })
	  }
	
	  function readBlobAsArrayBuffer(blob) {
	    var reader = new FileReader()
	    var promise = fileReaderReady(reader)
	    reader.readAsArrayBuffer(blob)
	    return promise
	  }
	
	  function readBlobAsText(blob) {
	    var reader = new FileReader()
	    var promise = fileReaderReady(reader)
	    reader.readAsText(blob)
	    return promise
	  }
	
	  function readArrayBufferAsText(buf) {
	    var view = new Uint8Array(buf)
	    var chars = new Array(view.length)
	
	    for (var i = 0; i < view.length; i++) {
	      chars[i] = String.fromCharCode(view[i])
	    }
	    return chars.join('')
	  }
	
	  function bufferClone(buf) {
	    if (buf.slice) {
	      return buf.slice(0)
	    } else {
	      var view = new Uint8Array(buf.byteLength)
	      view.set(new Uint8Array(buf))
	      return view.buffer
	    }
	  }
	
	  function Body() {
	    this.bodyUsed = false
	
	    this._initBody = function(body) {
	      this._bodyInit = body
	      if (!body) {
	        this._bodyText = ''
	      } else if (typeof body === 'string') {
	        this._bodyText = body
	      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
	        this._bodyBlob = body
	      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
	        this._bodyFormData = body
	      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
	        this._bodyText = body.toString()
	      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
	        this._bodyArrayBuffer = bufferClone(body.buffer)
	        // IE 10-11 can't handle a DataView body.
	        this._bodyInit = new Blob([this._bodyArrayBuffer])
	      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
	        this._bodyArrayBuffer = bufferClone(body)
	      } else {
	        throw new Error('unsupported BodyInit type')
	      }
	
	      if (!this.headers.get('content-type')) {
	        if (typeof body === 'string') {
	          this.headers.set('content-type', 'text/plain;charset=UTF-8')
	        } else if (this._bodyBlob && this._bodyBlob.type) {
	          this.headers.set('content-type', this._bodyBlob.type)
	        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
	          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
	        }
	      }
	    }
	
	    if (support.blob) {
	      this.blob = function() {
	        var rejected = consumed(this)
	        if (rejected) {
	          return rejected
	        }
	
	        if (this._bodyBlob) {
	          return Promise.resolve(this._bodyBlob)
	        } else if (this._bodyArrayBuffer) {
	          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
	        } else if (this._bodyFormData) {
	          throw new Error('could not read FormData body as blob')
	        } else {
	          return Promise.resolve(new Blob([this._bodyText]))
	        }
	      }
	
	      this.arrayBuffer = function() {
	        if (this._bodyArrayBuffer) {
	          return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
	        } else {
	          return this.blob().then(readBlobAsArrayBuffer)
	        }
	      }
	    }
	
	    this.text = function() {
	      var rejected = consumed(this)
	      if (rejected) {
	        return rejected
	      }
	
	      if (this._bodyBlob) {
	        return readBlobAsText(this._bodyBlob)
	      } else if (this._bodyArrayBuffer) {
	        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
	      } else if (this._bodyFormData) {
	        throw new Error('could not read FormData body as text')
	      } else {
	        return Promise.resolve(this._bodyText)
	      }
	    }
	
	    if (support.formData) {
	      this.formData = function() {
	        return this.text().then(decode)
	      }
	    }
	
	    this.json = function() {
	      return this.text().then(JSON.parse)
	    }
	
	    return this
	  }
	
	  // HTTP methods whose capitalization should be normalized
	  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']
	
	  function normalizeMethod(method) {
	    var upcased = method.toUpperCase()
	    return (methods.indexOf(upcased) > -1) ? upcased : method
	  }
	
	  function Request(input, options) {
	    options = options || {}
	    var body = options.body
	
	    if (input instanceof Request) {
	      if (input.bodyUsed) {
	        throw new TypeError('Already read')
	      }
	      this.url = input.url
	      this.credentials = input.credentials
	      if (!options.headers) {
	        this.headers = new Headers(input.headers)
	      }
	      this.method = input.method
	      this.mode = input.mode
	      if (!body && input._bodyInit != null) {
	        body = input._bodyInit
	        input.bodyUsed = true
	      }
	    } else {
	      this.url = String(input)
	    }
	
	    this.credentials = options.credentials || this.credentials || 'omit'
	    if (options.headers || !this.headers) {
	      this.headers = new Headers(options.headers)
	    }
	    this.method = normalizeMethod(options.method || this.method || 'GET')
	    this.mode = options.mode || this.mode || null
	    this.referrer = null
	
	    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
	      throw new TypeError('Body not allowed for GET or HEAD requests')
	    }
	    this._initBody(body)
	  }
	
	  Request.prototype.clone = function() {
	    return new Request(this, { body: this._bodyInit })
	  }
	
	  function decode(body) {
	    var form = new FormData()
	    body.trim().split('&').forEach(function(bytes) {
	      if (bytes) {
	        var split = bytes.split('=')
	        var name = split.shift().replace(/\+/g, ' ')
	        var value = split.join('=').replace(/\+/g, ' ')
	        form.append(decodeURIComponent(name), decodeURIComponent(value))
	      }
	    })
	    return form
	  }
	
	  function parseHeaders(rawHeaders) {
	    var headers = new Headers()
	    // Replace instances of \r\n and \n followed by at least one space or horizontal tab with a space
	    // https://tools.ietf.org/html/rfc7230#section-3.2
	    var preProcessedHeaders = rawHeaders.replace(/\r?\n[\t ]+/g, ' ')
	    preProcessedHeaders.split(/\r?\n/).forEach(function(line) {
	      var parts = line.split(':')
	      var key = parts.shift().trim()
	      if (key) {
	        var value = parts.join(':').trim()
	        headers.append(key, value)
	      }
	    })
	    return headers
	  }
	
	  Body.call(Request.prototype)
	
	  function Response(bodyInit, options) {
	    if (!options) {
	      options = {}
	    }
	
	    this.type = 'default'
	    this.status = options.status === undefined ? 200 : options.status
	    this.ok = this.status >= 200 && this.status < 300
	    this.statusText = 'statusText' in options ? options.statusText : 'OK'
	    this.headers = new Headers(options.headers)
	    this.url = options.url || ''
	    this._initBody(bodyInit)
	  }
	
	  Body.call(Response.prototype)
	
	  Response.prototype.clone = function() {
	    return new Response(this._bodyInit, {
	      status: this.status,
	      statusText: this.statusText,
	      headers: new Headers(this.headers),
	      url: this.url
	    })
	  }
	
	  Response.error = function() {
	    var response = new Response(null, {status: 0, statusText: ''})
	    response.type = 'error'
	    return response
	  }
	
	  var redirectStatuses = [301, 302, 303, 307, 308]
	
	  Response.redirect = function(url, status) {
	    if (redirectStatuses.indexOf(status) === -1) {
	      throw new RangeError('Invalid status code')
	    }
	
	    return new Response(null, {status: status, headers: {location: url}})
	  }
	
	  self.Headers = Headers
	  self.Request = Request
	  self.Response = Response
	
	  self.fetch = function(input, init) {
	    return new Promise(function(resolve, reject) {
	      var request = new Request(input, init)
	      var xhr = new XMLHttpRequest()
	
	      xhr.onload = function() {
	        var options = {
	          status: xhr.status,
	          statusText: xhr.statusText,
	          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
	        }
	        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL')
	        var body = 'response' in xhr ? xhr.response : xhr.responseText
	        resolve(new Response(body, options))
	      }
	
	      xhr.onerror = function() {
	        reject(new TypeError('Network request failed'))
	      }
	
	      xhr.ontimeout = function() {
	        reject(new TypeError('Network request failed'))
	      }
	
	      xhr.open(request.method, request.url, true)
	
	      if (request.credentials === 'include') {
	        xhr.withCredentials = true
	      } else if (request.credentials === 'omit') {
	        xhr.withCredentials = false
	      }
	
	      if ('responseType' in xhr && support.blob) {
	        xhr.responseType = 'blob'
	      }
	
	      request.headers.forEach(function(value, name) {
	        xhr.setRequestHeader(name, value)
	      })
	
	      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
	    })
	  }
	  self.fetch.polyfill = true
	})(typeof self !== 'undefined' ? self : this);


/***/ }),
/* 559 */
/***/ (function(module, exports) {

	module.exports = function(target, source, isTargetNew) {
	  var key;
	  var ret = {};
	
	  if (isTargetNew) {
	    for (key in target) {
	      if (target.hasOwnProperty(key)) {
	        ret[key] = target[key];
	      }
	    }
	    for (key in source) {
	      if (source.hasOwnProperty(key)) {
	        ret[key] = source[key];
	      }
	    }
	    return ret;
	    
	  }else{
	    for (key in source) {
	      if (source.hasOwnProperty(key)) {
	        target[key] = source[key];
	      }
	    }
	    return target;
	  }
	};

/***/ }),
/* 560 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 561 */,
/* 562 */,
/* 563 */,
/* 564 */,
/* 565 */,
/* 566 */,
/* 567 */,
/* 568 */,
/* 569 */,
/* 570 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(571);


/***/ }),
/* 571 */
/***/ (function(module, exports) {

	/* Zepto v1.2.7-20160812-170541-2-gffeba25 - zepto assets callbacks data deferred detect event form fx gesture ios3 selector stack touch ajax ie - zeptojs.com/license */
	
	var Zepto = module.exports = (function() {
	  var undefined, key, $, classList, emptyArray = [], slice = emptyArray.slice, filter = emptyArray.filter,
	    document = window.document,
	    elementDisplay = {}, classCache = {},
	    cssNumber = { 'column-count': 1, 'columns': 1, 'font-weight': 1, 'line-height': 1,'opacity': 1, 'z-index': 1, 'zoom': 1 },
	    fragmentRE = /^\s*<(\w+|!)[^>]*>/,
	    singleTagRE = /^<(\w+)\s*\/?>(?:<\/\1>|)$/,
	    tagExpanderRE = /<(?!area|br|col|embed|hr|img|input|link|meta|param)(([\w:]+)[^>]*)\/>/ig,
	    rootNodeRE = /^(?:body|html)$/i,
	    capitalRE = /([A-Z])/g,
	
	    // special attributes that should be get/set via method calls
	    methodAttributes = ['val', 'css', 'html', 'text', 'data', 'width', 'height', 'offset'],
	
	    adjacencyOperators = [ 'after', 'prepend', 'before', 'append' ],
	    table = document.createElement('table'),
	    tableRow = document.createElement('tr'),
	    containers = {
	      'tr': document.createElement('tbody'),
	      'tbody': table, 'thead': table, 'tfoot': table,
	      'td': tableRow, 'th': tableRow,
	      '*': document.createElement('div')
	    },
	    readyRE = /complete|loaded|interactive/,
	    simpleSelectorRE = /^[\w-]*$/,
	    class2type = {},
	    toString = class2type.toString,
	    zepto = {},
	    camelize, uniq,
	    tempParent = document.createElement('div'),
	    propMap = {
	      'tabindex': 'tabIndex',
	      'readonly': 'readOnly',
	      'for': 'htmlFor',
	      'class': 'className',
	      'maxlength': 'maxLength',
	      'cellspacing': 'cellSpacing',
	      'cellpadding': 'cellPadding',
	      'rowspan': 'rowSpan',
	      'colspan': 'colSpan',
	      'usemap': 'useMap',
	      'frameborder': 'frameBorder',
	      'contenteditable': 'contentEditable'
	    },
	    isArray = Array.isArray ||
	      function(object){ return object instanceof Array }
	
	  zepto.matches = function(element, selector) {
	    if (!selector || !element || element.nodeType !== 1) return false
	    var matchesSelector = element.webkitMatchesSelector || element.mozMatchesSelector ||
	                          element.oMatchesSelector || element.matchesSelector
	    if (matchesSelector) return matchesSelector.call(element, selector)
	    // fall back to performing a selector:
	    var match, parent = element.parentNode, temp = !parent
	    if (temp) (parent = tempParent).appendChild(element)
	    match = ~zepto.qsa(parent, selector).indexOf(element)
	    temp && tempParent.removeChild(element)
	    return match
	  }
	
	  function type(obj) {
	    return obj == null ? String(obj) :
	      class2type[toString.call(obj)] || "object"
	  }
	
	  function isFunction(value) { return type(value) == "function" }
	  function isWindow(obj)     { return obj != null && obj == obj.window }
	  function isDocument(obj)   { return obj != null && obj.nodeType == obj.DOCUMENT_NODE }
	  function isObject(obj)     { return type(obj) == "object" }
	  function isPlainObject(obj) {
	    return isObject(obj) && !isWindow(obj) && Object.getPrototypeOf(obj) == Object.prototype
	  }
	  function likeArray(obj) { return typeof obj.length == 'number' }
	
	  function compact(array) { return filter.call(array, function(item){ return item != null }) }
	  function flatten(array) { return array.length > 0 ? $.fn.concat.apply([], array) : array }
	  camelize = function(str){ return str.replace(/-+(.)?/g, function(match, chr){ return chr ? chr.toUpperCase() : '' }) }
	  function dasherize(str) {
	    return str.replace(/::/g, '/')
	           .replace(/([A-Z]+)([A-Z][a-z])/g, '$1_$2')
	           .replace(/([a-z\d])([A-Z])/g, '$1_$2')
	           .replace(/_/g, '-')
	           .toLowerCase()
	  }
	  uniq = function(array){ return filter.call(array, function(item, idx){ return array.indexOf(item) == idx }) }
	
	  function classRE(name) {
	    return name in classCache ?
	      classCache[name] : (classCache[name] = new RegExp('(^|\\s)' + name + '(\\s|$)'))
	  }
	
	  function maybeAddPx(name, value) {
	    return (typeof value == "number" && !cssNumber[dasherize(name)]) ? value + "px" : value
	  }
	
	  function defaultDisplay(nodeName) {
	    var element, display
	    if (!elementDisplay[nodeName]) {
	      element = document.createElement(nodeName)
	      document.body.appendChild(element)
	      display = getComputedStyle(element, '').getPropertyValue("display")
	      element.parentNode.removeChild(element)
	      display == "none" && (display = "block")
	      elementDisplay[nodeName] = display
	    }
	    return elementDisplay[nodeName]
	  }
	
	  function children(element) {
	    return 'children' in element ?
	      slice.call(element.children) :
	      $.map(element.childNodes, function(node){ if (node.nodeType == 1) return node })
	  }
	
	  // `$.zepto.fragment` takes a html string and an optional tag name
	  // to generate DOM nodes nodes from the given html string.
	  // The generated DOM nodes are returned as an array.
	  // This function can be overriden in plugins for example to make
	  // it compatible with browsers that don't support the DOM fully.
	  zepto.fragment = function(html, name, properties) {
	    var dom, nodes, container
	
	    // A special case optimization for a single tag
	    if (singleTagRE.test(html)) dom = $(document.createElement(RegExp.$1))
	
	    if (!dom) {
	      if (html.replace) html = html.replace(tagExpanderRE, "<$1></$2>")
	      if (name === undefined) name = fragmentRE.test(html) && RegExp.$1
	      if (!(name in containers)) name = '*'
	
	      container = containers[name]
	      container.innerHTML = '' + html
	      dom = $.each(slice.call(container.childNodes), function(){
	        container.removeChild(this)
	      })
	    }
	
	    if (isPlainObject(properties)) {
	      nodes = $(dom)
	      $.each(properties, function(key, value) {
	        if (methodAttributes.indexOf(key) > -1) nodes[key](value)
	        else nodes.attr(key, value)
	      })
	    }
	
	    return dom
	  }
	
	  // `$.zepto.Z` swaps out the prototype of the given `dom` array
	  // of nodes with `$.fn` and thus supplying all the Zepto functions
	  // to the array. Note that `__proto__` is not supported on Internet
	  // Explorer. This method can be overriden in plugins.
	  zepto.Z = function(dom, selector) {
	    dom = dom || []
	    dom.__proto__ = $.fn
	    dom.selector = selector || ''
	    return dom
	  }
	
	  // `$.zepto.isZ` should return `true` if the given object is a Zepto
	  // collection. This method can be overriden in plugins.
	  zepto.isZ = function(object) {
	    return object instanceof zepto.Z
	  }
	
	  // `$.zepto.init` is Zepto's counterpart to jQuery's `$.fn.init` and
	  // takes a CSS selector and an optional context (and handles various
	  // special cases).
	  // This method can be overriden in plugins.
	  zepto.init = function(selector, context) {
	    var dom
	    // If nothing given, return an empty Zepto collection
	    if (!selector) return zepto.Z()
	    // Optimize for string selectors
	    else if (typeof selector == 'string') {
	      selector = selector.trim()
	      // If it's a html fragment, create nodes from it
	      // Note: In both Chrome 21 and Firefox 15, DOM error 12
	      // is thrown if the fragment doesn't begin with <
	      if (selector[0] == '<' && fragmentRE.test(selector))
	        dom = zepto.fragment(selector, RegExp.$1, context), selector = null
	      // If there's a context, create a collection on that context first, and select
	      // nodes from there
	      else if (context !== undefined) return $(context).find(selector)
	      // If it's a CSS selector, use it to select nodes.
	      else dom = zepto.qsa(document, selector)
	    }
	    // If a function is given, call it when the DOM is ready
	    else if (isFunction(selector)) return $(document).ready(selector)
	    // If a Zepto collection is given, just return it
	    else if (zepto.isZ(selector)) return selector
	    else {
	      // normalize array if an array of nodes is given
	      if (isArray(selector)) dom = compact(selector)
	      // Wrap DOM nodes.
	      else if (isObject(selector))
	        dom = [selector], selector = null
	      // If it's a html fragment, create nodes from it
	      else if (fragmentRE.test(selector))
	        dom = zepto.fragment(selector.trim(), RegExp.$1, context), selector = null
	      // If there's a context, create a collection on that context first, and select
	      // nodes from there
	      else if (context !== undefined) return $(context).find(selector)
	      // And last but no least, if it's a CSS selector, use it to select nodes.
	      else dom = zepto.qsa(document, selector)
	    }
	    // create a new Zepto collection from the nodes found
	    return zepto.Z(dom, selector)
	  }
	
	  // `$` will be the base `Zepto` object. When calling this
	  // function just call `$.zepto.init, which makes the implementation
	  // details of selecting nodes and creating Zepto collections
	  // patchable in plugins.
	  $ = function(selector, context){
	    return zepto.init(selector, context)
	  }
	
	  function extend(target, source, deep) {
	    for (key in source)
	      if (deep && (isPlainObject(source[key]) || isArray(source[key]))) {
	        if (isPlainObject(source[key]) && !isPlainObject(target[key]))
	          target[key] = {}
	        if (isArray(source[key]) && !isArray(target[key]))
	          target[key] = []
	        extend(target[key], source[key], deep)
	      }
	      else if (source[key] !== undefined) target[key] = source[key]
	  }
	
	  // Copy all but undefined properties from one or more
	  // objects to the `target` object.
	  $.extend = function(target){
	    var deep, args = slice.call(arguments, 1)
	    if (typeof target == 'boolean') {
	      deep = target
	      target = args.shift()
	    }
	    args.forEach(function(arg){ extend(target, arg, deep) })
	    return target
	  }
	
	  // `$.zepto.qsa` is Zepto's CSS selector implementation which
	  // uses `document.querySelectorAll` and optimizes for some special cases, like `#id`.
	  // This method can be overriden in plugins.
	  zepto.qsa = function(element, selector){
	    var found,
	        maybeID = selector[0] == '#',
	        maybeClass = !maybeID && selector[0] == '.',
	        nameOnly = maybeID || maybeClass ? selector.slice(1) : selector, // Ensure that a 1 char tag name still gets checked
	        isSimple = simpleSelectorRE.test(nameOnly)
	    return (isDocument(element) && isSimple && maybeID) ?
	      ( (found = element.getElementById(nameOnly)) ? [found] : [] ) :
	      (element.nodeType !== 1 && element.nodeType !== 9) ? [] :
	      slice.call(
	        isSimple && !maybeID ?
	          maybeClass ? element.getElementsByClassName(nameOnly) : // If it's simple, it could be a class
	          element.getElementsByTagName(selector) : // Or a tag
	          element.querySelectorAll(selector) // Or it's not simple, and we need to query all
	      )
	  }
	
	  function filtered(nodes, selector) {
	    return selector == null ? $(nodes) : $(nodes).filter(selector)
	  }
	
	  $.contains = document.documentElement.contains ?
	    function(parent, node) {
	      return parent !== node && parent.contains(node)
	    } :
	    function(parent, node) {
	      while (node && (node = node.parentNode))
	        if (node === parent) return true
	      return false
	    }
	
	  function funcArg(context, arg, idx, payload) {
	    return isFunction(arg) ? arg.call(context, idx, payload) : arg
	  }
	
	  function setAttribute(node, name, value) {
	    value == null ? node.removeAttribute(name) : node.setAttribute(name, value)
	  }
	
	  // access className property while respecting SVGAnimatedString
	  function className(node, value){
	    var klass = node.className,
	        svg   = klass && klass.baseVal !== undefined
	
	    if (value === undefined) return svg ? klass.baseVal : klass
	    svg ? (klass.baseVal = value) : (node.className = value)
	  }
	
	  // "true"  => true
	  // "false" => false
	  // "null"  => null
	  // "42"    => 42
	  // "42.5"  => 42.5
	  // "08"    => "08"
	  // JSON    => parse if valid
	  // String  => self
	  function deserializeValue(value) {
	    var num
	    try {
	      return value ?
	        value == "true" ||
	        ( value == "false" ? false :
	          value == "null" ? null :
	          !/^0/.test(value) && !isNaN(num = Number(value)) ? num :
	          /^[\[\{]/.test(value) ? $.parseJSON(value) :
	          value )
	        : value
	    } catch(e) {
	      return value
	    }
	  }
	
	  $.type = type
	  $.isFunction = isFunction
	  $.isWindow = isWindow
	  $.isArray = isArray
	  $.isPlainObject = isPlainObject
	
	  $.isEmptyObject = function(obj) {
	    var name
	    for (name in obj) return false
	    return true
	  }
	
	  $.inArray = function(elem, array, i){
	    return emptyArray.indexOf.call(array, elem, i)
	  }
	
	  $.camelCase = camelize
	  $.trim = function(str) {
	    return str == null ? "" : String.prototype.trim.call(str)
	  }
	
	  // plugin compatibility
	  $.uuid = 0
	  $.support = { }
	  $.expr = { }
	
	  $.map = function(elements, callback){
	    var value, values = [], i, key
	    if (likeArray(elements))
	      for (i = 0; i < elements.length; i++) {
	        value = callback(elements[i], i)
	        if (value != null) values.push(value)
	      }
	    else
	      for (key in elements) {
	        value = callback(elements[key], key)
	        if (value != null) values.push(value)
	      }
	    return flatten(values)
	  }
	
	  $.each = function(elements, callback){
	    var i, key
	    if (likeArray(elements)) {
	      for (i = 0; i < elements.length; i++)
	        if (callback.call(elements[i], i, elements[i]) === false) return elements
	    } else {
	      for (key in elements)
	        if (callback.call(elements[key], key, elements[key]) === false) return elements
	    }
	
	    return elements
	  }
	
	  $.grep = function(elements, callback){
	    return filter.call(elements, callback)
	  }
	
	  if (window.JSON) $.parseJSON = JSON.parse
	
	  // Populate the class2type map
	  $.each("Boolean Number String Function Array Date RegExp Object Error".split(" "), function(i, name) {
	    class2type[ "[object " + name + "]" ] = name.toLowerCase()
	  })
	
	  // Define methods that will be available on all
	  // Zepto collections
	  $.fn = {
	    // Because a collection acts like an array
	    // copy over these useful array functions.
	    forEach: emptyArray.forEach,
	    reduce: emptyArray.reduce,
	    push: emptyArray.push,
	    sort: emptyArray.sort,
	    indexOf: emptyArray.indexOf,
	    concat: emptyArray.concat,
	
	    // `map` and `slice` in the jQuery API work differently
	    // from their array counterparts
	    map: function(fn){
	      return $($.map(this, function(el, i){ return fn.call(el, i, el) }))
	    },
	    slice: function(){
	      return $(slice.apply(this, arguments))
	    },
	
	    ready: function(callback){
	      // need to check if document.body exists for IE as that browser reports
	      // document ready when it hasn't yet created the body element
	      if (readyRE.test(document.readyState) && document.body) callback($)
	      else document.addEventListener('DOMContentLoaded', function(){ callback($) }, false)
	      return this
	    },
	    get: function(idx){
	      return idx === undefined ? slice.call(this) : this[idx >= 0 ? idx : idx + this.length]
	    },
	    toArray: function(){ return this.get() },
	    size: function(){
	      return this.length
	    },
	    remove: function(){
	      return this.each(function(){
	        if (this.parentNode != null)
	          this.parentNode.removeChild(this)
	      })
	    },
	    each: function(callback){
	      emptyArray.every.call(this, function(el, idx){
	        return callback.call(el, idx, el) !== false
	      })
	      return this
	    },
	    filter: function(selector){
	      if (isFunction(selector)) return this.not(this.not(selector))
	      return $(filter.call(this, function(element){
	        return zepto.matches(element, selector)
	      }))
	    },
	    add: function(selector,context){
	      return $(uniq(this.concat($(selector,context))))
	    },
	    is: function(selector){
	      return this.length > 0 && zepto.matches(this[0], selector)
	    },
	    not: function(selector){
	      var nodes=[]
	      if (isFunction(selector) && selector.call !== undefined)
	        this.each(function(idx){
	          if (!selector.call(this,idx)) nodes.push(this)
	        })
	      else {
	        var excludes = typeof selector == 'string' ? this.filter(selector) :
	          (likeArray(selector) && isFunction(selector.item)) ? slice.call(selector) : $(selector)
	        this.forEach(function(el){
	          if (excludes.indexOf(el) < 0) nodes.push(el)
	        })
	      }
	      return $(nodes)
	    },
	    has: function(selector){
	      return this.filter(function(){
	        return isObject(selector) ?
	          $.contains(this, selector) :
	          $(this).find(selector).size()
	      })
	    },
	    eq: function(idx){
	      return idx === -1 ? this.slice(idx) : this.slice(idx, + idx + 1)
	    },
	    first: function(){
	      var el = this[0]
	      return el && !isObject(el) ? el : $(el)
	    },
	    last: function(){
	      var el = this[this.length - 1]
	      return el && !isObject(el) ? el : $(el)
	    },
	    find: function(selector){
	      var result, $this = this
	      if (!selector) result = []
	      else if (typeof selector == 'object')
	        result = $(selector).filter(function(){
	          var node = this
	          return emptyArray.some.call($this, function(parent){
	            return $.contains(parent, node)
	          })
	        })
	      else if (this.length == 1) result = $(zepto.qsa(this[0], selector))
	      else result = this.map(function(){ return zepto.qsa(this, selector) })
	      return result
	    },
	    closest: function(selector, context){
	      var node = this[0], collection = false
	      if (typeof selector == 'object') collection = $(selector)
	      while (node && !(collection ? collection.indexOf(node) >= 0 : zepto.matches(node, selector)))
	        node = node !== context && !isDocument(node) && node.parentNode
	      return $(node)
	    },
	    parents: function(selector){
	      var ancestors = [], nodes = this
	      while (nodes.length > 0)
	        nodes = $.map(nodes, function(node){
	          if ((node = node.parentNode) && !isDocument(node) && ancestors.indexOf(node) < 0) {
	            ancestors.push(node)
	            return node
	          }
	        })
	      return filtered(ancestors, selector)
	    },
	    parent: function(selector){
	      return filtered(uniq(this.pluck('parentNode')), selector)
	    },
	    children: function(selector){
	      return filtered(this.map(function(){ return children(this) }), selector)
	    },
	    contents: function() {
	      return this.map(function() { return slice.call(this.childNodes) })
	    },
	    siblings: function(selector){
	      return filtered(this.map(function(i, el){
	        return filter.call(children(el.parentNode), function(child){ return child!==el })
	      }), selector)
	    },
	    empty: function(){
	      return this.each(function(){ this.innerHTML = '' })
	    },
	    // `pluck` is borrowed from Prototype.js
	    pluck: function(property){
	      return $.map(this, function(el){ return el[property] })
	    },
	    show: function(){
	      return this.each(function(){
	        this.style.display == "none" && (this.style.display = '')
	        if (getComputedStyle(this, '').getPropertyValue("display") == "none")
	          this.style.display = defaultDisplay(this.nodeName)
	      })
	    },
	    replaceWith: function(newContent){
	      return this.before(newContent).remove()
	    },
	    wrap: function(structure){
	      var func = isFunction(structure)
	      if (this[0] && !func)
	        var dom   = $(structure).get(0),
	            clone = dom.parentNode || this.length > 1
	
	      return this.each(function(index){
	        $(this).wrapAll(
	          func ? structure.call(this, index) :
	            clone ? dom.cloneNode(true) : dom
	        )
	      })
	    },
	    wrapAll: function(structure){
	      if (this[0]) {
	        $(this[0]).before(structure = $(structure))
	        var children
	        // drill down to the inmost element
	        while ((children = structure.children()).length) structure = children.first()
	        $(structure).append(this)
	      }
	      return this
	    },
	    wrapInner: function(structure){
	      var func = isFunction(structure)
	      return this.each(function(index){
	        var self = $(this), contents = self.contents(),
	            dom  = func ? structure.call(this, index) : structure
	        contents.length ? contents.wrapAll(dom) : self.append(dom)
	      })
	    },
	    unwrap: function(){
	      this.parent().each(function(){
	        $(this).replaceWith($(this).children())
	      })
	      return this
	    },
	    clone: function(){
	      return this.map(function(){ return this.cloneNode(true) })
	    },
	    hide: function(){
	      return this.css("display", "none")
	    },
	    toggle: function(setting){
	      return this.each(function(){
	        var el = $(this)
	        ;(setting === undefined ? el.css("display") == "none" : setting) ? el.show() : el.hide()
	      })
	    },
	    prev: function(selector){ return $(this.pluck('previousElementSibling')).filter(selector || '*') },
	    next: function(selector){ return $(this.pluck('nextElementSibling')).filter(selector || '*') },
	    html: function(html){
	      return 0 in arguments ?
	        this.each(function(idx){
	          var originHtml = this.innerHTML
	          $(this).empty().append( funcArg(this, html, idx, originHtml) )
	        }) :
	        (0 in this ? this[0].innerHTML : null)
	    },
	    text: function(text){
	      return 0 in arguments ?
	        this.each(function(idx){
	          var newText = funcArg(this, text, idx, this.textContent)
	          this.textContent = newText == null ? '' : ''+newText
	        }) :
	        (0 in this ? this[0].textContent : null)
	    },
	    attr: function(name, value){
	      var result
	      return (typeof name == 'string' && !(1 in arguments)) ?
	        (!this.length || this[0].nodeType !== 1 ? undefined :
	          (!(result = this[0].getAttribute(name)) && name in this[0]) ? this[0][name] : result
	        ) :
	        this.each(function(idx){
	          if (this.nodeType !== 1) return
	          if (isObject(name)) for (key in name) setAttribute(this, key, name[key])
	          else setAttribute(this, name, funcArg(this, value, idx, this.getAttribute(name)))
	        })
	    },
	    removeAttr: function(name){
	      return this.each(function(){ this.nodeType === 1 && setAttribute(this, name) })
	    },
	    prop: function(name, value){
	      name = propMap[name] || name
	      return (1 in arguments) ?
	        this.each(function(idx){
	          this[name] = funcArg(this, value, idx, this[name])
	        }) :
	        (this[0] && this[0][name])
	    },
	    data: function(name, value){
	      var attrName = 'data-' + name.replace(capitalRE, '-$1').toLowerCase()
	
	      var data = (1 in arguments) ?
	        this.attr(attrName, value) :
	        this.attr(attrName)
	
	      return data !== null ? deserializeValue(data) : undefined
	    },
	    val: function(value){
	      return 0 in arguments ?
	        this.each(function(idx){
	          this.value = funcArg(this, value, idx, this.value)
	        }) :
	        (this[0] && (this[0].multiple ?
	           $(this[0]).find('option').filter(function(){ return this.selected }).pluck('value') :
	           this[0].value)
	        )
	    },
	    offset: function(coordinates){
	      if (coordinates) return this.each(function(index){
	        var $this = $(this),
	            coords = funcArg(this, coordinates, index, $this.offset()),
	            parentOffset = $this.offsetParent().offset(),
	            props = {
	              top:  coords.top  - parentOffset.top,
	              left: coords.left - parentOffset.left
	            }
	
	        if ($this.css('position') == 'static') props['position'] = 'relative'
	        $this.css(props)
	      })
	      if (!this.length) return null
	      var obj = this[0].getBoundingClientRect()
	      return {
	        left: obj.left + window.pageXOffset,
	        top: obj.top + window.pageYOffset,
	        width: Math.round(obj.width),
	        height: Math.round(obj.height)
	      }
	    },
	    css: function(property, value){
	      if (arguments.length < 2) {
	        var element = this[0], computedStyle = getComputedStyle(element, '')
	        if(!element) return
	        if (typeof property == 'string')
	          return element.style[camelize(property)] || computedStyle.getPropertyValue(property)
	        else if (isArray(property)) {
	          var props = {}
	          $.each(isArray(property) ? property: [property], function(_, prop){
	            props[prop] = (element.style[camelize(prop)] || computedStyle.getPropertyValue(prop))
	          })
	          return props
	        }
	      }
	
	      var css = ''
	      if (type(property) == 'string') {
	        if (!value && value !== 0)
	          this.each(function(){ this.style.removeProperty(dasherize(property)) })
	        else
	          css = dasherize(property) + ":" + maybeAddPx(property, value)
	      } else {
	        for (key in property)
	          if (!property[key] && property[key] !== 0)
	            this.each(function(){ this.style.removeProperty(dasherize(key)) })
	          else
	            css += dasherize(key) + ':' + maybeAddPx(key, property[key]) + ';'
	      }
	
	      return this.each(function(){ this.style.cssText += ';' + css })
	    },
	    index: function(element){
	      return element ? this.indexOf($(element)[0]) : this.parent().children().indexOf(this[0])
	    },
	    hasClass: function(name){
	      if (!name) return false
	      return emptyArray.some.call(this, function(el){
	        return this.test(className(el))
	      }, classRE(name))
	    },
	    addClass: function(name){
	      if (!name) return this
	      return this.each(function(idx){
	        classList = []
	        var cls = className(this), newName = funcArg(this, name, idx, cls)
	        newName.split(/\s+/g).forEach(function(klass){
	          if (!$(this).hasClass(klass)) classList.push(klass)
	        }, this)
	        classList.length && className(this, cls + (cls ? " " : "") + classList.join(" "))
	      })
	    },
	    removeClass: function(name){
	      return this.each(function(idx){
	        if (name === undefined) return className(this, '')
	        classList = className(this)
	        funcArg(this, name, idx, classList).split(/\s+/g).forEach(function(klass){
	          classList = classList.replace(classRE(klass), " ")
	        })
	        className(this, classList.trim())
	      })
	    },
	    toggleClass: function(name, when){
	      if (!name) return this
	      return this.each(function(idx){
	        var $this = $(this), names = funcArg(this, name, idx, className(this))
	        names.split(/\s+/g).forEach(function(klass){
	          (when === undefined ? !$this.hasClass(klass) : when) ?
	            $this.addClass(klass) : $this.removeClass(klass)
	        })
	      })
	    },
	    scrollTop: function(value){
	      if (!this.length) return
	      var hasScrollTop = 'scrollTop' in this[0]
	      if (value === undefined) return hasScrollTop ? this[0].scrollTop : this[0].pageYOffset
	      return this.each(hasScrollTop ?
	        function(){ this.scrollTop = value } :
	        function(){ this.scrollTo(this.scrollX, value) })
	    },
	    scrollLeft: function(value){
	      if (!this.length) return
	      var hasScrollLeft = 'scrollLeft' in this[0]
	      if (value === undefined) return hasScrollLeft ? this[0].scrollLeft : this[0].pageXOffset
	      return this.each(hasScrollLeft ?
	        function(){ this.scrollLeft = value } :
	        function(){ this.scrollTo(value, this.scrollY) })
	    },
	    position: function() {
	      if (!this.length) return
	
	      var elem = this[0],
	        // Get *real* offsetParent
	        offsetParent = this.offsetParent(),
	        // Get correct offsets
	        offset       = this.offset(),
	        parentOffset = rootNodeRE.test(offsetParent[0].nodeName) ? { top: 0, left: 0 } : offsetParent.offset()
	
	      // Subtract element margins
	      // note: when an element has margin: auto the offsetLeft and marginLeft
	      // are the same in Safari causing offset.left to incorrectly be 0
	      offset.top  -= parseFloat( $(elem).css('margin-top') ) || 0
	      offset.left -= parseFloat( $(elem).css('margin-left') ) || 0
	
	      // Add offsetParent borders
	      parentOffset.top  += parseFloat( $(offsetParent[0]).css('border-top-width') ) || 0
	      parentOffset.left += parseFloat( $(offsetParent[0]).css('border-left-width') ) || 0
	
	      // Subtract the two offsets
	      return {
	        top:  offset.top  - parentOffset.top,
	        left: offset.left - parentOffset.left
	      }
	    },
	    offsetParent: function() {
	      return this.map(function(){
	        var parent = this.offsetParent || document.body
	        while (parent && !rootNodeRE.test(parent.nodeName) && $(parent).css("position") == "static")
	          parent = parent.offsetParent
	        return parent
	      })
	    }
	  }
	
	  // for now
	  $.fn.detach = $.fn.remove
	
	  // Generate the `width` and `height` functions
	  ;['width', 'height'].forEach(function(dimension){
	    var dimensionProperty =
	      dimension.replace(/./, function(m){ return m[0].toUpperCase() })
	
	    $.fn[dimension] = function(value){
	      var offset, el = this[0]
	      if (value === undefined) return isWindow(el) ? el['inner' + dimensionProperty] :
	        isDocument(el) ? el.documentElement['scroll' + dimensionProperty] :
	        (offset = this.offset()) && offset[dimension]
	      else return this.each(function(idx){
	        el = $(this)
	        el.css(dimension, funcArg(this, value, idx, el[dimension]()))
	      })
	    }
	  })
	
	  function traverseNode(node, fun) {
	    fun(node)
	    for (var i = 0, len = node.childNodes.length; i < len; i++)
	      traverseNode(node.childNodes[i], fun)
	  }
	
	  // Generate the `after`, `prepend`, `before`, `append`,
	  // `insertAfter`, `insertBefore`, `appendTo`, and `prependTo` methods.
	  adjacencyOperators.forEach(function(operator, operatorIndex) {
	    var inside = operatorIndex % 2 //=> prepend, append
	
	    $.fn[operator] = function(){
	      // arguments can be nodes, arrays of nodes, Zepto objects and HTML strings
	      var argType, nodes = $.map(arguments, function(arg) {
	            argType = type(arg)
	            return argType == "object" || argType == "array" || arg == null ?
	              arg : zepto.fragment(arg)
	          }),
	          parent, copyByClone = this.length > 1
	      if (nodes.length < 1) return this
	
	      return this.each(function(_, target){
	        parent = inside ? target : target.parentNode
	
	        // convert all methods to a "before" operation
	        target = operatorIndex == 0 ? target.nextSibling :
	                 operatorIndex == 1 ? target.firstChild :
	                 operatorIndex == 2 ? target :
	                 null
	
	        var parentInDocument = $.contains(document.documentElement, parent)
	
	        nodes.forEach(function(node){
	          if (copyByClone) node = node.cloneNode(true)
	          else if (!parent) return $(node).remove()
	
	          parent.insertBefore(node, target)
	          if (parentInDocument) traverseNode(node, function(el){
	            if (el.nodeName != null && el.nodeName.toUpperCase() === 'SCRIPT' &&
	               (!el.type || el.type === 'text/javascript') && !el.src)
	              window['eval'].call(window, el.innerHTML)
	          })
	        })
	      })
	    }
	
	    // after    => insertAfter
	    // prepend  => prependTo
	    // before   => insertBefore
	    // append   => appendTo
	    $.fn[inside ? operator+'To' : 'insert'+(operatorIndex ? 'Before' : 'After')] = function(html){
	      $(html)[operator](this)
	      return this
	    }
	  })
	
	  zepto.Z.prototype = $.fn
	
	  // Export internal API functions in the `$.zepto` namespace
	  zepto.uniq = uniq
	  zepto.deserializeValue = deserializeValue
	  $.zepto = zepto
	
	  return $
	})()
	
	;(function($){
	  var cache = [], timeout
	
	  $.fn.remove = function(){
	    return this.each(function(){
	      if(this.parentNode){
	        if(this.tagName === 'IMG'){
	          cache.push(this)
	          this.src = 'data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs='
	          if (timeout) clearTimeout(timeout)
	          timeout = setTimeout(function(){ cache = [] }, 60000)
	        }
	        this.parentNode.removeChild(this)
	      }
	    })
	  }
	})(Zepto)
	
	;(function($){
	  // Create a collection of callbacks to be fired in a sequence, with configurable behaviour
	  // Option flags:
	  //   - once: Callbacks fired at most one time.
	  //   - memory: Remember the most recent context and arguments
	  //   - stopOnFalse: Cease iterating over callback list
	  //   - unique: Permit adding at most one instance of the same callback
	  $.Callbacks = function(options) {
	    options = $.extend({}, options)
	
	    var memory, // Last fire value (for non-forgettable lists)
	        fired,  // Flag to know if list was already fired
	        firing, // Flag to know if list is currently firing
	        firingStart, // First callback to fire (used internally by add and fireWith)
	        firingLength, // End of the loop when firing
	        firingIndex, // Index of currently firing callback (modified by remove if needed)
	        list = [], // Actual callback list
	        stack = !options.once && [], // Stack of fire calls for repeatable lists
	        fire = function(data) {
	          memory = options.memory && data
	          fired = true
	          firingIndex = firingStart || 0
	          firingStart = 0
	          firingLength = list.length
	          firing = true
	          for ( ; list && firingIndex < firingLength ; ++firingIndex ) {
	            if (list[firingIndex].apply(data[0], data[1]) === false && options.stopOnFalse) {
	              memory = false
	              break
	            }
	          }
	          firing = false
	          if (list) {
	            if (stack) stack.length && fire(stack.shift())
	            else if (memory) list.length = 0
	            else Callbacks.disable()
	          }
	        },
	
	        Callbacks = {
	          add: function() {
	            if (list) {
	              var start = list.length,
	                  add = function(args) {
	                    $.each(args, function(_, arg){
	                      if (typeof arg === "function") {
	                        if (!options.unique || !Callbacks.has(arg)) list.push(arg)
	                      }
	                      else if (arg && arg.length && typeof arg !== 'string') add(arg)
	                    })
	                  }
	              add(arguments)
	              if (firing) firingLength = list.length
	              else if (memory) {
	                firingStart = start
	                fire(memory)
	              }
	            }
	            return this
	          },
	          remove: function() {
	            if (list) {
	              $.each(arguments, function(_, arg){
	                var index
	                while ((index = $.inArray(arg, list, index)) > -1) {
	                  list.splice(index, 1)
	                  // Handle firing indexes
	                  if (firing) {
	                    if (index <= firingLength) --firingLength
	                    if (index <= firingIndex) --firingIndex
	                  }
	                }
	              })
	            }
	            return this
	          },
	          has: function(fn) {
	            return !!(list && (fn ? $.inArray(fn, list) > -1 : list.length))
	          },
	          empty: function() {
	            firingLength = list.length = 0
	            return this
	          },
	          disable: function() {
	            list = stack = memory = undefined
	            return this
	          },
	          disabled: function() {
	            return !list
	          },
	          lock: function() {
	            stack = undefined;
	            if (!memory) Callbacks.disable()
	            return this
	          },
	          locked: function() {
	            return !stack
	          },
	          fireWith: function(context, args) {
	            if (list && (!fired || stack)) {
	              args = args || []
	              args = [context, args.slice ? args.slice() : args]
	              if (firing) stack.push(args)
	              else fire(args)
	            }
	            return this
	          },
	          fire: function() {
	            return Callbacks.fireWith(this, arguments)
	          },
	          fired: function() {
	            return !!fired
	          }
	        }
	
	    return Callbacks
	  }
	})(Zepto)
	
	;(function($){
	  var data = {}, dataAttr = $.fn.data, camelize = $.camelCase,
	    exp = $.expando = 'Zepto' + (+new Date()), emptyArray = []
	
	  // Get value from node:
	  // 1. first try key as given,
	  // 2. then try camelized key,
	  // 3. fall back to reading "data-*" attribute.
	  function getData(node, name) {
	    var id = node[exp], store = id && data[id]
	    if (name === undefined) return store || setData(node)
	    else {
	      if (store) {
	        if (name in store) return store[name]
	        var camelName = camelize(name)
	        if (camelName in store) return store[camelName]
	      }
	      return dataAttr.call($(node), name)
	    }
	  }
	
	  // Store value under camelized key on node
	  function setData(node, name, value) {
	    var id = node[exp] || (node[exp] = ++$.uuid),
	      store = data[id] || (data[id] = attributeData(node))
	    if (name !== undefined) store[camelize(name)] = value
	    return store
	  }
	
	  // Read all "data-*" attributes from a node
	  function attributeData(node) {
	    var store = {}
	    $.each(node.attributes || emptyArray, function(i, attr){
	      if (attr.name.indexOf('data-') == 0)
	        store[camelize(attr.name.replace('data-', ''))] =
	          $.zepto.deserializeValue(attr.value)
	    })
	    return store
	  }
	
	  $.fn.data = function(name, value) {
	    return value === undefined ?
	      // set multiple values via object
	      $.isPlainObject(name) ?
	        this.each(function(i, node){
	          $.each(name, function(key, value){ setData(node, key, value) })
	        }) :
	        // get value from first element
	        (0 in this ? getData(this[0], name) : undefined) :
	      // set value on all elements
	      this.each(function(){ setData(this, name, value) })
	  }
	
	  $.fn.removeData = function(names) {
	    if (typeof names == 'string') names = names.split(/\s+/)
	    return this.each(function(){
	      var id = this[exp], store = id && data[id]
	      if (store) $.each(names || store, function(key){
	        delete store[names ? camelize(this) : key]
	      })
	    })
	  }
	
	  // Generate extended `remove` and `empty` functions
	  ;['remove', 'empty'].forEach(function(methodName){
	    var origFn = $.fn[methodName]
	    $.fn[methodName] = function() {
	      var elements = this.find('*')
	      if (methodName === 'remove') elements = elements.add(this)
	      elements.removeData()
	      return origFn.call(this)
	    }
	  })
	})(Zepto)
	
	;(function($){
	  var slice = Array.prototype.slice
	
	  function Deferred(func) {
	    var tuples = [
	          // action, add listener, listener list, final state
	          [ "resolve", "done", $.Callbacks({once:1, memory:1}), "resolved" ],
	          [ "reject", "fail", $.Callbacks({once:1, memory:1}), "rejected" ],
	          [ "notify", "progress", $.Callbacks({memory:1}) ]
	        ],
	        state = "pending",
	        promise = {
	          state: function() {
	            return state
	          },
	          always: function() {
	            deferred.done(arguments).fail(arguments)
	            return this
	          },
	          then: function(/* fnDone [, fnFailed [, fnProgress]] */) {
	            var fns = arguments
	            return Deferred(function(defer){
	              $.each(tuples, function(i, tuple){
	                var fn = $.isFunction(fns[i]) && fns[i]
	                deferred[tuple[1]](function(){
	                  var returned = fn && fn.apply(this, arguments)
	                  if (returned && $.isFunction(returned.promise)) {
	                    returned.promise()
	                      .done(defer.resolve)
	                      .fail(defer.reject)
	                      .progress(defer.notify)
	                  } else {
	                    var context = this === promise ? defer.promise() : this,
	                        values = fn ? [returned] : arguments
	                    defer[tuple[0] + "With"](context, values)
	                  }
	                })
	              })
	              fns = null
	            }).promise()
	          },
	
	          promise: function(obj) {
	            return obj != null ? $.extend( obj, promise ) : promise
	          }
	        },
	        deferred = {}
	
	    $.each(tuples, function(i, tuple){
	      var list = tuple[2],
	          stateString = tuple[3]
	
	      promise[tuple[1]] = list.add
	
	      if (stateString) {
	        list.add(function(){
	          state = stateString
	        }, tuples[i^1][2].disable, tuples[2][2].lock)
	      }
	
	      deferred[tuple[0]] = function(){
	        deferred[tuple[0] + "With"](this === deferred ? promise : this, arguments)
	        return this
	      }
	      deferred[tuple[0] + "With"] = list.fireWith
	    })
	
	    promise.promise(deferred)
	    if (func) func.call(deferred, deferred)
	    return deferred
	  }
	
	  $.when = function(sub) {
	    var resolveValues = slice.call(arguments),
	        len = resolveValues.length,
	        i = 0,
	        remain = len !== 1 || (sub && $.isFunction(sub.promise)) ? len : 0,
	        deferred = remain === 1 ? sub : Deferred(),
	        progressValues, progressContexts, resolveContexts,
	        updateFn = function(i, ctx, val){
	          return function(value){
	            ctx[i] = this
	            val[i] = arguments.length > 1 ? slice.call(arguments) : value
	            if (val === progressValues) {
	              deferred.notifyWith(ctx, val)
	            } else if (!(--remain)) {
	              deferred.resolveWith(ctx, val)
	            }
	          }
	        }
	
	    if (len > 1) {
	      progressValues = new Array(len)
	      progressContexts = new Array(len)
	      resolveContexts = new Array(len)
	      for ( ; i < len; ++i ) {
	        if (resolveValues[i] && $.isFunction(resolveValues[i].promise)) {
	          resolveValues[i].promise()
	            .done(updateFn(i, resolveContexts, resolveValues))
	            .fail(deferred.reject)
	            .progress(updateFn(i, progressContexts, progressValues))
	        } else {
	          --remain
	        }
	      }
	    }
	    if (!remain) deferred.resolveWith(resolveContexts, resolveValues)
	    return deferred.promise()
	  }
	
	  $.Deferred = Deferred
	})(Zepto)
	
	;(function($){
	  function detect(ua){
	    var os = this.os = {}, browser = this.browser = {},
	      webkit = ua.match(/Web[kK]it[\/]{0,1}([\d.]+)/),
	      android = ua.match(/(Android);?[\s\/]+([\d.]+)?/),
	      osx = !!ua.match(/\(Macintosh\; Intel /),
	      ipad = ua.match(/(iPad).*OS\s([\d_]+)/),
	      ipod = ua.match(/(iPod)(.*OS\s([\d_]+))?/),
	      iphone = !ipad && ua.match(/(iPhone\sOS)\s([\d_]+)/),
	      webos = ua.match(/(webOS|hpwOS)[\s\/]([\d.]+)/),
	      wp = ua.match(/Windows Phone ([\d.]+)/),
	      touchpad = webos && ua.match(/TouchPad/),
	      kindle = ua.match(/Kindle\/([\d.]+)/),
	      silk = ua.match(/Silk\/([\d._]+)/),
	      blackberry = ua.match(/(BlackBerry).*Version\/([\d.]+)/),
	      bb10 = ua.match(/(BB10).*Version\/([\d.]+)/),
	      rimtabletos = ua.match(/(RIM\sTablet\sOS)\s([\d.]+)/),
	      playbook = ua.match(/PlayBook/),
	      chrome = ua.match(/Chrome\/([\d.]+)/) || ua.match(/CriOS\/([\d.]+)/),
	      firefox = ua.match(/Firefox\/([\d.]+)/),
	      ie = ua.match(/MSIE\s([\d.]+)/) || ua.match(/Trident\/[\d](?=[^\?]+).*rv:([0-9.].)/),
	      webview = !chrome && ua.match(/(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/),
	      safari = webview || ua.match(/Version\/([\d.]+)([^S](Safari)|[^M]*(Mobile)[^S]*(Safari))/)
	
	    // Todo: clean this up with a better OS/browser seperation:
	    // - discern (more) between multiple browsers on android
	    // - decide if kindle fire in silk mode is android or not
	    // - Firefox on Android doesn't specify the Android version
	    // - possibly devide in os, device and browser hashes
	
	    if (browser.webkit = !!webkit) browser.version = webkit[1]
	
	    if (android) os.android = true, os.version = android[2]
	    if (iphone && !ipod) os.ios = os.iphone = true, os.version = iphone[2].replace(/_/g, '.')
	    if (ipad) os.ios = os.ipad = true, os.version = ipad[2].replace(/_/g, '.')
	    if (ipod) os.ios = os.ipod = true, os.version = ipod[3] ? ipod[3].replace(/_/g, '.') : null
	    if (wp) os.wp = true, os.version = wp[1]
	    if (webos) os.webos = true, os.version = webos[2]
	    if (touchpad) os.touchpad = true
	    if (blackberry) os.blackberry = true, os.version = blackberry[2]
	    if (bb10) os.bb10 = true, os.version = bb10[2]
	    if (rimtabletos) os.rimtabletos = true, os.version = rimtabletos[2]
	    if (playbook) browser.playbook = true
	    if (kindle) os.kindle = true, os.version = kindle[1]
	    if (silk) browser.silk = true, browser.version = silk[1]
	    if (!silk && os.android && ua.match(/Kindle Fire/)) browser.silk = true
	    if (chrome) browser.chrome = true, browser.version = chrome[1]
	    if (firefox) browser.firefox = true, browser.version = firefox[1]
	    if (ie) browser.ie = true, browser.version = ie[1]
	    if (safari && (osx || os.ios)) {browser.safari = true; if (osx) browser.version = safari[1]}
	    if (webview) browser.webview = true
	
	    os.tablet = !!(ipad || playbook || (android && !ua.match(/Mobile/)) ||
	      (firefox && ua.match(/Tablet/)) || (ie && !ua.match(/Phone/) && ua.match(/Touch/)))
	    os.phone  = !!(!os.tablet && !os.ipod && (android || iphone || webos || blackberry || bb10 ||
	      (chrome && ua.match(/Android/)) || (chrome && ua.match(/CriOS\/([\d.]+)/)) ||
	      (firefox && ua.match(/Mobile/)) || (ie && ua.match(/Touch/))))
	  }
	
	  detect.call($, navigator.userAgent)
	  // make available to unit tests
	  $.__detect = detect
	
	})(Zepto)
	
	;(function($){
	  var _zid = 1, undefined,
	      slice = Array.prototype.slice,
	      isFunction = $.isFunction,
	      isString = function(obj){ return typeof obj == 'string' },
	      handlers = {},
	      specialEvents={},
	      focusinSupported = 'onfocusin' in window,
	      focus = { focus: 'focusin', blur: 'focusout' },
	      hover = { mouseenter: 'mouseover', mouseleave: 'mouseout' }
	
	  specialEvents.click = specialEvents.mousedown = specialEvents.mouseup = specialEvents.mousemove = 'MouseEvents'
	
	  function zid(element) {
	    return element._zid || (element._zid = _zid++)
	  }
	  function findHandlers(element, event, fn, selector) {
	    event = parse(event)
	    if (event.ns) var matcher = matcherFor(event.ns)
	    return (handlers[zid(element)] || []).filter(function(handler) {
	      return handler
	        && (!event.e  || handler.e == event.e)
	        && (!event.ns || matcher.test(handler.ns))
	        && (!fn       || zid(handler.fn) === zid(fn))
	        && (!selector || handler.sel == selector)
	    })
	  }
	  function parse(event) {
	    var parts = ('' + event).split('.')
	    return {e: parts[0], ns: parts.slice(1).sort().join(' ')}
	  }
	  function matcherFor(ns) {
	    return new RegExp('(?:^| )' + ns.replace(' ', ' .* ?') + '(?: |$)')
	  }
	
	  function eventCapture(handler, captureSetting) {
	    return handler.del &&
	      (!focusinSupported && (handler.e in focus)) ||
	      !!captureSetting
	  }
	
	  function realEvent(type) {
	    return hover[type] || (focusinSupported && focus[type]) || type
	  }
	
	  function add(element, events, fn, data, selector, delegator, capture){
	    var id = zid(element), set = (handlers[id] || (handlers[id] = []))
	    events.split(/\s/).forEach(function(event){
	      if (event == 'ready') return $(document).ready(fn)
	      var handler   = parse(event)
	      handler.fn    = fn
	      handler.sel   = selector
	      // emulate mouseenter, mouseleave
	      if (handler.e in hover) fn = function(e){
	        var related = e.relatedTarget
	        if (!related || (related !== this && !$.contains(this, related)))
	          return handler.fn.apply(this, arguments)
	      }
	      handler.del   = delegator
	      var callback  = delegator || fn
	      handler.proxy = function(e){
	        e = compatible(e)
	        if (e.isImmediatePropagationStopped()) return
	        e.data = data
	        var result = callback.apply(element, e._args == undefined ? [e] : [e].concat(e._args))
	        if (result === false) e.preventDefault(), e.stopPropagation()
	        return result
	      }
	      handler.i = set.length
	      set.push(handler)
	      if ('addEventListener' in element)
	        element.addEventListener(realEvent(handler.e), handler.proxy, eventCapture(handler, capture))
	    })
	  }
	  function remove(element, events, fn, selector, capture){
	    var id = zid(element)
	    ;(events || '').split(/\s/).forEach(function(event){
	      findHandlers(element, event, fn, selector).forEach(function(handler){
	        delete handlers[id][handler.i]
	      if ('removeEventListener' in element)
	        element.removeEventListener(realEvent(handler.e), handler.proxy, eventCapture(handler, capture))
	      })
	    })
	  }
	
	  $.event = { add: add, remove: remove }
	
	  $.proxy = function(fn, context) {
	    var args = (2 in arguments) && slice.call(arguments, 2)
	    if (isFunction(fn)) {
	      var proxyFn = function(){ return fn.apply(context, args ? args.concat(slice.call(arguments)) : arguments) }
	      proxyFn._zid = zid(fn)
	      return proxyFn
	    } else if (isString(context)) {
	      if (args) {
	        args.unshift(fn[context], fn)
	        return $.proxy.apply(null, args)
	      } else {
	        return $.proxy(fn[context], fn)
	      }
	    } else {
	      throw new TypeError("expected function")
	    }
	  }
	
	  $.fn.bind = function(event, data, callback){
	    return this.on(event, data, callback)
	  }
	  $.fn.unbind = function(event, callback){
	    return this.off(event, callback)
	  }
	  $.fn.one = function(event, selector, data, callback){
	    return this.on(event, selector, data, callback, 1)
	  }
	
	  var returnTrue = function(){return true},
	      returnFalse = function(){return false},
	      ignoreProperties = /^([A-Z]|returnValue$|layer[XY]$)/,
	      eventMethods = {
	        preventDefault: 'isDefaultPrevented',
	        stopImmediatePropagation: 'isImmediatePropagationStopped',
	        stopPropagation: 'isPropagationStopped'
	      }
	
	  function compatible(event, source) {
	    if (source || !event.isDefaultPrevented) {
	      source || (source = event)
	
	      $.each(eventMethods, function(name, predicate) {
	        var sourceMethod = source[name]
	        event[name] = function(){
	          this[predicate] = returnTrue
	          return sourceMethod && sourceMethod.apply(source, arguments)
	        }
	        event[predicate] = returnFalse
	      })
	
	      if (source.defaultPrevented !== undefined ? source.defaultPrevented :
	          'returnValue' in source ? source.returnValue === false :
	          source.getPreventDefault && source.getPreventDefault())
	        event.isDefaultPrevented = returnTrue
	    }
	    return event
	  }
	
	  function createProxy(event) {
	    var key, proxy = { originalEvent: event }
	    for (key in event)
	      if (!ignoreProperties.test(key) && event[key] !== undefined) proxy[key] = event[key]
	
	    return compatible(proxy, event)
	  }
	
	  $.fn.delegate = function(selector, event, callback){
	    return this.on(event, selector, callback)
	  }
	  $.fn.undelegate = function(selector, event, callback){
	    return this.off(event, selector, callback)
	  }
	
	  $.fn.live = function(event, callback){
	    $(document.body).delegate(this.selector, event, callback)
	    return this
	  }
	  $.fn.die = function(event, callback){
	    $(document.body).undelegate(this.selector, event, callback)
	    return this
	  }
	
	  $.fn.on = function(event, selector, data, callback, one){
	    var autoRemove, delegator, $this = this
	    if (event && !isString(event)) {
	      $.each(event, function(type, fn){
	        $this.on(type, selector, data, fn, one)
	      })
	      return $this
	    }
	
	    if (!isString(selector) && !isFunction(callback) && callback !== false)
	      callback = data, data = selector, selector = undefined
	    if (isFunction(data) || data === false)
	      callback = data, data = undefined
	
	    if (callback === false) callback = returnFalse
	
	    return $this.each(function(_, element){
	      if (one) autoRemove = function(e){
	        remove(element, e.type, callback)
	        return callback.apply(this, arguments)
	      }
	
	      if (selector) delegator = function(e){
	        var evt, match = $(e.target).closest(selector, element).get(0)
	        if (match && match !== element) {
	          evt = $.extend(createProxy(e), {currentTarget: match, liveFired: element})
	          return (autoRemove || callback).apply(match, [evt].concat(slice.call(arguments, 1)))
	        }
	      }
	
	      add(element, event, callback, data, selector, delegator || autoRemove)
	    })
	  }
	  $.fn.off = function(event, selector, callback){
	    var $this = this
	    if (event && !isString(event)) {
	      $.each(event, function(type, fn){
	        $this.off(type, selector, fn)
	      })
	      return $this
	    }
	
	    if (!isString(selector) && !isFunction(callback) && callback !== false)
	      callback = selector, selector = undefined
	
	    if (callback === false) callback = returnFalse
	
	    return $this.each(function(){
	      remove(this, event, callback, selector)
	    })
	  }
	
	  $.fn.trigger = function(event, args){
	    event = (isString(event) || $.isPlainObject(event)) ? $.Event(event) : compatible(event)
	    event._args = args
	    return this.each(function(){
	      // items in the collection might not be DOM elements
	      if('dispatchEvent' in this) this.dispatchEvent(event)
	      else $(this).triggerHandler(event, args)
	    })
	  }
	
	  // triggers event handlers on current element just as if an event occurred,
	  // doesn't trigger an actual event, doesn't bubble
	  $.fn.triggerHandler = function(event, args){
	    var e, result
	    this.each(function(i, element){
	      e = createProxy(isString(event) ? $.Event(event) : event)
	      e._args = args
	      e.target = element
	      $.each(findHandlers(element, event.type || event), function(i, handler){
	        result = handler.proxy(e)
	        if (e.isImmediatePropagationStopped()) return false
	      })
	    })
	    return result
	  }
	
	  // shortcut methods for `.bind(event, fn)` for each event type
	  ;('focusin focusout load resize scroll unload click dblclick '+
	  'mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave '+
	  'change select keydown keypress keyup error').split(' ').forEach(function(event) {
	    $.fn[event] = function(callback) {
	      return callback ?
	        this.bind(event, callback) :
	        this.trigger(event)
	    }
	  })
	
	  ;['focus', 'blur'].forEach(function(name) {
	    $.fn[name] = function(callback) {
	      if (callback) this.bind(name, callback)
	      else this.each(function(){
	        try { this[name]() }
	        catch(e) {}
	      })
	      return this
	    }
	  })
	
	  $.Event = function(type, props) {
	    if (!isString(type)) props = type, type = props.type
	    var event = document.createEvent(specialEvents[type] || 'Events'), bubbles = true
	    if (props) for (var name in props) (name == 'bubbles') ? (bubbles = !!props[name]) : (event[name] = props[name])
	    event.initEvent(type, bubbles, true)
	    return compatible(event)
	  }
	
	})(Zepto)
	
	;(function($){
	  $.fn.serializeArray = function() {
	    var el, type, result = []
	    $([].slice.call(this.get(0).elements)).each(function(){
	      el = $(this)
	      type = el.attr('type')
	      if (this.nodeName.toLowerCase() != 'fieldset' &&
	        !this.disabled && type != 'submit' && type != 'reset' && type != 'button' &&
	        ((type != 'radio' && type != 'checkbox') || this.checked))
	        result.push({
	          name: el.attr('name'),
	          value: el.val()
	        })
	    })
	    return result
	  }
	
	  $.fn.serialize = function(){
	    var result = []
	    this.serializeArray().forEach(function(elm){
	      result.push(encodeURIComponent(elm.name) + '=' + encodeURIComponent(elm.value))
	    })
	    return result.join('&')
	  }
	
	  $.fn.submit = function(callback) {
	    if (callback) this.bind('submit', callback)
	    else if (this.length) {
	      var event = $.Event('submit')
	      this.eq(0).trigger(event)
	      if (!event.isDefaultPrevented()) this.get(0).submit()
	    }
	    return this
	  }
	
	})(Zepto)
	
	;(function($, undefined){
	  var prefix = '', eventPrefix, endEventName, endAnimationName,
	    vendors = { Webkit: 'webkit', Moz: '', O: 'o' },
	    document = window.document, testEl = document.createElement('div'),
	    supportedTransforms = /^((translate|rotate|scale)(X|Y|Z|3d)?|matrix(3d)?|perspective|skew(X|Y)?)$/i,
	    transform,
	    transitionProperty, transitionDuration, transitionTiming, transitionDelay,
	    animationName, animationDuration, animationTiming, animationDelay,
	    cssReset = {}
	
	  function dasherize(str) { return str.replace(/([a-z])([A-Z])/, '$1-$2').toLowerCase() }
	  function normalizeEvent(name) { return eventPrefix ? eventPrefix + name : name.toLowerCase() }
	
	  $.each(vendors, function(vendor, event){
	    if (testEl.style[vendor + 'TransitionProperty'] !== undefined) {
	      prefix = '-' + vendor.toLowerCase() + '-'
	      eventPrefix = event
	      return false
	    }
	  })
	
	  transform = prefix + 'transform'
	  cssReset[transitionProperty = prefix + 'transition-property'] =
	  cssReset[transitionDuration = prefix + 'transition-duration'] =
	  cssReset[transitionDelay    = prefix + 'transition-delay'] =
	  cssReset[transitionTiming   = prefix + 'transition-timing-function'] =
	  cssReset[animationName      = prefix + 'animation-name'] =
	  cssReset[animationDuration  = prefix + 'animation-duration'] =
	  cssReset[animationDelay     = prefix + 'animation-delay'] =
	  cssReset[animationTiming    = prefix + 'animation-timing-function'] = ''
	
	  $.fx = {
	    off: (eventPrefix === undefined && testEl.style.transitionProperty === undefined),
	    speeds: { _default: 400, fast: 200, slow: 600 },
	    cssPrefix: prefix,
	    transitionEnd: normalizeEvent('TransitionEnd'),
	    animationEnd: normalizeEvent('AnimationEnd')
	  }
	
	  $.fn.animate = function(properties, duration, ease, callback, delay){
	    if ($.isFunction(duration))
	      callback = duration, ease = undefined, duration = undefined
	    if ($.isFunction(ease))
	      callback = ease, ease = undefined
	    if ($.isPlainObject(duration))
	      ease = duration.easing, callback = duration.complete, delay = duration.delay, duration = duration.duration
	    if (duration) duration = (typeof duration == 'number' ? duration :
	                    ($.fx.speeds[duration] || $.fx.speeds._default)) / 1000
	    if (delay) delay = parseFloat(delay) / 1000
	    return this.anim(properties, duration, ease, callback, delay)
	  }
	
	  $.fn.anim = function(properties, duration, ease, callback, delay){
	    var key, cssValues = {}, cssProperties, transforms = '',
	        that = this, wrappedCallback, endEvent = $.fx.transitionEnd,
	        fired = false
	
	    if (duration === undefined) duration = $.fx.speeds._default / 1000
	    if (delay === undefined) delay = 0
	    if ($.fx.off) duration = 0
	
	    if (typeof properties == 'string') {
	      // keyframe animation
	      cssValues[animationName] = properties
	      cssValues[animationDuration] = duration + 's'
	      cssValues[animationDelay] = delay + 's'
	      cssValues[animationTiming] = (ease || 'linear')
	      endEvent = $.fx.animationEnd
	    } else {
	      cssProperties = []
	      // CSS transitions
	      for (key in properties)
	        if (supportedTransforms.test(key)) transforms += key + '(' + properties[key] + ') '
	        else cssValues[key] = properties[key], cssProperties.push(dasherize(key))
	
	      if (transforms) cssValues[transform] = transforms, cssProperties.push(transform)
	      if (duration > 0 && typeof properties === 'object') {
	        cssValues[transitionProperty] = cssProperties.join(', ')
	        cssValues[transitionDuration] = duration + 's'
	        cssValues[transitionDelay] = delay + 's'
	        cssValues[transitionTiming] = (ease || 'linear')
	      }
	    }
	
	    wrappedCallback = function(event){
	      if (typeof event !== 'undefined') {
	        if (event.target !== event.currentTarget) return // makes sure the event didn't bubble from "below"
	        $(event.target).unbind(endEvent, wrappedCallback)
	      } else
	        $(this).unbind(endEvent, wrappedCallback) // triggered by setTimeout
	
	      fired = true
	      $(this).css(cssReset)
	      callback && callback.call(this)
	    }
	    if (duration > 0){
	      this.bind(endEvent, wrappedCallback)
	      // transitionEnd is not always firing on older Android phones
	      // so make sure it gets fired
	      setTimeout(function(){
	        if (fired) return
	        wrappedCallback.call(that)
	      }, (duration * 1000) + 25)
	    }
	
	    // trigger page reflow so new elements can animate
	    this.size() && this.get(0).clientLeft
	
	    this.css(cssValues)
	
	    if (duration <= 0) setTimeout(function() {
	      that.each(function(){ wrappedCallback.call(this) })
	    }, 0)
	
	    return this
	  }
	
	  testEl = null
	})(Zepto)
	
	;(function($){
	  if ($.os.ios) {
	    var gesture = {}, gestureTimeout
	
	    function parentIfText(node){
	      return 'tagName' in node ? node : node.parentNode
	    }
	
	    $(document).bind('gesturestart', function(e){
	      var now = Date.now(), delta = now - (gesture.last || now)
	      gesture.target = parentIfText(e.target)
	      gestureTimeout && clearTimeout(gestureTimeout)
	      gesture.e1 = e.scale
	      gesture.last = now
	    }).bind('gesturechange', function(e){
	      gesture.e2 = e.scale
	    }).bind('gestureend', function(e){
	      if (gesture.e2 > 0) {
	        Math.abs(gesture.e1 - gesture.e2) != 0 && $(gesture.target).trigger('pinch') &&
	          $(gesture.target).trigger('pinch' + (gesture.e1 - gesture.e2 > 0 ? 'In' : 'Out'))
	        gesture.e1 = gesture.e2 = gesture.last = 0
	      } else if ('last' in gesture) {
	        gesture = {}
	      }
	    })
	
	    ;['pinch', 'pinchIn', 'pinchOut'].forEach(function(m){
	      $.fn[m] = function(callback){ return this.bind(m, callback) }
	    })
	  }
	})(Zepto)
	
	;(function(undefined){
	  if (String.prototype.trim === undefined) // fix for iOS 3.2
	    String.prototype.trim = function(){ return this.replace(/^\s+|\s+$/g, '') }
	
	  // For iOS 3.x
	  // from https://developer.mozilla.org/en/JavaScript/Reference/Global_Objects/Array/reduce
	  if (Array.prototype.reduce === undefined)
	    Array.prototype.reduce = function(fun){
	      if(this === void 0 || this === null) throw new TypeError()
	      var t = Object(this), len = t.length >>> 0, k = 0, accumulator
	      if(typeof fun != 'function') throw new TypeError()
	      if(len == 0 && arguments.length == 1) throw new TypeError()
	
	      if(arguments.length >= 2)
	       accumulator = arguments[1]
	      else
	        do{
	          if(k in t){
	            accumulator = t[k++]
	            break
	          }
	          if(++k >= len) throw new TypeError()
	        } while (true)
	
	      while (k < len){
	        if(k in t) accumulator = fun.call(undefined, accumulator, t[k], k, t)
	        k++
	      }
	      return accumulator
	    }
	
	})()
	
	;(function($){
	  var zepto = $.zepto, oldQsa = zepto.qsa, oldMatches = zepto.matches
	
	  function visible(elem){
	    elem = $(elem)
	    return !!(elem.width() || elem.height()) && elem.css("display") !== "none"
	  }
	
	  // Implements a subset from:
	  // http://api.jquery.com/category/selectors/jquery-selector-extensions/
	  //
	  // Each filter function receives the current index, all nodes in the
	  // considered set, and a value if there were parentheses. The value
	  // of `this` is the node currently being considered. The function returns the
	  // resulting node(s), null, or undefined.
	  //
	  // Complex selectors are not supported:
	  //   li:has(label:contains("foo")) + li:has(label:contains("bar"))
	  //   ul.inner:first > li
	  var filters = $.expr[':'] = {
	    visible:  function(){ if (visible(this)) return this },
	    hidden:   function(){ if (!visible(this)) return this },
	    selected: function(){ if (this.selected) return this },
	    checked:  function(){ if (this.checked) return this },
	    parent:   function(){ return this.parentNode },
	    first:    function(idx){ if (idx === 0) return this },
	    last:     function(idx, nodes){ if (idx === nodes.length - 1) return this },
	    eq:       function(idx, _, value){ if (idx === value) return this },
	    contains: function(idx, _, text){ if ($(this).text().indexOf(text) > -1) return this },
	    has:      function(idx, _, sel){ if (zepto.qsa(this, sel).length) return this }
	  }
	
	  var filterRe = new RegExp('(.*):(\\w+)(?:\\(([^)]+)\\))?$\\s*'),
	      childRe  = /^\s*>/,
	      classTag = 'Zepto' + (+new Date())
	
	  function process(sel, fn) {
	    // quote the hash in `a[href^=#]` expression
	    sel = sel.replace(/=#\]/g, '="#"]')
	    var filter, arg, match = filterRe.exec(sel)
	    if (match && match[2] in filters) {
	      filter = filters[match[2]], arg = match[3]
	      sel = match[1]
	      if (arg) {
	        var num = Number(arg)
	        if (isNaN(num)) arg = arg.replace(/^["']|["']$/g, '')
	        else arg = num
	      }
	    }
	    return fn(sel, filter, arg)
	  }
	
	  zepto.qsa = function(node, selector) {
	    return process(selector, function(sel, filter, arg){
	      try {
	        var taggedParent
	        if (!sel && filter) sel = '*'
	        else if (childRe.test(sel))
	          // support "> *" child queries by tagging the parent node with a
	          // unique class and prepending that classname onto the selector
	          taggedParent = $(node).addClass(classTag), sel = '.'+classTag+' '+sel
	
	        var nodes = oldQsa(node, sel)
	      } catch(e) {
	        console.error('error performing selector: %o', selector)
	        throw e
	      } finally {
	        if (taggedParent) taggedParent.removeClass(classTag)
	      }
	      return !filter ? nodes :
	        zepto.uniq($.map(nodes, function(n, i){ return filter.call(n, i, nodes, arg) }))
	    })
	  }
	
	  zepto.matches = function(node, selector){
	    return process(selector, function(sel, filter, arg){
	      return (!sel || oldMatches(node, sel)) &&
	        (!filter || filter.call(node, null, arg) === node)
	    })
	  }
	})(Zepto)
	
	;(function($){
	  $.fn.end = function(){
	    return this.prevObject || $()
	  }
	
	  $.fn.andSelf = function(){
	    return this.add(this.prevObject || $())
	  }
	
	  'filter,add,not,eq,first,last,find,closest,parents,parent,children,siblings'.split(',').forEach(function(property){
	    var fn = $.fn[property]
	    $.fn[property] = function(){
	      var ret = fn.apply(this, arguments)
	      ret.prevObject = this
	      return ret
	    }
	  })
	})(Zepto)
	
	;(function($){
	  var touch = {},
	    touchTimeout, tapTimeout, swipeTimeout, longTapTimeout,
	    longTapDelay = 750,
	    gesture
	
	  function swipeDirection(x1, x2, y1, y2) {
	    return Math.abs(x1 - x2) >=
	      Math.abs(y1 - y2) ? (x1 - x2 > 0 ? 'Left' : 'Right') : (y1 - y2 > 0 ? 'Up' : 'Down')
	  }
	
	  function longTap() {
	    longTapTimeout = null
	    if (touch.last) {
	      touch.el.trigger('longTap')
	      touch = {}
	    }
	  }
	
	  function cancelLongTap() {
	    if (longTapTimeout) clearTimeout(longTapTimeout)
	    longTapTimeout = null
	  }
	
	  function cancelAll() {
	    if (touchTimeout) clearTimeout(touchTimeout)
	    if (tapTimeout) clearTimeout(tapTimeout)
	    if (swipeTimeout) clearTimeout(swipeTimeout)
	    if (longTapTimeout) clearTimeout(longTapTimeout)
	    touchTimeout = tapTimeout = swipeTimeout = longTapTimeout = null
	    touch = {}
	  }
	
	  function isPrimaryTouch(event){
	    return (event.pointerType == 'touch' ||
	      event.pointerType == event.MSPOINTER_TYPE_TOUCH)
	      && event.isPrimary
	  }
	
	  function isPointerEventType(e, type){
	    return (e.type == 'pointer'+type ||
	      e.type.toLowerCase() == 'mspointer'+type)
	  }
	
	  $(document).ready(function(){
	    var now, delta, deltaX = 0, deltaY = 0, firstTouch, _isPointerType
	
	    if ('MSGesture' in window) {
	      gesture = new MSGesture()
	      gesture.target = document.body
	    }
	
	    $(document)
	      .bind('MSGestureEnd', function(e){
	        var swipeDirectionFromVelocity =
	          e.velocityX > 1 ? 'Right' : e.velocityX < -1 ? 'Left' : e.velocityY > 1 ? 'Down' : e.velocityY < -1 ? 'Up' : null
	        if (swipeDirectionFromVelocity) {
	          touch.el.trigger('swipe')
	          touch.el.trigger('swipe'+ swipeDirectionFromVelocity)
	        }
	      })
	      .on('touchstart MSPointerDown pointerdown', function(e){
	        if((_isPointerType = isPointerEventType(e, 'down')) &&
	          !isPrimaryTouch(e)) return
	        firstTouch = _isPointerType ? e : e.touches[0]
	        if (e.touches && e.touches.length === 1 && touch.x2) {
	          // Clear out touch movement data if we have it sticking around
	          // This can occur if touchcancel doesn't fire due to preventDefault, etc.
	          touch.x2 = undefined
	          touch.y2 = undefined
	        }
	        now = Date.now()
	        delta = now - (touch.last || now)
	        touch.el = $('tagName' in firstTouch.target ?
	          firstTouch.target : firstTouch.target.parentNode)
	        touchTimeout && clearTimeout(touchTimeout)
	        touch.x1 = firstTouch.pageX
	        touch.y1 = firstTouch.pageY
	        if (delta > 0 && delta <= 250) touch.isDoubleTap = true
	        touch.last = now
	        longTapTimeout = setTimeout(longTap, longTapDelay)
	        // adds the current touch contact for IE gesture recognition
	        if (gesture && _isPointerType) gesture.addPointer(e.pointerId)
	      })
	      .on('touchmove MSPointerMove pointermove', function(e){
	        if((_isPointerType = isPointerEventType(e, 'move')) &&
	          !isPrimaryTouch(e)) return
	        firstTouch = _isPointerType ? e : e.touches[0]
	        cancelLongTap()
	        touch.x2 = firstTouch.pageX
	        touch.y2 = firstTouch.pageY
	
	        deltaX += Math.abs(touch.x1 - touch.x2)
	        deltaY += Math.abs(touch.y1 - touch.y2)
	      })
	      .on('touchend MSPointerUp pointerup', function(e){
	        if((_isPointerType = isPointerEventType(e, 'up')) &&
	          !isPrimaryTouch(e)) return
	        cancelLongTap()
	
	        // swipe
	        if ((touch.x2 && Math.abs(touch.x1 - touch.x2) > 30) ||
	            (touch.y2 && Math.abs(touch.y1 - touch.y2) > 30))
	
	          swipeTimeout = setTimeout(function() {
	            if (touch.el){
	              touch.el.trigger('swipe')
	              touch.el.trigger('swipe' + (swipeDirection(touch.x1, touch.x2, touch.y1, touch.y2)))
	            }
	            touch = {}
	          }, 0)
	
	        // normal tap
	        else if ('last' in touch)
	          // don't fire tap when delta position changed by more than 30 pixels,
	          // for instance when moving to a point and back to origin
	          if (deltaX < 30 && deltaY < 30) {
	            // delay by one tick so we can cancel the 'tap' event if 'scroll' fires
	            // ('tap' fires before 'scroll')
	            tapTimeout = setTimeout(function() {
	
	              // trigger universal 'tap' with the option to cancelTouch()
	              // (cancelTouch cancels processing of single vs double taps for faster 'tap' response)
	              var event = $.Event('tap')
	              event.cancelTouch = cancelAll
	              // [by paper] fix -> "TypeError: 'undefined' is not an object (evaluating 'touch.el.trigger'), when double tap
	              if (touch.el) touch.el.trigger(event)
	
	              // trigger double tap immediately
	              if (touch.isDoubleTap) {
	                if (touch.el) touch.el.trigger('doubleTap')
	                touch = {}
	              }
	
	              // trigger single tap after 250ms of inactivity
	              else {
	                touchTimeout = setTimeout(function(){
	                  touchTimeout = null
	                  if (touch.el) touch.el.trigger('singleTap')
	                  touch = {}
	                }, 250)
	              }
	            }, 0)
	          } else {
	            touch = {}
	          }
	          deltaX = deltaY = 0
	
	      })
	      // when the browser window loses focus,
	      // for example when a modal dialog is shown,
	      // cancel all ongoing events
	      .on('touchcancel MSPointerCancel pointercancel', cancelAll)
	
	    // scrolling the window indicates intention of the user
	    // to scroll, not tap or swipe, so cancel all ongoing events
	    $(window).on('scroll', cancelAll)
	  })
	
	  ;['swipe', 'swipeLeft', 'swipeRight', 'swipeUp', 'swipeDown',
	    'doubleTap', 'tap', 'singleTap', 'longTap'].forEach(function(eventName){
	    $.fn[eventName] = function(callback){ return this.on(eventName, callback) }
	  })
	})(Zepto)
	
	;(function($){
	  var jsonpID = +new Date(),
	      document = window.document,
	      key,
	      name,
	      rscript = /<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi,
	      scriptTypeRE = /^(?:text|application)\/javascript/i,
	      xmlTypeRE = /^(?:text|application)\/xml/i,
	      jsonType = 'application/json',
	      htmlType = 'text/html',
	      blankRE = /^\s*$/,
	      originAnchor = document.createElement('a')
	
	  originAnchor.href = window.location.href
	
	  // trigger a custom event and return false if it was cancelled
	  function triggerAndReturn(context, eventName, data) {
	    var event = $.Event(eventName)
	    $(context).trigger(event, data)
	    return !event.isDefaultPrevented()
	  }
	
	  // trigger an Ajax "global" event
	  function triggerGlobal(settings, context, eventName, data) {
	    if (settings.global) return triggerAndReturn(context || document, eventName, data)
	  }
	
	  // Number of active Ajax requests
	  $.active = 0
	
	  function ajaxStart(settings) {
	    if (settings.global && $.active++ === 0) triggerGlobal(settings, null, 'ajaxStart')
	  }
	  function ajaxStop(settings) {
	    if (settings.global && !(--$.active)) triggerGlobal(settings, null, 'ajaxStop')
	  }
	
	  // triggers an extra global event "ajaxBeforeSend" that's like "ajaxSend" but cancelable
	  function ajaxBeforeSend(xhr, settings) {
	    var context = settings.context
	    if (settings.beforeSend.call(context, xhr, settings) === false ||
	        triggerGlobal(settings, context, 'ajaxBeforeSend', [xhr, settings]) === false)
	      return false
	
	    triggerGlobal(settings, context, 'ajaxSend', [xhr, settings])
	  }
	  function ajaxSuccess(data, xhr, settings, deferred) {
	    var context = settings.context, status = 'success'
	    settings.success.call(context, data, status, xhr)
	    if (deferred) deferred.resolveWith(context, [data, status, xhr])
	    triggerGlobal(settings, context, 'ajaxSuccess', [xhr, settings, data])
	    ajaxComplete(status, xhr, settings)
	  }
	  // type: "timeout", "error", "abort", "parsererror"
	  function ajaxError(error, type, xhr, settings, deferred) {
	    var context = settings.context
	    settings.error.call(context, xhr, type, error)
	    if (deferred) deferred.rejectWith(context, [xhr, type, error])
	    triggerGlobal(settings, context, 'ajaxError', [xhr, settings, error || type])
	    ajaxComplete(type, xhr, settings)
	  }
	  // status: "success", "notmodified", "error", "timeout", "abort", "parsererror"
	  function ajaxComplete(status, xhr, settings) {
	    var context = settings.context
	    settings.complete.call(context, xhr, status)
	    triggerGlobal(settings, context, 'ajaxComplete', [xhr, settings])
	    ajaxStop(settings)
	  }
	
	  function ajaxDataFilter(data, type, settings) {
	    if (settings.dataFilter == empty) return data
	    var context = settings.context
	    return settings.dataFilter.call(context, data, type)
	  }
	
	  // Empty function, used as default callback
	  function empty() {}
	
	  $.ajaxJSONP = function(options, deferred){
	    if (!('type' in options)) return $.ajax(options)
	
	    var _callbackName = options.jsonpCallback,
	      callbackName = ($.isFunction(_callbackName) ?
	        _callbackName() : _callbackName) || ('Zepto' + (jsonpID++)),
	      script = document.createElement('script'),
	      originalCallback = window[callbackName],
	      responseData,
	      abort = function(errorType) {
	        $(script).triggerHandler('error', errorType || 'abort')
	      },
	      xhr = { abort: abort }, abortTimeout
	
	    if (deferred) deferred.promise(xhr)
	
	    $(script).on('load error', function(e, errorType){
	      clearTimeout(abortTimeout)
	      $(script).off().remove()
	
	      if (e.type == 'error' || !responseData) {
	        ajaxError(null, errorType || 'error', xhr, options, deferred)
	      } else {
	        ajaxSuccess(responseData[0], xhr, options, deferred)
	      }
	
	      window[callbackName] = originalCallback
	      if (responseData && $.isFunction(originalCallback))
	        originalCallback(responseData[0])
	
	      originalCallback = responseData = undefined
	    })
	
	    if (ajaxBeforeSend(xhr, options) === false) {
	      abort('abort')
	      return xhr
	    }
	
	    window[callbackName] = function(){
	      responseData = arguments
	    }
	
	    script.src = options.url.replace(/\?(.+)=\?/, '?$1=' + callbackName)
	    document.head.appendChild(script)
	
	    if (options.timeout > 0) abortTimeout = setTimeout(function(){
	      abort('timeout')
	    }, options.timeout)
	
	    return xhr
	  }
	
	  $.ajaxSettings = {
	    // Default type of request
	    type: 'GET',
	    // Callback that is executed before request
	    beforeSend: empty,
	    // Callback that is executed if the request succeeds
	    success: empty,
	    // Callback that is executed the the server drops error
	    error: empty,
	    // Callback that is executed on request complete (both: error and success)
	    complete: empty,
	    // The context for the callbacks
	    context: null,
	    // Whether to trigger "global" Ajax events
	    global: true,
	    // Transport
	    xhr: function () {
	      return new window.XMLHttpRequest()
	    },
	    // MIME types mapping
	    // IIS returns Javascript as "application/x-javascript"
	    accepts: {
	      script: 'text/javascript, application/javascript, application/x-javascript',
	      json:   jsonType,
	      xml:    'application/xml, text/xml',
	      html:   htmlType,
	      text:   'text/plain'
	    },
	    // Whether the request is to another domain
	    crossDomain: false,
	    // Default timeout
	    timeout: 0,
	    // Whether data should be serialized to string
	    processData: true,
	    // Whether the browser should be allowed to cache GET responses
	    cache: true,
	    //Used to handle the raw response data of XMLHttpRequest.
	    //This is a pre-filtering function to sanitize the response.
	    //The sanitized response should be returned
	    dataFilter: empty
	  }
	
	  function mimeToDataType(mime) {
	    if (mime) mime = mime.split(';', 2)[0]
	    return mime && ( mime == htmlType ? 'html' :
	      mime == jsonType ? 'json' :
	      scriptTypeRE.test(mime) ? 'script' :
	      xmlTypeRE.test(mime) && 'xml' ) || 'text'
	  }
	
	  function appendQuery(url, query) {
	    if (query == '') return url
	    return (url + '&' + query).replace(/[&?]{1,2}/, '?')
	  }
	
	  // serialize payload and append it to the URL for GET requests
	  function serializeData(options) {
	    if (options.processData && options.data && $.type(options.data) != "string")
	      options.data = $.param(options.data, options.traditional)
	    if (options.data && (!options.type || options.type.toUpperCase() == 'GET' || 'jsonp' == options.dataType))
	      options.url = appendQuery(options.url, options.data), options.data = undefined
	  }
	
	  $.ajax = function(options){
	    var settings = $.extend({}, options || {}),
	        deferred = $.Deferred && $.Deferred(),
	        urlAnchor, hashIndex
	    for (key in $.ajaxSettings) if (settings[key] === undefined) settings[key] = $.ajaxSettings[key]
	
	    ajaxStart(settings)
	
	    if (!settings.crossDomain) {
	      urlAnchor = document.createElement('a')
	      urlAnchor.href = settings.url
	      // cleans up URL for .href (IE only), see https://github.com/madrobby/zepto/pull/1049
	      urlAnchor.href = urlAnchor.href
	      settings.crossDomain = (originAnchor.protocol + '//' + originAnchor.host) !== (urlAnchor.protocol + '//' + urlAnchor.host)
	    }
	
	    if (!settings.url) settings.url = window.location.toString()
	    if ((hashIndex = settings.url.indexOf('#')) > -1) settings.url = settings.url.slice(0, hashIndex)
	    serializeData(settings)
	
	    var dataType = settings.dataType, hasPlaceholder = /\?.+=\?/.test(settings.url)
	    if (hasPlaceholder) dataType = 'jsonp'
	
	    if (settings.cache === false || (
	         (!options || options.cache !== true) &&
	         ('script' == dataType || 'jsonp' == dataType)
	        ))
	      settings.url = appendQuery(settings.url, '_=' + Date.now())
	
	    if ('jsonp' == dataType) {
	      if (!hasPlaceholder)
	        settings.url = appendQuery(settings.url,
	          settings.jsonp ? (settings.jsonp + '=?') : settings.jsonp === false ? '' : 'callback=?')
	      return $.ajaxJSONP(settings, deferred)
	    }
	
	    var mime = settings.accepts[dataType],
	        headers = { },
	        setHeader = function(name, value) { headers[name.toLowerCase()] = [name, value] },
	        protocol = /^([\w-]+:)\/\//.test(settings.url) ? RegExp.$1 : window.location.protocol,
	        xhr = settings.xhr(),
	        nativeSetHeader = xhr.setRequestHeader,
	        abortTimeout
	
	    if (deferred) deferred.promise(xhr)
	
	    if (!settings.crossDomain) setHeader('X-Requested-With', 'XMLHttpRequest')
	    setHeader('Accept', mime || '*/*')
	    if (mime = settings.mimeType || mime) {
	      if (mime.indexOf(',') > -1) mime = mime.split(',', 2)[0]
	      xhr.overrideMimeType && xhr.overrideMimeType(mime)
	    }
	    if (settings.contentType || (settings.contentType !== false && settings.data && settings.type.toUpperCase() != 'GET'))
	      setHeader('Content-Type', settings.contentType || 'application/x-www-form-urlencoded')
	
	    if (settings.headers) for (name in settings.headers) setHeader(name, settings.headers[name])
	    xhr.setRequestHeader = setHeader
	
	    xhr.onreadystatechange = function(){
	      if (xhr.readyState == 4) {
	        xhr.onreadystatechange = empty
	        clearTimeout(abortTimeout)
	        var result, error = false
	        if ((xhr.status >= 200 && xhr.status < 300) || xhr.status == 304 || (xhr.status == 0 && protocol == 'file:')) {
	          dataType = dataType || mimeToDataType(settings.mimeType || xhr.getResponseHeader('content-type'))
	
	          if (xhr.responseType == 'arraybuffer' || xhr.responseType == 'blob')
	            result = xhr.response
	          else {
	            result = xhr.responseText
	
	            try {
	              // http://perfectionkills.com/global-eval-what-are-the-options/
	              // sanitize response accordingly if data filter callback provided
	              result = ajaxDataFilter(result, dataType, settings)
	              if (dataType == 'script')    (1,eval)(result)
	              else if (dataType == 'xml')  result = xhr.responseXML
	              else if (dataType == 'json') result = blankRE.test(result) ? null : $.parseJSON(result)
	            } catch (e) { error = e }
	
	            if (error) return ajaxError(error, 'parsererror', xhr, settings, deferred)
	          }
	
	          ajaxSuccess(result, xhr, settings, deferred)
	        } else {
	          ajaxError(xhr.statusText || null, xhr.status ? 'error' : 'abort', xhr, settings, deferred)
	        }
	      }
	    }
	
	    if (ajaxBeforeSend(xhr, settings) === false) {
	      xhr.abort()
	      ajaxError(null, 'abort', xhr, settings, deferred)
	      return xhr
	    }
	
	    var async = 'async' in settings ? settings.async : true
	    xhr.open(settings.type, settings.url, async, settings.username, settings.password)
	
	    if (settings.xhrFields) for (name in settings.xhrFields) xhr[name] = settings.xhrFields[name]
	
	    for (name in headers) nativeSetHeader.apply(xhr, headers[name])
	
	    if (settings.timeout > 0) abortTimeout = setTimeout(function(){
	        xhr.onreadystatechange = empty
	        xhr.abort()
	        ajaxError(null, 'timeout', xhr, settings, deferred)
	      }, settings.timeout)
	
	    // avoid sending empty string (#319)
	    xhr.send(settings.data ? settings.data : null)
	    return xhr
	  }
	
	  // handle optional data/success arguments
	  function parseArguments(url, data, success, dataType) {
	    if ($.isFunction(data)) dataType = success, success = data, data = undefined
	    if (!$.isFunction(success)) dataType = success, success = undefined
	    return {
	      url: url
	    , data: data
	    , success: success
	    , dataType: dataType
	    }
	  }
	
	  $.get = function(/* url, data, success, dataType */){
	    return $.ajax(parseArguments.apply(null, arguments))
	  }
	
	  $.post = function(/* url, data, success, dataType */){
	    var options = parseArguments.apply(null, arguments)
	    options.type = 'POST'
	    return $.ajax(options)
	  }
	
	  $.getJSON = function(/* url, data, success */){
	    var options = parseArguments.apply(null, arguments)
	    options.dataType = 'json'
	    return $.ajax(options)
	  }
	
	  $.fn.load = function(url, data, success){
	    if (!this.length) return this
	    var self = this, parts = url.split(/\s/), selector,
	        options = parseArguments(url, data, success),
	        callback = options.success
	    if (parts.length > 1) options.url = parts[0], selector = parts[1]
	    options.success = function(response){
	      self.html(selector ?
	        $('<div>').html(response.replace(rscript, "")).find(selector)
	        : response)
	      callback && callback.apply(self, arguments)
	    }
	    $.ajax(options)
	    return this
	  }
	
	  var escape = encodeURIComponent
	
	  function serialize(params, obj, traditional, scope){
	    var type, array = $.isArray(obj), hash = $.isPlainObject(obj)
	    $.each(obj, function(key, value) {
	      type = $.type(value)
	      if (scope) key = traditional ? scope :
	        scope + '[' + (hash || type == 'object' || type == 'array' ? key : '') + ']'
	      // handle data in serializeArray() format
	      if (!scope && array) params.add(value.name, value.value)
	      // recurse into nested objects
	      else if (type == "array" || (!traditional && type == "object"))
	        serialize(params, value, traditional, key)
	      else params.add(key, value)
	    })
	  }
	
	  $.param = function(obj, traditional){
	    var params = []
	    params.add = function(key, value) {
	      if ($.isFunction(value)) value = value()
	      if (value == null) value = ""
	      this.push(escape(key) + '=' + escape(value))
	    }
	    serialize(params, obj, traditional)
	    return params.join('&').replace(/%20/g, '+')
	  }
	})(Zepto)
	
	;(function($){
	  // __proto__ doesn't exist on IE<11, so redefine
	  // the Z function to use object extension instead
	  if (!('__proto__' in {})) {
	    $.extend($.zepto, {
	      Z: function(dom, selector){
	        dom = dom || []
	        $.extend(dom, $.fn)
	        dom.selector = selector || ''
	        dom.__Z = true
	        return dom
	      },
	      // this is a kludge but works
	      isZ: function(object){
	        return $.type(object) === 'array' && '__Z' in object
	      }
	    })
	  }
	
	  // getComputedStyle shouldn't freak out when called
	  // without a valid element as argument
	  try {
	    getComputedStyle(undefined)
	  } catch(e) {
	    var nativeGetComputedStyle = getComputedStyle;
	    window.getComputedStyle = function(element){
	      try {
	        return nativeGetComputedStyle(element)
	      } catch(e) {
	        return null
	      }
	    }
	  }
	})(Zepto)


/***/ }),
/* 572 */
/***/ (function(module, exports, __webpack_require__) {

	var $ = __webpack_require__(570);
	var Overlay = __webpack_require__(573);
	
	var AUTOTIME = 2000;
	var ZINDEX = 10000002;
	var overlay = new Overlay(ZINDEX-1);
	
	/**
	 * @constructor
	 * @param {String} text text to shown
	 * @param {Number} time auto hide time, default 2000ms;
	 * @param {Function} callback after the overlay is hidden
	 * */
	function Toast(text,time,callback){
	    
	    if(time === true){
	        time = 20000;
	    }else{
	        time = time || AUTOTIME;
	    }
	
	    var CSS = {
	        'position':'fixed',
	        'z-index':ZINDEX,
	        'top':'50%',
	        'left':'50%',
	        'min-width':'100px',
	        'max-width':'160px',
	        'padding':'10px',
	        'border-radius':'5px',
	        '-webkit-border-radius':'5px',
	        'background':'#000',
	        'color':'#fff',
	        'text-align':'center',
	        'font-size':'14px',
	        'word-break':'break-all',
	        '-webkit-box-sizing':'border-box',
	        'box-sizing':'border-box'
	    };
	
	    var box = $('<div>'+text+'</div>');
	    box.css(CSS).appendTo('body').css('margin','-'+ box.height()/2+'px 0 0 -'+ box.width()/2+'px' );
	    overlay.show();
	    overlay.once('hide',function(){
	        box.remove();
	        callback && callback();
	        clearTimeout(timer);
	    });
	
	    var timer = setTimeout(function(){
	        overlay.hide();
	    },time);
	
	
	    return {
	        close:function(){
	            clearTimeout(timer);
	            overlay.hide();
	        }
	    }
	}
	
	module.exports = Toast;


/***/ }),
/* 573 */
/***/ (function(module, exports, __webpack_require__) {

	var $ = __webpack_require__(570);
	var Event = __webpack_require__(574);
	var _lastShowTime=0;
	var TouchEventInterval=500;
	var createOverlay = function (zindex) {
	    var CSS = {
	        top: 0,
	        left: 0,
	        width: '100%',
	        height: '100%',
	        'background': 'rgba(0,0,0,.6)',
	        'z-index': zindex || 200,
	        position: 'fixed',
	        display: 'none'
	    };
	    return $('<div class="overlay"></div>').css(CSS);
	};
	
	/**
	 * @constructor
	 * @param {Number} zindex default is 200
	 *
	 * */
	function Overlay(zindex, hide) {
	    var self = this;
	    /**
	     * @property {ZeptoElement} $el
	     * */
	    var ol = this.$el = createOverlay(zindex).appendTo('body');
	
	    ol.on('touchstart touchmove touchend', function (e) {
	        e.preventDefault();
	    });
	
	    ol.on('touchstart click', function (e) {
	        var now=+new Date();
	        (now-_lastShowTime>TouchEventInterval)&&!hide && self.hide();//增加浮层延时，防止双击导致浮层出现又消失
	    });
	}
	
	/**
	 * 显示overlay
	 * @method
	 * @public
	 * */
	Overlay.prototype.show = function () {
	    this.$el.show();
	    this.trigger('show');
	    _lastShowTime=+new Date();
	};
	
	/**
	 * 隐藏overlay
	 * @method
	 * @public
	 * */
	Overlay.prototype.hide = function () {
	    this.$el.hide();
	    this.trigger('hide');
	};
	
	//扩展Event
	Event.extendTo(Overlay.prototype);
	
	module.exports = Overlay;


/***/ }),
/* 574 */
/***/ (function(module, exports) {

	/**
	 * 自定义事件，同Backbone.Events
	 *
	 * */
	
	var slice = Array.prototype.slice;
	
	var _once = function(func) {
	    var ran = false, memo;
	    return function() {
	        if (ran) return memo;
	        ran = true;
	        memo = func.apply(this, arguments);
	        func = null;
	        return memo;
	    };
	};
	
	var _isEmpty = function(obj){
	    for(var key in obj){
	        if(obj.hasOwnProperty(key)){
	            return false;
	        }
	    }
	    return true;
	};
	var idCounter = 0;
	var _uniqueId = function(prefix) {
	    var id = ++idCounter + '';
	    return prefix ? prefix + id : id;
	};
	
	var Events = {
	    // Bind an event to a `callback` function. Passing `"all"` will bind
	    // the callback to all events fired.
	    on: function(name, callback, context) {
	        if (!eventsApi(this, 'on', name, [callback, context]) || !callback) return this;
	        this._events || (this._events = {});
	        var events = this._events[name] || (this._events[name] = []);
	        events.push({callback: callback, context: context, ctx: context || this});
	        return this;
	    },
	
	    // Bind an event to only be triggered a single time. After the first time
	    // the callback is invoked, it will be removed.
	    once: function(name, callback, context) {
	        if (!eventsApi(this, 'once', name, [callback, context]) || !callback) return this;
	        var self = this;
	        var once = _once(function() {
	            self.off(name, once);
	            callback.apply(this, arguments);
	        });
	        once._callback = callback;
	        return this.on(name, once, context);
	    },
	
	    // Remove one or many callbacks. If `context` is null, removes all
	    // callbacks with that function. If `callback` is null, removes all
	    // callbacks for the event. If `name` is null, removes all bound
	    // callbacks for all events.
	    off: function(name, callback, context) {
	        var retain, ev, events, names, i, l, j, k;
	        if (!this._events || !eventsApi(this, 'off', name, [callback, context])) return this;
	        if (!name && !callback && !context) {
	            this._events = void 0;
	            return this;
	        }
	        names = name ? [name] : Object.keys(this._events);
	        for (i = 0, l = names.length; i < l; i++) {
	            name = names[i];
	            if (events = this._events[name]) {
	                this._events[name] = retain = [];
	                if (callback || context) {
	                    for (j = 0, k = events.length; j < k; j++) {
	                        ev = events[j];
	                        if ((callback && callback !== ev.callback && callback !== ev.callback._callback) ||
	                            (context && context !== ev.context)) {
	                            retain.push(ev);
	                        }
	                    }
	                }
	                if (!retain.length) delete this._events[name];
	            }
	        }
	
	        return this;
	    },
	
	    // Trigger one or many events, firing all bound callbacks. Callbacks are
	    // passed the same arguments as `trigger` is, apart from the event name
	    // (unless you're listening on `"all"`, which will cause your callback to
	    // receive the true name of the event as the first argument).
	    trigger: function(name) {
	        if (!this._events) return this;
	        var args = slice.call(arguments, 1);
	        if (!eventsApi(this, 'trigger', name, args)) return this;
	        var events = this._events[name];
	        var allEvents = this._events.all;
	        if (events) triggerEvents(events, args);
	        if (allEvents) triggerEvents(allEvents, arguments);
	        return this;
	    },
	
	    // Tell this object to stop listening to either specific events ... or
	    // to every object it's currently listening to.
	    stopListening: function(obj, name, callback) {
	        var listeningTo = this._listeningTo;
	        if (!listeningTo) return this;
	        var remove = !name && !callback;
	        if (!callback && typeof name === 'object') callback = this;
	        if (obj) (listeningTo = {})[obj._listenId] = obj;
	        for (var id in listeningTo) {
	            obj = listeningTo[id];
	            obj.off(name, callback, this);
	            if (remove || _isEmpty(obj._events)) delete this._listeningTo[id];
	        }
	        return this;
	    },
	    /**
	     * 扩展到其他对象，参数可以有多个对象
	     * @public
	     * @method
	     * @param {Object} obj target object 
	     * */
	    extendTo : function(){
	        slice.call(arguments,0).forEach(function(obj){
	            for(var method in Events){
	                if(Events.hasOwnProperty(method) && method !=='extendTo'){
	                    obj[method] = Events[method];
	                }
	            }
	        });
	    }
	};
	
	// Regular expression used to split event strings.
	var eventSplitter = /\s+/;
	
	// Implement fancy features of the Events API such as multiple event
	// names `"change blur"` and jQuery-style event maps `{change: action}`
	// in terms of the existing API.
	var eventsApi = function(obj, action, name, rest) {
	    if (!name) return true;
	
	    // Handle event maps.
	    if (typeof name === 'object') {
	        for (var key in name) {
	            obj[action].apply(obj, [key, name[key]].concat(rest));
	        }
	        return false;
	    }
	
	    // Handle space separated event names.
	    if (eventSplitter.test(name)) {
	        var names = name.split(eventSplitter);
	        for (var i = 0, l = names.length; i < l; i++) {
	            obj[action].apply(obj, [names[i]].concat(rest));
	        }
	        return false;
	    }
	
	    return true;
	};
	
	// A difficult-to-believe, but optimized internal dispatch function for
	// triggering events. Tries to keep the usual cases speedy (most internal
	// Backbone events have 3 arguments).
	var triggerEvents = function(events, args) {
	    var ev, i = -1, l = events.length, a1 = args[0], a2 = args[1], a3 = args[2];
	    switch (args.length) {
	        case 0: while (++i < l) (ev = events[i]).callback.call(ev.ctx); return;
	        case 1: while (++i < l) (ev = events[i]).callback.call(ev.ctx, a1); return;
	        case 2: while (++i < l) (ev = events[i]).callback.call(ev.ctx, a1, a2); return;
	        case 3: while (++i < l) (ev = events[i]).callback.call(ev.ctx, a1, a2, a3); return;
	        default: while (++i < l) (ev = events[i]).callback.apply(ev.ctx, args); return;
	    }
	};
	
	var listenMethods = {listenTo: 'on', listenToOnce: 'once'};
	
	// Inversion-of-control versions of `on` and `once`. Tell *this* object to
	// listen to an event in another object ... keeping track of what it's
	// listening to.
	Object.keys(listenMethods).forEach(function(method){
	    var implementation = listenMethods[method];
	    Events[method] = function(obj, name, callback) {
	        var listeningTo = this._listeningTo || (this._listeningTo = {});
	        var id = obj._listenId || (obj._listenId = _uniqueId('l'));
	        listeningTo[id] = obj;
	        if (!callback && typeof name === 'object') callback = this;
	        obj[implementation](name, callback, this);
	        return this;
	    };
	
	});
	
	// Aliases for backwards compatibility.
	Events.bind   = Events.on;
	Events.unbind = Events.off;
	
	
	
	module.exports = Events;


/***/ }),
/* 575 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var formatDate = exports.formatDate = function formatDate() {
	  var date = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : Date.now();
	  var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'yyyy-MM-dd hh:mm';
	  var separator = arguments[2];
	
	  date = new Date(date);
	  // let result = '';
	  // if (/yyyy/i.test(format)) {
	  //     result += `${date.getFullYear()}` + (separator || '年')
	  // }
	  // if (/MM/.test(format)) {
	  //     let month = date.getMonth() + 1;
	  //     month = month < 10 ? `0${month}` : month;
	  //     result += `${month}` + (separator || '月')
	  // }
	  // if (/dd/i.test(format)) {
	  //     let day = date.getDate();
	  //     day = day < 10 ? `0${day}` : day;
	  //     result += `${day}` + (separator ? '' : '日')
	  // }
	  // if (/hh/i.test(format)) {
	  //     let hours = date.getHours();
	  //     hours = hours < 10 ? `0${hours}` : hours;
	  //     result += ` ${hours}`
	  // }
	  // if (/mm/.test(format)) {
	  //     let minutes = date.getMinutes();
	  //     minutes = minutes < 10 ? `0${minutes}` : minutes;
	  //     result += `:${minutes}`
	  // }
	  // if (/ss/.test(format)) {
	  //     let seconds = date.getSeconds();
	  //     seconds = seconds < 10 ? `0${seconds}` : seconds;
	  //     result += `:${seconds}`
	  // }
	  // return result;
	  var year = date.getFullYear(); // 年份
	  var month = date.getMonth() + 1; // 月份
	  var day = date.getDate(); // 日
	  var hours24 = date.getHours(); // 小时
	  var hours = hours24 % 12 === 0 ? 12 : hours24 % 12;
	  var minutes = date.getMinutes(); // 分
	  var seconds = date.getSeconds(); // 秒
	  var milliseconds = date.getMilliseconds(); // 毫秒
	  var map = {
	    yyyy: year,
	    MM: ('0' + month).slice(-2),
	    M: month,
	    dd: ('0' + day).slice(-2),
	    d: day,
	    HH: ('0' + hours24).slice(-2),
	    H: hours24,
	    hh: ('0' + hours).slice(-2),
	    h: hours,
	    mm: ('0' + minutes).slice(-2),
	    m: minutes,
	    ss: ('0' + seconds).slice(-2),
	    s: seconds,
	    S: milliseconds
	  };
	  return format.replace(/y+|M+|d+|H+|h+|m+|s+|S+/g, function (str) {
	    return map[str];
	  });
	};

/***/ }),
/* 576 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.shareSuccHandler = undefined;
	
	var _util = __webpack_require__(281);
	
	var _util2 = _interopRequireDefault(_util);
	
	var _knb = __webpack_require__(282);
	
	var _knb2 = _interopRequireDefault(_knb);
	
	var _weppModuleToast = __webpack_require__(572);
	
	var _weppModuleToast2 = _interopRequireDefault(_weppModuleToast);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var cx = '';
	function shareSuccess() {
	    return _util2.default.reqwest('/mobile/event/arro/shareget', {
	        type: 'activity',
	        cx: cx
	    }).then(function (r) {
	        if (r.code == 200 && r.msg) {
	            // let addScore = r.msg.score
	            // parseInt(addScore) && Toast(`分享成功，又增加了${addScore}霸气值`)
	            return Promise.resolve(r);
	        } else {
	            return Promise.reject('Unkown: ' + r.code);
	        }
	    }).catch(function (e) {
	        return Promise.reject('Exception: ' + e);
	    });
	}
	var shareSuccHandler = exports.shareSuccHandler = function shareSuccHandler() {
	    if (_util2.default.isApp()) {
	        console.log('=====isapp=====');
	        _knb2.default.getFingerprint({
	            success: function success(ret) {
	                cx = ret.fingerprint;
	                shareSuccess();
	            },
	            fail: function fail() {
	                (0, _weppModuleToast2.default)('出错了');
	            }
	        });
	    } else {
	        console.log('=====not app====');
	        shareSuccess();
	    }
	};

/***/ }),
/* 577 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"Hide":"Hide___1WJqq","hide":"hide___3kwLr","Hidden":"Hidden___2We7D","mt-5":"mt-5___2AzlM","res_item":"res_item___3oQF7","avatar_wrap":"avatar_wrap___RIU7_","avatar":"avatar___3baU4","res_info":"res_info___ppV-m","user_date":"user_date___236R2","username":"username___2At_m","timestamp":"timestamp___3tKOc","content":"content___242DP","btn_wrap":"btn_wrap___pcMiV","btn":"btn___3wXxj","btn_primary":"btn_primary___v9NMf","btn_secondary":"btn_secondary___1G3Rv","btn_plain":"btn_plain___1pefN","start_0":"start_0___3Fxl6","start_10":"start_10___2PIxR","start_20":"start_20___2RJed","start_30":"start_30___B18rS","start_35":"start_35___15OBr","start_40":"start_40___j-9_T","start_45":"start_45___ofIQq","start_50":"start_50___UDsv8","icon_loading":"icon_loading___1CdgK","loading":"loading___baWcI","load_wrap":"load_wrap___1Srnb","list_tips":"list_tips___1kCeS","sprites-icon-applied":"sprites-icon-applied___3KVdl","sprites-icon-checkin-disabled":"sprites-icon-checkin-disabled___35ZFl","sprites-icon-checkin":"sprites-icon-checkin___1xZTo","sprites-icon-close":"sprites-icon-close___2HYj3","sprites-icon-coupon":"sprites-icon-coupon___2B8T1","sprites-icon-db":"sprites-icon-db___2B3Fe","sprites-icon-empty":"sprites-icon-empty___1heuY","sprites-icon-error":"sprites-icon-error___3r2ct","sprites-icon-loc":"sprites-icon-loc___3XMpW","sprites-icon-logo":"sprites-icon-logo___lsRs9","sprites-icon-lv1":"sprites-icon-lv1___HQ7AZ","sprites-icon-lv2":"sprites-icon-lv2___2aDve","sprites-icon-lv3":"sprites-icon-lv3___UzfAN","sprites-icon-lv4":"sprites-icon-lv4___3RuIJ","sprites-icon-lv5":"sprites-icon-lv5___2Kyxq","sprites-icon-lv6":"sprites-icon-lv6___1YhA4","sprites-icon-lv7":"sprites-icon-lv7___1bnIE","sprites-icon-my":"sprites-icon-my___RSz7B","sprites-icon-notice":"sprites-icon-notice___2c5oo","sprites-icon-notify":"sprites-icon-notify___3PkyX","sprites-icon-passcard-disabled":"sprites-icon-passcard-disabled___IdGJI","sprites-icon-passcard":"sprites-icon-passcard___1npF-","sprites-icon-phone-l":"sprites-icon-phone-l___2Zb1u","sprites-icon-phone":"sprites-icon-phone___RRxEM","sprites-icon-prize":"sprites-icon-prize___2Vogt","sprites-icon-quiz":"sprites-icon-quiz___2DwLh","sprites-icon-success":"sprites-icon-success___3Bjq5","sprites-icon-switch-on":"sprites-icon-switch-on___1ZZta","sprites-icon-switch-s-off":"sprites-icon-switch-s-off___c6Gka","sprites-icon-switch-s-on":"sprites-icon-switch-s-on___291EW","sprites-icon-switch":"sprites-icon-switch___ch7dz","sprites-icon-vip-grey":"sprites-icon-vip-grey___S0HGm","sprites-icon-vip":"sprites-icon-vip___1kQEV","sprites-icon-win":"sprites-icon-win___3yXs_","sprites-star-0":"sprites-star-0___1vJ7-","sprites-star-10":"sprites-star-10___1bOuC","sprites-star-20":"sprites-star-20___SRbTP","sprites-star-30":"sprites-star-30___3nr1x","sprites-star-35":"sprites-star-35___3SPQZ","sprites-star-40":"sprites-star-40___3U496","sprites-star-45":"sprites-star-45___1FEMd","sprites-star-50":"sprites-star-50___2S-Fd","highlight":"highlight___29oyN","red_txt":"red_txt___2Qq4Y","icon_arrow":"icon_arrow___3IYCp","icon_arrow_down":"icon_arrow_down___1Sl5o","icon_arrow_up":"icon_arrow_up___3DvP5","detail_layout":"detail_layout___25H5f","detail_main":"detail_main___2JYD9","input_wrap":"input_wrap___7G5sR","input_el":"input_el___183Xz","btn_res_submit":"btn_res_submit___bwJMK","default_title":"default_title___8n2D3","img_wrap":"img_wrap___o3fEi","img_count":"img_count___3OyzL","count_dot":"count_dot___-THHQ","count_dot_on":"count_dot_on___iJwTX","desc_wrap":"desc_wrap___8HJFM","desc_hd":"desc_hd___2L7x8","desc_info":"desc_info___3euaH","cur_price":"cur_price___jKbIh","origin_price":"origin_price___12qV8","statistics":"statistics___kCBUo","statistics_item":"statistics_item___1bHBL","passcard":"passcard___2W4AY","passcard_disabled":"passcard_disabled___2t-xN","passcard_link":"passcard_link___28qHJ","desc_tips":"desc_tips___1ZGrC","detail_title":"detail_title___256v3","detail_content":"detail_content___1euD-","tab_wrap":"tab_wrap___VZwvV","tab_item":"tab_item___gUJ8g","tab_item_on":"tab_item_on___31wZ3","more_entry":"more_entry___31E45","merchant_title":"merchant_title___3MDGW","merchant_label":"merchant_label___1Csw7","merchant_content":"merchant_content___tJeB9","merchant_list":"merchant_list___C9hwo","merchant_item":"merchant_item___3uk_r","merchant_item_title":"merchant_item_title___16zZu","merchant_item_desc":"merchant_item_desc___34jW0","merchant_item_desc_highlight":"merchant_item_desc_highlight___2f0eF","merchant_tips":"merchant_tips___1F9zg","footer_wrap":"footer_wrap___v4pvF","record_wrap":"record_wrap___WXCnR","record_title":"record_title___3U-7a","record_list":"record_list___2T038","record_item":"record_item___3asHj","record_disable_item":"record_disable_item___3J_vE","label_status":"label_status___3bsnq","record_username":"record_username___3NxUx","record_time":"record_time___1qCi3","record_price":"record_price___22lPk","shop_wrap":"shop_wrap___2mURv","shop_title":"shop_title___12uGO","shop_change":"shop_change___vKJRU","shop_content":"shop_content___1bQ9N","shop_detail":"shop_detail___3JN0l","shop_brand":"shop_brand___1sq9n","shop_info":"shop_info___1-oXm","start_level":"start_level___3DE8_","distance":"distance___ug2eW","shop_phone":"shop_phone___1KUbN","shop_loc":"shop_loc___2Wx4y","more_user":"more_user___28Alc","progress-bar-stripes":"progress-bar-stripes___4TVQ7","clock-timing":"clock-timing___fPPtG"};

/***/ }),
/* 578 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 579 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.withRouter = exports.matchPath = exports.Switch = exports.StaticRouter = exports.Router = exports.Route = exports.Redirect = exports.Prompt = exports.NavLink = exports.MemoryRouter = exports.Link = exports.HashRouter = exports.BrowserRouter = undefined;
	
	var _BrowserRouter2 = __webpack_require__(580);
	
	var _BrowserRouter3 = _interopRequireDefault(_BrowserRouter2);
	
	var _HashRouter2 = __webpack_require__(591);
	
	var _HashRouter3 = _interopRequireDefault(_HashRouter2);
	
	var _Link2 = __webpack_require__(593);
	
	var _Link3 = _interopRequireDefault(_Link2);
	
	var _MemoryRouter2 = __webpack_require__(594);
	
	var _MemoryRouter3 = _interopRequireDefault(_MemoryRouter2);
	
	var _NavLink2 = __webpack_require__(597);
	
	var _NavLink3 = _interopRequireDefault(_NavLink2);
	
	var _Prompt2 = __webpack_require__(603);
	
	var _Prompt3 = _interopRequireDefault(_Prompt2);
	
	var _Redirect2 = __webpack_require__(605);
	
	var _Redirect3 = _interopRequireDefault(_Redirect2);
	
	var _Route2 = __webpack_require__(598);
	
	var _Route3 = _interopRequireDefault(_Route2);
	
	var _Router2 = __webpack_require__(589);
	
	var _Router3 = _interopRequireDefault(_Router2);
	
	var _StaticRouter2 = __webpack_require__(608);
	
	var _StaticRouter3 = _interopRequireDefault(_StaticRouter2);
	
	var _Switch2 = __webpack_require__(610);
	
	var _Switch3 = _interopRequireDefault(_Switch2);
	
	var _matchPath2 = __webpack_require__(612);
	
	var _matchPath3 = _interopRequireDefault(_matchPath2);
	
	var _withRouter2 = __webpack_require__(613);
	
	var _withRouter3 = _interopRequireDefault(_withRouter2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.BrowserRouter = _BrowserRouter3.default;
	exports.HashRouter = _HashRouter3.default;
	exports.Link = _Link3.default;
	exports.MemoryRouter = _MemoryRouter3.default;
	exports.NavLink = _NavLink3.default;
	exports.Prompt = _Prompt3.default;
	exports.Redirect = _Redirect3.default;
	exports.Route = _Route3.default;
	exports.Router = _Router3.default;
	exports.StaticRouter = _StaticRouter3.default;
	exports.Switch = _Switch3.default;
	exports.matchPath = _matchPath3.default;
	exports.withRouter = _withRouter3.default;

/***/ }),
/* 580 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _warning = __webpack_require__(581);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _react = __webpack_require__(73);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(267);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _createBrowserHistory = __webpack_require__(582);
	
	var _createBrowserHistory2 = _interopRequireDefault(_createBrowserHistory);
	
	var _Router = __webpack_require__(589);
	
	var _Router2 = _interopRequireDefault(_Router);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The public API for a <Router> that uses HTML5 history.
	 */
	var BrowserRouter = function (_React$Component) {
	  _inherits(BrowserRouter, _React$Component);
	
	  function BrowserRouter() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, BrowserRouter);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = (0, _createBrowserHistory2.default)(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  BrowserRouter.prototype.componentWillMount = function componentWillMount() {
	    (0, _warning2.default)(!this.props.history, '<BrowserRouter> ignores the history prop. To use a custom history, ' + 'use `import { Router }` instead of `import { BrowserRouter as Router }`.');
	  };
	
	  BrowserRouter.prototype.render = function render() {
	    return _react2.default.createElement(_Router2.default, { history: this.history, children: this.props.children });
	  };
	
	  return BrowserRouter;
	}(_react2.default.Component);
	
	BrowserRouter.propTypes = {
	  basename: _propTypes2.default.string,
	  forceRefresh: _propTypes2.default.bool,
	  getUserConfirmation: _propTypes2.default.func,
	  keyLength: _propTypes2.default.number,
	  children: _propTypes2.default.node
	};
	exports.default = BrowserRouter;

/***/ }),
/* 581 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	/**
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var warning = function() {};
	
	if (false) {
	  warning = function(condition, format, args) {
	    var len = arguments.length;
	    args = new Array(len > 2 ? len - 2 : 0);
	    for (var key = 2; key < len; key++) {
	      args[key - 2] = arguments[key];
	    }
	    if (format === undefined) {
	      throw new Error(
	        '`warning(condition, format, ...args)` requires a warning ' +
	        'message argument'
	      );
	    }
	
	    if (format.length < 10 || (/^[s\W]*$/).test(format)) {
	      throw new Error(
	        'The warning format should be able to uniquely identify this ' +
	        'warning. Please, use a more descriptive format than: ' + format
	      );
	    }
	
	    if (!condition) {
	      var argIndex = 0;
	      var message = 'Warning: ' +
	        format.replace(/%s/g, function() {
	          return args[argIndex++];
	        });
	      if (typeof console !== 'undefined') {
	        console.error(message);
	      }
	      try {
	        // This error was thrown as a convenience so that you can use this stack
	        // to find the callsite that caused this warning to fire.
	        throw new Error(message);
	      } catch(x) {}
	    }
	  };
	}
	
	module.exports = warning;


/***/ }),
/* 582 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _warning = __webpack_require__(581);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _invariant = __webpack_require__(275);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _LocationUtils = __webpack_require__(583);
	
	var _PathUtils = __webpack_require__(586);
	
	var _createTransitionManager = __webpack_require__(587);
	
	var _createTransitionManager2 = _interopRequireDefault(_createTransitionManager);
	
	var _DOMUtils = __webpack_require__(588);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PopStateEvent = 'popstate';
	var HashChangeEvent = 'hashchange';
	
	var getHistoryState = function getHistoryState() {
	  try {
	    return window.history.state || {};
	  } catch (e) {
	    // IE 11 sometimes throws when accessing window.history.state
	    // See https://github.com/ReactTraining/history/pull/289
	    return {};
	  }
	};
	
	/**
	 * Creates a history object that uses the HTML5 history API including
	 * pushState, replaceState, and the popstate event.
	 */
	var createBrowserHistory = function createBrowserHistory() {
	  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  (0, _invariant2.default)(_DOMUtils.canUseDOM, 'Browser history needs a DOM');
	
	  var globalHistory = window.history;
	  var canUseHistory = (0, _DOMUtils.supportsHistory)();
	  var needsHashChangeListener = !(0, _DOMUtils.supportsPopStateOnHashChange)();
	
	  var _props$forceRefresh = props.forceRefresh,
	      forceRefresh = _props$forceRefresh === undefined ? false : _props$forceRefresh,
	      _props$getUserConfirm = props.getUserConfirmation,
	      getUserConfirmation = _props$getUserConfirm === undefined ? _DOMUtils.getConfirmation : _props$getUserConfirm,
	      _props$keyLength = props.keyLength,
	      keyLength = _props$keyLength === undefined ? 6 : _props$keyLength;
	
	  var basename = props.basename ? (0, _PathUtils.stripTrailingSlash)((0, _PathUtils.addLeadingSlash)(props.basename)) : '';
	
	  var getDOMLocation = function getDOMLocation(historyState) {
	    var _ref = historyState || {},
	        key = _ref.key,
	        state = _ref.state;
	
	    var _window$location = window.location,
	        pathname = _window$location.pathname,
	        search = _window$location.search,
	        hash = _window$location.hash;
	
	
	    var path = pathname + search + hash;
	
	    (0, _warning2.default)(!basename || (0, _PathUtils.hasBasename)(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".');
	
	    if (basename) path = (0, _PathUtils.stripBasename)(path, basename);
	
	    return (0, _LocationUtils.createLocation)(path, state, key);
	  };
	
	  var createKey = function createKey() {
	    return Math.random().toString(36).substr(2, keyLength);
	  };
	
	  var transitionManager = (0, _createTransitionManager2.default)();
	
	  var setState = function setState(nextState) {
	    _extends(history, nextState);
	
	    history.length = globalHistory.length;
	
	    transitionManager.notifyListeners(history.location, history.action);
	  };
	
	  var handlePopState = function handlePopState(event) {
	    // Ignore extraneous popstate events in WebKit.
	    if ((0, _DOMUtils.isExtraneousPopstateEvent)(event)) return;
	
	    handlePop(getDOMLocation(event.state));
	  };
	
	  var handleHashChange = function handleHashChange() {
	    handlePop(getDOMLocation(getHistoryState()));
	  };
	
	  var forceNextPop = false;
	
	  var handlePop = function handlePop(location) {
	    if (forceNextPop) {
	      forceNextPop = false;
	      setState();
	    } else {
	      var action = 'POP';
	
	      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
	        if (ok) {
	          setState({ action: action, location: location });
	        } else {
	          revertPop(location);
	        }
	      });
	    }
	  };
	
	  var revertPop = function revertPop(fromLocation) {
	    var toLocation = history.location;
	
	    // TODO: We could probably make this more reliable by
	    // keeping a list of keys we've seen in sessionStorage.
	    // Instead, we just default to 0 for keys we don't know.
	
	    var toIndex = allKeys.indexOf(toLocation.key);
	
	    if (toIndex === -1) toIndex = 0;
	
	    var fromIndex = allKeys.indexOf(fromLocation.key);
	
	    if (fromIndex === -1) fromIndex = 0;
	
	    var delta = toIndex - fromIndex;
	
	    if (delta) {
	      forceNextPop = true;
	      go(delta);
	    }
	  };
	
	  var initialLocation = getDOMLocation(getHistoryState());
	  var allKeys = [initialLocation.key];
	
	  // Public interface
	
	  var createHref = function createHref(location) {
	    return basename + (0, _PathUtils.createPath)(location);
	  };
	
	  var push = function push(path, state) {
	    (0, _warning2.default)(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored');
	
	    var action = 'PUSH';
	    var location = (0, _LocationUtils.createLocation)(path, state, createKey(), history.location);
	
	    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
	      if (!ok) return;
	
	      var href = createHref(location);
	      var key = location.key,
	          state = location.state;
	
	
	      if (canUseHistory) {
	        globalHistory.pushState({ key: key, state: state }, null, href);
	
	        if (forceRefresh) {
	          window.location.href = href;
	        } else {
	          var prevIndex = allKeys.indexOf(history.location.key);
	          var nextKeys = allKeys.slice(0, prevIndex === -1 ? 0 : prevIndex + 1);
	
	          nextKeys.push(location.key);
	          allKeys = nextKeys;
	
	          setState({ action: action, location: location });
	        }
	      } else {
	        (0, _warning2.default)(state === undefined, 'Browser history cannot push state in browsers that do not support HTML5 history');
	
	        window.location.href = href;
	      }
	    });
	  };
	
	  var replace = function replace(path, state) {
	    (0, _warning2.default)(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored');
	
	    var action = 'REPLACE';
	    var location = (0, _LocationUtils.createLocation)(path, state, createKey(), history.location);
	
	    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
	      if (!ok) return;
	
	      var href = createHref(location);
	      var key = location.key,
	          state = location.state;
	
	
	      if (canUseHistory) {
	        globalHistory.replaceState({ key: key, state: state }, null, href);
	
	        if (forceRefresh) {
	          window.location.replace(href);
	        } else {
	          var prevIndex = allKeys.indexOf(history.location.key);
	
	          if (prevIndex !== -1) allKeys[prevIndex] = location.key;
	
	          setState({ action: action, location: location });
	        }
	      } else {
	        (0, _warning2.default)(state === undefined, 'Browser history cannot replace state in browsers that do not support HTML5 history');
	
	        window.location.replace(href);
	      }
	    });
	  };
	
	  var go = function go(n) {
	    globalHistory.go(n);
	  };
	
	  var goBack = function goBack() {
	    return go(-1);
	  };
	
	  var goForward = function goForward() {
	    return go(1);
	  };
	
	  var listenerCount = 0;
	
	  var checkDOMListeners = function checkDOMListeners(delta) {
	    listenerCount += delta;
	
	    if (listenerCount === 1) {
	      (0, _DOMUtils.addEventListener)(window, PopStateEvent, handlePopState);
	
	      if (needsHashChangeListener) (0, _DOMUtils.addEventListener)(window, HashChangeEvent, handleHashChange);
	    } else if (listenerCount === 0) {
	      (0, _DOMUtils.removeEventListener)(window, PopStateEvent, handlePopState);
	
	      if (needsHashChangeListener) (0, _DOMUtils.removeEventListener)(window, HashChangeEvent, handleHashChange);
	    }
	  };
	
	  var isBlocked = false;
	
	  var block = function block() {
	    var prompt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
	    var unblock = transitionManager.setPrompt(prompt);
	
	    if (!isBlocked) {
	      checkDOMListeners(1);
	      isBlocked = true;
	    }
	
	    return function () {
	      if (isBlocked) {
	        isBlocked = false;
	        checkDOMListeners(-1);
	      }
	
	      return unblock();
	    };
	  };
	
	  var listen = function listen(listener) {
	    var unlisten = transitionManager.appendListener(listener);
	    checkDOMListeners(1);
	
	    return function () {
	      checkDOMListeners(-1);
	      unlisten();
	    };
	  };
	
	  var history = {
	    length: globalHistory.length,
	    action: 'POP',
	    location: initialLocation,
	    createHref: createHref,
	    push: push,
	    replace: replace,
	    go: go,
	    goBack: goBack,
	    goForward: goForward,
	    block: block,
	    listen: listen
	  };
	
	  return history;
	};
	
	exports.default = createBrowserHistory;

/***/ }),
/* 583 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.locationsAreEqual = exports.createLocation = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _resolvePathname = __webpack_require__(584);
	
	var _resolvePathname2 = _interopRequireDefault(_resolvePathname);
	
	var _valueEqual = __webpack_require__(585);
	
	var _valueEqual2 = _interopRequireDefault(_valueEqual);
	
	var _PathUtils = __webpack_require__(586);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var createLocation = exports.createLocation = function createLocation(path, state, key, currentLocation) {
	  var location = void 0;
	  if (typeof path === 'string') {
	    // Two-arg form: push(path, state)
	    location = (0, _PathUtils.parsePath)(path);
	    location.state = state;
	  } else {
	    // One-arg form: push(location)
	    location = _extends({}, path);
	
	    if (location.pathname === undefined) location.pathname = '';
	
	    if (location.search) {
	      if (location.search.charAt(0) !== '?') location.search = '?' + location.search;
	    } else {
	      location.search = '';
	    }
	
	    if (location.hash) {
	      if (location.hash.charAt(0) !== '#') location.hash = '#' + location.hash;
	    } else {
	      location.hash = '';
	    }
	
	    if (state !== undefined && location.state === undefined) location.state = state;
	  }
	
	  try {
	    location.pathname = decodeURI(location.pathname);
	  } catch (e) {
	    if (e instanceof URIError) {
	      throw new URIError('Pathname "' + location.pathname + '" could not be decoded. ' + 'This is likely caused by an invalid percent-encoding.');
	    } else {
	      throw e;
	    }
	  }
	
	  if (key) location.key = key;
	
	  if (currentLocation) {
	    // Resolve incomplete/relative pathname relative to current location.
	    if (!location.pathname) {
	      location.pathname = currentLocation.pathname;
	    } else if (location.pathname.charAt(0) !== '/') {
	      location.pathname = (0, _resolvePathname2.default)(location.pathname, currentLocation.pathname);
	    }
	  } else {
	    // When there is no prior location and pathname is empty, set it to /
	    if (!location.pathname) {
	      location.pathname = '/';
	    }
	  }
	
	  return location;
	};
	
	var locationsAreEqual = exports.locationsAreEqual = function locationsAreEqual(a, b) {
	  return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && a.key === b.key && (0, _valueEqual2.default)(a.state, b.state);
	};

/***/ }),
/* 584 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	function isAbsolute(pathname) {
	  return pathname.charAt(0) === '/';
	}
	
	// About 1.5x faster than the two-arg version of Array#splice()
	function spliceOne(list, index) {
	  for (var i = index, k = i + 1, n = list.length; k < n; i += 1, k += 1) {
	    list[i] = list[k];
	  }
	
	  list.pop();
	}
	
	// This implementation is based heavily on node's url.parse
	function resolvePathname(to) {
	  var from = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
	
	  var toParts = to && to.split('/') || [];
	  var fromParts = from && from.split('/') || [];
	
	  var isToAbs = to && isAbsolute(to);
	  var isFromAbs = from && isAbsolute(from);
	  var mustEndAbs = isToAbs || isFromAbs;
	
	  if (to && isAbsolute(to)) {
	    // to is absolute
	    fromParts = toParts;
	  } else if (toParts.length) {
	    // to is relative, drop the filename
	    fromParts.pop();
	    fromParts = fromParts.concat(toParts);
	  }
	
	  if (!fromParts.length) return '/';
	
	  var hasTrailingSlash = void 0;
	  if (fromParts.length) {
	    var last = fromParts[fromParts.length - 1];
	    hasTrailingSlash = last === '.' || last === '..' || last === '';
	  } else {
	    hasTrailingSlash = false;
	  }
	
	  var up = 0;
	  for (var i = fromParts.length; i >= 0; i--) {
	    var part = fromParts[i];
	
	    if (part === '.') {
	      spliceOne(fromParts, i);
	    } else if (part === '..') {
	      spliceOne(fromParts, i);
	      up++;
	    } else if (up) {
	      spliceOne(fromParts, i);
	      up--;
	    }
	  }
	
	  if (!mustEndAbs) for (; up--; up) {
	    fromParts.unshift('..');
	  }if (mustEndAbs && fromParts[0] !== '' && (!fromParts[0] || !isAbsolute(fromParts[0]))) fromParts.unshift('');
	
	  var result = fromParts.join('/');
	
	  if (hasTrailingSlash && result.substr(-1) !== '/') result += '/';
	
	  return result;
	}
	
	exports.default = resolvePathname;
	module.exports = exports['default'];

/***/ }),
/* 585 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	function valueEqual(a, b) {
	  if (a === b) return true;
	
	  if (a == null || b == null) return false;
	
	  if (Array.isArray(a)) {
	    return Array.isArray(b) && a.length === b.length && a.every(function (item, index) {
	      return valueEqual(item, b[index]);
	    });
	  }
	
	  var aType = typeof a === 'undefined' ? 'undefined' : _typeof(a);
	  var bType = typeof b === 'undefined' ? 'undefined' : _typeof(b);
	
	  if (aType !== bType) return false;
	
	  if (aType === 'object') {
	    var aValue = a.valueOf();
	    var bValue = b.valueOf();
	
	    if (aValue !== a || bValue !== b) return valueEqual(aValue, bValue);
	
	    var aKeys = Object.keys(a);
	    var bKeys = Object.keys(b);
	
	    if (aKeys.length !== bKeys.length) return false;
	
	    return aKeys.every(function (key) {
	      return valueEqual(a[key], b[key]);
	    });
	  }
	
	  return false;
	}
	
	exports.default = valueEqual;
	module.exports = exports['default'];

/***/ }),
/* 586 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var addLeadingSlash = exports.addLeadingSlash = function addLeadingSlash(path) {
	  return path.charAt(0) === '/' ? path : '/' + path;
	};
	
	var stripLeadingSlash = exports.stripLeadingSlash = function stripLeadingSlash(path) {
	  return path.charAt(0) === '/' ? path.substr(1) : path;
	};
	
	var hasBasename = exports.hasBasename = function hasBasename(path, prefix) {
	  return new RegExp('^' + prefix + '(\\/|\\?|#|$)', 'i').test(path);
	};
	
	var stripBasename = exports.stripBasename = function stripBasename(path, prefix) {
	  return hasBasename(path, prefix) ? path.substr(prefix.length) : path;
	};
	
	var stripTrailingSlash = exports.stripTrailingSlash = function stripTrailingSlash(path) {
	  return path.charAt(path.length - 1) === '/' ? path.slice(0, -1) : path;
	};
	
	var parsePath = exports.parsePath = function parsePath(path) {
	  var pathname = path || '/';
	  var search = '';
	  var hash = '';
	
	  var hashIndex = pathname.indexOf('#');
	  if (hashIndex !== -1) {
	    hash = pathname.substr(hashIndex);
	    pathname = pathname.substr(0, hashIndex);
	  }
	
	  var searchIndex = pathname.indexOf('?');
	  if (searchIndex !== -1) {
	    search = pathname.substr(searchIndex);
	    pathname = pathname.substr(0, searchIndex);
	  }
	
	  return {
	    pathname: pathname,
	    search: search === '?' ? '' : search,
	    hash: hash === '#' ? '' : hash
	  };
	};
	
	var createPath = exports.createPath = function createPath(location) {
	  var pathname = location.pathname,
	      search = location.search,
	      hash = location.hash;
	
	
	  var path = pathname || '/';
	
	  if (search && search !== '?') path += search.charAt(0) === '?' ? search : '?' + search;
	
	  if (hash && hash !== '#') path += hash.charAt(0) === '#' ? hash : '#' + hash;
	
	  return path;
	};

/***/ }),
/* 587 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _warning = __webpack_require__(581);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var createTransitionManager = function createTransitionManager() {
	  var prompt = null;
	
	  var setPrompt = function setPrompt(nextPrompt) {
	    (0, _warning2.default)(prompt == null, 'A history supports only one prompt at a time');
	
	    prompt = nextPrompt;
	
	    return function () {
	      if (prompt === nextPrompt) prompt = null;
	    };
	  };
	
	  var confirmTransitionTo = function confirmTransitionTo(location, action, getUserConfirmation, callback) {
	    // TODO: If another transition starts while we're still confirming
	    // the previous one, we may end up in a weird state. Figure out the
	    // best way to handle this.
	    if (prompt != null) {
	      var result = typeof prompt === 'function' ? prompt(location, action) : prompt;
	
	      if (typeof result === 'string') {
	        if (typeof getUserConfirmation === 'function') {
	          getUserConfirmation(result, callback);
	        } else {
	          (0, _warning2.default)(false, 'A history needs a getUserConfirmation function in order to use a prompt message');
	
	          callback(true);
	        }
	      } else {
	        // Return false from a transition hook to cancel the transition.
	        callback(result !== false);
	      }
	    } else {
	      callback(true);
	    }
	  };
	
	  var listeners = [];
	
	  var appendListener = function appendListener(fn) {
	    var isActive = true;
	
	    var listener = function listener() {
	      if (isActive) fn.apply(undefined, arguments);
	    };
	
	    listeners.push(listener);
	
	    return function () {
	      isActive = false;
	      listeners = listeners.filter(function (item) {
	        return item !== listener;
	      });
	    };
	  };
	
	  var notifyListeners = function notifyListeners() {
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    listeners.forEach(function (listener) {
	      return listener.apply(undefined, args);
	    });
	  };
	
	  return {
	    setPrompt: setPrompt,
	    confirmTransitionTo: confirmTransitionTo,
	    appendListener: appendListener,
	    notifyListeners: notifyListeners
	  };
	};
	
	exports.default = createTransitionManager;

/***/ }),
/* 588 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var canUseDOM = exports.canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	
	var addEventListener = exports.addEventListener = function addEventListener(node, event, listener) {
	  return node.addEventListener ? node.addEventListener(event, listener, false) : node.attachEvent('on' + event, listener);
	};
	
	var removeEventListener = exports.removeEventListener = function removeEventListener(node, event, listener) {
	  return node.removeEventListener ? node.removeEventListener(event, listener, false) : node.detachEvent('on' + event, listener);
	};
	
	var getConfirmation = exports.getConfirmation = function getConfirmation(message, callback) {
	  return callback(window.confirm(message));
	}; // eslint-disable-line no-alert
	
	/**
	 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
	 *
	 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
	 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
	 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
	 */
	var supportsHistory = exports.supportsHistory = function supportsHistory() {
	  var ua = window.navigator.userAgent;
	
	  if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) return false;
	
	  return window.history && 'pushState' in window.history;
	};
	
	/**
	 * Returns true if browser fires popstate on hash change.
	 * IE10 and IE11 do not.
	 */
	var supportsPopStateOnHashChange = exports.supportsPopStateOnHashChange = function supportsPopStateOnHashChange() {
	  return window.navigator.userAgent.indexOf('Trident') === -1;
	};
	
	/**
	 * Returns false if using go(n) with hash history causes a full page reload.
	 */
	var supportsGoWithoutReloadUsingHash = exports.supportsGoWithoutReloadUsingHash = function supportsGoWithoutReloadUsingHash() {
	  return window.navigator.userAgent.indexOf('Firefox') === -1;
	};
	
	/**
	 * Returns true if a given popstate event is an extraneous WebKit event.
	 * Accounts for the fact that Chrome on iOS fires real popstate events
	 * containing undefined state when pressing the back button.
	 */
	var isExtraneousPopstateEvent = exports.isExtraneousPopstateEvent = function isExtraneousPopstateEvent(event) {
	  return event.state === undefined && navigator.userAgent.indexOf('CriOS') === -1;
	};

/***/ }),
/* 589 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _Router = __webpack_require__(590);
	
	var _Router2 = _interopRequireDefault(_Router);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Router2.default; // Written in this round about way for babel-transform-imports

/***/ }),
/* 590 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _warning = __webpack_require__(581);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _invariant = __webpack_require__(275);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _react = __webpack_require__(73);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(267);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The public API for putting history on context.
	 */
	var Router = function (_React$Component) {
	  _inherits(Router, _React$Component);
	
	  function Router() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Router);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
	      match: _this.computeMatch(_this.props.history.location.pathname)
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  Router.prototype.getChildContext = function getChildContext() {
	    return {
	      router: _extends({}, this.context.router, {
	        history: this.props.history,
	        route: {
	          location: this.props.history.location,
	          match: this.state.match
	        }
	      })
	    };
	  };
	
	  Router.prototype.computeMatch = function computeMatch(pathname) {
	    return {
	      path: '/',
	      url: '/',
	      params: {},
	      isExact: pathname === '/'
	    };
	  };
	
	  Router.prototype.componentWillMount = function componentWillMount() {
	    var _this2 = this;
	
	    var _props = this.props,
	        children = _props.children,
	        history = _props.history;
	
	
	    (0, _invariant2.default)(children == null || _react2.default.Children.count(children) === 1, 'A <Router> may have only one child element');
	
	    // Do this here so we can setState when a <Redirect> changes the
	    // location in componentWillMount. This happens e.g. when doing
	    // server rendering using a <StaticRouter>.
	    this.unlisten = history.listen(function () {
	      _this2.setState({
	        match: _this2.computeMatch(history.location.pathname)
	      });
	    });
	  };
	
	  Router.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    (0, _warning2.default)(this.props.history === nextProps.history, 'You cannot change <Router history>');
	  };
	
	  Router.prototype.componentWillUnmount = function componentWillUnmount() {
	    this.unlisten();
	  };
	
	  Router.prototype.render = function render() {
	    var children = this.props.children;
	
	    return children ? _react2.default.Children.only(children) : null;
	  };
	
	  return Router;
	}(_react2.default.Component);
	
	Router.propTypes = {
	  history: _propTypes2.default.object.isRequired,
	  children: _propTypes2.default.node
	};
	Router.contextTypes = {
	  router: _propTypes2.default.object
	};
	Router.childContextTypes = {
	  router: _propTypes2.default.object.isRequired
	};
	exports.default = Router;

/***/ }),
/* 591 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _warning = __webpack_require__(581);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _react = __webpack_require__(73);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(267);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _createHashHistory = __webpack_require__(592);
	
	var _createHashHistory2 = _interopRequireDefault(_createHashHistory);
	
	var _Router = __webpack_require__(589);
	
	var _Router2 = _interopRequireDefault(_Router);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The public API for a <Router> that uses window.location.hash.
	 */
	var HashRouter = function (_React$Component) {
	  _inherits(HashRouter, _React$Component);
	
	  function HashRouter() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, HashRouter);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = (0, _createHashHistory2.default)(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  HashRouter.prototype.componentWillMount = function componentWillMount() {
	    (0, _warning2.default)(!this.props.history, '<HashRouter> ignores the history prop. To use a custom history, ' + 'use `import { Router }` instead of `import { HashRouter as Router }`.');
	  };
	
	  HashRouter.prototype.render = function render() {
	    return _react2.default.createElement(_Router2.default, { history: this.history, children: this.props.children });
	  };
	
	  return HashRouter;
	}(_react2.default.Component);
	
	HashRouter.propTypes = {
	  basename: _propTypes2.default.string,
	  getUserConfirmation: _propTypes2.default.func,
	  hashType: _propTypes2.default.oneOf(['hashbang', 'noslash', 'slash']),
	  children: _propTypes2.default.node
	};
	exports.default = HashRouter;

/***/ }),
/* 592 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _warning = __webpack_require__(581);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _invariant = __webpack_require__(275);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _LocationUtils = __webpack_require__(583);
	
	var _PathUtils = __webpack_require__(586);
	
	var _createTransitionManager = __webpack_require__(587);
	
	var _createTransitionManager2 = _interopRequireDefault(_createTransitionManager);
	
	var _DOMUtils = __webpack_require__(588);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HashChangeEvent = 'hashchange';
	
	var HashPathCoders = {
	  hashbang: {
	    encodePath: function encodePath(path) {
	      return path.charAt(0) === '!' ? path : '!/' + (0, _PathUtils.stripLeadingSlash)(path);
	    },
	    decodePath: function decodePath(path) {
	      return path.charAt(0) === '!' ? path.substr(1) : path;
	    }
	  },
	  noslash: {
	    encodePath: _PathUtils.stripLeadingSlash,
	    decodePath: _PathUtils.addLeadingSlash
	  },
	  slash: {
	    encodePath: _PathUtils.addLeadingSlash,
	    decodePath: _PathUtils.addLeadingSlash
	  }
	};
	
	var getHashPath = function getHashPath() {
	  // We can't use window.location.hash here because it's not
	  // consistent across browsers - Firefox will pre-decode it!
	  var href = window.location.href;
	  var hashIndex = href.indexOf('#');
	  return hashIndex === -1 ? '' : href.substring(hashIndex + 1);
	};
	
	var pushHashPath = function pushHashPath(path) {
	  return window.location.hash = path;
	};
	
	var replaceHashPath = function replaceHashPath(path) {
	  var hashIndex = window.location.href.indexOf('#');
	
	  window.location.replace(window.location.href.slice(0, hashIndex >= 0 ? hashIndex : 0) + '#' + path);
	};
	
	var createHashHistory = function createHashHistory() {
	  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  (0, _invariant2.default)(_DOMUtils.canUseDOM, 'Hash history needs a DOM');
	
	  var globalHistory = window.history;
	  var canGoWithoutReload = (0, _DOMUtils.supportsGoWithoutReloadUsingHash)();
	
	  var _props$getUserConfirm = props.getUserConfirmation,
	      getUserConfirmation = _props$getUserConfirm === undefined ? _DOMUtils.getConfirmation : _props$getUserConfirm,
	      _props$hashType = props.hashType,
	      hashType = _props$hashType === undefined ? 'slash' : _props$hashType;
	
	  var basename = props.basename ? (0, _PathUtils.stripTrailingSlash)((0, _PathUtils.addLeadingSlash)(props.basename)) : '';
	
	  var _HashPathCoders$hashT = HashPathCoders[hashType],
	      encodePath = _HashPathCoders$hashT.encodePath,
	      decodePath = _HashPathCoders$hashT.decodePath;
	
	
	  var getDOMLocation = function getDOMLocation() {
	    var path = decodePath(getHashPath());
	
	    (0, _warning2.default)(!basename || (0, _PathUtils.hasBasename)(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".');
	
	    if (basename) path = (0, _PathUtils.stripBasename)(path, basename);
	
	    return (0, _LocationUtils.createLocation)(path);
	  };
	
	  var transitionManager = (0, _createTransitionManager2.default)();
	
	  var setState = function setState(nextState) {
	    _extends(history, nextState);
	
	    history.length = globalHistory.length;
	
	    transitionManager.notifyListeners(history.location, history.action);
	  };
	
	  var forceNextPop = false;
	  var ignorePath = null;
	
	  var handleHashChange = function handleHashChange() {
	    var path = getHashPath();
	    var encodedPath = encodePath(path);
	
	    if (path !== encodedPath) {
	      // Ensure we always have a properly-encoded hash.
	      replaceHashPath(encodedPath);
	    } else {
	      var location = getDOMLocation();
	      var prevLocation = history.location;
	
	      if (!forceNextPop && (0, _LocationUtils.locationsAreEqual)(prevLocation, location)) return; // A hashchange doesn't always == location change.
	
	      if (ignorePath === (0, _PathUtils.createPath)(location)) return; // Ignore this change; we already setState in push/replace.
	
	      ignorePath = null;
	
	      handlePop(location);
	    }
	  };
	
	  var handlePop = function handlePop(location) {
	    if (forceNextPop) {
	      forceNextPop = false;
	      setState();
	    } else {
	      var action = 'POP';
	
	      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
	        if (ok) {
	          setState({ action: action, location: location });
	        } else {
	          revertPop(location);
	        }
	      });
	    }
	  };
	
	  var revertPop = function revertPop(fromLocation) {
	    var toLocation = history.location;
	
	    // TODO: We could probably make this more reliable by
	    // keeping a list of paths we've seen in sessionStorage.
	    // Instead, we just default to 0 for paths we don't know.
	
	    var toIndex = allPaths.lastIndexOf((0, _PathUtils.createPath)(toLocation));
	
	    if (toIndex === -1) toIndex = 0;
	
	    var fromIndex = allPaths.lastIndexOf((0, _PathUtils.createPath)(fromLocation));
	
	    if (fromIndex === -1) fromIndex = 0;
	
	    var delta = toIndex - fromIndex;
	
	    if (delta) {
	      forceNextPop = true;
	      go(delta);
	    }
	  };
	
	  // Ensure the hash is encoded properly before doing anything else.
	  var path = getHashPath();
	  var encodedPath = encodePath(path);
	
	  if (path !== encodedPath) replaceHashPath(encodedPath);
	
	  var initialLocation = getDOMLocation();
	  var allPaths = [(0, _PathUtils.createPath)(initialLocation)];
	
	  // Public interface
	
	  var createHref = function createHref(location) {
	    return '#' + encodePath(basename + (0, _PathUtils.createPath)(location));
	  };
	
	  var push = function push(path, state) {
	    (0, _warning2.default)(state === undefined, 'Hash history cannot push state; it is ignored');
	
	    var action = 'PUSH';
	    var location = (0, _LocationUtils.createLocation)(path, undefined, undefined, history.location);
	
	    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
	      if (!ok) return;
	
	      var path = (0, _PathUtils.createPath)(location);
	      var encodedPath = encodePath(basename + path);
	      var hashChanged = getHashPath() !== encodedPath;
	
	      if (hashChanged) {
	        // We cannot tell if a hashchange was caused by a PUSH, so we'd
	        // rather setState here and ignore the hashchange. The caveat here
	        // is that other hash histories in the page will consider it a POP.
	        ignorePath = path;
	        pushHashPath(encodedPath);
	
	        var prevIndex = allPaths.lastIndexOf((0, _PathUtils.createPath)(history.location));
	        var nextPaths = allPaths.slice(0, prevIndex === -1 ? 0 : prevIndex + 1);
	
	        nextPaths.push(path);
	        allPaths = nextPaths;
	
	        setState({ action: action, location: location });
	      } else {
	        (0, _warning2.default)(false, 'Hash history cannot PUSH the same path; a new entry will not be added to the history stack');
	
	        setState();
	      }
	    });
	  };
	
	  var replace = function replace(path, state) {
	    (0, _warning2.default)(state === undefined, 'Hash history cannot replace state; it is ignored');
	
	    var action = 'REPLACE';
	    var location = (0, _LocationUtils.createLocation)(path, undefined, undefined, history.location);
	
	    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
	      if (!ok) return;
	
	      var path = (0, _PathUtils.createPath)(location);
	      var encodedPath = encodePath(basename + path);
	      var hashChanged = getHashPath() !== encodedPath;
	
	      if (hashChanged) {
	        // We cannot tell if a hashchange was caused by a REPLACE, so we'd
	        // rather setState here and ignore the hashchange. The caveat here
	        // is that other hash histories in the page will consider it a POP.
	        ignorePath = path;
	        replaceHashPath(encodedPath);
	      }
	
	      var prevIndex = allPaths.indexOf((0, _PathUtils.createPath)(history.location));
	
	      if (prevIndex !== -1) allPaths[prevIndex] = path;
	
	      setState({ action: action, location: location });
	    });
	  };
	
	  var go = function go(n) {
	    (0, _warning2.default)(canGoWithoutReload, 'Hash history go(n) causes a full page reload in this browser');
	
	    globalHistory.go(n);
	  };
	
	  var goBack = function goBack() {
	    return go(-1);
	  };
	
	  var goForward = function goForward() {
	    return go(1);
	  };
	
	  var listenerCount = 0;
	
	  var checkDOMListeners = function checkDOMListeners(delta) {
	    listenerCount += delta;
	
	    if (listenerCount === 1) {
	      (0, _DOMUtils.addEventListener)(window, HashChangeEvent, handleHashChange);
	    } else if (listenerCount === 0) {
	      (0, _DOMUtils.removeEventListener)(window, HashChangeEvent, handleHashChange);
	    }
	  };
	
	  var isBlocked = false;
	
	  var block = function block() {
	    var prompt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
	    var unblock = transitionManager.setPrompt(prompt);
	
	    if (!isBlocked) {
	      checkDOMListeners(1);
	      isBlocked = true;
	    }
	
	    return function () {
	      if (isBlocked) {
	        isBlocked = false;
	        checkDOMListeners(-1);
	      }
	
	      return unblock();
	    };
	  };
	
	  var listen = function listen(listener) {
	    var unlisten = transitionManager.appendListener(listener);
	    checkDOMListeners(1);
	
	    return function () {
	      checkDOMListeners(-1);
	      unlisten();
	    };
	  };
	
	  var history = {
	    length: globalHistory.length,
	    action: 'POP',
	    location: initialLocation,
	    createHref: createHref,
	    push: push,
	    replace: replace,
	    go: go,
	    goBack: goBack,
	    goForward: goForward,
	    block: block,
	    listen: listen
	  };
	
	  return history;
	};
	
	exports.default = createHashHistory;

/***/ }),
/* 593 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(73);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(267);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _invariant = __webpack_require__(275);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var isModifiedEvent = function isModifiedEvent(event) {
	  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
	};
	
	/**
	 * The public API for rendering a history-aware <a>.
	 */
	
	var Link = function (_React$Component) {
	  _inherits(Link, _React$Component);
	
	  function Link() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Link);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.handleClick = function (event) {
	      if (_this.props.onClick) _this.props.onClick(event);
	
	      if (!event.defaultPrevented && // onClick prevented default
	      event.button === 0 && // ignore right clicks
	      !_this.props.target && // let browser handle "target=_blank" etc.
	      !isModifiedEvent(event) // ignore clicks with modifier keys
	      ) {
	          event.preventDefault();
	
	          var history = _this.context.router.history;
	          var _this$props = _this.props,
	              replace = _this$props.replace,
	              to = _this$props.to;
	
	
	          if (replace) {
	            history.replace(to);
	          } else {
	            history.push(to);
	          }
	        }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  Link.prototype.render = function render() {
	    var _props = this.props,
	        replace = _props.replace,
	        to = _props.to,
	        innerRef = _props.innerRef,
	        props = _objectWithoutProperties(_props, ['replace', 'to', 'innerRef']); // eslint-disable-line no-unused-vars
	
	    (0, _invariant2.default)(this.context.router, 'You should not use <Link> outside a <Router>');
	
	    var href = this.context.router.history.createHref(typeof to === 'string' ? { pathname: to } : to);
	
	    return _react2.default.createElement('a', _extends({}, props, { onClick: this.handleClick, href: href, ref: innerRef }));
	  };
	
	  return Link;
	}(_react2.default.Component);
	
	Link.propTypes = {
	  onClick: _propTypes2.default.func,
	  target: _propTypes2.default.string,
	  replace: _propTypes2.default.bool,
	  to: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]).isRequired,
	  innerRef: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func])
	};
	Link.defaultProps = {
	  replace: false
	};
	Link.contextTypes = {
	  router: _propTypes2.default.shape({
	    history: _propTypes2.default.shape({
	      push: _propTypes2.default.func.isRequired,
	      replace: _propTypes2.default.func.isRequired,
	      createHref: _propTypes2.default.func.isRequired
	    }).isRequired
	  }).isRequired
	};
	exports.default = Link;

/***/ }),
/* 594 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _MemoryRouter = __webpack_require__(595);
	
	var _MemoryRouter2 = _interopRequireDefault(_MemoryRouter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _MemoryRouter2.default; // Written in this round about way for babel-transform-imports

/***/ }),
/* 595 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _warning = __webpack_require__(581);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _react = __webpack_require__(73);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(267);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _createMemoryHistory = __webpack_require__(596);
	
	var _createMemoryHistory2 = _interopRequireDefault(_createMemoryHistory);
	
	var _Router = __webpack_require__(590);
	
	var _Router2 = _interopRequireDefault(_Router);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The public API for a <Router> that stores location in memory.
	 */
	var MemoryRouter = function (_React$Component) {
	  _inherits(MemoryRouter, _React$Component);
	
	  function MemoryRouter() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, MemoryRouter);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = (0, _createMemoryHistory2.default)(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  MemoryRouter.prototype.componentWillMount = function componentWillMount() {
	    (0, _warning2.default)(!this.props.history, '<MemoryRouter> ignores the history prop. To use a custom history, ' + 'use `import { Router }` instead of `import { MemoryRouter as Router }`.');
	  };
	
	  MemoryRouter.prototype.render = function render() {
	    return _react2.default.createElement(_Router2.default, { history: this.history, children: this.props.children });
	  };
	
	  return MemoryRouter;
	}(_react2.default.Component);
	
	MemoryRouter.propTypes = {
	  initialEntries: _propTypes2.default.array,
	  initialIndex: _propTypes2.default.number,
	  getUserConfirmation: _propTypes2.default.func,
	  keyLength: _propTypes2.default.number,
	  children: _propTypes2.default.node
	};
	exports.default = MemoryRouter;

/***/ }),
/* 596 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _warning = __webpack_require__(581);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _PathUtils = __webpack_require__(586);
	
	var _LocationUtils = __webpack_require__(583);
	
	var _createTransitionManager = __webpack_require__(587);
	
	var _createTransitionManager2 = _interopRequireDefault(_createTransitionManager);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var clamp = function clamp(n, lowerBound, upperBound) {
	  return Math.min(Math.max(n, lowerBound), upperBound);
	};
	
	/**
	 * Creates a history object that stores locations in memory.
	 */
	var createMemoryHistory = function createMemoryHistory() {
	  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var getUserConfirmation = props.getUserConfirmation,
	      _props$initialEntries = props.initialEntries,
	      initialEntries = _props$initialEntries === undefined ? ['/'] : _props$initialEntries,
	      _props$initialIndex = props.initialIndex,
	      initialIndex = _props$initialIndex === undefined ? 0 : _props$initialIndex,
	      _props$keyLength = props.keyLength,
	      keyLength = _props$keyLength === undefined ? 6 : _props$keyLength;
	
	
	  var transitionManager = (0, _createTransitionManager2.default)();
	
	  var setState = function setState(nextState) {
	    _extends(history, nextState);
	
	    history.length = history.entries.length;
	
	    transitionManager.notifyListeners(history.location, history.action);
	  };
	
	  var createKey = function createKey() {
	    return Math.random().toString(36).substr(2, keyLength);
	  };
	
	  var index = clamp(initialIndex, 0, initialEntries.length - 1);
	  var entries = initialEntries.map(function (entry) {
	    return typeof entry === 'string' ? (0, _LocationUtils.createLocation)(entry, undefined, createKey()) : (0, _LocationUtils.createLocation)(entry, undefined, entry.key || createKey());
	  });
	
	  // Public interface
	
	  var createHref = _PathUtils.createPath;
	
	  var push = function push(path, state) {
	    (0, _warning2.default)(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored');
	
	    var action = 'PUSH';
	    var location = (0, _LocationUtils.createLocation)(path, state, createKey(), history.location);
	
	    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
	      if (!ok) return;
	
	      var prevIndex = history.index;
	      var nextIndex = prevIndex + 1;
	
	      var nextEntries = history.entries.slice(0);
	      if (nextEntries.length > nextIndex) {
	        nextEntries.splice(nextIndex, nextEntries.length - nextIndex, location);
	      } else {
	        nextEntries.push(location);
	      }
	
	      setState({
	        action: action,
	        location: location,
	        index: nextIndex,
	        entries: nextEntries
	      });
	    });
	  };
	
	  var replace = function replace(path, state) {
	    (0, _warning2.default)(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored');
	
	    var action = 'REPLACE';
	    var location = (0, _LocationUtils.createLocation)(path, state, createKey(), history.location);
	
	    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
	      if (!ok) return;
	
	      history.entries[history.index] = location;
	
	      setState({ action: action, location: location });
	    });
	  };
	
	  var go = function go(n) {
	    var nextIndex = clamp(history.index + n, 0, history.entries.length - 1);
	
	    var action = 'POP';
	    var location = history.entries[nextIndex];
	
	    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
	      if (ok) {
	        setState({
	          action: action,
	          location: location,
	          index: nextIndex
	        });
	      } else {
	        // Mimic the behavior of DOM histories by
	        // causing a render after a cancelled POP.
	        setState();
	      }
	    });
	  };
	
	  var goBack = function goBack() {
	    return go(-1);
	  };
	
	  var goForward = function goForward() {
	    return go(1);
	  };
	
	  var canGo = function canGo(n) {
	    var nextIndex = history.index + n;
	    return nextIndex >= 0 && nextIndex < history.entries.length;
	  };
	
	  var block = function block() {
	    var prompt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	    return transitionManager.setPrompt(prompt);
	  };
	
	  var listen = function listen(listener) {
	    return transitionManager.appendListener(listener);
	  };
	
	  var history = {
	    length: entries.length,
	    action: 'POP',
	    location: entries[index],
	    index: index,
	    entries: entries,
	    createHref: createHref,
	    push: push,
	    replace: replace,
	    go: go,
	    goBack: goBack,
	    goForward: goForward,
	    canGo: canGo,
	    block: block,
	    listen: listen
	  };
	
	  return history;
	};
	
	exports.default = createMemoryHistory;

/***/ }),
/* 597 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _react = __webpack_require__(73);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(267);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Route = __webpack_require__(598);
	
	var _Route2 = _interopRequireDefault(_Route);
	
	var _Link = __webpack_require__(593);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	/**
	 * A <Link> wrapper that knows if it's "active" or not.
	 */
	var NavLink = function NavLink(_ref) {
	  var to = _ref.to,
	      exact = _ref.exact,
	      strict = _ref.strict,
	      location = _ref.location,
	      activeClassName = _ref.activeClassName,
	      className = _ref.className,
	      activeStyle = _ref.activeStyle,
	      style = _ref.style,
	      getIsActive = _ref.isActive,
	      ariaCurrent = _ref.ariaCurrent,
	      rest = _objectWithoutProperties(_ref, ['to', 'exact', 'strict', 'location', 'activeClassName', 'className', 'activeStyle', 'style', 'isActive', 'ariaCurrent']);
	
	  return _react2.default.createElement(_Route2.default, {
	    path: (typeof to === 'undefined' ? 'undefined' : _typeof(to)) === 'object' ? to.pathname : to,
	    exact: exact,
	    strict: strict,
	    location: location,
	    children: function children(_ref2) {
	      var location = _ref2.location,
	          match = _ref2.match;
	
	      var isActive = !!(getIsActive ? getIsActive(match, location) : match);
	
	      return _react2.default.createElement(_Link2.default, _extends({
	        to: to,
	        className: isActive ? [className, activeClassName].filter(function (i) {
	          return i;
	        }).join(' ') : className,
	        style: isActive ? _extends({}, style, activeStyle) : style,
	        'aria-current': isActive && ariaCurrent
	      }, rest));
	    }
	  });
	};
	
	NavLink.propTypes = {
	  to: _Link2.default.propTypes.to,
	  exact: _propTypes2.default.bool,
	  strict: _propTypes2.default.bool,
	  location: _propTypes2.default.object,
	  activeClassName: _propTypes2.default.string,
	  className: _propTypes2.default.string,
	  activeStyle: _propTypes2.default.object,
	  style: _propTypes2.default.object,
	  isActive: _propTypes2.default.func,
	  ariaCurrent: _propTypes2.default.oneOf(['page', 'step', 'location', 'true'])
	};
	
	NavLink.defaultProps = {
	  activeClassName: 'active',
	  ariaCurrent: 'true'
	};
	
	exports.default = NavLink;

/***/ }),
/* 598 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _Route = __webpack_require__(599);
	
	var _Route2 = _interopRequireDefault(_Route);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Route2.default; // Written in this round about way for babel-transform-imports

/***/ }),
/* 599 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _warning = __webpack_require__(581);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _invariant = __webpack_require__(275);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _react = __webpack_require__(73);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(267);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _matchPath = __webpack_require__(600);
	
	var _matchPath2 = _interopRequireDefault(_matchPath);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var isEmptyChildren = function isEmptyChildren(children) {
	  return _react2.default.Children.count(children) === 0;
	};
	
	/**
	 * The public API for matching a single path and rendering.
	 */
	
	var Route = function (_React$Component) {
	  _inherits(Route, _React$Component);
	
	  function Route() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Route);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
	      match: _this.computeMatch(_this.props, _this.context.router)
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  Route.prototype.getChildContext = function getChildContext() {
	    return {
	      router: _extends({}, this.context.router, {
	        route: {
	          location: this.props.location || this.context.router.route.location,
	          match: this.state.match
	        }
	      })
	    };
	  };
	
	  Route.prototype.computeMatch = function computeMatch(_ref, router) {
	    var computedMatch = _ref.computedMatch,
	        location = _ref.location,
	        path = _ref.path,
	        strict = _ref.strict,
	        exact = _ref.exact,
	        sensitive = _ref.sensitive;
	
	    if (computedMatch) return computedMatch; // <Switch> already computed the match for us
	
	    (0, _invariant2.default)(router, 'You should not use <Route> or withRouter() outside a <Router>');
	
	    var route = router.route;
	
	    var pathname = (location || route.location).pathname;
	
	    return path ? (0, _matchPath2.default)(pathname, { path: path, strict: strict, exact: exact, sensitive: sensitive }) : route.match;
	  };
	
	  Route.prototype.componentWillMount = function componentWillMount() {
	    (0, _warning2.default)(!(this.props.component && this.props.render), 'You should not use <Route component> and <Route render> in the same route; <Route render> will be ignored');
	
	    (0, _warning2.default)(!(this.props.component && this.props.children && !isEmptyChildren(this.props.children)), 'You should not use <Route component> and <Route children> in the same route; <Route children> will be ignored');
	
	    (0, _warning2.default)(!(this.props.render && this.props.children && !isEmptyChildren(this.props.children)), 'You should not use <Route render> and <Route children> in the same route; <Route children> will be ignored');
	  };
	
	  Route.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps, nextContext) {
	    (0, _warning2.default)(!(nextProps.location && !this.props.location), '<Route> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.');
	
	    (0, _warning2.default)(!(!nextProps.location && this.props.location), '<Route> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.');
	
	    this.setState({
	      match: this.computeMatch(nextProps, nextContext.router)
	    });
	  };
	
	  Route.prototype.render = function render() {
	    var match = this.state.match;
	    var _props = this.props,
	        children = _props.children,
	        component = _props.component,
	        render = _props.render;
	    var _context$router = this.context.router,
	        history = _context$router.history,
	        route = _context$router.route,
	        staticContext = _context$router.staticContext;
	
	    var location = this.props.location || route.location;
	    var props = { match: match, location: location, history: history, staticContext: staticContext };
	
	    return component ? // component prop gets first priority, only called if there's a match
	    match ? _react2.default.createElement(component, props) : null : render ? // render prop is next, only called if there's a match
	    match ? render(props) : null : children ? // children come last, always called
	    typeof children === 'function' ? children(props) : !isEmptyChildren(children) ? _react2.default.Children.only(children) : null : null;
	  };
	
	  return Route;
	}(_react2.default.Component);
	
	Route.propTypes = {
	  computedMatch: _propTypes2.default.object, // private, from <Switch>
	  path: _propTypes2.default.string,
	  exact: _propTypes2.default.bool,
	  strict: _propTypes2.default.bool,
	  sensitive: _propTypes2.default.bool,
	  component: _propTypes2.default.func,
	  render: _propTypes2.default.func,
	  children: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.node]),
	  location: _propTypes2.default.object
	};
	Route.contextTypes = {
	  router: _propTypes2.default.shape({
	    history: _propTypes2.default.object.isRequired,
	    route: _propTypes2.default.object.isRequired,
	    staticContext: _propTypes2.default.object
	  })
	};
	Route.childContextTypes = {
	  router: _propTypes2.default.object.isRequired
	};
	exports.default = Route;

/***/ }),
/* 600 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _pathToRegexp = __webpack_require__(601);
	
	var _pathToRegexp2 = _interopRequireDefault(_pathToRegexp);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var patternCache = {};
	var cacheLimit = 10000;
	var cacheCount = 0;
	
	var compilePath = function compilePath(pattern, options) {
	  var cacheKey = '' + options.end + options.strict + options.sensitive;
	  var cache = patternCache[cacheKey] || (patternCache[cacheKey] = {});
	
	  if (cache[pattern]) return cache[pattern];
	
	  var keys = [];
	  var re = (0, _pathToRegexp2.default)(pattern, keys, options);
	  var compiledPattern = { re: re, keys: keys };
	
	  if (cacheCount < cacheLimit) {
	    cache[pattern] = compiledPattern;
	    cacheCount++;
	  }
	
	  return compiledPattern;
	};
	
	/**
	 * Public API for matching a URL pathname to a path pattern.
	 */
	var matchPath = function matchPath(pathname) {
	  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	  if (typeof options === 'string') options = { path: options };
	
	  var _options = options,
	      _options$path = _options.path,
	      path = _options$path === undefined ? '/' : _options$path,
	      _options$exact = _options.exact,
	      exact = _options$exact === undefined ? false : _options$exact,
	      _options$strict = _options.strict,
	      strict = _options$strict === undefined ? false : _options$strict,
	      _options$sensitive = _options.sensitive,
	      sensitive = _options$sensitive === undefined ? false : _options$sensitive;
	
	  var _compilePath = compilePath(path, { end: exact, strict: strict, sensitive: sensitive }),
	      re = _compilePath.re,
	      keys = _compilePath.keys;
	
	  var match = re.exec(pathname);
	
	  if (!match) return null;
	
	  var url = match[0],
	      values = match.slice(1);
	
	  var isExact = pathname === url;
	
	  if (exact && !isExact) return null;
	
	  return {
	    path: path, // the path pattern used to match
	    url: path === '/' && url === '' ? '/' : url, // the matched portion of the URL
	    isExact: isExact, // whether or not we matched exactly
	    params: keys.reduce(function (memo, key, index) {
	      memo[key.name] = values[index];
	      return memo;
	    }, {})
	  };
	};
	
	exports.default = matchPath;

/***/ }),
/* 601 */
/***/ (function(module, exports, __webpack_require__) {

	var isarray = __webpack_require__(602)
	
	/**
	 * Expose `pathToRegexp`.
	 */
	module.exports = pathToRegexp
	module.exports.parse = parse
	module.exports.compile = compile
	module.exports.tokensToFunction = tokensToFunction
	module.exports.tokensToRegExp = tokensToRegExp
	
	/**
	 * The main path matching regexp utility.
	 *
	 * @type {RegExp}
	 */
	var PATH_REGEXP = new RegExp([
	  // Match escaped characters that would otherwise appear in future matches.
	  // This allows the user to escape special characters that won't transform.
	  '(\\\\.)',
	  // Match Express-style parameters and un-named parameters with a prefix
	  // and optional suffixes. Matches appear as:
	  //
	  // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
	  // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
	  // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
	  '([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))'
	].join('|'), 'g')
	
	/**
	 * Parse a string for the raw tokens.
	 *
	 * @param  {string}  str
	 * @param  {Object=} options
	 * @return {!Array}
	 */
	function parse (str, options) {
	  var tokens = []
	  var key = 0
	  var index = 0
	  var path = ''
	  var defaultDelimiter = options && options.delimiter || '/'
	  var res
	
	  while ((res = PATH_REGEXP.exec(str)) != null) {
	    var m = res[0]
	    var escaped = res[1]
	    var offset = res.index
	    path += str.slice(index, offset)
	    index = offset + m.length
	
	    // Ignore already escaped sequences.
	    if (escaped) {
	      path += escaped[1]
	      continue
	    }
	
	    var next = str[index]
	    var prefix = res[2]
	    var name = res[3]
	    var capture = res[4]
	    var group = res[5]
	    var modifier = res[6]
	    var asterisk = res[7]
	
	    // Push the current path onto the tokens.
	    if (path) {
	      tokens.push(path)
	      path = ''
	    }
	
	    var partial = prefix != null && next != null && next !== prefix
	    var repeat = modifier === '+' || modifier === '*'
	    var optional = modifier === '?' || modifier === '*'
	    var delimiter = res[2] || defaultDelimiter
	    var pattern = capture || group
	
	    tokens.push({
	      name: name || key++,
	      prefix: prefix || '',
	      delimiter: delimiter,
	      optional: optional,
	      repeat: repeat,
	      partial: partial,
	      asterisk: !!asterisk,
	      pattern: pattern ? escapeGroup(pattern) : (asterisk ? '.*' : '[^' + escapeString(delimiter) + ']+?')
	    })
	  }
	
	  // Match any characters still remaining.
	  if (index < str.length) {
	    path += str.substr(index)
	  }
	
	  // If the path exists, push it onto the end.
	  if (path) {
	    tokens.push(path)
	  }
	
	  return tokens
	}
	
	/**
	 * Compile a string to a template function for the path.
	 *
	 * @param  {string}             str
	 * @param  {Object=}            options
	 * @return {!function(Object=, Object=)}
	 */
	function compile (str, options) {
	  return tokensToFunction(parse(str, options))
	}
	
	/**
	 * Prettier encoding of URI path segments.
	 *
	 * @param  {string}
	 * @return {string}
	 */
	function encodeURIComponentPretty (str) {
	  return encodeURI(str).replace(/[\/?#]/g, function (c) {
	    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
	  })
	}
	
	/**
	 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
	 *
	 * @param  {string}
	 * @return {string}
	 */
	function encodeAsterisk (str) {
	  return encodeURI(str).replace(/[?#]/g, function (c) {
	    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
	  })
	}
	
	/**
	 * Expose a method for transforming tokens into the path function.
	 */
	function tokensToFunction (tokens) {
	  // Compile all the tokens into regexps.
	  var matches = new Array(tokens.length)
	
	  // Compile all the patterns before compilation.
	  for (var i = 0; i < tokens.length; i++) {
	    if (typeof tokens[i] === 'object') {
	      matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$')
	    }
	  }
	
	  return function (obj, opts) {
	    var path = ''
	    var data = obj || {}
	    var options = opts || {}
	    var encode = options.pretty ? encodeURIComponentPretty : encodeURIComponent
	
	    for (var i = 0; i < tokens.length; i++) {
	      var token = tokens[i]
	
	      if (typeof token === 'string') {
	        path += token
	
	        continue
	      }
	
	      var value = data[token.name]
	      var segment
	
	      if (value == null) {
	        if (token.optional) {
	          // Prepend partial segment prefixes.
	          if (token.partial) {
	            path += token.prefix
	          }
	
	          continue
	        } else {
	          throw new TypeError('Expected "' + token.name + '" to be defined')
	        }
	      }
	
	      if (isarray(value)) {
	        if (!token.repeat) {
	          throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + '`')
	        }
	
	        if (value.length === 0) {
	          if (token.optional) {
	            continue
	          } else {
	            throw new TypeError('Expected "' + token.name + '" to not be empty')
	          }
	        }
	
	        for (var j = 0; j < value.length; j++) {
	          segment = encode(value[j])
	
	          if (!matches[i].test(segment)) {
	            throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + '`')
	          }
	
	          path += (j === 0 ? token.prefix : token.delimiter) + segment
	        }
	
	        continue
	      }
	
	      segment = token.asterisk ? encodeAsterisk(value) : encode(value)
	
	      if (!matches[i].test(segment)) {
	        throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"')
	      }
	
	      path += token.prefix + segment
	    }
	
	    return path
	  }
	}
	
	/**
	 * Escape a regular expression string.
	 *
	 * @param  {string} str
	 * @return {string}
	 */
	function escapeString (str) {
	  return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, '\\$1')
	}
	
	/**
	 * Escape the capturing group by escaping special characters and meaning.
	 *
	 * @param  {string} group
	 * @return {string}
	 */
	function escapeGroup (group) {
	  return group.replace(/([=!:$\/()])/g, '\\$1')
	}
	
	/**
	 * Attach the keys as a property of the regexp.
	 *
	 * @param  {!RegExp} re
	 * @param  {Array}   keys
	 * @return {!RegExp}
	 */
	function attachKeys (re, keys) {
	  re.keys = keys
	  return re
	}
	
	/**
	 * Get the flags for a regexp from the options.
	 *
	 * @param  {Object} options
	 * @return {string}
	 */
	function flags (options) {
	  return options.sensitive ? '' : 'i'
	}
	
	/**
	 * Pull out keys from a regexp.
	 *
	 * @param  {!RegExp} path
	 * @param  {!Array}  keys
	 * @return {!RegExp}
	 */
	function regexpToRegexp (path, keys) {
	  // Use a negative lookahead to match only capturing groups.
	  var groups = path.source.match(/\((?!\?)/g)
	
	  if (groups) {
	    for (var i = 0; i < groups.length; i++) {
	      keys.push({
	        name: i,
	        prefix: null,
	        delimiter: null,
	        optional: false,
	        repeat: false,
	        partial: false,
	        asterisk: false,
	        pattern: null
	      })
	    }
	  }
	
	  return attachKeys(path, keys)
	}
	
	/**
	 * Transform an array into a regexp.
	 *
	 * @param  {!Array}  path
	 * @param  {Array}   keys
	 * @param  {!Object} options
	 * @return {!RegExp}
	 */
	function arrayToRegexp (path, keys, options) {
	  var parts = []
	
	  for (var i = 0; i < path.length; i++) {
	    parts.push(pathToRegexp(path[i], keys, options).source)
	  }
	
	  var regexp = new RegExp('(?:' + parts.join('|') + ')', flags(options))
	
	  return attachKeys(regexp, keys)
	}
	
	/**
	 * Create a path regexp from string input.
	 *
	 * @param  {string}  path
	 * @param  {!Array}  keys
	 * @param  {!Object} options
	 * @return {!RegExp}
	 */
	function stringToRegexp (path, keys, options) {
	  return tokensToRegExp(parse(path, options), keys, options)
	}
	
	/**
	 * Expose a function for taking tokens and returning a RegExp.
	 *
	 * @param  {!Array}          tokens
	 * @param  {(Array|Object)=} keys
	 * @param  {Object=}         options
	 * @return {!RegExp}
	 */
	function tokensToRegExp (tokens, keys, options) {
	  if (!isarray(keys)) {
	    options = /** @type {!Object} */ (keys || options)
	    keys = []
	  }
	
	  options = options || {}
	
	  var strict = options.strict
	  var end = options.end !== false
	  var route = ''
	
	  // Iterate over the tokens and create our regexp string.
	  for (var i = 0; i < tokens.length; i++) {
	    var token = tokens[i]
	
	    if (typeof token === 'string') {
	      route += escapeString(token)
	    } else {
	      var prefix = escapeString(token.prefix)
	      var capture = '(?:' + token.pattern + ')'
	
	      keys.push(token)
	
	      if (token.repeat) {
	        capture += '(?:' + prefix + capture + ')*'
	      }
	
	      if (token.optional) {
	        if (!token.partial) {
	          capture = '(?:' + prefix + '(' + capture + '))?'
	        } else {
	          capture = prefix + '(' + capture + ')?'
	        }
	      } else {
	        capture = prefix + '(' + capture + ')'
	      }
	
	      route += capture
	    }
	  }
	
	  var delimiter = escapeString(options.delimiter || '/')
	  var endsWithDelimiter = route.slice(-delimiter.length) === delimiter
	
	  // In non-strict mode we allow a slash at the end of match. If the path to
	  // match already ends with a slash, we remove it for consistency. The slash
	  // is valid at the end of a path match, not in the middle. This is important
	  // in non-ending mode, where "/test/" shouldn't match "/test//route".
	  if (!strict) {
	    route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + '(?:' + delimiter + '(?=$))?'
	  }
	
	  if (end) {
	    route += '$'
	  } else {
	    // In non-ending mode, we need the capturing groups to match as much as
	    // possible by using a positive lookahead to the end or next path segment.
	    route += strict && endsWithDelimiter ? '' : '(?=' + delimiter + '|$)'
	  }
	
	  return attachKeys(new RegExp('^' + route, flags(options)), keys)
	}
	
	/**
	 * Normalize the given path string, returning a regular expression.
	 *
	 * An empty array can be passed in for the keys, which will hold the
	 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
	 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
	 *
	 * @param  {(string|RegExp|Array)} path
	 * @param  {(Array|Object)=}       keys
	 * @param  {Object=}               options
	 * @return {!RegExp}
	 */
	function pathToRegexp (path, keys, options) {
	  if (!isarray(keys)) {
	    options = /** @type {!Object} */ (keys || options)
	    keys = []
	  }
	
	  options = options || {}
	
	  if (path instanceof RegExp) {
	    return regexpToRegexp(path, /** @type {!Array} */ (keys))
	  }
	
	  if (isarray(path)) {
	    return arrayToRegexp(/** @type {!Array} */ (path), /** @type {!Array} */ (keys), options)
	  }
	
	  return stringToRegexp(/** @type {string} */ (path), /** @type {!Array} */ (keys), options)
	}


/***/ }),
/* 602 */
/***/ (function(module, exports) {

	module.exports = Array.isArray || function (arr) {
	  return Object.prototype.toString.call(arr) == '[object Array]';
	};


/***/ }),
/* 603 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _Prompt = __webpack_require__(604);
	
	var _Prompt2 = _interopRequireDefault(_Prompt);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Prompt2.default; // Written in this round about way for babel-transform-imports

/***/ }),
/* 604 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(73);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(267);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _invariant = __webpack_require__(275);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The public API for prompting the user before navigating away
	 * from a screen with a component.
	 */
	var Prompt = function (_React$Component) {
	  _inherits(Prompt, _React$Component);
	
	  function Prompt() {
	    _classCallCheck(this, Prompt);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  Prompt.prototype.enable = function enable(message) {
	    if (this.unblock) this.unblock();
	
	    this.unblock = this.context.router.history.block(message);
	  };
	
	  Prompt.prototype.disable = function disable() {
	    if (this.unblock) {
	      this.unblock();
	      this.unblock = null;
	    }
	  };
	
	  Prompt.prototype.componentWillMount = function componentWillMount() {
	    (0, _invariant2.default)(this.context.router, 'You should not use <Prompt> outside a <Router>');
	
	    if (this.props.when) this.enable(this.props.message);
	  };
	
	  Prompt.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    if (nextProps.when) {
	      if (!this.props.when || this.props.message !== nextProps.message) this.enable(nextProps.message);
	    } else {
	      this.disable();
	    }
	  };
	
	  Prompt.prototype.componentWillUnmount = function componentWillUnmount() {
	    this.disable();
	  };
	
	  Prompt.prototype.render = function render() {
	    return null;
	  };
	
	  return Prompt;
	}(_react2.default.Component);
	
	Prompt.propTypes = {
	  when: _propTypes2.default.bool,
	  message: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.string]).isRequired
	};
	Prompt.defaultProps = {
	  when: true
	};
	Prompt.contextTypes = {
	  router: _propTypes2.default.shape({
	    history: _propTypes2.default.shape({
	      block: _propTypes2.default.func.isRequired
	    }).isRequired
	  }).isRequired
	};
	exports.default = Prompt;

/***/ }),
/* 605 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _Redirect = __webpack_require__(606);
	
	var _Redirect2 = _interopRequireDefault(_Redirect);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Redirect2.default; // Written in this round about way for babel-transform-imports

/***/ }),
/* 606 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(73);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(267);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _warning = __webpack_require__(581);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _invariant = __webpack_require__(275);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _history = __webpack_require__(607);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The public API for updating the location programmatically
	 * with a component.
	 */
	var Redirect = function (_React$Component) {
	  _inherits(Redirect, _React$Component);
	
	  function Redirect() {
	    _classCallCheck(this, Redirect);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  Redirect.prototype.isStatic = function isStatic() {
	    return this.context.router && this.context.router.staticContext;
	  };
	
	  Redirect.prototype.componentWillMount = function componentWillMount() {
	    (0, _invariant2.default)(this.context.router, 'You should not use <Redirect> outside a <Router>');
	
	    if (this.isStatic()) this.perform();
	  };
	
	  Redirect.prototype.componentDidMount = function componentDidMount() {
	    if (!this.isStatic()) this.perform();
	  };
	
	  Redirect.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
	    var prevTo = (0, _history.createLocation)(prevProps.to);
	    var nextTo = (0, _history.createLocation)(this.props.to);
	
	    if ((0, _history.locationsAreEqual)(prevTo, nextTo)) {
	      (0, _warning2.default)(false, 'You tried to redirect to the same route you\'re currently on: ' + ('"' + nextTo.pathname + nextTo.search + '"'));
	      return;
	    }
	
	    this.perform();
	  };
	
	  Redirect.prototype.perform = function perform() {
	    var history = this.context.router.history;
	    var _props = this.props,
	        push = _props.push,
	        to = _props.to;
	
	
	    if (push) {
	      history.push(to);
	    } else {
	      history.replace(to);
	    }
	  };
	
	  Redirect.prototype.render = function render() {
	    return null;
	  };
	
	  return Redirect;
	}(_react2.default.Component);
	
	Redirect.propTypes = {
	  push: _propTypes2.default.bool,
	  from: _propTypes2.default.string,
	  to: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]).isRequired
	};
	Redirect.defaultProps = {
	  push: false
	};
	Redirect.contextTypes = {
	  router: _propTypes2.default.shape({
	    history: _propTypes2.default.shape({
	      push: _propTypes2.default.func.isRequired,
	      replace: _propTypes2.default.func.isRequired
	    }).isRequired,
	    staticContext: _propTypes2.default.object
	  }).isRequired
	};
	exports.default = Redirect;

/***/ }),
/* 607 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.createPath = exports.parsePath = exports.locationsAreEqual = exports.createLocation = exports.createMemoryHistory = exports.createHashHistory = exports.createBrowserHistory = undefined;
	
	var _LocationUtils = __webpack_require__(583);
	
	Object.defineProperty(exports, 'createLocation', {
	  enumerable: true,
	  get: function get() {
	    return _LocationUtils.createLocation;
	  }
	});
	Object.defineProperty(exports, 'locationsAreEqual', {
	  enumerable: true,
	  get: function get() {
	    return _LocationUtils.locationsAreEqual;
	  }
	});
	
	var _PathUtils = __webpack_require__(586);
	
	Object.defineProperty(exports, 'parsePath', {
	  enumerable: true,
	  get: function get() {
	    return _PathUtils.parsePath;
	  }
	});
	Object.defineProperty(exports, 'createPath', {
	  enumerable: true,
	  get: function get() {
	    return _PathUtils.createPath;
	  }
	});
	
	var _createBrowserHistory2 = __webpack_require__(582);
	
	var _createBrowserHistory3 = _interopRequireDefault(_createBrowserHistory2);
	
	var _createHashHistory2 = __webpack_require__(592);
	
	var _createHashHistory3 = _interopRequireDefault(_createHashHistory2);
	
	var _createMemoryHistory2 = __webpack_require__(596);
	
	var _createMemoryHistory3 = _interopRequireDefault(_createMemoryHistory2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.createBrowserHistory = _createBrowserHistory3.default;
	exports.createHashHistory = _createHashHistory3.default;
	exports.createMemoryHistory = _createMemoryHistory3.default;

/***/ }),
/* 608 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _StaticRouter = __webpack_require__(609);
	
	var _StaticRouter2 = _interopRequireDefault(_StaticRouter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _StaticRouter2.default; // Written in this round about way for babel-transform-imports

/***/ }),
/* 609 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _warning = __webpack_require__(581);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _invariant = __webpack_require__(275);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _react = __webpack_require__(73);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(267);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _PathUtils = __webpack_require__(586);
	
	var _Router = __webpack_require__(590);
	
	var _Router2 = _interopRequireDefault(_Router);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var normalizeLocation = function normalizeLocation(object) {
	  var _object$pathname = object.pathname,
	      pathname = _object$pathname === undefined ? '/' : _object$pathname,
	      _object$search = object.search,
	      search = _object$search === undefined ? '' : _object$search,
	      _object$hash = object.hash,
	      hash = _object$hash === undefined ? '' : _object$hash;
	
	
	  return {
	    pathname: pathname,
	    search: search === '?' ? '' : search,
	    hash: hash === '#' ? '' : hash
	  };
	};
	
	var addBasename = function addBasename(basename, location) {
	  if (!basename) return location;
	
	  return _extends({}, location, {
	    pathname: (0, _PathUtils.addLeadingSlash)(basename) + location.pathname
	  });
	};
	
	var stripBasename = function stripBasename(basename, location) {
	  if (!basename) return location;
	
	  var base = (0, _PathUtils.addLeadingSlash)(basename);
	
	  if (location.pathname.indexOf(base) !== 0) return location;
	
	  return _extends({}, location, {
	    pathname: location.pathname.substr(base.length)
	  });
	};
	
	var createLocation = function createLocation(location) {
	  return typeof location === 'string' ? (0, _PathUtils.parsePath)(location) : normalizeLocation(location);
	};
	
	var createURL = function createURL(location) {
	  return typeof location === 'string' ? location : (0, _PathUtils.createPath)(location);
	};
	
	var staticHandler = function staticHandler(methodName) {
	  return function () {
	    (0, _invariant2.default)(false, 'You cannot %s with <StaticRouter>', methodName);
	  };
	};
	
	var noop = function noop() {};
	
	/**
	 * The public top-level API for a "static" <Router>, so-called because it
	 * can't actually change the current location. Instead, it just records
	 * location changes in a context object. Useful mainly in testing and
	 * server-rendering scenarios.
	 */
	
	var StaticRouter = function (_React$Component) {
	  _inherits(StaticRouter, _React$Component);
	
	  function StaticRouter() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, StaticRouter);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.createHref = function (path) {
	      return (0, _PathUtils.addLeadingSlash)(_this.props.basename + createURL(path));
	    }, _this.handlePush = function (location) {
	      var _this$props = _this.props,
	          basename = _this$props.basename,
	          context = _this$props.context;
	
	      context.action = 'PUSH';
	      context.location = addBasename(basename, createLocation(location));
	      context.url = createURL(context.location);
	    }, _this.handleReplace = function (location) {
	      var _this$props2 = _this.props,
	          basename = _this$props2.basename,
	          context = _this$props2.context;
	
	      context.action = 'REPLACE';
	      context.location = addBasename(basename, createLocation(location));
	      context.url = createURL(context.location);
	    }, _this.handleListen = function () {
	      return noop;
	    }, _this.handleBlock = function () {
	      return noop;
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  StaticRouter.prototype.getChildContext = function getChildContext() {
	    return {
	      router: {
	        staticContext: this.props.context
	      }
	    };
	  };
	
	  StaticRouter.prototype.componentWillMount = function componentWillMount() {
	    (0, _warning2.default)(!this.props.history, '<StaticRouter> ignores the history prop. To use a custom history, ' + 'use `import { Router }` instead of `import { StaticRouter as Router }`.');
	  };
	
	  StaticRouter.prototype.render = function render() {
	    var _props = this.props,
	        basename = _props.basename,
	        context = _props.context,
	        location = _props.location,
	        props = _objectWithoutProperties(_props, ['basename', 'context', 'location']);
	
	    var history = {
	      createHref: this.createHref,
	      action: 'POP',
	      location: stripBasename(basename, createLocation(location)),
	      push: this.handlePush,
	      replace: this.handleReplace,
	      go: staticHandler('go'),
	      goBack: staticHandler('goBack'),
	      goForward: staticHandler('goForward'),
	      listen: this.handleListen,
	      block: this.handleBlock
	    };
	
	    return _react2.default.createElement(_Router2.default, _extends({}, props, { history: history }));
	  };
	
	  return StaticRouter;
	}(_react2.default.Component);
	
	StaticRouter.propTypes = {
	  basename: _propTypes2.default.string,
	  context: _propTypes2.default.object.isRequired,
	  location: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object])
	};
	StaticRouter.defaultProps = {
	  basename: '',
	  location: '/'
	};
	StaticRouter.childContextTypes = {
	  router: _propTypes2.default.object.isRequired
	};
	exports.default = StaticRouter;

/***/ }),
/* 610 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _Switch = __webpack_require__(611);
	
	var _Switch2 = _interopRequireDefault(_Switch);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Switch2.default; // Written in this round about way for babel-transform-imports

/***/ }),
/* 611 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(73);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(267);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _warning = __webpack_require__(581);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _invariant = __webpack_require__(275);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _matchPath = __webpack_require__(600);
	
	var _matchPath2 = _interopRequireDefault(_matchPath);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The public API for rendering the first <Route> that matches.
	 */
	var Switch = function (_React$Component) {
	  _inherits(Switch, _React$Component);
	
	  function Switch() {
	    _classCallCheck(this, Switch);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  Switch.prototype.componentWillMount = function componentWillMount() {
	    (0, _invariant2.default)(this.context.router, 'You should not use <Switch> outside a <Router>');
	  };
	
	  Switch.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    (0, _warning2.default)(!(nextProps.location && !this.props.location), '<Switch> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.');
	
	    (0, _warning2.default)(!(!nextProps.location && this.props.location), '<Switch> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.');
	  };
	
	  Switch.prototype.render = function render() {
	    var route = this.context.router.route;
	    var children = this.props.children;
	
	    var location = this.props.location || route.location;
	
	    var match = void 0,
	        child = void 0;
	    _react2.default.Children.forEach(children, function (element) {
	      if (!_react2.default.isValidElement(element)) return;
	
	      var _element$props = element.props,
	          pathProp = _element$props.path,
	          exact = _element$props.exact,
	          strict = _element$props.strict,
	          sensitive = _element$props.sensitive,
	          from = _element$props.from;
	
	      var path = pathProp || from;
	
	      if (match == null) {
	        child = element;
	        match = path ? (0, _matchPath2.default)(location.pathname, { path: path, exact: exact, strict: strict, sensitive: sensitive }) : route.match;
	      }
	    });
	
	    return match ? _react2.default.cloneElement(child, { location: location, computedMatch: match }) : null;
	  };
	
	  return Switch;
	}(_react2.default.Component);
	
	Switch.contextTypes = {
	  router: _propTypes2.default.shape({
	    route: _propTypes2.default.object.isRequired
	  }).isRequired
	};
	Switch.propTypes = {
	  children: _propTypes2.default.node,
	  location: _propTypes2.default.object
	};
	exports.default = Switch;

/***/ }),
/* 612 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _matchPath = __webpack_require__(600);
	
	var _matchPath2 = _interopRequireDefault(_matchPath);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _matchPath2.default; // Written in this round about way for babel-transform-imports

/***/ }),
/* 613 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _withRouter = __webpack_require__(614);
	
	var _withRouter2 = _interopRequireDefault(_withRouter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _withRouter2.default; // Written in this round about way for babel-transform-imports

/***/ }),
/* 614 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(73);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(267);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _hoistNonReactStatics = __webpack_require__(274);
	
	var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);
	
	var _Route = __webpack_require__(599);
	
	var _Route2 = _interopRequireDefault(_Route);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	/**
	 * A public higher-order component to access the imperative API
	 */
	var withRouter = function withRouter(Component) {
	  var C = function C(props) {
	    var wrappedComponentRef = props.wrappedComponentRef,
	        remainingProps = _objectWithoutProperties(props, ['wrappedComponentRef']);
	
	    return _react2.default.createElement(_Route2.default, { render: function render(routeComponentProps) {
	        return _react2.default.createElement(Component, _extends({}, remainingProps, routeComponentProps, { ref: wrappedComponentRef }));
	      } });
	  };
	
	  C.displayName = 'withRouter(' + (Component.displayName || Component.name) + ')';
	  C.WrappedComponent = Component;
	  C.propTypes = {
	    wrappedComponentRef: _propTypes2.default.func
	  };
	
	  return (0, _hoistNonReactStatics2.default)(C, Component);
	};
	
	exports.default = withRouter;

/***/ }),
/* 615 */
/***/ (function(module, exports) {

	/**
	 * Created by madlord on 16/1/27.
	 */
	
	(function () {
	    if (typeof window === "undefined") return;
	    var baseWidth=375;
	    var baseRemSize=10;
	    function upadte() {
	        var w=Math.min(window.screen.width,document.body.clientWidth,document.documentElement.getBoundingClientRect().width);
	        var fontSize=w/baseWidth*baseRemSize;
	        document.documentElement.style['fontSize']=fontSize+'px';
	        var div=document.createElement("div");
	        div.style.width=fontSize+'px';
	        div.id='rem';
	        document.body.appendChild(div);
	        var realFontSize=parseFloat(document.defaultView.getComputedStyle(document.getElementById('rem'), null)['width']);
	
	        //部分华为魅族机型的html fontSize计算不正确
	        if (realFontSize/fontSize!==1) {
	
	            document.documentElement.style['fontSize']=fontSize*fontSize/realFontSize+'px';
	        }
	
	    }
	    module.exports={
	        init:function (bw) {
	            baseWidth=bw||375;
	            window.addEventListener('resize',upadte)
	            upadte();
	        },
	
	        getOneREMSize:function () {
	            return parseFloat(document.getElementsByTagName('html')[0].style['font-size']);
	        }
	    }
	})();
	


/***/ }),
/* 616 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ })
]);


// WEBPACK FOOTER //
// detail.js